
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("6SZAm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $094447ae995aeca0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("2Geeh");

var $jD5no = parcelRequire("jD5no");

var $i8pyY = parcelRequire("i8pyY");

var $hmRfM = parcelRequire("hmRfM");

var $4Pf62 = parcelRequire("4Pf62");

var $9dbF6 = parcelRequire("9dbF6");

var $38Y30 = parcelRequire("38Y30");

var $90yGq = parcelRequire("90yGq");

var $hqBSi = parcelRequire("hqBSi");

var $l8ruj = parcelRequire("l8ruj");

var $7tQej = parcelRequire("7tQej");
const $094447ae995aeca0$var$JiraSoftwareFormSubmitApp = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    if (!accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    const hasSoftwareLicense = licensedProducts?.[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE];
    if (!hasSoftwareLicense) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/projects"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "jira-software-form-submit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "jira-software-form-submit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8pyY.FormSubmissionContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hmRfM.FormSubmissionRoot), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    })));
};
var $094447ae995aeca0$export$2e2bcd8739ae039 = $094447ae995aeca0$var$JiraSoftwareFormSubmitApp;

});
parcelRegister("i8pyY", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionContextProvider", () => $c118b8c67dae9e54$export$762da44d062c3e8b);

var $5uXOq = parcelRequire("5uXOq");

var $aXhsp = parcelRequire("aXhsp");

var $AeWM3 = parcelRequire("AeWM3");

var $cm8b5 = parcelRequire("cm8b5");

var $2vSU6 = parcelRequire("2vSU6");

var $iXVV6 = parcelRequire("iXVV6");

var $aVFIE = parcelRequire("aVFIE");

var $l2N2a = parcelRequire("l2N2a");

var $iEEXl = parcelRequire("iEEXl");

var $7wwVP = parcelRequire("7wwVP");

var $6czoq = parcelRequire("6czoq");

var $lAzTA = parcelRequire("lAzTA");

var $g2iZ7 = parcelRequire("g2iZ7");

var $kyf8b = parcelRequire("kyf8b");

var $0557y = parcelRequire("0557y");
const $c118b8c67dae9e54$var$FormAccessWrapper = ({ children: children })=>{
    const [initialLoading, setInitialLoading] = (0, $5uXOq.useState)(true);
    const { data: project, loading: projectLoading } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const [{ data: data, loading: loading, error: error }] = (0, $kyf8b.useFormSubmissionStore)();
    (0, $5uXOq.useEffect)(()=>{
        if (loading) setInitialLoading(false);
    }, [
        loading
    ]);
    const isOpenForm = data?.accessLevel === (0, $7wwVP.FormAccessLevelTypes).OPEN;
    const projectId = String(data?.projectId);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            projectId: projectId,
            isOpenForm: isOpenForm,
            projectType: (0, $2vSU6.CORE_PROJECT)
        }), [
        projectId,
        isOpenForm
    ]);
    const experienceTrackerAttributes = (0, $lAzTA.useConditionalFieldLogicAnalyticsAttrs)();
    if (initialLoading || projectLoading || loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVFIE.ThemedLazySkeleton), null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $0557y.isFormNotFoundError)(error) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceFailed), {
        experience: (0, $iEEXl.VIEW_FORM_SUBMISSION_EXPERIENCE),
        error: error,
        attributes: experienceTrackerAttributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.FormUnavailableView), null));
    if ((!project || !project.permissions.viewIssues || !project.permissions.createIssues) && isOpenForm) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: projectId,
        containerType: "project",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "businessFormSubmissionContext",
        attributes: analyticsAttributes
    }, children);
    return children;
};
const $c118b8c67dae9e54$export$762da44d062c3e8b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceErrorBoundary), {
        experience: (0, $iEEXl.VIEW_FORM_SUBMISSION_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aXhsp.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2iZ7.FormSubmissionPreloader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c118b8c67dae9e54$var$FormAccessWrapper, null, children)));

});
parcelRegister("aXhsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88f4e626c9babc0$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $dJl1T = parcelRequire("dJl1T");

var $dxpxC = parcelRequire("dxpxC");

var $l0T7c = parcelRequire("l0T7c");

var $9g713 = parcelRequire("9g713");


const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($l0T7c))
});
const $d88f4e626c9babc0$var$errorLink = (0, $h4ppL.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $9g713.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $9g713.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $dJl1T.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $dJl1T.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(operation.getContext(), [
            $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $dJl1T.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, $lC4FX.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $9g713.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, $clSzL.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $clSzL.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $d88f4e626c9babc0$var$cache = new (0, $ivfDv.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $clSzL.ApolloLink).from([
            $d88f4e626c9babc0$var$retryLinkWithFama,
            $d88f4e626c9babc0$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
            ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                new $d88f4e626c9babc0$var$CancelableRequestLink()
            ] : [],
            new (0, $JPsIz.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $d88f4e626c9babc0$var$cache,
        connectToDevTools: false
    });
var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
    clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $clSzL.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $clSzL.Observable).of({
                data: {}
            });
            return new (0, $clSzL.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("dxpxC", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $4350c2bcf1320fcf$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bFU4G = parcelRequire("bFU4G");
const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bFU4G.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("l0T7c", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("9g713", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a87e716199660ede$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a87e716199660ede$export$a78ebe1911f50d41);

var $9XE6b = parcelRequire("9XE6b");

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");
const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
    });
const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(context, [
        $a87e716199660ede$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $e3a3O.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("iEEXl", function(module, exports) {

$parcel$export(module.exports, "URL_PARAMS", () => $8497b4ce450fc8b0$export$bcc0c92e1564488c);
$parcel$export(module.exports, "PACKAGE_NAME", () => $8497b4ce450fc8b0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "VIEW_FORM_DIRECTORY_EXPERIENCE", () => $8497b4ce450fc8b0$export$3a0a03305bcf855e);
$parcel$export(module.exports, "DELETE_FORM_EXPERIENCE", () => $8497b4ce450fc8b0$export$7da90561e94f981);
$parcel$export(module.exports, "VIEW_FORM_SUBMISSION_EXPERIENCE", () => $8497b4ce450fc8b0$export$cdf9f6e9e7d621b6);
$parcel$export(module.exports, "SUBMIT_FORM_EXPERIENCE", () => $8497b4ce450fc8b0$export$537c9533c0b9bc1);
$parcel$export(module.exports, "VIEW_FORM_CREATE_EXPERIENCE", () => $8497b4ce450fc8b0$export$ca4e778581db201e);
$parcel$export(module.exports, "CREATE_FORM_EXPERIENCE", () => $8497b4ce450fc8b0$export$a18ce17ea7fe6b60);
$parcel$export(module.exports, "VIEW_FORM_UPDATE_EXPERIENCE", () => $8497b4ce450fc8b0$export$3a8f4f9a630a8c30);
$parcel$export(module.exports, "UPDATE_FORM_EXPERIENCE", () => $8497b4ce450fc8b0$export$b60e0f4f7fb57d79);
$parcel$export(module.exports, "FORM_VALIDATION_ERROR", () => $8497b4ce450fc8b0$export$85998b62672f570a);
$parcel$export(module.exports, "BUSINESS_PREFIX", () => $8497b4ce450fc8b0$export$b8ed4f67ef69db43);
$parcel$export(module.exports, "SOFTWARE_TMP_PREFIX", () => $8497b4ce450fc8b0$export$b1dbf4e7f8828780);
$parcel$export(module.exports, "SOFTWARE_CMP_PREFIX", () => $8497b4ce450fc8b0$export$90c8d3e12aee976a);
$parcel$export(module.exports, "BUSINESS_FEEDBACK_GROUP_ID", () => $8497b4ce450fc8b0$export$8d12d5bc867b3584);
$parcel$export(module.exports, "SOFTWARE_FEEDBACK_GROUP_ID", () => $8497b4ce450fc8b0$export$446ca3d108d6e8b0);
const $8497b4ce450fc8b0$export$61b0d4a63fb97a47 = 250;
const $8497b4ce450fc8b0$export$bcc0c92e1564488c = {
    FROM: 'from',
    DIRECTORY: 'directory'
};
const $8497b4ce450fc8b0$export$b8b9d90f9e5bd72b = 'jiraBusinessForm';
const $8497b4ce450fc8b0$export$3a0a03305bcf855e = {
    experience: 'viewFormDirectory',
    experienceId: 'viewDirectory',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$7da90561e94f981 = {
    experience: 'deleteForm',
    experienceId: 'deleteForm',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$cdf9f6e9e7d621b6 = {
    experience: 'formSubmission',
    experienceId: 'main',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$537c9533c0b9bc1 = {
    experience: 'CreateJiraBusinessIssueForm',
    experienceId: 'mutation',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$ca4e778581db201e = {
    experience: 'formCreation',
    experienceId: 'main',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$a18ce17ea7fe6b60 = {
    experience: 'CreateJiraBusinessForm',
    experienceId: 'mutation',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$3a8f4f9a630a8c30 = {
    experience: 'formUpdate',
    experienceId: 'main',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$b60e0f4f7fb57d79 = {
    experience: 'UpdateJiraBusinessForm',
    experienceId: 'mutation',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$85998b62672f570a = {
    ATTACHMENT_ERROR: 'ATTACHMENT_VALIDATION_ERROR'
};
const $8497b4ce450fc8b0$export$b8ed4f67ef69db43 = '/jira/core';
const $8497b4ce450fc8b0$export$b1dbf4e7f8828780 = '/jira/software';
const $8497b4ce450fc8b0$export$90c8d3e12aee976a = '/jira/software/c';
const $8497b4ce450fc8b0$export$8d12d5bc867b3584 = 'jbus-feedback-form';
const $8497b4ce450fc8b0$export$446ca3d108d6e8b0 = 'jirasoftware-feedback-form';

});

parcelRegister("7wwVP", function(module, exports) {

$parcel$export(module.exports, "FormAccessLevelTypes", () => $731dd5b579eaba8f$export$dbc34c94c457377);
const $731dd5b579eaba8f$export$dbc34c94c457377 = {
    LIMITED: 'limited',
    OPEN: 'open',
    PUBLIC: 'public'
};

});

parcelRegister("6czoq", function(module, exports) {

$parcel$export(module.exports, "SuccessView", () => $5f0f2a833fc793a6$export$be5117c66bf44cb9);
$parcel$export(module.exports, "NoPermissionView", () => $5f0f2a833fc793a6$export$be11ccfe1ded6d81);
$parcel$export(module.exports, "FormUnavailableView", () => $5f0f2a833fc793a6$export$5759d094146e3811);
$parcel$export(module.exports, "NoProjectAccessView", () => $5f0f2a833fc793a6$export$8c53a54f2f70bf31);
$parcel$export(module.exports, "IssueTypeNotAssociatedView", () => $5f0f2a833fc793a6$export$5d16b0bd7e8f5692);
$parcel$export(module.exports, "IssueTypeDeletedView", () => $5f0f2a833fc793a6$export$8e65211163568af8);
$parcel$export(module.exports, "FormContainsUnsupportedRequiredFieldsView", () => $5f0f2a833fc793a6$export$1c25efc053ce2b31);
$parcel$export(module.exports, "FormMissingSupportedRequiredFieldsView", () => $5f0f2a833fc793a6$export$e6e19199dff5fc90);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2rqOp = parcelRequire("2rqOp");

var $hTEpF = parcelRequire("hTEpF");

var $l1N8i = parcelRequire("l1N8i");

var $29YN9 = parcelRequire("29YN9");

var $cgL5K = parcelRequire("cgL5K");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $8Q4sF = parcelRequire("8Q4sF");

var $c8ARX = parcelRequire("c8ARX");

var $c2E1P = parcelRequire("c2E1P");

var $iVgQf = parcelRequire("iVgQf");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l2N2a = parcelRequire("l2N2a");

var $khNIP = parcelRequire("khNIP");
const $5f0f2a833fc793a6$var$contactAdminUrl = '/jira/contact-administrator';
const $5f0f2a833fc793a6$var$ContactYourAdminLinkMessage = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: $5f0f2a833fc793a6$var$contactAdminUrl
    }, chunks);
const $5f0f2a833fc793a6$var$WAC_LINK = 'https://www.atlassian.com/software/jira?utm_source=in-product-banner&utm_medium=inapp&utm_campaign=P:jira-work-management%7CO:cloudpmm-jwm%7CF:discovery%7CE:cloud%7CX:expand%7C';
const $5f0f2a833fc793a6$export$be5117c66bf44cb9 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { shouldHidePoweredBy: shouldHidePoweredBy, onResetClick: onResetClick, analyticAttributes: analyticAttributes } = props;
    const onSubmitAnotherResponse = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'submitAnotherResponseForForm', {
            ...analyticAttributes
        });
        onResetClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormSuccessView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$SuccessWrapper, {
        shouldHidePoweredBy: shouldHidePoweredBy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$Heading, null, formatMessage((0, $khNIP.messages).successSubmissionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $khNIP.messages).successSubmissionContentExperiment)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$SubmitAnotherButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        appearance: "primary",
        onClick: onSubmitAnotherResponse
    }, formatMessage((0, $khNIP.messages).formSubmitAnotherForm))), !shouldHidePoweredBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$PromoFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $khNIP.messages).formSuccessFooterSpork, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        }),
        componentsMapping: {
            link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29YN9.JiraIcon), {
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: $5f0f2a833fc793a6$var$WAC_LINK,
                    target: "_blank",
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'poweredByJwm');
                    }
                }, children))
        }
    }))));
};
const $5f0f2a833fc793a6$export$be11ccfe1ded6d81 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormNoPermissionView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).noPermissionHeading),
        headingLevel: 1,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $khNIP.messages).noPermissionContent,
            values: {
                createPermissionName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $khNIP.messages).createPermissionNameIssueTermRefresh : (0, $khNIP.messages).createPermissionName)),
                linkToContactAdmin: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
                ), {
                    onClick: (event, analyticsEvent)=>{
                        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'contactAdministrator');
                    },
                    href: "/secure/ContactAdministrators!default.jspa"
                }, formatMessage((0, $khNIP.messages).noPermissionLinkToContactAdmin))
            }
        }),
        maxImageWidth: 100,
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c2E1P.default))
    }));
};
const $5f0f2a833fc793a6$export$5759d094146e3811 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "business-form.common.ui.empty-views.form-unavailable",
        header: formatMessage((0, $khNIP.messages).formUnavailableHeading),
        headingLevel: 1,
        description: formatMessage((0, $khNIP.messages).formUnavailableContent),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$export$8c53a54f2f70bf31 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).formUnavailableWithoutProjectAccessTitle),
        headingLevel: 1,
        description: formatMessage((0, $khNIP.messages).formUnavailableWithoutProjectAccessDescription),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$export$5d16b0bd7e8f5692 = ({ issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const project = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)().data;
    const isAdmin = project && project.permissions.administerProject;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableIssueTypeRemovedView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).formUnavailableHeading),
        headingLevel: 1,
        description: isAdmin ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $khNIP.messages).formUnavailableIssueTypeNotAssociatedContentForAdminsIssueTermRefresh : (0, $khNIP.messages).formUnavailableIssueTypeNotAssociatedContentForAdmins, {
            issueTypeName: issueTypeName
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $khNIP.messages).formUnavailableIssueTypeNotAssociatedContentIssueTermRefresh : (0, $khNIP.messages).formUnavailableIssueTypeNotAssociatedContent,
            values: {
                link: $5f0f2a833fc793a6$var$ContactYourAdminLinkMessage
            }
        }),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$export$8e65211163568af8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const project = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)().data;
    const isAdmin = project && project.permissions.administerProject;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableIssueTypeDeletedView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).formUnavailableHeading),
        headingLevel: 1,
        description: isAdmin ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $khNIP.messages).formUnavailableIssueTypeDeletedContentForAdminsIssueTermRefresh : (0, $khNIP.messages).formUnavailableIssueTypeDeletedContentForAdmins) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $khNIP.messages).formUnavailableIssueTypeDeletedContentIssueTermRefresh : (0, $khNIP.messages).formUnavailableIssueTypeDeletedContent,
            values: {
                link: $5f0f2a833fc793a6$var$ContactYourAdminLinkMessage
            }
        }),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$export$1c25efc053ce2b31 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const project = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)().data;
    const canCreateOrModifyForm = project && project.permissions.administerProject;
    const projectKey = project?.key;
    const isTeamManaged = project?.isSimplified;
    const fieldLayoutSchemesUrlCMP = '/secure/admin/ViewFieldLayoutSchemes.jspa';
    const fieldLayoutSchemesUrlTMP = `/jira/core/projects/${projectKey}/settings/issuetypes`;
    const fieldLayoutSchemesUrl = isTeamManaged ? fieldLayoutSchemesUrlTMP : fieldLayoutSchemesUrlCMP;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormContainsUnsupportedRequiredFieldsView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).unsupportedRequiredFieldsHeading),
        headingLevel: 1,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $khNIP.messages).unsupportedRequiredFieldsDescription,
            values: {
                canCreateOrModifyForm: canCreateOrModifyForm,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
                        onClick: (event, analyticsEvent)=>{
                            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'formMissingUnsupportedRequiredFieldsCta', {
                                isAdmin: canCreateOrModifyForm
                            });
                        },
                        href: canCreateOrModifyForm ? fieldLayoutSchemesUrl : $5f0f2a833fc793a6$var$contactAdminUrl
                    }, chunks)
            }
        }),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$export$e6e19199dff5fc90 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const project = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)().data;
    const canCreateOrModifyForm = project && project.permissions.administerProject;
    const adminUrl = typeof window !== 'undefined' ? `${window.location.href}/builder` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormMissingSupportedRequiredFieldsView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).supportedRequiredFieldsMissingHeading),
        headingLevel: 1,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $khNIP.messages).supportedRequiredFieldsDescription,
            values: {
                canCreateOrModifyForm: canCreateOrModifyForm,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
                        onClick: (event, analyticsEvent)=>{
                            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'formMissingSupportedRequiredFieldsCta', {
                                isAdmin: canCreateOrModifyForm
                            });
                        },
                        href: canCreateOrModifyForm ? adminUrl : $5f0f2a833fc793a6$var$contactAdminUrl
                    }, chunks)
            }
        }),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$var$illustrationHeight = 4;
const $5f0f2a833fc793a6$var$Heading = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large",
        as: "h1"
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f0f2a833fc793a6$var$WrapperStyleBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _eid3idpf _fntnidpf _cfu11ule _l5lo12bs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f0f2a833fc793a6$var$SuccessWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $5f0f2a833fc793a6$var$WrapperStyleBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxmgjw _otyridpf _18u0mgjw _1kt976ek",
            __cmplp.shouldHidePoweredBy ? "_n3tdf6fq" : "_n3tdidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f0f2a833fc793a6$var$PromoFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3doudwz _1e0c1txw _4cvr1h6o _1bah1h6o _19pkxy5q _otyrpxbi _ca0q1ejb _syaz1thw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f0f2a833fc793a6$var$SubmitAnotherButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _19pku2gc _2hwxxy5q _otyridpf _18u0xy5q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $dJl1T.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("c8ARX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fefc6da4073af21$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mstqrh7gfrgxbc8ggp3w5jrj
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mstqrh7gfrgxbc8ggp3w5jrj

var $dCLgq = parcelRequire("dCLgq");

var $at4lO = parcelRequire("at4lO");
const $2fefc6da4073af21$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($at4lO)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($at4lO))
});
var $2fefc6da4073af21$export$2e2bcd8739ae039 = $2fefc6da4073af21$var$Illustration;
// for advanced use only
const $2fefc6da4073af21$export$a179c88182cb9d56 = [
    0,
    0,
    236,
    211
];

});
parcelRegister("at4lO", function(module, exports) {
module.exports = new URL("loading-file-error.402df2c9.svg", import.meta.url).toString();

});


parcelRegister("c2E1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $c12b9bc47dd929a8$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = sc7h9stshcvmkj7nt3ccks24
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/sc7h9stshcvmkj7nt3ccks24

var $dCLgq = parcelRequire("dCLgq");

var $9IVIt = parcelRequire("9IVIt");

var $d60hN = parcelRequire("d60hN");
const $c12b9bc47dd929a8$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($d60hN)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9IVIt))
});
var $c12b9bc47dd929a8$export$2e2bcd8739ae039 = $c12b9bc47dd929a8$var$Illustration;
// for advanced use only
const $c12b9bc47dd929a8$export$a179c88182cb9d56 = [
    0,
    0,
    169,
    222
];

});
parcelRegister("9IVIt", function(module, exports) {
module.exports = new URL("lock-red-darkmode.35f0d66e.svg", import.meta.url).toString();

});

parcelRegister("d60hN", function(module, exports) {
module.exports = new URL("lock-red.0ce332f2.svg", import.meta.url).toString();

});


parcelRegister("khNIP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $df85728e69598bad$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $df85728e69598bad$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    successSubmissionHeading: {
        "id": "business-form.common.empty-views.success-submission-heading",
        "defaultMessage": "We're on it!"
    },
    successSubmissionContentExperiment: {
        "id": "business-form.common.empty-views.success-submission-content-experiment",
        "defaultMessage": "Thanks for your submission."
    },
    noPermissionHeading: {
        "id": "business-form.common.empty-views.no-permission-heading",
        "defaultMessage": "You don't have access to this form"
    },
    noPermissionContent: {
        "id": "business-form.common.empty-views.no-permission-content",
        "defaultMessage": "You do not have permission to submit forms to this project. Please request for the {createPermissionName} permission by {linkToContactAdmin}"
    },
    noPermissionLinkToContactAdmin: {
        "id": "business-form.common.empty-views.no-permission-link-to-contact-admin",
        "defaultMessage": " contacting this project's administrator."
    },
    createPermissionName: {
        "id": "business-form.common.empty-views.create-permission-name",
        "defaultMessage": "\u201CCreate Issue\u201D"
    },
    formUnavailableHeading: {
        "id": "business-form.common.empty-views.form-unavailable-heading",
        "defaultMessage": "Form is unavailable"
    },
    formUnavailableContent: {
        "id": "business-form.common.empty-views.form-unavailable-content",
        "defaultMessage": "This form is no longer active. Try contacting the owner of the form if you think this is a mistake."
    },
    formUnavailableIssueTypeDeletedContent: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content",
        "defaultMessage": "The issue type associated with this form was removed from your business project. <link>Contact your admin</link> to delete the form and create a new one.  "
    },
    formUnavailableIssueTypeDeletedContentForAdmins: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content-for-admins",
        "defaultMessage": "The issue type associated with this form was removed from your business project. Delete this form and create a new one with the issue types that are available."
    },
    formUnavailableIssueTypeNotAssociatedContentOld: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-old",
        "defaultMessage": "The issue type being used for this form is not valid. {linkStart}Contact your admin{linkEnd} to check if this issue type is linked to the issue type scheme for this business project."
    },
    formUnavailableIssueTypeNotAssociatedContent: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content",
        "defaultMessage": "The issue type being used for this form is not valid. <link>Contact your admin</link> to check if this issue type is linked to the issue type scheme for this business project."
    },
    formUnavailableIssueTypeNotAssociatedContentForAdmins: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-for-admins",
        "defaultMessage": "The issue type {issueTypeName} being used for this form is not valid. Check if this issue type is linked to the issue type scheme for this business project."
    },
    formSuccessFooterSpork: {
        "id": "business-form.common.empty-views.form-success-footer-spork",
        "defaultMessage": "Powered by {linkStart}Jira{linkEnd}"
    },
    formSubmitAnotherForm: {
        "id": "business-form.common.empty-views.form-submit-another-form",
        "defaultMessage": "Submit another form"
    },
    unsupportedRequiredFieldsHeading: {
        "id": "business-form.common.empty-views.unsupported-required-fields-heading",
        "defaultMessage": "Unsupported required fields"
    },
    unsupportedRequiredFieldsDescription: {
        "id": "business-form.common.empty-views.unsupported-required-fields-description",
        "defaultMessage": "{canCreateOrModifyForm, select,\n            true {This form is missing information that is required. <link>Update the field configuration</link> to make these fields optional, and try again}\n            other {This form is missing information that is required by the admin. <link>Contact the admin</link> to request changes to the field configuration}\n        }."
    },
    supportedRequiredFieldsMissingHeading: {
        "id": "business-form.common.empty-views.supported-required-fields-missing-heading",
        "defaultMessage": "Missing required fields"
    },
    supportedRequiredFieldsDescription: {
        "id": "business-form.common.empty-views.supported-required-fields-description",
        "defaultMessage": "{canCreateOrModifyForm, select,\n            true {This form is missing information that is required. <link>Complete all the required fields in the form</link> and try again}\n            other {This form is missing information that is required by the admin. <link>Contact the admin</link> to request any changes to required fields}\n        }."
    },
    formUnavailableWithoutProjectAccessTitle: {
        "id": "business-form.common.empty-views.form-unavailable-without-project-access-title",
        "defaultMessage": "You can't view this form without access to this Jira project"
    },
    formUnavailableWithoutProjectAccessDescription: {
        "id": "business-form.common.empty-views.form-unavailable-without-project-access-description",
        "defaultMessage": "Try contacting the owner of this form if you think this is a mistake."
    },
    createPermissionNameIssueTermRefresh: {
        "id": "business-form.common.empty-views.create-permission-name-issue-term-refresh",
        "defaultMessage": "\u201CCreate work item\u201D"
    },
    formUnavailableIssueTypeDeletedContentIssueTermRefresh: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content-issue-term-refresh",
        "defaultMessage": "The work type associated with this form was removed from your business project. <link>Contact your admin</link> to delete the form and create a new one."
    },
    formUnavailableIssueTypeDeletedContentForAdminsIssueTermRefresh: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content-for-admins-issue-term-refresh",
        "defaultMessage": "The work type associated with this form was removed from your business project. Delete this form and create a new one with the work types that are available."
    },
    formUnavailableIssueTypeNotAssociatedContentOldIssueTermRefresh: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-old-issue-term-refresh",
        "defaultMessage": "The work type being used for this form is not valid. {linkStart}Contact your admin{linkEnd} to check if this work type is linked to the work type scheme for this business project."
    },
    formUnavailableIssueTypeNotAssociatedContentIssueTermRefresh: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-issue-term-refresh",
        "defaultMessage": "The work type being used for this form is not valid. <link>Contact your admin</link> to check if this work type is linked to the work type scheme for this business project."
    },
    formUnavailableIssueTypeNotAssociatedContentForAdminsIssueTermRefresh: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-for-admins-issue-term-refresh",
        "defaultMessage": "The work type {issueTypeName} being used for this form is not valid. Check if this work type is linked to the work type scheme for this business project."
    }
});

});


parcelRegister("lAzTA", function(module, exports) {

$parcel$export(module.exports, "useConditionalFieldLogicAnalyticsAttrs", () => $00e9d8575f2f4d9f$export$d1cdb18427131362);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $00e9d8575f2f4d9f$export$d1cdb18427131362 = ()=>(0, $5uXOq.useMemo)(()=>({
            isConditionalFieldLogicGateEnabled: (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_')
        }), []);

});

parcelRegister("g2iZ7", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionPreloader", () => $818cc29cb1c3ec2d$export$bacf31e62dc24134);
$parcel$export(module.exports, "useFormSubmission", () => $818cc29cb1c3ec2d$export$6a196f0d30f494f8);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $l2N2a = parcelRequire("l2N2a");

var $doZTA = parcelRequire("doZTA");

var $gak61 = parcelRequire("gak61");

var $EU5WQ = parcelRequire("EU5WQ");

var $5FLxe = parcelRequire("5FLxe");

var $kyf8b = parcelRequire("kyf8b");

var $8feUl = parcelRequire("8feUl");
const $818cc29cb1c3ec2d$export$bacf31e62dc24134 = ()=>{
    const [{ match: { params: { formId: formId } } }] = (0, $doZTA.useRouter)();
    const result = (0, $5FLxe.useGetFormWithFieldDataByFormId)(String(formId));
    const [state, { updateStore: updateStore }] = (0, $kyf8b.useFormSubmissionStore)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(result, state)) updateStore(result);
    }, [
        updateStore,
        result,
        state
    ]);
    return null;
};
const $818cc29cb1c3ec2d$export$6a196f0d30f494f8 = ()=>{
    const [{ data: formWithFieldData, loading: getFormLoading, error: getFormError }] = (0, $kyf8b.useFormSubmissionStore)();
    // TODO TNK-2651: If public, don't fetch `createmeta/businessform`
    const { data: fieldMetaData, loading: fieldMetaDataLoading, error: fieldMetaDataError } = (0, $EU5WQ.useFieldMeta)(formWithFieldData?.projectId, formWithFieldData?.issueType?.id, String(formWithFieldData?.formId));
    // TODO: Remove useProject on cleanup of jsw_forms_rollout
    const { data: project } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const projectType = (0, $gak61.useProjectType)();
    const loading = getFormLoading || fieldMetaDataLoading;
    return {
        data: loading ? undefined : {
            fieldMetaData: fieldMetaData,
            formWithFieldData: formWithFieldData,
            formSubmissionValidationData: (0, $8feUl.getFormValidationData)({
                formData: formWithFieldData,
                fieldMetaData: fieldMetaData,
                projectType: projectType ?? project?.type
            })
        },
        formId: String(formWithFieldData?.formId),
        loading: loading,
        error: getFormError || fieldMetaDataError
    };
};

});
parcelRegister("gak61", function(module, exports) {

$parcel$export(module.exports, "useIsSoftwareProject", () => $07561ff55b22087f$export$54f478d5af594f53);
$parcel$export(module.exports, "useProjectType", () => $07561ff55b22087f$export$6de29d851c914935);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $lODMY = parcelRequire("lODMY");
const $07561ff55b22087f$var$SOFTWARE_ROUTES_GROUPS = [
    'classic-software',
    'software'
];
const $07561ff55b22087f$export$a1210dbe3ee59218 = (state)=>$07561ff55b22087f$var$SOFTWARE_ROUTES_GROUPS.includes(state.route.group ?? '');
const $07561ff55b22087f$export$54f478d5af594f53 = (0, $lODMY.createRouterSelector)($07561ff55b22087f$export$a1210dbe3ee59218);
const $07561ff55b22087f$export$6de29d851c914935 = ()=>{
    if (!(0, $4R6GH.fg)('jsw_forms_rollout')) return undefined;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isSoftwareProject = $07561ff55b22087f$export$54f478d5af594f53();
    return isSoftwareProject ? (0, $2vSU6.SOFTWARE_PROJECT) : (0, $2vSU6.CORE_PROJECT);
};

});

parcelRegister("EU5WQ", function(module, exports) {

$parcel$export(module.exports, "useFieldMeta", () => $bba4aa13d32bd987$export$c6fef47cfdcb6be7);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");


var $gN11a = parcelRequire("gN11a");

var $7f4tk = parcelRequire("7f4tk");

var $45NOA = parcelRequire("45NOA");
const $bba4aa13d32bd987$var$fetchMeta = async (formId)=>{
    // https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-issues/#api-rest-api-2-issue-createmeta-get
    const response = await (0, $7f4tk.default)(`/rest/api/2/issue/createmeta/businessform?formId=${formId}&expand=projects.issuetypes.fields`);
    return response;
};
const $bba4aa13d32bd987$var$memoizedFetchMeta = (0, $8QpSo.default)($bba4aa13d32bd987$var$fetchMeta);
const $bba4aa13d32bd987$export$c6fef47cfdcb6be7 = (projectId, issueTypeId, formId)=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: true
    });
    (0, $5uXOq.useEffect)(()=>{
        if (projectId === undefined || projectId === null || issueTypeId === undefined || issueTypeId === null || formId === undefined || formId === null) {
            setState({
                loading: false
            });
            return;
        }
        (async ()=>{
            setState({
                loading: true
            });
            (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            try {
                // https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-issues/#api-rest-api-2-issue-createmeta-get
                const response = await $bba4aa13d32bd987$var$memoizedFetchMeta(formId);
                let data;
                // if there's a permission error, the response will exist but projects will be an empty array
                if (response.projects[0]?.issuetypes[0]?.fields) data = (0, $45NOA.transformFieldsMeta)((0, $45NOA.filterFieldsMeta)(response.projects[0].issuetypes[0].fields));
                setState({
                    data: // @ts-expect-error - TS2322 - Type '{ [x: string]: FieldMeta | { required: boolean; autoCompleteUrl?: string | undefined; schema?: { custom?: string | undefined; system?: string | undefined; } | undefined; defaultFieldValue?: string | undefined; allowedValues: CascadingAllowableValue[]; }; } | undefined' is not assignable to type 'FieldsMeta | undefined'.
                    data,
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setState({
                    loading: false,
                    error: e.message
                });
            } finally{
                (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
            }
        })();
    }, [
        formId,
        issueTypeId,
        projectId
    ]);
    return state;
};

});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("45NOA", function(module, exports) {

$parcel$export(module.exports, "filterFieldsMeta", () => $e161d853a36b3724$export$6a17577fedf4efeb);
$parcel$export(module.exports, "transformFieldsMeta", () => $e161d853a36b3724$export$613acfe083d57f99);

var $dPSWJ = parcelRequire("dPSWJ");

var $5fc53 = parcelRequire("5fc53");
const $e161d853a36b3724$export$6a17577fedf4efeb = (fieldMeta)=>{
    // remove specific field property from fieldMeta
    const { issuetype: issuetype, project: project, reporter: reporter, ...otherFieldMeta } = fieldMeta;
    return otherFieldMeta;
};
const $e161d853a36b3724$export$5647ab885112c565 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $e161d853a36b3724$var$isCascadingField = (fieldMeta)=>fieldMeta.schema?.custom === $e161d853a36b3724$export$5647ab885112c565;
// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'value' implicitly has an 'any' type.
const $e161d853a36b3724$var$transformCascadingFieldChildValue = ({ id: id, value: value })=>({
        id: id,
        value: value,
        __typename: 'JiraCascadingOptions'
    });
const $e161d853a36b3724$export$8e0c8a960f1af96 = ({ id: id, value: value, children: children = [] })=>({
        parentOptionValue: {
            id: id,
            value: value,
            __typename: 'JiraOption'
        },
        childOptionValues: children.map($e161d853a36b3724$var$transformCascadingFieldChildValue)
    });
// https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-groups/#api-rest-api-3-groups-picker-get
const $e161d853a36b3724$var$GROUP_PICKER_API_ENDPOINT = '/rest/api/3/groups/picker?query=';
const $e161d853a36b3724$var$isGroupField = (fieldMeta)=>fieldMeta.schema?.custom === (0, $5fc53.GROUP_CF_TYPE) || fieldMeta.schema?.custom === (0, $5fc53.MULTI_GROUP_CF_TYPE);
const $e161d853a36b3724$var$transformGroupField = (fieldMeta)=>({
        ...fieldMeta,
        autoCompleteUrl: $e161d853a36b3724$var$GROUP_PICKER_API_ENDPOINT
    });
const $e161d853a36b3724$export$613acfe083d57f99 = (fieldsMeta)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(fieldsMeta, (field)=>{
        // An autocomplete URL is not included in field meta data for Single or Multi group picker fields.
        // For now, manually include the autocomplete URL for these fields.
        if ($e161d853a36b3724$var$isGroupField(field)) return $e161d853a36b3724$var$transformGroupField(field);
        if (!$e161d853a36b3724$var$isCascadingField(field)) return field;
        const { allowedValues: allowedValues = [], ...rest } = field;
        return {
            allowedValues: allowedValues.map($e161d853a36b3724$export$8e0c8a960f1af96),
            ...rest
        };
    });

});


parcelRegister("5FLxe", function(module, exports) {

$parcel$export(module.exports, "useFormById", () => $fb77ed67ab7c7c60$export$ac7a76dbf4149182);
$parcel$export(module.exports, "useGetFormWithFieldDataByFormId", () => $fb77ed67ab7c7c60$export$7c42f44d9574ee82);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");


var $gN11a = parcelRequire("gN11a");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8qFWq = parcelRequire("8qFWq");

var $0557y = parcelRequire("0557y");
const $fb77ed67ab7c7c60$export$ac7a76dbf4149182 = (formId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [fetch, { data: data, loading: loading, error: error }] = (0, $5tTFS.useLazyQuery)((0, $8qFWq.JIRA_BUSINESS_FORM_BY_ID));
    (0, $5uXOq.useEffect)(()=>{
        if (formId != null) {
            (0, $gN11a.markViewMetric)('form', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            const QUERY_NAME = 'JiraBusinessFormById';
            fetch({
                variables: {
                    formId: formId,
                    isConditionalFieldsEnabled: (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_')
                },
                // @ts-expect-error - TS2345 - Argument of type '{ variables: { formId: string; }; onError: (apolloError: any) => void; onCompleted: () => void; }' is not assignable to parameter of type 'QueryLazyOptions<JiraBusinessFormByIdVariables>'. | TS7006 - Parameter 'apolloError' implicitly has an 'any' type.
                onError: (apolloError)=>{
                    (0, $jcw0u.default)({
                        meta: {
                            id: QUERY_NAME,
                            packageName: 'jiraBusinessForm',
                            teamName: 'jira-werewolves'
                        },
                        error: apolloError,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    (0, $gN11a.markViewMetric)('form', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
                },
                onCompleted: ()=>{
                    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${QUERY_NAME} succeeded`);
                    (0, $gN11a.markViewMetric)('form', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
                }
            });
        }
    }, [
        createAnalyticsEvent,
        fetch,
        formId
    ]);
    const form = (0, $5uXOq.useMemo)(()=>(0, $0557y.transformJiraBusinessForm)({
            data: data
        }), [
        data
    ]);
    return {
        form: form,
        loading: loading,
        error: error
    };
};
const $fb77ed67ab7c7c60$export$7c42f44d9574ee82 = (formId)=>{
    const QUERY_NAME = 'JiraBusinessFormWithFieldDataByFormId';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
    }, []);
    const { data: data, loading: loading, error: error } = (0, $5tTFS.useQuery)((0, $8qFWq.JIRA_BUSINESS_FORM_WITH_FIELD_DATA_BY_FORM_ID), {
        /**
		 * Forms currently has no requirement to utilize a cache, however if
		 * this policy is changed, be aware that you may need to make other changes
		 * to ensure that GQL unions work as expected and/or the cache doesn't
		 * collide with other features.
		 * See: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/45683/overview?commentId=2977330
		 */ fetchPolicy: 'no-cache',
        variables: {
            formId: formId,
            isConditionalFieldsEnabled: (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_')
        },
        onError: (apolloError)=>{
            const analyticsError = apolloError;
            const skipSentry = (0, $0557y.isFormNotFoundError)(analyticsError);
            if (skipSentry) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            analyticsError.skipSentry = true;
            (0, $jcw0u.default)({
                meta: {
                    id: QUERY_NAME,
                    packageName: 'jiraBusinessForm',
                    teamName: 'jira-werewolves'
                },
                error: analyticsError,
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        },
        onCompleted: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${QUERY_NAME} succeeded`);
            (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        }
    });
    return {
        data: (0, $0557y.transformFormDataWithFieldData)({
            data: data
        }),
        loading: loading,
        error: error
    };
};

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("8qFWq", function(module, exports) {

$parcel$export(module.exports, "JIRA_BUSINESS_FORM_BY_ID", () => $a583d3b87ccf6299$export$46b3396662c77cec);
$parcel$export(module.exports, "JIRA_BUSINESS_FORM_WITH_FIELD_DATA_BY_FORM_ID", () => $a583d3b87ccf6299$export$30c35ae67d1502b);

var $5cllN = parcelRequire("5cllN");

var $cRgoL = parcelRequire("cRgoL");
const $a583d3b87ccf6299$export$46b3396662c77cec = (0, $5cllN.default)`
  query JiraBusinessFormById($formId: ID!, $isConditionalFieldsEnabled: Boolean!) {
    jiraBusinessForm(formId: $formId) {
      ...FormBuilderConfigurationFragment
    }
  }

  ${(0, $cRgoL.FORM_BUILDER_CONFIGURATION_FRAGMENT)}
`;
const $a583d3b87ccf6299$export$30c35ae67d1502b = (0, $5cllN.default)`
  query JiraBusinessFormWithFieldDataByFormId(
		$formId: ID!,
		$isConditionalFieldsEnabled: Boolean!
	) {
    jiraBusinessForm(formId: $formId) {
      formId
      projectId
      issueType {
        name
        issueTypeId
      }
      title
      description
      bannerColor
      enabled
      accessLevel
      fields {
        fieldId
        alias
        description
        isRequired
				parentCondition @include(if: $isConditionalFieldsEnabled) {
					...FieldParentConditionFragment
				}
        field {
          name
          type
          ... on GenericIssueField {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraIssueFieldConfiguration {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraRichTextField {
            renderer
          }
        }
      }
    }
  }

	${(0, $cRgoL.FIELD_PARENT_CONDITION_FRAGMENT)}
`;

});
parcelRegister("cRgoL", function(module, exports) {

$parcel$export(module.exports, "FORM_BUILDER_CONFIGURATION_FRAGMENT", () => $e4d2e67206dcc3bb$export$41f21ae1bbcf5d4c);
$parcel$export(module.exports, "FORM_CONFIGURATION_FOR_DIRECTORY", () => $e4d2e67206dcc3bb$export$e89d36bee87f0323);
$parcel$export(module.exports, "MUTATION_ERROR_FRAGMENT", () => $e4d2e67206dcc3bb$export$25fa4c03959b6e86);
$parcel$export(module.exports, "FIELD_PARENT_CONDITION_FRAGMENT", () => $e4d2e67206dcc3bb$export$4e44bfa60653a6f1);

var $5cllN = parcelRequire("5cllN");
const $e4d2e67206dcc3bb$export$41f21ae1bbcf5d4c = (0, $5cllN.default)`
 fragment FormBuilderConfigurationFragment on JiraBusinessFormConfiguration {
    id
    formId
    projectId
    title
    description
    bannerColor
    enabled
    isSubmittableByAllLoggedInUsers
    accessLevel
    fields {
      id
      fieldId
      alias
      description
      isRequired
      parentCondition @include(if: $isConditionalFieldsEnabled) {
        id
      }
      conditions @include(if: $isConditionalFieldsEnabled) {
        __typename
        id
        ... on JiraFormSelectCondition {
          fieldOptionIds
          operator
        }
      }
      field @include(if: $isConditionalFieldsEnabled) {
        __typename
        id
		... on JiraSingleSelectField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraMultipleSelectField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraRadioSelectField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraCheckboxesField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraPriorityField {
			priorities {
				edges {
					node {
						id
						priorityId
						name
						iconUrl
					}
				}
			}
		}
      }
    }
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
 }
`;
const $e4d2e67206dcc3bb$export$e89d36bee87f0323 = (0, $5cllN.default)`
  fragment FormConfigurationFragmentForDirectory on JiraBusinessFormConfiguration {
    id
    formId
    title
    description
    bannerColor
    enabled
    updated
    accessLevel
    issueType {
      issueTypeId
      name
      avatarId
      avatar {
        medium
      }
    }
    updateAuthor {
      name
      accountId
    }
    errors
  }
`;
const $e4d2e67206dcc3bb$export$25fa4c03959b6e86 = (0, $5cllN.default)`
  fragment MutationErrorFragment on MutationError {
    message
    extensions {
      statusCode
      errorType
    }
  }
`;
const $e4d2e67206dcc3bb$export$4e44bfa60653a6f1 = (0, $5cllN.default)`
	fragment FieldParentConditionFragment on JiraFormFieldCondition {
		__typename
		id
		... on JiraFormSelectCondition {
			fieldOptionIds
			operator
		}
		parentField {
			id
			fieldId
			field {
				__typename
				id
			}
		}
	}
`;

});


parcelRegister("0557y", function(module, exports) {

$parcel$export(module.exports, "transformJiraBusinessForm", () => $b6818a16bbb72cb8$export$c07aa36a491f7398);
$parcel$export(module.exports, "transformFormDataWithFieldData", () => $b6818a16bbb72cb8$export$9488a647bac5a6d6);
$parcel$export(module.exports, "isFormNotFoundError", () => $b6818a16bbb72cb8$export$1227e121b71c2a43);
$parcel$export(module.exports, "formFieldByIdMatcher", () => $b6818a16bbb72cb8$export$a88a707fc50ff4c2);
$parcel$export(module.exports, "availableFieldByIdMatcher", () => $b6818a16bbb72cb8$export$bd8ddc5cdda736ac);

var $4R6GH = parcelRequire("4R6GH");

var $7wwVP = parcelRequire("7wwVP");

var $f7GQf = parcelRequire("f7GQf");
const $b6818a16bbb72cb8$export$4dee7f5ded2c202d = (field)=>// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"reporter" | "issuetype"'.
    (0, $f7GQf.IGNORE_FIELD_IDS).includes(field.fieldId) === false;
const $b6818a16bbb72cb8$export$47e6f860e5c51292 = (field)=>// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"reporter" | "issuetype"'.
    (0, $f7GQf.IGNORE_FIELD_IDS).includes(field.fieldId) === false;
const $b6818a16bbb72cb8$export$c07aa36a491f7398 = ({ data: data })=>{
    if (!data || !data.jiraBusinessForm) return undefined;
    const { jiraBusinessForm: jiraBusinessForm } = data;
    // the mapping from GraphQL type to FE type
    // mainly affects the `fields` only
    // this is done to remove the `undefined` from the fields array so it will be easier to consume in the UI layer
    const form = {
        id: jiraBusinessForm.id,
        formId: jiraBusinessForm.formId,
        projectId: jiraBusinessForm.projectId,
        title: jiraBusinessForm.title,
        description: jiraBusinessForm.description ?? undefined,
        bannerColor: jiraBusinessForm.bannerColor ?? undefined,
        enabled: jiraBusinessForm.enabled,
        isSubmittableByAllLoggedInUsers: jiraBusinessForm.isSubmittableByAllLoggedInUsers,
        issueType: jiraBusinessForm.issueType ? {
            id: jiraBusinessForm.issueType.issueTypeId ?? '',
            name: jiraBusinessForm.issueType.name ?? '',
            avatarId: jiraBusinessForm.issueType.avatarId ?? null,
            avatarUrl: jiraBusinessForm.issueType.avatar?.medium ?? null,
            isDefault: false,
            subtask: jiraBusinessForm.issueType.type === 'SUB_TASK',
            hierarchyLevel: jiraBusinessForm.issueType.hierarchy?.level ?? 0
        } : null,
        fields: jiraBusinessForm.fields?.filter(Boolean).map((f)=>({
                id: f.id,
                fieldId: f.fieldId,
                alias: f.alias ?? undefined,
                isRequiredByForm: !!f.isRequired,
                description: f.description ?? undefined,
                ...(0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_') && {
                    conditions: f.conditions?.concat(),
                    parentCondition: f.parentCondition,
                    field: f.field
                }
            })).filter($b6818a16bbb72cb8$export$4dee7f5ded2c202d) ?? null,
        accessLevel: jiraBusinessForm.accessLevel ? jiraBusinessForm.accessLevel : (0, $7wwVP.FormAccessLevelTypes).LIMITED
    };
    return form;
};
const $b6818a16bbb72cb8$export$9488a647bac5a6d6 = ({ data: data })=>{
    if (!data || !data.jiraBusinessForm) return undefined;
    const { jiraBusinessForm: jiraBusinessForm } = data;
    return {
        formId: jiraBusinessForm.formId,
        projectId: jiraBusinessForm.projectId,
        issueType: jiraBusinessForm.issueType ? {
            name: jiraBusinessForm.issueType.name || '',
            id: jiraBusinessForm.issueType.issueTypeId ?? ''
        } : null,
        title: jiraBusinessForm.title,
        description: jiraBusinessForm.description ?? undefined,
        bannerColor: jiraBusinessForm.bannerColor ?? undefined,
        enabled: jiraBusinessForm.enabled,
        fields: jiraBusinessForm.fields?.filter(Boolean).filter((f)=>'fieldConfig' in f.field).map((f)=>{
            const fieldIsRequiredByIssueConfig = 'fieldConfig' in f.field && Boolean(f.field.fieldConfig?.isRequired);
            const fieldIsRequiredByFormConfig = !!f.isRequired;
            return {
                fieldId: f.fieldId,
                alias: f.alias,
                name: f.field.name,
                isRequired: fieldIsRequiredByIssueConfig,
                isRequiredByForm: fieldIsRequiredByFormConfig,
                description: f.description ?? undefined,
                type: f.field.type,
                ...(0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_') && {
                    parentCondition: f.parentCondition
                },
                ...(0, $4R6GH.fg)('forms_multiline_text_wiki_renderer') && {
                    // @ts-expect-error - TS2339: Property 'renderer' does not exist on type 'JiraBusinessFormWithFieldDataByFormId_jiraBusinessForm_fields_field'.
                    renderer: f.field.renderer ?? undefined
                }
            };
        }).filter($b6818a16bbb72cb8$export$47e6f860e5c51292) ?? [],
        accessLevel: jiraBusinessForm.accessLevel ? jiraBusinessForm.accessLevel : (0, $7wwVP.FormAccessLevelTypes).LIMITED
    };
};
const $b6818a16bbb72cb8$export$1227e121b71c2a43 = (error)=>error.graphQLErrors?.[0]?.extensions?.errorType === (0, $f7GQf.FORM_NOT_FOUND_ERROR);
const $b6818a16bbb72cb8$export$a88a707fc50ff4c2 = (fieldId)=>(field)=>field.fieldId === fieldId;
const $b6818a16bbb72cb8$export$bd8ddc5cdda736ac = (fieldId)=>(field)=>field.fieldId === fieldId;

});
parcelRegister("f7GQf", function(module, exports) {

$parcel$export(module.exports, "IGNORE_FIELD_IDS", () => $5c143e6311b821dd$export$18705e0cb6bd7398);
$parcel$export(module.exports, "FORM_NOT_FOUND_ERROR", () => $5c143e6311b821dd$export$a5614f895fe1c5d2);

var $5fc53 = parcelRequire("5fc53");
const $5c143e6311b821dd$export$18705e0cb6bd7398 = [
    (0, $5fc53.REPORTER_TYPE),
    (0, $5fc53.ISSUE_TYPE)
];
const $5c143e6311b821dd$export$a5614f895fe1c5d2 = 'FORM_NOT_FOUND';

});



parcelRegister("kyf8b", function(module, exports) {

$parcel$export(module.exports, "useFormSubmissionStore", () => $885876e47cc26c5a$export$bd364acc55858de);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $885876e47cc26c5a$var$actions = {
    updateStore: (newData)=>({ setState: setState })=>{
            setState(newData);
        }
};
const $885876e47cc26c5a$var$FormSubmissionStore = (0, $iXqE5.createStore)({
    initialState: {
        data: undefined,
        loading: false,
        error: undefined
    },
    actions: $885876e47cc26c5a$var$actions,
    name: 'JWMFormSubmission'
});
const $885876e47cc26c5a$export$bd364acc55858de = (0, $3sQ5x.createHook)($885876e47cc26c5a$var$FormSubmissionStore);

});

parcelRegister("8feUl", function(module, exports) {

$parcel$export(module.exports, "getFormValidationData", () => $c8efa796b9edd3e8$export$1b92201c43ea8a87);

var $fOgCm = parcelRequire("fOgCm");
const $c8efa796b9edd3e8$export$1b92201c43ea8a87 = ({ formData: formData, fieldMetaData: fieldMetaData, projectType: projectType })=>{
    if (!formData || !fieldMetaData) return null;
    // required fields in form that are also required in the issue type
    const formRequiredFields = formData.fields.filter((f)=>f.isRequired && !!fieldMetaData[f.fieldId]);
    // required fields in project
    const requiredFieldIds = Object.keys(fieldMetaData).filter((fieldId)=>fieldMetaData[fieldId].required);
    const formContainsAllRequiredFields = formRequiredFields.length === requiredFieldIds.length;
    const isAllRequiredFieldsSupported = requiredFieldIds.every((f)=>{
        const fieldType = fieldMetaData[f].schema?.custom || fieldMetaData[f].schema?.system;
        if (!fieldType) return false;
        return (0, $fOgCm.isFieldTypeSupported)(fieldType, projectType);
    });
    const fieldsRequiredByForm = formData.fields.filter((f)=>f.isRequiredByForm && !!fieldMetaData[f.fieldId]);
    const hasProjectScopedRequiredFields = fieldsRequiredByForm.some(({ type: fieldType })=>{
        if (!fieldType) return false;
        return (0, $fOgCm.isProjectScopedFieldType)(fieldType);
    });
    return {
        isFormSubmissionValid: formContainsAllRequiredFields && isAllRequiredFieldsSupported,
        hasMissingSupportedRequiredFields: !formContainsAllRequiredFields && isAllRequiredFieldsSupported,
        hasUnsupportedRequiredFields: !isAllRequiredFieldsSupported,
        hasProjectScopedRequiredFields: hasProjectScopedRequiredFields
    };
};

});
parcelRegister("fOgCm", function(module, exports) {

$parcel$export(module.exports, "isFieldTypeSupported", () => $cef62a43f25c3fdf$export$b47920a5dd99844f);
$parcel$export(module.exports, "getFieldTypeConfig", () => $cef62a43f25c3fdf$export$5be962d414ad6e6c);
$parcel$export(module.exports, "FORM_LABEL", () => $cef62a43f25c3fdf$export$364c27f38e7541f8);
$parcel$export(module.exports, "getFormLabelPrefix", () => $cef62a43f25c3fdf$export$1cad3815d15ba80d);
$parcel$export(module.exports, "getUniqueFormLabel", () => $cef62a43f25c3fdf$export$b0616c054785bb44);
$parcel$export(module.exports, "isProjectScopedFieldType", () => $cef62a43f25c3fdf$export$b6ad606b1df91ef5);
$parcel$export(module.exports, "isFieldImproperForForm", () => $cef62a43f25c3fdf$export$567d10980a8f2859);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");

var $btedi = parcelRequire("btedi");

var $22Wo8 = parcelRequire("22Wo8");

var $1Zt9x = parcelRequire("1Zt9x");

var $1C9NJ = parcelRequire("1C9NJ");

var $97VNg = parcelRequire("97VNg");

var $aR835 = parcelRequire("aR835");

var $9Hxrl = parcelRequire("9Hxrl");

var $bunMY = parcelRequire("bunMY");

var $bxMnv = parcelRequire("bxMnv");

var $iNY3w = parcelRequire("iNY3w");

var $jbGY4 = parcelRequire("jbGY4");

var $awO6U = parcelRequire("awO6U");

var $3ZQGw = parcelRequire("3ZQGw");

var $kTnsH = parcelRequire("kTnsH");

var $g8kqC = parcelRequire("g8kqC");

var $iHSUu = parcelRequire("iHSUu");

var $3owst = parcelRequire("3owst");

var $dzSVK = parcelRequire("dzSVK");

var $2prZd = parcelRequire("2prZd");

var $eRVlU = parcelRequire("eRVlU");

var $cK31e = parcelRequire("cK31e");

var $9HQd3 = parcelRequire("9HQd3");

var $7lpSO = parcelRequire("7lpSO");

var $chk7J = parcelRequire("chk7J");

var $j85Ze = parcelRequire("j85Ze");

var $9TyvL = parcelRequire("9TyvL");

var $j2R7K = parcelRequire("j2R7K");

var $kfv7e = parcelRequire("kfv7e");

var $9uVge = parcelRequire("9uVge");

var $4I0dG = parcelRequire("4I0dG");

var $eFzGt = parcelRequire("eFzGt");

var $5VWF9 = parcelRequire("5VWF9");

var $1avQ5 = parcelRequire("1avQ5");
const $cef62a43f25c3fdf$var$PROJECT_SCOPED_FIELD_TYPE_CONFIGS = {
    [(0, $5fc53.PARENT_TYPE)]: (0, $2prZd.ParentFieldTypeConfig),
    [(0, $5fc53.SPRINT_TYPE)]: (0, $chk7J.SprintFieldTypeConfig)
};
const $cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS = {
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: (0, $1avQ5.MultiVersionsFieldTypeConfig)((0, $5fc53.AFFECTS_VERSIONS_TYPE)),
    [(0, $5fc53.ASSIGNEE_TYPE)]: (0, $22Wo8.AssigneeFieldTypeConfig),
    [(0, $5fc53.ATTACHMENT_TYPE)]: (0, $1Zt9x.AttachmentFieldTypeConfig),
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: (0, $1C9NJ.CascadingSelectFieldTypeConfig),
    [(0, $5fc53.CATEGORY_TYPE)]: (0, $97VNg.CategoryFieldTypeConfig),
    [(0, $5fc53.COMPONENTS_TYPE)]: (0, $aR835.ComponentsFieldTypeConfig),
    [(0, $5fc53.DATETIME_CF_TYPE)]: (0, $bunMY.DateTimeCustomFieldTypeConfig),
    [(0, $5fc53.DATE_CF_TYPE)]: (0, $9Hxrl.DateCustomFieldTypeConfig),
    [(0, $5fc53.DESCRIPTION_TYPE)]: (0, $bxMnv.DescriptionFieldTypeConfig),
    [(0, $5fc53.DUE_DATE_TYPE)]: (0, $iNY3w.DueDateFieldTypeConfig),
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: (0, $1avQ5.MultiVersionsFieldTypeConfig)((0, $5fc53.FIX_VERSIONS_TYPE)),
    [(0, $5fc53.GROUP_CF_TYPE)]: (0, $jbGY4.GroupCustomFieldTypeConfig),
    [(0, $5fc53.LABELS_CF_TYPE)]: (0, $awO6U.LabelsCustomFieldTypeConfig),
    [(0, $5fc53.LABELS_TYPE)]: (0, $3ZQGw.LabelsFieldTypeConfig),
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: (0, $kTnsH.MultiCheckboxesCustomFieldTypeConfig),
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: (0, $g8kqC.MultiGroupCustomFieldTypeConfig),
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: (0, $iHSUu.MultiSelectCustomFieldTypeConfig),
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: (0, $3owst.MultiUserCustomFieldTypeConfig),
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: (0, $1avQ5.MultiVersionsFieldTypeConfig)((0, $5fc53.MULTI_VERSION_CF_TYPE)),
    [(0, $5fc53.NUMBER_CF_TYPE)]: (0, $dzSVK.NumberCustomFieldTypeConfig),
    [(0, $5fc53.PARENT_TYPE)]: (0, $2prZd.ParentFieldTypeConfig),
    [(0, $5fc53.PEOPLE_CF_TYPE)]: (0, $eRVlU.PeopleCustomFieldType),
    [(0, $5fc53.PRIORITY_TYPE)]: (0, $cK31e.PriorityFieldTypeConfig),
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: (0, $9HQd3.RadioButtonsCustomFieldTypeConfig),
    [(0, $5fc53.SELECT_CF_TYPE)]: (0, $7lpSO.SelectCustomFieldTypeConfig),
    [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: (0, $btedi.AffectedServicesCustomFieldTypeConfig),
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $j85Ze.StoryPointEstimateCustomFieldTypeConfig),
    [(0, $5fc53.SUMMARY_TYPE)]: (0, $9TyvL.SummaryFieldTypeConfig),
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: (0, $kfv7e.TeamsPlatformCustomFieldTypeConfig),
    [(0, $5fc53.TEAM_CF_TYPE)]: (0, $j2R7K.TeamCustomFieldTypeConfig),
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: (0, $9uVge.TextAreaCustomFieldTypeConfig),
    [(0, $5fc53.TEXT_CF_TYPE)]: (0, $4I0dG.TextCustomFieldTypeConfig),
    [(0, $5fc53.URL_CF_TYPE)]: (0, $eFzGt.UrlCustomFieldTypeConfig),
    [(0, $5fc53.USER_CF_TYPE)]: (0, $5VWF9.UserCustomFieldTypeConfig),
    [(0, $5fc53.VERSION_CF_TYPE)]: (0, $1avQ5.VersionFieldTypeConfig)
};
const $cef62a43f25c3fdf$var$SOFTWARE_FIELD_TYPE_CONFIGS = {
    [(0, $5fc53.SPRINT_TYPE)]: (0, $chk7J.SprintFieldTypeConfig)
};
const $cef62a43f25c3fdf$var$FIELD_TYPE_CONFIGS = {
    ...$cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS,
    ...$cef62a43f25c3fdf$var$SOFTWARE_FIELD_TYPE_CONFIGS
};
function $cef62a43f25c3fdf$export$b47920a5dd99844f(type, projectType) {
    if (projectType === (0, $2vSU6.SOFTWARE_PROJECT)) return type in $cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS || type in $cef62a43f25c3fdf$var$SOFTWARE_FIELD_TYPE_CONFIGS;
    return type in $cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS;
}
function $cef62a43f25c3fdf$export$5be962d414ad6e6c(fieldType, projectType) {
    return $cef62a43f25c3fdf$export$b47920a5dd99844f(fieldType, projectType) ? $cef62a43f25c3fdf$var$FIELD_TYPE_CONFIGS[fieldType] : undefined;
}
const $cef62a43f25c3fdf$export$364c27f38e7541f8 = 'business-form';
const $cef62a43f25c3fdf$export$1cad3815d15ba80d = (projectType)=>{
    if ((0, $4R6GH.fg)('fix_forms_issue_create_labelling_issue')) {
        if (projectType === (0, $2vSU6.SOFTWARE_PROJECT)) return 'form';
        return 'business-form';
    }
    if (projectType != null && projectType === 'business') return 'business-form';
    return 'form';
};
const $cef62a43f25c3fdf$export$b0616c054785bb44 = (formLabelPrefix, formId)=>`${formLabelPrefix}-${formId}`;
const $cef62a43f25c3fdf$export$b6ad606b1df91ef5 = (type)=>type in $cef62a43f25c3fdf$var$PROJECT_SCOPED_FIELD_TYPE_CONFIGS;
/**
 * List of fields IDs that do not make sense to be shown in form
 * This is based on https://hello.atlassian.net/wiki/spaces/JBus/pages/988271414/Forms+-+Field+support+prioritisation Quadrant 4
 */ const $cef62a43f25c3fdf$var$improperFieldIdsForForm = new Set([
    'created',
    'issuelinks',
    'issuetype',
    'project',
    'resolution',
    'security',
    'subtasks',
    'timeoriginalestimate',
    'updated',
    'updated',
    'votes',
    'watches'
]);
const $cef62a43f25c3fdf$var$improperFieldTypesForForm = new Set([
    (0, $5fc53.EPIC_TYPE),
    (0, $5fc53.EPIC_COLOR_TYPE),
    (0, $5fc53.EPIC_NAME_TYPE)
]);
const $cef62a43f25c3fdf$export$567d10980a8f2859 = ({ fieldId: fieldId, fieldName: fieldName, fieldType: fieldType })=>{
    if ($cef62a43f25c3fdf$var$improperFieldIdsForForm.has(fieldId) || $cef62a43f25c3fdf$var$improperFieldTypesForForm.has(fieldType)) return true;
    // Cases for others where fieldId and fieldType are not sufficient
    // and requires combination of both
    // e.g. for some custom field because their fieldId is different in every instance
    // Flagged field
    if (fieldName === 'Flagged' && fieldType === (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) return true;
    return false;
};

});
parcelRegister("btedi", function(module, exports) {

$parcel$export(module.exports, "AffectedServicesCustomFieldTypeConfig", () => $b16b96f20af09d65$export$b379a34008ba5f5a);

var $5uXOq = parcelRequire("5uXOq");

var $ehis8 = parcelRequire("ehis8");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $2Kya6 = parcelRequire("2Kya6");

var $kShoa = parcelRequire("kShoa");
const $b16b96f20af09d65$var$AffectedServicesCustomFieldComponent = (props)=>{
    // strip off any query strings from URL as the field component also adds them in
    const autoCompleteUrl = props.autoCompleteUrl?.split('?')[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Kya6.default), {
        ...props,
        autoCompleteUrl: autoCompleteUrl
    });
};
const $b16b96f20af09d65$export$b379a34008ba5f5a = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ehis8))),
    type: (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
    Component: $b16b96f20af09d65$var$AffectedServicesCustomFieldComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.multiSelectFieldWriter)
};

});
parcelRegister("ehis8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eced7ee5c5c5dca9d0f101adbd9a0dd5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a650f78d49c8cbb1$var$_react = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a650f78d49c8cbb1$var$_baseNew = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a650f78d49c8cbb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a650f78d49c8cbb1$var$ComponentIcon = (props)=>/*#__PURE__*/ $a650f78d49c8cbb1$var$_react.default.createElement($a650f78d49c8cbb1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 5.25H2c-.69 0-1.25.56-1.25 1.25V12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6.5c0-.69-.56-1.25-1.25-1.25h-.75m-10.5 0v-2.5h3.5v2.5m-3.5 0h3.5m0 0h3.5m0 0v-2.5h3.5v2.5m-3.5 0h3.5"/>`
    }, props));
$a650f78d49c8cbb1$var$ComponentIcon.displayName = 'ComponentIcon';
var $a650f78d49c8cbb1$var$_default = module.exports.default = $a650f78d49c8cbb1$var$ComponentIcon;

});

parcelRegister("9gHYS", function(module, exports) {

$parcel$export(module.exports, "TextFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$6fa85fe91d7baf70);
$parcel$export(module.exports, "DescriptionFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$b2a65447738df397);
$parcel$export(module.exports, "AttachmentFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$b3e78b2794b60a3c);
$parcel$export(module.exports, "AssigneeFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$628ddd885c3ef19a);
$parcel$export(module.exports, "DropdownFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$6767d78d6b24ff93);
$parcel$export(module.exports, "DateFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$94d5efb8e5cd7e54);
$parcel$export(module.exports, "DateTimeFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$8ba7f20c1eb81d37);
$parcel$export(module.exports, "NotSupportedFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$4b127f667f36c30b);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $acknU = parcelRequire("acknU");

var $c8Oei = parcelRequire("c8Oei");

var $dD7Zc = parcelRequire("dD7Zc");

var $hPcwl = parcelRequire("hPcwl");

var $7FST0 = parcelRequire("7FST0");

var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $25C5e = parcelRequire("25C5e");
const $91f0bd5d2e8ed9a6$export$6fa85fe91d7baf70 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$TextFieldWrapper, null, formatMessage((0, $25C5e.default).fieldPlaceholder));
};
const $91f0bd5d2e8ed9a6$export$b2a65447738df397 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$DescriptionWrapper, null, formatMessage((0, $25C5e.default).fieldPlaceholder));
};
const $91f0bd5d2e8ed9a6$export$b3e78b2794b60a3c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$AttachmentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hPcwl))), {
        spacing: "spacious",
        label: "upload"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $25C5e.default).attachmentFieldPlaceholder))));
};
const $91f0bd5d2e8ed9a6$export$628ddd885c3ef19a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $91f0bd5d2e8ed9a6$var$fieldHeight,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7FST0))), {
        spacing: "spacious",
        label: "avatar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $25C5e.default).assigneeFieldPlaceholder)))));
};
const $91f0bd5d2e8ed9a6$export$6767d78d6b24ff93 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$WithIconAfterFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $91f0bd5d2e8ed9a6$var$fieldHeight,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $25C5e.default).dropdownFieldPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        spacing: "spacious",
        label: "openDropdown"
    }));
};
const $91f0bd5d2e8ed9a6$export$94d5efb8e5cd7e54 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$WithIconAfterFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $91f0bd5d2e8ed9a6$var$fieldHeight,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $25C5e.default).dateFieldPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
        spacing: "spacious",
        label: "calendar"
    }));
};
const $91f0bd5d2e8ed9a6$export$8ba7f20c1eb81d37 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$SplitHalfFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: $91f0bd5d2e8ed9a6$var$fieldHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $25C5e.default).dateFieldPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: $91f0bd5d2e8ed9a6$var$fieldHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $25C5e.default).timeFieldPlaceholder))));
};
const $91f0bd5d2e8ed9a6$export$4b127f667f36c30b = ({ isRequired: isRequired, onRemoveFieldClick: onRemoveFieldClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$NotSupportedFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: "error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtlest"
    }, isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $25C5e.default).notSupportedRequiredFieldPlaceholder,
        values: {
            contactAdmin: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: "/secure/ContactAdministrators!default.jspa"
            }, formatMessage((0, $25C5e.default).contactAdmin))
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $25C5e.default).notSupportedOptionalFieldPlaceholder,
        values: {
            clickHere: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                onClick: onRemoveFieldClick
            }, formatMessage((0, $25C5e.default).clickHere)))
        }
    }))));
};
const $91f0bd5d2e8ed9a6$var$fieldHeight = (0, $8CUq3.xcss)({
    height: '2.25rem'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$FieldBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _11c81oud _189et94y _1dqonqa1 _1h6dkidp _bfhk6rqw _syaz15i6 _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
}); /**
     * Expect icon in the content as the first element
     * Vertical align the icon and gives space between icon and the content
     */ 
const $91f0bd5d2e8ed9a6$var$IconBeforeBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _10nju2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$FieldBaseWithIconBefore = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _10nju2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$TextFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBaseWithIconBefore, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i14no",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$DescriptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i8vuz _ca0qu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$AttachmentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBaseWithIconBefore, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1dqogq9o _4t3i14no _bfhk18uv _1bah1h6o",
            __cmplp.className
        ])
    });
}); /**
     * Expect an icon as the last child, so it will be placed in the very right
     */ 
const $91f0bd5d2e8ed9a6$var$WithIconAfterFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1oc61wug",
            __cmplp.className
        ])
    });
});
const $91f0bd5d2e8ed9a6$var$SplitHalfFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _12apkb7n",
            __cmplp.className
        ])
    });
});
const $91f0bd5d2e8ed9a6$var$NotSupportedFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$IconBeforeBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81oud _syaz15i6 _1bsb1osq _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $91f0bd5d2e8ed9a6$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_17zi1oud _i1wwidpf _8ax3idpf _ake1idpf _1gqwidpf _t74oqslr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab6a74d5dbe2e66f9a6df60fb0887ec0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3c6678ca49b47a08391fd96c442f9a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("hPcwl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fcee7f74c07d89e15f85ecbe185ed53>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfa0e970215956ee$var$_react = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cfa0e970215956ee$var$_cloudArrowUp = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("ePJ5X")));

var $cfa0e970215956ee$var$_upload = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("aPRJS")));
function $cfa0e970215956ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfa0e970215956ee$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $cfa0e970215956ee$var$_react.default.createElement($cfa0e970215956ee$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $cfa0e970215956ee$var$_upload.default
    }, props));
$cfa0e970215956ee$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $cfa0e970215956ee$var$_default = module.exports.default = $cfa0e970215956ee$var$CloudArrowUpIcon;

});
parcelRegister("ePJ5X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae7bcd071fdd1b31fc8e5ebcc86c0a87>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc8cf07db1d2dba$var$_react = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $acc8cf07db1d2dba$var$_baseNew = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $acc8cf07db1d2dba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc8cf07db1d2dba$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $acc8cf07db1d2dba$var$_react.default.createElement($acc8cf07db1d2dba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.75 12.75a3 3 0 0 1-.733-5.91 5 5 0 0 1 9.908-.456A3.251 3.251 0 0 1 12 12.75m-7-2 3-3 3 3m-3-2.5V16"/>`
    }, props));
$acc8cf07db1d2dba$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $acc8cf07db1d2dba$var$_default = module.exports.default = $acc8cf07db1d2dba$var$CloudArrowUpIcon;

});

parcelRegister("aPRJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e385a40dadea6dc$var$_react = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7e385a40dadea6dc$var$_cloudArrowUp = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("ePJ5X")));
function $7e385a40dadea6dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7e385a40dadea6dc$var$UploadIcon = (props)=>/*#__PURE__*/ $7e385a40dadea6dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $7e385a40dadea6dc$var$_cloudArrowUp.default
    }));
$7e385a40dadea6dc$var$UploadIcon.displayName = 'UploadIcon';
var $7e385a40dadea6dc$var$_default = module.exports.default = $7e385a40dadea6dc$var$UploadIcon;

});


parcelRegister("25C5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $714c727dd5fe3e71$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $714c727dd5fe3e71$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fieldPlaceholder: {
        "id": "business-form.common.field-placeholders.field-placeholder",
        "defaultMessage": "Answer will be written here"
    },
    attachmentFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.attachment-field-placeholder",
        "defaultMessage": "Attachments will be uploaded here"
    },
    assigneeFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.assignee-field-placeholder",
        "defaultMessage": "Unassigned"
    },
    dropdownFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.dropdown-field-placeholder",
        "defaultMessage": "Answer will be selected from dropdown"
    },
    dateFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.date-field-placeholder",
        "defaultMessage": "Date will be entered here"
    },
    timeFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.time-field-placeholder",
        "defaultMessage": "Time will be entered here"
    },
    notSupportedRequiredFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.not-supported-required-field-placeholder",
        "defaultMessage": "This required field is unsupported, {contactAdmin} to make this field optional"
    },
    contactAdmin: {
        "id": "business-form.common.field-placeholders.contact-admin",
        "defaultMessage": "contact admin"
    },
    notSupportedOptionalFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.not-supported-optional-field-placeholder",
        "defaultMessage": "This field is unsupported, {clickHere} to remove this field. "
    },
    clickHere: {
        "id": "business-form.common.field-placeholders.click-here",
        "defaultMessage": "click here"
    }
});

});


parcelRegister("2Kya6", function(module, exports) {

$parcel$export(module.exports, "default", () => $55a4d6a889fba550$export$2e2bcd8739ae039);

var $hpV4g = parcelRequire("hpV4g");

var $ii6hB = parcelRequire("ii6hB");

var $aZJYe = parcelRequire("aZJYe");

var $6iZh4 = parcelRequire("6iZh4");
const $55a4d6a889fba550$var$AffectedServicesField = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aZJYe.transformDefaultAffectedServices),
    validator: (0, $6iZh4.validateRequired)
})((0, $ii6hB.AffectedServicesField));
var $55a4d6a889fba550$export$2e2bcd8739ae039 = $55a4d6a889fba550$var$AffectedServicesField;

});
parcelRegister("hpV4g", function(module, exports) {

$parcel$export(module.exports, "withFormField", () => $b3f935405140180d$export$17bf6386ac4a43ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7O4UO = parcelRequire("7O4UO");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $5pZ9g = parcelRequire("5pZ9g");

var $7Emtg = parcelRequire("7Emtg");

var $6cMZg = parcelRequire("6cMZg");

var $gifeQ = parcelRequire("gifeQ");

var $bPtOr = parcelRequire("bPtOr");

var $fl3Yy = parcelRequire("fl3Yy");

var $1MgIu = parcelRequire("1MgIu");

var $bCATC = parcelRequire("bCATC");
var $bv5he = parcelRequire("bv5he");
var $mTNgq = parcelRequire("mTNgq");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");


var $2eeg1 = parcelRequire("2eeg1");

var $dCm1o = parcelRequire("dCm1o");

var $aBZin = parcelRequire("aBZin");

var $45JN1 = parcelRequire("45JN1");

var $iblgc = parcelRequire("iblgc");

var $86fzT = parcelRequire("86fzT");
const $b3f935405140180d$export$17bf6386ac4a43ba = (options)=>(Component)=>// @ts-expect-error - TS2322 - Type '(ownProps: ReturnComponentProps<Config>) => JSX.Element | null' is not assignable to type 'AbstractComponent<ReturnComponentProps<Config>, any>'.
        (ownProps)=>{
            const { fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, description: descriptionRaw, isRequired: isRequired = false, defaultValue: // @ts-expect-error - TS2339 - Property 'defaultValue' does not exist on type '{ areUiModificationsBusy?: boolean | undefined; } & BaseField & { componentKey?: string | undefined; fieldType?: string | undefined; forge?: { selectedProject: SelectedProject; selectedIssueType: IssueOrRequestType; modules: ForgeModules; } | undefined; fieldHelpTextUrl?: string | undefined; onLayoutDone?: (() => vo...'.
            defaultValue, componentKey: componentKey, forge: forge, onLayoutDone: onLayoutDone, fieldHelpTextUrl: fieldHelpTextUrl, areUiModificationsBusy: areUiModificationsBusy, defaultValueDontTransform: defaultValueDontTransform, isRequiredFromUIM: isRequiredFromUIM, onLinkClickEvent: onLinkClickEvent, isMini: isMini, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive, fieldWrapperElement: fieldWrapperElement, ...ownPropsRest } = ownProps;
            const { publish: publish } = (0, $9svjh.useGICLifeCycleEvents)();
            const { transformDefaultValue: transformDefaultValue, validator: validator, shouldRenderFieldMessage: shouldRenderFieldMessage = true, shouldHideLabel: shouldHideLabel = false } = options;
            const description = (0, $gifeQ.isForgeCustomField)(fieldType) ? (0, $1MgIu.extractEnvFromFieldDescription)(descriptionRaw).description : descriptionRaw;
            const hasSentTransformDefaultValueError = (0, $5uXOq.useRef)(false);
            let transformedDefaultValue;
            try {
                /**
     * The transformDefaultValue function is generally used to transform a defaultValue
     * that is passed from the backend, which is in a different data format to the
     * frontend data format.
     *
     * In some situations, we want to set the defaultValue using data that is already
     * in the frontend data format instead of the backend data format. In these cases
     * we want to ignore the transformDefaultValue and just use the defaultValue from props.
     *
     * To do this, we are using the defaultValueDontTransform prop to know that we
     * can safely not run transformDefaultValue.
     */ if (defaultValueDontTransform) transformedDefaultValue = defaultValue; // this can be merged into the below on ff cleanup
                else transformedDefaultValue = defaultValue !== undefined && typeof transformDefaultValue === 'function' ? transformDefaultValue(defaultValue) : defaultValue;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (hasSentTransformDefaultValueError.current === false) {
                    hasSentTransformDefaultValueError.current = true;
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'defaultValueTransformation',
                            packageName: 'jiraIssueCreateCommons',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            fieldType: fieldType
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
            (0, $5uXOq.useLayoutEffect)(()=>{
                onLayoutDone && onLayoutDone();
            }, [
                onLayoutDone
            ]);
            const shouldSetWidth = (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? isMini || isFieldResponsive : isMini;
            const renderComponent = (fieldProps, error)=>// @ts-expect-error Type 'Omit<ReturnComponentProps<Config>, "fieldId" | "fieldName" | "description" | "isRequired" | "defaultValue" | "areUiModificationsBusy" | "componentKey" | "fieldType" | "forge" | "fieldHelpTextUrl" | "onLayoutDone"> & { ...; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<ComponentProps<Config, FieldValue>> & RefAttributes<any> & { ...; }'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...ownPropsRest,
                    fieldId: fieldId,
                    fieldName: fieldName,
                    isRequired: isRequired,
                    fieldProps: fieldProps,
                    width: shouldSetWidth ? '100%' : undefined,
                    isMini: isMini,
                    description: description,
                    defaultValue: defaultValue,
                    error: error,
                    key: componentKey,
                    ariaLabelledBy: `${fieldId}-field-label`
                });
            const renderFieldMessage = (0, $5uXOq.useCallback)((error)=>{
                if (shouldRenderFieldMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
                    fieldId: fieldId,
                    description: description,
                    error: error,
                    fieldName: fieldName,
                    fieldHelpTextUrl: fieldHelpTextUrl,
                    onLinkClickEvent: onLinkClickEvent,
                    isMini: isMini
                });
                return null;
            }, [
                description,
                fieldHelpTextUrl,
                fieldId,
                fieldName,
                isMini,
                onLinkClickEvent,
                shouldRenderFieldMessage
            ]);
            const extension = (0, $5uXOq.useMemo)(()=>{
                if (typeof fieldType === 'string' && (0, $gifeQ.isForgeCustomField)(fieldType) && forge?.modules && forge?.hasFinishedLoading) return (0, $6cMZg.getExtension)(fieldType, forge?.modules);
                return null;
            }, [
                fieldType,
                forge?.modules,
                forge?.hasFinishedLoading
            ]);
            (0, $5uXOq.useEffect)(()=>{
                const shouldReportFailure = typeof fieldType === 'string' && (0, $gifeQ.isForgeCustomField)(fieldType) && forge?.hasFinishedLoading && !extension && forge?.modules && forge?.filteredOutModules;
                if (shouldReportFailure) (0, $7Emtg.reportForgeFailure)(fieldType, forge?.modules, forge?.filteredOutModules);
            }, [
                fieldType,
                extension,
                forge?.modules,
                forge?.filteredOutModules,
                forge?.hasFinishedLoading
            ]);
            const renderFieldContent = (fieldProps, error)=>{
                if (isCollapsed && (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return null;
                const fieldPropsWithPublish = {
                    ...fieldProps,
                    onChange: (value, ...rest)=>{
                        fieldProps.onChange(value, ...rest);
                        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, {
                            fieldId: fieldId,
                            fieldName: fieldName,
                            fieldType: fieldType,
                            value: (0, $aBZin.getValueFromEventOrValue)(value)
                        });
                    }
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldType !== undefined && (0, $gifeQ.isForgeCustomField)(fieldType) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5pZ9g.ForgeField), {
                    fieldId: fieldId,
                    fieldName: fieldName,
                    fieldType: fieldType,
                    fieldProps: fieldPropsWithPublish,
                    error: error,
                    selectedProject: forge?.selectedProject,
                    selectedIssueType: forge?.selectedIssueType,
                    extension: extension,
                    renderFieldMessage: renderFieldMessage,
                    renderDefaultComponent: renderComponent
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldWrapperElement ? /*#__PURE__*/ (0, $5uXOq.cloneElement)(fieldWrapperElement, {}, [
                    renderComponent(fieldPropsWithPublish, error),
                    renderFieldMessage(error)
                ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
            };
            const renderFieldLabel = (0, $5uXOq.useCallback)(()=>{
                if (isCollapsed && (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return ''; // TODO Merge this condition with the one below when cleaning migrate_gic_smart_fields_jira_labs https://hello.jira.atlassian.cloud/browse/DEE-3790
                if (shouldHideLabel) return ''; // one off case only expected in case of worklog where we want to show the label inside the component code
                if ((0, $gifeQ.isForgeCustomField)(fieldType)) {
                    const { environment: environment } = (0, $1MgIu.extractEnvFromFieldDescription)(descriptionRaw);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f935405140180d$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
                        environmentType: environment
                    }));
                }
                return fieldName;
            }, [
                fieldName,
                fieldType,
                shouldHideLabel,
                descriptionRaw,
                isCollapsed
            ]);
            if ((0, $gifeQ.isForgeCustomField)(fieldType) && !forge?.hasFinishedLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iblgc.FieldSkeleton), null);
            if ((0, $gifeQ.isForgeCustomField)(fieldType) && !extension) return null;
            const renderField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                id: `${fieldId}-field`,
                label: renderFieldLabel(),
                elementAfterLabel: areUiModificationsBusy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv5he.FieldBusyIndicator), {
                    fieldId: fieldId
                }) : undefined,
                isRequired: isRequired,
                name: fieldId,
                defaultValue: transformedDefaultValue,
                key: (0, $86fzT.generateKeyForRequiredFromUIM)({
                    fieldId: fieldId,
                    isRequiredFromUIM: isRequiredFromUIM === true
                }),
                validate: (value, _formState, { dirty: dirty })=>{
                    try {
                        const { type: type } = ownPropsRest;
                        if ((0, $gifeQ.isForgeCustomField)(fieldType) && isRequired) // Dirty check is required for the forge custom fields that haven't yet populated the value because it haven't lost a focus
                        return dirty && typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                        return typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'fieldValidationIssue',
                                packageName: 'jiraIssueCreateCommons',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        return undefined;
                    }
                }
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassOutput), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                    id: "issueAdjustmentsFieldValueDecorator",
                    packageName: "jiraIssueCreateModal",
                    fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mTNgq.IssueAdjustmentsErrorHandler), null), renderFieldContent(fieldProps, error)),
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: (err)=>({
                            errorType: (0, $bPtOr.getErrorType)(err),
                            viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                            fieldId: fieldId,
                            fieldType: fieldType
                        })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eeg1.FieldValueDecoratorAsync), {
                    fieldId: fieldId,
                    fieldType: fieldType,
                    fieldProps: fieldProps
                }, (interceptedFieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassInput), null, renderFieldContent(interceptedFieldProps, error))))));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                id: "withFormField",
                packageName: "jiraIssueCreateModal",
                fallback: "unmount",
                sendToPrivacyUnsafeSplunk: true,
                ...(0, $4R6GH.fg)('gic_add_attributes_to_form_field_error_boundary') ? {
                    attributes: {
                        fieldId: fieldId,
                        fieldType: fieldType
                    }
                } : {}
            }, (0, $dCm1o.isVisualRefreshEnabled)() && fieldId === 'assignee' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $b3f935405140180d$var$fieldStyles
            }, " ", renderField, " ") : renderField);
        };
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3f935405140180d$var$ForgeLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81il0 _zulpu2gc _1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $b3f935405140180d$var$fieldStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});

});
parcelRegister("5pZ9g", function(module, exports) {

$parcel$export(module.exports, "ForgeField", () => $297a009f70430225$export$34a15d6027142c62);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $2RhPB = parcelRequire("2RhPB");

var $7Aezm = parcelRequire("7Aezm");

var $g5X3G = parcelRequire("g5X3G");

var $gifeQ = parcelRequire("gifeQ");

var $ELVDL = parcelRequire("ELVDL");

var $j5sSv = parcelRequire("j5sSv");

var $7fjFA = parcelRequire("7fjFA");


var $6cMZg = parcelRequire("6cMZg");
const $297a009f70430225$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, error: error, selectedProject: selectedProject, selectedIssueType: selectedIssueType, extension: extension, renderDefaultComponent: renderDefaultComponent })=>{
    const { onChange: onChange, value: value } = fieldProps;
    const extensionPayload = (0, $5uXOq.useMemo)(()=>{
        if (value === undefined) return {
            fieldValue: null
        };
        return {
            fieldValue: (0, $6cMZg.transformValueToExtensionData)(value, extension)
        };
    }, [
        extension,
        value
    ]);
    const extensionData = (0, $5uXOq.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: 'issue-create'
        };
        if (!selectedProject || !selectedIssueType) return defaultExtensionData;
        const issueTypeId = (0, $g5X3G.toIssueTypeId)(selectedIssueType.type === (0, $5363dcf42759d41f$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value);
        return {
            ...defaultExtensionData,
            project: {
                id: (0, $g5X3G.toProjectId)(selectedProject.value),
                key: (0, $g5X3G.toProjectKey)(selectedProject.projectKey),
                type: selectedProject.projectType
            },
            issue: {
                type: selectedIssueType.type === (0, $5363dcf42759d41f$export$92ab80c1dc9baf44) && selectedIssueType.issueTypeName || selectedIssueType.label,
                typeId: issueTypeId
            }
        };
    }, [
        selectedProject,
        selectedIssueType,
        fieldId,
        fieldName,
        fieldType
    ]);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            renderContext: 'issue-create',
            fieldType: extension?.properties.type,
            module: extension?.type,
            ...extension ? (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension) : {}
        }), [
        extension
    ]);
    if (!extension) return null;
    const renderDefaultView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderDefaultComponent(fieldProps, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
            attributes: {
                ...analyticsAttributes,
                renderMode: 'default'
            }
        }));
    if (!extension.properties.edit) return renderDefaultView();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ELVDL.EditMode), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        analyticsAttributes: analyticsAttributes,
        onChange: onChange
    });
};
const $297a009f70430225$export$34a15d6027142c62 = (props)=>{
    const { renderFieldMessage: renderFieldMessage, ...rest } = props;
    const { fieldId: fieldId, extension: extension, error: error } = rest;
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            renderContext: 'issue-create',
            ...extension && (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension)
        }), [
        extension
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Aezm.EditAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j5sSv.FieldContainer), {
        width: "100%",
        paddingBottom: 6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($297a009f70430225$export$4f0175d9150f8767, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7fjFA.ForgeFieldMessage), {
        error: error,
        fieldId: fieldId,
        renderFieldMessage: renderFieldMessage
    })));
};

});
parcelRegister("7Aezm", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $f6c5a5a43a090916$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $f6c5a5a43a090916$export$947ae3996b2bc000);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");
const $f6c5a5a43a090916$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $f6c5a5a43a090916$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
        entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
        ...props
    });

});

parcelRegister("gifeQ", function(module, exports) {

$parcel$export(module.exports, "isForgeCustomField", () => $89f92c26c7f930da$export$78cf1b56a8dede1f);
$parcel$export(module.exports, "isForgeLegacyFieldType", () => $89f92c26c7f930da$export$3fb46a1fa454ffea);
$parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", () => $89f92c26c7f930da$export$2b6a9cc67d548886);
$parcel$export(module.exports, "focusFormButton", () => $89f92c26c7f930da$export$f1a0ef98758e7a8a);

var $k2DRb = parcelRequire("k2DRb");
const $89f92c26c7f930da$export$78cf1b56a8dede1f = (fieldType)=>typeof fieldType === 'string' && (fieldType.startsWith((0, $k2DRb.LEGACY_FORGE_FIELD_TYPE_PREFIX)) || fieldType.startsWith((0, $k2DRb.FORGE_FIELD_TYPE_PREFIX)));
const $89f92c26c7f930da$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith((0, $k2DRb.LEGACY_FORGE_FIELD_TYPE_PREFIX));
const $89f92c26c7f930da$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split((0, $k2DRb.PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX))[1] || null;
const $89f92c26c7f930da$export$319e805d3fc5ee35 = (fields)=>Object.values(fields).filter((field)=>$89f92c26c7f930da$export$78cf1b56a8dede1f(field.fieldType));
const $89f92c26c7f930da$export$f1a0ef98758e7a8a = (formSelector, target = document)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const button = target.querySelector(`button[form="${formSelector}"][type="submit"]`);
    if (button != null) button.focus();
};

});

parcelRegister("ELVDL", function(module, exports) {

$parcel$export(module.exports, "EditMode", () => $ed405e89d26d258c$export$5304145354a3bee9);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $2RhPB = parcelRequire("2RhPB");

var $4JpPl = parcelRequire("4JpPl");

var $7Aezm = parcelRequire("7Aezm");

var $9wJ66 = parcelRequire("9wJ66");

var $frltc = parcelRequire("frltc");

var $koVbs = parcelRequire("koVbs");

var $6cMZg = parcelRequire("6cMZg");

var $gb8Pv = parcelRequire("gb8Pv");
const $ed405e89d26d258c$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
    const [isModalMode, setIsModalMode] = (0, $5uXOq.useState)(false);
    const intl = (0, $koVbs.default)();
    const onEditConfirm = (0, $5uXOq.useCallback)((newValue)=>{
        onChange((0, $6cMZg.transformValue)(newValue, extension));
        (0, $4JpPl.fireTrackEditedEvent)('issue-create', analyticsAttributes);
    }, [
        extension,
        analyticsAttributes,
        onChange
    ]);
    const onModalRender = (0, $5uXOq.useCallback)(()=>setIsModalMode(true), []);
    if (isModalMode) {
        // temporary for UI Kit version of 1.2.0 when inline edit is not supported
        // will be fixed with https://ecosystem-platform.atlassian.net/browse/ARKEN-32
        const translatedError = {
            message: intl.formatMessage((0, $gb8Pv.default).modalModeErrorTitle),
            errorMessage: intl.formatMessage((0, $gb8Pv.default).modalModeErrorDescription)
        };
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience on issue create', {
            ...analyticsAttributes,
            extension: JSON.stringify(extension)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frltc.ErrorPanel), {
            error: translatedError
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wJ66.AsyncCustomFieldInlineEdit), {
        extension: extension,
        extensionData: extensionData,
        analyticsAttributes: analyticsAttributes,
        extensionPayload: extensionPayload,
        onSubmit: onEditConfirm,
        onModalRender: onModalRender
    });
};
const $ed405e89d26d258c$export$5304145354a3bee9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Aezm.EditAnalyticsWrapper), {
        attributes: (0, $2RhPB.getAnalyticsAttributesFromExtension)(props.extension)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed405e89d26d258c$export$ba588b5cce278e96, props));

});
parcelRegister("4JpPl", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $d80ee50440a72c0c$export$1798d320c6527c08);
$parcel$export(module.exports, "fireUiCanceledEvent", () => $d80ee50440a72c0c$export$fc09afa3d0d5294c);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $d80ee50440a72c0c$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $d80ee50440a72c0c$export$cfefb608fbbf02c9);
$parcel$export(module.exports, "fireOperationalFailedEvent", () => $d80ee50440a72c0c$export$add44f896fb31ba3);

var $k2DRb = parcelRequire("k2DRb");

var $8uOa6 = parcelRequire("8uOa6");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");
const $d80ee50440a72c0c$var$moduleEventId = (0, $9BrHy.getEventId)({
    module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
});
const $d80ee50440a72c0c$var$triggerEventId = (0, $9BrHy.getEventId)({
    module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
});
const $d80ee50440a72c0c$export$1798d320c6527c08 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).EDITED, {
        id: $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $d80ee50440a72c0c$export$fc09afa3d0d5294c = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CANCELED, {
        id: $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $d80ee50440a72c0c$export$762dee9e981de3e1 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $d80ee50440a72c0c$export$cfefb608fbbf02c9 = (extensionId, source, attributes)=>{
    (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CLICKED, {
        id: $d80ee50440a72c0c$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $d80ee50440a72c0c$export$add44f896fb31ba3 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("9wJ66", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomFieldInlineEdit", () => $05c72791f20b76f4$export$ca6c6772b322056d);

var $5uXOq = parcelRequire("5uXOq");

var $2G8Ll = parcelRequire("2G8Ll");

var $3oVvh = parcelRequire("3oVvh");
const $05c72791f20b76f4$var$isIssueViewProps = (props)=>props.extensionData.renderContext === 'issue-view';
const $05c72791f20b76f4$var$isIssueCreateOrTransitionProps = (props)=>props.extensionData.renderContext === 'issue-create' || props.extensionData.renderContext === 'issue-transition';
const $05c72791f20b76f4$export$980ea0297ad3a4c8 = (props)=>{
    if ($05c72791f20b76f4$var$isIssueViewProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3oVvh.LazyCustomFieldInlineEditIssueView), props);
    if ($05c72791f20b76f4$var$isIssueCreateOrTransitionProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2G8Ll.LazyCustomFieldInlineEditForm), props);
    return null;
};
const $05c72791f20b76f4$export$ca6c6772b322056d = $05c72791f20b76f4$export$980ea0297ad3a4c8;

});
parcelRegister("2G8Ll", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditForm", () => $3e8d63ebec6f951f$export$eb4eaeb8dcd7d4ca);

var $5uXOq = parcelRequire("5uXOq");


var $6ikhl = parcelRequire("6ikhl");

var $4JpPl = parcelRequire("4JpPl");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $lfTZh = parcelRequire("lfTZh");

var $bLCKr = parcelRequire("bLCKr");

var $69dub = parcelRequire("69dub");

var $3OHUI = parcelRequire("3OHUI");
const $3e8d63ebec6f951f$var$skeletonConfig = [
    {
        width: 100
    }
];
const $3e8d63ebec6f951f$export$eb4eaeb8dcd7d4ca = ({ onSubmit: onSubmit, onModalRender: onModalRender, ...restProps })=>{
    const requestsCount = (0, $5uXOq.useRef)(0);
    const [, { setFieldState: setFieldState }] = (0, $6ikhl.useInlineField)(restProps.extensionData.fieldId);
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
    const loadingComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLCKr.Skeleton), {
            skeletonConfig: $3e8d63ebec6f951f$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $5uXOq.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldId: extensionData.fieldId,
            fieldType: extensionData.fieldType,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            isInline: true
        };
    }, [
        extension,
        extensionData
    ]);
    const extraProps = (0, $5uXOq.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    const createRetryFunction = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fieldValue)=>async ()=>{
            try {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)
                });
                requestsCount.current += 1;
                const submitValue = await Promise.resolve(fieldValue);
                onSubmit(submitValue);
                requestsCount.current -= 1;
                if (requestsCount.current === 0) setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$9956c6a700e724c4)
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)
                });
                (0, $4JpPl.fireOperationalEditFailedEvent)(extensionData.renderContext, {
                    error: error,
                    isInline: true
                });
            }
            return undefined;
        }, [
        onSubmit,
        extensionData,
        setFieldState
    ]);
    const submit = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async ({ data: fieldValue })=>{
        const retryFunction = createRetryFunction(fieldValue);
        setFieldState({
            fieldId: extensionData.fieldId,
            retryFunction: retryFunction
        });
        await retryFunction();
        return undefined;
    }, [
        createRetryFunction,
        extensionData.fieldId,
        setFieldState
    ]);
    const bridge = (0, $5uXOq.useMemo)(()=>({
            submit: submit
        }), [
        submit
    ]);
    if ((0, $3mOWa.isNativeUiExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT)) || (0, $3mOWa.isCustomUIExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditExtension), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-inline-edit",
        fallback: loadingComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditRenderer), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })));
};

});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("6ikhl", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $d56dd4f138add558$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $d56dd4f138add558$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $d56dd4f138add558$export$cdb4b503c6154b35);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5rCpD = parcelRequire("5rCpD");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $d56dd4f138add558$var$store = (0, $iXqE5.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $5rCpD.default
});
const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store);
const $d56dd4f138add558$export$14c9655e9d9e873c = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: null
});

});
parcelRegister("5rCpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $02373df28193ad93$export$2e2bcd8739ae039);

var $hPhpd = parcelRequire("hPhpd");
const $02373df28193ad93$var$actions = {
    setFieldState: $hPhpd.setFieldState,
    resetState: $hPhpd.resetState,
    dispatchRetryFunction: $hPhpd.dispatchRetryFunction,
    dispatchFormSubmits: $hPhpd.dispatchFormSubmits
};
var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;

});
parcelRegister("hPhpd", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $9eca433be421af07$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $9eca433be421af07$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $9eca433be421af07$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $9eca433be421af07$export$42fd5e650971333b);


var $9J85a = parcelRequire("9J85a");
const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                const formRef = currentState[fieldId]?.formRef;
                (0, $9J85a.dispatchFormSubmitAndBlurElements)(formRef);
            }
        });
    };

});
parcelRegister("9J85a", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $b1c36799aab2b39a$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $b1c36799aab2b39a$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $b1c36799aab2b39a$export$ee23412a8bea9333);

const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
    $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("bLCKr", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $e1da1ba1fdde315e$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonLayout", () => $e1da1ba1fdde315e$export$af3ba02ef74c9bdf);
/* main.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $e1da1ba1fdde315e$export$69f3c7f0b2b87aa2 = [];
const $e1da1ba1fdde315e$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $e1da1ba1fdde315e$export$69f3c7f0b2b87aa2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1da1ba1fdde315e$var$ForgeSkeleton, {
            "data-testId": `forgeskeleton-${index}`,
            key: index,
            width: width
        })));
const $e1da1ba1fdde315e$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
    if (!layout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "forge-ui-async.common.ui.skeleton.box",
        xcss: $e1da1ba1fdde315e$var$layoutStyles
    }, children);
};
const $e1da1ba1fdde315e$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1da1ba1fdde315e$var$ForgeSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1y04s53": (0, $lD23V.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
            __cmplp.className
        ])
    });
});
const $e1da1ba1fdde315e$var$layoutStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});

});

parcelRegister("69dub", function(module, exports) {

$parcel$export(module.exports, "StopSubmitPropagation", () => $1d6031a605ad4b71$export$238f56c0891e9254);

var $5uXOq = parcelRequire("5uXOq");
const $1d6031a605ad4b71$export$e6dfd72ab29f8598 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
        onSubmit: props.onSubmit
    }, props.children);
const $1d6031a605ad4b71$export$238f56c0891e9254 = ({ children: children })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1d6031a605ad4b71$export$e6dfd72ab29f8598, {
        onSubmit: handleSubmit
    }, children);
};

});

parcelRegister("3OHUI", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditRenderer", () => $e47c1fd0d3acd296$export$eef5130ba28e0f4e);
$parcel$export(module.exports, "LazyCustomFieldInlineEditExtension", () => $e47c1fd0d3acd296$export$299b8ce8659dec8c);

var $1rTGO = parcelRequire("1rTGO");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");

var $kxZPA = parcelRequire("kxZPA");

const $e47c1fd0d3acd296$var$getModule = ()=>(0, $8kVg1.measureInitialPageLoadAsyncResourcesTiming)((0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("ikTXu")));

const $e47c1fd0d3acd296$var$getForgeExtensionModule = ()=>(0, $8kVg1.measureInitialPageLoadAsyncResourcesTiming)((0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("ghT7u")));
const $e47c1fd0d3acd296$export$eef5130ba28e0f4e = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$e47c1fd0d3acd296$var$getModule().then((module)=>module.CustomFieldInlineEdit), {
    ssr: false
}));
const $e47c1fd0d3acd296$export$299b8ce8659dec8c = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$e47c1fd0d3acd296$var$getForgeExtensionModule().then((module)=>module.CustomFieldInlineEdit), {
    ssr: false
}));

});
parcelRegister("ikTXu", function(module, exports) {

let $d5958077960e8d0d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d5958077960e8d0d$var$load("kWrFZ"),
    $d5958077960e8d0d$var$load("2AjeU")
]).then(()=>parcelRequire('lDRdH'));

});

parcelRegister("ghT7u", function(module, exports) {

let $bdb8fd80ce8f8896$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bdb8fd80ce8f8896$var$load("eNmuD"),
    $bdb8fd80ce8f8896$var$load("cM9em"),
    $bdb8fd80ce8f8896$var$load("fr9NE"),
    $bdb8fd80ce8f8896$var$load("hPzOn"),
    $bdb8fd80ce8f8896$var$load("h2MrD"),
    $bdb8fd80ce8f8896$var$load("bYT2S"),
    $bdb8fd80ce8f8896$var$load("kWrFZ"),
    $bdb8fd80ce8f8896$var$load("2QVAD")
]).then(()=>parcelRequire('456zR'));

});



parcelRegister("3oVvh", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditIssueView", () => $46e0705763f3c3d0$export$9929b4973c13a82f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $lfTZh = parcelRequire("lfTZh");

var $bLCKr = parcelRequire("bLCKr");

var $69dub = parcelRequire("69dub");

var $7IjIj = parcelRequire("7IjIj");

var $3OHUI = parcelRequire("3OHUI");
const $46e0705763f3c3d0$var$skeletonConfig = [
    {
        width: 100
    }
];
const $46e0705763f3c3d0$export$9929b4973c13a82f = ({ onSave: onSave, onCancel: onCancel, onConfirm: onConfirm, onRender: onRender, ...restProps })=>{
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const loadingComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLCKr.Skeleton), {
            skeletonConfig: $46e0705763f3c3d0$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $5uXOq.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldType: extensionData.fieldType,
            fieldId: extensionData.fieldId,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            isInline: true
        };
    }, [
        extension.type,
        extensionData
    ]);
    const extraProps = (0, $5uXOq.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    const submit = (0, $5uXOq.useCallback)(({ data: fieldValue })=>(0, $7IjIj.onCustomFieldSubmit)(fieldValue, onSave, onConfirm, showFlag), // todo SMT-491 onConfirm, onSave (fieldId) was changing every time component tree was changed by Bento issue view.
    // root cause - Bento's connect-field is creating onConfirm function and fieldId every time. More in mentioned ticket
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        showFlag
    ]);
    const close = onCancel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bridge = (0, $5uXOq.useMemo)(()=>({
            submit: submit,
            close: close
        }), [
        submit,
        close
    ]);
    if ((0, $3mOWa.isNativeUiExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT)) || (0, $3mOWa.isCustomUIExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditExtension), {
        ...restProps,
        ...extraProps,
        onCancel: onCancel,
        onLoad: onRender,
        onRender: onRender,
        bridge: bridge
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditRenderer), {
        ...restProps,
        ...extraProps,
        onRender: onRender,
        onCancel: onCancel,
        bridge: bridge
    })));
};

});
parcelRegister("7IjIj", function(module, exports) {

$parcel$export(module.exports, "onCustomFieldSubmit", () => $7482280c9b50d561$export$fc8c2ed652969e74);

var $jJZqs = parcelRequire("jJZqs");

var $dGSK4 = parcelRequire("dGSK4");
const $7482280c9b50d561$export$fc8c2ed652969e74 = (fieldValue, onSave, onConfirm, showFlag)=>onSave(fieldValue).then((response)=>{
        if (response == null) return;
        // The error is handled in the catch block
        if ('error' in response) {
            if (response.error) throw response.error;
        } else onConfirm(response.data);
    }).catch((error)=>{
        showFlag((0, $dGSK4.default)(error));
        // Custom UI depends on this error to get know whether the form was successfully submitted or not
        if ((0, $jJZqs.isValidationError)(error)) throw error;
        throw Error(`Unable to save custom field, error: ${error.message}`);
    });

});
parcelRegister("dGSK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60f776846cd27f9$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $eRDnE = parcelRequire("eRDnE");

var $ctOgQ = parcelRequire("ctOgQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b60f776846cd27f9$export$2e2bcd8739ae039 = (error)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $jJZqs.isValidationError)(error) ? (0, $ctOgQ.default)(error.errors) : (0, $eRDnE.default)();

});
parcelRegister("eRDnE", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e1a5ac6c28ff9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $41e1a5ac6c28ff9a$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.generic-error.title",
        "defaultMessage": "We were unable to edit this custom field. Please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$41e1a5ac6c28ff9a$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $41e1a5ac6c28ff9a$var$messages.title,
        isAutoDismiss: false
    });

});

parcelRegister("ctOgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $59eef974107568f4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $59eef974107568f4$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.validation-error.title",
        "defaultMessage": "Validation error"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$59eef974107568f4$export$2e2bcd8739ae039 = (errors)=>({
        type: 'error',
        title: $59eef974107568f4$var$messages.title,
        description: errors.map(({ error: error })=>error).join(', '),
        isAutoDismiss: false
    });

});





parcelRegister("frltc", function(module, exports) {

$parcel$export(module.exports, "ErrorPanel", () => $a7cc7ee0610715db$export$9f3dc18e1adf5d8f);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $eZJjh = parcelRequire("eZJjh");

var $koVbs = parcelRequire("koVbs");

var $lUtFZ = parcelRequire("lUtFZ");
const $a7cc7ee0610715db$var$Loader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$LoaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        testId: "forge-ui-renderers.common.ui.error-panel.forge-app-loading-spinner",
        size: "large"
    }));
const $a7cc7ee0610715db$export$9f3dc18e1adf5d8f = ({ error: error, onRetry: onRetry })=>{
    const { message: message, errorMessage: errorMessage, errorDetails: errorDetails } = error;
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const intl = (0, $koVbs.default)();
    const onClickStopPropagation = (0, $5uXOq.useCallback)((e)=>e.stopPropagation(), []);
    const reinitializeApp = (0, $5uXOq.useCallback)(async (e)=>{
        setIsLoading(true);
        try {
            e.stopPropagation();
            if (onRetry) await onRetry();
        } catch  {} finally{
            setIsLoading(false);
        }
    }, [
        onRetry
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$Loader, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ContentWrapper, {
        onClick: onClickStopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        title: message,
        actions: onRetry ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                onClick: reinitializeApp,
                key: "refresh"
            }, intl.formatMessage((0, $lUtFZ.default).refreshApp))
        ] : []
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ErrorMessageWrapper, null, errorMessage), errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ErrorDetailsWrapper, null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _k7zyidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$LoaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$ErrorDetailsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$containerStyles = (0, $8CUq3.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $a97355a0cc6aeb06$var$bleedStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
const $a97355a0cc6aeb06$var$contentStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: 'font.body'
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a97355a0cc6aeb06$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        // props for new icon
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a97355a0cc6aeb06$var$contentStyles
    }, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: "list"
    }, actionsArray.map((action, id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            role: "listitem",
            key: id
        }, action))))));
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $5uXOq = parcelRequire("5uXOq");

var $btivG = parcelRequire("btivG");

var $7nnPp = parcelRequire("7nnPp");

var $2hXfb = parcelRequire("2hXfb");

var $eJS47 = parcelRequire("eJS47");

var $gtreQ = parcelRequire("gtreQ");

const $d1d7dced94bb00f5$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($btivG))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eJS47))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$export$faa35441caff5bb6[appearance] || $d1d7dced94bb00f5$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("ctz0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e844da07d79ea04$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
const $2e844da07d79ea04$var$styles = {
    common: "_11c81oud _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $2e844da07d79ea04$var$SectionMessageAction = /*#__PURE__*/ (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    if (!linkComponent && (0, $VSDnB.fg)('platform_section_message_action_migration')) {
        if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.anchor)
        }, children);
        if (onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.pressable)
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span",
            testId: testId
        }, children);
    }
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
});
var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;

});

parcelRegister("lUtFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0d2ab7d73abc3f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0c0d2ab7d73abc3f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    refreshApp: {
        "id": "forge-ui-renderers.common.error-panel.refresh-app",
        "defaultMessage": "Refresh app"
    }
});

});


parcelRegister("6cMZg", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $856789955d192c4b$export$98c150630afe5417);
$parcel$export(module.exports, "transformValueToExtensionData", () => $856789955d192c4b$export$b82f09291a00d8c1);
$parcel$export(module.exports, "getExtension", () => $856789955d192c4b$export$78d71f9ed5534abe);

var $2QTbq = parcelRequire("2QTbq");

var $gifeQ = parcelRequire("gifeQ");

var $2pEv1 = parcelRequire("2pEv1");
const $856789955d192c4b$export$98c150630afe5417 = (value, extension)=>{
    const { properties: { type: type, collection: collection } } = extension;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2322 - Type 'Option[]' is not assignable to type 'ForgeCustomFieldValue'. | TS2345 - Argument of type 'string[] | User[] | Group[]' is not assignable to parameter of type 'LabelsValue'.
            return (0, $2QTbq.mapDataToLabelOptions)(value);
            return value;
        case 'object':
            return JSON.stringify(value);
        case 'user':
            if (value != null) // @ts-expect-error - TS2345 - Argument of type 'string | number | string[] | User | Group | { [key: string]: unknown; } | User[] | Group[]' is not assignable to parameter of type 'JiraUser | JiraUser[]'.
            return $856789955d192c4b$export$26760e7b66ccf1e1(value);
            return value;
        default:
            return value;
    }
};
const $856789955d192c4b$export$b82f09291a00d8c1 = (value, extension)=>{
    const type = extension?.properties?.type;
    const collection = extension?.properties?.collection;
    switch(type){
        case 'string':
            if (collection === 'list') // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'Option[]'.
            return (0, $2QTbq.mapLabelOptionsToData)(value);
            return value;
        case 'object':
            return (0, $2pEv1.transformJSONStringToObject)(value);
        case 'user':
            if (value === null) return value;
            // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'UserOption | UserOption[]'.
            return $856789955d192c4b$export$e4490ea0dfe4173f(value);
        default:
            return value;
    }
};
const $856789955d192c4b$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
const $856789955d192c4b$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $856789955d192c4b$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $856789955d192c4b$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($856789955d192c4b$export$3e406786572c35b0);
    return $856789955d192c4b$export$3e406786572c35b0(defaultValue);
};

});
parcelRegister("2QTbq", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $392cb309afc1042a$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mapLabelOptionsToData", () => $392cb309afc1042a$export$1bf703d99c7bcef6);
$parcel$export(module.exports, "mapLabelsResponseToLabelOptions", () => $392cb309afc1042a$export$37f55c1f665c1221);
const $392cb309afc1042a$export$cd8e373d5b1325b1 = (data)=>{
    if (!data) return [];
    return data.map((value)=>({
            value: value,
            label: value
        }));
};
const $392cb309afc1042a$export$1bf703d99c7bcef6 = (options)=>options.map(({ value: value })=>value);
const $392cb309afc1042a$export$37f55c1f665c1221 = (response)=>{
    const { suggestions: suggestions } = response;
    if (!suggestions) return [];
    return suggestions.map(({ label: label })=>({
            label: label,
            value: label
        }));
};

});

parcelRegister("2pEv1", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $ff7dce57394b1eb3$export$2de59005e10fd82);

var $agVdz = parcelRequire("agVdz");
const $ff7dce57394b1eb3$export$2de59005e10fd82 = (value)=>{
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(value) && JSON.parse(value)) return JSON.parse(value);
    } catch (e) {
        return value;
    }
    return value;
};

});


parcelRegister("gb8Pv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c94c49b5b89ee482$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c94c49b5b89ee482$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalModeErrorTitle: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-title",
        "defaultMessage": "We couldn't show this extension"
    },
    modalModeErrorDescription: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-description",
        "defaultMessage": "Contact the app vendor to update the app."
    }
});

});


parcelRegister("j5sSv", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $41b83e50a34e2ca1$export$b5c4b0e7cd7f148b);
/* FieldContainer.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $41b83e50a34e2ca1$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1r250ak": (0, $lD23V.default)(typeof (__cmplp.width ?? 350) === 'number' ? `${__cmplp.width ?? 350}px` : __cmplp.width ?? 350),
            "--_1glwpqj": (0, $lD23V.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $lD23V.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbuo76 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7fjFA", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldMessage", () => $111a3dd21aa999b8$export$1df6b326181f4cdf);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $qfj8c = parcelRequire("qfj8c");

var $eZJjh = parcelRequire("eZJjh");


var $6ikhl = parcelRequire("6ikhl");

var $koVbs = parcelRequire("koVbs");

var $jcuk9 = parcelRequire("jcuk9");

var $3EMIO = parcelRequire("3EMIO");
const $111a3dd21aa999b8$export$1df6b326181f4cdf = (props)=>{
    const failedErrorMessageAppeared = (0, $5uXOq.useRef)(false);
    const { error: error, fieldId: fieldId, renderFieldMessage: renderFieldMessage } = props;
    const [fieldState] = (0, $6ikhl.useInlineField)(fieldId);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderErrorMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($111a3dd21aa999b8$var$MessagePartsSeparationWrapper, null, formatMessage((0, $3EMIO.default).forgeFieldErrorTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jcuk9.ForgeFieldDispatchButton), {
            fieldId: fieldId
        }));
    const renderSuccessMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ValidMessage), null, formatMessage((0, $3EMIO.default).forgeFieldSuccessTextLabel));
    const renderHelperMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($111a3dd21aa999b8$var$MessagePartsSeparationWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        })), formatMessage((0, $3EMIO.default).forgeFieldPendingTextLabel));
    const renderDefaultErrorMessage = ()=>{
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderFieldMessage(error));
        return null;
    };
    if (error !== undefined) return renderDefaultErrorMessage();
    if (failedErrorMessageAppeared.current) {
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) switch(fieldState?.status){
            case 0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd:
                return renderErrorMessage();
            case 0, $3e5c7761c2e3cf02$export$9956c6a700e724c4:
                return renderSuccessMessage();
            case 0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c:
            case 0, $3e5c7761c2e3cf02$export$2ace7d3737836262:
                return renderHelperMessage();
            default:
                return renderDefaultErrorMessage();
        }
        return null;
    }
    if (fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) {
        failedErrorMessageAppeared.current = true;
        return renderErrorMessage();
    }
    return renderDefaultErrorMessage();
};
// For now, it only gives some space between the spinner and the message
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $111a3dd21aa999b8$var$MessagePartsSeparationWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f31b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jcuk9", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldDispatchButton", () => $354a8a5375650812$export$59e3aafda495153);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");


var $6ikhl = parcelRequire("6ikhl");
const $354a8a5375650812$export$59e3aafda495153 = (props)=>{
    const { fieldId: fieldId } = props;
    const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, $6ikhl.useInlineField)(fieldId);
    const onClickHandler = async ()=>{
        if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
    };
    const renderRetryButton = ()=>{
        if (fieldState !== undefined && fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            spacing: "none",
            appearance: "link",
            onClick: onClickHandler
        }, "Try again?");
        return null;
    };
    return renderRetryButton();
};

});

parcelRegister("3EMIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $477739caf5b64c43$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $477739caf5b64c43$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    forgeFieldErrorTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-error-text-label",
        "defaultMessage": "We couldn't save the value of this custom field."
    },
    forgeFieldSuccessTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-success-text-label",
        "defaultMessage": "Custom field value saved."
    },
    forgeFieldPendingTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-pending-text-label",
        "defaultMessage": "Saving custom field value."
    }
});

});


// itsm practices - copied from src/packages/issue-create/issue-create-common-types/src/common/types/index.tsx
const $5363dcf42759d41f$var$SERVICE_REQUEST = 'SERVICE_REQUEST';
const $5363dcf42759d41f$var$INCIDENT_MANAGEMENT = 'INCIDENT_MANAGEMENT';
const $5363dcf42759d41f$var$PROBLEM_MANAGEMENT = 'PROBLEM_MANAGEMENT';
const $5363dcf42759d41f$var$CHANGE_MANAGEMENT = 'CHANGE_MANAGEMENT';
const $5363dcf42759d41f$var$POST_INCIDENT_REVIEW = 'POST_INCIDENT_REVIEW';
// cs practice
const $5363dcf42759d41f$var$DEVELOPER_ESCALATION = 'DEVELOPER_ESCALATION';
const $5363dcf42759d41f$var$UNASSIGNED_REQUEST_TYPE = 'UNASSIGNED_REQUEST_TYPE';
const $5363dcf42759d41f$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $5363dcf42759d41f$var$ISSUE_TYPE = 'ISSUE_TYPE';


parcelRegister("7Emtg", function(module, exports) {

$parcel$export(module.exports, "reportForgeFailure", () => $6c61c34a1b63244f$export$e95b9e5003024a9c);

var $4JpPl = parcelRequire("4JpPl");

var $gifeQ = parcelRequire("gifeQ");
const $6c61c34a1b63244f$export$e95b9e5003024a9c = (fieldType, modules, filteredOutModules)=>{
    const isExtensionFilteredOut = filteredOutModules.some((field)=>(0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
    const isEmptyForgeData = modules.length === 0 && filteredOutModules.length === 0;
    /*
        Not log error:
         * if the extensions is filtered out by display conditions or access narrowing
         * if the forge data is empty (when fetching error there is an excluded error, empty response is returned)
    */ if (isEmptyForgeData || isExtensionFilteredOut) return;
    (0, $4JpPl.fireOperationalFailedEvent)('issue-create', {
        error: Error('Forge extension passed to ForgeCustomField component is null or undefined'),
        renderContext: 'issue-create'
    });
};

});

parcelRegister("1MgIu", function(module, exports) {

$parcel$export(module.exports, "extractEnvFromFieldDescription", () => $91f4ce51875a932d$export$dfa36573f3bd00af);
const $91f4ce51875a932d$var$DEV_PREFIX = '(DEVELOPMENT) ';
const $91f4ce51875a932d$var$STG_PREFIX = '(STAGING) ';
const $91f4ce51875a932d$export$dfa36573f3bd00af = (descriptionWithEnv = '')=>{
    if (descriptionWithEnv?.startsWith($91f4ce51875a932d$var$DEV_PREFIX)) return {
        environment: 'DEVELOPMENT',
        description: descriptionWithEnv.replace($91f4ce51875a932d$var$DEV_PREFIX, '')
    };
    if (descriptionWithEnv?.startsWith($91f4ce51875a932d$var$STG_PREFIX)) return {
        environment: 'STAGING',
        description: descriptionWithEnv.replace($91f4ce51875a932d$var$STG_PREFIX, '')
    };
    return {
        environment: 'PRODUCTION',
        description: descriptionWithEnv ?? ''
    };
};

});

parcelRegister("bCATC", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryBypassProvider", () => $8f20301774b6a173$export$a5feb4d632b53009);
$parcel$export(module.exports, "ErrorBoundaryBypassInput", () => $8f20301774b6a173$export$36798a6d5688c318);
$parcel$export(module.exports, "ErrorBoundaryBypassOutput", () => $8f20301774b6a173$export$775be62266860b86);

var $5uXOq = parcelRequire("5uXOq");
const $8f20301774b6a173$var$ErrorBoundaryBypassApiContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8f20301774b6a173$var$ErrorBoundaryBypassErrorContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8f20301774b6a173$export$a5feb4d632b53009 = ({ children: children })=>{
    const [bypassedError, setBypassedError] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            swallowError: (error)=>{
                setBypassedError(error);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f20301774b6a173$var$ErrorBoundaryBypassErrorContext.Provider, {
        value: bypassedError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f20301774b6a173$var$ErrorBoundaryBypassApiContext.Provider, {
        value: api
    }, children));
};
class $8f20301774b6a173$export$36798a6d5688c318 extends (0, $5uXOq.Component) {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        if (this.context !== null) this.context.swallowError(error);
    }
    static{
        this.contextType = $8f20301774b6a173$var$ErrorBoundaryBypassApiContext;
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
const $8f20301774b6a173$export$775be62266860b86 = ()=>{
    const bypassedError = (0, $5uXOq.useContext)($8f20301774b6a173$var$ErrorBoundaryBypassErrorContext);
    if (bypassedError !== null) throw bypassedError;
    return null;
};

});

parcelRegister("bv5he", function(module, exports) {

$parcel$export(module.exports, "FieldBusyIndicator", () => $88ca25f0a40fdec1$export$cf3e115209fc94cb);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $4eKbI = parcelRequire("4eKbI");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $3WXbV = parcelRequire("3WXbV");
const $88ca25f0a40fdec1$export$cf3e115209fc94cb = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const loadingMessage = formatMessage((0, $3WXbV.default).fieldLevelIndicatorTooltipContent);
    const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
    const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        tag: "span",
        content: loadingMessage,
        testId: tooltipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88ca25f0a40fdec1$export$4e31364808fb7483, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4eKbI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        testId: indicatorId,
        size: "small"
    }))));
});
$88ca25f0a40fdec1$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator';
const $88ca25f0a40fdec1$export$4e31364808fb7483 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4eKbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd3e682addb0cb4a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");
function $fd3e682addb0cb4a$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const ignoredInteractionContext = (0, $5uXOq.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6wxJn.default).Provider, {
        value: ignoredInteractionContext
    }, kids);
}

});

parcelRegister("3WXbV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0ef3198f799e6a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c0ef3198f799e6a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fieldLevelIndicatorTooltipContent: {
        id: 'issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content',
        defaultMessage: 'Loading UI modifications...',
        description: 'A tooltip message showed on UI modifications loading icon on each loading field'
    }
});

});


parcelRegister("mTNgq", function(module, exports) {

$parcel$export(module.exports, "IssueAdjustmentsErrorHandler", () => $f3c77fc718edb938$export$68b86a282e98ff70);

var $5uXOq = parcelRequire("5uXOq");

var $1YewZ = parcelRequire("1YewZ");
const $f3c77fc718edb938$export$68b86a282e98ff70 = ()=>{
    const { setError: setError, resetError: resetError } = (0, $1YewZ.useIssueAdjustmentsActions)();
    (0, $5uXOq.useEffect)(()=>{
        setError({
            errorCode: 'ERROR_BOUNDARY_HANDLER_ERROR_CODE'
        });
        return ()=>resetError();
    }, [
        setError,
        resetError
    ]);
    return null;
};

});
parcelRegister("1YewZ", function(module, exports) {

$parcel$export(module.exports, "store", () => $cf6a6312e4141eb7$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $cf6a6312e4141eb7$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $cf6a6312e4141eb7$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $cf6a6312e4141eb7$export$677b3e34bd14c681);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $3whHg = parcelRequire("3whHg");

var $hyCnL = parcelRequire("hyCnL");

var $boEP0 = parcelRequire("boEP0");

var $2NMWZ = parcelRequire("2NMWZ");

var $d30F5 = parcelRequire("d30F5");

var $8e24q = parcelRequire("8e24q");

var $cTj8m = parcelRequire("cTj8m");

var $i4uue = parcelRequire("i4uue");

var $3iUv8 = parcelRequire("3iUv8");

var $b8ZsE = parcelRequire("b8ZsE");

var $jDMtG = parcelRequire("jDMtG");

var $l0b2q = parcelRequire("l0b2q");

var $4MJXd = parcelRequire("4MJXd");

var $gHQFd = parcelRequire("gHQFd");

var $7JtDe = parcelRequire("7JtDe");
const $cf6a6312e4141eb7$var$name = 'issue-adjustments';
const $cf6a6312e4141eb7$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $cf6a6312e4141eb7$var$triggerFieldInitializationKey, viewType: $cf6a6312e4141eb7$var$scopedViewType, numberOfSupportedFields: $cf6a6312e4141eb7$var$numberOfSupportedFields, ...$cf6a6312e4141eb7$var$stateForResetAllFields } = $cf6a6312e4141eb7$export$d4c72bab9d6cc13a;
const $cf6a6312e4141eb7$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $b8ZsE.processChange,
    setFieldValue: $l0b2q.setFieldValue,
    initializeField: $8e24q.initializeField,
    initializeFields: $8e24q.initializeFields,
    startFieldsInitialisationTimeout: $d30F5.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $d30F5.successFieldsInitalisation,
    registerFields: $jDMtG.registerFields,
    unregisterFields: $jDMtG.unregisterFields,
    updateFields: $gHQFd.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($cf6a6312e4141eb7$var$stateForResetAllFields);
        },
    setError: $2NMWZ.setError,
    resetError: $2NMWZ.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3whHg.setAppErrors,
    resetAppErrors: $3whHg.resetAppErrors,
    addAppsErrors: $3whHg.addAppsErrors,
    initializeNoScreenTab: $cTj8m.initializeNoScreenTab,
    initializeScreenTabs: $i4uue.initializeScreenTabs,
    updateScreenTabs: $7JtDe.updateScreenTabs,
    updateActiveScreenTab: $4MJXd.updateActiveScreenTab,
    detectAppliedChangesConflicts: $hyCnL.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $boEP0.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $boEP0.collectFieldsAppliedChangesHistory,
    setNotification: $3iUv8.setNotification,
    resetNotification: $3iUv8.resetNotification
};
const $cf6a6312e4141eb7$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: $cf6a6312e4141eb7$var$name,
    initialState: $cf6a6312e4141eb7$export$d4c72bab9d6cc13a,
    actions: $cf6a6312e4141eb7$export$e324594224ef24da
});
const $cf6a6312e4141eb7$export$37792a602e748c08 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe = {};
const $cf6a6312e4141eb7$export$df4b0714e8177e0e = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe
});
const $cf6a6312e4141eb7$export$cb9a014ec14556d8 = (0, $3sQ5x.createActionsHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$export$677b3e34bd14c681 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("3whHg", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $87bccf3deeafaa75$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $87bccf3deeafaa75$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $87bccf3deeafaa75$export$24c821207687a907);
const $87bccf3deeafaa75$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $87bccf3deeafaa75$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $87bccf3deeafaa75$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("hyCnL", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $4c0b86f075c0ff6b$export$90d94f20d157e756);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $3whHg = parcelRequire("3whHg");

var $3iUv8 = parcelRequire("3iUv8");

var $lLAXK = parcelRequire("lLAXK");
const $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $4c0b86f075c0ff6b$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $19ec31e354320eb2$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $lLAXK.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $3whHg.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $3iUv8.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("2jyqu", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $9253211b05747618$export$a1fb57756f0de62b);

var $gB4mS = parcelRequire("gB4mS");


const $9253211b05747618$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $gB4mS.default)((0, $aded369bac156944$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $6e65040b988c460f$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

const $aded369bac156944$export$8280e5c6104c5b40 = 'ui-modifications';


const $19ec31e354320eb2$export$415cc1afa6445f90 = 'onInitChangeId';
const $19ec31e354320eb2$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("3iUv8", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $547ed651019edc98$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $547ed651019edc98$export$caafa3945f199bc7);
const $547ed651019edc98$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $547ed651019edc98$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("lLAXK", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $5d47c6c300e4a9ca$export$a06103ec99e4e394);

var $fr1K2 = parcelRequire("fr1K2");


var $bCvSM = parcelRequire("bCvSM");

const $5d47c6c300e4a9ca$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $5d47c6c300e4a9ca$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $78805f0b93715186$export$f674b7a3bbd94b5)) return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $bCvSM.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $5d47c6c300e4a9ca$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $5d47c6c300e4a9ca$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $ca611ff348f89182$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $ca611ff348f89182$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $ca611ff348f89182$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $ca611ff348f89182$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $ca611ff348f89182$export$e4ac32edd5da2ee7 = 'FIELD';
const $ca611ff348f89182$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("bCvSM", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $b1dea33557091402$export$e1cc7da28a1c4bb7);
const $b1dea33557091402$var$SET_NAME_METHOD = 'setName';
const $b1dea33557091402$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $b1dea33557091402$var$SET_VISIBLE_METHOD = 'setVisible';
const $b1dea33557091402$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $b1dea33557091402$var$SET_VALUE_METHOD = 'setValue';
const $b1dea33557091402$var$SET_REQUIRED_METHOD = 'setRequired';
const $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $b1dea33557091402$export$8325709d137b2606 = {
    fieldName: $b1dea33557091402$var$SET_NAME_METHOD,
    description: $b1dea33557091402$var$SET_DESCRIPTION_METHOD,
    isVisible: $b1dea33557091402$var$SET_VISIBLE_METHOD,
    isReadOnly: $b1dea33557091402$var$SET_READ_ONLY_METHOD,
    value: $b1dea33557091402$var$SET_VALUE_METHOD,
    isRequired: $b1dea33557091402$var$SET_REQUIRED_METHOD,
    optionsVisibility: $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $b1dea33557091402$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $b1dea33557091402$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $78805f0b93715186$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $78805f0b93715186$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("boEP0", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$7d0f534e5b16dcc9);


var $3vp6H = parcelRequire("3vp6H");
const $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $f5288ff27f25fb7e$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $78805f0b93715186$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $f5288ff27f25fb7e$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $3vp6H.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("3vp6H", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $23bcfa1804fc8fad$export$8a23b3e9a1749620);

const $23bcfa1804fc8fad$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $78805f0b93715186$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $23bcfa1804fc8fad$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $23bcfa1804fc8fad$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("2NMWZ", function(module, exports) {

$parcel$export(module.exports, "setError", () => $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $13e2b126ca97f7fe$export$7e5930c6217b1d4e);
const $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $13e2b126ca97f7fe$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("d30F5", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $e08f4de833312075$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $e08f4de833312075$export$cf768a695e83eefa);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");

var $1FDIy = parcelRequire("1FDIy");

var $2NMWZ = parcelRequire("2NMWZ");
const $e08f4de833312075$var$getTimeout = ()=>50000;
const $e08f4de833312075$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $e08f4de833312075$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $e08f4de833312075$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($e08f4de833312075$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $e08f4de833312075$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $e08f4de833312075$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status) || (0, $1FDIy.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $2NMWZ.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $e08f4de833312075$var$getTimeout(),
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $e08f4de833312075$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("1FDIy", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $9ea7c26aba3c4975$export$4cadeedb8c3f31f7);

var $gKZoD = parcelRequire("gKZoD");

var $6dDSs = parcelRequire("6dDSs");

var $gL80q = parcelRequire("gL80q");
const $9ea7c26aba3c4975$export$4cadeedb8c3f31f7 = (0, $6dDSs.createSelector)((_, props)=>props.viewType, (state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (viewType, formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    (0, $gKZoD.di)((0, $gL80q.isScreenTabsSupportEnabled));
    if (formData !== null && !(0, $gL80q.isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: []
    };
    if (formData !== null && screenTabsData !== null && (0, $gL80q.isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});
parcelRegister("gL80q", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $968cd36658e5c86e$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $968cd36658e5c86e$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $968cd36658e5c86e$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $968cd36658e5c86e$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $968cd36658e5c86e$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $968cd36658e5c86e$export$ef45e4471aa21b27);
$parcel$export(module.exports, "isScreenTabsSupportEnabled", () => $968cd36658e5c86e$export$71e5898a2b967ce3);

var $cmmj3 = parcelRequire("cmmj3");

var $3OTqu = parcelRequire("3OTqu");
const $968cd36658e5c86e$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $968cd36658e5c86e$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $3OTqu.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $968cd36658e5c86e$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$968cd36658e5c86e$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $968cd36658e5c86e$export$e4330d77fd93d1de = (viewType)=>$968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $968cd36658e5c86e$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $968cd36658e5c86e$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $968cd36658e5c86e$export$20eabd2b3ada6bf3(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $968cd36658e5c86e$export$b768d6a95f7a930(context) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $968cd36658e5c86e$export$b0297573c90085aa(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $968cd36658e5c86e$export$c0728caa743a409e(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $968cd36658e5c86e$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $968cd36658e5c86e$export$c0728caa743a409e(viewType).has(triggerPoint);
const $968cd36658e5c86e$export$71e5898a2b967ce3 = (viewType)=>$968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).isScreenTabsSupportEnabled();

});
parcelRegister("cmmj3", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $1359a69054531aa4$export$a27c21aa3ed8f0f1);
parcelRequire("1nF7O");
var $bajNy = parcelRequire("bajNy");

var $z11xo = parcelRequire("z11xo");
const $1359a69054531aa4$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $1359a69054531aa4$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $z11xo.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $bajNy.default)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $1359a69054531aa4$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("1nF7O", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("bajNy")).default);
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => (parcelRequire("bajNy")).initialiseErrorAnalyticsClient);
$parcel$export(module.exports, "ReportErrors", () => (parcelRequire("kRBfD")).default);

var $9ZBi7 = parcelRequire("9ZBi7");

var $bajNy = parcelRequire("bajNy");

var $kRBfD = parcelRequire("kRBfD");

});
parcelRegister("9ZBi7", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $e146a6146624d7ff$export$f5282963edea4a68);

var $e4JR5 = parcelRequire("e4JR5");
const $e146a6146624d7ff$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $e4JR5.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $e146a6146624d7ff$export$f5282963edea4a68 = (location, error, details = {})=>(0, $e4JR5.default).captureException(location, error, details);

});
parcelRegister("e4JR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a438973d9769f0e5$export$2e2bcd8739ae039);
// This is the only file that should directly import Raven.

var $7zHWg = parcelRequire("7zHWg");
var $3kk8J = parcelRequire("3kk8J");
var $kFfmc = parcelRequire("kFfmc");

var $ehYmi = parcelRequire("ehYmi");
var $lt9kQ = parcelRequire("lt9kQ");
var $kBLvL = parcelRequire("kBLvL");
var $50FPh = parcelRequire("50FPh");

var $kGsr8 = parcelRequire("kGsr8");
const $a438973d9769f0e5$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $a438973d9769f0e5$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $a438973d9769f0e5$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $a438973d9769f0e5$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $a438973d9769f0e5$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $3kk8J.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $a438973d9769f0e5$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$a438973d9769f0e5$var$getFilteredIntegrations(integrations),
                new $lt9kQ.Dedupe(),
                new $kBLvL.ExtraErrorData(),
                new $50FPh.Transaction(),
                new $ehYmi.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $kFfmc.init({
        ...defaultConfig,
        ...config
    });
    try {
        $7zHWg.setExtras(getExtraContext());
    } catch (e) {
        $7zHWg.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $a438973d9769f0e5$var$tags = [
    'packageName',
    'teamName'
];
const $a438973d9769f0e5$var$captureException = (location, error, details)=>{
    $7zHWg.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($a438973d9769f0e5$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $7zHWg.captureException(error);
};
var $a438973d9769f0e5$export$2e2bcd8739ae039 = {
    installGlobalHandler: $a438973d9769f0e5$var$installGlobalHandler,
    captureException: $a438973d9769f0e5$var$captureException
};

});
parcelRegister("7zHWg", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $583de2969a487e4e$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $583de2969a487e4e$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $583de2969a487e4e$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $583de2969a487e4e$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $583de2969a487e4e$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $583de2969a487e4e$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $583de2969a487e4e$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $583de2969a487e4e$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $583de2969a487e4e$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $583de2969a487e4e$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $583de2969a487e4e$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $583de2969a487e4e$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $583de2969a487e4e$export$e262da7ae6480481);

var $3VFsf = parcelRequire("3VFsf");

var $3kk8J = parcelRequire("3kk8J");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $583de2969a487e4e$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $3kk8J.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $3VFsf.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $583de2969a487e4e$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $583de2969a487e4e$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $583de2969a487e4e$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $583de2969a487e4e$var$callOnHub('captureMessage', message, level, (0, $3VFsf.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $583de2969a487e4e$export$1462b974fdcf6ba2(event) {
    return $583de2969a487e4e$var$callOnHub('captureEvent', event);
}
function $583de2969a487e4e$export$99d44f04437e9cb8(callback) {
    $583de2969a487e4e$var$callOnHub('configureScope', callback);
}
function $583de2969a487e4e$export$efda9a273d7a036d(breadcrumb) {
    $583de2969a487e4e$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $583de2969a487e4e$export$2f04de43fe27971a(name, context) {
    $583de2969a487e4e$var$callOnHub('setContext', name, context);
}
function $583de2969a487e4e$export$bb4922da0dd51b92(extras) {
    $583de2969a487e4e$var$callOnHub('setExtras', extras);
}
function $583de2969a487e4e$export$74a8fb34822092e6(tags) {
    $583de2969a487e4e$var$callOnHub('setTags', tags);
}
function $583de2969a487e4e$export$8e8e7789d42ed61d(key, extra) {
    $583de2969a487e4e$var$callOnHub('setExtra', key, extra);
}
function $583de2969a487e4e$export$a37d07ee78eb4569(key, value) {
    $583de2969a487e4e$var$callOnHub('setTag', key, value);
}
function $583de2969a487e4e$export$8b6bb3dd62a01be2(user) {
    $583de2969a487e4e$var$callOnHub('setUser', user);
}
function $583de2969a487e4e$export$ec58d9285c204497(callback) {
    $583de2969a487e4e$var$callOnHub('withScope', callback);
}
function $583de2969a487e4e$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $583de2969a487e4e$var$callOnHub.apply(void 0, (0, $3VFsf.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $583de2969a487e4e$export$e262da7ae6480481(context, customSamplingContext) {
    return $583de2969a487e4e$var$callOnHub('startTransaction', (0, $3VFsf.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("3kk8J", function(module, exports) {

$parcel$export(module.exports, "Hub", () => $26c2dcb27d4dffef$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $26c2dcb27d4dffef$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $26c2dcb27d4dffef$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $26c2dcb27d4dffef$export$a07cdf6544bbd7c);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("2zyAl");
var $aHQIJ = parcelRequire("aHQIJ");
var $gI8Be = parcelRequire("gI8Be");
var $eUO5L = parcelRequire("eUO5L");
var $3kiq9 = parcelRequire("3kiq9");
var $1vYJz = parcelRequire("1vYJz");

var $23Apf = parcelRequire("23Apf");

var $gfYRq = parcelRequire("gfYRq");

var $lTZg9 = parcelRequire("lTZg9");
var $26c2dcb27d4dffef$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $26c2dcb27d4dffef$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $26c2dcb27d4dffef$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $gfYRq.Scope)();
        if (_version === void 0) _version = $26c2dcb27d4dffef$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $gfYRq.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $1vYJz.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $1vYJz.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $1vYJz.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $26c2dcb27d4dffef$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $gI8Be.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $3VFsf.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $aHQIJ.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $26c2dcb27d4dffef$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $26c2dcb27d4dffef$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $23Apf.IS_DEBUG_BUILD) && (0, $aHQIJ.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $eUO5L.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $lTZg9.Session)((0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $3VFsf.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $26c2dcb27d4dffef$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $23Apf.IS_DEBUG_BUILD) && (0, $aHQIJ.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $26c2dcb27d4dffef$export$19eade501500c6c1() {
    var carrier = (0, $eUO5L.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $26c2dcb27d4dffef$export$4188a14ad302d1bc(hub) {
    var registry = $26c2dcb27d4dffef$export$19eade501500c6c1();
    var oldHub = $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
    $26c2dcb27d4dffef$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $26c2dcb27d4dffef$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $26c2dcb27d4dffef$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$26c2dcb27d4dffef$var$hasHubOnCarrier(registry) || $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry).isOlderThan($26c2dcb27d4dffef$export$24a86ef7798177e4)) $26c2dcb27d4dffef$export$849f05434e95d2f2(registry, new $26c2dcb27d4dffef$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $3kiq9.isNodeEnv)()) return $26c2dcb27d4dffef$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
}
function $26c2dcb27d4dffef$export$1c4d656130202699() {
    (0, $23Apf.IS_DEBUG_BUILD) && (0, $aHQIJ.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $26c2dcb27d4dffef$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $26c2dcb27d4dffef$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $26c2dcb27d4dffef$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$26c2dcb27d4dffef$var$hasHubOnCarrier(activeDomain) || $26c2dcb27d4dffef$export$bfa8a924a84a76b7(activeDomain).isOlderThan($26c2dcb27d4dffef$export$24a86ef7798177e4)) {
            var registryHubTopStack = $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry).getStackTop();
            $26c2dcb27d4dffef$export$849f05434e95d2f2(activeDomain, new $26c2dcb27d4dffef$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $gfYRq.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $26c2dcb27d4dffef$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $26c2dcb27d4dffef$export$bfa8a924a84a76b7(carrier) {
    return (0, $eUO5L.getGlobalSingleton)('hub', function() {
        return new $26c2dcb27d4dffef$export$8c41bb232f1008b1();
    }, carrier);
}
function $26c2dcb27d4dffef$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("2zyAl", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("eUO5L")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("eUO5L")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("okkfE")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("okkfE")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("aHQIJ")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("aHQIJ")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("1vYJz")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("59M0S")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("4mVTs")).SyncPromise);





parcelRequire("eUO5L");

parcelRequire("okkfE");
parcelRequire("aHQIJ");

parcelRequire("1vYJz");

var $3kiq9 = parcelRequire("3kiq9");

parcelRequire("59M0S");







parcelRequire("4mVTs");

var $gI8Be = parcelRequire("gI8Be");





$parcel$exportWildcard(module.exports, $3kiq9);
$parcel$exportWildcard(module.exports, $gI8Be);

});
parcelRegister("eUO5L", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $adbd26dd4cdaba08$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $adbd26dd4cdaba08$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $3kiq9 = parcelRequire("3kiq9");
var $adbd26dd4cdaba08$var$fallbackGlobalObject = {};
function $adbd26dd4cdaba08$export$256479dc0cea61c4() {
    return (0, $3kiq9.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $adbd26dd4cdaba08$var$fallbackGlobalObject;
}
function $adbd26dd4cdaba08$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $adbd26dd4cdaba08$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("3kiq9", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $diNsD = parcelRequire("diNsD");

var $6cAn5 = parcelRequire("6cAn5");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $diNsD.isBrowserBundle)() && Object.prototype.toString.call(typeof $6cAn5 !== 'undefined' ? $6cAn5 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("diNsD", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $9af352b66430744d$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $9af352b66430744d$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("okkfE", function(module, exports) {

$parcel$export(module.exports, "isError", () => $04920240eebc235f$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $04920240eebc235f$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $04920240eebc235f$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $04920240eebc235f$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $04920240eebc235f$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $04920240eebc235f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $04920240eebc235f$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $04920240eebc235f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $04920240eebc235f$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $04920240eebc235f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $04920240eebc235f$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $04920240eebc235f$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $04920240eebc235f$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $04920240eebc235f$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $04920240eebc235f$var$objectToString = Object.prototype.toString;
function $04920240eebc235f$export$e6127cc7fe7395c3(wat) {
    switch($04920240eebc235f$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $04920240eebc235f$export$49034edbe6b62415(wat, Error);
    }
}
function $04920240eebc235f$var$isBuiltin(wat, ty) {
    return $04920240eebc235f$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $04920240eebc235f$export$9f9636d330b71954(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'ErrorEvent');
}
function $04920240eebc235f$export$ef9e2056653f0c8e(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'DOMError');
}
function $04920240eebc235f$export$12e869b2a583f783(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'DOMException');
}
function $04920240eebc235f$export$844ec244b1367d54(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'String');
}
function $04920240eebc235f$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $04920240eebc235f$export$53b83ca8eaab0383(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'Object');
}
function $04920240eebc235f$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $04920240eebc235f$export$49034edbe6b62415(wat, Event);
}
function $04920240eebc235f$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $04920240eebc235f$export$49034edbe6b62415(wat, Element);
}
function $04920240eebc235f$export$49841c62b9eff15(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'RegExp');
}
function $04920240eebc235f$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $04920240eebc235f$export$bc2894c7158efbac(wat) {
    return $04920240eebc235f$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $04920240eebc235f$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $04920240eebc235f$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("aHQIJ", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $7cb6d0bbf859a350$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $7cb6d0bbf859a350$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $7cb6d0bbf859a350$export$af88d00dbe7f521);

var $3VFsf = parcelRequire("3VFsf");

var $1pUkh = parcelRequire("1pUkh");

var $eUO5L = parcelRequire("eUO5L");
// TODO: Implement different loggers for different environments
var $7cb6d0bbf859a350$var$global = (0, $eUO5L.getGlobalObject)();
/** Prefix for logging strings */ var $7cb6d0bbf859a350$var$PREFIX = 'Sentry Logger ';
var $7cb6d0bbf859a350$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $7cb6d0bbf859a350$export$cda52e2a8927a2ca(callback) {
    var global = (0, $eUO5L.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $7cb6d0bbf859a350$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $1pUkh.IS_DEBUG_BUILD) $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $7cb6d0bbf859a350$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $7cb6d0bbf859a350$var$global.console)[name].apply(_a, (0, $3VFsf.__spread)([
                    $7cb6d0bbf859a350$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $7cb6d0bbf859a350$export$af88d00dbe7f521;
if (0, $1pUkh.IS_DEBUG_BUILD) $7cb6d0bbf859a350$export$af88d00dbe7f521 = (0, $eUO5L.getGlobalSingleton)('logger', $7cb6d0bbf859a350$var$makeLogger);
else $7cb6d0bbf859a350$export$af88d00dbe7f521 = $7cb6d0bbf859a350$var$makeLogger();

});
parcelRegister("1pUkh", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $1083d16d6e02eb4b$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $1083d16d6e02eb4b$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("1vYJz", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $11a7cc3993e3d0c3$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $11a7cc3993e3d0c3$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $11a7cc3993e3d0c3$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $11a7cc3993e3d0c3$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $11a7cc3993e3d0c3$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $11a7cc3993e3d0c3$export$6de4ffac6a2f1098);

var $3VFsf = parcelRequire("3VFsf");

var $eUO5L = parcelRequire("eUO5L");

var $59M0S = parcelRequire("59M0S");

var $keOcA = parcelRequire("keOcA");
function $11a7cc3993e3d0c3$export$19f53698e68b2496() {
    var global = (0, $eUO5L.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $11a7cc3993e3d0c3$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $11a7cc3993e3d0c3$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $11a7cc3993e3d0c3$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $11a7cc3993e3d0c3$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $11a7cc3993e3d0c3$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $11a7cc3993e3d0c3$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $11a7cc3993e3d0c3$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $11a7cc3993e3d0c3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $11a7cc3993e3d0c3$export$d364f2020ab30578(input) {
    var match = input.match($11a7cc3993e3d0c3$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $11a7cc3993e3d0c3$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $keOcA.snipLine)(line, 0);
    });
    frame.context_line = (0, $keOcA.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $keOcA.snipLine)(line, 0);
    });
}
function $11a7cc3993e3d0c3$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $11a7cc3993e3d0c3$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $59M0S.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("59M0S", function(module, exports) {

$parcel$export(module.exports, "fill", () => $3c130969d9628ee3$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $3c130969d9628ee3$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $3c130969d9628ee3$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $3c130969d9628ee3$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $3c130969d9628ee3$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $3c130969d9628ee3$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $3c130969d9628ee3$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $3c130969d9628ee3$export$d25f2688db1bb433);

var $3VFsf = parcelRequire("3VFsf");

var $fB1v8 = parcelRequire("fB1v8");

var $okkfE = parcelRequire("okkfE");

var $keOcA = parcelRequire("keOcA");
function $3c130969d9628ee3$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $3c130969d9628ee3$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $3c130969d9628ee3$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $3c130969d9628ee3$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $3c130969d9628ee3$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $3c130969d9628ee3$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $3c130969d9628ee3$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $3c130969d9628ee3$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $okkfE.isError)(value)) newObj = (0, $3VFsf.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $3c130969d9628ee3$var$getOwnProperties(value));
    else if ((0, $okkfE.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $3VFsf.__assign)({
            type: event_1.type,
            target: $3c130969d9628ee3$var$serializeEventTarget(event_1.target),
            currentTarget: $3c130969d9628ee3$var$serializeEventTarget(event_1.currentTarget)
        }, $3c130969d9628ee3$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $okkfE.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $3c130969d9628ee3$var$serializeEventTarget(target) {
    try {
        return (0, $okkfE.isElement)(target) ? (0, $fB1v8.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $3c130969d9628ee3$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $3c130969d9628ee3$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($3c130969d9628ee3$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $keOcA.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $keOcA.truncate)(serialized, maxLength);
    }
    return '';
}
function $3c130969d9628ee3$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $okkfE.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $3VFsf.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $3c130969d9628ee3$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($3c130969d9628ee3$export$d25f2688db1bb433);
    return val;
}
function $3c130969d9628ee3$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $okkfE.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("fB1v8", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $b5ab79d71b24e1dd$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $b5ab79d71b24e1dd$export$1cfafeee2987818b);

var $eUO5L = parcelRequire("eUO5L");

var $okkfE = parcelRequire("okkfE");
function $b5ab79d71b24e1dd$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b5ab79d71b24e1dd$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b5ab79d71b24e1dd$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $okkfE.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $b5ab79d71b24e1dd$export$1cfafeee2987818b() {
    var global = (0, $eUO5L.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("keOcA", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $ebbc0e804ef05913$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $ebbc0e804ef05913$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $ebbc0e804ef05913$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $ebbc0e804ef05913$export$cdded5b28a5f8c6d);

var $okkfE = parcelRequire("okkfE");
function $ebbc0e804ef05913$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $ebbc0e804ef05913$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $ebbc0e804ef05913$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $ebbc0e804ef05913$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $okkfE.isString)(value)) return false;
    if ((0, $okkfE.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $ebbc0e804ef05913$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});



parcelRegister("4mVTs", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $32e61feb582e8017$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $32e61feb582e8017$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $32e61feb582e8017$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $okkfE = parcelRequire("okkfE");
function $32e61feb582e8017$export$1fda8aa4d135f8aa(value) {
    return new $32e61feb582e8017$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $32e61feb582e8017$export$78e43115b553f358(reason) {
    return new $32e61feb582e8017$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $32e61feb582e8017$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $okkfE.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("gI8Be", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $eUO5L = parcelRequire("eUO5L");

var $3kiq9 = parcelRequire("3kiq9");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $eUO5L.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $3kiq9.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $3kiq9.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $eUO5L.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});


parcelRegister("23Apf", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $17f81a1bea39bc90$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $17f81a1bea39bc90$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("gfYRq", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $bd5d41be26a98453$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $bd5d41be26a98453$export$8e4e25f54d456511);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("2zyAl");
var $gI8Be = parcelRequire("gI8Be");
var $eUO5L = parcelRequire("eUO5L");
var $okkfE = parcelRequire("okkfE");
var $4mVTs = parcelRequire("4mVTs");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $bd5d41be26a98453$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $bd5d41be26a98453$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $3VFsf.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $3VFsf.__assign)({}, scope._tags);
            newScope._extra = (0, $3VFsf.__assign)({}, scope._extra);
            newScope._contexts = (0, $3VFsf.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $3VFsf.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $okkfE.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $bd5d41be26a98453$var$MAX_BREADCRUMBS) : $bd5d41be26a98453$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $3VFsf.__assign)({
            timestamp: (0, $gI8Be.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $3VFsf.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $3VFsf.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $3VFsf.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $3VFsf.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $3VFsf.__spread)($bd5d41be26a98453$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $4mVTs.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $3VFsf.__assign)({}, event), hint);
                if ((0, $okkfE.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $bd5d41be26a98453$var$getGlobalEventProcessors() {
    return (0, $eUO5L.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $bd5d41be26a98453$export$8e4e25f54d456511(callback) {
    $bd5d41be26a98453$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("lTZg9", function(module, exports) {

$parcel$export(module.exports, "Session", () => $ff1e40e1db4f1b32$export$1fb4852a55678982);
parcelRequire("2zyAl");
var $59M0S = parcelRequire("59M0S");
var $gI8Be = parcelRequire("gI8Be");
var $1vYJz = parcelRequire("1vYJz");
/**
 * @inheritdoc
 */ var $ff1e40e1db4f1b32$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $1vYJz.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $gI8Be.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $gI8Be.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $1vYJz.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $59M0S.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("kFfmc", function(module, exports) {

$parcel$export(module.exports, "init", () => $f0b38c92b55bde06$export$2cd8252107eb640b);

var $3VFsf = parcelRequire("3VFsf");

var $3kk8J = parcelRequire("3kk8J");
var $DPuyZ = parcelRequire("DPuyZ");
var $hK2IQ = parcelRequire("hK2IQ");
parcelRequire("8KVVB");
var $1sgxX = parcelRequire("1sgxX");
var $35A7f = parcelRequire("35A7f");
var $4geCF = parcelRequire("4geCF");
var $3X7U8 = parcelRequire("3X7U8");

var $3pmgQ = parcelRequire("3pmgQ");

var $l97zN = parcelRequire("l97zN");

var $9aSEL = parcelRequire("9aSEL");

var $5Z1NC = parcelRequire("5Z1NC");
var $ilDeH = parcelRequire("ilDeH");
var $ijPmO = parcelRequire("ijPmO");
var $5zMCv = parcelRequire("5zMCv");
var $4EoaR = parcelRequire("4EoaR");
var $lKe3d = parcelRequire("lKe3d");
var $f0b38c92b55bde06$export$5ef831fccfce35e5 = [
    new (0, $hK2IQ).InboundFilters(),
    new (0, $hK2IQ).FunctionToString(),
    new (0, $4EoaR.TryCatch)(),
    new (0, $5Z1NC.Breadcrumbs)(),
    new (0, $ijPmO.GlobalHandlers)(),
    new (0, $5zMCv.LinkedErrors)(),
    new (0, $ilDeH.Dedupe)(),
    new (0, $lKe3d.UserAgent)()
];
function $f0b38c92b55bde06$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $f0b38c92b55bde06$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $35A7f.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $DPuyZ.initAndBind)((0, $3pmgQ.BrowserClient), options);
    if (options.autoSessionTracking) $f0b38c92b55bde06$var$startSessionTracking();
}
function $f0b38c92b55bde06$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $3kk8J.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $f0b38c92b55bde06$export$5d4e9fd7fac8e617() {
    return (0, $3kk8J.getCurrentHub)().lastEventId();
}
function $f0b38c92b55bde06$export$a3f323d81eede727() {
// Noop
}
function $f0b38c92b55bde06$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $f0b38c92b55bde06$export$4909b86c8034bf73(timeout) {
    var client = (0, $3kk8J.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Cannot flush events. No client defined.');
    return (0, $3X7U8.resolvedSyncPromise)(false);
}
function $f0b38c92b55bde06$export$8360e631d277ea4d(timeout) {
    var client = (0, $3kk8J.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $3X7U8.resolvedSyncPromise)(false);
}
function $f0b38c92b55bde06$export$4997ffc0176396a6(fn) {
    return (0, $9aSEL.wrap)(fn)();
}
function $f0b38c92b55bde06$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $f0b38c92b55bde06$var$startSessionTracking() {
    var window = (0, $35A7f.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $3kk8J.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $f0b38c92b55bde06$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $1sgxX.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $f0b38c92b55bde06$var$startSessionOnHub((0, $3kk8J.getCurrentHub)());
    });
}

});
parcelRegister("DPuyZ", function(module, exports) {

$parcel$export(module.exports, "initAndBind", () => $077b95dcdc7224fa$export$5333c3f1c58d9bc1);

var $3kk8J = parcelRequire("3kk8J");
parcelRequire("8KVVB");
var $4geCF = parcelRequire("4geCF");

var $aEGcl = parcelRequire("aEGcl");
function $077b95dcdc7224fa$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $aEGcl.IS_DEBUG_BUILD) (0, $4geCF.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $3kk8J.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});
parcelRegister("8KVVB", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("dYkdu")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("7yHR0")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("7yHR0")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("gSiM6")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("gSiM6")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("b17Q6")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("35A7f")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("1sgxX")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("gkmq5")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("gkmq5")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("gkmq5")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("gkmq5")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("gkmq5")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("gkmq5")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("gkmq5")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("gkmq5")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("gkmq5")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("gkmq5")).isThenable);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("4geCF")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("4geCF")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("jyUiA")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("jyUiA")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("jyUiA")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("jyUiA")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("jyUiA")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("jyUiA")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("2mY5H")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("2mY5H")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("1l3DN")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("1l3DN")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("1l3DN")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("1l3DN")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("1l3DN")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("1l3DN")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("9aaXP")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("n3F4l")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("aNkwr")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("aNkwr")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("aGIlP")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("jOwKr")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("jOwKr")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("jOwKr")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("ci1rH")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("ci1rH")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("ci1rH")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("3X7U8")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("3X7U8")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("3X7U8")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("e1x9C")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("e1x9C")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("e1x9C")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("jk0Xn")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("2rF5w")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("2rF5w")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("2rF5w")).updateRateLimits);
parcelRequire("dYkdu");
parcelRequire("7yHR0");
parcelRequire("gSiM6");

parcelRequire("b17Q6");
parcelRequire("35A7f");
parcelRequire("1sgxX");
parcelRequire("gkmq5");
parcelRequire("4geCF");

parcelRequire("jyUiA");

var $9UV3v = parcelRequire("9UV3v");
parcelRequire("2mY5H");
parcelRequire("1l3DN");

parcelRequire("9aaXP");
parcelRequire("n3F4l");
parcelRequire("aNkwr");
parcelRequire("aGIlP");
parcelRequire("jOwKr");
parcelRequire("ci1rH");
parcelRequire("3X7U8");

var $eHWqV = parcelRequire("eHWqV");


parcelRequire("e1x9C");
parcelRequire("jk0Xn");
parcelRequire("2rF5w");
$parcel$exportWildcard(module.exports, $9UV3v);
$parcel$exportWildcard(module.exports, $eHWqV);

});
parcelRegister("dYkdu", function(module, exports) {

$parcel$export(module.exports, "forget", () => $02a00250c53700ca$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $02a00250c53700ca$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("7yHR0", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $580db9d8ee86b37d$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $580db9d8ee86b37d$export$1cfafeee2987818b);

var $35A7f = parcelRequire("35A7f");

var $gkmq5 = parcelRequire("gkmq5");
function $580db9d8ee86b37d$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $580db9d8ee86b37d$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $580db9d8ee86b37d$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $gkmq5.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $580db9d8ee86b37d$export$1cfafeee2987818b() {
    var global = (0, $35A7f.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("35A7f", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $23fdda930ad06550$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $23fdda930ad06550$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $9UV3v = parcelRequire("9UV3v");
var $23fdda930ad06550$var$fallbackGlobalObject = {};
function $23fdda930ad06550$export$256479dc0cea61c4() {
    return (0, $9UV3v.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $23fdda930ad06550$var$fallbackGlobalObject;
}
function $23fdda930ad06550$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $23fdda930ad06550$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("9UV3v", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $9gXpd = parcelRequire("9gXpd");

var $6cAn5 = parcelRequire("6cAn5");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $9gXpd.isBrowserBundle)() && Object.prototype.toString.call(typeof $6cAn5 !== 'undefined' ? $6cAn5 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("9gXpd", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $6c03b06a7831477f$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $6c03b06a7831477f$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("gkmq5", function(module, exports) {

$parcel$export(module.exports, "isError", () => $be2fe7accd263025$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $be2fe7accd263025$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $be2fe7accd263025$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $be2fe7accd263025$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $be2fe7accd263025$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $be2fe7accd263025$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $be2fe7accd263025$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $be2fe7accd263025$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $be2fe7accd263025$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $be2fe7accd263025$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $be2fe7accd263025$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $be2fe7accd263025$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $be2fe7accd263025$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $be2fe7accd263025$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $be2fe7accd263025$var$objectToString = Object.prototype.toString;
function $be2fe7accd263025$export$e6127cc7fe7395c3(wat) {
    switch($be2fe7accd263025$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $be2fe7accd263025$export$49034edbe6b62415(wat, Error);
    }
}
function $be2fe7accd263025$var$isBuiltin(wat, ty) {
    return $be2fe7accd263025$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $be2fe7accd263025$export$9f9636d330b71954(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'ErrorEvent');
}
function $be2fe7accd263025$export$ef9e2056653f0c8e(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'DOMError');
}
function $be2fe7accd263025$export$12e869b2a583f783(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'DOMException');
}
function $be2fe7accd263025$export$844ec244b1367d54(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'String');
}
function $be2fe7accd263025$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $be2fe7accd263025$export$53b83ca8eaab0383(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'Object');
}
function $be2fe7accd263025$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $be2fe7accd263025$export$49034edbe6b62415(wat, Event);
}
function $be2fe7accd263025$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $be2fe7accd263025$export$49034edbe6b62415(wat, Element);
}
function $be2fe7accd263025$export$49841c62b9eff15(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'RegExp');
}
function $be2fe7accd263025$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $be2fe7accd263025$export$bc2894c7158efbac(wat) {
    return $be2fe7accd263025$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $be2fe7accd263025$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $be2fe7accd263025$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("gSiM6", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $c49040c921587e2a$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $c49040c921587e2a$export$128827c3562ec0cb);

var $3VFsf = parcelRequire("3VFsf");

var $b17Q6 = parcelRequire("b17Q6");

var $7zZth = parcelRequire("7zZth");
/** Regular expression used to parse a Dsn. */ var $c49040c921587e2a$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $c49040c921587e2a$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $c49040c921587e2a$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $c49040c921587e2a$var$dsnFromString(str) {
    var match = $c49040c921587e2a$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $b17Q6.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $3VFsf.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $c49040c921587e2a$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $c49040c921587e2a$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $c49040c921587e2a$var$validateDsn(dsn) {
    if (!(0, $7zZth.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $b17Q6.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $b17Q6.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$c49040c921587e2a$var$isValidProtocol(protocol)) throw new (0, $b17Q6.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $b17Q6.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $c49040c921587e2a$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $c49040c921587e2a$var$dsnFromString(from) : $c49040c921587e2a$var$dsnFromComponents(from);
    $c49040c921587e2a$var$validateDsn(components);
    return components;
}

});
parcelRegister("b17Q6", function(module, exports) {

$parcel$export(module.exports, "SentryError", () => $8055de6a13943cfb$export$5949942ba2a7c0e2);

var $3VFsf = parcelRequire("3VFsf");

var $cQly6 = parcelRequire("cQly6");
/** An error emitted by Sentry SDKs and related utilities. */ var $8055de6a13943cfb$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $cQly6.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("cQly6", function(module, exports) {

$parcel$export(module.exports, "setPrototypeOf", () => $959b0e8d921af28b$export$1cb0d91350beb6cc);
var $959b0e8d921af28b$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $959b0e8d921af28b$var$setProtoOf : $959b0e8d921af28b$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $959b0e8d921af28b$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $959b0e8d921af28b$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("7zZth", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $584b7c38f9c3783f$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $584b7c38f9c3783f$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("1sgxX", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $10f53dcccdcfb2a2$export$285b9172a3741fb7);

var $3VFsf = parcelRequire("3VFsf");

var $7zZth = parcelRequire("7zZth");

var $35A7f = parcelRequire("35A7f");

var $gkmq5 = parcelRequire("gkmq5");

var $4geCF = parcelRequire("4geCF");

var $1l3DN = parcelRequire("1l3DN");

var $aNkwr = parcelRequire("aNkwr");

var $ci1rH = parcelRequire("ci1rH");
var $10f53dcccdcfb2a2$var$global = (0, $35A7f.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $10f53dcccdcfb2a2$var$handlers = {};
var $10f53dcccdcfb2a2$var$instrumented = {};
/** Instruments given API */ function $10f53dcccdcfb2a2$var$instrument(type) {
    if ($10f53dcccdcfb2a2$var$instrumented[type]) return;
    $10f53dcccdcfb2a2$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $10f53dcccdcfb2a2$var$instrumentConsole();
            break;
        case 'dom':
            $10f53dcccdcfb2a2$var$instrumentDOM();
            break;
        case 'xhr':
            $10f53dcccdcfb2a2$var$instrumentXHR();
            break;
        case 'fetch':
            $10f53dcccdcfb2a2$var$instrumentFetch();
            break;
        case 'history':
            $10f53dcccdcfb2a2$var$instrumentHistory();
            break;
        case 'error':
            $10f53dcccdcfb2a2$var$instrumentError();
            break;
        case 'unhandledrejection':
            $10f53dcccdcfb2a2$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $7zZth.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $10f53dcccdcfb2a2$export$285b9172a3741fb7(type, callback) {
    $10f53dcccdcfb2a2$var$handlers[type] = $10f53dcccdcfb2a2$var$handlers[type] || [];
    $10f53dcccdcfb2a2$var$handlers[type].push(callback);
    $10f53dcccdcfb2a2$var$instrument(type);
}
/** JSDoc */ function $10f53dcccdcfb2a2$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$10f53dcccdcfb2a2$var$handlers[type]) return;
    try {
        for(var _b = (0, $3VFsf.__values)($10f53dcccdcfb2a2$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $7zZth.IS_DEBUG_BUILD) && (0, $4geCF.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $aNkwr.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentConsole() {
    if (!('console' in $10f53dcccdcfb2a2$var$global)) return;
    (0, $4geCF.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $10f53dcccdcfb2a2$var$global.console)) return;
        (0, $1l3DN.fill)($10f53dcccdcfb2a2$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $10f53dcccdcfb2a2$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($10f53dcccdcfb2a2$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentFetch() {
    if (!(0, $ci1rH.supportsNativeFetch)()) return;
    (0, $1l3DN.fill)($10f53dcccdcfb2a2$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $10f53dcccdcfb2a2$var$getFetchMethod(args),
                    url: $10f53dcccdcfb2a2$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $10f53dcccdcfb2a2$var$triggerHandlers('fetch', (0, $3VFsf.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($10f53dcccdcfb2a2$var$global, args).then(function(response) {
                $10f53dcccdcfb2a2$var$triggerHandlers('fetch', (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $10f53dcccdcfb2a2$var$triggerHandlers('fetch', (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $10f53dcccdcfb2a2$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $10f53dcccdcfb2a2$var$global && (0, $gkmq5.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $10f53dcccdcfb2a2$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $10f53dcccdcfb2a2$var$global && (0, $gkmq5.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $10f53dcccdcfb2a2$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $1l3DN.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $gkmq5.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $gkmq5.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $10f53dcccdcfb2a2$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $1l3DN.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $1l3DN.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $10f53dcccdcfb2a2$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $10f53dcccdcfb2a2$var$lastHref;
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentHistory() {
    if (!(0, $ci1rH.supportsHistory)()) return;
    var oldOnPopState = $10f53dcccdcfb2a2$var$global.onpopstate;
    $10f53dcccdcfb2a2$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $10f53dcccdcfb2a2$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $10f53dcccdcfb2a2$var$lastHref;
        $10f53dcccdcfb2a2$var$lastHref = to;
        $10f53dcccdcfb2a2$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $10f53dcccdcfb2a2$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $10f53dcccdcfb2a2$var$lastHref = to;
                $10f53dcccdcfb2a2$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $1l3DN.fill)($10f53dcccdcfb2a2$var$global.history, 'pushState', historyReplacementFunction);
    (0, $1l3DN.fill)($10f53dcccdcfb2a2$var$global.history, 'replaceState', historyReplacementFunction);
}
var $10f53dcccdcfb2a2$var$debounceDuration = 1000;
var $10f53dcccdcfb2a2$var$debounceTimerID;
var $10f53dcccdcfb2a2$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $10f53dcccdcfb2a2$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $10f53dcccdcfb2a2$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $10f53dcccdcfb2a2$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $10f53dcccdcfb2a2$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($10f53dcccdcfb2a2$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($10f53dcccdcfb2a2$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $10f53dcccdcfb2a2$var$lastCapturedEvent = event;
        } else if ($10f53dcccdcfb2a2$var$shouldShortcircuitPreviousDebounce($10f53dcccdcfb2a2$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $10f53dcccdcfb2a2$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($10f53dcccdcfb2a2$var$debounceTimerID);
        $10f53dcccdcfb2a2$var$debounceTimerID = $10f53dcccdcfb2a2$var$global.setTimeout(function() {
            $10f53dcccdcfb2a2$var$debounceTimerID = undefined;
        }, $10f53dcccdcfb2a2$var$debounceDuration);
    };
}
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentDOM() {
    if (!('document' in $10f53dcccdcfb2a2$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $10f53dcccdcfb2a2$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $10f53dcccdcfb2a2$var$makeDOMEventHandler(triggerDOMHandler, true);
    $10f53dcccdcfb2a2$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $10f53dcccdcfb2a2$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $10f53dcccdcfb2a2$var$global[target] && $10f53dcccdcfb2a2$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $1l3DN.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $10f53dcccdcfb2a2$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $1l3DN.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $10f53dcccdcfb2a2$var$_oldOnErrorHandler = null;
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentError() {
    $10f53dcccdcfb2a2$var$_oldOnErrorHandler = $10f53dcccdcfb2a2$var$global.onerror;
    $10f53dcccdcfb2a2$var$global.onerror = function(msg, url, line, column, error) {
        $10f53dcccdcfb2a2$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($10f53dcccdcfb2a2$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $10f53dcccdcfb2a2$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $10f53dcccdcfb2a2$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentUnhandledRejection() {
    $10f53dcccdcfb2a2$var$_oldOnUnhandledRejectionHandler = $10f53dcccdcfb2a2$var$global.onunhandledrejection;
    $10f53dcccdcfb2a2$var$global.onunhandledrejection = function(e) {
        $10f53dcccdcfb2a2$var$triggerHandlers('unhandledrejection', e);
        if ($10f53dcccdcfb2a2$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $10f53dcccdcfb2a2$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("4geCF", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $31a3ffca8b63e1cc$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $31a3ffca8b63e1cc$export$af88d00dbe7f521);

var $3VFsf = parcelRequire("3VFsf");

var $7zZth = parcelRequire("7zZth");

var $35A7f = parcelRequire("35A7f");
// TODO: Implement different loggers for different environments
var $31a3ffca8b63e1cc$var$global = (0, $35A7f.getGlobalObject)();
/** Prefix for logging strings */ var $31a3ffca8b63e1cc$var$PREFIX = 'Sentry Logger ';
var $31a3ffca8b63e1cc$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $31a3ffca8b63e1cc$export$cda52e2a8927a2ca(callback) {
    var global = (0, $35A7f.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $31a3ffca8b63e1cc$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $31a3ffca8b63e1cc$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $7zZth.IS_DEBUG_BUILD) $31a3ffca8b63e1cc$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $31a3ffca8b63e1cc$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $31a3ffca8b63e1cc$var$global.console)[name].apply(_a, (0, $3VFsf.__spread)([
                    $31a3ffca8b63e1cc$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $31a3ffca8b63e1cc$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $31a3ffca8b63e1cc$export$af88d00dbe7f521;
if (0, $7zZth.IS_DEBUG_BUILD) $31a3ffca8b63e1cc$export$af88d00dbe7f521 = (0, $35A7f.getGlobalSingleton)('logger', $31a3ffca8b63e1cc$var$makeLogger);
else $31a3ffca8b63e1cc$export$af88d00dbe7f521 = $31a3ffca8b63e1cc$var$makeLogger();

});

parcelRegister("1l3DN", function(module, exports) {

$parcel$export(module.exports, "fill", () => $0f9a939899ca1852$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $0f9a939899ca1852$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $0f9a939899ca1852$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $0f9a939899ca1852$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $0f9a939899ca1852$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $0f9a939899ca1852$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $0f9a939899ca1852$export$b0244d5063c0b61b);

var $3VFsf = parcelRequire("3VFsf");

var $7yHR0 = parcelRequire("7yHR0");

var $gkmq5 = parcelRequire("gkmq5");

var $jOwKr = parcelRequire("jOwKr");
function $0f9a939899ca1852$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $0f9a939899ca1852$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $0f9a939899ca1852$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $0f9a939899ca1852$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $0f9a939899ca1852$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $0f9a939899ca1852$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $0f9a939899ca1852$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $0f9a939899ca1852$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $gkmq5.isError)(value)) newObj = (0, $3VFsf.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $0f9a939899ca1852$var$getOwnProperties(value));
    else if ((0, $gkmq5.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $3VFsf.__assign)({
            type: event_1.type,
            target: $0f9a939899ca1852$var$serializeEventTarget(event_1.target),
            currentTarget: $0f9a939899ca1852$var$serializeEventTarget(event_1.currentTarget)
        }, $0f9a939899ca1852$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $gkmq5.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $0f9a939899ca1852$var$serializeEventTarget(target) {
    try {
        return (0, $gkmq5.isElement)(target) ? (0, $7yHR0.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $0f9a939899ca1852$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $0f9a939899ca1852$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($0f9a939899ca1852$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $jOwKr.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $jOwKr.truncate)(serialized, maxLength);
    }
    return '';
}
function $0f9a939899ca1852$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $gkmq5.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $3VFsf.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $0f9a939899ca1852$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($0f9a939899ca1852$export$d25f2688db1bb433);
    return val;
}
function $0f9a939899ca1852$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $gkmq5.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("jOwKr", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $e6cc16e585cef99d$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $e6cc16e585cef99d$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $e6cc16e585cef99d$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $e6cc16e585cef99d$export$cdded5b28a5f8c6d);

var $gkmq5 = parcelRequire("gkmq5");
function $e6cc16e585cef99d$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $e6cc16e585cef99d$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $e6cc16e585cef99d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $e6cc16e585cef99d$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $gkmq5.isString)(value)) return false;
    if ((0, $gkmq5.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $e6cc16e585cef99d$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("aNkwr", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $7dbe6648bfa0e83e$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $7dbe6648bfa0e83e$export$aad197c7121a6651);

var $3VFsf = parcelRequire("3VFsf");
var $7dbe6648bfa0e83e$var$STACKTRACE_LIMIT = 50;
function $7dbe6648bfa0e83e$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $3VFsf.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $3VFsf.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $7dbe6648bfa0e83e$export$c55c24c0eeba0205(frames);
    };
}
function $7dbe6648bfa0e83e$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $7dbe6648bfa0e83e$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $7dbe6648bfa0e83e$var$defaultFunctionName = '<anonymous>';
function $7dbe6648bfa0e83e$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $7dbe6648bfa0e83e$var$defaultFunctionName;
        return fn.name || $7dbe6648bfa0e83e$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $7dbe6648bfa0e83e$var$defaultFunctionName;
    }
}

});

parcelRegister("ci1rH", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", () => $8f2849975b030cc8$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $8f2849975b030cc8$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $8f2849975b030cc8$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $8f2849975b030cc8$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $8f2849975b030cc8$export$67fc34576016d6ec);

var $7zZth = parcelRequire("7zZth");

var $35A7f = parcelRequire("35A7f");

var $4geCF = parcelRequire("4geCF");
function $8f2849975b030cc8$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $8f2849975b030cc8$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $8f2849975b030cc8$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $8f2849975b030cc8$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $35A7f.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $8f2849975b030cc8$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $8f2849975b030cc8$export$c82d238e23c40b21() {
    if (!$8f2849975b030cc8$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $35A7f.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($8f2849975b030cc8$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $8f2849975b030cc8$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $7zZth.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $8f2849975b030cc8$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $35A7f.getGlobalObject)();
}
function $8f2849975b030cc8$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$8f2849975b030cc8$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $8f2849975b030cc8$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $35A7f.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("jyUiA", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $e3dcdd1608c449ef$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $e3dcdd1608c449ef$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $e3dcdd1608c449ef$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $e3dcdd1608c449ef$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $e3dcdd1608c449ef$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $e3dcdd1608c449ef$export$6de4ffac6a2f1098);

var $3VFsf = parcelRequire("3VFsf");

var $35A7f = parcelRequire("35A7f");

var $1l3DN = parcelRequire("1l3DN");

var $jOwKr = parcelRequire("jOwKr");
function $e3dcdd1608c449ef$export$19f53698e68b2496() {
    var global = (0, $35A7f.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $e3dcdd1608c449ef$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $e3dcdd1608c449ef$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $e3dcdd1608c449ef$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $e3dcdd1608c449ef$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $e3dcdd1608c449ef$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $e3dcdd1608c449ef$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $e3dcdd1608c449ef$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $e3dcdd1608c449ef$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $e3dcdd1608c449ef$export$d364f2020ab30578(input) {
    var match = input.match($e3dcdd1608c449ef$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $e3dcdd1608c449ef$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $jOwKr.snipLine)(line, 0);
    });
    frame.context_line = (0, $jOwKr.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $jOwKr.snipLine)(line, 0);
    });
}
function $e3dcdd1608c449ef$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $e3dcdd1608c449ef$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $1l3DN.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("2mY5H", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $1b9c3fa19e940880$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $1b9c3fa19e940880$export$23fbbb20bed71033);

var $3VFsf = parcelRequire("3VFsf");

var $gkmq5 = parcelRequire("gkmq5");

var $377JV = parcelRequire("377JV");

var $1l3DN = parcelRequire("1l3DN");

var $aNkwr = parcelRequire("aNkwr");
function $1b9c3fa19e940880$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $1b9c3fa19e940880$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $1b9c3fa19e940880$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $1b9c3fa19e940880$export$a3295358bff77e(object, depth);
    if ($1b9c3fa19e940880$var$jsonSize(normalized) > maxSize) return $1b9c3fa19e940880$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $1b9c3fa19e940880$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $377JV.memoBuilder)();
    var _a = (0, $3VFsf.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $gkmq5.isNaN)(value)) return value;
    var stringified = $1b9c3fa19e940880$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $gkmq5.isError)(value) || (0, $gkmq5.isEvent)(value) ? (0, $1l3DN.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $1b9c3fa19e940880$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $1b9c3fa19e940880$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $gkmq5.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $aNkwr.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $1b9c3fa19e940880$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $1b9c3fa19e940880$var$jsonSize(value) {
    return $1b9c3fa19e940880$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("377JV", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $24480783204ac77c$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $24480783204ac77c$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("9aaXP", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", () => $6abd8d736a42b85d$export$85a4f67f852183e6);

var $b17Q6 = parcelRequire("b17Q6");

var $3X7U8 = parcelRequire("3X7U8");
function $6abd8d736a42b85d$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $3X7U8.rejectedSyncPromise)(new (0, $b17Q6.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $3X7U8.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $3X7U8.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("3X7U8", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $2e0d03738c27a94c$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $2e0d03738c27a94c$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $2e0d03738c27a94c$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $gkmq5 = parcelRequire("gkmq5");
function $2e0d03738c27a94c$export$1fda8aa4d135f8aa(value) {
    return new $2e0d03738c27a94c$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $2e0d03738c27a94c$export$78e43115b553f358(reason) {
    return new $2e0d03738c27a94c$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $2e0d03738c27a94c$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $gkmq5.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("n3F4l", function(module, exports) {

$parcel$export(module.exports, "severityFromString", () => $0454fd2cf9d26b9d$export$e01cef29b4327697);

var $4aybe = parcelRequire("4aybe");

var $7UEZR = parcelRequire("7UEZR");
function $0454fd2cf9d26b9d$var$isSupportedSeverity(level) {
    return (0, $7UEZR.SeverityLevels).indexOf(level) !== -1;
}
function $0454fd2cf9d26b9d$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $4aybe.Severity).Warning;
    if ($0454fd2cf9d26b9d$var$isSupportedSeverity(level)) return level;
    return (0, $4aybe.Severity).Log;
}

});
parcelRegister("4aybe", function(module, exports) {

$parcel$export(module.exports, "Severity", () => $30929c0b26d77527$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $30929c0b26d77527$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($30929c0b26d77527$export$918a9776c0a3cf27 || ($30929c0b26d77527$export$918a9776c0a3cf27 = {}));
var $30929c0b26d77527$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("7UEZR", function(module, exports) {

$parcel$export(module.exports, "SeverityLevels", () => $5c2d9075c2497ee3$export$484b1ea9aec914c);
var $5c2d9075c2497ee3$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("aGIlP", function(module, exports) {

$parcel$export(module.exports, "eventStatusFromHttpCode", () => $7c803ad63297ed5d$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $7c803ad63297ed5d$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("eHWqV", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $35A7f = parcelRequire("35A7f");

var $9UV3v = parcelRequire("9UV3v");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $35A7f.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $9UV3v.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $9UV3v.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $35A7f.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("e1x9C", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", () => $a35ae061efedcb1a$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $a35ae061efedcb1a$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $a35ae061efedcb1a$export$32f9b428425aac85);

var $3VFsf = parcelRequire("3VFsf");

var $gkmq5 = parcelRequire("gkmq5");
function $a35ae061efedcb1a$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $a35ae061efedcb1a$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $3VFsf.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $3VFsf.__spread)(items, [
            newItem
        ])
    ];
}
function $a35ae061efedcb1a$export$d84939284bbafcd4(envelope) {
    var _a = (0, $3VFsf.__read)(envelope, 2), _b = (0, $3VFsf.__read)(_a[1], 1), _c = (0, $3VFsf.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $a35ae061efedcb1a$export$32f9b428425aac85(envelope) {
    var _a = (0, $3VFsf.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $3VFsf.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $gkmq5.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("jk0Xn", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", () => $e110a091c483d2cf$export$f3b9ed77c03eeb00);

var $e1x9C = parcelRequire("e1x9C");

var $eHWqV = parcelRequire("eHWqV");
function $e110a091c483d2cf$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $eHWqV.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $e1x9C.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("2rF5w", function(module, exports) {

$parcel$export(module.exports, "disabledUntil", () => $1c7df99b82793dbb$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $1c7df99b82793dbb$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $1c7df99b82793dbb$export$699aff705e0d49d4);

var $3VFsf = parcelRequire("3VFsf");
var $1c7df99b82793dbb$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $1c7df99b82793dbb$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $1c7df99b82793dbb$export$b09ce39faaeb1e7c;
}
function $1c7df99b82793dbb$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $1c7df99b82793dbb$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $1c7df99b82793dbb$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $1c7df99b82793dbb$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $3VFsf.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $3VFsf.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $3VFsf.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $1c7df99b82793dbb$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("aEGcl", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $7c1e5f737e2182ad$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $7c1e5f737e2182ad$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("hK2IQ", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("dRmVN")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("7TVcb")).InboundFilters);

var $dRmVN = parcelRequire("dRmVN");

var $7TVcb = parcelRequire("7TVcb");

});
parcelRegister("dRmVN", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", () => $a172034355d26ef7$export$da4704525c20ae79);
parcelRequire("8KVVB");
var $1l3DN = parcelRequire("1l3DN");
var $a172034355d26ef7$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $a172034355d26ef7$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $a172034355d26ef7$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $1l3DN.getOriginalFunction)(this) || this;
            return $a172034355d26ef7$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("7TVcb", function(module, exports) {

$parcel$export(module.exports, "InboundFilters", () => $5c0a0947fc55720e$export$2ffbb5359dcc6be4);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $jyUiA = parcelRequire("jyUiA");
var $jOwKr = parcelRequire("jOwKr");
var $4geCF = parcelRequire("4geCF");

var $aEGcl = parcelRequire("aEGcl");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $5c0a0947fc55720e$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $5c0a0947fc55720e$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $5c0a0947fc55720e$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $5c0a0947fc55720e$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $5c0a0947fc55720e$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $3VFsf.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $3VFsf.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $3VFsf.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $5c0a0947fc55720e$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $5c0a0947fc55720e$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $5c0a0947fc55720e$var$_isSentryError(event)) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $jyUiA.getEventDescription)(event));
        return true;
    }
    if ($5c0a0947fc55720e$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $jyUiA.getEventDescription)(event));
        return true;
    }
    if ($5c0a0947fc55720e$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $jyUiA.getEventDescription)(event) + ".\nUrl: " + $5c0a0947fc55720e$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$5c0a0947fc55720e$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $jyUiA.getEventDescription)(event) + ".\nUrl: " + $5c0a0947fc55720e$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $5c0a0947fc55720e$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $5c0a0947fc55720e$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $jOwKr.isMatchingPattern)(message, pattern);
        });
    });
}
function $5c0a0947fc55720e$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $5c0a0947fc55720e$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $jOwKr.isMatchingPattern)(url, pattern);
    });
}
function $5c0a0947fc55720e$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $5c0a0947fc55720e$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $jOwKr.isMatchingPattern)(url, pattern);
    });
}
function $5c0a0947fc55720e$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error("Cannot extract message for event " + (0, $jyUiA.getEventDescription)(event));
        return [];
    }
    return [];
}
function $5c0a0947fc55720e$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $5c0a0947fc55720e$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $5c0a0947fc55720e$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $5c0a0947fc55720e$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $5c0a0947fc55720e$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error("Cannot extract url for event " + (0, $jyUiA.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("3pmgQ", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", () => $27b4fb6362ae1f2a$export$1df9218a526d318d);

var $3VFsf = parcelRequire("3VFsf");

var $4mR0v = parcelRequire("4mR0v");
var $f1FVh = parcelRequire("f1FVh");
parcelRequire("8KVVB");
var $35A7f = parcelRequire("35A7f");
var $4geCF = parcelRequire("4geCF");

var $7bB5K = parcelRequire("7bB5K");

var $l97zN = parcelRequire("l97zN");

var $9aSEL = parcelRequire("9aSEL");

var $5Z1NC = parcelRequire("5Z1NC");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $27b4fb6362ae1f2a$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $f1FVh.SDK_VERSION)
                }
            ],
            version: (0, $f1FVh.SDK_VERSION)
        };
        _this = _super.call(this, (0, $7bB5K.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $35A7f.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $9aSEL.injectReportDialog)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $5Z1NC.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $4mR0v.BaseClient));

});
parcelRegister("4mR0v", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $32e2559d400632fa$export$4f22f74eddb7716a);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
parcelRequire("8KVVB");
var $jyUiA = parcelRequire("jyUiA");
var $eHWqV = parcelRequire("eHWqV");
var $gkmq5 = parcelRequire("gkmq5");
var $4geCF = parcelRequire("4geCF");
var $gSiM6 = parcelRequire("gSiM6");
var $2mY5H = parcelRequire("2mY5H");
var $3X7U8 = parcelRequire("3X7U8");
var $b17Q6 = parcelRequire("b17Q6");
var $jOwKr = parcelRequire("jOwKr");

var $aEGcl = parcelRequire("aEGcl");

var $6WKyI = parcelRequire("6WKyI");
var $32e2559d400632fa$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $32e2559d400632fa$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $gSiM6.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $jyUiA.checkOrSetAlreadyCaught)(exception)) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).log($32e2559d400632fa$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $gkmq5.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $jyUiA.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).log($32e2559d400632fa$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $6WKyI.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $3VFsf.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $3X7U8.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $jyUiA.uuid4)()),
            timestamp: event.timestamp || (0, $eHWqV.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $gfYRq.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $3X7U8.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $2mY5H.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, b), b.data && {
                    data: (0, $2mY5H.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $2mY5H.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $2mY5H.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $2mY5H.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $jOwKr.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $jOwKr.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $jOwKr.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $3VFsf.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $3X7U8.rejectedSyncPromise)(new (0, $b17Q6.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $3X7U8.rejectedSyncPromise)(new (0, $b17Q6.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $b17Q6.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $32e2559d400632fa$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $b17Q6.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $b17Q6.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $b17Q6.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $32e2559d400632fa$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $gkmq5.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $gkmq5.isPlainObject)(event) || event === null)) throw new (0, $b17Q6.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $b17Q6.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $gkmq5.isPlainObject)(rv) || rv === null)) throw new (0, $b17Q6.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("6WKyI", function(module, exports) {

$parcel$export(module.exports, "setupIntegrations", () => $50ec467f037cb5b6$export$51abed9797baa598);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
var $3kk8J = parcelRequire("3kk8J");
parcelRequire("8KVVB");
var $1l3DN = parcelRequire("1l3DN");
var $4geCF = parcelRequire("4geCF");

var $aEGcl = parcelRequire("aEGcl");
var $50ec467f037cb5b6$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $50ec467f037cb5b6$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $50ec467f037cb5b6$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $3VFsf.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $3VFsf.__spread)($50ec467f037cb5b6$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $3VFsf.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $50ec467f037cb5b6$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $3VFsf.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $50ec467f037cb5b6$export$e7390a03b70a6f2f(integration) {
    if ($50ec467f037cb5b6$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $gfYRq.addGlobalEventProcessor), (0, $3kk8J.getCurrentHub));
    $50ec467f037cb5b6$export$b14a8888f80a0b3e.push(integration.name);
    (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).log("Integration installed: " + integration.name);
}
function $50ec467f037cb5b6$export$51abed9797baa598(options) {
    var integrations = {};
    $50ec467f037cb5b6$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $50ec467f037cb5b6$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $1l3DN.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("f1FVh", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $af0778001337a981$export$31499a9cd224b78c);
var $af0778001337a981$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("7bB5K", function(module, exports) {

$parcel$export(module.exports, "BrowserBackend", () => $53b6551be133373f$export$2526e21aec9d0ce7);

var $3VFsf = parcelRequire("3VFsf");

var $hNPWg = parcelRequire("hNPWg");
var $eo4PV = parcelRequire("eo4PV");

var $4aybe = parcelRequire("4aybe");
parcelRequire("8KVVB");
var $ci1rH = parcelRequire("ci1rH");

var $j0O65 = parcelRequire("j0O65");

var $dPxoy = parcelRequire("dPxoy");
var $j0yJv = parcelRequire("j0yJv");
var $9FggM = parcelRequire("9FggM");
var $li9k9 = parcelRequire("li9k9");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $53b6551be133373f$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $j0O65.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $4aybe.Severity).Info;
        return (0, $j0O65.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $eo4PV.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $eo4PV.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $ci1rH.supportsFetch)()) {
            var requestOptions = (0, $3VFsf.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $j0yJv.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $dPxoy.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $9FggM.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $li9k9.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $hNPWg.BaseBackend));

});
parcelRegister("hNPWg", function(module, exports) {

$parcel$export(module.exports, "BaseBackend", () => $cf5f4d389fcdf9b4$export$8f43a53a38d7e95f);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $4geCF = parcelRequire("4geCF");
var $b17Q6 = parcelRequire("b17Q6");

var $eo4PV = parcelRequire("eo4PV");

var $aEGcl = parcelRequire("aEGcl");

var $74I1Q = parcelRequire("74I1Q");

var $bp300 = parcelRequire("bp300");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $cf5f4d389fcdf9b4$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $b17Q6.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $b17Q6.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $eo4PV.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $74I1Q.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $eo4PV.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $3VFsf.__read)((0, $74I1Q.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $bp300.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("eo4PV", function(module, exports) {

$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $a7970f0597e3bc77$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $a7970f0597e3bc77$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $a7970f0597e3bc77$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $a7970f0597e3bc77$export$671c7ed8e40a7a57);
parcelRequire("8KVVB");
var $gSiM6 = parcelRequire("gSiM6");
var $1l3DN = parcelRequire("1l3DN");
var $a7970f0597e3bc77$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $a7970f0597e3bc77$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $gSiM6.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $a7970f0597e3bc77$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $a7970f0597e3bc77$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $a7970f0597e3bc77$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $a7970f0597e3bc77$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $a7970f0597e3bc77$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $gSiM6.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $a7970f0597e3bc77$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $a7970f0597e3bc77$var$_getIngestEndpoint(dsn, target) {
    return "" + $a7970f0597e3bc77$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $a7970f0597e3bc77$var$_encodedAuth(dsn) {
    return (0, $1l3DN.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $a7970f0597e3bc77$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $a7970f0597e3bc77$var$getStoreEndpoint(dsn) {
    return $a7970f0597e3bc77$var$_getIngestEndpoint(dsn, 'store');
}
function $a7970f0597e3bc77$export$c1677e22ac2217a5(dsn) {
    return $a7970f0597e3bc77$var$getStoreEndpoint(dsn) + "?" + $a7970f0597e3bc77$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $a7970f0597e3bc77$var$_getEnvelopeEndpoint(dsn) {
    return $a7970f0597e3bc77$var$_getIngestEndpoint(dsn, 'envelope');
}
function $a7970f0597e3bc77$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $a7970f0597e3bc77$var$_getEnvelopeEndpoint(dsn) + "?" + $a7970f0597e3bc77$var$_encodedAuth(dsn);
}
function $a7970f0597e3bc77$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $a7970f0597e3bc77$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $a7970f0597e3bc77$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $gSiM6.makeDsn)(dsnLike);
    var endpoint = $a7970f0597e3bc77$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $gSiM6.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("74I1Q", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", () => $526b0f525f112293$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $526b0f525f112293$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $526b0f525f112293$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $526b0f525f112293$export$2006389de558b996);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $e1x9C = parcelRequire("e1x9C");
var $gSiM6 = parcelRequire("gSiM6");
var $2mY5H = parcelRequire("2mY5H");

var $eo4PV = parcelRequire("eo4PV");
/** Extract sdk info from from the API metadata */ function $526b0f525f112293$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $526b0f525f112293$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $3VFsf.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $3VFsf.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $526b0f525f112293$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $526b0f525f112293$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $gSiM6.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $e1x9C.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $526b0f525f112293$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $3VFsf.__read)($526b0f525f112293$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $e1x9C.serializeEnvelope)(envelope),
        type: type,
        url: (0, $eo4PV.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $526b0f525f112293$export$c31057337a18010f(event, api) {
    var sdkInfo = $526b0f525f112293$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $526b0f525f112293$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $gSiM6.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $e1x9C.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $526b0f525f112293$export$2006389de558b996(event, api) {
    var sdkInfo = $526b0f525f112293$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $526b0f525f112293$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $2mY5H.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $eo4PV.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $eo4PV.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $gSiM6.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $e1x9C.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $e1x9C.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("bp300", function(module, exports) {

$parcel$export(module.exports, "NoopTransport", () => $84d45b1428dd62f9$export$6f2767450ea1346c);
parcelRequire("8KVVB");
var $3X7U8 = parcelRequire("3X7U8");
/** Noop transport */ var $84d45b1428dd62f9$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $3X7U8.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $3X7U8.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("j0O65", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $dd74e0aea3b95fc8$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $dd74e0aea3b95fc8$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $dd74e0aea3b95fc8$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $dd74e0aea3b95fc8$export$5425b53185d13d6c);

var $3VFsf = parcelRequire("3VFsf");

var $4aybe = parcelRequire("4aybe");
parcelRequire("8KVVB");
var $jyUiA = parcelRequire("jyUiA");
var $aNkwr = parcelRequire("aNkwr");
var $1l3DN = parcelRequire("1l3DN");
var $gkmq5 = parcelRequire("gkmq5");
var $2mY5H = parcelRequire("2mY5H");
var $3X7U8 = parcelRequire("3X7U8");

var $kwRAs = parcelRequire("kwRAs");
function $dd74e0aea3b95fc8$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $dd74e0aea3b95fc8$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $dd74e0aea3b95fc8$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $dd74e0aea3b95fc8$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $gkmq5.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $1l3DN.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $2mY5H.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $dd74e0aea3b95fc8$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $dd74e0aea3b95fc8$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $dd74e0aea3b95fc8$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $dd74e0aea3b95fc8$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $dd74e0aea3b95fc8$var$getPopSize(ex);
    try {
        return (0, $aNkwr.createStackParser)((0, $kwRAs.opera10StackParser), (0, $kwRAs.opera11StackParser), (0, $kwRAs.chromeStackParser), (0, $kwRAs.winjsStackParser), (0, $kwRAs.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $dd74e0aea3b95fc8$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $dd74e0aea3b95fc8$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($dd74e0aea3b95fc8$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $dd74e0aea3b95fc8$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $dd74e0aea3b95fc8$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $dd74e0aea3b95fc8$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $jyUiA.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $4aybe.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3X7U8.resolvedSyncPromise)(event);
}
function $dd74e0aea3b95fc8$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $4aybe.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $dd74e0aea3b95fc8$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3X7U8.resolvedSyncPromise)(event);
}
function $dd74e0aea3b95fc8$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $gkmq5.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $dd74e0aea3b95fc8$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $gkmq5.isDOMError)(exception) || (0, $gkmq5.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $dd74e0aea3b95fc8$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $gkmq5.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $dd74e0aea3b95fc8$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $jyUiA.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $gkmq5.isError)(exception)) // we have a real Error object, do nothing
    return $dd74e0aea3b95fc8$export$73fbea5a0a5234af(exception);
    if ((0, $gkmq5.isPlainObject)(exception) || (0, $gkmq5.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $dd74e0aea3b95fc8$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $jyUiA.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $dd74e0aea3b95fc8$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $jyUiA.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $jyUiA.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $dd74e0aea3b95fc8$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $dd74e0aea3b95fc8$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("kwRAs", function(module, exports) {

$parcel$export(module.exports, "chromeStackParser", () => $ef205d17f92bb38b$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $ef205d17f92bb38b$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $ef205d17f92bb38b$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $ef205d17f92bb38b$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $ef205d17f92bb38b$export$989a1824b4734ce6);

var $3VFsf = parcelRequire("3VFsf");
// global reference to slice
var $ef205d17f92bb38b$var$UNKNOWN_FUNCTION = '?';
var $ef205d17f92bb38b$var$OPERA10_PRIORITY = 10;
var $ef205d17f92bb38b$var$OPERA11_PRIORITY = 20;
var $ef205d17f92bb38b$var$CHROME_PRIORITY = 30;
var $ef205d17f92bb38b$var$WINJS_PRIORITY = 40;
var $ef205d17f92bb38b$var$GECKO_PRIORITY = 50;
function $ef205d17f92bb38b$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $ef205d17f92bb38b$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $ef205d17f92bb38b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $ef205d17f92bb38b$var$chrome = function(line) {
    var parts = $ef205d17f92bb38b$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $ef205d17f92bb38b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $3VFsf.__read)($ef205d17f92bb38b$var$extractSafariExtensionDetails(parts[1] || $ef205d17f92bb38b$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $ef205d17f92bb38b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $ef205d17f92bb38b$export$c693d9295441d8f9 = [
    $ef205d17f92bb38b$var$CHROME_PRIORITY,
    $ef205d17f92bb38b$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $ef205d17f92bb38b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $ef205d17f92bb38b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $ef205d17f92bb38b$var$gecko = function(line) {
    var _a;
    var parts = $ef205d17f92bb38b$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $ef205d17f92bb38b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $ef205d17f92bb38b$var$UNKNOWN_FUNCTION;
        _a = (0, $3VFsf.__read)($ef205d17f92bb38b$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $ef205d17f92bb38b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $ef205d17f92bb38b$export$c9ddf1e2b5d48bff = [
    $ef205d17f92bb38b$var$GECKO_PRIORITY,
    $ef205d17f92bb38b$var$gecko
];
var $ef205d17f92bb38b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $ef205d17f92bb38b$var$winjs = function(line) {
    var parts = $ef205d17f92bb38b$var$winjsRegex.exec(line);
    return parts ? $ef205d17f92bb38b$var$createFrame(parts[2], parts[1] || $ef205d17f92bb38b$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $ef205d17f92bb38b$export$b6d155d85c1dcba5 = [
    $ef205d17f92bb38b$var$WINJS_PRIORITY,
    $ef205d17f92bb38b$var$winjs
];
var $ef205d17f92bb38b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $ef205d17f92bb38b$var$opera10 = function(line) {
    var parts = $ef205d17f92bb38b$var$opera10Regex.exec(line);
    return parts ? $ef205d17f92bb38b$var$createFrame(parts[2], parts[3] || $ef205d17f92bb38b$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $ef205d17f92bb38b$export$966ec832d9699d6 = [
    $ef205d17f92bb38b$var$OPERA10_PRIORITY,
    $ef205d17f92bb38b$var$opera10
];
var $ef205d17f92bb38b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $ef205d17f92bb38b$var$opera11 = function(line) {
    var parts = $ef205d17f92bb38b$var$opera11Regex.exec(line);
    return parts ? $ef205d17f92bb38b$var$createFrame(parts[5], parts[3] || parts[4] || $ef205d17f92bb38b$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $ef205d17f92bb38b$export$989a1824b4734ce6 = [
    $ef205d17f92bb38b$var$OPERA11_PRIORITY,
    $ef205d17f92bb38b$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $ef205d17f92bb38b$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $ef205d17f92bb38b$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("dPxoy", function(module, exports) {

$parcel$export(module.exports, "FetchTransport", () => $a119f15ae89a1689$export$2bdee3f9b92f4e82);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $b17Q6 = parcelRequire("b17Q6");
var $ci1rH = parcelRequire("ci1rH");
var $3X7U8 = parcelRequire("3X7U8");

var $hZuUW = parcelRequire("hZuUW");

var $4pdWf = parcelRequire("4pdWf");
/** `fetch` based transport */ var $a119f15ae89a1689$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $4pdWf.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $ci1rH.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $3X7U8.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $b17Q6.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $hZuUW.BaseTransport));

});
parcelRegister("hZuUW", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", () => $d1901dbbc4f5b26b$export$74b99d619e90f481);

var $3VFsf = parcelRequire("3VFsf");

var $74I1Q = parcelRequire("74I1Q");
var $eo4PV = parcelRequire("eo4PV");
parcelRequire("8KVVB");
var $jk0Xn = parcelRequire("jk0Xn");
var $2rF5w = parcelRequire("2rF5w");
var $gSiM6 = parcelRequire("gSiM6");
var $aGIlP = parcelRequire("aGIlP");
var $35A7f = parcelRequire("35A7f");
var $4geCF = parcelRequire("4geCF");
var $9aaXP = parcelRequire("9aaXP");
var $e1x9C = parcelRequire("e1x9C");

var $l97zN = parcelRequire("l97zN");

var $4pdWf = parcelRequire("4pdWf");
function $d1901dbbc4f5b26b$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $d1901dbbc4f5b26b$var$global = (0, $35A7f.getGlobalObject)();
/** Base Transport class implementation */ var $d1901dbbc4f5b26b$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $9aaXP.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $eo4PV.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $eo4PV.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $d1901dbbc4f5b26b$var$global.document) $d1901dbbc4f5b26b$var$global.document.addEventListener('visibilitychange', function() {
            if ($d1901dbbc4f5b26b$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $74I1Q.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $74I1Q.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $d1901dbbc4f5b26b$var$requestTypeToCategory(category) + ":" + reason;
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).log('No outcomes to flush');
            return;
        }
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $eo4PV.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $3VFsf.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $jk0Xn.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $gSiM6.dsnToString)(this._api.dsn));
        try {
            (0, $4pdWf.sendReport)(url, (0, $e1x9C.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $aGIlP.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $2rF5w.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $l97zN.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $4geCF.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $d1901dbbc4f5b26b$var$requestTypeToCategory(requestType);
        return new Date((0, $2rF5w.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $d1901dbbc4f5b26b$var$requestTypeToCategory(requestType);
        return (0, $2rF5w.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("l97zN", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $f65050bba670d163$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $f65050bba670d163$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("4pdWf", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", () => $33544f207336afe5$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $33544f207336afe5$export$84bb63b2c17ec44d);
parcelRequire("8KVVB");
var $dYkdu = parcelRequire("dYkdu");
var $35A7f = parcelRequire("35A7f");
var $ci1rH = parcelRequire("ci1rH");
var $4geCF = parcelRequire("4geCF");

var $l97zN = parcelRequire("l97zN");
var $33544f207336afe5$var$global = (0, $35A7f.getGlobalObject)();
var $33544f207336afe5$var$cachedFetchImpl;
function $33544f207336afe5$export$8be2119ce08e3379() {
    if ($33544f207336afe5$var$cachedFetchImpl) return $33544f207336afe5$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $ci1rH.isNativeFetch)($33544f207336afe5$var$global.fetch)) return $33544f207336afe5$var$cachedFetchImpl = $33544f207336afe5$var$global.fetch.bind($33544f207336afe5$var$global);
    var document = $33544f207336afe5$var$global.document;
    var fetchImpl = $33544f207336afe5$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $33544f207336afe5$var$cachedFetchImpl = fetchImpl.bind($33544f207336afe5$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $33544f207336afe5$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($33544f207336afe5$var$global && $33544f207336afe5$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $33544f207336afe5$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $33544f207336afe5$var$global.navigator.sendBeacon.bind($33544f207336afe5$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $ci1rH.supportsFetch)()) {
        var fetch_1 = $33544f207336afe5$export$8be2119ce08e3379();
        return (0, $dYkdu.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("j0yJv", function(module, exports) {

$parcel$export(module.exports, "makeNewFetchTransport", () => $dd68f5a63b9639f9$export$1c57e6bfd09bad13);

var $3VFsf = parcelRequire("3VFsf");

var $l15lu = parcelRequire("l15lu");

var $4pdWf = parcelRequire("4pdWf");
function $dd68f5a63b9639f9$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $4pdWf.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $3VFsf.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $l15lu.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("l15lu", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $f4cdd67afa492495$export$d09f50d9ab7f7b69);
parcelRequire("8KVVB");
var $2rF5w = parcelRequire("2rF5w");
var $aGIlP = parcelRequire("aGIlP");
var $e1x9C = parcelRequire("e1x9C");
var $9aaXP = parcelRequire("9aaXP");
var $3X7U8 = parcelRequire("3X7U8");
var $f4cdd67afa492495$export$d8a725a7dce95622 = 'error';
var $f4cdd67afa492495$export$99adc6fe67a3c63e = 'transaction';
var $f4cdd67afa492495$export$9d7ad34f132fe68f = 'attachment';
var $f4cdd67afa492495$export$42d9e7b5fc564c45 = 'session';
var $f4cdd67afa492495$export$e515cf6dfd2f98b8 = 30;
function $f4cdd67afa492495$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $9aaXP.makePromiseBuffer)(options.bufferSize || $f4cdd67afa492495$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $e1x9C.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $e1x9C.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $2rF5w.isRateLimited)(rateLimits, category)) return (0, $3X7U8.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $f4cdd67afa492495$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $aGIlP.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $2rF5w.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $3X7U8.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $3X7U8.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $f4cdd67afa492495$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $f4cdd67afa492495$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $2rF5w.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("9FggM", function(module, exports) {

$parcel$export(module.exports, "makeNewXHRTransport", () => $709490302946f0a5$export$4c0ac1dd4bbf4921);

var $l15lu = parcelRequire("l15lu");
parcelRequire("8KVVB");
var $3X7U8 = parcelRequire("3X7U8");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $709490302946f0a5$var$XHR_READYSTATE_DONE = 4;
function $709490302946f0a5$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $3X7U8.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $709490302946f0a5$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $l15lu.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("li9k9", function(module, exports) {

$parcel$export(module.exports, "XHRTransport", () => $f80282f2edc4209e$export$874a283af77e8e62);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $b17Q6 = parcelRequire("b17Q6");
var $3X7U8 = parcelRequire("3X7U8");

var $hZuUW = parcelRequire("hZuUW");
/** `XHR` based transport */ var $f80282f2edc4209e$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $3X7U8.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $b17Q6.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $hZuUW.BaseTransport));

});


parcelRegister("9aSEL", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreOnError", () => $6adf71defd0a32ad$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $6adf71defd0a32ad$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $6adf71defd0a32ad$export$deb9aac8ea0b576c);

var $3VFsf = parcelRequire("3VFsf");

var $7zHWg = parcelRequire("7zHWg");
var $eo4PV = parcelRequire("eo4PV");
parcelRequire("8KVVB");
var $jyUiA = parcelRequire("jyUiA");
var $1l3DN = parcelRequire("1l3DN");
var $35A7f = parcelRequire("35A7f");
var $4geCF = parcelRequire("4geCF");

var $l97zN = parcelRequire("l97zN");
var $6adf71defd0a32ad$var$global = (0, $35A7f.getGlobalObject)();
var $6adf71defd0a32ad$var$ignoreOnError = 0;
function $6adf71defd0a32ad$export$b79738ab10c590b2() {
    return $6adf71defd0a32ad$var$ignoreOnError > 0;
}
function $6adf71defd0a32ad$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $6adf71defd0a32ad$var$ignoreOnError += 1;
    setTimeout(function() {
        $6adf71defd0a32ad$var$ignoreOnError -= 1;
    });
}
function $6adf71defd0a32ad$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $1l3DN.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $6adf71defd0a32ad$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $6adf71defd0a32ad$export$1265a142ff5ba165();
            (0, $7zHWg.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $jyUiA.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $jyUiA.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $7zHWg.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $1l3DN.markFunctionWrapped)(sentryWrapped, fn);
    (0, $1l3DN.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $6adf71defd0a32ad$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$6adf71defd0a32ad$var$global.document) return;
    if (!options.eventId) {
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $6adf71defd0a32ad$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $eo4PV.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $6adf71defd0a32ad$var$global.document.head || $6adf71defd0a32ad$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("5Z1NC", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $45b40b8d79a6890b$export$2dc68d50d56fbbd);

var $3VFsf = parcelRequire("3VFsf");

var $3kk8J = parcelRequire("3kk8J");

var $4aybe = parcelRequire("4aybe");
parcelRequire("8KVVB");
var $1sgxX = parcelRequire("1sgxX");
var $jyUiA = parcelRequire("jyUiA");
var $35A7f = parcelRequire("35A7f");
var $7yHR0 = parcelRequire("7yHR0");
var $jOwKr = parcelRequire("jOwKr");
var $n3F4l = parcelRequire("n3F4l");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $45b40b8d79a6890b$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $3VFsf.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $jyUiA.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $1sgxX.addInstrumentationHandler)('console', $45b40b8d79a6890b$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $1sgxX.addInstrumentationHandler)('dom', $45b40b8d79a6890b$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $1sgxX.addInstrumentationHandler)('xhr', $45b40b8d79a6890b$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $1sgxX.addInstrumentationHandler)('fetch', $45b40b8d79a6890b$var$_fetchBreadcrumb);
        if (this._options.history) (0, $1sgxX.addInstrumentationHandler)('history', $45b40b8d79a6890b$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $45b40b8d79a6890b$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $7yHR0.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $7yHR0.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $45b40b8d79a6890b$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $n3F4l.severityFromString)(handlerData.level),
        message: (0, $jOwKr.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $jOwKr.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $3kk8J.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $45b40b8d79a6890b$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $45b40b8d79a6890b$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $4aybe.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $45b40b8d79a6890b$var$_historyBreadcrumb(handlerData) {
    var global = (0, $35A7f.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $jyUiA.parseUrl)(global.location.href);
    var parsedFrom = (0, $jyUiA.parseUrl)(from);
    var parsedTo = (0, $jyUiA.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("ilDeH", function(module, exports) {

$parcel$export(module.exports, "Dedupe", () => $d5b89f9e1dbfa430$export$688d98c249d31ad3);
parcelRequire("8KVVB");
var $4geCF = parcelRequire("4geCF");

var $l97zN = parcelRequire("l97zN");
/** Deduplication filter */ var $d5b89f9e1dbfa430$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($d5b89f9e1dbfa430$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $d5b89f9e1dbfa430$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($d5b89f9e1dbfa430$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($d5b89f9e1dbfa430$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$d5b89f9e1dbfa430$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$d5b89f9e1dbfa430$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $d5b89f9e1dbfa430$var$_getExceptionFromEvent(previousEvent);
    var currentException = $d5b89f9e1dbfa430$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$d5b89f9e1dbfa430$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$d5b89f9e1dbfa430$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $d5b89f9e1dbfa430$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $d5b89f9e1dbfa430$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("ijPmO", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", () => $d561d8bc9ed14bc0$export$204155decbc90e5a);

var $3VFsf = parcelRequire("3VFsf");

var $3kk8J = parcelRequire("3kk8J");

var $4aybe = parcelRequire("4aybe");
parcelRequire("8KVVB");
var $jyUiA = parcelRequire("jyUiA");
var $1sgxX = parcelRequire("1sgxX");
var $7yHR0 = parcelRequire("7yHR0");
var $gkmq5 = parcelRequire("gkmq5");
var $4geCF = parcelRequire("4geCF");

var $j0O65 = parcelRequire("j0O65");

var $l97zN = parcelRequire("l97zN");

var $9aSEL = parcelRequire("9aSEL");
/** Global handlers */ var $d561d8bc9ed14bc0$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $d561d8bc9ed14bc0$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $d561d8bc9ed14bc0$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $3VFsf.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $d561d8bc9ed14bc0$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $d561d8bc9ed14bc0$var$_installGlobalOnErrorHandler() {
    (0, $1sgxX.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $3VFsf.__read)($d561d8bc9ed14bc0$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($d561d8bc9ed14bc0$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $9aSEL.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $gkmq5.isString)(msg) ? $d561d8bc9ed14bc0$var$_eventFromIncompleteOnError(msg, url, line, column) : $d561d8bc9ed14bc0$var$_enhanceEventWithInitialFrame((0, $j0O65.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $4aybe.Severity).Error;
        $d561d8bc9ed14bc0$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $d561d8bc9ed14bc0$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $1sgxX.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $3VFsf.__read)($d561d8bc9ed14bc0$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($d561d8bc9ed14bc0$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $9aSEL.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $gkmq5.isPrimitive)(error) ? $d561d8bc9ed14bc0$var$_eventFromRejectionWithPrimitive(error) : (0, $j0O65.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $4aybe.Severity).Error;
        $d561d8bc9ed14bc0$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $d561d8bc9ed14bc0$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d561d8bc9ed14bc0$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $gkmq5.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $d561d8bc9ed14bc0$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d561d8bc9ed14bc0$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $gkmq5.isString)(url) && url.length > 0 ? url : (0, $7yHR0.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $d561d8bc9ed14bc0$var$globalHandlerLog(type) {
    (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).log("Global Handler attached: " + type);
}
function $d561d8bc9ed14bc0$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $jyUiA.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $d561d8bc9ed14bc0$var$getHubAndAttachStacktrace() {
    var hub = (0, $3kk8J.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("5zMCv", function(module, exports) {

$parcel$export(module.exports, "LinkedErrors", () => $40f5ef8f867e83cc$export$8d1e60aaf616fb4f);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
var $3kk8J = parcelRequire("3kk8J");
parcelRequire("8KVVB");
var $gkmq5 = parcelRequire("gkmq5");

var $j0O65 = parcelRequire("j0O65");
var $40f5ef8f867e83cc$var$DEFAULT_KEY = 'cause';
var $40f5ef8f867e83cc$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $40f5ef8f867e83cc$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $40f5ef8f867e83cc$var$DEFAULT_KEY;
        this._limit = options.limit || $40f5ef8f867e83cc$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $gfYRq.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $3kk8J.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $40f5ef8f867e83cc$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $40f5ef8f867e83cc$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $gkmq5.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $40f5ef8f867e83cc$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $3VFsf.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $40f5ef8f867e83cc$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $gkmq5.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $j0O65.exceptionFromError)(error[key]);
    return $40f5ef8f867e83cc$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $3VFsf.__spread)([
        exception
    ], stack));
}

});

parcelRegister("4EoaR", function(module, exports) {

$parcel$export(module.exports, "TryCatch", () => $362da65422a63562$export$f1a018517668e6d3);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $1l3DN = parcelRequire("1l3DN");
var $aNkwr = parcelRequire("aNkwr");
var $35A7f = parcelRequire("35A7f");

var $9aSEL = parcelRequire("9aSEL");
var $362da65422a63562$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $362da65422a63562$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $3VFsf.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $35A7f.getGlobalObject)();
        if (this._options.setTimeout) (0, $1l3DN.fill)(global, 'setTimeout', $362da65422a63562$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $1l3DN.fill)(global, 'setInterval', $362da65422a63562$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $1l3DN.fill)(global, 'requestAnimationFrame', $362da65422a63562$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $1l3DN.fill)(XMLHttpRequest.prototype, 'send', $362da65422a63562$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $362da65422a63562$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($362da65422a63562$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $362da65422a63562$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $9aSEL.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $aNkwr.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $362da65422a63562$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $9aSEL.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $aNkwr.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $362da65422a63562$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $1l3DN.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $aNkwr.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $1l3DN.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $aNkwr.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $9aSEL.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $362da65422a63562$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $35A7f.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $1l3DN.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $9aSEL.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $aNkwr.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $9aSEL.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $aNkwr.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $1l3DN.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("lKe3d", function(module, exports) {

$parcel$export(module.exports, "UserAgent", () => $fd48cb0c99c1602c$export$5fba5e10934a4faf);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
var $3kk8J = parcelRequire("3kk8J");
parcelRequire("8KVVB");
var $35A7f = parcelRequire("35A7f");
var $fd48cb0c99c1602c$var$global = (0, $35A7f.getGlobalObject)();
/** UserAgent */ var $fd48cb0c99c1602c$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $gfYRq.addGlobalEventProcessor)(function(event) {
            if ((0, $3kk8J.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$fd48cb0c99c1602c$var$global.navigator && !$fd48cb0c99c1602c$var$global.location && !$fd48cb0c99c1602c$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $fd48cb0c99c1602c$var$global.location && $fd48cb0c99c1602c$var$global.location.href;
                var referrer = ($fd48cb0c99c1602c$var$global.document || {}).referrer;
                var userAgent = ($fd48cb0c99c1602c$var$global.navigator || {}).userAgent;
                var headers = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("ehYmi", function(module, exports) {

$parcel$export(module.exports, "CaptureConsole", () => $a6717928cd5d30a0$export$25a43cb5b5c58c08);
parcelRequire("8KVVB");
var $4geCF = parcelRequire("4geCF");
var $1l3DN = parcelRequire("1l3DN");
var $35A7f = parcelRequire("35A7f");
var $jOwKr = parcelRequire("jOwKr");
var $n3F4l = parcelRequire("n3F4l");
var $a6717928cd5d30a0$var$global = (0, $35A7f.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $a6717928cd5d30a0$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $4geCF.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $a6717928cd5d30a0$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $a6717928cd5d30a0$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $1l3DN.fill)($a6717928cd5d30a0$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $n3F4l.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $jOwKr.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $jOwKr.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($a6717928cd5d30a0$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();

});

parcelRegister("lt9kQ", function(module, exports) {

$parcel$export(module.exports, "Dedupe", () => $fa138c2da26103f3$export$688d98c249d31ad3);
parcelRequire("8KVVB");
var $4geCF = parcelRequire("4geCF");

var $gVBdk = parcelRequire("gVBdk");
/** Deduplication filter */ var $fa138c2da26103f3$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($fa138c2da26103f3$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $gVBdk.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $fa138c2da26103f3$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($fa138c2da26103f3$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($fa138c2da26103f3$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $fa138c2da26103f3$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$fa138c2da26103f3$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fa138c2da26103f3$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $fa138c2da26103f3$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $fa138c2da26103f3$var$_getExceptionFromEvent(previousEvent);
    var currentException = $fa138c2da26103f3$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$fa138c2da26103f3$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fa138c2da26103f3$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $fa138c2da26103f3$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $fa138c2da26103f3$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $fa138c2da26103f3$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $fa138c2da26103f3$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $fa138c2da26103f3$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $fa138c2da26103f3$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});
parcelRegister("gVBdk", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $c52ed61e693d7b9c$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $c52ed61e693d7b9c$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("kBLvL", function(module, exports) {

$parcel$export(module.exports, "ExtraErrorData", () => $f00c1e1a00938139$export$56d961ef3a52a072);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $gkmq5 = parcelRequire("gkmq5");
var $4geCF = parcelRequire("4geCF");
var $2mY5H = parcelRequire("2mY5H");

var $gVBdk = parcelRequire("gVBdk");
/** Patch toString calls to return proper name for wrapped functions */ var $f00c1e1a00938139$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $3VFsf.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $gkmq5.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $3VFsf.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $2mY5H.normalize)(errorData, this._options.depth);
            if ((0, $gkmq5.isPlainObject)(normalizedErrorData)) contexts = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $3VFsf.__assign)({}, normalizedErrorData), _a));
            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $3VFsf.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $gkmq5.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $3VFsf.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $gkmq5.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $gVBdk.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();

});

parcelRegister("50FPh", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $3a5d659acff7091e$export$febc5573c75cefb0);
/** Add node transaction to the event */ var $3a5d659acff7091e$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();

});



parcelRegister("bajNy", function(module, exports) {

$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => $d5c5a4f71e96ff9b$export$d4079397f9611138);
$parcel$export(module.exports, "default", () => $d5c5a4f71e96ff9b$export$2e2bcd8739ae039);

var $gccSB = parcelRequire("gccSB");

var $9xWGk = parcelRequire("9xWGk");

var $kCVub = parcelRequire("kCVub");
var $h8yj2 = parcelRequire("h8yj2");

var $9ZBi7 = parcelRequire("9ZBi7");
let $d5c5a4f71e96ff9b$var$analyticsClient;
const $d5c5a4f71e96ff9b$export$d4079397f9611138 = (client)=>{
    $d5c5a4f71e96ff9b$var$analyticsClient = client;
};
const $d5c5a4f71e96ff9b$export$bf406c01a195b215 = ()=>{
    $d5c5a4f71e96ff9b$var$analyticsClient = undefined;
};
const $d5c5a4f71e96ff9b$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (false) {
        if (error) throw error;
        else {
            const payload = event && (0, $kCVub.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB))));
        if (event && event.context) {
            const fullEvent = (0, $kCVub.extractAWCDataFromEvent)(event);
            (0, $9ZBi7.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $9ZBi7.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $h8yj2.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($d5c5a4f71e96ff9b$var$analyticsClient && $d5c5a4f71e96ff9b$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $d5c5a4f71e96ff9b$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $9ZBi7.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $d5c5a4f71e96ff9b$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $d5c5a4f71e96ff9b$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $d5c5a4f71e96ff9b$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $d5c5a4f71e96ff9b$export$2e2bcd8739ae039 = $d5c5a4f71e96ff9b$var$fireErrorAnalytics;

});
parcelRegister("kCVub", function(module, exports) {

$parcel$export(module.exports, "extractAWCDataFromEvent", () => $d006147c8436533b$export$1c850cf68c053906);

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");


var $8HgKr = parcelRequire("8HgKr");
const $d006147c8436533b$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $8HgKr.getAnalyticsType)(castedEvent);
    const attributes = (0, $8HgKr.getAttributes)(castedEvent);
    const source = (0, $8HgKr.getSource)(castedEvent);
    const actionSubject = (0, $8HgKr.getActionSubject)(castedEvent);
    if (analyticsType === (0, $6e65040b988c460f$export$f1d537d508d2945a)) return {
        type: (0, $6e65040b988c460f$export$f1d537d508d2945a),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $6e65040b988c460f$export$a1562d08625f5d7e:
        case 0, $6e65040b988c460f$export$947dac6c72b26f81:
        case 0, $6e65040b988c460f$export$12346a674644c156:
            {
                const action = (0, $8HgKr.getAction)(castedEvent);
                const actionSubjectId = (0, $8HgKr.getActionSubjectId)(castedEvent);
                const containerId = (0, $8HgKr.getContainerId)(castedEvent);
                const containerType = (0, $8HgKr.getContainerType)(castedEvent);
                const objectId = (0, $8HgKr.getObjectId)(castedEvent);
                const objectType = (0, $8HgKr.getObjectType)(castedEvent);
                const tags = (0, $8HgKr.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("8HgKr", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsType", () => $6831e52439d2a9a2$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $6831e52439d2a9a2$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $6831e52439d2a9a2$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $6831e52439d2a9a2$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $6831e52439d2a9a2$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $6831e52439d2a9a2$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $6831e52439d2a9a2$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $6831e52439d2a9a2$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $6831e52439d2a9a2$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $6831e52439d2a9a2$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $6831e52439d2a9a2$export$af63d7414243dad3);

var $183uB = parcelRequire("183uB");

var $cjFoH = parcelRequire("cjFoH");

var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

var $9xWGk = parcelRequire("9xWGk");

var $kGsr8 = parcelRequire("kGsr8");
const $6831e52439d2a9a2$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $6831e52439d2a9a2$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $6831e52439d2a9a2$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $6831e52439d2a9a2$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $6831e52439d2a9a2$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};
const $6831e52439d2a9a2$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'source').filter(Boolean));
const $6831e52439d2a9a2$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $6831e52439d2a9a2$export$6ca3170acb89054 = (event)=>event.payload.action;
const $6831e52439d2a9a2$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $6831e52439d2a9a2$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'containerId').filter(Boolean));
const $6831e52439d2a9a2$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'containerType').filter(Boolean));
const $6831e52439d2a9a2$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'objectId').filter(Boolean));
const $6831e52439d2a9a2$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'objectType').filter(Boolean));
const $6831e52439d2a9a2$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))((0, (/*@__PURE__*/$parcel$interopDefault($183uB)))($6831e52439d2a9a2$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});


parcelRegister("h8yj2", function(module, exports) {

$parcel$export(module.exports, "fireAnalytics", () => $b264de6d6a035739$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $b264de6d6a035739$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $b264de6d6a035739$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $b264de6d6a035739$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $b264de6d6a035739$export$6f46fb37ad7d962b);

var $hYfgW = parcelRequire("hYfgW");


var $4zfLY = parcelRequire("4zfLY");
const $b264de6d6a035739$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $6e65040b988c460f$export$2ceccf177fae277c));
};
const $b264de6d6a035739$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $b264de6d6a035739$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $b264de6d6a035739$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$947dac6c72b26f81), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$12346a674644c156), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$f1d537d508d2945a), {
        attributes: attributes
    });
};

});
parcelRegister("4zfLY", function(module, exports) {

$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $ccaec2c661eabde7$export$e6baab532ef8c6bf);
const $ccaec2c661eabde7$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $ccaec2c661eabde7$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $ccaec2c661eabde7$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $ccaec2c661eabde7$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $ccaec2c661eabde7$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});



parcelRegister("kRBfD", function(module, exports) {

$parcel$export(module.exports, "default", () => $72219f5167e88013$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $bajNy = parcelRequire("bajNy");
class $72219f5167e88013$var$CatchAndReportErrors extends (0, $5uXOq.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $bajNy.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
}
var $72219f5167e88013$export$2e2bcd8739ae039 = (0, $cb25w.default)()($72219f5167e88013$var$CatchAndReportErrors);

});


parcelRegister("z11xo", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $df5192e881ed2750$export$e19f9f08a6d79fd2);

var $3HlI9 = parcelRequire("3HlI9");
const $df5192e881ed2750$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $df5192e881ed2750$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $df5192e881ed2750$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $df5192e881ed2750$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $df5192e881ed2750$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $df5192e881ed2750$export$89a175d4190df42e = 'Invoke value functions failed:';
const $df5192e881ed2750$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $df5192e881ed2750$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $df5192e881ed2750$var$BAD_REQUEST = 400;
const $df5192e881ed2750$var$REQUEST_TIMEOUT = 408;
const $df5192e881ed2750$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $df5192e881ed2750$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $df5192e881ed2750$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($df5192e881ed2750$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $df5192e881ed2750$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($df5192e881ed2750$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($df5192e881ed2750$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($df5192e881ed2750$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $3HlI9.isClientFetchError)(error)) return $df5192e881ed2750$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("3HlI9", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cbf82ad04131c769$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cbf82ad04131c769$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cbf82ad04131c769$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cbf82ad04131c769$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cbf82ad04131c769$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cbf82ad04131c769$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.cause.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("3OTqu", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $b8beb3418915829f$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $b8beb3418915829f$export$f0022a21ccd1f6be);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
const $b8beb3418915829f$var$VIEW_CONFIGURATIONS = new Map();
const $b8beb3418915829f$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$b8beb3418915829f$var$VIEW_CONFIGURATIONS.has(viewType)) $b8beb3418915829f$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $b8beb3418915829f$export$176b6e68da08ffa2 = (viewType)=>$b8beb3418915829f$var$VIEW_CONFIGURATIONS.get(viewType);
const $b8beb3418915829f$export$e8091eff40c4f16e = ()=>{
    $b8beb3418915829f$var$VIEW_CONFIGURATIONS.clear();
};
const $b8beb3418915829f$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gKZoD.di)($b8beb3418915829f$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $5uXOq.useState)(()=>{
        $b8beb3418915829f$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("8e24q", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $c1b779e01c06a231$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $c1b779e01c06a231$export$4a6b4707110b0552);

var $iLSUx = parcelRequire("iLSUx");
const $c1b779e01c06a231$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $c1b779e01c06a231$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("iLSUx", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $4854c3676fce92c1$export$50806045b617d116);

var $gKZoD = parcelRequire("gKZoD");

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $4854c3676fce92c1$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gKZoD.di)((0, $cmmj3.fireErrorAnalytics), (0, $gL80q.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $cmmj3.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});


parcelRegister("cTj8m", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $b87f070d69e40149$export$93459ad9bfd6c380);
const $b87f070d69e40149$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("i4uue", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $559bbe3e01414de7$export$7f7be235f64f029b);
const $559bbe3e01414de7$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("b8ZsE", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $926b03f8c2e312a1$export$352dfcce04d66748);

var $3ZT8o = parcelRequire("3ZT8o");

var $gKZoD = parcelRequire("gKZoD");

var $gL80q = parcelRequire("gL80q");

var $l6AQO = parcelRequire("l6AQO");
const $926b03f8c2e312a1$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType, fieldType: fieldType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o))));
        const emitChangeOn = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});

parcelRegister("l6AQO", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $2b658e9f553d1ad3$export$25441a03bb8f1cb0);

var $ajpes = parcelRequire("ajpes");

var $iLSUx = parcelRequire("iLSUx");
const $2b658e9f553d1ad3$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("jDMtG", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $5e78d8ed1ee13321$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $5e78d8ed1ee13321$export$1ca69a85bb7273de);

var $fr1K2 = parcelRequire("fr1K2");

var $kGsr8 = parcelRequire("kGsr8");
const $5e78d8ed1ee13321$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $5e78d8ed1ee13321$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("l0b2q", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $da1080104d423ca2$export$6556d46d2662453c);

var $l6AQO = parcelRequire("l6AQO");
const $da1080104d423ca2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("4MJXd", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $104b1b4dd763f6ee$export$21363496760d39cd);
const $104b1b4dd763f6ee$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("gHQFd", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $069ce0e12537855c$export$cceae62fd4d1ef0a);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $ajglJ = parcelRequire("ajglJ");

var $dA2NP = parcelRequire("dA2NP");

var $fKje4 = parcelRequire("fKje4");

var $dwG9p = parcelRequire("dwG9p");

var $dRfi6 = parcelRequire("dRfi6");

var $3whHg = parcelRequire("3whHg");

var $boEP0 = parcelRequire("boEP0");

var $hzAKL = parcelRequire("hzAKL");
const $069ce0e12537855c$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $boEP0.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $dA2NP.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $3whHg.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $80e7f3d73b333b84$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $80e7f3d73b333b84$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $80e7f3d73b333b84$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $hzAKL.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $dRfi6.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $fKje4.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, $ajglJ.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $dwG9p.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $boEP0.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $80e7f3d73b333b84$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $80e7f3d73b333b84$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $80e7f3d73b333b84$export$f5d5f6bb902f1027 = '-1';
const $80e7f3d73b333b84$export$106087dcfd4fb129 = 100;

parcelRegister("ajglJ", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $907938b0f57574ed$export$9e8b5e552e255163);

var $2jqAp = parcelRequire("2jqAp");
class $907938b0f57574ed$export$9e8b5e552e255163 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("2jqAp", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $b8ce6491bf34e535$export$6e8165c81a6a65df);
class $b8ce6491bf34e535$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("dA2NP", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b);
const $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("fKje4", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $620a721e65ec1dbe$export$460820f27643954e);

var $gL80q = parcelRequire("gL80q");
const $620a721e65ec1dbe$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("dwG9p", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $8d92968018d86237$export$e1fce51bc5be90b7);
const $8d92968018d86237$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("dRfi6", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $cc6b08557666e682$export$aa453854f74fab);

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $cc6b08557666e682$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("hzAKL", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $422557008e0dbc71$export$d14f85c01e334a1);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $7NDId = parcelRequire("7NDId");

var $gL80q = parcelRequire("gL80q");


var $bCvSM = parcelRequire("bCvSM");

var $2J6IF = parcelRequire("2J6IF");

var $hwDyF = parcelRequire("hwDyF");
const $422557008e0dbc71$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gKZoD.di)((0, $gL80q.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $2J6IF.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $2J6IF.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $7NDId.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $ca611ff348f89182$export$d1996cb46a690190),
                        method: (0, $bCvSM.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $hwDyF.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $hwDyF.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("7NDId", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $64626586c22c486e$export$73c2f0689b6c4a5a);
class $64626586c22c486e$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("2J6IF", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $5fbccb776f84792e$export$ee79e3ab53b8db79);
const $5fbccb776f84792e$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("hwDyF", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $e8aa8431ce8b786b$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $e8aa8431ce8b786b$export$ddd005554aecd409);
const $e8aa8431ce8b786b$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $e8aa8431ce8b786b$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("7JtDe", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $c6c7124cbfc0022b$export$131c67fd312b8a11);

var $gKZoD = parcelRequire("gKZoD");

var $iUvwD = parcelRequire("iUvwD");

var $50ech = parcelRequire("50ech");

var $boEP0 = parcelRequire("boEP0");

var $iiEdL = parcelRequire("iiEdL");
const $c6c7124cbfc0022b$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gKZoD.di)((0, $boEP0.collectScreenTabsAppliedChangesHistory), (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $iiEdL.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $iiEdL.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $boEP0.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $iUvwD.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $50ech.toScreenTabsValidationError))
        });
    };

});
parcelRegister("iUvwD", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $2febbf39fb2cebbc$export$faf1f1824ee0a136);

var $2jqAp = parcelRequire("2jqAp");
class $2febbf39fb2cebbc$export$faf1f1824ee0a136 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("50ech", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $32af3bb8fe161d39$export$b2675440ade984fb);

const $32af3bb8fe161d39$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $ca611ff348f89182$export$fd26696d109785a0)
    });

});

parcelRegister("iiEdL", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $5d43d6affeb19d8a$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $5d43d6affeb19d8a$export$62d63af83dac7315);
const $5d43d6affeb19d8a$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $5d43d6affeb19d8a$var$isValidScreenTabId = (internalScreenTabs, id)=>$5d43d6affeb19d8a$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $5d43d6affeb19d8a$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$5d43d6affeb19d8a$var$isValidScreenTabId(internalScreenTabs, id) && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && $5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive);
const $5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $5d43d6affeb19d8a$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$5d43d6affeb19d8a$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $5d43d6affeb19d8a$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});




parcelRegister("5eGnF", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $700db8c378cd19d9$export$876003a5b887f37e);
const $700db8c378cd19d9$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("9svjh", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $d9b2e43e4699b192$export$e3ff72f196296fcc);

var $1mrD8 = parcelRequire("1mrD8");
const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, $1mrD8.PubSubHub)();
const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
        ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
    });

});
parcelRegister("1mrD8", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


const $380826ec5efdda82$export$e615b7e9b8fb4715 = 'GIC';

parcelRegister("2eeg1", function(module, exports) {

$parcel$export(module.exports, "FieldValueDecoratorAsync", () => $58ac5136636efa9f$export$24545fc29fe55980);

var $5uXOq = parcelRequire("5uXOq");

var $gL80q = parcelRequire("gL80q");
var $jrwZp = parcelRequire("jrwZp");


var $62s0B = parcelRequire("62s0B");
const $58ac5136636efa9f$var$FieldValueDecoratorAsyncNoMemo = ({ children: children, fieldType: fieldType, fieldProps: fieldProps, fieldId: fieldId })=>{
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const undecoratedResult = children(fieldProps);
    if ((0, $gL80q.isFieldTypeSupported)((0, $380826ec5efdda82$export$e615b7e9b8fb4715), fieldType) && adjustmentsAreEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62s0B.EnabledFieldValueDecorator), {
        fieldProps: fieldProps,
        fieldId: fieldId,
        fieldType: fieldType
    }, children);
    return undecoratedResult;
};
const $58ac5136636efa9f$export$24545fc29fe55980 = /*#__PURE__*/ (0, $5uXOq.memo)($58ac5136636efa9f$var$FieldValueDecoratorAsyncNoMemo);

});
parcelRegister("jrwZp", function(module, exports) {

$parcel$export(module.exports, "store", () => $db4845f733e81d44$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $db4845f733e81d44$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $db4845f733e81d44$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $db4845f733e81d44$export$5eb9c167b683d125);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $db4845f733e81d44$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $db4845f733e81d44$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($db4845f733e81d44$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $db4845f733e81d44$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-adjustments-context',
    initialState: $db4845f733e81d44$var$initialState,
    actions: $db4845f733e81d44$export$e324594224ef24da
});
const $db4845f733e81d44$export$a12f82a132dee079 = (0, $3sQ5x.createHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$358ad850b2f6d6fe = (0, $3sQ5x.createStateHook)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $db4845f733e81d44$export$4f2729981f4b81d2 = (0, $3sQ5x.createActionsHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$5eb9c167b683d125 = (0, $gg7kZ.createContainer)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("62s0B", function(module, exports) {

$parcel$export(module.exports, "EnabledFieldValueDecorator", () => $f47b896eac91b738$export$9d96bb1f53295b76);

var $1YewZ = parcelRequire("1YewZ");

var $9QJ7Z = parcelRequire("9QJ7Z");
const $f47b896eac91b738$export$9d96bb1f53295b76 = ({ children: children, fieldId: fieldId, fieldType: fieldType, fieldProps: fieldProps })=>{
    const { onBlur: onBlur, onChange: onChange } = fieldProps;
    const { getFieldValue: getFieldValue } = (0, $9QJ7Z.useFormApi)();
    const { processChange: processChange } = (0, $1YewZ.useIssueAdjustmentsActions)();
    const processChangeByType = (eventType)=>{
        processChange({
            fieldId: fieldId,
            fieldValue: getFieldValue(fieldId),
            eventType: eventType,
            fieldType: fieldType
        });
    };
    const interceptedFieldProps = {
        ...fieldProps,
        onChange: (modifiedValue)=>{
            // Order is important to pass the current value to the UIM
            onChange(modifiedValue);
            processChangeByType('change');
        },
        onBlur: ()=>{
            // Order is important to pass the current value to the UIM
            onBlur();
            processChangeByType('blur');
        }
    };
    return children(interceptedFieldProps);
};

});
parcelRegister("9QJ7Z", function(module, exports) {

$parcel$export(module.exports, "FormApiProvider", () => $33387961dd1f98b9$export$1e7be89a21d0c0ae);
$parcel$export(module.exports, "useFormApi", () => $33387961dd1f98b9$export$4607062597b2b4df);

var $5uXOq = parcelRequire("5uXOq");
const $33387961dd1f98b9$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $33387961dd1f98b9$export$1e7be89a21d0c0ae = ({ children: children, setFieldValue: setFieldValue, getFormState: getFormState })=>{
    const setFieldValueRef = (0, $5uXOq.useRef)(setFieldValue);
    setFieldValueRef.current = setFieldValue;
    const getFormStateRef = (0, $5uXOq.useRef)(getFormState);
    getFormStateRef.current = getFormState;
    const value = (0, $5uXOq.useMemo)(()=>({
            setFieldValue: (...args)=>setFieldValueRef.current(...args),
            getFieldValue: (fieldId)=>getFormStateRef.current().values[fieldId]
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($33387961dd1f98b9$var$Context.Provider, {
        value: value
    }, children);
};
const $33387961dd1f98b9$export$4607062597b2b4df = ()=>{
    const context = (0, $5uXOq.useContext)($33387961dd1f98b9$var$Context);
    if (context === null) throw new Error('Missing FormApiProvider');
    return context;
};

});



parcelRegister("aBZin", function(module, exports) {

$parcel$export(module.exports, "getValueFromEventOrValue", () => $56aa95be299fa4e4$export$a59801673b41acfd);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $56aa95be299fa4e4$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $56aa95be299fa4e4$export$a59801673b41acfd(eventOrValue) {
    if ($56aa95be299fa4e4$var$isEvent(eventOrValue)) {
        const { currentTarget: currentTarget } = eventOrValue;
        if (currentTarget.type === 'checkbox') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (currentTarget.checked) return currentTarget.value || true;
            return currentTarget.value ? undefined : false;
        }
        if (currentTarget) return currentTarget.value;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return eventOrValue;
}

});

parcelRegister("45JN1", function(module, exports) {

$parcel$export(module.exports, "FieldMessage", () => $f046862319512079$export$eb5013679a5d3f69);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $kOFhM = parcelRequire("kOFhM");

var $qfj8c = parcelRequire("qfj8c");

var $e4yMr = parcelRequire("e4yMr");

var $f5oqj = parcelRequire("f5oqj");

var $3bDjY = parcelRequire("3bDjY");

var $h17zy = parcelRequire("h17zy");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $6a30R = parcelRequire("6a30R");

var $4IoOR = parcelRequire("4IoOR");

var $aQb3V = parcelRequire("aQb3V");
const $f046862319512079$var$FieldHelpLink = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldHelpTextUrl: fieldHelpTextUrl })=>{
    const learnMoreMessage = (0, $aQb3V.getLearnMoreMessage)(fieldHelpTextUrl ?? '');
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: fieldHelpTextUrl,
        target: "_blank"
    }, formatMessage(learnMoreMessage));
});
const $f046862319512079$var$FieldMessageBehaviour = (props)=>{
    const { description: description = '', error: error, fieldName: fieldName, fieldHelpTextUrl: fieldHelpTextUrl = '', isMini: isMini, onLinkClickEvent: onLinkClickEvent, fieldId: fieldId } = props;
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    const maxHeight = 22;
    const emojiProvider = (0, $h17zy.useEmojiProvider)();
    const adfDocument = (0, $5uXOq.useMemo)(()=>{
        if (error) return null;
        return (0, $4IoOR.convertWikiToAdf)(description);
    }, [
        description,
        error
    ]);
    if (error !== undefined && error !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $aQb3V.getErrorMessage)(error, fieldName, formatMessage, formatNumber));
    if (!adfDocument && !fieldHelpTextUrl) return null;
    const getRenderer = (isTruncated = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ), {
            document: adfDocument,
            schema: (0, $kOFhM.defaultSchema),
            dataProviders: emojiProvider,
            disableHeadingIDs: true,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                // enables sending analytics event with renderer specific tti measurement
                // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
                'renderer-tti-tracking': (0, $4R6GH.fg)('renderer_tti_tracking_jira'),
                'allow-windowed-code-block': true
            },
            maxHeight: isTruncated ? maxHeight : undefined,
            truncated: isTruncated,
            fadeOutHeight: isTruncated ? 0 : undefined,
            eventHandlers: {
                smartCard: {
                    onClick: (0, $6a30R.onLinkClick)
                },
                link: {
                    onClick: onLinkClickEvent || (0, $6a30R.onLinkClick)
                }
            },
            smartLinks: (0, $6a30R.smartLinksDefault)
        });
    const getRenderedDescription = (truncatedRenderer = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$Description, {
            "data-testid": "issue-create-commons.common.ui.field-message.description",
            isMini: isMini,
            ...fieldId && {
                id: `${fieldId}-field-message`
            }
        }, adfDocument && getRenderer(truncatedRenderer), fieldHelpTextUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$FieldHelpLink, {
            fieldHelpTextUrl: fieldHelpTextUrl
        })));
    if (isMini) {
        if (adfDocument?.content[0]?.type === 'paragraph') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$TooltipContentContainer, null, getRenderer()),
            position: "bottom"
        }, getRenderedDescription(true));
        return null;
    }
    return getRenderedDescription();
};
const $f046862319512079$export$eb5013679a5d3f69 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$FieldMessageBehaviour, {
        key: `field-message-${props.fieldId}`,
        ...props
    });
const $f046862319512079$var$TooltipContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1f1h16g6 _woio15cr _13odidpf _9j7z1moj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $f046862319512079$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_162p546": (0, $lD23V.default)(__cmplp.isMini && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            })
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1f1hqk37 _woio1wmz _13od1b66 _1pz31ynx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kOFhM", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $f27880a8173018db$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $f27880a8173018db$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $f27880a8173018db$export$1db618b7b2275ea1);

var $8QpSo = parcelRequire("8QpSo");

var $aXBFx = parcelRequire("aXBFx");
var $7kC9H = parcelRequire("7kC9H");
var $47jug = parcelRequire("47jug");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $bFtEE = parcelRequire("bFtEE");
var $9UDEr = parcelRequire("9UDEr");

var $kBho7 = parcelRequire("kBho7");
const $f27880a8173018db$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $f27880a8173018db$export$e4e3ac1fa64862db = $f27880a8173018db$var$getDefaultSchemaConfig();
const $f27880a8173018db$export$fd147e7d448dea03 = (0, $8QpSo.default)((stage = 'final')=>{
    const defaultSchemaConfig = $f27880a8173018db$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $gZoER.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $47jug.multiBodiedExtension),
        extensionFrame: (0, $47jug.extensionFrame),
        expand: (0, $7kC9H.expandWithNestedExpand),
        blockquote: (0, $aXBFx.blockquoteWithNestedCodeblockOrMedia),
        listItem: (0, $2FIVU.listItemWithDecisionStage0),
        panel: (0, $bFtEE.panelWithBlockquoteStage0)(true),
        table: (0, $9UDEr.tableWithNestedTable),
        tableRow: (0, $9UDEr.tableRowWithNestedTable),
        tableCell: (0, $9UDEr.tableCellWithNestedTable),
        tableHeader: (0, $9UDEr.tableHeaderWithNestedTable)
    };
    return (0, $kBho7.createSchema)(defaultSchemaConfig);
});
const $f27880a8173018db$export$1db618b7b2275ea1 = $f27880a8173018db$export$fd147e7d448dea03();

});
parcelRegister("aXBFx", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $7faca2534e4894a0$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => $7faca2534e4894a0$export$c4d50234112df933);
$parcel$export(module.exports, "blockquoteWithList", () => $7faca2534e4894a0$export$9b4686c4b9672643);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockquote_node
 */ const $7faca2534e4894a0$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $7faca2534e4894a0$export$67dc04e652a298ca = (0, $gthjq.blockquoteLegacy)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$c4d50234112df933 = (0, $gthjq.blockquote)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$9b4686c4b9672643 = (0, $gthjq.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});

});
parcelRegister("gthjq", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $bfdcc8a4590754dc$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $bfdcc8a4590754dc$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $bfdcc8a4590754dc$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", () => $bfdcc8a4590754dc$export$a91509d1c739c16f);
$parcel$export(module.exports, "bodiedExtension", () => $bfdcc8a4590754dc$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $bfdcc8a4590754dc$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $bfdcc8a4590754dc$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $bfdcc8a4590754dc$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $bfdcc8a4590754dc$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $bfdcc8a4590754dc$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $bfdcc8a4590754dc$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $bfdcc8a4590754dc$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $bfdcc8a4590754dc$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $bfdcc8a4590754dc$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $bfdcc8a4590754dc$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $bfdcc8a4590754dc$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $bfdcc8a4590754dc$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithoutNestedExpand", () => $bfdcc8a4590754dc$export$63c0f3992661097b);
$parcel$export(module.exports, "extension", () => $bfdcc8a4590754dc$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $bfdcc8a4590754dc$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $bfdcc8a4590754dc$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $bfdcc8a4590754dc$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $bfdcc8a4590754dc$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $bfdcc8a4590754dc$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $bfdcc8a4590754dc$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $bfdcc8a4590754dc$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $bfdcc8a4590754dc$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $bfdcc8a4590754dc$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $bfdcc8a4590754dc$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $bfdcc8a4590754dc$export$df876f0305235056);
$parcel$export(module.exports, "media", () => $bfdcc8a4590754dc$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $bfdcc8a4590754dc$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $bfdcc8a4590754dc$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $bfdcc8a4590754dc$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $bfdcc8a4590754dc$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $bfdcc8a4590754dc$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $bfdcc8a4590754dc$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $bfdcc8a4590754dc$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $bfdcc8a4590754dc$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $bfdcc8a4590754dc$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $bfdcc8a4590754dc$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $bfdcc8a4590754dc$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelWithNestedBlockquoteStage0", () => $bfdcc8a4590754dc$export$a1cf9918ad22c7e9);
$parcel$export(module.exports, "paragraph", () => $bfdcc8a4590754dc$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $bfdcc8a4590754dc$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $bfdcc8a4590754dc$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $bfdcc8a4590754dc$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $bfdcc8a4590754dc$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $bfdcc8a4590754dc$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $bfdcc8a4590754dc$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $bfdcc8a4590754dc$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $bfdcc8a4590754dc$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $bfdcc8a4590754dc$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $bfdcc8a4590754dc$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $bfdcc8a4590754dc$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $bfdcc8a4590754dc$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $bfdcc8a4590754dc$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $bfdcc8a4590754dc$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $bfdcc8a4590754dc$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $bfdcc8a4590754dc$export$c4c2f833baaebdb8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$67dc04e652a298ca = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$199922e5af8e9a6 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$a91509d1c739c16f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$27903d543b563e39 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$e7320d153c538837 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a140c94e5ea26bee = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$7bb0d5c671655cc4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$e4f1c66d84049f8b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$daf889beb5092f95 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$e6e4878f43c27cab = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$3e6d667072febc87 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$324d90190a8b822a = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$47988d68fe575725 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$6959e16eeff859b4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $bfdcc8a4590754dc$export$62d45a65fb43d95e = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2a111da947c407d2 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $bfdcc8a4590754dc$export$be4283d9a1cb1ff6 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a19185d1233fc4b2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$f5574b5d45fc2112 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9f77e0932fb78f72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$7e3788972005cc72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$63c0f3992661097b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$1b45514b112dd749 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a8baf338431a691 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b555be60c7703afb = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$371da9dd35aba193 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $bfdcc8a4590754dc$export$46e4a324ac90507f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$1b0c1557b234fa00 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$85461f751c457cc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2b380a0f7e250af1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$5c452ff88e35e47d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $bfdcc8a4590754dc$export$cbf8224b64e0d942 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$2f4e72b9459914ad = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$16b353b2649bd8d9 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b3b1e36c2105006d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$ab76e7c03cd6f650 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$cdae19acb0a520fd = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$206007566ca0aca5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
const $bfdcc8a4590754dc$export$76c7e83ecc9cdf05 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$df876f0305235056 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$987d49ffe1b0900f = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$2855e964765eac9 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $bfdcc8a4590754dc$export$38bab695e3f720f1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$969fe3781ca15058 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $bfdcc8a4590754dc$export$8d067f22dc2d1254 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$7e767666f2ce108a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$4bd9a38995f6bf50 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$db83999c14438df4 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$46f790bd65f760d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$750e45819f66d9d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $bfdcc8a4590754dc$export$63cadbf5f4296627 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$f03786aa6312d1e4 = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a5dc81035676e7a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$21f42ab9b6679f44 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a1cf9918ad22c7e9 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | blockquote)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9c206ddddb32a9b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$4f98472e6dc14293 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$ea332b61641b0588 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$a1f41dc4901771f8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$c7187bbd1a7a9244 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block'
});
const $bfdcc8a4590754dc$export$471f7ae5c4103ae1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b6ce52be8d7a261 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9852986a3ec5f6a0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$ce086a560a1d05f5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$e1e720e5f4603e6a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$abf39ca178940ff3 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$48884d2a5190dc73 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$2a5a518232fa1a97 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$ce666bf02318c957 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$7d657479499397 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$6d8b0ef52e2e6390 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$375b6afcc5f4d291 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$6f093cfa640b7166 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$5ea06bc686c59dc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$93256a4c17b33a82 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$a12828d0f14a2762 = (0, $f0ccE.createPMNodeSpecFactory)({});
const $bfdcc8a4590754dc$export$44b79b0979d0f0f7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$310ebe0d80122e9b = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("f0ccE", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $aec0525c0df12bb9$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $aec0525c0df12bb9$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $aec0525c0df12bb9$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $aec0525c0df12bb9$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("7kC9H", function(module, exports) {

$parcel$export(module.exports, "expand", () => $5567ff8f3f52f7a8$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithNestedExpand", () => $5567ff8f3f52f7a8$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $5567ff8f3f52f7a8$export$54fd2c36b5cc6731);

var $gthjq = parcelRequire("gthjq");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $5567ff8f3f52f7a8$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $5567ff8f3f52f7a8$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $5567ff8f3f52f7a8$export$9f77e0932fb78f72 = (0, $gthjq.expandWithoutNestedExpand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$7b80cba28d10b2c1 = (0, $gthjq.expand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("47jug", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $2ff6ee9baaedd4b6$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $2ff6ee9baaedd4b6$export$c3c04d555a8b9013);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $2ff6ee9baaedd4b6$export$4fdcae991fd743e7 = (0, $gthjq.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $2ff6ee9baaedd4b6$export$c3c04d555a8b9013 = (0, $gthjq.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("CWpyq", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $0750dbf71b86cced$export$1765e2758fc47004);
const $0750dbf71b86cced$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $0750dbf71b86cced$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $0750dbf71b86cced$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("gZoER", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $c5e57867b1f8b9c7$export$4f9d8f623ff17117);

var $gthjq = parcelRequire("gthjq");
const $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be = (0, $gthjq.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$cdae19acb0a520fd = (0, $gthjq.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$4f9d8f623ff17117 = (0, $gthjq.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2FIVU", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $1f2243de0d109562$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $1f2243de0d109562$export$58dca2f0678302a4);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $1f2243de0d109562$export$b2cd54d5ce935ddb);

var $gthjq = parcelRequire("gthjq");
const $1f2243de0d109562$export$76c7e83ecc9cdf05 = (0, $gthjq.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $1f2243de0d109562$export$58dca2f0678302a4 = $1f2243de0d109562$export$76c7e83ecc9cdf05;
const $1f2243de0d109562$export$b2cd54d5ce935ddb = (0, $gthjq.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("bFtEE", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $87ea86de426496d8$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $87ea86de426496d8$export$ce20b13564211141);
$parcel$export(module.exports, "panelWithBlockquoteStage0", () => $87ea86de426496d8$export$1f8c55a804c909c7);

var $gthjq = parcelRequire("gthjq");
let $87ea86de426496d8$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $87ea86de426496d8$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $87ea86de426496d8$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $87ea86de426496d8$export$969277cf61e5a7aa.CUSTOM ? $87ea86de426496d8$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $87ea86de426496d8$export$ce20b13564211141 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $gthjq.panel)({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
    return panelNodeSpec;
};
const $87ea86de426496d8$export$1f8c55a804c909c7 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $gthjq.panelWithNestedBlockquoteStage0)({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
    return panelNodeSpec;
};

});

parcelRegister("9UDEr", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $737819f27951a815$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $737819f27951a815$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $737819f27951a815$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $737819f27951a815$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $737819f27951a815$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $737819f27951a815$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $737819f27951a815$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $737819f27951a815$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $737819f27951a815$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $737819f27951a815$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $737819f27951a815$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $737819f27951a815$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $737819f27951a815$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $737819f27951a815$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $737819f27951a815$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $737819f27951a815$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $737819f27951a815$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $737819f27951a815$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $737819f27951a815$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $737819f27951a815$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $737819f27951a815$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $737819f27951a815$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $737819f27951a815$export$2a5a518232fa1a97);

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $9IGaJ = parcelRequire("9IGaJ");

var $87j2U = parcelRequire("87j2U");

var $gthjq = parcelRequire("gthjq");
const $737819f27951a815$export$9cfceb893b24742a = 'pm-table';
const $737819f27951a815$export$69cb4c3f80383763 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-content-wrap`;
const $737819f27951a815$export$7b07d37d879c957f = `${$737819f27951a815$export$9cfceb893b24742a}-header-content-wrap`;
const $737819f27951a815$export$8dd42a84cd52da07 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $737819f27951a815$export$5e26a5c19f0865d8 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $51H8P.N20).toLocaleLowerCase();
const $737819f27951a815$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $51H8P.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $51H8P.isRgb)(backgroundColor)) {
        const result = (0, $51H8P.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $737819f27951a815$var$testGlobalTheme;
const $737819f27951a815$export$fd7e0dd2b74807f7 = (theme)=>{
    $737819f27951a815$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $737819f27951a815$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($737819f27951a815$var$testGlobalTheme) return {
        colorMode: $737819f27951a815$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $737819f27951a815$var$cssVariablePattern = /^var\(--.*\)$/;
const $737819f27951a815$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $51H8P.isRgb)(background) && (0, $51H8P.rgbToHex)(background) ? (0, $51H8P.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $daes7.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $737819f27951a815$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($737819f27951a815$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $87j2U.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $737819f27951a815$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $737819f27951a815$export$7b07d37d879c957f;
    else attrs.class = $737819f27951a815$export$69cb4c3f80383763;
    return attrs;
};
const $737819f27951a815$export$219b7f492ad209f8 = new Map();
const $737819f27951a815$export$95e9c925fbf01d1c = (0, $51H8P.hexToRgba)((0, $51H8P.N800), 0.12) || (0, $51H8P.N0);
const $737819f27951a815$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B50),
        'Light blue'
    ],
    [
        (0, $51H8P.T50),
        'Light teal'
    ],
    [
        (0, $51H8P.G50),
        'Light green'
    ],
    [
        (0, $51H8P.Y50),
        'Light yellow'
    ],
    [
        (0, $51H8P.R50),
        'Light red'
    ],
    [
        (0, $51H8P.P50),
        'Light purple'
    ],
    [
        (0, $51H8P.N20),
        'Light gray'
    ],
    [
        (0, $51H8P.B75),
        'Blue'
    ],
    [
        (0, $51H8P.T75),
        'Teal'
    ],
    [
        (0, $51H8P.G75),
        'Green'
    ],
    [
        (0, $51H8P.Y75),
        'Yellow'
    ],
    [
        (0, $51H8P.R75),
        'Red'
    ],
    [
        (0, $51H8P.P75),
        'Purple'
    ],
    [
        (0, $51H8P.N60),
        'Gray'
    ],
    [
        (0, $51H8P.B100),
        'Dark blue'
    ],
    [
        (0, $51H8P.T100),
        'Dark teal'
    ],
    [
        (0, $51H8P.G200),
        'Dark green'
    ],
    [
        (0, $51H8P.Y200),
        'Dark yellow'
    ],
    [
        (0, $51H8P.R100),
        'Dark red'
    ],
    [
        (0, $51H8P.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $737819f27951a815$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $737819f27951a815$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
const $737819f27951a815$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $9IGaJ.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
const $737819f27951a815$var$createTableSpec = ()=>(0, $gthjq.table)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$9852986a3ec5f6a0 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$90e634fbace1f0c4 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$3862de5c8c9098cf = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $737819f27951a815$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$737819f27951a815$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $737819f27951a815$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $737819f27951a815$export$ce666bf02318c957 = (0, $gthjq.tableRow)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $737819f27951a815$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$e1e720e5f4603e6a = (0, $gthjq.tableCell)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($737819f27951a815$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $737819f27951a815$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom, {
                    background: $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$48884d2a5190dc73 = (0, $gthjq.tableHeader)($737819f27951a815$var$tableHeaderNodeSpecOptions);
const $737819f27951a815$export$2af48797a1010bb1 = $737819f27951a815$export$2ac34c099660f1a8;
const $737819f27951a815$export$ce086a560a1d05f5 = (0, $gthjq.tableWithNestedTable)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$7d657479499397 = (0, $gthjq.tableRowWithNestedTable)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$export$abf39ca178940ff3 = (0, $gthjq.tableCellWithNestedTable)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2a5a518232fa1a97 = (0, $gthjq.tableHeaderWithNestedTable)($737819f27951a815$var$tableHeaderNodeSpecOptions);

});
parcelRegister("daes7", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $99576b847e5fbb17$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $99576b847e5fbb17$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $99576b847e5fbb17$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $99576b847e5fbb17$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $99576b847e5fbb17$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $99576b847e5fbb17$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? $99576b847e5fbb17$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $99576b847e5fbb17$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("51H8P", function(module, exports) {

$parcel$export(module.exports, "R50", () => $3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a8e82bcbd673dd1$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a8e82bcbd673dd1$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a8e82bcbd673dd1$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $3a8e82bcbd673dd1$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a8e82bcbd673dd1$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a8e82bcbd673dd1$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $3a8e82bcbd673dd1$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a8e82bcbd673dd1$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a8e82bcbd673dd1$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $3a8e82bcbd673dd1$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a8e82bcbd673dd1$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a8e82bcbd673dd1$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a8e82bcbd673dd1$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a8e82bcbd673dd1$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a8e82bcbd673dd1$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a8e82bcbd673dd1$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a8e82bcbd673dd1$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a8e82bcbd673dd1$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a8e82bcbd673dd1$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a8e82bcbd673dd1$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a8e82bcbd673dd1$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a8e82bcbd673dd1$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a8e82bcbd673dd1$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a8e82bcbd673dd1$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a8e82bcbd673dd1$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a8e82bcbd673dd1$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a8e82bcbd673dd1$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a8e82bcbd673dd1$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a8e82bcbd673dd1$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a8e82bcbd673dd1$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a8e82bcbd673dd1$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a8e82bcbd673dd1$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a8e82bcbd673dd1$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a8e82bcbd673dd1$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a8e82bcbd673dd1$export$9665a07d9187b414);

var $3nnJa = parcelRequire("3nnJa");
const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
        else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
    if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("3nnJa", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("9IGaJ", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $7138efa2a0163ee8$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $7138efa2a0163ee8$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $7138efa2a0163ee8$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $7138efa2a0163ee8$var$staticValue = false;
const $7138efa2a0163ee8$export$31b40729666a4ae0 = {
    setStatic (value) {
        $7138efa2a0163ee8$var$staticValue = value;
    },
    generate () {
        return $7138efa2a0163ee8$var$staticValue || $7138efa2a0163ee8$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("87j2U", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $5e8dc04ff4ab4f7d$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $5e8dc04ff4ab4f7d$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $5e8dc04ff4ab4f7d$var$rgbFromHex = (input)=>{
    const fullHex = $5e8dc04ff4ab4f7d$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $5e8dc04ff4ab4f7d$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $5e8dc04ff4ab4f7d$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $5e8dc04ff4ab4f7d$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $5e8dc04ff4ab4f7d$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToLch = (rgb)=>$5e8dc04ff4ab4f7d$var$labToLch($5e8dc04ff4ab4f7d$var$xyzToLab($5e8dc04ff4ab4f7d$var$rgbToXyz(rgb)));
const $5e8dc04ff4ab4f7d$var$lchToRgb = (lch)=>$5e8dc04ff4ab4f7d$var$xyzToRgb($5e8dc04ff4ab4f7d$var$labToXyz($5e8dc04ff4ab4f7d$var$lchToLab(lch)));
const $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    lch.l = $5e8dc04ff4ab4f7d$var$clamp(newPercent, 0, 100);
    return $5e8dc04ff4ab4f7d$var$rgbToHex($5e8dc04ff4ab4f7d$var$lchToRgb(lch));
};
const $5e8dc04ff4ab4f7d$var$getLightness = (color)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    return lch.l;
};
const $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $5e8dc04ff4ab4f7d$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("kBho7", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $eff4c0443be4d23b$export$5f4ce795563f4211);

var $kCV8T = parcelRequire("kCV8T");


var $7P7H6 = parcelRequire("7P7H6");

var $aeGrH = parcelRequire("aeGrH");
var $88i6h = parcelRequire("88i6h");
var $8jJss = parcelRequire("8jJss");
var $14Vqw = parcelRequire("14Vqw");
var $zceQE = parcelRequire("zceQE");
var $lcXoV = parcelRequire("lcXoV");
var $71k4W = parcelRequire("71k4W");
var $cUwVZ = parcelRequire("cUwVZ");
var $l3Tmi = parcelRequire("l3Tmi");
var $29Vii = parcelRequire("29Vii");
var $fK6mK = parcelRequire("fK6mK");
var $8XeG6 = parcelRequire("8XeG6");
var $aUhe2 = parcelRequire("aUhe2");
var $hhtT8 = parcelRequire("hhtT8");
var $4NwJJ = parcelRequire("4NwJJ");
var $c9aa1 = parcelRequire("c9aa1");
var $dtyqo = parcelRequire("dtyqo");
var $8EAPB = parcelRequire("8EAPB");
var $jxVez = parcelRequire("jxVez");
var $lVmBd = parcelRequire("lVmBd");

var $21PS7 = parcelRequire("21PS7");
var $aXBFx = parcelRequire("aXBFx");
var $5AxYU = parcelRequire("5AxYU");
var $kjhhp = parcelRequire("kjhhp");
var $5JeV5 = parcelRequire("5JeV5");
var $8vlrc = parcelRequire("8vlrc");
var $6bbHe = parcelRequire("6bbHe");
var $5y0tR = parcelRequire("5y0tR");
var $bd7A9 = parcelRequire("bd7A9");
var $b2VmY = parcelRequire("b2VmY");
var $Khvpb = parcelRequire("Khvpb");
var $8gSD8 = parcelRequire("8gSD8");
var $xjCuM = parcelRequire("xjCuM");
var $kshOv = parcelRequire("kshOv");
var $7DoMR = parcelRequire("7DoMR");
var $7kC9H = parcelRequire("7kC9H");
var $bFtEE = parcelRequire("bFtEE");
var $hhN5g = parcelRequire("hhN5g");
var $47jug = parcelRequire("47jug");
var $jnMM2 = parcelRequire("jnMM2");
var $lRTZM = parcelRequire("lRTZM");
var $7lRBh = parcelRequire("7lRBh");
var $cCBEe = parcelRequire("cCBEe");
var $5BOuQ = parcelRequire("5BOuQ");
var $4EbxI = parcelRequire("4EbxI");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $7agO8 = parcelRequire("7agO8");
var $92lix = parcelRequire("92lix");
var $7Xgp3 = parcelRequire("7Xgp3");
var $bIGZ7 = parcelRequire("bIGZ7");
var $g7Cky = parcelRequire("g7Cky");
var $dx5eC = parcelRequire("dx5eC");
var $dwptW = parcelRequire("dwptW");
var $abme3 = parcelRequire("abme3");
var $dgJoa = parcelRequire("dgJoa");
var $M4hHz = parcelRequire("M4hHz");
var $18bvk = parcelRequire("18bvk");
var $9UDEr = parcelRequire("9UDEr");
var $iThOL = parcelRequire("iThOL");
var $43mJF = parcelRequire("43mJF");
var $3DR6L = parcelRequire("3DR6L");
var $9X587 = parcelRequire("9X587");
var $d1d6m = parcelRequire("d1d6m");
var $6kr5W = parcelRequire("6kr5W");
function $eff4c0443be4d23b$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $eff4c0443be4d23b$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $eff4c0443be4d23b$var$markGroupDeclarations = [
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$9b982809044276a6)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$4498a6080fed604c)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$b395009ca7f092c7))
];
const $eff4c0443be4d23b$var$markGroupDeclarationsNames = $eff4c0443be4d23b$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $eff4c0443be4d23b$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $xjCuM.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $abme3.paragraph)
    },
    {
        name: 'text',
        spec: (0, $3DR6L.text)
    },
    {
        name: 'bulletList',
        spec: (0, $kjhhp.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $dwptW.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $2FIVU.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $lRTZM.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $aXBFx.blockquoteWithNestedCodeblockOrMedia)
    },
    {
        name: 'codeBlock',
        spec: (0, $8vlrc.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $bFtEE.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $M4hHz.rule)
    },
    {
        name: 'image',
        spec: (0, $7lRBh.image)
    },
    {
        name: 'mention',
        spec: (0, $g7Cky.mention)
    },
    {
        name: 'caption',
        spec: (0, $5JeV5.caption)
    },
    {
        name: 'media',
        spec: (0, $7agO8.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $92lix.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $bIGZ7.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $7Xgp3.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $dgJoa.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $gZoER.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $4EbxI.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $jnMM2.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $7DoMR.emoji)
    },
    {
        name: 'table',
        spec: (0, $9UDEr.table)
    },
    {
        name: 'tableCell',
        spec: (0, $9UDEr.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $9UDEr.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $9UDEr.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $6bbHe.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $bd7A9.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $5y0tR.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $8gSD8.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $Khvpb.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $43mJF.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $iThOL.taskItem)
    },
    {
        name: 'date',
        spec: (0, $b2VmY.date)
    },
    {
        name: 'status',
        spec: (0, $18bvk.status)
    },
    {
        name: 'expand',
        spec: (0, $7kC9H.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $dx5eC.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $hhN5g.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $5BOuQ.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $5AxYU.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $47jug.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $47jug.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $cCBEe.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $21PS7.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $kshOv.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $9X587.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $d1d6m.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $6kr5W.unsupportedInline)
    }
];
const $eff4c0443be4d23b$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $8XeG6.link)
    },
    {
        name: 'em',
        spec: (0, $l3Tmi.em)
    },
    {
        name: 'strong',
        spec: (0, $hhtT8.strong)
    },
    {
        name: 'textColor',
        spec: (0, $c9aa1.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $8jJss.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $aUhe2.strike)
    },
    {
        name: 'subsup',
        spec: (0, $4NwJJ.subsup)
    },
    {
        name: 'underline',
        spec: (0, $8EAPB.underline)
    },
    {
        name: 'code',
        spec: (0, $lcXoV.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $dtyqo.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $aeGrH.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $88i6h.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $71k4W.confluenceInlineComment)
    },
    ...$eff4c0443be4d23b$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $zceQE.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $cUwVZ.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $29Vii.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $fK6mK.indentation)
    },
    {
        name: 'border',
        spec: (0, $14Vqw.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $jxVez.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $lVmBd.unsupportedNodeAttribute)
    }
];
function $eff4c0443be4d23b$export$2d0c32a809131488() {
    const nodes = $eff4c0443be4d23b$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $eff4c0443be4d23b$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $eff4c0443be4d23b$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($eff4c0443be4d23b$var$markGroupDeclarationsNames);
    let nodes = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $7P7H6.sanitizeNodes)(nodes, marks);
    return new (0, $kCV8T.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $eff4c0443be4d23b$export$c77b6d30da5276a1 = true;

});
parcelRegister("kCV8T", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f043ae92c0a873f0$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $f043ae92c0a873f0$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $f043ae92c0a873f0$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $f043ae92c0a873f0$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $f043ae92c0a873f0$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $f043ae92c0a873f0$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $f043ae92c0a873f0$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $f043ae92c0a873f0$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $f043ae92c0a873f0$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $f043ae92c0a873f0$export$3476b78f8f5a8b72);

var $dHeNB = parcelRequire("dHeNB");
function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $f043ae92c0a873f0$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
        if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                return $f043ae92c0a873f0$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
const $f043ae92c0a873f0$var$found = {
    index: 0,
    offset: 0
};
function $f043ae92c0a873f0$var$retIndex(index, offset) {
    $f043ae92c0a873f0$var$found.index = index;
    $f043ae92c0a873f0$var$found.offset = offset;
    return $f043ae92c0a873f0$var$found;
}
function $f043ae92c0a873f0$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
function $f043ae92c0a873f0$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $f043ae92c0a873f0$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
    return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
}
function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
        return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $f043ae92c0a873f0$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
    return node;
}
function $f043ae92c0a873f0$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
}
function $f043ae92c0a873f0$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
        $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
        if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
        let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
        return result;
    }
}
class $f043ae92c0a873f0$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $f043ae92c0a873f0$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
        $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
class $f043ae92c0a873f0$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $f043ae92c0a873f0$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
    let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $f043ae92c0a873f0$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
    let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $f043ae92c0a873f0$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $f043ae92c0a873f0$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $f043ae92c0a873f0$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $f043ae92c0a873f0$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($f043ae92c0a873f0$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $f043ae92c0a873f0$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $f043ae92c0a873f0$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $f043ae92c0a873f0$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $f043ae92c0a873f0$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $f043ae92c0a873f0$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $dHeNB.default).from(spec.nodes), instanceSpec.marks = (0, $dHeNB.default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $f043ae92c0a873f0$var$isTagRule(rule) {
    return rule.tag != null;
}
function $f043ae92c0a873f0$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
            else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $f043ae92c0a873f0$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $f043ae92c0a873f0$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $f043ae92c0a873f0$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
}
class $f043ae92c0a873f0$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $f043ae92c0a873f0$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
        let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $f043ae92c0a873f0$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $f043ae92c0a873f0$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $f043ae92c0a873f0$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $f043ae92c0a873f0$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
    }
}
function $f043ae92c0a873f0$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $f043ae92c0a873f0$var$doc(options) {
    return options.document || window.document;
}
const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
    let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
    return value;
}
function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("dHeNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
    this.content = content;
}
$9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
    constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $9f8ac547b0b2e1f8$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
    if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
};
var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $72fd39d34ca5bb7c$export$4498a6080fed604c = 'fontStyle';
const $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $72fd39d34ca5bb7c$export$b395009ca7f092c7 = 'link';
const $72fd39d34ca5bb7c$export$9b982809044276a6 = 'color';
const $72fd39d34ca5bb7c$export$470d0905851e47a1 = 'alignment';
const $72fd39d34ca5bb7c$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("7P7H6", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", () => $5b2343b4eb27461c$export$daf54fed04c8fb77);
function $5b2343b4eb27461c$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$5b2343b4eb27461c$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$5b2343b4eb27461c$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $5b2343b4eb27461c$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $5b2343b4eb27461c$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("aeGrH", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $773c2309706a915e$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $773c2309706a915e$export$8e53000a4ec837);

var $2fTAU = parcelRequire("2fTAU");
const $773c2309706a915e$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $773c2309706a915e$export$8e53000a4ec837 = (0, $2fTAU.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("2fTAU", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $1a481b607696d815$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $1a481b607696d815$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $1a481b607696d815$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $1a481b607696d815$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $1a481b607696d815$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $1a481b607696d815$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $1a481b607696d815$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $1a481b607696d815$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $1a481b607696d815$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $1a481b607696d815$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $1a481b607696d815$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $1a481b607696d815$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $1a481b607696d815$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $1a481b607696d815$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $1a481b607696d815$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $1a481b607696d815$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $1a481b607696d815$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $1a481b607696d815$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $1a481b607696d815$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $1a481b607696d815$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $1a481b607696d815$export$8e53000a4ec837 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $1a481b607696d815$export$8512c9afa7b24c3b = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $1a481b607696d815$export$8c5a050822fd698c = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $1a481b607696d815$export$1edee58a52776cd9 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $1a481b607696d815$export$89015c65f1c75e3f = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $1a481b607696d815$export$6565f9f03506010b = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $1a481b607696d815$export$f3b72f8fc4684ecd = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$3024f02c495408d6 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $1a481b607696d815$export$c63c6f932822f543 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$f00aeb236b6f05af = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$480c699bd4ec0d86 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $1a481b607696d815$export$9c30223ca0a664fb = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $1a481b607696d815$export$4899a95d70ec5056 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$59ae2c325a998f89 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$b3401ee80eb31041 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$32f78bffcd82ff28 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $1a481b607696d815$export$20af3dabbb5538df = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $1a481b607696d815$export$425327af25286e5e = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$30d78d5eb6719bb8 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $1a481b607696d815$export$a316dc07ff5182a2 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("88i6h", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $5ebd1c6c912098fc$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $5ebd1c6c912098fc$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $5ebd1c6c912098fc$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $5ebd1c6c912098fc$export$8512c9afa7b24c3b);

var $2fTAU = parcelRequire("2fTAU");
let $5ebd1c6c912098fc$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $5ebd1c6c912098fc$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $5ebd1c6c912098fc$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $5ebd1c6c912098fc$export$8512c9afa7b24c3b = (0, $2fTAU.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$5ebd1c6c912098fc$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("8jJss", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $60e35c16db44f137$export$8c5a050822fd698c);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $c9aa1 = parcelRequire("c9aa1");

var $87j2U = parcelRequire("87j2U");
/**
 * @name backgroundColor_mark
 */ const $60e35c16db44f137$var$colorArrayPalette = [
    [
        (0, $51H8P.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51H8P.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51H8P.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51H8P.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51H8P.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51H8P.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $60e35c16db44f137$export$14ec3f21a268e497 = new Map();
$60e35c16db44f137$var$colorArrayPalette.forEach(([color, label])=>$60e35c16db44f137$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $60e35c16db44f137$export$8c5a050822fd698c = (0, $2fTAU.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $c9aa1.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("c9aa1", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $8d7e34fd69d04bb8$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $8d7e34fd69d04bb8$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $8d7e34fd69d04bb8$export$32f78bffcd82ff28);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $87j2U = parcelRequire("87j2U");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $8d7e34fd69d04bb8$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $51H8P.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $51H8P.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $51H8P.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $51H8P.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $51H8P.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $51H8P.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $51H8P.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $51H8P.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $51H8P.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $51H8P.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $51H8P.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $51H8P.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $51H8P.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $51H8P.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $51H8P.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $51H8P.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $51H8P.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $51H8P.P50),
        'Light purple'
    ] // Lavender secret
];
const $8d7e34fd69d04bb8$export$569885e57444f84a = new Map();
const $8d7e34fd69d04bb8$export$81e5ed9e84fe2e28 = $8d7e34fd69d04bb8$export$569885e57444f84a;
$8d7e34fd69d04bb8$var$colorArrayPalette.forEach(([color, label])=>$8d7e34fd69d04bb8$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $8d7e34fd69d04bb8$var$testGlobalTheme;
const $8d7e34fd69d04bb8$export$fd7e0dd2b74807f7 = (theme)=>{
    $8d7e34fd69d04bb8$var$testGlobalTheme = theme;
};
const $8d7e34fd69d04bb8$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($8d7e34fd69d04bb8$var$testGlobalTheme) return {
        colorMode: $8d7e34fd69d04bb8$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $8d7e34fd69d04bb8$export$32f78bffcd82ff28 = (0, $2fTAU.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($8d7e34fd69d04bb8$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("14Vqw", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $0c92b5eb9dbe9377$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $0c92b5eb9dbe9377$export$1edee58a52776cd9);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $0c92b5eb9dbe9377$var$borderColorArrayPalette = [
    [
        (0, $51H8P.N300A),
        'Subtle gray'
    ],
    [
        (0, $51H8P.N600),
        'Gray'
    ],
    [
        (0, $51H8P.N1000),
        'Bold gray'
    ]
];
const $0c92b5eb9dbe9377$export$e4e044c989c86ca7 = new Map();
$0c92b5eb9dbe9377$var$borderColorArrayPalette.forEach(([color, label])=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $0c92b5eb9dbe9377$export$1edee58a52776cd9 = (0, $2fTAU.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $0c92b5eb9dbe9377$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $daes7.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("zceQE", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $069cc34ec2ef025e$export$89015c65f1c75e3f);

var $2fTAU = parcelRequire("2fTAU");
const $069cc34ec2ef025e$var$allowedTypes = [
    'wide',
    'full-width'
];
const $069cc34ec2ef025e$export$89015c65f1c75e3f = (0, $2fTAU.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                const width = dom.getAttribute('data-width');
                return {
                    mode: $069cc34ec2ef025e$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("lcXoV", function(module, exports) {

$parcel$export(module.exports, "code", () => $f708cbc93f02b120$export$6565f9f03506010b);

var $2fTAU = parcelRequire("2fTAU");
const $f708cbc93f02b120$export$6565f9f03506010b = (0, $2fTAU.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("71k4W", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $51c833981031ae17$export$f3b72f8fc4684ecd);

var $2fTAU = parcelRequire("2fTAU");
const $51c833981031ae17$export$f3b72f8fc4684ecd = (0, $2fTAU.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("cUwVZ", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $966443126bdc8969$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $966443126bdc8969$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $966443126bdc8969$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $6VXbJ.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $966443126bdc8969$export$3024f02c495408d6 = (0, $2fTAU.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$966443126bdc8969$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $966443126bdc8969$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("6VXbJ", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $50c5fa8010b73128$export$c296e2d4365c37a5);
const $50c5fa8010b73128$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("l3Tmi", function(module, exports) {

$parcel$export(module.exports, "em", () => $f554d1dac524ac83$export$c63c6f932822f543);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name em_mark
 */ const $f554d1dac524ac83$var$emDOM = [
    'em'
];
const $f554d1dac524ac83$export$c63c6f932822f543 = (0, $2fTAU.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $f554d1dac524ac83$var$emDOM;
    }
});

});

parcelRegister("29Vii", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $1928dd6d160b68a9$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $1928dd6d160b68a9$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $1928dd6d160b68a9$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $6VXbJ.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $1928dd6d160b68a9$export$f00aeb236b6f05af = (0, $2fTAU.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$1928dd6d160b68a9$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $1928dd6d160b68a9$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("fK6mK", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $b760170dcfe13435$export$480c699bd4ec0d86);

var $2fTAU = parcelRequire("2fTAU");
const $b760170dcfe13435$export$480c699bd4ec0d86 = (0, $2fTAU.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("8XeG6", function(module, exports) {

$parcel$export(module.exports, "link", () => $684f383282dda449$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $684f383282dda449$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $iZOJ9 = parcelRequire("iZOJ9");
const $684f383282dda449$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $iZOJ9.isSafeUrl)(href)) return false;
        if ((0, $iZOJ9.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $iZOJ9.normalizeUrl)(href);
        return attrs;
    };
const $684f383282dda449$export$9c30223ca0a664fb = (0, $2fTAU.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $iZOJ9.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $684f383282dda449$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $684f383282dda449$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($684f383282dda449$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("iZOJ9", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $dd4545da25e52dce$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $dd4545da25e52dce$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $dd4545da25e52dce$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $dd4545da25e52dce$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $dd4545da25e52dce$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $dd4545da25e52dce$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $i6xkD = parcelRequire("i6xkD");
const $dd4545da25e52dce$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($i6xkD)))();
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
    if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
    if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
    const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("i6xkD", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d2e2a485107d561a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d2e2a485107d561a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d2e2a485107d561a$var$isString(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object String]';
}
function $d2e2a485107d561a$var$isObject(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
}
function $d2e2a485107d561a$var$isRegExp(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
}
function $d2e2a485107d561a$var$isFunction(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
}
function $d2e2a485107d561a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d2e2a485107d561a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d2e2a485107d561a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d2e2a485107d561a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d2e2a485107d561a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d2e2a485107d561a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d2e2a485107d561a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d2e2a485107d561a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d2e2a485107d561a$var$isObject(val)) {
            if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
            else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d2e2a485107d561a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d2e2a485107d561a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d2e2a485107d561a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d2e2a485107d561a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d2e2a485107d561a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d2e2a485107d561a$var$createMatch(self, shift) {
    var match = new $d2e2a485107d561a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d2e2a485107d561a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d2e2a485107d561a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d2e2a485107d561a$var$LinkifyIt;

});
parcelRegister("9mKTr", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("b9ep3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("23ErL", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("oRY4m", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("9bBmm", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("aUhe2", function(module, exports) {

$parcel$export(module.exports, "strike", () => $7f0c7ef7d4ef76e7$export$4899a95d70ec5056);

var $2fTAU = parcelRequire("2fTAU");
const $7f0c7ef7d4ef76e7$export$4899a95d70ec5056 = (0, $2fTAU.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("hhtT8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $c94b3560d4129743$export$59ae2c325a998f89);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name strong_mark
 */ const $c94b3560d4129743$var$strongDOM = [
    'strong'
];
const $c94b3560d4129743$export$59ae2c325a998f89 = (0, $2fTAU.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $c94b3560d4129743$var$strongDOM;
    }
});

});

parcelRegister("4NwJJ", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $37e521d9accf6615$export$b3401ee80eb31041);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name subsup_mark
 */ function $37e521d9accf6615$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $37e521d9accf6615$export$b3401ee80eb31041 = (0, $2fTAU.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("dtyqo", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $9cf8afcff83743a0$export$20af3dabbb5538df);

var $2fTAU = parcelRequire("2fTAU");

var $51H8P = parcelRequire("51H8P");
const $9cf8afcff83743a0$export$20af3dabbb5538df = (0, $2fTAU.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $51H8P.B400)}`
            }
        ];
    }
});

});

parcelRegister("8EAPB", function(module, exports) {

$parcel$export(module.exports, "underline", () => $64cea1116bb0e8f8$export$425327af25286e5e);

var $2fTAU = parcelRequire("2fTAU");
const $64cea1116bb0e8f8$export$425327af25286e5e = (0, $2fTAU.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("jxVez", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $e3ad7edb6364f3b2$export$30d78d5eb6719bb8);

var $2fTAU = parcelRequire("2fTAU");
const $e3ad7edb6364f3b2$export$30d78d5eb6719bb8 = (0, $2fTAU.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("lVmBd", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $ff60739479aa7be3$export$a316dc07ff5182a2);

var $2fTAU = parcelRequire("2fTAU");
const $ff60739479aa7be3$export$a316dc07ff5182a2 = (0, $2fTAU.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("21PS7", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $17a3e9738ed289c7$export$c4c2f833baaebdb8);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockCard_node
 */ const $17a3e9738ed289c7$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $17a3e9738ed289c7$export$c4c2f833baaebdb8 = (0, $gthjq.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("5AxYU", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $411aac89e34c8741$export$27903d543b563e39);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $411aac89e34c8741$export$27903d543b563e39 = (0, $gthjq.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("kjhhp", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $ec92fc66e86ee824$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $ec92fc66e86ee824$export$a140c94e5ea26bee);

var $gthjq = parcelRequire("gthjq");
const $ec92fc66e86ee824$export$5f25a39efab3b58b = '.ak-ul';
const $ec92fc66e86ee824$export$a140c94e5ea26bee = (0, $gthjq.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $ec92fc66e86ee824$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5JeV5", function(module, exports) {

$parcel$export(module.exports, "caption", () => $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d);

var $gthjq = parcelRequire("gthjq");
const $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d = (0, $gthjq.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8vlrc", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $6311d90c8f0b12c7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $6311d90c8f0b12c7$export$54fd2c36b5cc6731);

var $kCV8T = parcelRequire("kCV8T");

var $gthjq = parcelRequire("gthjq");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ const $6311d90c8f0b12c7$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $6311d90c8f0b12c7$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $6311d90c8f0b12c7$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $6311d90c8f0b12c7$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $6311d90c8f0b12c7$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $6311d90c8f0b12c7$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $6311d90c8f0b12c7$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $6311d90c8f0b12c7$export$7bb0d5c671655cc4 = (0, $gthjq.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromEditorStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $6311d90c8f0b12c7$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $6311d90c8f0b12c7$var$parseCodeFromHtml(domNode);
                return code ? (0, $kCV8T.Fragment).from(schema.text(code)) : (0, $kCV8T.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $6311d90c8f0b12c7$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("6bbHe", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $47fcd7cf328a46ad$export$daf889beb5092f95);

var $gthjq = parcelRequire("gthjq");
const $47fcd7cf328a46ad$var$name = 'confluenceJiraIssue';
const $47fcd7cf328a46ad$export$daf889beb5092f95 = (0, $gthjq.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$47fcd7cf328a46ad$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $47fcd7cf328a46ad$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("5y0tR", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $40a0802970c8dfd0$export$e6e4878f43c27cab);

var $gthjq = parcelRequire("gthjq");
const $40a0802970c8dfd0$var$name = 'confluenceUnsupportedBlock';
const $40a0802970c8dfd0$export$e6e4878f43c27cab = (0, $gthjq.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $40a0802970c8dfd0$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$40a0802970c8dfd0$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("bd7A9", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $8296ca40a4ed2ee7$export$3e6d667072febc87);

var $gthjq = parcelRequire("gthjq");
const $8296ca40a4ed2ee7$var$name = 'confluenceUnsupportedInline';
const $8296ca40a4ed2ee7$export$3e6d667072febc87 = (0, $gthjq.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $8296ca40a4ed2ee7$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$8296ca40a4ed2ee7$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("b2VmY", function(module, exports) {

$parcel$export(module.exports, "date", () => $80ac620012a63cc1$export$324d90190a8b822a);

var $gthjq = parcelRequire("gthjq");
const $80ac620012a63cc1$export$324d90190a8b822a = (0, $gthjq.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("Khvpb", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $08b1e03a19cbdc24$export$6959e16eeff859b4);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $08b1e03a19cbdc24$export$6959e16eeff859b4 = (0, $gthjq.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8gSD8", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $605a31c9af2a8977$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $605a31c9af2a8977$export$62d45a65fb43d95e);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name decisionList_node
 */ const $605a31c9af2a8977$var$name = 'decisionList';
const $605a31c9af2a8977$export$a5393ce68c2ff601 = `[data-node-type="${$605a31c9af2a8977$var$name}"]`;
const $605a31c9af2a8977$export$62d45a65fb43d95e = (0, $gthjq.decisionList)({
    parseDOM: [
        {
            tag: `ol${$605a31c9af2a8977$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $605a31c9af2a8977$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("xjCuM", function(module, exports) {

$parcel$export(module.exports, "doc", () => $06424d48e92613a9$export$2a111da947c407d2);

var $gthjq = parcelRequire("gthjq");
const $06424d48e92613a9$export$2a111da947c407d2 = (0, $gthjq.doc)({});

});

parcelRegister("kshOv", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $ee443d93678dbe0b$export$be4283d9a1cb1ff6);

var $gthjq = parcelRequire("gthjq");
const $ee443d93678dbe0b$export$be4283d9a1cb1ff6 = (0, $gthjq.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("7DoMR", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $58ef6723e99e5604$export$a19185d1233fc4b2);

var $4pzsz = parcelRequire("4pzsz");

var $gthjq = parcelRequire("gthjq");
const $58ef6723e99e5604$export$a19185d1233fc4b2 = (0, $gthjq.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $4pzsz.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $4pzsz.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("4pzsz", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $336500cbd1ca0f10$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $336500cbd1ca0f10$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $336500cbd1ca0f10$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $336500cbd1ca0f10$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $336500cbd1ca0f10$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $336500cbd1ca0f10$export$f61e93bda2a8b420(acName) {
    const emojiData = $336500cbd1ca0f10$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$336500cbd1ca0f10$var$acNameToEmojiMap[acName] ? $336500cbd1ca0f10$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($336500cbd1ca0f10$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $336500cbd1ca0f10$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$336500cbd1ca0f10$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $336500cbd1ca0f10$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($336500cbd1ca0f10$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $336500cbd1ca0f10$var$getAcNameFromShortName(shortName);
        if (possibleName in $336500cbd1ca0f10$var$acNameToEmojiMap) return possibleName;
    }
    return $336500cbd1ca0f10$export$bc94e44ec0e7bd82(id) || $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("hhN5g", function(module, exports) {

$parcel$export(module.exports, "extension", () => $c95a1940f4fa6aee$export$1b45514b112dd749);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $c95a1940f4fa6aee$export$1b45514b112dd749 = (0, $gthjq.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("jnMM2", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $e1c5ffc4cc369fdc$export$371da9dd35aba193);

var $gthjq = parcelRequire("gthjq");
const $e1c5ffc4cc369fdc$export$371da9dd35aba193 = (0, $gthjq.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("lRTZM", function(module, exports) {

$parcel$export(module.exports, "heading", () => $feb9fbb7aabe0cc7$export$46e4a324ac90507f);

var $gthjq = parcelRequire("gthjq");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $feb9fbb7aabe0cc7$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $feb9fbb7aabe0cc7$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $feb9fbb7aabe0cc7$export$46e4a324ac90507f = (0, $gthjq.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("7lRBh", function(module, exports) {

$parcel$export(module.exports, "image", () => $55a4127c569d3934$export$5c452ff88e35e47d);

var $gthjq = parcelRequire("gthjq");
const $55a4127c569d3934$export$5c452ff88e35e47d = (0, $gthjq.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("cCBEe", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $93063cb7956d3766$export$cbf8224b64e0d942);

var $gthjq = parcelRequire("gthjq");
const $93063cb7956d3766$export$cbf8224b64e0d942 = (0, $gthjq.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("5BOuQ", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $4157940155363fee$export$16b353b2649bd8d9);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $4157940155363fee$export$16b353b2649bd8d9 = (0, $gthjq.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("4EbxI", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $3623d9fd8951cfd2$export$ab76e7c03cd6f650);

var $gthjq = parcelRequire("gthjq");
const $3623d9fd8951cfd2$export$ab76e7c03cd6f650 = (0, $gthjq.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("7agO8", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $5376813d9b4ea07d$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $5376813d9b4ea07d$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $5376813d9b4ea07d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $5376813d9b4ea07d$export$54fd2c36b5cc6731);

var $51H8P = parcelRequire("51H8P");

var $gthjq = parcelRequire("gthjq");
const $5376813d9b4ea07d$export$bb3fe706be61f640 = (0, $gthjq.media)({}).attrs;
const $5376813d9b4ea07d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $5376813d9b4ea07d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $51H8P.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $5376813d9b4ea07d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$5376813d9b4ea07d$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $gthjq.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $gthjq.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ],
        toDOM: toDOM
    });
};
const $5376813d9b4ea07d$export$987d49ffe1b0900f = $5376813d9b4ea07d$export$35bdbf5bc8caa677($5376813d9b4ea07d$export$bb3fe706be61f640, false);
const $5376813d9b4ea07d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $5376813d9b4ea07d$export$111130fa8968d741 = (from, to, map)=>{
    if ($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs) Object.keys($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $5376813d9b4ea07d$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $5376813d9b4ea07d$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $5376813d9b4ea07d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $5376813d9b4ea07d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($5376813d9b4ea07d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("92lix", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $6944d24b2c8b0dd9$export$2855e964765eac9);

var $gthjq = parcelRequire("gthjq");
const $6944d24b2c8b0dd9$export$2855e964765eac9 = (0, $gthjq.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("7Xgp3", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $5caac46433adf3f0$export$38bab695e3f720f1);

var $7agO8 = parcelRequire("7agO8");

var $gthjq = parcelRequire("gthjq");
const $5caac46433adf3f0$export$38bab695e3f720f1 = (0, $7agO8.createMediaSpec)((0, $gthjq.mediaInline)({}).attrs, true);

});

parcelRegister("bIGZ7", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $888525ada96954d1$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $888525ada96954d1$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $888525ada96954d1$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $888525ada96954d1$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $888525ada96954d1$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $888525ada96954d1$export$54fd2c36b5cc6731);

var $ITAJ1 = parcelRequire("ITAJ1");

var $6VXbJ = parcelRequire("6VXbJ");

var $gthjq = parcelRequire("gthjq");
const $888525ada96954d1$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $888525ada96954d1$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $6VXbJ.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $ITAJ1.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $ITAJ1.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $gthjq.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $gthjq.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $888525ada96954d1$export$969fe3781ca15058 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$d35e6c006d4abdfb = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$9c58e19811ce4cf5 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$7e767666f2ce108a = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("ITAJ1", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $086f3b754fef02e1$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $086f3b754fef02e1$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("g7Cky", function(module, exports) {

$parcel$export(module.exports, "mention", () => $bbcb0873d657d42d$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $bbcb0873d657d42d$export$54fd2c36b5cc6731);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
let $bbcb0873d657d42d$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $bbcb0873d657d42d$export$db83999c14438df4 = (0, $gthjq.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $bbcb0873d657d42d$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $9IGaJ.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($bbcb0873d657d42d$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $bbcb0873d657d42d$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $bbcb0873d657d42d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($bbcb0873d657d42d$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("dx5eC", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $9da26af350402964$export$63cadbf5f4296627);

var $gthjq = parcelRequire("gthjq");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $9da26af350402964$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $9da26af350402964$export$63cadbf5f4296627 = (0, $gthjq.nestedExpand)({
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("dwptW", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $9d8207b1e6c47527$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $9d8207b1e6c47527$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $9d8207b1e6c47527$export$b9ab759e8298198f);

var $gthjq = parcelRequire("gthjq");
const $9d8207b1e6c47527$export$4e7125c7ff595be5 = '.ak-ol';
const $9d8207b1e6c47527$export$a5dc81035676e7a = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $9d8207b1e6c47527$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $9d8207b1e6c47527$export$b9ab759e8298198f = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $9d8207b1e6c47527$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $9d8207b1e6c47527$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("abme3", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $769c2c0b195d79f6$export$9c206ddddb32a9b);

var $gthjq = parcelRequire("gthjq");
const $769c2c0b195d79f6$export$9c206ddddb32a9b = (0, $gthjq.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $769c2c0b195d79f6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("dgJoa", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244);

var $gthjq = parcelRequire("gthjq");
const $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244 = (0, $gthjq.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("M4hHz", function(module, exports) {

$parcel$export(module.exports, "rule", () => $0907ce9fea0294ca$export$fbeb3a3956e8a3c7);

var $gthjq = parcelRequire("gthjq");
/**
 * @name rule_node
 */ const $0907ce9fea0294ca$var$hrDOM = [
    'hr'
];
const $0907ce9fea0294ca$export$fbeb3a3956e8a3c7 = (0, $gthjq.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $0907ce9fea0294ca$var$hrDOM;
    }
});

});

parcelRegister("18bvk", function(module, exports) {

$parcel$export(module.exports, "status", () => $0d2f764e7fea7c00$export$471f7ae5c4103ae1);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $0d2f764e7fea7c00$export$471f7ae5c4103ae1 = (0, $gthjq.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $9IGaJ.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("iThOL", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390 = (0, $gthjq.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("43mJF", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $2f3914100d01687b$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $2f3914100d01687b$export$375b6afcc5f4d291);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name taskList_node
 */ const $2f3914100d01687b$var$name = 'actionList';
const $2f3914100d01687b$export$c0ec71adb7a18fb2 = `[data-node-type="${$2f3914100d01687b$var$name}"]`;
const $2f3914100d01687b$export$375b6afcc5f4d291 = (0, $gthjq.taskList)({
    parseDOM: [
        {
            tag: `div${$2f3914100d01687b$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $2f3914100d01687b$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3DR6L", function(module, exports) {

$parcel$export(module.exports, "text", () => $2a6e35cab1a01b8e$export$6f093cfa640b7166);

var $gthjq = parcelRequire("gthjq");
const $2a6e35cab1a01b8e$export$6f093cfa640b7166 = (0, $gthjq.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("9X587", function(module, exports) {

$parcel$export(module.exports, "default", () => $01deabc8204e5493$export$2e2bcd8739ae039);
const $01deabc8204e5493$var$name = 'unknownBlock';
var $01deabc8204e5493$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $01deabc8204e5493$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$01deabc8204e5493$var$name}"]`
        }
    ]
};

});

parcelRegister("d1d6m", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $97a5880db351ce36$export$44b79b0979d0f0f7);

var $gthjq = parcelRequire("gthjq");
const $97a5880db351ce36$export$44b79b0979d0f0f7 = (0, $gthjq.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("6kr5W", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b);

var $gthjq = parcelRequire("gthjq");
const $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b = (0, $gthjq.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("f5oqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de1eca32602d427$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $kOFhM = parcelRequire("kOFhM");

var $dGzaM = parcelRequire("dGzaM");
var $9S8fM = parcelRequire("9S8fM");

var $9Iju4 = parcelRequire("9Iju4");
var $fIJEx = parcelRequire("fIJEx");
var $iiXGq = parcelRequire("iiXGq");
var $4ceoy = parcelRequire("4ceoy");
var $2DpUZ = parcelRequire("2DpUZ");

var $gmhCD = parcelRequire("gmhCD");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $iN9lO = parcelRequire("iN9lO");

var $ap7h6 = parcelRequire("ap7h6");

var $kFiBa = parcelRequire("kFiBa");

var $4NUlu = parcelRequire("4NUlu");
var $fc6h8 = parcelRequire("fc6h8");

var $VSDnB = parcelRequire("VSDnB");

var $dWAZk = parcelRequire("dWAZk");

var $1PVpv = parcelRequire("1PVpv");

var $gkwXh = parcelRequire("gkwXh");

var $4zXba = parcelRequire("4zXba");

var $iHYdz = parcelRequire("iHYdz");

var $8QpSo = parcelRequire("8QpSo");

var $bXrHm = parcelRequire("bXrHm");

var $9gOVJ = parcelRequire("9gOVJ");
var $12yAL = parcelRequire("12yAL");

var $TM1uy = parcelRequire("TM1uy");

var $knXBU = parcelRequire("knXBU");

var $1urn6 = parcelRequire("1urn6");

var $3kKuL = parcelRequire("3kKuL");

var $dyURG = parcelRequire("dyURG");

var $K5Jsy = parcelRequire("K5Jsy");

var $fCNtA = parcelRequire("fCNtA");

var $4BsEy = parcelRequire("4BsEy");

var $1pTqN = parcelRequire("1pTqN");

var $4YrGg = parcelRequire("4YrGg");

var $8Eu7T = parcelRequire("8Eu7T");

var $jUVor = parcelRequire("jUVor");

var $TPpI8 = parcelRequire("TPpI8");

var $kgV4b = parcelRequire("kgV4b");

var $OxITw = parcelRequire("OxITw");

var $3lRy2 = parcelRequire("3lRy2");
function $3de1eca32602d427$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3de1eca32602d427$export$47b2879ca9bbf67a = 2000;
const $3de1eca32602d427$export$1b622068be977101 = 3000;
const $3de1eca32602d427$var$packageName = "platform-pkg";
const $3de1eca32602d427$var$packageVersion = "0.0.0-use.local";
const $3de1eca32602d427$var$setAsQueryContainerStyles = {
    name: "isqlwl",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size;contain:layout style inline-size"
};
class $3de1eca32602d427$export$5161b00bb85c4267 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), /**
   * This is used in measuring the Renderer Mount time and is then
   * deleted once that measurement occurs.
   */ this.renderedMeasurementDistortedDurationMonitor = (0, $ap7h6.getDistortedDurationMonitor)(), this.createRendererContext = (0, $8QpSo.default)((featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                // The context is uninitialized at the top level. In nested levels it's all false
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }), this.fireAnalyticsEvent = (event)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) {
                const channel = (0, $dWAZk.FabricChannel).editor;
                createAnalyticsEvent(event).fire(channel);
            }
        }, this.getSchema = (0, $8QpSo.default)((schema, adfStage)=>{
            if (schema) return schema;
            return (0, $kOFhM.getSchemaBasedOnStage)(adfStage);
        }), this.onMouseDownEditView = ()=>{
            // When the user is deselecting text on the screen by clicking, if they are clicking outside
            // the current selection, by the time the onclick handler is called the window.getSelection()
            // value will already be cleared.
            // The mousedown callback is called before the selection is cleared.
            const windowSelection = window.getSelection();
            this.mouseDownSelection = windowSelection !== null ? windowSelection.toString() : undefined;
        }, this.handleMouseTripleClickInTables = (event)=>{
            if ((0, $gE8f9.browser).ios || (0, $gE8f9.browser).android) return;
            const badBrowser = (0, $gE8f9.browser).chrome || (0, $gE8f9.browser).safari;
            const tripleClick = event.detail >= 3;
            if (!(badBrowser && tripleClick)) return;
            const selection = window.getSelection();
            if (!selection) return;
            const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
            const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
            if (!rangeSelection) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            const tableCell = target.closest('td,th');
            const clickedInCell = Boolean(tableCell);
            if (!clickedInCell) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const anchorInCell = tableCell.contains(anchorNode);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const focusInCell = tableCell.contains(focusNode);
            const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
            if (!selectionStartsOrEndsOutsideClickedCell) return;
            // If selection starts or ends in a different cell than the clicked cell,
            // we select the node inside the clicked cell (or if both are in a different
            // cell, we select the cell's contents instead). We want to select the nearest
            // parent block, so that a whole line of text/content is selected (rather than
            // selecting a span that would select one specific chunk of text).
            const elementToSelect = anchorInCell ? // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            focusNode.parentElement?.closest('div,p') : tableCell;
            if (elementToSelect) selection.selectAllChildren(elementToSelect);
        };
        this.providerFactory = props.dataProviders || new (0, $dGzaM.default)();
        this.serializer = new (0, $9gOVJ.default)(this.deriveSerializerProps(props));
        this.editorRef = props.innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        (0, $iN9lO.startMeasure)(`Renderer Render Time: ${this.id}`);
    }
    anchorLinkAnalytics() {
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const { disableHeadingIDs: disableHeadingIDs } = this.props;
        if (!disableHeadingIDs && hash && this.editorRef && this.editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            // We are not use this.editorRef.querySelector here, instead we have this.editorRef.contains
            // because querySelector might fail if there are special characters in hash, and CSS.escape is still experimental.
            if (anchorLinkElement && this.editorRef.current.contains(anchorLinkElement)) this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
        }
    }
    componentDidMount() {
        this.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).STARTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB
            },
            eventType: (0, $gkwXh.EVENT_TYPE).UI
        });
        this.rafID = requestAnimationFrame(()=>{
            (0, $iN9lO.stopMeasure)(`Renderer Render Time: ${this.id}`, (duration)=>{
                const { analyticsEventSeverityTracking: analyticsEventSeverityTracking } = this.props;
                const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $fc6h8.shouldForceTracking)();
                const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $4NUlu.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                // ED-16320: Check for explicit disable so that by default
                // it will still be enabled as it currently is. Then we can
                // progressively opt out synthetic tenants.
                const isTTRTrackingExplicitlyDisabled = this.props?.analyticsEventSeverityTracking?.enabled === false;
                if (!isTTRTrackingExplicitlyDisabled) this.fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).RENDERED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                    attributes: {
                        platform: (0, $knXBU.PLATFORM).WEB,
                        duration: duration,
                        distortedDuration: // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.renderedMeasurementDistortedDurationMonitor.distortedDuration,
                        ttfb: (0, $kFiBa.getResponseEndTime)(),
                        nodes: (0, $kgV4b.countNodes)(this.props.document),
                        severity: severity
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.renderedMeasurementDistortedDurationMonitor.cleanup();
                delete this.renderedMeasurementDistortedDurationMonitor;
            });
            this.anchorLinkAnalytics();
        });
    }
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillReceiveProps(nextProps) {
        const nextMedia = nextProps.media || {};
        const media = this.props.media || {};
        if (nextProps.portal !== this.props.portal || nextProps.appearance !== this.props.appearance || nextProps.stickyHeaders !== this.props.stickyHeaders || nextProps.disableActions !== this.props.disableActions || nextProps.allowCustomPanels !== this.props.allowCustomPanels || nextProps.extensionHandlers !== this.props.extensionHandlers || nextProps.allowHeadingAnchorLinks !== this.props.allowHeadingAnchorLinks || nextMedia.allowLinking !== media.allowLinking) this.serializer = new (0, $9gOVJ.default)(this.deriveSerializerProps(nextProps));
    }
    deriveSerializerProps(props) {
        // if just passed a boolean, change shape into object to simplify type
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = this.createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos,
            providers: this.providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            // does not currently support SSR, should not be enabled in environments where Renderer is SSR-ed
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            textHighlighter: props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing
        };
    }
    render() {
        const { document: adfDocument, onComplete: onComplete, onError: onError, appearance: appearance, allowAnnotations: allowAnnotations, adfStage: adfStage, truncated: truncated, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, enableSsrInlineScripts: enableSsrInlineScripts, noOpSSRInlineScript: noOpSSRInlineScript, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, allowCustomPanels: allowCustomPanels, media: media, skipValidation: skipValidation } = this.props;
        const rendererContext = this.createRendererContext(this.props.featureFlags, this.props.isTopLevelRenderer);
        const allowNestedHeaderLinks = (0, $3kKuL.isNestedHeaderLinksEnabled)(allowHeadingAnchorLinks);
        /**
     * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
     * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
     * renderer out for the editor).
     * @param event Click event anywhere inside renderer
     */ const handleWrapperOnClick = (event)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const targetElement = event.target;
            // ED-14862: When a user triple clicks to select a line of content inside a
            // a table cell, but the browser incorrectly moves the selection start or end into
            // a different table cell, we manually set the selection back to within the original
            // table cell the user intended to target
            this.handleMouseTripleClickInTables(event);
            if (!this.props.eventHandlers?.onUnhandledClick) return;
            if (!(targetElement instanceof window.Element)) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const rendererWrapper = event.currentTarget;
            // Check if the click was on an interactive element
            const isInteractiveElementInTree = (0, $K5Jsy.findInTree)(targetElement, rendererWrapper, (0, $TPpI8.isInteractiveElement));
            if (isInteractiveElementInTree) return;
            // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
            // This logic originated in jira-frontend:
            // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
            // The selection is required to be checked in `onMouseDown` and here. If not here, a new
            // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
            // return an empty selection, which will erroneously fire onUnhandledClick.
            const windowSelection = window.getSelection();
            const selection = windowSelection !== null ? windowSelection.toString() : undefined;
            const hasSelection = selection && selection.length !== 0;
            const hasSelectionMouseDown = this.mouseDownSelection && this.mouseDownSelection.length !== 0;
            const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
            if (allowEditBasedOnSelection) this.props.eventHandlers.onUnhandledClick(event);
        };
        try {
            const schema = this.getSchema(this.props.schema, this.props.adfStage);
            const { result: result, stat: stat, pmDoc: pmDoc } = (0, $12yAL.renderDocument)(adfDocument, this.serializer, schema, adfStage, this.props.useSpecBasedValidator, this.id, this.fireAnalyticsEvent, this.props.unsupportedContentLevelsTracking, this.props.appearance, this.props.includeNodesCountInStats, skipValidation);
            if (onComplete) onComplete(stat);
            const rendererOutput = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dyURG.RendererContextProvider), {
                value: rendererContext
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1pTqN.ActiveHeaderIdProvider), {
                value: (0, $3kKuL.getActiveHeadingId)(allowHeadingAnchorLinks)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $TM1uy.default).Provider, {
                value: {
                    fireAnalyticsEvent: (event)=>this.fireAnalyticsEvent(event)
                }
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4BsEy.Provider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9S8fM.ProviderFactoryProvider), {
                value: this.providerFactory
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
                allowAnnotations: allowAnnotations,
                appearance: appearance,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                allowColumnSorting: allowColumnSorting,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowCustomPanels: allowCustomPanels,
                allowPlaceholderText: allowPlaceholderText,
                useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                addTelepointer: this.props.addTelepointer,
                innerRef: this.editorRef,
                onClick: handleWrapperOnClick,
                onMouseDown: this.onMouseDownEditView,
                ssr: media?.ssr,
                isInsideOfInlineExtension: this.props.isInsideOfInlineExtension,
                isTopLevelRenderer: rendererContext.isTopLevelRenderer
            }, enableSsrInlineScripts || noOpSSRInlineScript ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUVor.BreakoutSSRInlineScript), {
                noOpSSRInlineScript: Boolean(noOpSSRInlineScript)
            }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
                doc: pmDoc,
                schema: schema,
                onAnalyticsEvent: this.fireAnalyticsEvent
            }, result)))))));
            const rendererResult = truncated ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3lRy2.TruncatedWrapper), {
                height: maxHeight,
                fadeHeight: fadeOutHeight
            }, rendererOutput) : rendererOutput;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, rendererResult);
        } catch (e) {
            if (onError) onError(e);
            return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
                allowAnnotations: allowAnnotations,
                appearance: appearance,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowPlaceholderText: allowPlaceholderText,
                allowColumnSorting: allowColumnSorting,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                addTelepointer: this.props.addTelepointer,
                onClick: handleWrapperOnClick,
                isTopLevelRenderer: rendererContext.isTopLevelRenderer
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iiXGq.default), null));
        }
    }
    componentWillUnmount() {
        const { dataProviders: dataProviders } = this.props;
        if (this.rafID) window.cancelAnimationFrame(this.rafID);
        // if this is the ProviderFactory which was created in constructor
        // it's safe to destroy it on Renderer unmount
        if (!dataProviders) this.providerFactory.destroy();
    }
}
const $3de1eca32602d427$var$handleMouseTripleClickInTables = (event)=>{
    if ((0, $gE8f9.browser).ios || (0, $gE8f9.browser).android) return;
    const badBrowser = (0, $gE8f9.browser).chrome || (0, $gE8f9.browser).safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 */ const $3de1eca32602d427$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $3de1eca32602d427$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $K5Jsy.findInTree)(targetElement, rendererWrapper, (0, $TPpI8.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $3de1eca32602d427$var$RendererFunctionalComponent = (props)=>{
    const mouseDownSelection = (0, $5uXOq.useRef)(undefined);
    const providerFactory = (0, $5uXOq.useMemo)(()=>props.dataProviders || new (0, $dGzaM.default)(), [
        props.dataProviders
    ]);
    const createRendererContext = (0, $5uXOq.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }, []);
    const fireAnalyticsEvent = (0, $5uXOq.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const deriveSerializerProps = (0, $5uXOq.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            textHighlighter: props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent
    ]);
    const serializer = (0, $5uXOq.useMemo)(()=>new (0, $9gOVJ.default)(deriveSerializerProps({
            ...props,
            startPos: props.startPos ?? 0
        })), [
        deriveSerializerProps,
        props
    ]);
    const localRef = (0, $5uXOq.useRef)(null);
    const editorRef = props.innerRef || localRef;
    const id = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $5uXOq.useMemo)(()=>(0, $ap7h6.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $5uXOq.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $iN9lO.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $5uXOq.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $5uXOq.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $kOFhM.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $5uXOq.useEffect)(()=>{
        let rafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).STARTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $iN9lO.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $fc6h8.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $4NUlu.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).RENDERED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, $knXBU.PLATFORM).WEB,
                            duration: duration,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, $kFiBa.getResponseEndTime)(),
                            nodes: (0, $kgV4b.countNodes)(props.document),
                            severity: severity
                        },
                        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                    });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $12yAL.renderDocument)(props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dyURG.RendererContextProvider), {
            value: createRendererContext(props.featureFlags, props.isTopLevelRenderer)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1pTqN.ActiveHeaderIdProvider), {
            value: (0, $3kKuL.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $TM1uy.default).Provider, {
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4BsEy.Provider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9S8fM.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: createRendererContext(props.featureFlags, props.isTopLevelRenderer).featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: createRendererContext(props.featureFlags, props.isTopLevelRenderer).isTopLevelRenderer
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUVor.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3lRy2.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: createRendererContext(props.featureFlags, props.isTopLevelRenderer).featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: createRendererContext(props.featureFlags, props.isTopLevelRenderer).isTopLevelRenderer
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iiXGq.default), null));
    }
};
function $3de1eca32602d427$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $4YrGg.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    return (0, $VSDnB.fg)('platform_editor_react18_renderer') ? /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererFunctionalComponent, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: isTopLevelRenderer
    }) : // eslint-disable-next-line react/jsx-pascal-case
    /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$5161b00bb85c4267, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: isTopLevelRenderer
    });
}
const $3de1eca32602d427$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $4NUlu.getAnalyticsAppearance)(props.appearance),
            packageName: $3de1eca32602d427$var$packageName,
            packageVersion: $3de1eca32602d427$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))()
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2DpUZ.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8Eu7T.ErrorBoundary), {
                component: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fIJEx.IntlErrorBoundary), null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $3de1eca32602d427$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $OxITw.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    (0, $5uXOq.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $OxITw.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $OxITw.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Iju4.BaseTheme), {
        baseFontSize: appearance && appearance !== 'comment' ? (0, $iHYdz.akEditorFullPageDefaultFontSize) : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1urn6.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $OxITw.rendererStyles)({
            appearance: appearance,
            allowNestedHeaderLinks: allowNestedHeaderLinks,
            allowColumnSorting: !!allowColumnSorting,
            useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
            allowAnnotations: props.allowAnnotations,
            allowTableResizing: allowTableResizing
        })
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'comment') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && (0, $VSDnB.fg)('platform-fix-table-ssr-resizing') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3de1eca32602d427$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $3de1eca32602d427$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $3de1eca32602d427$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($3de1eca32602d427$var$RootRendererContext);
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const rendererRef = (0, $5uXOq.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children);
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $3de1eca32602d427$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fCNtA.RendererActionsContext), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4YrGg.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $3de1eca32602d427$export$2e2bcd8739ae039 = $3de1eca32602d427$var$RendererWithAnnotationSelection;

});
parcelRegister("dGzaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $586c606cb83743fd$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $586c606cb83743fd$var$isUndefined(x) {
    return x === undefined;
}
class $586c606cb83743fd$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $586c606cb83743fd$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$586c606cb83743fd$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("9S8fM", function(module, exports) {

$parcel$export(module.exports, "ProviderFactoryProvider", () => $d1ee541d73df1fcd$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $d1ee541d73df1fcd$export$693cdb10cec23617);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");
const $d1ee541d73df1fcd$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $dGzaM.default)());
const $d1ee541d73df1fcd$export$617c134b25cc4265 = $d1ee541d73df1fcd$var$ProviderFactoryContext.Provider;
const $d1ee541d73df1fcd$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($d1ee541d73df1fcd$var$ProviderFactoryContext);
const $d1ee541d73df1fcd$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("9Iju4", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $b0fd15d81ba0fb5a$export$a1a213d350ca51ca);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $g0wej = parcelRequire("g0wej");

var $iHYdz = parcelRequire("iHYdz");

var $4ceoy = parcelRequire("4ceoy");
function $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $b0fd15d81ba0fb5a$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $iHYdz.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0wej.a), {
        theme: memoizedTheme,
        children: children
    });
}
function $b0fd15d81ba0fb5a$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $2OMIu.jsx)($b0fd15d81ba0fb5a$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: children
                })
            })
    });
}

});
parcelRegister("iHYdz", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $01f0a5ace820da37$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $01f0a5ace820da37$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $01f0a5ace820da37$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $01f0a5ace820da37$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $01f0a5ace820da37$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $01f0a5ace820da37$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $01f0a5ace820da37$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $01f0a5ace820da37$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $01f0a5ace820da37$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $01f0a5ace820da37$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $01f0a5ace820da37$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $01f0a5ace820da37$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $01f0a5ace820da37$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $01f0a5ace820da37$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBoldBoxShadow", () => $01f0a5ace820da37$export$37e178ca41c198ca);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $01f0a5ace820da37$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $01f0a5ace820da37$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $01f0a5ace820da37$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $01f0a5ace820da37$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $01f0a5ace820da37$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $01f0a5ace820da37$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $01f0a5ace820da37$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $01f0a5ace820da37$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $01f0a5ace820da37$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $01f0a5ace820da37$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $01f0a5ace820da37$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $01f0a5ace820da37$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $01f0a5ace820da37$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $01f0a5ace820da37$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $01f0a5ace820da37$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $01f0a5ace820da37$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $01f0a5ace820da37$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $01f0a5ace820da37$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $01f0a5ace820da37$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $01f0a5ace820da37$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $01f0a5ace820da37$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $01f0a5ace820da37$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $01f0a5ace820da37$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $01f0a5ace820da37$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $01f0a5ace820da37$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $01f0a5ace820da37$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $01f0a5ace820da37$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $01f0a5ace820da37$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $01f0a5ace820da37$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $01f0a5ace820da37$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $01f0a5ace820da37$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $01f0a5ace820da37$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $01f0a5ace820da37$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $01f0a5ace820da37$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $01f0a5ace820da37$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $01f0a5ace820da37$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $01f0a5ace820da37$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $01f0a5ace820da37$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $01f0a5ace820da37$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $01f0a5ace820da37$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $01f0a5ace820da37$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $01f0a5ace820da37$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $01f0a5ace820da37$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $01f0a5ace820da37$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $01f0a5ace820da37$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $01f0a5ace820da37$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $01f0a5ace820da37$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $01f0a5ace820da37$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $01f0a5ace820da37$export$59733a9f61449b25);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $01f0a5ace820da37$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $01f0a5ace820da37$export$42608c013398a830);

var $VSDnB = parcelRequire("VSDnB");
const $01f0a5ace820da37$export$fe6b0b821a0e9067 = 16;
const $01f0a5ace820da37$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $01f0a5ace820da37$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $01f0a5ace820da37$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$f0e953d95429ca1 = '12px';
const $01f0a5ace820da37$export$a309dbdeca0adb1a = '2px 4px';
const $01f0a5ace820da37$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $01f0a5ace820da37$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $01f0a5ace820da37$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $01f0a5ace820da37$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $01f0a5ace820da37$export$d2715266dd4a1fd1 = 20;
const $01f0a5ace820da37$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $01f0a5ace820da37$export$8dac549e32469ac4 = 1;
const $01f0a5ace820da37$export$befaaae517e3d864 = 2;
const $01f0a5ace820da37$export$6e1e1996c4e8cc51 = `${$01f0a5ace820da37$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$b6a59ac3a19b6343 = `0 0 0 ${$01f0a5ace820da37$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$37e178ca41c198ca = `0 0 0 ${$01f0a5ace820da37$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$4a007c22e25e31f6 = 0.3;
const $01f0a5ace820da37$export$f35cc48f3398ab79 = 1;
const $01f0a5ace820da37$export$b46cda584c619451 = 2;
const $01f0a5ace820da37$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $01f0a5ace820da37$export$321ddd2f049dd12 = $01f0a5ace820da37$export$6bed85de54b5de42 + 1;
const $01f0a5ace820da37$export$daeac9b8422ac3c2 = 2;
const $01f0a5ace820da37$export$501d46e11ed5bf73 = 500;
const $01f0a5ace820da37$export$6817b4b6a5ef78f1 = 400;
const $01f0a5ace820da37$export$93768eb72dec48ce = $01f0a5ace820da37$export$501d46e11ed5bf73 + 10;
const $01f0a5ace820da37$export$c0aec4e0896849a0 = $01f0a5ace820da37$export$93768eb72dec48ce - 5;
const $01f0a5ace820da37$export$5886f057e4f21fe4 = $01f0a5ace820da37$export$6817b4b6a5ef78f1 + 5;
const $01f0a5ace820da37$export$6e85faa46d537a3f = 11;
const $01f0a5ace820da37$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $01f0a5ace820da37$export$95e9a0285b97474d = '#2C333A';
const $01f0a5ace820da37$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $01f0a5ace820da37$export$76b5e653883e5290 = '3px';
const $01f0a5ace820da37$export$6d85fe8177a50c0c = 0.5;
const $01f0a5ace820da37$export$fad19f16d3f953a3 = 680;
const $01f0a5ace820da37$export$9db045950eedb49f = 760;
const $01f0a5ace820da37$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $01f0a5ace820da37$export$f580e3d28d0986de = 1800;
const $01f0a5ace820da37$export$9d5488b5afad62bf = 1792;
const $01f0a5ace820da37$export$37df10057d36a0e5 = 42;
const $01f0a5ace820da37$export$437293c5e9fc2703 = 96;
const $01f0a5ace820da37$export$6e0f4d52efd3d2d = 32;
const $01f0a5ace820da37$export$f222e0c7a2dc5324 = ()=>(0, $VSDnB.fg)('platform_editor_core_increase_full_page_guttering') ? 52 : 32;
const $01f0a5ace820da37$export$efe8561bbd3f74d2 = 720;
const $01f0a5ace820da37$export$e4d39a9e8607c1d3 = 48;
const $01f0a5ace820da37$export$43946f2400ab6f1f = 128;
const $01f0a5ace820da37$export$558438ae7fd4b8ce = 12;
const $01f0a5ace820da37$export$6beb98d32d4ca149 = 4;
const $01f0a5ace820da37$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $01f0a5ace820da37$export$5edb4f38c3eacb1a = 1024;
const $01f0a5ace820da37$export$e60820063058ed59 = 1.33;
const $01f0a5ace820da37$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $01f0a5ace820da37$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $01f0a5ace820da37$export$fb15fade89f67217 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 99;
const $01f0a5ace820da37$export$847030921e9d5a40 = 12;
const $01f0a5ace820da37$export$40eb41ab799f0329 = 1.714;
const $01f0a5ace820da37$export$e271312fc7124aec = '1px';
const $01f0a5ace820da37$export$d29cb2c31fcbb7c5 = 2;
const $01f0a5ace820da37$export$688a6dc01e760755 = 320;
const $01f0a5ace820da37$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $01f0a5ace820da37$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $01f0a5ace820da37$export$e88f6c898960b391 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $01f0a5ace820da37$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $01f0a5ace820da37$export$1d0d506416d457f1 = '0.75rem';
const $01f0a5ace820da37$export$e683ef42725d1713 = 680;
const $01f0a5ace820da37$export$226c784ba04bd04b = 480;
const $01f0a5ace820da37$export$214ff00e5618d86c = 20;
const $01f0a5ace820da37$export$c82675fa56f2eefd = '56px';
const $01f0a5ace820da37$var$DEFAULT_FONT_SIZE = 14;
const $01f0a5ace820da37$export$d7726a000ae2d7c = ()=>(0, $VSDnB.fg)('live_pages_content_jump_mitigation') ? '2.188rem' : "var(--ds-space-500, 40px)";
const $01f0a5ace820da37$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $01f0a5ace820da37$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $01f0a5ace820da37$var$DEFAULT_FONT_SIZE;
const $01f0a5ace820da37$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$01f0a5ace820da37$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $01f0a5ace820da37$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $01f0a5ace820da37$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $01f0a5ace820da37$export$9369fd010fa0ddd6 = 0;
const $01f0a5ace820da37$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $01f0a5ace820da37$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $01f0a5ace820da37$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
    }
];

});

parcelRegister("4ceoy", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $a2904bcfe480568e$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $a2904bcfe480568e$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $a2904bcfe480568e$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $a2904bcfe480568e$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $a2904bcfe480568e$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8QpSo = parcelRequire("8QpSo");

var $7nRxN = parcelRequire("7nRxN");

var $gJlZe = parcelRequire("gJlZe");

var $1v3g5 = parcelRequire("1v3g5");
function $a2904bcfe480568e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a2904bcfe480568e$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $a2904bcfe480568e$var$SCROLLBAR_WIDTH = 30;
function $a2904bcfe480568e$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $a2904bcfe480568e$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $a2904bcfe480568e$export$1eb095b00b926404(width)
    };
}
const $a2904bcfe480568e$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($a2904bcfe480568e$export$31a4966bffb9ac98());
const { Provider: $a2904bcfe480568e$var$Provider, Consumer: $a2904bcfe480568e$export$5d8538aa831b6ebb } = $a2904bcfe480568e$export$27e39f636459b9f;
const $a2904bcfe480568e$export$df154c49e93b2ac2 = (0, $8QpSo.default)(()=>{
    return (0, $1v3g5.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $a2904bcfe480568e$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $5uXOq.useContext)($a2904bcfe480568e$export$27e39f636459b9f);
    const [width, setWidth] = (0, $5uXOq.useState)($a2904bcfe480568e$export$df154c49e93b2ac2);
    const widthRef = (0, $5uXOq.useRef)(width);
    const isMountedRef = (0, $5uXOq.useRef)(true);
    const providerValue = (0, $5uXOq.useMemo)(()=>$a2904bcfe480568e$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $5uXOq.useMemo)(()=>{
        return (0, $7nRxN.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $a2904bcfe480568e$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $a2904bcfe480568e$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gJlZe.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($a2904bcfe480568e$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("1v3g5", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $161da1f5bf80dbfb$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $161da1f5bf80dbfb$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("fIJEx", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $f1eccfecc1c43fb5$export$7df0749115d18d19);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $f1eccfecc1c43fb5$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f1eccfecc1c43fb5$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("iiXGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $94120525d10931b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $eJS47 = parcelRequire("eJS47");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $94120525d10931b9$var$blockNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $94120525d10931b9$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent, (0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $94120525d10931b9$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJS47))), {
        label: "?",
        size: "small"
    })))));
};
var $94120525d10931b9$export$2e2bcd8739ae039 = (0, $8RXs9.default)($94120525d10931b9$var$UnsupportedBlockNode);

});
parcelRegister("gkwXh", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $97c56ca7515fdb59$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $97c56ca7515fdb59$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $97c56ca7515fdb59$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $97c56ca7515fdb59$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $97c56ca7515fdb59$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $97c56ca7515fdb59$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $97c56ca7515fdb59$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $97c56ca7515fdb59$export$9f0b2adf3cfd71b7);
var $97c56ca7515fdb59$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $97c56ca7515fdb59$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_TTI"] = "tti";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
    ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
    ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDERN"] = "getChildern";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    return ACTION;
}({});
var $97c56ca7515fdb59$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    return INPUT_METHOD;
}({});
var $97c56ca7515fdb59$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $97c56ca7515fdb59$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    return TRIGGER_METHOD;
}({});
var $97c56ca7515fdb59$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    return ACTION_SUBJECT;
}({});
var $97c56ca7515fdb59$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    return ACTION_SUBJECT_ID;
}({});
var $97c56ca7515fdb59$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $97c56ca7515fdb59$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("7R1zM", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $757d518931aaa671$export$32ec96484dd3ba39);

var $7VHMR = parcelRequire("7VHMR");
const $757d518931aaa671$export$32ec96484dd3ba39 = (0, $7VHMR.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("d54NZ", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $850930d0b79c2a61$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $850930d0b79c2a61$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $850930d0b79c2a61$export$3a34598135e7219b);

var $gkwXh = parcelRequire("gkwXh");
const $850930d0b79c2a61$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $850930d0b79c2a61$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $850930d0b79c2a61$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $850930d0b79c2a61$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$850930d0b79c2a61$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $850930d0b79c2a61$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$850930d0b79c2a61$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $850930d0b79c2a61$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $850930d0b79c2a61$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $850930d0b79c2a61$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $850930d0b79c2a61$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor((0, $gkwXh.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("9tFGn", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $3ba5e7dd155390b9$export$d4ded51d0f0bd2df);
function $3ba5e7dd155390b9$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("2DpUZ", function(module, exports) {

$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $10143a74d71d9da7$export$9ac3d19711324187);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
const $10143a74d71d9da7$export$9ac3d19711324187 = (0, $cb25w.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("gmhCD", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $a90e6fd79e0e0cb2$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $a90e6fd79e0e0cb2$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iEN9D = parcelRequire("iEN9D");

var $hdkTE = parcelRequire("hdkTE");

var $a0Psj = parcelRequire("a0Psj");
function $a90e6fd79e0e0cb2$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $hdkTE.editorExperimentsConfig)[experimentName];
    if ((0, $a0Psj._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._overrides)[experimentName] === expectedExperimentValue;
    if (!(0, $a0Psj._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig.productKeys?.[0, $a0Psj._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $hdkTE.editorExperimentsConfig)[experimentName].defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}
function $a90e6fd79e0e0cb2$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $a0Psj._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});
parcelRegister("hdkTE", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $7a273b3c03491c92$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $9qwvi = parcelRequire("9qwvi");
const $7a273b3c03491c92$export$6cbb856f286b07ef = {
    // Added 2024-08-08
    'example-boolean': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        // Note -- you need to set the type to boolean for the default value
        defaultValue: false
    },
    // Added 2024-08-08
    'example-multivariate': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        typeGuard: (0, $9qwvi.oneOf)([
            'one',
            'two',
            'three'
        ]),
        // Note -- you need to specify the type of the default value as the union of all possible values
        // This is used to provide type safety on consumption
        defaultValue: 'one'
    },
    // Added 2024-08-08
    'test-new-experiments-package': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Add 2024-08-14
    'basic-text-transformations': {
        productKeys: {
            confluence: 'platform_editor_basic_text_transformations'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-28
    'element-level-templates': {
        productKeys: {
            confluence: 'platform_editor_element_level_templates'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-29
    'add-media-from-url': {
        productKeys: {
            confluence: 'platform_editor_add_media_from_url'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-30
    'nested-dnd': {
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_nested'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-29
    'insert-menu-in-right-rail': {
        productKeys: {
            confluence: 'platform_editor_insert_menu_in_right_rail'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-05
    support_table_in_comment: {
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: {
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: {
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-18
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nest_nested_expand_in_expand/setup
    'nested-expand-in-expand': {
        productKeys: {
            confluence: 'platform_editor_nest_nested_expand_in_expand'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-23
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/editor_ai_-_multi_prompts/setup
    'editor_ai_-_multi_prompts': {
        productKeys: {
            confluence: 'editor_ai_-_multi_prompts'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 2024-10-01
    comment_on_bodied_extensions: {
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: {
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-10-08
    support_table_in_comment_jira: {
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    'platform_editor_ai-prompts-placeholder': {
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': {
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-11-13
    issue_view_action_items: {
        productKeys: {
            jira: 'issue_view_action_items'
        },
        param: 'isActionItemsEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-11-18
    contextual_formatting_toolbar: {
        productKeys: {
            confluence: 'platform_editor_contextual_formatting_toolbar_exp'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-11-19
    platform_editor_ai_1p_smart_link_unfurl_in_prompt: {
        productKeys: {
            confluence: 'platform_editor_ai_1p_smart_link_unfurl_in_prompt'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: {
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-15
    platform_editor_ai_advanced_prompts: {
        productKeys: {
            confluence: 'platform_editor_ai_advanced_prompts'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    expand_selection_range_to_include_inline_node: {
        productKeys: {
            confluence: 'expand_selection_range_to_include_inline_node'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: {
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-09
    platform_editor_advanced_code_blocks: {
        productKeys: {
            confluence: 'platform_editor_advanced_code_blocks'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: {
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-16
    live_pages_graceful_edit: {
        productKeys: {
            confluence: 'live_pages_graceful_edit'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'text-click-delayed',
            'text-click-no-delay',
            'initially-hide-toolbar'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-01-20
    platform_editor_contextual_formatting_toolbar_v2: {
        productKeys: {
            confluence: 'platform_editor_contextual_formatting_toolbar_v2'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'variant1',
            'variant2'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: {
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-22
    platform_editor_ai_jira_content_read_url: {
        productKeys: {
            jira: 'platform_editor_ai_jira_content_read_url'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    }
};

});
parcelRegister("9qwvi", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $41035ee8947774ef$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $41035ee8947774ef$export$a9a18ae5ba42aeab);
function $41035ee8947774ef$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $41035ee8947774ef$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($41035ee8947774ef$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $41035ee8947774ef$var$IS_TESTING_ENV = false;

});


parcelRegister("a0Psj", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $ae2371e90434836c$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $ae2371e90434836c$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $ae2371e90434836c$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $ae2371e90434836c$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $hdkTE = parcelRequire("hdkTE");
let $ae2371e90434836c$export$e5d73bf4f8e2ae96 = {};
let $ae2371e90434836c$export$4e849416bb5c5b52 = {};
let $ae2371e90434836c$export$cf7305fc65acbf0d;
function $ae2371e90434836c$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $hdkTE.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $ae2371e90434836c$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    $ae2371e90434836c$export$cf7305fc65acbf0d = product;
    if (paramOverrides) $ae2371e90434836c$export$4e849416bb5c5b52 = paramOverrides;
}

});


parcelRegister("gE8f9", function(module, exports) {

$parcel$export(module.exports, "browser", () => $6911d91f679e4e6c$export$3f2684e5d7cb1006);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6911d91f679e4e6c$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieEdge = /(?:Edge|Edg)\/(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.windows = // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigator.userAgentData?.platform === 'Windows' || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /Windows|Win\d+/i.test(navigator.userAgent);
    const ie = $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ios = // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari_version = parseInt(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}

});

parcelRegister("iN9lO", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $420059dd531814dc$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $420059dd531814dc$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $420059dd531814dc$export$6f766653554dac02);

var $b7gJe = parcelRequire("b7gJe");
const $420059dd531814dc$var$measureMap = new Map();
function $420059dd531814dc$export$b62aa2130c86b59b(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $420059dd531814dc$var$measureMap.set(measureName, performance.now());
}
function $420059dd531814dc$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $420059dd531814dc$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $420059dd531814dc$export$6f766653554dac02(measureName);
    }
}
function $420059dd531814dc$export$6f766653554dac02(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    $420059dd531814dc$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $420059dd531814dc$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return false;
    return $420059dd531814dc$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("b7gJe", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $da51e67df7144cd5$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $da51e67df7144cd5$export$48995af1e77d8643);
let $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
function $da51e67df7144cd5$export$b5717a625dd4a3eb() {
    if ($da51e67df7144cd5$var$hasRequiredPerformanceAPIs === undefined) $da51e67df7144cd5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
}
function $da51e67df7144cd5$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $da51e67df7144cd5$export$4370ec0f52022f66() {
    return $da51e67df7144cd5$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("ap7h6", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $3e05ce213e57560b$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $3e05ce213e57560b$export$267ed650a5d21ae6);

var $b7gJe = parcelRequire("b7gJe");
const $3e05ce213e57560b$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $3e05ce213e57560b$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $3e05ce213e57560b$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("kFiBa", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $9d05c46136d117ff$export$92d097a1155bbe27);

var $b7gJe = parcelRequire("b7gJe");
function $9d05c46136d117ff$export$92d097a1155bbe27() {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("4NUlu", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $d9ce436f8d702318$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $d9ce436f8d702318$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $d9ce436f8d702318$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "analyticsEventKey", () => $d9ce436f8d702318$export$288273ee3e3b6132);

var $d93fQ = parcelRequire("d93fQ");
const $d9ce436f8d702318$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $d9ce436f8d702318$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$d9ce436f8d702318$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $d9ce436f8d702318$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
var $d9ce436f8d702318$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $d9ce436f8d702318$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});

parcelRegister("fc6h8", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $d5e5ded83470406e$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $d5e5ded83470406e$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("4zXba", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $e819a2725d93345d$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $e819a2725d93345d$export$6d018dd0f6cbebcb);

var $e4eHl = parcelRequire("e4eHl");

var $3T6Xo = parcelRequire("3T6Xo");
const $e819a2725d93345d$var$EMPTY = {};
function $e819a2725d93345d$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $e819a2725d93345d$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $e819a2725d93345d$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $e819a2725d93345d$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($e819a2725d93345d$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(e[0]), e[1], options?.objectFlagKeys) && $e819a2725d93345d$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($e819a2725d93345d$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $e819a2725d93345d$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("9gOVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a549b54270369c2c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kCV8T = parcelRequire("kCV8T");

var $gmhCD = parcelRequire("gmhCD");

var $3kKuL = parcelRequire("3kKuL");
parcelRequire("gJX6d");
var $5KNWO = parcelRequire("5KNWO");
var $gJX6d = parcelRequire("gJX6d");

var $5BLIh = parcelRequire("5BLIh");

var $cKKwC = parcelRequire("cKKwC");
var $GDkvY = parcelRequire("GDkvY");

var $eQNWQ = parcelRequire("eQNWQ");

var $5or39 = parcelRequire("5or39");

var $K5Jsy = parcelRequire("K5Jsy");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $bzwTW = parcelRequire("bzwTW");

var $bVGKe = parcelRequire("bVGKe");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");
function $a549b54270369c2c$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $kCV8T.MarkType) && prev && prev.type instanceof (0, $kCV8T.MarkType) && Array.isArray(prev.content) && (0, $eQNWQ.isSameMark)(prev, markOrNode)) prev.content = $a549b54270369c2c$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $a549b54270369c2c$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
	 * The reason we have this extra array here is because we need to generate the same unique
	 * heading id for 2 different nodes: headers and expands (check the implementation of
	 * `getUniqueHeadingId` for more info).
	 *
	 * We will eventually need to refactor the current approach to generate unique ids
	 * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
	 */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $gJX6d.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $GDkvY.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $cKKwC.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $cKKwC.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $bVGKe.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $5KNWO.DocWithSelectAllTrap) : (0, $5KNWO.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $a549b54270369c2c$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $gJX6d.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        return $a549b54270369c2c$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $gJX6d.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            return this.renderMark((0, $GDkvY.toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5BLIh.default), {
                key: textKey,
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks
            }, mark.text);
        }
        const segments = (0, $h5tvG.segmentText)(mark.text, this.textHighlighter);
        return (0, $3VpWO.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NodeComponent, {
            key: key,
            ...props
        }, content));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MarkComponent, {
            key: key,
            ...props
        }, content));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        // TODO: https://product-fabric.atlassian.net/browse/CEMS-1048
        const stickyHeaders = !(0, $bzwTW.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $bzwTW.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $bzwTW.insideTable)(path, node.type.schema);
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: // When allowTableResizing is enabled, the number of columns is required to render
            // the same scaling logic as editor. Some tables can have unequal rows, so the entire
            // table needs to be scanned.
            this.allowTableResizing && (0, $VSDnB.fg)('platform_editor_table_col_calculation_fix') ? (0, $5or39.getColumnWidths)(node) : (0, $5or39.calcTableColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
        };
    }
    getEmojiProps(node) {
        return {
            ...this.getProps(node),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $5r0mK.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $K5Jsy.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $gJX6d.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $eQNWQ.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $a549b54270369c2c$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    // TODO: ED-9004 Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $a549b54270369c2c$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("3kKuL", function(module, exports) {

$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $e845fca6b21fd822$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $e845fca6b21fd822$export$acb253d79d72af92);
function $e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $e845fca6b21fd822$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("gJX6d", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $2b5167c1d6aa176d$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $2b5167c1d6aa176d$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $2b5167c1d6aa176d$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $2b5167c1d6aa176d$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $2b5167c1d6aa176d$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $2b5167c1d6aa176d$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("5KNWO")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("5KNWO")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $4qBtX = parcelRequire("4qBtX");

var $atrOQ = parcelRequire("atrOQ");

var $4dtZR = parcelRequire("4dtZR");

var $bQeYo = parcelRequire("bQeYo");

var $cOnYv = parcelRequire("cOnYv");

var $cWRvh = parcelRequire("cWRvh");

var $5KNWO = parcelRequire("5KNWO");

var $i8Zwf = parcelRequire("i8Zwf");

var $lKIDi = parcelRequire("lKIDi");

var $7AttJ = parcelRequire("7AttJ");

var $112O7 = parcelRequire("112O7");

var $ieJGA = parcelRequire("ieJGA");

var $3RqVz = parcelRequire("3RqVz");

var $qjsNK = parcelRequire("qjsNK");

var $jHa9U = parcelRequire("jHa9U");

var $6svWT = parcelRequire("6svWT");

var $9FXQX = parcelRequire("9FXQX");

var $hqBb9 = parcelRequire("hqBb9");

var $ixoQV = parcelRequire("ixoQV");

var $dkc63 = parcelRequire("dkc63");

var $cWojJ = parcelRequire("cWojJ");

var $i4Lgj = parcelRequire("i4Lgj");

var $gfMkN = parcelRequire("gfMkN");

var $iiXGq = parcelRequire("iiXGq");
var $9kpKZ = parcelRequire("9kpKZ");

const $2b5167c1d6aa176d$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("b7uH5")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4nigH")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("jjsQN")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("0K8mZ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("k7Zs2")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("aNesC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("57OMq")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bfPot")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("7mtWi")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("cyYfQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bat28")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("iyg8s")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("gQJy5")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("7UIjK")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("lmZTQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4kfHt")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("hPQIC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("3ceee")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bbv0R")).then((mod)=>mod.default),
    loading: ()=>null
});
const $2b5167c1d6aa176d$export$3931063f6a5f290e = {
    blockquote: (0, $atrOQ.default),
    bulletList: (0, $cWRvh.default),
    blockCard: $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0,
    caption: (0, $jHa9U.default),
    date: $2b5167c1d6aa176d$export$6341f9a885713487,
    decisionItem: $2b5167c1d6aa176d$export$b6f73a2b0b0de599,
    decisionList: $2b5167c1d6aa176d$export$b458dfa720128865,
    doc: (0, $5KNWO.default),
    emoji: $2b5167c1d6aa176d$export$56cc48506ff790a,
    extension: (0, $i8Zwf.default),
    bodiedExtension: (0, $4dtZR.default),
    multiBodiedExtension: (0, $bQeYo.default),
    extensionFrame: (0, $cOnYv.default),
    hardBreak: (0, $lKIDi.default),
    heading: (0, $7AttJ.default),
    inlineCard: $2b5167c1d6aa176d$export$aff6291803939b05,
    inlineExtension: (0, $112O7.default),
    layoutSection: (0, $ieJGA.default),
    layoutColumn: (0, $3RqVz.default),
    listItem: (0, $qjsNK.default),
    media: $2b5167c1d6aa176d$export$7fc53215244aec38,
    mediaGroup: $2b5167c1d6aa176d$export$d7858be3df00d59,
    mediaInline: $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f,
    mediaSingle: $2b5167c1d6aa176d$export$888d74bc001c3a5d,
    mention: $2b5167c1d6aa176d$export$e891316fea657d90,
    orderedList: (0, $6svWT.default),
    panel: $2b5167c1d6aa176d$export$2ddb90ad54e5f587,
    paragraph: (0, $9FXQX.default),
    placeholder: (0, $hqBb9.default),
    rule: (0, $ixoQV.default),
    status: $2b5167c1d6aa176d$export$96e9906d6d93a972,
    taskItem: $2b5167c1d6aa176d$export$27c4189b8be1bf93,
    taskList: $2b5167c1d6aa176d$export$771a55a10b0a40ae,
    table: (0, $dkc63.default),
    tableCell: (0, $cWojJ.TableCell),
    tableHeader: (0, $cWojJ.TableHeader),
    tableRow: (0, $i4Lgj.default),
    unknownBlock: (0, $gfMkN.default),
    unsupportedBlock: (0, $iiXGq.default),
    unsupportedInline: (0, $9kpKZ.default),
    expand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    nestedExpand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    embedCard: $2b5167c1d6aa176d$export$6789d7ecdc77631b
};
const $2b5167c1d6aa176d$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $5KNWO.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $2b5167c1d6aa176d$export$a22ee8f907eecb5f;
        return $2b5167c1d6aa176d$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$2b5167c1d6aa176d$export$3931063f6a5f290e,
        ...nodeComponents
    };
    return nodes[node.type.name];
};
const $2b5167c1d6aa176d$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$2b5167c1d6aa176d$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $2b5167c1d6aa176d$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $2b5167c1d6aa176d$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $2b5167c1d6aa176d$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $2b5167c1d6aa176d$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2b5167c1d6aa176d$var$whitespaceRegex = /^\s*$/;
const $2b5167c1d6aa176d$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $2b5167c1d6aa176d$var$isEmojiBlock(node.content);
};
const $2b5167c1d6aa176d$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($2b5167c1d6aa176d$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("atrOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d51d57a125840f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8d51d57a125840f5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("blockquote", null, props.children);
}

});

parcelRegister("4dtZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9e9d2beaec6b895$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $i8Zwf = parcelRequire("i8Zwf");

var $8Eu7T = parcelRequire("8Eu7T");

var $fAZXL = parcelRequire("fAZXL");

var $cWCI0 = parcelRequire("cWCI0");

var $gkwXh = parcelRequire("gkwXh");

var $4YrGg = parcelRequire("4YrGg");
const $b9e9d2beaec6b895$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Eu7T.ErrorBoundary), {
        component: (0, $cWCI0.ACTION_SUBJECT).RENDERER,
        componentId: (0, $gkwXh.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YrGg.AnnotationsPositionContext).Provider, {
        value: {
            startPos: props.startPos + 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAZXL.default), {
        ...props,
        type: "bodiedExtension"
    }, ({ result: result })=>{
        try {
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
            return (0, $i8Zwf.renderExtension)(result, layout, {
                isTopLevel: path.length < 1
            }, removeOverflow);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return (0, $i8Zwf.renderExtension)(children, layout, {
            isTopLevel: path.length < 1
        }, removeOverflow);
    })));
};
var $b9e9d2beaec6b895$export$2e2bcd8739ae039 = $b9e9d2beaec6b895$var$BodiedExtension;

});
parcelRegister("i8Zwf", function(module, exports) {

$parcel$export(module.exports, "renderExtension", () => $1a97cbb70a611ae8$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $1a97cbb70a611ae8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $l8Gxi = parcelRequire("l8Gxi");
const $1a97cbb70a611ae8$export$b7482bdc8aff85e4 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
content, layout, options = {}, removeOverflow)=>{
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: overflowContainerClass
        }, content)));
};
const $1a97cbb70a611ae8$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [] } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAZXL.default), {
        ...props,
        type: "extension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            });
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames
        });
    });
};
var $1a97cbb70a611ae8$export$2e2bcd8739ae039 = (0, $ajc8Z.default)($1a97cbb70a611ae8$var$Extension, {
    overflowSelector: `.${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("fAZXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $45cce7a6859f4709$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $gnH2s = parcelRequire("gnH2s");

var $9Egzu = parcelRequire("9Egzu");

var $2vGdQ = parcelRequire("2vGdQ");
const $45cce7a6859f4709$var$inlineExtensionStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
function $45cce7a6859f4709$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $8QpSo.default)((0, $gnH2s.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2vGdQ.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)($45cce7a6859f4709$var$InlineNodeRendererWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Egzu.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $45cce7a6859f4709$var$InlineNodeRendererWrapper = ({ children: children })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: "inline-extension-renderer",
        css: $45cce7a6859f4709$var$inlineExtensionStyle
    }, children));
};

});
parcelRegister("gnH2s", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $36d4284a17bc60a0$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $36d4284a17bc60a0$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $36d4284a17bc60a0$export$67a7d49db68d30a0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $izxHQ = parcelRequire("izxHQ");
async function $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $izxHQ.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $36d4284a17bc60a0$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, {});
}
function $36d4284a17bc60a0$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            children: "Error loading the extension!"
        });
    } else return null;
}
function $36d4284a17bc60a0$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>{
            return $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $izxHQ.resolveImport)(node.render()));
        },
        loading: $36d4284a17bc60a0$var$ExtensionLoading
    });
}

});
parcelRegister("izxHQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $23c4e3f9598df846$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $23c4e3f9598df846$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImport", () => $23c4e3f9598df846$export$d69c9b451c47653b);
const $23c4e3f9598df846$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $23c4e3f9598df846$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $23c4e3f9598df846$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $23c4e3f9598df846$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $23c4e3f9598df846$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest);
}
const $23c4e3f9598df846$export$d69c9b451c47653b = async (importPromise)=>{
    const importedModule = await importPromise;
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
function $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $23c4e3f9598df846$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("9Egzu", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $76144329c6f313cf$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
class $76144329c6f313cf$export$d498ee8be33e096f extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            if ((0, $VSDnB.fg)('platform_editor_react18_phase2_v2')) {
                const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
                providers[name] = providerPromise;
            } else providers[name] = undefined;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillMount() {
        if (!(0, $VSDnB.fg)('platform_editor_react18_phase2_v2')) {
            const { providers: providers, providerFactory: providerFactory } = this.props;
            providers.forEach((name)=>{
                providerFactory.subscribe(name, this.handleProvider);
            });
        }
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("2vGdQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $f7ce50c6d2d400b7$export$9214452ef07eda7);
function $f7ce50c6d2d400b7$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("ajc8Z", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $0d6cb6e0383d0ba0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bbl9Y = parcelRequire("bbl9Y");
const $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $0d6cb6e0383d0ba0$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $bbl9Y.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                showRightShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                showLeftShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return(// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            }));
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("bbl9Y", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $cd027df5593f4e8b$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $cd027df5593f4e8b$export$51a5b28e4fb2dba2);
var $cd027df5593f4e8b$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $cd027df5593f4e8b$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $cd027df5593f4e8b$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $cd027df5593f4e8b$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $cd027df5593f4e8b$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $cd027df5593f4e8b$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $cd027df5593f4e8b$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("eOOFp", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $081c5ce54850cd88$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $081c5ce54850cd88$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $081c5ce54850cd88$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $081c5ce54850cd88$export$5f4502874a28dfce);
$parcel$export(module.exports, "calcBreakoutWithCustomWidth", () => $081c5ce54850cd88$export$ccc0a02edddeed39);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $081c5ce54850cd88$export$c377853ecdd53e5b);
$parcel$export(module.exports, "getNextBreakoutMode", () => $081c5ce54850cd88$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $081c5ce54850cd88$export$70d1bf7729efff40);

var $iHYdz = parcelRequire("iHYdz");

var $8DYpW = parcelRequire("8DYpW");

var $9Iju4 = parcelRequire("9Iju4");

var $4ceoy = parcelRequire("4ceoy");

var $eQcNy = parcelRequire("eQcNy");
/**
 * Variables required to construct a context for breakout ssr inline script.
 *
 * TODO: Clean this up after: https://product-fabric.atlassian.net/browse/ED-8942
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $081c5ce54850cd88$export$ead1fecec2ecf57c = {
    padding: (0, $iHYdz.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $iHYdz.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $iHYdz.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $iHYdz.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $iHYdz.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $9Iju4.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $4ceoy.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (layout, containerWidth, padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        switch(layout){
            case 'full-width':
                return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
            case 'wide':
                if (effectiveFullWidth <= 0) return '100%';
                const wideWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                return wideWidth;
            default:
                return '100%';
        }
    },
    calcBreakoutWithCustomWidth: (mode, width, editorContainerWidth)=>{
        if (width !== null && width > 0) {
            const effectiveFullWidth = editorContainerWidth - $081c5ce54850cd88$export$ead1fecec2ecf57c.padding;
            // if below 0 then expect we're rendering in SSR
            return `${Math.min(width, effectiveFullWidth)}px`;
        }
        return $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(mode, editorContainerWidth);
    },
    calcLineLength: ()=>$081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth,
    calcWideWidth: (containerWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        const layoutMaxWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $081c5ce54850cd88$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
        return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
    }
};
const $081c5ce54850cd88$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $iHYdz.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $081c5ce54850cd88$export$86325001fe8f3adc = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth;
const $081c5ce54850cd88$export$5f4502874a28dfce = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth;
const $081c5ce54850cd88$export$ccc0a02edddeed39 = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth;
function $081c5ce54850cd88$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $eQcNy.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $081c5ce54850cd88$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $eQcNy.parsePx)($081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $081c5ce54850cd88$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $081c5ce54850cd88$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $8DYpW.default).layoutFixedWidth;
        case 'wide':
            return (0, $8DYpW.default).layoutFullWidth;
        default:
            return (0, $8DYpW.default).layoutWide;
    }
};

});
parcelRegister("8DYpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb832a3bfaa1d66d$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7VHMR = parcelRequire("7VHMR");





var $l9HLU = parcelRequire("l9HLU");

var $8cp3a = parcelRequire("8cp3a");

var $9NKqk = parcelRequire("9NKqk");

var $fJyLQ = parcelRequire("fJyLQ");

var $gSYO9 = parcelRequire("gSYO9");

var $jDuvE = parcelRequire("jDuvE");


var $lQKNV = parcelRequire("lQKNV");

var $2i4K4 = parcelRequire("2i4K4");

var $eX53M = parcelRequire("eX53M");

var $80CM7 = parcelRequire("80CM7");

var $kXnoC = parcelRequire("kXnoC");

var $eDTMN = parcelRequire("eDTMN");

var $2V0EL = parcelRequire("2V0EL");

var $kFJBG = parcelRequire("kFJBG");

var $7S9ZN = parcelRequire("7S9ZN");

var $6OcHr = parcelRequire("6OcHr");

var $dbepQ = parcelRequire("dbepQ");

var $kANLZ = parcelRequire("kANLZ");

var $kmmxF = parcelRequire("kmmxF");

var $80TXs = parcelRequire("80TXs");

var $9QBHe = parcelRequire("9QBHe");

var $kAM3u = parcelRequire("kAM3u");

var $6lWmZ = parcelRequire("6lWmZ");

var $ixwvf = parcelRequire("ixwvf");

var $fJm1A = parcelRequire("fJm1A");

var $ecAvy = parcelRequire("ecAvy");

var $7ywdr = parcelRequire("7ywdr");

var $1ElKj = parcelRequire("1ElKj");



var $3AEXe = parcelRequire("3AEXe");
var $eb832a3bfaa1d66d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    }
});

});
parcelRegister("l9HLU", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $c0194801a7a2c28d$export$5229ffea355cfdf6);

var $7VHMR = parcelRequire("7VHMR");
const $c0194801a7a2c28d$export$5229ffea355cfdf6 = (0, $7VHMR.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("8cp3a", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $0f161f19f888f3d2$export$ff612ca71703201d);

var $7VHMR = parcelRequire("7VHMR");
const $0f161f19f888f3d2$export$ff612ca71703201d = (0, $7VHMR.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    },
    createCommentOnInlineNodeSpotlightBody: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.body',
        defaultMessage: 'You can now leave comments on inline elements like links, dates, statuses and mentions.',
        description: 'The body content of the spotlight message that appears when the user can leave comments on inline nodes'
    },
    createCommentOnInlineNodeSpotlightAction: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.action',
        defaultMessage: 'Got it',
        description: 'The content of the action button that closes the spotlight'
    }
});

});

parcelRegister("9NKqk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f845f8650b83fa4e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f845f8650b83fa4e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("fJyLQ", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $bc1b61e25b99393f$export$42bb270d1224182);

var $7VHMR = parcelRequire("7VHMR");
const $bc1b61e25b99393f$export$42bb270d1224182 = (0, $7VHMR.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("gSYO9", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $6ccabeb0d4490fe2$export$4ce3884394d6d9);

var $7VHMR = parcelRequire("7VHMR");
const $6ccabeb0d4490fe2$export$4ce3884394d6d9 = (0, $7VHMR.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("jDuvE", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $8ffd20c106600435$export$2d7676d841c8ae9);

var $7VHMR = parcelRequire("7VHMR");
const $8ffd20c106600435$export$2d7676d841c8ae9 = (0, $7VHMR.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("lQKNV", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $20d0fb06aaa96548$export$74e304339778e94d);

var $7VHMR = parcelRequire("7VHMR");
const $20d0fb06aaa96548$export$74e304339778e94d = (0, $7VHMR.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("2i4K4", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $4423ee10317a70cf$export$70c8a7203d95247);

var $7VHMR = parcelRequire("7VHMR");
const $4423ee10317a70cf$export$70c8a7203d95247 = (0, $7VHMR.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Insert a node into the document'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the new editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    columnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.description',
        defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: ''
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Turn selected texts into another element containing those texts'
    }
});

});

parcelRegister("eX53M", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("80CM7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $402c787ddf19f01c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $402c787ddf19f01c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    }
});

});

parcelRegister("kXnoC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19e3f2f865259995$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19e3f2f865259995$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("eDTMN", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $ec9866e02d0168cb$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $ec9866e02d0168cb$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    textFormat: {
        id: 'fabric.editor.textFormat',
        defaultMessage: 'Format text',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    }
});

});

parcelRegister("2V0EL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bcecf16097bd0035$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bcecf16097bd0035$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("kFJBG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a872fd5a03f73724$export$defe85febe8b728c);
// Common Translations will live here

var $7VHMR = parcelRequire("7VHMR");
const $a872fd5a03f73724$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("7S9ZN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9078664297972b18$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9078664297972b18$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("6OcHr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b883afcc2fb8665e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b883afcc2fb8665e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    }
});

});

parcelRegister("dbepQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19b9098ff265842b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19b9098ff265842b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    }
});

});

parcelRegister("kANLZ", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $2ae4030e88533f57$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $2ae4030e88533f57$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    twoColumnsAdvancedLayout: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: '2 Column layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    threeColumnsAdvancedLayout: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: '3 Column layout',
        description: 'Layout with three columns of equal width'
    },
    fourColumns: {
        id: 'fabric.editor.fourColumns',
        defaultMessage: '4 Column layout',
        description: 'Layout with four columns of equal width'
    },
    fiveColumns: {
        id: 'fabric.editor.fiveColumns',
        defaultMessage: '5 Column layout',
        description: 'Layout with five columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    threeColumnsWithLeftSidebars: {
        id: 'fabric.editor.threeColumnsWithLeftSidebars',
        defaultMessage: 'Three columns with left sidebar layout',
        description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
    },
    threeColumnsWithRightSidebars: {
        id: 'fabric.editor.threeColumnsWithRightSidebars',
        defaultMessage: 'Three columns with right sidebar layout',
        description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    },
    layoutPlaceholder: {
        id: 'fabric.editor.layout.placeholder',
        defaultMessage: 'Add content',
        description: 'Add placeholder text for empty layout'
    },
    columnOption: {
        id: 'fabric.editor.layout.columnOption',
        defaultMessage: '{count, plural, one { Column} other {{count} Columns}}',
        description: 'column option text for layout'
    },
    resizeLayout: {
        id: 'fabric.editor.layout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'resize layout'
    }
});

});

parcelRegister("kmmxF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e4735e0a5cdca6f9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e4735e0a5cdca6f9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("80TXs", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $cedd04a0024a64f8$export$8a0e7c3f8f5b8868);

var $7VHMR = parcelRequire("7VHMR");
const $cedd04a0024a64f8$export$8a0e7c3f8f5b8868 = (0, $7VHMR.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("9QBHe", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $b943fdad34912591$export$b46a930e1a386b2e);

var $7VHMR = parcelRequire("7VHMR");
const $b943fdad34912591$export$b46a930e1a386b2e = (0, $7VHMR.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("kAM3u", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $147c4cd461faf1fe$export$effb4ee8b6f74abe);

var $7VHMR = parcelRequire("7VHMR");
const $147c4cd461faf1fe$export$effb4ee8b6f74abe = (0, $7VHMR.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    }
});

});

parcelRegister("6lWmZ", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $65d46911a2519e83$export$273d864e9e6d0b1f);

var $7VHMR = parcelRequire("7VHMR");
const $65d46911a2519e83$export$273d864e9e6d0b1f = (0, $7VHMR.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    }
});

});

parcelRegister("ixwvf", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $358e275c47040b0e$export$ee8ab8a034b5a8bd);

var $7VHMR = parcelRequire("7VHMR");
const $358e275c47040b0e$export$ee8ab8a034b5a8bd = (0, $7VHMR.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    }
});

});

parcelRegister("fJm1A", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $b0fedd2e9a93e39a$export$703e803e9cb0cea4);

var $7VHMR = parcelRequire("7VHMR");
const $b0fedd2e9a93e39a$export$703e803e9cb0cea4 = (0, $7VHMR.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("ecAvy", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $e955dc2d97d725ff$export$7bb18eb6f9170174);

var $7VHMR = parcelRequire("7VHMR");
const $e955dc2d97d725ff$export$7bb18eb6f9170174 = (0, $7VHMR.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("7ywdr", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $a3d6d16f96d339d5$export$33aafd5ccbbbd00a);

var $7VHMR = parcelRequire("7VHMR");
const $a3d6d16f96d339d5$export$33aafd5ccbbbd00a = (0, $7VHMR.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    },
    unknownLabel: {
        id: 'fabric.editor.unknown.label',
        defaultMessage: 'Unknown',
        description: 'Label to indicate unknown mention node'
    }
});

});

parcelRegister("1ElKj", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $691908dbd48d7aae$export$83c85447c71428ba);

var $7VHMR = parcelRequire("7VHMR");
const $691908dbd48d7aae$export$83c85447c71428ba = (0, $7VHMR.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("3AEXe", function(module, exports) {

$parcel$export(module.exports, "mediaInsertMessages", () => $a755ba82139b4a7d$export$7eb9dc59242bbc45);

var $7VHMR = parcelRequire("7VHMR");
const $a755ba82139b4a7d$export$7eb9dc59242bbc45 = (0, $7VHMR.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    }
});

});


parcelRegister("eQcNy", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $ab609be3c0cbf6e9$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $ab609be3c0cbf6e9$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $ab609be3c0cbf6e9$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $ab609be3c0cbf6e9$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $ab609be3c0cbf6e9$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $ab609be3c0cbf6e9$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $ab609be3c0cbf6e9$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $ab609be3c0cbf6e9$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $ab609be3c0cbf6e9$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $ab609be3c0cbf6e9$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $ab609be3c0cbf6e9$export$d508bcfb7f019487(node, s) {
    return $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s);
}
function $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2(elem, callback) {
    return $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("l8Gxi", function(module, exports) {

$parcel$export(module.exports, "RendererCssClassName", () => $ca55565f908e8e5d$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $ca55565f908e8e5d$var$clPrefix = 'ak-renderer-';
const $ca55565f908e8e5d$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$ca55565f908e8e5d$var$clPrefix}document`,
    EXTENSION: `${$ca55565f908e8e5d$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$ca55565f908e8e5d$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$ca55565f908e8e5d$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});


parcelRegister("8Eu7T", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $19f8e43ef61748ed$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");

var $1KzE6 = parcelRequire("1KzE6");

var $knXBU = parcelRequire("knXBU");

var $7Jxgt = parcelRequire("7Jxgt");
class $19f8e43ef61748ed$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $1KzE6.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState(()=>({
                    domError: true
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))()
        }, this.props.children);
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}

});
parcelRegister("1KzE6", function(module, exports) {

$parcel$export(module.exports, "logException", () => $8cb678cf4830ec10$export$f86b2a1a2ce291b3);

var $8eFcy = parcelRequire("8eFcy");
const $8cb678cf4830ec10$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $8cb678cf4830ec10$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $8cb678cf4830ec10$var$packageVersion = "0.0.0-use.local";
const $8cb678cf4830ec10$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $8cb678cf4830ec10$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("8IyQ8"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("eqokj"));
        const sentryOptions = {
            dsn: (0, $8eFcy.isFedRamp)() ? undefined : $8cb678cf4830ec10$var$SENTRY_DSN,
            release: `${$8cb678cf4830ec10$var$packageName}@${$8cb678cf4830ec10$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network error/i,
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $8cb678cf4830ec10$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("8eFcy", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $1a8a754a294d51a4$export$64d6499adf9b2e51);
const $1a8a754a294d51a4$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $1a8a754a294d51a4$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $1a8a754a294d51a4$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("8IyQ8", function(module, exports) {

let $658d753eb7264f71$var$load = (parcelRequire("28QjX"))(4);
module.exports = $658d753eb7264f71$var$load("56SDo").then(()=>parcelRequire('hFoxV'));

});

parcelRegister("eqokj", function(module, exports) {

let $a8065d22b57a6f1c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a8065d22b57a6f1c$var$load("a12Xb").then(()=>parcelRequire('1dEW4'));

});


parcelRegister("knXBU", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $11894d4d5d86b4b1$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $11894d4d5d86b4b1$export$e48589d9e4824227);
var $11894d4d5d86b4b1$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $11894d4d5d86b4b1$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $11894d4d5d86b4b1$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($11894d4d5d86b4b1$var$RESOLVE_METHOD || {});

});


parcelRegister("cWCI0", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $78ed418dcea0e38c$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $78ed418dcea0e38c$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $78ed418dcea0e38c$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $78ed418dcea0e38c$export$9957974f8b4d8f74);
var $78ed418dcea0e38c$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $78ed418dcea0e38c$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    return ACTION;
}({});
var $78ed418dcea0e38c$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    return ACTION_SUBJECT;
}({});
var $78ed418dcea0e38c$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("4YrGg", function(module, exports) {

$parcel$export(module.exports, "AnnotationsPositionContext", () => $5dd0541565473935$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $5dd0541565473935$export$cef0157dd42cbb3f);

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $eka68 = parcelRequire("eka68");

var $8Mz83 = parcelRequire("8Mz83");

var $iYAgE = parcelRequire("iYAgE");

var $joddd = parcelRequire("joddd");

var $1oOiu = parcelRequire("1oOiu");

var $2NMNM = parcelRequire("2NMNM");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");
const $5dd0541565473935$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $joddd.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $5dd0541565473935$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    startPos: 1
});
const $5dd0541565473935$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const updateSubscriber = annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $1oOiu.useAnnotationStateByTypeEvent)({
        type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYAgE.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYAgE.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EsbE.AnnotationRangeProvider), {
        allowCommentsOnMedia: annotationProvider?.inlineComment?.allowCommentsOnMedia ?? false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kuusl.AnnotationHoverContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Mz83.AnnotationsContextWrapper), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5dd0541565473935$var$LoadAnnotations, {
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eka68.AnnotationView), {
        isNestedRender: isNestedRender,
        createAnalyticsEvent: createAnalyticsEvent
    }), children)))));
};

});
parcelRegister("eka68", function(module, exports) {

$parcel$export(module.exports, "AnnotationView", () => $38b360e678e45e5a$export$41cd4a02859c2806);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $1oOiu = parcelRequire("1oOiu");

var $fCNtA = parcelRequire("fCNtA");
const $38b360e678e45e5a$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const actionContext = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $1oOiu.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $5uXOq.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $5uXOq.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("iYAgE", function(module, exports) {

$parcel$export(module.exports, "AnnotationsDraftContext", () => $1cf3b601714e6f28$export$365d1799d81a236d);
$parcel$export(module.exports, "ProvidersContext", () => $1cf3b601714e6f28$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $1cf3b601714e6f28$export$aafe46a36ef535ba);
$parcel$export(module.exports, "AnnotationsDraftContextWrapper", () => $1cf3b601714e6f28$export$153126608e00390);

var $5uXOq = parcelRequire("5uXOq");
const $1cf3b601714e6f28$export$365d1799d81a236d = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1cf3b601714e6f28$export$6a26b015ac619737 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1cf3b601714e6f28$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $5uXOq.createContext)({});
class $1cf3b601714e6f28$export$153126608e00390 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children } = this.props;
        const { position: position } = this.state;
        const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
        const clearAnnotationDraft = this.clearAnnotationDraft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf3b601714e6f28$export$365d1799d81a236d.Provider, {
            value: position
        }, children({
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            position: null
        }, this.applyAnnotationDraftAt = (nextPosition)=>{
            const { setDraftRange: setDraftRange } = this.props;
            // Set the draft range to preserve it downstream
            setDraftRange();
            // We need to support a new draft being made while one exists and overwrite it
            // Set the document position for the newly created draft
            this.setState({
                position: nextPosition
            });
        }, this.clearAnnotationDraft = ()=>{
            const { clearDraftRange: clearDraftRange } = this.props;
            // Clear the draft range
            clearDraftRange();
            // Clear the draft position in the document
            this.setState({
                position: null
            });
        };
    }
}

});

parcelRegister("1oOiu", function(module, exports) {

$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $477334c02b9da473$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $477334c02b9da473$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $477334c02b9da473$export$26cf539704e444c1);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $iEN9D = parcelRequire("iEN9D");

var $88i6h = parcelRequire("88i6h");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");
const $477334c02b9da473$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $5uXOq.useState)({});
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        return ()=>{
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        };
    }, [
        states,
        type,
        updateSubscriber
    ]);
    return states;
};
const $477334c02b9da473$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $5uXOq.useState)(false);
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const isInlineCommentsKbAccessible = (0, $iEN9D.default).checkGate('inline_comments_keyboard_accessible_renderer');
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
            if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
            if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
        return ()=>{
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
        };
    }, [
        id,
        updateSubscriber,
        isInlineCommentsKbAccessible
    ]);
    return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $477334c02b9da473$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $5uXOq.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const isInlineCommentsKbAccessible = (0, $iEN9D.default).checkGate('inline_comments_keyboard_accessible_renderer');
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
            if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        return ()=>{
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        };
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isInlineCommentsKbAccessible,
        isNestedRender
    ]);
    return annotationClickEvent;
};

});
parcelRegister("dEtqo", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $916fd31c0363f129$export$c1c4b33b4e7b1c70);

var $6Oghe = parcelRequire("6Oghe");
var $916fd31c0363f129$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $916fd31c0363f129$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($6Oghe)))();
    }
}

});
parcelRegister("6Oghe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $4f5409da028b4771$var$ReflectOwnKeys;
if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $4f5409da028b4771$var$EventEmitter() {
    $4f5409da028b4771$var$EventEmitter.init.call(this);
}
module.exports = $4f5409da028b4771$var$EventEmitter;
module.exports.once = $4f5409da028b4771$var$once;
// Backwards-compat with node 0.10.x
$4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
$4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
$4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
$4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $4f5409da028b4771$var$defaultMaxListeners = 10;
function $4f5409da028b4771$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $4f5409da028b4771$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $4f5409da028b4771$var$defaultMaxListeners = arg;
    }
});
$4f5409da028b4771$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $4f5409da028b4771$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $4f5409da028b4771$var$_getMaxListeners(this);
};
$4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $4f5409da028b4771$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $4f5409da028b4771$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $4f5409da028b4771$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, false);
};
$4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
$4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, true);
};
function $4f5409da028b4771$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $4f5409da028b4771$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $4f5409da028b4771$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
$4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
}
$4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, true);
};
$4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, false);
};
$4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
};
$4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
function $4f5409da028b4771$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
};
function $4f5409da028b4771$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $4f5409da028b4771$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $4f5409da028b4771$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $4f5409da028b4771$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});



parcelRegister("fCNtA", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $7e61ed70df2336e9$export$66feffbad722f9d4);

var $5uXOq = parcelRequire("5uXOq");

var $6pY1y = parcelRequire("6pY1y");
const $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $6pY1y.default)());
function $7e61ed70df2336e9$export$66feffbad722f9d4({ children: children, context: context }) {
    const actions = (0, $5uXOq.useMemo)(()=>new (0, $6pY1y.default)(true), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children));
}
const $7e61ed70df2336e9$export$d5fcf151601331bc = $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("6pY1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7850a7dc1aaf7e$export$2e2bcd8739ae039);

var $88i6h = parcelRequire("88i6h");

var $h03xs = parcelRequire("h03xs");

var $hYNZx = parcelRequire("hYNZx");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $eS2Dn = parcelRequire("eS2Dn");

var $VSDnB = parcelRequire("VSDnB");

var $cMPbW = parcelRequire("cMPbW");

var $4apTl = parcelRequire("4apTl");

var $hAPWV = parcelRequire("hAPWV");
class $5e7850a7dc1aaf7e$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $hYNZx.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
	 * Validate whether we can create an annotation between two positions
	 */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        if ((0, $VSDnB.fg)('forbid_comments_on_empty_newlines')) {
            const currentSelection = (0, $gZGBX.TextSelection).create(this.doc, from, to);
            if ((0, $h03xs.isEmptyTextSelection)(currentSelection, this.schema)) return false;
        }
        return (0, $h03xs.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $eS2Dn.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $eS2Dn.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $gkwXh.ACTION).DELETED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $eS2Dn.RemoveMarkStep) ? (0, $4apTl.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * This is replaced by `isRangeAnnotatable`.
	 *
	 * @deprecated
	 **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
	 * Note: False indicates that the selection not able to be calculated.
	 */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $cMPbW.getPosFromRange)(range);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $h03xs.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $eS2Dn.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $cMPbW.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $4apTl.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // TODO: Do not forget to remove `undefined` when the
    //       `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $h03xs.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("h03xs", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $ccb20202dc8fa865$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $ccb20202dc8fa865$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $ccb20202dc8fa865$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $ccb20202dc8fa865$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $ccb20202dc8fa865$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $ccb20202dc8fa865$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $ccb20202dc8fa865$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $ccb20202dc8fa865$export$2efbc6d84ea0fbec);

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");
const $ccb20202dc8fa865$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $ccb20202dc8fa865$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $ccb20202dc8fa865$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $ccb20202dc8fa865$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $ccb20202dc8fa865$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($ccb20202dc8fa865$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $ccb20202dc8fa865$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $ccb20202dc8fa865$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $ccb20202dc8fa865$export$bb1945a828f2864b(pos) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $ccb20202dc8fa865$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("hYNZx", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $c960adc5c7547145$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $c960adc5c7547145$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ajpes = parcelRequire("ajpes");

var $8vlrc = parcelRequire("8vlrc");
var $cUwVZ = parcelRequire("cUwVZ");
var $7kC9H = parcelRequire("7kC9H");
var $29Vii = parcelRequire("29Vii");
var $8XeG6 = parcelRequire("8XeG6");
var $bIGZ7 = parcelRequire("bIGZ7");
var $7agO8 = parcelRequire("7agO8");
var $g7Cky = parcelRequire("g7Cky");
var $9UDEr = parcelRequire("9UDEr");

var $kOFhM = parcelRequire("kOFhM");

var $fVI2q = parcelRequire("fVI2q");

var $0Cgjx = parcelRequire("0Cgjx");
var $c960adc5c7547145$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $c960adc5c7547145$var$isType = (type)=>(node)=>node.type.name === type;
const $c960adc5c7547145$var$isCodeBlock = $c960adc5c7547145$var$isType('codeBlock');
const $c960adc5c7547145$var$isMediaNode = $c960adc5c7547145$var$isType('media');
const $c960adc5c7547145$var$isMediaInline = $c960adc5c7547145$var$isType('mediaInline');
const $c960adc5c7547145$var$isMediaSingleNode = $c960adc5c7547145$var$isType('mediaSingle');
const $c960adc5c7547145$var$isMentionNode = $c960adc5c7547145$var$isType('mention');
const $c960adc5c7547145$var$isParagraph = $c960adc5c7547145$var$isType('paragraph');
const $c960adc5c7547145$var$isHeading = $c960adc5c7547145$var$isType('heading');
const $c960adc5c7547145$var$isTable = $c960adc5c7547145$var$isType('table');
const $c960adc5c7547145$var$isTableCell = $c960adc5c7547145$var$isType('tableCell');
const $c960adc5c7547145$var$isTableHeader = $c960adc5c7547145$var$isType('tableHeader');
const $c960adc5c7547145$var$isLinkMark = $c960adc5c7547145$var$isType('link');
const $c960adc5c7547145$var$isUnsupportedMark = $c960adc5c7547145$var$isType('unsupportedMark');
const $c960adc5c7547145$var$isUnsupportedNodeAttributeMark = $c960adc5c7547145$var$isType('unsupportedNodeAttribute');
const $c960adc5c7547145$var$isExpand = $c960adc5c7547145$var$isType('expand');
const $c960adc5c7547145$var$isNestedExpand = $c960adc5c7547145$var$isType('nestedExpand');
const $c960adc5c7547145$var$isUnsupportedNode = (node)=>$c960adc5c7547145$var$isType('unsupportedBlock')(node) || $c960adc5c7547145$var$isType('unsupportedInline')(node);
const $c960adc5c7547145$var$isDataConsumer = $c960adc5c7547145$var$isType('dataConsumer');
const $c960adc5c7547145$var$isFragmentMark = $c960adc5c7547145$var$isType('fragment');
const $c960adc5c7547145$var$isHardBreak = $c960adc5c7547145$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c960adc5c7547145$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $c960adc5c7547145$var$filterNull(current);
    }
    return output;
};
const $c960adc5c7547145$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $c960adc5c7547145$var$emptyDoc = $c960adc5c7547145$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $c960adc5c7547145$var$toJSON = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($c960adc5c7547145$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($c960adc5c7547145$var$isMediaNode(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaSingleNode(node)) obj.attrs = (0, $bIGZ7.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaInline(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMentionNode(node)) obj.attrs = (0, $g7Cky.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isCodeBlock(node)) obj.attrs = (0, $8vlrc.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTable(node)) obj.attrs = (0, $9UDEr.tableToJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTableCell(node)) obj.attrs = (0, $9UDEr.toJSONTableCell)(node).attrs;
    else if ($c960adc5c7547145$var$isTableHeader(node)) obj.attrs = (0, $9UDEr.toJSONTableHeader)(node).attrs;
    else if ($c960adc5c7547145$var$isExpand(node) || $c960adc5c7547145$var$isNestedExpand(node)) obj.attrs = (0, $7kC9H.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $c960adc5c7547145$var$filterNull(obj.attrs);
    if ($c960adc5c7547145$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($c960adc5c7547145$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    // Hard break has optional attr.text which was added for PM <-> ADF compatibility.
    // No need to preserve it.
    if ($c960adc5c7547145$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($c960adc5c7547145$var$toJSON(child, mentionMap));
    });
    if ($c960adc5c7547145$var$isParagraph(node) || $c960adc5c7547145$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($c960adc5c7547145$var$isUnsupportedMark(mark)) return $c960adc5c7547145$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($c960adc5c7547145$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($c960adc5c7547145$var$isLinkMark(mark)) return (0, $8XeG6.toJSON)(mark);
            else if ($c960adc5c7547145$var$isDataConsumer(mark)) {
                const serialised = (0, $cUwVZ.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($c960adc5c7547145$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $29Vii.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($c960adc5c7547145$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$c960adc5c7547145$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $c960adc5c7547145$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $fVI2q.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $c960adc5c7547145$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $c960adc5c7547145$export$98cb1d9308d0944d {
    /**
	 * @param schema The current editor schema
	 * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
	 * mention node.attr.text values with mapped names.
	 */ constructor(schema = (0, $kOFhM.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(child, this.mentionMap)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(content, $c960adc5c7547145$var$emptyDoc.content)) return $c960adc5c7547145$var$createDocFromContent([]);
        return $c960adc5c7547145$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $kOFhM.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($c960adc5c7547145$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(node, this.mentionMap));
    }
}

});
parcelRegister("fVI2q", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $7f7cf8cf5d94f891$export$28e4e3c024cce988);
const $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $7f7cf8cf5d94f891$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour;
        default:
            return $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("0Cgjx", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $45db1c8142107da9$export$48b382180baf8e88);

var $aSk3Q = parcelRequire("aSk3Q");

var $l1C1k = parcelRequire("l1C1k");

var $VSDnB = parcelRequire("VSDnB");

var $hRZSy = parcelRequire("hRZSy");
const $45db1c8142107da9$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $45db1c8142107da9$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $l1C1k.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $hRZSy.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        tableHeader: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        emoji: (0, $hRZSy.removeNonAnnotationMarks),
        mention: (0, $hRZSy.removeNonAnnotationMarks),
        date: (0, $hRZSy.removeNonAnnotationMarks),
        hardBreak: (0, $hRZSy.removeMarks),
        inlineCard: (0, $hRZSy.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("aSk3Q", function(module, exports) {

$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $2dd8f1bba9a54435$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $2dd8f1bba9a54435$export$8a334a7d9fe120ec);

var $l1C1k = parcelRequire("l1C1k");

var $gxbjN = parcelRequire("gxbjN");

var $8YCkv = parcelRequire("8YCkv");
const $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $2dd8f1bba9a54435$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY;
const $2dd8f1bba9a54435$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
function $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent) {
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent?.parent?.node) return $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent.parent);
    return false;
}
const $2dd8f1bba9a54435$export$18544d0b5f43e4a1 = (adf, options = {})=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        extension: (node, parent)=>{
            if ($2dd8f1bba9a54435$export$f45e7335ec874bfe(node)) {
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent)) return undefined;
                isTransformed = true;
                return $2dd8f1bba9a54435$var$transformNestedTableExtension(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $2dd8f1bba9a54435$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $gxbjN.extension)({
                    extensionType: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("l1C1k", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b903aab814d8ed47$export$df3f009e3d155b20);
function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
    if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b903aab814d8ed47$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("gxbjN", function(module, exports) {

$parcel$export(module.exports, "extension", () => $ec4576859225619a$export$1b45514b112dd749);
const $ec4576859225619a$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("8YCkv", function(module, exports) {

$parcel$export(module.exports, "NodeNestingTransformError", () => $b0271efedae2a0b7$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $b0271efedae2a0b7$export$3d8e8d2182f13924 extends Error {
    /**
	 * @param message - Error message - Do not use any UGC in this message
	 */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("hRZSy", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $7e7bed7752b3d3e8$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $7e7bed7752b3d3e8$export$8cae9126fc577085);
function $7e7bed7752b3d3e8$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $7e7bed7752b3d3e8$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});



parcelRegister("cMPbW", function(module, exports) {

$parcel$export(module.exports, "isRoot", () => $c9441534493a403f$export$e3140dc7d0c35e48);
$parcel$export(module.exports, "getPosFromRange", () => $c9441534493a403f$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $c9441534493a403f$export$74899f7e5acb5cd3);

var $VSDnB = parcelRequire("VSDnB");

var $eS2Dn = parcelRequire("eS2Dn");
function $c9441534493a403f$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $c9441534493a403f$var$getNodeType = (element)=>element.dataset.nodeType;
function $c9441534493a403f$var$isPositionPointer(element) {
    return $c9441534493a403f$var$getStartPos(element) > -1;
}
function $c9441534493a403f$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return parentElement;
    return $c9441534493a403f$var$findParent(parentElement);
}
function $c9441534493a403f$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $c9441534493a403f$var$findMediaParent(parentElement);
}
function $c9441534493a403f$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($c9441534493a403f$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return element;
    return $c9441534493a403f$var$findParentBeforePointer(parentElement);
}
function $c9441534493a403f$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $c9441534493a403f$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $c9441534493a403f$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $c9441534493a403f$var$isNodeInlineMark(node) {
    return $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $c9441534493a403f$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $c9441534493a403f$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
	 * This checks if the element has any descendents with the data-inline-card
	 * attribute set to 'true'. If it does, we should not consider it as an
	 * inline text mark.
	 **/ if ($c9441534493a403f$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $c9441534493a403f$var$hasInlineNodeDescendant(node) {
    if ($c9441534493a403f$var$isElementNode(node)) {
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($c9441534493a403f$var$hasInlineNodeDescendant);
    }
    return false;
}
function $c9441534493a403f$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev && ($c9441534493a403f$var$isTextNode(prev) || $c9441534493a403f$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($c9441534493a403f$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($c9441534493a403f$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $c9441534493a403f$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $c9441534493a403f$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
	 * If anchor node is an element (e.g. after a triple click) the anchorOffset
	 * is the number of child nodes preceding the anchor.
	 * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
	 *
	 * For end pos we calculate the number of characters by stepping through
	 * each of the node's children.
	 */ if (node instanceof HTMLElement && $c9441534493a403f$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $c9441534493a403f$var$getStartPos(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $c9441534493a403f$var$getStartPos(node) + offset;
    }
    const parent = $c9441534493a403f$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $c9441534493a403f$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $c9441534493a403f$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($c9441534493a403f$var$isNodeInlineTextMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($c9441534493a403f$var$isElementInlineMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $c9441534493a403f$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $c9441534493a403f$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $c9441534493a403f$var$findParent(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $c9441534493a403f$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $c9441534493a403f$var$getStartPos(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $c9441534493a403f$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $c9441534493a403f$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $c9441534493a403f$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $eS2Dn.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("4apTl", function(module, exports) {

$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $3b0115c3167e4664$export$b0ea72d31617ccea);

var $h03xs = parcelRequire("h03xs");

var $VSDnB = parcelRequire("VSDnB");
function $3b0115c3167e4664$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $h03xs.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});

parcelRegister("hAPWV", function(module, exports) {

$parcel$export(module.exports, "getIndexMatch", () => $8b6d6fb20e026dde$export$fb7dab895a0d310e);
function $8b6d6fb20e026dde$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $8b6d6fb20e026dde$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});




parcelRegister("8Mz83", function(module, exports) {

$parcel$export(module.exports, "AnnotationsContextWrapper", () => $68c25c02b6872087$export$787af8a111ff3c03);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $6MIvG = parcelRequire("6MIvG");

var $iatcV = parcelRequire("iatcV");

var $2EsbE = parcelRequire("2EsbE");
const $68c25c02b6872087$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const { range: range, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const { setDraftRange: setDraftRange, clearDraftRange: clearDraftRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    // We want to set the draft to the range the user highlighted
    const setRangeForDraft = (0, $5uXOq.useCallback)(()=>{
        setDraftRange(range, type);
    }, [
        range,
        setDraftRange,
        type
    ]);
    const clearRangeForDraft = (0, $5uXOq.useCallback)(()=>{
        clearDraftRange(type);
    }, [
        type,
        clearDraftRange
    ]);
    const render = (0, $5uXOq.useCallback)(({ applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children, !!hoverComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6MIvG.RangeValidator), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            component: hoverComponent,
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }), !!selectionComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iatcV.SelectionRangeValidator), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            selectionComponent: selectionComponent,
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }));
    }, [
        hoverComponent,
        selectionComponent,
        children,
        rendererRef,
        createAnalyticsEvent
    ]);
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYAgE.AnnotationsDraftContextWrapper), {
        setDraftRange: setRangeForDraft,
        clearDraftRange: clearRangeForDraft
    }, render);
};

});
parcelRegister("6MIvG", function(module, exports) {

$parcel$export(module.exports, "RangeValidator", () => $38d3fe2fadcf735b$export$6d8376a902cb8aa7);

var $5uXOq = parcelRequire("5uXOq");

var $7g31n = parcelRequire("7g31n");

var $fCNtA = parcelRequire("fCNtA");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");
const $38d3fe2fadcf735b$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $kuusl.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7g31n.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("7g31n", function(module, exports) {

$parcel$export(module.exports, "Mounter", () => $3da53cae08f8e9e6$export$2109cd350bcf6eda);

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $fCNtA = parcelRequire("fCNtA");
const $3da53cae08f8e9e6$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        if (!isAnnotationAllowed || !documentPosition || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        return applyAnnotation(draftDocumentPosition || documentPosition, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        actions,
        range
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("fVTp8", function(module, exports) {

$parcel$export(module.exports, "dataAttributes", () => $c2a45e53becb69f1$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $c2a45e53becb69f1$export$e14699d956e87e73);
const $c2a45e53becb69f1$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $c2a45e53becb69f1$var$buildDataAttributesQuery = (pos)=>{
    const a = $c2a45e53becb69f1$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $c2a45e53becb69f1$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($c2a45e53becb69f1$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});


parcelRegister("2EsbE", function(module, exports) {

$parcel$export(module.exports, "AnnotationRangeProvider", () => $7c7af48337b91c7a$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $7c7af48337b91c7a$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $7c7af48337b91c7a$export$708fc397e2b6f08d);

var $5uXOq = parcelRequire("5uXOq");
function $7c7af48337b91c7a$var$reducer(state, action) {
    switch(action.type){
        case 'clear':
            if (!!state.range || !!state.type) return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'clearSelection':
            if (state.type === 'selection') return {
                ...state,
                range: null,
                type: null
            };
            return state;
        case 'clearDraftSelection':
            if (state.type === 'selection') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearDraftHover':
            if (state.type === 'hover') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearHover':
            if (state.type === 'hover') return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'setSelection':
            if (state.range !== action.range || state.type !== 'selection') return {
                ...state,
                range: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.range !== action.range || state.type !== 'hover') return {
                ...state,
                range: action.range,
                type: 'hover'
            };
            return state;
        case 'setDraftSelection':
            if (state.draftRange !== action.draftRange || state.type !== 'selection') return {
                range: null,
                draftRange: action.draftRange,
                type: null
            };
            return state;
        case 'setDraftHover':
            if (state.draftRange !== action.draftRange || state.type !== 'hover') return {
                ...state,
                draftRange: action.draftRange
            };
            return state;
    }
}
const $7c7af48337b91c7a$var$AnnotationRangeStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    range: null,
    draftRange: null,
    type: null
});
const $7c7af48337b91c7a$var$AnnotationRangeDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    clearRange: ()=>{},
    clearSelectionRange: ()=>{},
    clearDraftRange: ()=>{},
    clearHoverRange: ()=>{},
    setRange: ()=>{},
    setDraftRange: ()=>{}
});
const $7c7af48337b91c7a$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ range: range, draftRange: draftRange, type: type }, dispatch] = (0, $5uXOq.useReducer)($7c7af48337b91c7a$var$reducer, {
        range: null,
        draftRange: null,
        type: null
    });
    const clearRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clear'
        }), []);
    const clearSelectionRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearDraftRange = (0, $5uXOq.useCallback)((type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'clearDraftHover'
            });
            return;
        }
        dispatch({
            type: 'clearDraftSelection'
        });
    }, []);
    const clearHoverRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setRange = (0, $5uXOq.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setDraftRange = (0, $5uXOq.useCallback)((range, type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'setDraftHover',
                draftRange: range
            });
            return;
        }
        dispatch({
            type: 'setDraftSelection',
            draftRange: range
        });
    }, []);
    const setHoverTarget = (0, $5uXOq.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const stateData = (0, $5uXOq.useMemo)(()=>({
            range: range,
            draftRange: draftRange,
            type: type
        }), [
        range,
        draftRange,
        type
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            clearRange: clearRange,
            clearSelectionRange: clearSelectionRange,
            clearDraftRange: clearDraftRange,
            clearHoverRange: clearHoverRange,
            setRange: setRange,
            setDraftRange: setDraftRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined
        }), [
        allowCommentsOnMedia,
        clearRange,
        clearSelectionRange,
        clearDraftRange,
        clearHoverRange,
        setRange,
        setDraftRange,
        setHoverTarget
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c7af48337b91c7a$var$AnnotationRangeStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c7af48337b91c7a$var$AnnotationRangeDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $7c7af48337b91c7a$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeStateContext);
};
const $7c7af48337b91c7a$export$708fc397e2b6f08d = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeDispatchContext);
};

});

parcelRegister("kuusl", function(module, exports) {

$parcel$export(module.exports, "AnnotationHoverContext", () => $b758d405b6d3becf$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $b758d405b6d3becf$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $b758d405b6d3becf$export$c288883964405c82);

var $5uXOq = parcelRequire("5uXOq");
const $b758d405b6d3becf$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWithinRange: false
});
const $b758d405b6d3becf$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $b758d405b6d3becf$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $5uXOq.useState)(false);
    const timeoutHandler = (0, $5uXOq.useRef)();
    const cancelTimeout = (0, $5uXOq.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $5uXOq.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $5uXOq.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b758d405b6d3becf$var$AnnotationHoverStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b758d405b6d3becf$var$AnnotationHoverDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $b758d405b6d3becf$export$a02bfcbbbf920306 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverStateContext);
};
const $b758d405b6d3becf$export$c288883964405c82 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("iatcV", function(module, exports) {

$parcel$export(module.exports, "SelectionRangeValidator", () => $d73a3647df6a8131$export$74435b85e23b84d9);

var $5uXOq = parcelRequire("5uXOq");

var $jWe7H = parcelRequire("jWe7H");

var $bZQ2Q = parcelRequire("bZQ2Q");

var $fCNtA = parcelRequire("fCNtA");
const $d73a3647df6a8131$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const [range, draftRange, clearRange] = (0, $jWe7H.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    if (!range && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bZQ2Q.SelectionInlineCommentMounter), {
        range: range,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("jWe7H", function(module, exports) {

$parcel$export(module.exports, "useUserSelectionRange", () => $cd0f4805a1ba9aff$export$47201332e612f5a4);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2EsbE = parcelRequire("2EsbE");

var $jqO24 = parcelRequire("jqO24");

var $cMPbW = parcelRequire("cMPbW");
const $cd0f4805a1ba9aff$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $5uXOq.useRef)();
    const { clearRange: clearRange, setRange: setRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, draftRange: draftRange, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    (0, $5uXOq.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        const onSelectionChange = (event)=>{
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                const _range = sel.getRangeAt(0);
                if (rendererDOM && (0, $jqO24.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    if ((0, $VSDnB.fg)('platform_editor_allow_annotation_triple_click')) {
                        const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                        const parentNode = startContainer.parentNode;
                        // ED-23493
                        // On triple-click in Chrome and Safari, the native Selection API's range has endContainer as a non-text node
                        // and commonAncestorContainer as root level div.ak-renderer-document when the node is followed by div or hr.
                        // Triple clicks are the only case that can cause the endContainer to be a non-text node
                        // Same check for highlight range logic in confluence/next/packages/comments-util/src/domUtils.ts Line 180
                        const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                        // isAnnotationAllowedOnRange range validation is checking if the parent container is root element and disable the comment if it is.
                        // platform/packages/editor/renderer/src/steps/index.ts Line 180
                        // This workaround ensures the endContainer is set to a text node when endContainer is non-text and the parent container is the root element
                        if (isTripleClick && // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        (0, $cMPbW.isRoot)(commonAncestorContainer) && parentNode?.nodeName === 'P' // ignore if the parent node is strong, em, etc.
                        ) {
                            const lastChild = parentNode?.lastChild && parentNode?.lastChild?.nodeType === Node.TEXT_NODE ? parentNode?.lastChild : parentNode?.lastChild?.childNodes[0];
                            _range.setEnd(lastChild, lastChild.length || 0);
                        }
                    }
                    setRange(_range.cloneRange());
                }
            }, 250);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearRange();
        };
    }, [
        rendererDOM,
        setRange,
        clearRange
    ]);
    return [
        type === 'selection' ? range : null,
        draftRange,
        clearRange
    ];
};

});
parcelRegister("jqO24", function(module, exports) {

$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $8373eb69e5c4287b$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $8373eb69e5c4287b$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("bZQ2Q", function(module, exports) {

$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $7e4c7bbc0d380e24$export$ca7741472ed8ba00);

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $4apTl = parcelRequire("4apTl");

var $fCNtA = parcelRequire("fCNtA");
const $7e4c7bbc0d380e24$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const inlineNodeTypes = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('annotations_defensive_node_name_calculations')) {
            if (!actions.isRangeAnnotatable(range)) return undefined;
            return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
        } else {
            if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
            if (actions.isValidAnnotationRange(range)) return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
            else return undefined;
        }
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        actions,
        range,
        inlineNodeTypes
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("joddd", function(module, exports) {

$parcel$export(module.exports, "useLoadAnnotations", () => $9aa08f3110a2b008$export$39f7c1a861a0d41c);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $VSDnB = parcelRequire("VSDnB");

var $iYAgE = parcelRequire("iYAgE");

var $fCNtA = parcelRequire("fCNtA");
const $9aa08f3110a2b008$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    (0, $5uXOq.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender && (0, $VSDnB.fg)('use_comments_data_annotation_updater')) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            updateSubscriberInlineComment.emit((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete
    ]);
};

});



parcelRegister("bQeYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5dc6f3b113435da$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $5uXOq = parcelRequire("5uXOq");

var $i8Zwf = parcelRequire("i8Zwf");

var $fAZXL = parcelRequire("fAZXL");

var $edXiX = parcelRequire("edXiX");
var $4ceoy = parcelRequire("4ceoy");

var $l8Gxi = parcelRequire("l8Gxi");

var $eOOFp = parcelRequire("eOOFp");
const $c5dc6f3b113435da$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getChildren () {
                return [];
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $c5dc6f3b113435da$var$navigationCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $c5dc6f3b113435da$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $c5dc6f3b113435da$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $edXiX.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $c5dc6f3b113435da$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fAZXL.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $i8Zwf.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $i8Zwf.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $c5dc6f3b113435da$export$2e2bcd8739ae039 = $c5dc6f3b113435da$var$MultiBodiedExtension;

});
parcelRegister("edXiX", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $a5dc814f02ba73ab$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $a5dc814f02ba73ab$export$9c7196ca47f67390);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $a5dc814f02ba73ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $a5dc814f02ba73ab$var$mbeExtensionContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none',
        background: "var(--ds-surface, white)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $a5dc814f02ba73ab$var$mbeNavigation = {
    name: "2ubief",
    styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $a5dc814f02ba73ab$var$extensionFrameContent = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: "var(--ds-surface, white)",
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a5dc814f02ba73ab$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $a5dc814f02ba73ab$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $a5dc814f02ba73ab$var$mbeExtensionContainer,
    mbeNavigation: $a5dc814f02ba73ab$var$mbeNavigation,
    extensionFrameContent: $a5dc814f02ba73ab$var$extensionFrameContent
};

});


parcelRegister("cOnYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $adf8f8318644b4cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $adf8f8318644b4cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $adf8f8318644b4cb$var$containerCSS = {
    name: "ecvjkq",
    styles: "min-height:100px"
};
const $adf8f8318644b4cb$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $adf8f8318644b4cb$var$containerCSS,
        "data-extension-frame": "true",
        style: {
            flexBasis: `100%`
        }
    }, props.children);
};
var $adf8f8318644b4cb$export$2e2bcd8739ae039 = $adf8f8318644b4cb$var$ExtensionFrame;

});

parcelRegister("cWRvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4346c39a86c4f3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kjhhp = parcelRequire("kjhhp");

var $503mU = parcelRequire("503mU");
function $4b4346c39a86c4f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $kjhhp.bulletListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1
    }, props.children);
}

});
parcelRegister("503mU", function(module, exports) {

$parcel$export(module.exports, "getListIndentLevel", () => $95f5719763d590de$export$75aa84e85754623e);
function $95f5719763d590de$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("5KNWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e507ebac88967e63$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $e507ebac88967e63$export$41121a410ca2f650);

var $5uXOq = parcelRequire("5uXOq");

var $l8Gxi = parcelRequire("l8Gxi");

var $bGnBY = parcelRequire("bGnBY");
function $e507ebac88967e63$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT
    }, props.children);
}
function $e507ebac88967e63$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: (0, $bGnBY.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT
    }, props.children);
}

});
parcelRegister("bGnBY", function(module, exports) {

$parcel$export(module.exports, "useSelectAllTrap", () => $08249876083d1eac$export$98871b245ee25215);

var $gkwXh = parcelRequire("gkwXh");

var $5uXOq = parcelRequire("5uXOq");

var $TM1uy = parcelRequire("TM1uy");

var $lb6Ua = parcelRequire("lb6Ua");
const $08249876083d1eac$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $TM1uy.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $lb6Ua.ElementSelection).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("TM1uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e1e4f8cfab5159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $64e1e4f8cfab5159$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $64e1e4f8cfab5159$export$2e2bcd8739ae039 = $64e1e4f8cfab5159$var$AnalyticsContext;

});

parcelRegister("lb6Ua", function(module, exports) {

$parcel$export(module.exports, "ElementSelection", () => $854590065f4073c9$export$6e6724d89f27411);
class $854590065f4073c9$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $854590065f4073c9$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $854590065f4073c9$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("lKIDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a311e98fd838fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $98a311e98fd838fb$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null);
};
var $98a311e98fd838fb$export$2e2bcd8739ae039 = $98a311e98fd838fb$var$HardBreak;

});

parcelRegister("7AttJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20de8dc9c3ed0b1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jldZL = parcelRequire("jldZL");

var $VSDnB = parcelRequire("VSDnB");

var $3rouw = parcelRequire("3rouw");

var $gkwXh = parcelRequire("gkwXh");

var $TM1uy = parcelRequire("TM1uy");

var $jSk6P = parcelRequire("jSk6P");
const $e20de8dc9c3ed0b1$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $e20de8dc9c3ed0b1$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TM1uy.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3rouw.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            onCopyText: ()=>{
                fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).CLICKED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                });
                return (0, $jSk6P.copyTextToClipboard)($e20de8dc9c3ed0b1$var$getCurrentUrlWithHash(headingId));
            },
            hideFromScreenReader: hideFromScreenReader
        }));
}
function $e20de8dc9c3ed0b1$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
    const HX = `h${props.level}`;
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HX, {
        id: headingIdToUse,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: (0, $VSDnB.fg)('platform_editor_accessible_heading_copy_link')
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: (0, $VSDnB.fg)('platform_editor_accessible_heading_copy_link')
    }))), (0, $VSDnB.fg)('platform_editor_accessible_heading_copy_link') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
        testId: "visually-hidden-heading-anchor"
    }, showAnchorLink && headingId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId
    })));
}
var $e20de8dc9c3ed0b1$export$2e2bcd8739ae039 = $e20de8dc9c3ed0b1$var$Heading;

});
parcelRegister("3rouw", function(module, exports) {

$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $b36f5408031b5508$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $b36f5408031b5508$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $458iJ = parcelRequire("458iJ");

var $3bDjY = parcelRequire("3bDjY");

var $8RXs9 = parcelRequire("8RXs9");

var $1Bd5P = parcelRequire("1Bd5P");
const $b36f5408031b5508$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $b36f5408031b5508$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b36f5408031b5508$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $b36f5408031b5508$var$copyAnchorButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline',
    outline: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
    cursor: 'pointer',
    right: 0
});
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b36f5408031b5508$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $b36f5408031b5508$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $1Bd5P.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $1Bd5P.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            this.setTooltipState((0, $1Bd5P.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
                "data-testid": "anchor-button",
                css: $b36f5408031b5508$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: hideFromScreenReader ? undefined : -1,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                type: "button"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($458iJ))), {
                label: this.getCopyAriaLabel(),
                size: this.props.level > 3 ? 'small' : 'medium',
                primaryColor: this.state.isClicked ? `var(--ds-icon-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-icon-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            }));
        };
    }
}
var $b36f5408031b5508$export$2e2bcd8739ae039 = (0, $8RXs9.default)($b36f5408031b5508$var$HeadingAnchor);

});
parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a87d743bb5f5b238079f9e871192b6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});


parcelRegister("1Bd5P", function(module, exports) {

$parcel$export(module.exports, "headingAnchorLinkMessages", () => $bb2bb569629ca076$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $bb2bb569629ca076$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $bb2bb569629ca076$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7VHMR = parcelRequire("7VHMR");
const $bb2bb569629ca076$export$74bada844422036d = (0, $7VHMR.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $bb2bb569629ca076$export$c79ebc36348824d1 = (0, $7VHMR.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $bb2bb569629ca076$export$9f52c375a6ef34fc = (0, $7VHMR.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});


parcelRegister("jSk6P", function(module, exports) {

$parcel$export(module.exports, "copyTextToClipboard", () => $2ff51d830678d63e$export$f980440e1ab4537d);
const $2ff51d830678d63e$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});


parcelRegister("112O7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4bc2ade6d275922$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");
const $a4bc2ade6d275922$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAZXL.default), {
        ...props,
        type: "inlineExtension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, result);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, text || 'inlineExtension');
    }));
};
var $a4bc2ade6d275922$export$2e2bcd8739ae039 = $a4bc2ade6d275922$var$InlineExtension;

});

parcelRegister("ieJGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $57fd1bc0570bfa35$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gmhCD = parcelRequire("gmhCD");
function $57fd1bc0570bfa35$export$2e2bcd8739ae039(props) {
    return (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: "layout-section-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-layout-section": true,
        "data-layout-columns": props?.content?.length
    }, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-layout-section": true
    }, props.children);
}

});

parcelRegister("3RqVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f45378df34617d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iEGtv = parcelRequire("iEGtv");
var $4ceoy = parcelRequire("4ceoy");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $93f45378df34617d$var$layoutColumnClearMarginTopStyles = /*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $iEGtv.clearNextSiblingMarginTopStyle), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $iEGtv.clearNextSiblingBlockMarkMarginTopStyle));
function $93f45378df34617d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $93f45378df34617d$var$layoutColumnClearMarginTopStyles
    }), props.children));
}

});
parcelRegister("iEGtv", function(module, exports) {

$parcel$export(module.exports, "clearNextSiblingMarginTopStyle", () => $1f25160b5efdbc99$export$b15ec88fc1f2e843);
$parcel$export(module.exports, "clearNextSiblingBlockMarkMarginTopStyle", () => $1f25160b5efdbc99$export$eb3aaa9338936d44);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $1f25160b5efdbc99$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1f25160b5efdbc99$export$b15ec88fc1f2e843 = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $1f25160b5efdbc99$var$textElements = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];
const $1f25160b5efdbc99$var$nextSiblingBlockMarkContentSelectors = $1f25160b5efdbc99$var$textElements.map((elem)=>`+ .fabric-editor-block-mark > ${elem}`).join(',');
const $1f25160b5efdbc99$export$eb3aaa9338936d44 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$1f25160b5efdbc99$var$nextSiblingBlockMarkContentSelectors}`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});

});


parcelRegister("qjsNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd334ef870d278c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $ccd334ef870d278c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, props.children);
}

});

parcelRegister("jHa9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fce9f67e250185e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8hSwr = parcelRequire("8hSwr");
const $4fce9f67e250185e$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8hSwr.default), {
        hasContent: true,
        dataAttributes: dataAttributes
    }, children);
};
var $4fce9f67e250185e$export$2e2bcd8739ae039 = $4fce9f67e250185e$var$RenderCaption;

});
parcelRegister("8hSwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb2c70aa755b661$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2AEnW = parcelRequire("2AEnW");
function $5bb2c70aa755b661$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5bb2c70aa755b661$var$captionWrapperStyle = {
    name: "1f0iwez",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
};
const $5bb2c70aa755b661$var$placeholderStyle = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $5bb2c70aa755b661$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $5bb2c70aa755b661$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            xcss: $5bb2c70aa755b661$var$placeholderStyle
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), null, formatMessage((0, $2AEnW.messages).placeholder))) : null, children);
    }
}
var $5bb2c70aa755b661$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5bb2c70aa755b661$export$f7feb87190a94c76);

});
parcelRegister("2AEnW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa314c48a072d691$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $aa314c48a072d691$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("6svWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6654d29b704d772$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dwptW = parcelRequire("dwptW");

var $jlYLw = parcelRequire("jlYLw");

var $uTDrM = parcelRequire("uTDrM");

var $503mU = parcelRequire("503mU");
function $e6654d29b704d772$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $uTDrM.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, $jlYLw.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $uTDrM.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dwptW.orderedListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps
    }, props.children);
}

});
parcelRegister("jlYLw", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $6a64108c33d9274c$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $6a64108c33d9274c$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $6a64108c33d9274c$export$ea95db02cc29c78f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kjhhp = parcelRequire("kjhhp");
var $dwptW = parcelRequire("dwptW");

var $gE8f9 = parcelRequire("gE8f9");
const $6a64108c33d9274c$export$bafd6beec0797f87 = 24;
var $6a64108c33d9274c$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($6a64108c33d9274c$var$CSS_VAR_NAMES || {});
const $6a64108c33d9274c$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $6a64108c33d9274c$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $6a64108c33d9274c$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $6a64108c33d9274c$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $6a64108c33d9274c$var$stringifyStyle(style);
    return style;
}
const $6a64108c33d9274c$export$ea95db02cc29c78f = /*#__PURE__*/ (0, $f8Sb3.css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $6a64108c33d9274c$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, $gE8f9.browser).gecko ? 'display: inline-block;' : '', ";}}", (0, $dwptW.orderedListSelector), ",", (0, $kjhhp.bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");

});

parcelRegister("uTDrM", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $ebe278356715a8a4$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $ebe278356715a8a4$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $ebe278356715a8a4$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $ebe278356715a8a4$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $ebe278356715a8a4$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $ebe278356715a8a4$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $ebe278356715a8a4$export$8ef94ae42a3729bd = 1;
const $ebe278356715a8a4$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $ebe278356715a8a4$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $ebe278356715a8a4$export$d445360e2a3c026b(order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
};
const $ebe278356715a8a4$export$320582fc14ba1e0f = (options)=>{
    const order = $ebe278356715a8a4$export$d445360e2a3c026b(options.order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $ebe278356715a8a4$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $ebe278356715a8a4$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $ebe278356715a8a4$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("9FXQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d2961aa3d14cef$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $EGPjg = parcelRequire("EGPjg");
function $26d2961aa3d14cef$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", dataAttributes, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $EGPjg.default), null, children)));
}

});
parcelRegister("EGPjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $372a7010ecff9ba7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $372a7010ecff9ba7$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "\xa0");
    return children;
}

});


parcelRegister("hqBb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $add04eab04996fda$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $add04eab04996fda$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-placeholder": `${props.text}`
    }, props.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null);
}

});

parcelRegister("ixoQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1bb5022786e53a6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $e1bb5022786e53a6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("hr", {
        role: "presentation"
    });
}

});

parcelRegister("dkc63", function(module, exports) {

$parcel$export(module.exports, "isTableResizingEnabled", () => $7478efdfea2a60bf$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $7478efdfea2a60bf$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $7478efdfea2a60bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $VSDnB = parcelRequire("VSDnB");

var $5vnE9 = parcelRequire("5vnE9");
var $5or39 = parcelRequire("5or39");
var $5J0oM = parcelRequire("5J0oM");

var $9BYlQ = parcelRequire("9BYlQ");

var $iHYdz = parcelRequire("iHYdz");

var $fKLIs = parcelRequire("fKLIs");

var $gmhCD = parcelRequire("gmhCD");

var $OxITw = parcelRequire("OxITw");

var $cWojJ = parcelRequire("cWojJ");

var $4BsEy = parcelRequire("4BsEy");

var $2aXGN = parcelRequire("2aXGN");

var $a4mor = parcelRequire("a4mor");

var $kjIja = parcelRequire("kjIja");

var $eIscD = parcelRequire("eIscD");
const $7478efdfea2a60bf$export$eec82c0a93aa66d9 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) || (0, $kjIja.isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $7478efdfea2a60bf$export$bdb2dadcb04aad50 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $7478efdfea2a60bf$var$orderChildren = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $9BYlQ.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5or39.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $7478efdfea2a60bf$var$hasRowspan = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $7478efdfea2a60bf$var$getRefTop = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $7478efdfea2a60bf$var$shouldHeaderStick = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $7478efdfea2a60bf$var$shouldHeaderPinBottom = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $7478efdfea2a60bf$var$addSortableColumn = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $7478efdfea2a60bf$var$isHeaderRowEnabled = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cWojJ.TableHeader);
    return children.every((node)=>node.type === (0, $cWojJ.TableHeader));
};
const $7478efdfea2a60bf$var$tableCanBeSticky = (node, children)=>{
    return $7478efdfea2a60bf$var$isHeaderRowEnabled(children) && node && node.firstChild && !$7478efdfea2a60bf$var$hasRowspan(node.firstChild);
};
class $7478efdfea2a60bf$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $eIscD.TableStickyScrollbar)(this.wrapperRef.current);
    }
    componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $6gEe5.tableMarginTop) - (0, $2aXGN.tableStickyPadding);
    }
    get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $iHYdz.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $OxITw.FullPagePadding}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth),
                `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $kjIja.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const fixTableSSRResizing = (0, $VSDnB.fg)('platform-fix-table-ssr-resizing');
        const tableWidthNew = fixTableSSRResizing ? (0, $fKLIs.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $kjIja.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $iHYdz.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        let style;
        if (fixTableSSRResizing) style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            ref: this.props.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
            "data-testid": "sticky-scrollbar-sentinel-top"
        }), stickyHeaders && $7478efdfea2a60bf$var$tableCanBeSticky(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2aXGN.StickyTable), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: tableWidth,
            layout: layout,
            renderWidth: renderWidth,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            allowTableResizing: allowTableResizing
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER,
            ref: this.wrapperRef,
            onScroll: this.props.stickyHeaders && this.onWrapperScrolled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4mor.Table), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing
        }, this.grabFirstRowRef(children))), $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
            ref: this.stickyScrollbarRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)",
                // MAX_BROWSER_SCROLLBAR_HEIGHT
                // Follow editor to hide by default so it does not show empty gap in SSR
                // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: fixTableSSRResizing ? 'none' : 'block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                width: '100%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: this.tableRef.current?.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            }
        })), $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
            "data-testid": "sticky-scrollbar-sentinel-bottom"
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $2aXGN.tableStickyPadding);
            const tableTop = $7478efdfea2a60bf$var$getRefTop(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $7478efdfea2a60bf$var$shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $7478efdfea2a60bf$var$shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $7478efdfea2a60bf$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        const orderedChildren = (0, $5vnE9.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$export$f2c3aea42b2a048f, this.props, orderedChildren);
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $7478efdfea2a60bf$var$isHeaderRowEnabled(childrenArray) && tableNode && !(0, $5or39.hasMergedCell)(tableNode)) return $7478efdfea2a60bf$var$addSortableColumn($7478efdfea2a60bf$var$orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $7478efdfea2a60bf$var$isHeaderRowEnabled(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
const $7478efdfea2a60bf$var$TableWithShadows = (0, $ajc8Z.default)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $7478efdfea2a60bf$var$TableWithWidth = (props)=>{
    // Remember, `width` will be 0 during SSR
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ceoy.WidthConsumer), null, ({ width: width })=>{
        const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $OxITw.FullPagePadding) * 2 : width;
        const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$var$TableWithShadows, {
            renderWidth: renderWidth,
            ...props
        });
        // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$export$91e0997fd3f75d56, {
            renderWidth: renderWidth,
            ...props
        });
    });
};
var $7478efdfea2a60bf$export$2e2bcd8739ae039 = (0, $4BsEy.withSmartCardStorage)($7478efdfea2a60bf$var$TableWithWidth);

});
parcelRegister("6gEe5", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $356bd8bd1d42bb7c$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $356bd8bd1d42bb7c$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $356bd8bd1d42bb7c$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $356bd8bd1d42bb7c$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $356bd8bd1d42bb7c$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $356bd8bd1d42bb7c$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $356bd8bd1d42bb7c$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $356bd8bd1d42bb7c$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $356bd8bd1d42bb7c$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $356bd8bd1d42bb7c$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $gE8f9 = parcelRequire("gE8f9");

var $cYeQP = parcelRequire("cYeQP");

var $hgR8Y = parcelRequire("hgR8Y");
function $356bd8bd1d42bb7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $356bd8bd1d42bb7c$export$808015ab1dd6897a = 24;
const $356bd8bd1d42bb7c$export$afe1899c3eea9823 = 16;
const $356bd8bd1d42bb7c$export$910bf0d22c3d10f2 = 14;
const $356bd8bd1d42bb7c$export$a43e30915fab3ccf = 8;
const $356bd8bd1d42bb7c$export$531f77930bf508de = 48;
const $356bd8bd1d42bb7c$export$c60fae4049791eae = 140;
const $356bd8bd1d42bb7c$export$72aad729077aa0fb = 1;
const $356bd8bd1d42bb7c$export$e56b8ca552b280f6 = 8;
const $356bd8bd1d42bb7c$export$bba39e724bc39451 = 6;
const $356bd8bd1d42bb7c$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $9UDEr.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $9UDEr.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $9UDEr.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $9UDEr.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $356bd8bd1d42bb7c$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $356bd8bd1d42bb7c$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop = ()=>(0, $gmhCD.editorExperiment)('nested-dnd', true) ? $356bd8bd1d42bb7c$var$_ref2 : $356bd8bd1d42bb7c$var$_ref;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $356bd8bd1d42bb7c$export$c2bf8eea75aa9302 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $hgR8Y.tableCellBackgroundStyleOverride)(), " .", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $iHYdz.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $356bd8bd1d42bb7c$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `> tbody > tr > th, > tbody > tr > td` : 'th, td', "{min-width:", $356bd8bd1d42bb7c$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", (0, $gE8f9.browser).gecko || (0, $gE8f9.browser).ie || (0, $gE8f9.browser).mac && (0, $gE8f9.browser).chrome ? 'background-clip: padding-box;' : '', " ", $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}", (0, $VSDnB.fg)('platform_editor_nested_tables_renderer_styles') ? `// Ensures nested tables are compatible with parent table background color - uses specificity to ensure tables nested by extensions are not affected
			> tbody > tr > td {
				background-color: ${"var(--ds-surface, #FFFFFF)"};
			}` : '', " th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $iHYdz.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
const $356bd8bd1d42bb7c$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorWideLayoutWidth));
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("eluMF", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $b41fea6975363b1e$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $b41fea6975363b1e$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)();
};

});

parcelRegister("cYeQP", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $dca73d3fed5e4b1b$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $dca73d3fed5e4b1b$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $dca73d3fed5e4b1b$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");
const $dca73d3fed5e4b1b$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
const $dca73d3fed5e4b1b$export$a4fbe21dc6fae881 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;font-family:", (0, $iHYdz.akEditorCodeFontFamily), ";min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;--ds--code--bg-color:transparent;white-space:normal;.code-block-gutter-pseudo-element::before{content:attr(data-label);}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{position:relative;background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "::before{content:'1';visibility:hidden;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
const $dca73d3fed5e4b1b$export$3aa5ee2f4c156533 = /*#__PURE__*/ (0, $f8Sb3.css)("::before{content:' ';line-height:", (0, $iHYdz.akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, $iHYdz.akEditorLineHeight), "em!important;}");

});

parcelRegister("hgR8Y", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $eaa2b3bf40c7fca9$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $hAs1r = parcelRequire("hAs1r");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $eaa2b3bf40c7fca9$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $9UDEr.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $hAs1r.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $eaa2b3bf40c7fca9$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)($eaa2b3bf40c7fca9$var$mapBackgroundColors());

});
parcelRegister("hAs1r", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $3966f91ec47ca318$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $3966f91ec47ca318$export$a270511a0e7fd61a);
// This import will be stripped on build

var $kTHGn = parcelRequire("kTHGn");
function $3966f91ec47ca318$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $3966f91ec47ca318$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $3966f91ec47ca318$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("5vnE9", function(module, exports) {

$parcel$export(module.exports, "compose", () => $8cb395a24b5942e2$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $8cb395a24b5942e2$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("5or39", function(module, exports) {

$parcel$export(module.exports, "getColumnWidths", () => $a59f56ae192d20af$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $a59f56ae192d20af$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $a59f56ae192d20af$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $a59f56ae192d20af$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $a59f56ae192d20af$export$889a8e446452be16);

var $VSDnB = parcelRequire("VSDnB");
function $a59f56ae192d20af$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$98951d3cdcfd364b(node) {
    // TODO: replaced with getColumnWidths, which correctly scans entire table for column widths
    if ((0, $VSDnB.fg)('platform_editor_table_row_span_fix')) {
        const firstRow = node.firstChild;
        const tableColumnWidths = [];
        if (firstRow) firstRow.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
            else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
            else tableColumnWidths.push(0);
        });
        return tableColumnWidths;
    }
    let tableColumnWidths = [];
    const firstRow = node.firstChild;
    if (firstRow) // Sanity validation, but it should always have a first row
    // Iterate for the cells in the first row
    firstRow.forEach((colNode)=>{
        const colwidth = colNode.attrs.colwidth || [
            0
        ];
        // If we have colwidth, we added it
        if (colwidth) tableColumnWidths = [
            ...tableColumnWidths,
            ...colwidth
        ];
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $a59f56ae192d20af$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $a59f56ae192d20af$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("5J0oM", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $c09b1d49576acabb$export$49215374a8bec29c);

var $9BYlQ = parcelRequire("9BYlQ");
var $c09b1d49576acabb$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $c09b1d49576acabb$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $c09b1d49576acabb$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $c09b1d49576acabb$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $c09b1d49576acabb$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $c09b1d49576acabb$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $c09b1d49576acabb$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $c09b1d49576acabb$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                // TODO: Check what should be the fallback when mention does not have a text
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $c09b1d49576acabb$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $c09b1d49576acabb$export$49215374a8bec29c = (options, order = (0, $9BYlQ.SortOrder).ASC)=>{
    const normalizeTextParser = $c09b1d49576acabb$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $c09b1d49576acabb$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $c09b1d49576acabb$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $9BYlQ.SortOrder).DESC ? -1 : 1) * $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $c09b1d49576acabb$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("9BYlQ", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $42ab1316856d1585$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $dEtqo = parcelRequire("dEtqo");

var $kXC89 = parcelRequire("kXC89");
var $42ab1316856d1585$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("kXC89", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $fa36a5395f686390$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $fa36a5395f686390$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsNext", () => $fa36a5395f686390$export$3f050002d3df641b);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $fa36a5395f686390$export$63ca43752be70b90);
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $fa36a5395f686390$export$501a79d885598191);
var $fa36a5395f686390$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $fa36a5395f686390$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $fa36a5395f686390$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $fa36a5395f686390$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $fa36a5395f686390$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});



parcelRegister("fKLIs", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $78b5f00ff26d55fc$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $78b5f00ff26d55fc$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $78b5f00ff26d55fc$export$3930799be057b305);

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $bQr2R = parcelRequire("bQr2R");

var $ejmVg = parcelRequire("ejmVg");

var $6gEe5 = parcelRequire("6gEe5");

var $eOOFp = parcelRequire("eOOFp");
const $78b5f00ff26d55fc$var$GRID_SIZE = 8;
const $78b5f00ff26d55fc$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $iHYdz.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $iHYdz.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $iHYdz.akEditorFullWidthLayoutWidth)
};
const $78b5f00ff26d55fc$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $78b5f00ff26d55fc$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $78b5f00ff26d55fc$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // TODO: ED-15663
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    if (node.type === schema.nodes.layoutSection && !(0, $VSDnB.fg)('platform_editor_nested_tables_resizing')) {
        parentWidth += (0, $iHYdz.akLayoutGutterOffset) * 2; // extra width that gets added to layout
        // Calculate width of parent layout column when
        // Parallel layout with viewport greater than 1024px
        // OR side panel of an extension is open and change the node width to smaller than containerWidth
        if (containerWidth.width > (0, $iHYdz.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
            parentWidth -= ((0, $ejmVg.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
            const $pos = state.doc.resolve(pos);
            const column = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
                state.schema.nodes.layoutColumn
            ]);
            if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
            parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
        }
    }
    switch(node.type){
        case schema.nodes.layoutSection:
            if ((0, $VSDnB.fg)('platform_editor_nested_tables_resizing')) {
                parentWidth += (0, $iHYdz.akLayoutGutterOffset) * 2; // extra width that gets added to layout
                // Calculate width of parent layout column when
                // Parallel layout with viewport greater than 1024px
                // OR side panel of an extension is open and change the node width to smaller than containerWidth
                if (containerWidth.width > (0, $iHYdz.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                    parentWidth -= ((0, $ejmVg.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
                    const $pos = state.doc.resolve(pos);
                    const column = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
                        state.schema.nodes.layoutColumn
                    ]);
                    if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                    parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
                }
            }
            // account for the padding of the parent node
            parentWidth -= (0, $ejmVg.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $78b5f00ff26d55fc$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE;
            // padding left
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 4 - $78b5f00ff26d55fc$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            if ((0, $VSDnB.fg)('platform_editor_nested_tables_resizing')) {
                // Calculate the available column width
                if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
                // Compensate for padding
                parentWidth -= (0, $6gEe5.tableCellPadding) * 2;
            }
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $78b5f00ff26d55fc$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    let parent;
    if ((0, $VSDnB.fg)('platform_editor_nested_tables_resizing')) parent = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader
    ]);
    else parent = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand
    ]);
    return parent ? parent.node : null;
};
const $78b5f00ff26d55fc$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $eOOFp.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $78b5f00ff26d55fc$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $78b5f00ff26d55fc$export$9b77d38feba5446[node?.attrs.layout] || (0, $iHYdz.akEditorDefaultLayoutWidth);
};
const $78b5f00ff26d55fc$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $78b5f00ff26d55fc$export$3930799be057b305(node) - offset;
    return $78b5f00ff26d55fc$export$3930799be057b305(node);
};

});
parcelRegister("5r0mK", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $3f4fc20879d21ebe$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $3f4fc20879d21ebe$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $3f4fc20879d21ebe$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $3f4fc20879d21ebe$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $3f4fc20879d21ebe$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $3f4fc20879d21ebe$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $3f4fc20879d21ebe$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $3f4fc20879d21ebe$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $3f4fc20879d21ebe$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $3f4fc20879d21ebe$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $3f4fc20879d21ebe$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $3f4fc20879d21ebe$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $3f4fc20879d21ebe$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $3f4fc20879d21ebe$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $3f4fc20879d21ebe$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $3f4fc20879d21ebe$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $3f4fc20879d21ebe$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $3f4fc20879d21ebe$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $3f4fc20879d21ebe$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $3f4fc20879d21ebe$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $3f4fc20879d21ebe$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $3f4fc20879d21ebe$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $3f4fc20879d21ebe$export$2344b14b097df817);
// src/selection.ts

var $gZGBX = parcelRequire("gZGBX");

var $kCV8T = parcelRequire("kCV8T");
var $3f4fc20879d21ebe$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $3f4fc20879d21ebe$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $3f4fc20879d21ebe$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$7d6e4e6663186878 = (tr)=>{
    if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $3f4fc20879d21ebe$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $kCV8T.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $kCV8T.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $3f4fc20879d21ebe$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $3f4fc20879d21ebe$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $kCV8T.Node) && node.type && node.type.spec.selectable);
var $3f4fc20879d21ebe$var$shouldSelectNode = (node)=>$3f4fc20879d21ebe$var$isSelectableNode(node) && node.type.isLeaf;
var $3f4fc20879d21ebe$var$setSelection = (node, pos, tr)=>{
    if ($3f4fc20879d21ebe$var$shouldSelectNode(node)) return tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(pos)));
    return $3f4fc20879d21ebe$export$1df6d14df6b0b758(pos)(tr);
};
var $3f4fc20879d21ebe$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($3f4fc20879d21ebe$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $3f4fc20879d21ebe$var$setSelection(content, pos, tr);
            }
        }
        if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $3f4fc20879d21ebe$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $3f4fc20879d21ebe$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $3f4fc20879d21ebe$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $3f4fc20879d21ebe$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $gZGBX.NodeSelection);
};
var $3f4fc20879d21ebe$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $3f4fc20879d21ebe$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $3f4fc20879d21ebe$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($3f4fc20879d21ebe$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $3f4fc20879d21ebe$var$cloneTr(tr);
        }
        return tr;
    };
var $3f4fc20879d21ebe$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $kCV8T.Fragment) ? content : (0, $kCV8T.Fragment).from(content));
};
var $3f4fc20879d21ebe$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $3f4fc20879d21ebe$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $kCV8T.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $kCV8T.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $3f4fc20879d21ebe$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $3f4fc20879d21ebe$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $3f4fc20879d21ebe$export$fe09644e3bc6166b($from, predicate);
    };
var $3f4fc20879d21ebe$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $3f4fc20879d21ebe$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $3f4fc20879d21ebe$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $3f4fc20879d21ebe$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
    };
var $3f4fc20879d21ebe$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$dc159056ffdb4c76((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $3f4fc20879d21ebe$export$fe09644e3bc6166b($pos, (node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node));
};
var $3f4fc20879d21ebe$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$178ecaf80f45fdb6((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $3f4fc20879d21ebe$export$8556d79fa8189214((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $3f4fc20879d21ebe$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($3f4fc20879d21ebe$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $3f4fc20879d21ebe$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $gZGBX.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $3f4fc20879d21ebe$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $3f4fc20879d21ebe$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $3f4fc20879d21ebe$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $3f4fc20879d21ebe$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $3f4fc20879d21ebe$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $3f4fc20879d21ebe$export$ddc1620722e25671 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $3f4fc20879d21ebe$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $3f4fc20879d21ebe$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $3f4fc20879d21ebe$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $3f4fc20879d21ebe$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $3f4fc20879d21ebe$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$3f4fc20879d21ebe$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("bQr2R", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $6a203c68476205e6$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $6a203c68476205e6$export$91624ec52c59c24c);
const $6a203c68476205e6$export$f5ecdce4c60ff98b = 8;
const $6a203c68476205e6$export$5ac5087fe1217160 = $6a203c68476205e6$export$f5ecdce4c60ff98b * 2;
const $6a203c68476205e6$export$91624ec52c59c24c = 12;

});

parcelRegister("ejmVg", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $16b49a7404f3316f$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $16b49a7404f3316f$export$a1bb91aa2d5fcce8);
const $16b49a7404f3316f$export$cd04f19842abff0 = 8;
const $16b49a7404f3316f$export$a1bb91aa2d5fcce8 = $16b49a7404f3316f$export$cd04f19842abff0 * 1.5;

});


parcelRegister("OxITw", function(module, exports) {

$parcel$export(module.exports, "FullPagePadding", () => $19a4579e32968c00$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $19a4579e32968c00$export$74b525449cc7cbd1);
$parcel$export(module.exports, "rendererStyles", () => $19a4579e32968c00$export$1c4377249312209);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");


var $cSyk1 = parcelRequire("cSyk1");

var $9R9Rb = parcelRequire("9R9Rb");

var $1xqpZ = parcelRequire("1xqpZ");
var $cx4Bg = parcelRequire("cx4Bg");
var $kRRtM = parcelRequire("kRRtM");
var $cYeQP = parcelRequire("cYeQP");
var $7Acon = parcelRequire("7Acon");
var $719f3 = parcelRequire("719f3");
var $4E5wI = parcelRequire("4E5wI");
var $kZxLT = parcelRequire("kZxLT");
var $idytF = parcelRequire("idytF");
var $5fBxY = parcelRequire("5fBxY");
var $jlYLw = parcelRequire("jlYLw");
var $ceYEW = parcelRequire("ceYEW");
var $4jyW9 = parcelRequire("4jyW9");
var $bv4Ps = parcelRequire("bv4Ps");
var $aSoqv = parcelRequire("aSoqv");
var $iJOES = parcelRequire("iJOES");
var $6gEe5 = parcelRequire("6gEe5");
var $1bQ0V = parcelRequire("1bQ0V");
var $jRk4M = parcelRequire("jRk4M");
var $fwxzS = parcelRequire("fwxzS");

var $ajc8Z = parcelRequire("ajc8Z");
var $bbl9Y = parcelRequire("bbl9Y");

var $gE8f9 = parcelRequire("gE8f9");

var $iHYdz = parcelRequire("iHYdz");

var $l8Gxi = parcelRequire("l8Gxi");

var $3rouw = parcelRequire("3rouw");

var $2o2hu = parcelRequire("2o2hu");

var $dkc63 = parcelRequire("dkc63");


var $gmhCD = parcelRequire("gmhCD");
const $19a4579e32968c00$export$12fd658e5eef0d79 = 32;
const $19a4579e32968c00$var$tableShadowWidth = 32;
const $19a4579e32968c00$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
const $19a4579e32968c00$var$telepointerStyles = (colorMode)=>{
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)("#", $19a4579e32968c00$export$74b525449cc7cbd1, "{display:inline-block;position:relative;width:1.5px;height:25px;background:linear-gradient(\n\t\t\t\t45deg,\n\t\t\t\t", colorMode === 'dark' ? '#f5cd47' : '#f8e6a0', " -12.02%,\n\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " 19.18%,\n\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t);margin-left:var(--ds-space-025, 2px);&::after{content:'AI';position:absolute;display:block;top:0;left:0;font-size:10px;font-weight:var(--ds-font-weight-bold, 700);width:12.5px;height:13px;padding-top:1px;padding-left:1.5px;line-height:initial;border-radius:0px 2px 2px 0px;color:var(--ds-text-inverse, white);background:linear-gradient(\n\t\t\t\t\t45deg,\n\t\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " -57%,\n\t\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t\t);}}");
};
/**
 * **DEPRECATED**
 *
 * Originally defined in `@atlaskit/theme/typography`, but moved here as it has since been deleted in favor of typography tokens.
 * This should be removed as part of editor token work. More info:
 * https://atlassian.slack.com/archives/C075G5D7ZP1/p1733449725865539?thread_ts=1732159801.409789&cid=C075G5D7ZP1
 * */ const $19a4579e32968c00$var$headingSizesImport = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
const $19a4579e32968c00$var$getLineHeight = (fontCode)=>$19a4579e32968c00$var$headingSizesImport[fontCode].lineHeight / $19a4579e32968c00$var$headingSizesImport[fontCode].size;
const $19a4579e32968c00$var$headingSizes = {
    h1: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h700')
    },
    h2: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h600')
    },
    h3: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h500')
    },
    h4: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h400')
    },
    h5: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h300')
    },
    h6: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h100')
    }
};
const $19a4579e32968c00$var$headingAnchorStyle = (headingTag)=>/*#__PURE__*/ // TODO Delete this comment after verifying space token -> previous value `margin-left: 6px`
    (0, $f8Sb3.css)(".", (0, $3rouw.HeadingAnchorWrapperClassName), "{position:absolute;height:", $19a4579e32968c00$var$headingSizes[headingTag].lineHeight, "em;margin-left:var(--ds-space-075, 6px);button{padding-left:0;padding-right:0;}}/**\n     * Applies hover effects to the heading anchor link button\n     * to fade in when the user rolls over the heading.\n     *\n     * The link is persistent on mobile, so we use feature detection\n     * to enable hover effects for systems that support it (desktop).\n     *\n     * @see https://caniuse.com/mdn-css_at-rules_media_hover\n     */@media (hover: hover) and (pointer: fine){.", (0, $3rouw.HeadingAnchorWrapperClassName), "{>button{opacity:0;transform:translate(-8px, 0px);transition:opacity 0.2s ease 0s,transform 0.2s ease 0s;}}&:hover{.", (0, $3rouw.HeadingAnchorWrapperClassName), ">button{opacity:1;transform:none!important;}}}.", (0, $3rouw.HeadingAnchorWrapperClassName), "{button:focus{opacity:1;transform:none!important;}}");
const $19a4579e32968c00$var$alignedHeadingAnchorStyle = ({ allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowNestedHeaderLinks) return '';
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    return /*#__PURE__*/ (0, $f8Sb3.css)(".fabric-editor-block-mark[data-align]>{h1,h2,h3,h4,h5,h6{position:relative;}}.fabric-editor-block-mark:not([data-align='center'])[data-align]{.", (0, $3rouw.HeadingAnchorWrapperClassName), "{margin:0 var(--ds-space-075, 6px) 0 0;transform:translateX(calc(-100% - var(--ds-space-075, 6px)));}@media (hover: hover) and (pointer: fine){.", (0, $3rouw.HeadingAnchorWrapperClassName), ">button{transform:translate(8px, 0px);}}}");
};
const $19a4579e32968c00$var$tableSortableColumnStyle = ({ allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowColumnSorting) return '';
    let headingsCss = '';
    if (allowNestedHeaderLinks) headingsCss = `
      /**
       * When the sort button is enabled we want the heading's copy link button
       * to reserve space so that it can prematurely wrap to avoid the button
       * being displayed underneath the sort button (hidden or obscured).
       *
       * The two buttons fight each other since the sort button is displayed
       * on hover of the <th /> and the copy link button is displayed on hover
       * of the heading.
       *
       * Note that this can break the WYSIWYG experience in the case where
       * a heading fills the width of the table cell and the only thing which
       * wraps is the copy link button. This is hopefully a rare fringe case.
       */
      .${0, $3rouw.HeadingAnchorWrapperClassName} {
        position: unset;
      }
      > {
        h1, h2, h3, h4, h5, h6 {
          margin-right: 30px;
        }
      }
    `;
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "{padding:0;", (0, $VSDnB.fg)('platform_editor_nested_tables_renderer_styles') ? /*#__PURE__*/ (0, $f8Sb3.css)(">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, "{margin:0;.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;transition:opacity 0.2s ease-in-out;}}>.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover:not(\n\t\t\t\t\t\t\t\t:has(\n\t\t\t\t\t\t\t\t\t\t.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "\n\t\t\t\t\t\t\t\t\t\t\t.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ":hover\n\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t)>.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}") : /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, "{margin:0;.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;transition:opacity 0.2s ease-in-out;}}.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover{.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}"), ";.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, "{width:100%;height:100%;padding:", (0, $6gEe5.tableCellPadding), "px;border-width:1.5px;border-style:solid;border-color:transparent;", headingsCss, ";>*:first-child{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}@supports selector(:focus-visible){&:focus{outline:unset;}&:focus-visible{border-color:", `var(--ds-border-focused, ${$829f609a65d26a98$export$e62e8919cca44969})`, ";}}}}");
};
const $19a4579e32968c00$var$fullPageStyles = ({ appearance: appearance }, { theme: theme })=>{
    if (appearance !== 'full-page') return '';
    return /*#__PURE__*/ (0, $f8Sb3.css)("max-width:", theme && theme.layoutMaxWidth ? `${theme.layoutMaxWidth}px` : 'none', ";margin:0 auto;padding:0 ", appearance === 'full-page' ? $19a4579e32968c00$export$12fd658e5eef0d79 : 0, "px;");
};
const $19a4579e32968c00$var$fullWidthStyles = ({ appearance: appearance })=>{
    if (appearance !== 'full-width') return '';
    return /*#__PURE__*/ (0, $f8Sb3.css)("max-width:", (0, $iHYdz.akEditorFullWidthLayoutWidth), "px;margin:0 auto;.fabric-editor-breakout-mark:not([data-has-width='true']),.ak-renderer-extension{width:100%!important;}", (0, $dkc63.isTableResizingEnabled)(appearance) ? '' : `
      .pm-table-container {
        width: 100% !important;
      }
    `, ";");
};
const $19a4579e32968c00$var$breakoutWidthStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("*:not([data-mark-type='fragment']) .", (0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}[data-mark-type='fragment'] * .", (0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}");
};
const $19a4579e32968c00$var$getShadowOverrides = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("&.", (0, $ajc8Z.shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, $ajc8Z.shadowClassNames).LEFT_SHADOW, "::before{width:", $19a4579e32968c00$var$tableShadowWidth, "px;background:linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);}&.", (0, $ajc8Z.shadowClassNames).RIGHT_SHADOW, "::after{background:linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);right:0px;}");
};
function $19a4579e32968c00$var$getAnnotationStyles({ allowAnnotations: allowAnnotations }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return '';
    if ((0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles')) return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node]': {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
            paddingTop: "var(--ds-space-025, 2px)"
        }
    });
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`}`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
            cursor: 'pointer',
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
        }
    });
}
const $19a4579e32968c00$var$tableRowHeight = 44;
const $19a4579e32968c00$var$stickyScrollbarStyles = `
	position: relative;
	flex-direction: column;

	> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
	  width: 100%;
	  display: block;
	  visibility: hidden;
	  overflow-x: auto;
	  position: sticky;
	  bottom: ${"var(--ds-space-0, 0px)"};
	  z-index: 1;
	}

	> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
	> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   position: absolute;
	   width: 100%;
	   height: 1px;
	   margin-top: -1px;
	   // need this to avoid sentinel being focused via keyboard
	   // this still allows it to be detected by intersection observer
	   visibility: hidden;
	 }
	 > .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   top: ${$19a4579e32968c00$var$tableRowHeight * 3}px;
	 }
	 > .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
	   bottom:  ${"var(--ds-space-250, 20px)"}; // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
	 }
  `;
const $19a4579e32968c00$export$1c4377249312209 = (wrapperProps)=>(theme)=>{
        const { colorMode: colorMode, typography: typography } = (0, $cSyk1.default)();
        // This is required to be compatible with styled-components prop structure.
        const themeProps = {
            theme: theme
        };
        const { useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, appearance: appearance } = wrapperProps;
        const isAdvancedLayoutsOn = (0, $gmhCD.editorExperiment)('advanced_layouts', true);
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression
        return /*#__PURE__*/ (0, $f8Sb3.css)("font-size:", (0, $iHYdz.editorFontSize)(themeProps), "px;line-height:1.5rem;color:", `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`, ";.", (0, $l8Gxi.RendererCssClassName).DOCUMENT, "::after{content:'';visibility:hidden;display:block;height:0;clear:both;}", $19a4579e32968c00$var$fullPageStyles(wrapperProps, themeProps), " ", $19a4579e32968c00$var$fullWidthStyles(wrapperProps), " .", (0, $l8Gxi.RendererCssClassName).DOCUMENT, "{", (0, $9R9Rb.mediaInlineImageStyles), ";}& h1{", $19a4579e32968c00$var$headingAnchorStyle('h1'), ";}& h2{", $19a4579e32968c00$var$headingAnchorStyle('h2'), ";}& h3{", $19a4579e32968c00$var$headingAnchorStyle('h3'), ";}& h4{", $19a4579e32968c00$var$headingAnchorStyle('h4'), ";}& h5{", $19a4579e32968c00$var$headingAnchorStyle('h5'), ";}& h6{", $19a4579e32968c00$var$headingAnchorStyle('h6'), ";}& span.akActionMark{color:", `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`, ";text-decoration:none;&:hover{color:", `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`, ";text-decoration:underline;}&:active{color:", `var(--ds-link-pressed, ${$829f609a65d26a98$export$a6ee3d71bc067634})`, ";}}& span.akActionMark{cursor:pointer;}& span[data-placeholder]{color:", `var(--ds-text-subtlest, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`, ";}", $19a4579e32968c00$var$telepointerStyles(colorMode), " ", (0, $fwxzS.whitespaceSharedStyles), ";", (0, $kRRtM.blockquoteSharedStyles), ";", (0, $idytF.headingsSharedStyles)(typography), ";", (0, $bv4Ps.ruleSharedStyles)(), ";", (0, $4jyW9.paragraphSharedStyles)(typography), ";", (0, $jlYLw.listsSharedStyles), ";", (0, $5fBxY.indentationSharedStyles), ";", (0, $cx4Bg.blockMarksSharedStyles), ";", (0, $7Acon.codeMarkSharedStyles)(), ";", (0, $aSoqv.shadowSharedStyle), ";", (0, $4E5wI.dateSharedStyle), ";", (0, $jRk4M.textColorStyles), ";", (0, $1xqpZ.backgroundColorStyles)(), ";", (0, $1bQ0V.tasksAndDecisionsStyles), ";", (0, $iJOES.smartCardSharedStyles), " ", $19a4579e32968c00$var$getAnnotationStyles(wrapperProps), " ", (0, $kZxLT.getStatusSharedStyles)(), " & .UnknownBlock{font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";font-weight:var(--ds-font-weight-regular, 400);white-space:pre-wrap;word-wrap:break-word;}& span.date-node{background:", `var(--ds-background-neutral, ${$829f609a65d26a98$export$920c0d5c49070351})`, ";border-radius:var(--ds-border-radius-100, 3px);color:", `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`, ";padding:var(--ds-space-025, 2px) var(--ds-space-050, 4px);margin:0 1px;transition:background 0.3s;}& span.date-node-highlighted{background:", `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`, ";color:", `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`, ";}& .renderer-image{max-width:100%;display:block;margin:var(--ds-space-300, 24px) 0;}.", (0, $ceYEW.richMediaClassName), ".rich-media-wrapped+.", (0, $ceYEW.richMediaClassName), ":not(.rich-media-wrapped){clear:both;}& .code-block,& blockquote,& hr,&>div>div:not(.rich-media-wrapped),.", (0, $ceYEW.richMediaClassName), ".rich-media-wrapped+.rich-media-wrapped+*:not(.rich-media-wrapped),.", (0, $ceYEW.richMediaClassName), ".rich-media-wrapped+div:not(.rich-media-wrapped),.", (0, $ceYEW.richMediaClassName), ".image-align-start,.", (0, $ceYEW.richMediaClassName), ".image-center,.", (0, $ceYEW.richMediaClassName), ".image-align-end{clear:both;}& .rich-media-wrapped{&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{margin-top:var(--ds-space-100, 8px);}}", $19a4579e32968c00$var$alignedHeadingAnchorStyle(wrapperProps), (0, $ceYEW.mediaSingleSharedStyle), " & div[class^='image-wrap-']+div[class^='image-wrap-']{margin-left:0;margin-right:0;}.", (0, $l8Gxi.RendererCssClassName).DOCUMENT, ">{", $19a4579e32968c00$var$breakoutWidthStyle(), " * .", (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER, "{overflow-x:auto;}& .", (0, $l8Gxi.RendererCssClassName).EXTENSION, ":first-child{margin-top:0;}}.", (0, $l8Gxi.RendererCssClassName).DOCUMENT, "{.", (0, $l8Gxi.RendererCssClassName).EXTENSION, "{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}.", (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN, "{margin-left:50%;transform:translateX(-50%);}.", (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;}.", (0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER, " .", (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER, "{display:flex;}}", (0, $6gEe5.tableSharedStyle)(), " .", (0, $l8Gxi.RendererCssClassName).DOCUMENT, " .", (0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER, "{z-index:0;transition:all 0.1s linear;display:flex;&.", (0, $ajc8Z.shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, $ajc8Z.shadowClassNames).LEFT_SHADOW, "::before{top:", (0, $6gEe5.tableMarginTop) - 1, "px;height:calc(100% - ", (0, $6gEe5.tableMarginTop), "px);z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), ";}", $19a4579e32968c00$var$getShadowOverrides(), " ", (0, $dkc63.isStickyScrollbarEnabled)(appearance) ? $19a4579e32968c00$var$stickyScrollbarStyles : '', " & .", (0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT, ",& .", (0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT, "{height:calc(100% - ", (0, $6gEe5.tableMarginTop), "px);}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table` : 'table', "{height:1px;", $19a4579e32968c00$var$tableSortableColumnStyle(wrapperProps), ";margin-left:0;margin-right:0;}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type ` : 'table tr:first-of-type', "{height:100%;td,th{position:relative;}}table[data-number-column='true']{.", (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN, "{background-color:", `var(--ds-background-neutral, ${(0, $iHYdz.akEditorTableToolbar)})`, ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";width:", (0, $iHYdz.akEditorTableNumberColumnWidth), "px;text-align:center;color:", `var(--ds-text-subtlest, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`, ";font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";}.fixed .", (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN, "{border-right:0px none;}}}tr[data-header-row].fixed{position:fixed!important;display:flex;overflow:hidden;z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";border-bottom:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";transform:translateX(-1px);}.sticky>th{z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), ";position:sticky!important;top:0;}.sticky>td{position:sticky!important;top:0;}.sticky th,.sticky td{box-shadow:0px 1px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ",0px -0.5px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ",inset -1px 0px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`, ",0px -1px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`, ";}.fixed+tr{min-height:0px;}& .code-block{max-width:100%;display:block;position:relative;border-radius:var(--ds-border-radius-100, 3px);word-wrap:normal;}& .MediaGroup,& .code-block{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}", $19a4579e32968c00$var$useGridRenderForCodeBlock(useBlockRenderForCodeBlock), " ", (0, $2o2hu.getLightWeightCodeBlockStylesForRootRendererStyleSheet)(), " ", isAdvancedLayoutsOn ? (0, $719f3.columnLayoutResponsiveSharedStyle) : (0, $719f3.columnLayoutSharedStyle), ";", isAdvancedLayoutsOn && (0, $719f3.columnLayoutResponsiveRendererStyles), ";& [data-layout-section]{margin-top:var(--ds-space-250, 20px);&>div+div{margin-left:", isAdvancedLayoutsOn ? 0 : "var(--ds-space-400, 32px)", ";}@media screen and (max-width: ", (0, $iHYdz.gridMediumMaxWidth), "px){&>div+div{margin-left:0;}}& .MediaGroup,& .code-block{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}}& li{>.code-block{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child{margin-top:0;}>div:last-of-type.code-block{margin-bottom:", (0, $iHYdz.blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, $gE8f9.browser).safari ? (0, $cYeQP.codeBlockInListSafariFix) : '', ";}");
    };
const $19a4579e32968c00$var$useGridRenderForCodeBlock = (codeBlockRenderAsBlock)=>{
    if (codeBlockRenderAsBlock) return '';
    return `& .code-block {
       /* -ms- properties are necessary until MS supports the latest version of the grid spec */
       /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */
       display: -ms-grid;
       display: grid;
       -ms-grid-columns: auto 1fr;
       /* stylelint-enable */

       grid-template-columns: minmax(0, 1fr);

       & > span {
         /* stylelint-disable value-no-vendor-prefix */
         -ms-grid-row: 1;
         -ms-grid-column: 2;
         /* stylelint-enable */
         grid-column: 1;
       }
     }`;
};

});
parcelRegister("9R9Rb", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $c55873fb36219b19$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $c55873fb36219b19$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $c55873fb36219b19$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $c55873fb36219b19$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $c55873fb36219b19$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $c55873fb36219b19$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $c55873fb36219b19$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $c55873fb36219b19$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dR3f5 = parcelRequire("dR3f5");
const $c55873fb36219b19$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $c55873fb36219b19$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $c55873fb36219b19$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $c55873fb36219b19$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $c55873fb36219b19$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $f8Sb3.css)(">.mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $c55873fb36219b19$export$dee15762144889b7 = /*#__PURE__*/ (0, $f8Sb3.css)(".", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", (0, $dR3f5.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h1'], -3), ";}h2{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h2'], -3), ";}h3{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h3'], -2), ";}h4{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h4'], -2), ";}h5{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h5'], -2), ";}h6{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h6'], -2), ";}");
const $c55873fb36219b19$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$c55873fb36219b19$export$7ab34e219ce6eef}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $c55873fb36219b19$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    outline: 'none'
});
const $c55873fb36219b19$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(${$c55873fb36219b19$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("dR3f5", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $c9848698b53f0c39$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $c9848698b53f0c39$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $c9848698b53f0c39$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $c9848698b53f0c39$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $c9848698b53f0c39$export$c1317a9224e4d798);
const $c9848698b53f0c39$export$d722b7527b1834a8 = 250;
const $c9848698b53f0c39$export$da894f7669b4e67c = 200;
const $c9848698b53f0c39$export$286cf28b87ad4b4f = $c9848698b53f0c39$export$d722b7527b1834a8 / $c9848698b53f0c39$export$da894f7669b4e67c;
const $c9848698b53f0c39$export$64fe09732fb8680 = 0;
const $c9848698b53f0c39$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("1xqpZ", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $31831d84911fc513$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $31831d84911fc513$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $31831d84911fc513$var$_ref = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $31831d84911fc513$export$e4cca17cf56e99d = ()=>{
    return $31831d84911fc513$var$_ref;
};

});

parcelRegister("cx4Bg", function(module, exports) {

$parcel$export(module.exports, "blockMarksSharedStyles", () => $e319ea6be2c09fe0$export$33edc553df878c50);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Perfectly safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $e319ea6be2c09fe0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e319ea6be2c09fe0$export$33edc553df878c50 = {
    name: "1p01ut3",
    styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
};

});

parcelRegister("kRRtM", function(module, exports) {

$parcel$export(module.exports, "blockquoteSharedStyles", () => $93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $iHYdz.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        }
    }
});

});

parcelRegister("7Acon", function(module, exports) {

$parcel$export(module.exports, "codeMarkSharedStyles", () => $4ae245bd686f7965$export$ea799c18f699972b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $1HkQx = parcelRequire("1HkQx");
const $4ae245bd686f7965$export$ea799c18f699972b = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code': {
            '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $1HkQx.getCodeStyles)()
        }
    });
};

});
parcelRegister("1HkQx", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $a9c1aabaca189fa1$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $a9c1aabaca189fa1$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lBXbx = parcelRequire("lBXbx");

var $8CJbG = parcelRequire("8CJbG");
const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $lBXbx.SPACING}px !important`,
        paddingLeft: (0, $lBXbx.SPACING),
        marginRight: (0, $lBXbx.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: "var(--ds-font-weight-bold, 700)"
            }
        }
    });
/**
 * Styles applied at the root element level, common across code/codeblock
 */ const $a9c1aabaca189fa1$var$getBaseCodeStyles = (theme)=>({
        fontSize: (0, $lBXbx.CODE_FONT_SIZE),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: theme.fontFamily,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(${0, $lBXbx.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $lBXbx.SPACING}px 0` : (0, $lBXbx.SPACING),
                tabSize: 4
            },
            display: 'flex',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $lBXbx.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$a9c1aabaca189fa1$var$getBaseCodeStyles(theme),
            ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                marginRight: `-${0, $lBXbx.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $lBXbx.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $lBXbx.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $8CJbG.getBaseTheme)();
    const baseStyles = $a9c1aabaca189fa1$var$getBaseCodeStyles(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $8CJbG.getBaseTheme)(),
        ...(0, $8CJbG.getColorPalette)(),
        lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("lBXbx", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $6ec31795911692d1$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $6ec31795911692d1$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $6ec31795911692d1$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $6ec31795911692d1$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $6ec31795911692d1$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $6ec31795911692d1$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $6ec31795911692d1$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
const $6ec31795911692d1$export$82ea42e772d49e5b = (0, $k5uoT.gridSize)();
const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("8CJbG", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $eac5fe855702cfc1$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $eac5fe855702cfc1$export$fe2a6478976e8b17);

var $8QpSo = parcelRequire("8QpSo");


var $kTHGn = parcelRequire("kTHGn");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $eac5fe855702cfc1$var$T800 = '#067384';
const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $kTHGn.default)('font.family.code')}`,
        backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
    });
const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, $8QpSo.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
    };
});
const $eac5fe855702cfc1$var$getTheme = ()=>({
        ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
        ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
    });
var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;

});



parcelRegister("719f3", function(module, exports) {

$parcel$export(module.exports, "columnLayoutSharedStyle", () => $2e5d010f6440279f$export$6891a39948814a80);
$parcel$export(module.exports, "columnLayoutResponsiveSharedStyle", () => $2e5d010f6440279f$export$3afcac98e7ca927d);
$parcel$export(module.exports, "columnLayoutResponsiveRendererStyles", () => $2e5d010f6440279f$export$f2451ec7aca7656c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
function $2e5d010f6440279f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2e5d010f6440279f$export$6891a39948814a80 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $2e5d010f6440279f$export$3afcac98e7ca927d = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $2e5d010f6440279f$var$LAYOUT_BREAKPOINT_RENDERER = 629;
const $2e5d010f6440279f$export$f2451ec7aca7656c = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            gap: "var(--ds-space-600, 48px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`@container layout-area (max-width:${$2e5d010f6440279f$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
                flexDirection: 'column',
                gap: "var(--ds-space-400, 32px)"
            }
        }
    }
});

});

parcelRegister("4E5wI", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $174371b9df7208d5$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $174371b9df7208d5$export$86f86bd772084bf4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $174371b9df7208d5$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $174371b9df7208d5$export$86f86bd772084bf4 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$174371b9df7208d5$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("kZxLT", function(module, exports) {

$parcel$export(module.exports, "StatusSharedCssClassName", () => $1b48498df0149da7$export$b18e58a1c082b710);
$parcel$export(module.exports, "getStatusSharedStyles", () => $1b48498df0149da7$export$1e03960666c96c29);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $1b48498df0149da7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b48498df0149da7$export$b18e58a1c082b710 = {
    STATUS_CONTAINER: 'statusView-content-wrap',
    STATUS_LOZENGE: 'status-lozenge-span'
};
var $1b48498df0149da7$var$_ref = {
    name: "0",
    styles: ""
};
const $1b48498df0149da7$export$1e03960666c96c29 = ()=>// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1b48498df0149da7$export$b18e58a1c082b710.STATUS_LOZENGE} > span `]: {
            border: `1px solid ${"var(--ds-border-inverse, #FFF)"}`
        }
    }) : $1b48498df0149da7$var$_ref;

});

parcelRegister("idytF", function(module, exports) {

$parcel$export(module.exports, "headingsSharedStyles", () => $152b62c033bbf99a$export$9272613b68afed4b);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $04VvC = parcelRequire("04VvC");
const $152b62c033bbf99a$var$headingWithAlignmentStyles = ()=>// Override marginTop: 0 with default margin found in headingsSharedStyles for first heading in alignment block that is not the first child
    (0, $VSDnB.fg)('platform_editor_heading_margin_fix') ? {
        '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
            '> h1:first-child': {
                marginTop: '1.667em'
            },
            ' > h2:first-child': {
                marginTop: '1.8em'
            },
            '> h3:first-child': {
                marginTop: '2em'
            },
            '> h4:first-child': {
                marginTop: '1.357em'
            },
            '> h5:first-child': {
                marginTop: '1.667em'
            },
            '> h6:first-child': {
                marginTop: '1.455em'
            }
        },
        // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
        '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
            '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                marginTop: '0'
            }
        }
    } : {};
const $152b62c033bbf99a$export$9272613b68afed4b = (typographyTheme)=>{
    if ((0, $VSDnB.fg)('platform_editor_typography_ugc')) return /*#__PURE__*/ (0, $f8Sb3.css)({
        '& h1': {
            font: (0, $04VvC.default)('editor.font.heading.h1', typographyTheme),
            marginBottom: 0,
            marginTop: '1.45833em',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            },
            '&::before': {}
        },
        '& h2': {
            font: (0, $04VvC.default)('editor.font.heading.h2', typographyTheme),
            marginTop: '1.4em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            }
        },
        '& h3': {
            font: (0, $04VvC.default)('editor.font.heading.h3', typographyTheme),
            marginTop: '1.31249em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            }
        },
        '& h4': {
            font: (0, $04VvC.default)('editor.font.heading.h4', typographyTheme),
            marginTop: '1.25em',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            }
        },
        '& h5': {
            font: (0, $04VvC.default)('editor.font.heading.h5', typographyTheme),
            marginTop: '1.45833em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            }
        },
        '& h6': {
            font: (0, $04VvC.default)('editor.font.heading.h6', typographyTheme),
            marginTop: '1.59091em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            }
        },
        ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
    });
    else return /*#__PURE__*/ (0, $f8Sb3.css)({
        '& h1': {
            fontSize: `${24 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 28 / 24,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            marginTop: '1.667em'
        },
        '& h2': {
            fontSize: `${20 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.2,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.008em`,
            marginTop: '1.8em',
            marginBottom: 0
        },
        '& h3': {
            fontSize: `${16 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.25,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.006em`,
            marginTop: '2em',
            marginBottom: 0
        },
        '& h4': {
            fontSize: `${1}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 14,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.003em`,
            marginTop: '1.357em'
        },
        '& h5': {
            fontSize: `${12 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 12,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            marginTop: '1.667em',
            textTransform: 'none'
        },
        '& h6': {
            fontSize: `${11 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 11,
            color: "var(--ds-text-subtlest, #626F86)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            marginTop: '1.455em',
            textTransform: 'none'
        },
        ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
    });
};

});
parcelRegister("04VvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f731000984869b$export$2e2bcd8739ae039);

var $kqZva = parcelRequire("kqZva");
function $53f731000984869b$var$editorUGCToken(path, typographyTheme) {
    let token;
    switch(typographyTheme){
        case 'typography-modernized':
            token = (0, $kqZva.editorUGCTokensModernized)[path];
            break;
        case 'typography-refreshed':
            token = (0, $kqZva.editorUGCTokensRefreshed)[path];
            break;
        default:
            token = (0, $kqZva.editorUGCTokens)[path];
            break;
    }
    return token;
}
var $53f731000984869b$export$2e2bcd8739ae039 = $53f731000984869b$var$editorUGCToken;

});
parcelRegister("kqZva", function(module, exports) {

$parcel$export(module.exports, "editorUGCTokens", () => $5558cddd9c1ce385$export$4a3637dc6e2ae29e);
$parcel$export(module.exports, "editorUGCTokensModernized", () => $5558cddd9c1ce385$export$95588e746468319e);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $5558cddd9c1ce385$export$63adc0ebe3278d31);
const $5558cddd9c1ce385$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});



parcelRegister("5fBxY", function(module, exports) {

$parcel$export(module.exports, "indentationSharedStyles", () => $586c09e19d6f6d26$export$6856b92f564d3de8);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $586c09e19d6f6d26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $586c09e19d6f6d26$export$6856b92f564d3de8 = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};

});

parcelRegister("ceYEW", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $5c06afce66d8efef$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyle", () => $5c06afce66d8efef$export$d031611b96ba4cf0);
$parcel$export(module.exports, "mediaSingleSharedStyleNew", () => $5c06afce66d8efef$export$b51dea84d928a378);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $5c06afce66d8efef$export$cfe6da7d522d87bb = 'rich-media-item';
const $5c06afce66d8efef$var$wrappedMediaBreakoutPoint = 410;
const $5c06afce66d8efef$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $5c06afce66d8efef$export$b51dea84d928a378 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $iHYdz.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("4jyW9", function(module, exports) {

$parcel$export(module.exports, "paragraphSharedStyles", () => $0bce92e99beab9a0$export$2f49074d75b0e29f);
/* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $04VvC = parcelRequire("04VvC");
const $0bce92e99beab9a0$export$2f49074d75b0e29f = (typographyTheme)=>{
    return (0, $VSDnB.fg)('platform_editor_typography_ugc') ? /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            font: (0, $04VvC.default)('editor.font.body', typographyTheme),
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            marginBottom: 0
        }
    }) : /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            fontSize: '1em',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            lineHeight: (0, $iHYdz.akEditorLineHeight),
            fontWeight: "var(--ds-font-weight-regular, 400)",
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            marginBottom: 0,
            letterSpacing: '-0.005em'
        }
    });
};

});

parcelRegister("bv4Ps", function(module, exports) {

$parcel$export(module.exports, "ruleSharedStyles", () => $f15d364691bf541f$export$329434b3a2da905e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $f15d364691bf541f$export$329434b3a2da905e = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& hr': {
            border: 'none',
            backgroundColor: "var(--ds-border, #091E4224)",
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `${(0, $iHYdz.akEditorLineHeight)}em 0`,
            height: '2px',
            borderRadius: '1px'
        }
    });

});

parcelRegister("aSoqv", function(module, exports) {

$parcel$export(module.exports, "shadowSharedStyle", () => $0235d3a2f78ffda6$export$985ce3da3286f9ed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $ajc8Z = parcelRequire("ajc8Z");

var $bbl9Y = parcelRequire("bbl9Y");
const $0235d3a2f78ffda6$var$shadowWidth = 8;
/**
 * TODO: This is close to working and removes a tone of JS from OverflowShadow component
 *
 *  background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
 *         linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
 *        linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
 *         linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2)) 100% 0;
 *       background-repeat: no-repeat;
 *       background-color: white;
 *       background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
 *
 *      background-attachment: local, local, scroll, scroll;
 */ const $0235d3a2f78ffda6$export$985ce3da3286f9ed = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorShadowZIndex),
        width: `${$0235d3a2f78ffda6$var$shadowWidth}px`,
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});

});

parcelRegister("iJOES", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $bc13534612fcd0a2$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "smartCardSharedStyles", () => $bc13534612fcd0a2$export$83e107f0a431e184);

var $iHYdz = parcelRequire("iHYdz");
const $bc13534612fcd0a2$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $bc13534612fcd0a2$export$83e107f0a431e184 = `
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $iHYdz.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;

});

parcelRegister("1bQ0V", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $2398d5ed497032ce$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $2398d5ed497032ce$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $2398d5ed497032ce$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item'
};
const $2398d5ed497032ce$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{.taskItemView-content-wrap,.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, $iHYdz.akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, $iHYdz.akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");

});

parcelRegister("jRk4M", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $e9c9f96b9e0ca8df$export$a518ea5d00002b38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $e9c9f96b9e0ca8df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e9c9f96b9e0ca8df$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("fwxzS", function(module, exports) {

$parcel$export(module.exports, "whitespaceSharedStyles", () => $308dad73f97ce24c$export$c9ce3bfa46d7acba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $308dad73f97ce24c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $308dad73f97ce24c$export$c9ce3bfa46d7acba = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};

});

parcelRegister("2o2hu", function(module, exports) {

$parcel$export(module.exports, "getLightWeightCodeBlockStylesForRootRendererStyleSheet", () => $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a);
$parcel$export(module.exports, "default", () => $67d1fb0f1c6fc210$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $cYeQP = parcelRequire("cYeQP");

var $23OJc = parcelRequire("23OJc");

var $l8Gxi = parcelRequire("l8Gxi");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{cursor:text;}");
const $67d1fb0f1c6fc210$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).DOCUMENT, ">.", $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER, " .", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}");
};
const $67d1fb0f1c6fc210$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $5uXOq.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $23OJc.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $cYeQP.codeBlockSharedStyles)(),
            $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("code", null, renderBidiWarnings(text))))));
});
var $67d1fb0f1c6fc210$export$2e2bcd8739ae039 = $67d1fb0f1c6fc210$var$LightWeightCodeBlock;

});
parcelRegister("23OJc", function(module, exports) {

$parcel$export(module.exports, "useBidiWarnings", () => $807954ab13bca9b8$export$9fb9fe546a188c7b);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lrHA4 = parcelRequire("lrHA4");

var $fJyLQ = parcelRequire("fJyLQ");

var $31cgS = parcelRequire("31cgS");
const $807954ab13bca9b8$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $koVbs.default)();
    const warningLabel = intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        return (0, $31cgS.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrHA4.default), {
                bidiCharacter: bidiCharacter,
                key: index,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $59fdc1b7b0ae96c9$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", null, bidiCharacterCode)));
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});



const $75c933b3daaf1f19$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;


parcelRegister("cWojJ", function(module, exports) {

$parcel$export(module.exports, "TableHeader", () => $decaf4f5703baa00$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $decaf4f5703baa00$export$1e4baea7053fc0e3);

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");
var $9UDEr = parcelRequire("9UDEr");

var $hxoiH = parcelRequire("hxoiH");

var $9BYlQ = parcelRequire("9BYlQ");

var $hAs1r = parcelRequire("hAs1r");

var $hrpWq = parcelRequire("hrpWq");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $l8Gxi = parcelRequire("l8Gxi");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");
const $decaf4f5703baa00$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $decaf4f5703baa00$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return (0, $9BYlQ.SortOrder).ASC;
        case (0, $9BYlQ.SortOrder).ASC:
            return (0, $9BYlQ.SortOrder).DESC;
        case (0, $9BYlQ.SortOrder).DESC:
            return (0, $9BYlQ.SortOrder).NO_ORDER;
    }
    return (0, $9BYlQ.SortOrder).NO_ORDER;
};
const $decaf4f5703baa00$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $1Bd5P.tableCellMessages);
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $decaf4f5703baa00$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $decaf4f5703baa00$var$cssVariablePattern = /^var\(--.*\)$/;
const $decaf4f5703baa00$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $hAs1r.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $decaf4f5703baa00$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $87j2U.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $decaf4f5703baa00$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $hxoiH.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $9UDEr.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $decaf4f5703baa00$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$decaf4f5703baa00$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort
        }, children);
    };
};
const $decaf4f5703baa00$var$TH = $decaf4f5703baa00$var$getWithCellProps('th');
const $decaf4f5703baa00$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $koVbs.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $9BYlQ.SortOrder).NO_ORDER ? (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $decaf4f5703baa00$var$getSortOrderLabel(intl, sortOrdered)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("figure", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hrpWq.default), {
            isSortingAllowed: !!onSorting,
            sortOrdered: sortOrdered,
            onClick: sort,
            onKeyDown: onKeyPress
        }))));
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$decaf4f5703baa00$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $decaf4f5703baa00$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).SORT_COLUMN,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $knXBU.PLATFORM).WEB,
                        mode: (0, $knXBU.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            });
        }
    };
};
const $decaf4f5703baa00$export$f850895b287ef28e = $decaf4f5703baa00$export$cfca40ca5c56a38e($decaf4f5703baa00$var$TH);
const $decaf4f5703baa00$var$TD = $decaf4f5703baa00$var$getWithCellProps('td');
const $decaf4f5703baa00$export$1e4baea7053fc0e3 = $decaf4f5703baa00$var$TD;

});
parcelRegister("hrpWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d33846969f29997f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $9BYlQ = parcelRequire("9BYlQ");


var $3hakN = parcelRequire("3hakN");
function $d33846969f29997f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d33846969f29997f$var$annotationRangeFixStyle = {
    name: "oldbq4",
    styles: "user-select:none"
};
var $d33846969f29997f$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$buttonStyles = /*#__PURE__*/ (0, $f8Sb3.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$iconWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $d33846969f29997f$var$iconStyles = {
    name: "1uj2pwb",
    styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $d33846969f29997f$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $9BYlQ.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $d33846969f29997f$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $3hakN.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $d33846969f29997f$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $3hakN.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $d33846969f29997f$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $d33846969f29997f$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $d33846969f29997f$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": (0, $VSDnB.fg)('platform_renderer_table_sort_btn_aria_hidden') ? !isSortingAllowed : undefined,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d33846969f29997f$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $d33846969f29997f$var$iconStyles,
            (0, $VSDnB.fg)('platform_editor_allow_annotation_triple_click') && $d33846969f29997f$var$annotationRangeFixStyle
        ]
    }))));
};
var $d33846969f29997f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d33846969f29997f$var$SortingIcon);

});
parcelRegister("3hakN", function(module, exports) {

$parcel$export(module.exports, "sortingIconMessages", () => $c1f584a2cfc01515$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $c1f584a2cfc01515$export$f142573f51a67577);

var $7VHMR = parcelRequire("7VHMR");
const $c1f584a2cfc01515$export$458c50917513cd1a = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $c1f584a2cfc01515$export$f142573f51a67577 = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("4BsEy", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $3b927b61a8274f19$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $3b927b61a8274f19$export$65e2d5a272a382b0);

var $5uXOq = parcelRequire("5uXOq");
const $3b927b61a8274f19$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new Map());
const $3b927b61a8274f19$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b927b61a8274f19$export$841858b892ce1f4c.Provider, {
        value: new Map()
    }, children);
};
const $3b927b61a8274f19$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b927b61a8274f19$export$841858b892ce1f4c.Consumer, null, (storage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    smartCardStorage: storage
                }));
        }
    };
};

});

parcelRegister("2aXGN", function(module, exports) {

$parcel$export(module.exports, "tableStickyPadding", () => $9b3e020198447653$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $9b3e020198447653$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $9b3e020198447653$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");


var $a4mor = parcelRequire("a4mor");

var $6cOrl = parcelRequire("6cOrl");
function $9b3e020198447653$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9b3e020198447653$export$3de6413b528017ca = 8;
const $9b3e020198447653$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// TODO: Quality ticket: https://product-fabric.atlassian.net/browse/DSP-4123
const $9b3e020198447653$var$fixedTableDivStaticStyles = (top, width, allowTableResizing)=>{
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $iHYdz.akEditorStickyHeaderZIndex);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)(typeof top === 'number' && `top: ${top}px;`, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: stickyHeaderZIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            marginTop: 0,
            marginBottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            tr: {
                background: "var(--ds-surface, white)"
            }
        },
        borderTop: `${$9b3e020198447653$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
        background: "var(--ds-surface-overlay, white)",
        boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "div[data-expanded='false'] &": {
            display: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
            top: '0px',
            height: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&.fixed-table-div-custom-table-resizing[mode='stick']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: stickyHeaderZIndex
        }
    });
};
const $9b3e020198447653$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    const fixedTableCss = [
        $9b3e020198447653$var$fixedTableDivStaticStyles(top, wrapperWidth, allowTableResizing),
        $9b3e020198447653$var$modeSpecficStyles?.[mode]
    ];
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: fixedTableCss
    }, props.children);
};
const $9b3e020198447653$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9b3e020198447653$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a4mor.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $6cOrl.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 */ function $9b3e020198447653$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $9b3e020198447653$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    static fromElement(el, defaultScrollRootId) {
        return new $9b3e020198447653$export$e97bc6692974bd0b($9b3e020198447653$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    get isElement() {
        return this.ref instanceof HTMLElement;
    }
    get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    removeEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("a4mor", function(module, exports) {

$parcel$export(module.exports, "Table", () => $40c6d2c88bc98a0d$export$54ec01a60f47d33d);

var $5uXOq = parcelRequire("5uXOq");

var $3nHPA = parcelRequire("3nHPA");

var $fKLIs = parcelRequire("fKLIs");

var $iHYdz = parcelRequire("iHYdz");
const $40c6d2c88bc98a0d$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing })=>{
    let tableWidth = tableNode ? (0, $fKLIs.getTableContainerWidth)(tableNode) : (0, $iHYdz.akEditorDefaultLayoutWidth);
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) tableWidth = renderWidth;
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("table", {
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nHPA.Colgroup), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        isInsideOfTable: isInsideOfTable,
        isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
        allowTableResizing: allowTableResizing
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tbody", null, children));
});

});
parcelRegister("3nHPA", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $ae0cfecd7422435f$export$89efc2d0ceeaa030);

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $fKLIs = parcelRequire("fKLIs");

var $VSDnB = parcelRequire("VSDnB");

var $9JDnL = parcelRequire("9JDnL");

var $dyURG = parcelRequire("dyURG");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT = 0.3;
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $ae0cfecd7422435f$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $ae0cfecd7422435f$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $6gEe5.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $6gEe5.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : (0, $6gEe5.tableCellMinWidth));
};
const $ae0cfecd7422435f$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $iHYdz.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $ae0cfecd7422435f$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $ae0cfecd7422435f$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    if (!columnWidths) return [];
    const tableColumnResized = $ae0cfecd7422435f$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false && (0, $VSDnB.fg)('platform_editor_nested_table_in_nested_parent_fix');
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested ? renderWidth : (0, $fKLIs.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !((0, $VSDnB.fg)('platform_editor_nested_tables_renderer_colgroup') && isInsideOfTable) && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $ae0cfecd7422435f$var$colWidthSum(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const scalePercentage = +((tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / tableContainerWidth);
        const targetMaxWidth = tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $6gEe5.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $6gEe5.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $iHYdz.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $iHYdz.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $ae0cfecd7422435f$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $iHYdz.akEditorTableLegacyCellMinWidth) ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $ae0cfecd7422435f$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $ae0cfecd7422435f$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $ae0cfecd7422435f$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $9JDnL.useFeatureFlags)();
    if (!columnWidths) return null;
    const colStyles = $ae0cfecd7422435f$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("colgroup", null, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("col", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $iHYdz.akEditorTableNumberColumnWidth)
        },
        "data-test-id": 'num'
    }), colStyles.map((style, idx)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("col", {
            key: idx,
            style: style
        })));
};

});
parcelRegister("9JDnL", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlags", () => $7cc75954bd6ebac0$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dyURG = parcelRequire("dyURG");
const $7cc75954bd6ebac0$export$90335b3ff08f335 = ()=>(0, $dyURG.useRendererContext)()?.featureFlags;

});
parcelRegister("dyURG", function(module, exports) {

$parcel$export(module.exports, "useRendererContext", () => $6d8aa882825f4203$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $6d8aa882825f4203$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $5uXOq = parcelRequire("5uXOq");
const $6d8aa882825f4203$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $6d8aa882825f4203$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($6d8aa882825f4203$var$RendererContext);
const $6d8aa882825f4203$export$ca5df47902194781 = $6d8aa882825f4203$var$RendererContext.Provider;

});




parcelRegister("6cOrl", function(module, exports) {

$parcel$export(module.exports, "recursivelyInjectProps", () => $7a2ba32d880ccda8$export$40e12ce8e0a76b0c);

var $5uXOq = parcelRequire("5uXOq");
function $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            children: $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("kjIja", function(module, exports) {

$parcel$export(module.exports, "isFullWidthAppearance", () => $b5d34963b73650ed$export$c0112b8340d4924b);
$parcel$export(module.exports, "isFullPageAppearance", () => $b5d34963b73650ed$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $b5d34963b73650ed$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $b5d34963b73650ed$export$33331a99fac775a1);
const $b5d34963b73650ed$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $b5d34963b73650ed$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $b5d34963b73650ed$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $b5d34963b73650ed$export$33331a99fac775a1 = (appearance)=>$b5d34963b73650ed$export$a64737a81cde10b4(appearance) || $b5d34963b73650ed$export$c0112b8340d4924b(appearance);

});

parcelRegister("eIscD", function(module, exports) {

$parcel$export(module.exports, "TableStickyScrollbar", () => $ea0307076d72d83e$export$8c072780619cfc83);

var $6gEe5 = parcelRequire("6gEe5");
class $ea0307076d72d83e$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        this.stickyScrollbarContainerElement = this.wrapper.parentElement?.querySelector(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.bottom = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});


parcelRegister("i4Lgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d6cf54c99dd1cb3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5vnE9 = parcelRequire("5vnE9");

var $9BYlQ = parcelRequire("9BYlQ");

var $l8Gxi = parcelRequire("l8Gxi");
class $6d6cf54c99dd1cb3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", {
            ref: innerRef
        }, this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("td", {
            className: (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN
        }, this.props.index), (0, $5vnE9.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
    }
    constructor(...args){
        super(...args), this.state = {
            colGroupWidths: []
        }, this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            if (allowColumnSorting) {
                const isHeaderRow = !rowIndex;
                childrenArray = childrenArray.map((child, index)=>{
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                        const { tableOrderStatus: tableOrderStatus } = this.props;
                        let sortOrdered = (0, $9BYlQ.SortOrder).NO_ORDER;
                        if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $9BYlQ.SortOrder).NO_ORDER;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                            columnIndex: index,
                            onSorting: this.props.onSorting,
                            sortOrdered: sortOrdered,
                            isHeaderRow: isHeaderRow
                        });
                    }
                });
            }
            return childrenArray;
        }, this.addColGroupWidth = (childrenArray)=>{
            if (this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("gfMkN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5be854e6b8cbd84$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $d5be854e6b8cbd84$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: "UnknownBlock"
    }, props.children);
}

});

parcelRegister("9kpKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b743bc5ccb58a13$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $eJS47 = parcelRequire("eJS47");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $5b743bc5ccb58a13$var$inlineNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $5b743bc5ccb58a13$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $5b743bc5ccb58a13$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJS47))), {
        label: "?",
        size: "small"
    }))));
};
var $5b743bc5ccb58a13$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5b743bc5ccb58a13$var$UnsupportedInlineNode);

});

parcelRegister("b7uH5", function(module, exports) {

let $8188285c16b52cce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8188285c16b52cce$var$load("jv5OL").then(()=>parcelRequire('fyj1u'));

});

parcelRegister("4nigH", function(module, exports) {

let $32f77b20371be65f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32f77b20371be65f$var$load("27B3z").then(()=>parcelRequire('bO8HO'));

});

parcelRegister("jjsQN", function(module, exports) {

let $e0f62bc8730c7d05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0f62bc8730c7d05$var$load("wQW1L").then(()=>parcelRequire('iLXzZ'));

});

parcelRegister("0K8mZ", function(module, exports) {

let $0023c973e159b439$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0023c973e159b439$var$load("hY7zf").then(()=>parcelRequire('5Y7e4'));

});

parcelRegister("k7Zs2", function(module, exports) {

let $ea742102175705e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea742102175705e3$var$load("7lItE").then(()=>parcelRequire('h2Mqp'));

});

parcelRegister("aNesC", function(module, exports) {

let $7db9b28bd0545c2e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7db9b28bd0545c2e$var$load("6OdqE").then(()=>parcelRequire('sFJC1'));

});

parcelRegister("57OMq", function(module, exports) {

let $3bb4ff084aedf044$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3bb4ff084aedf044$var$load("8PYkX").then(()=>parcelRequire('4hMem'));

});

parcelRegister("bfPot", function(module, exports) {

let $8318f624fdf8cb8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8318f624fdf8cb8b$var$load("aetML").then(()=>parcelRequire('c3ssB'));

});

parcelRegister("7mtWi", function(module, exports) {

let $55c1cfcbb6e43f4a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $55c1cfcbb6e43f4a$var$load("cM9em"),
    $55c1cfcbb6e43f4a$var$load("fr9NE"),
    $55c1cfcbb6e43f4a$var$load("h2MrD"),
    $55c1cfcbb6e43f4a$var$load("bYT2S"),
    $55c1cfcbb6e43f4a$var$load("9VCdz")
]).then(()=>parcelRequire('hibqv'));

});

parcelRegister("cyYfQ", function(module, exports) {

let $92576655004e1c2c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $92576655004e1c2c$var$load("cM9em"),
    $92576655004e1c2c$var$load("fr9NE"),
    $92576655004e1c2c$var$load("h2MrD"),
    $92576655004e1c2c$var$load("bYT2S"),
    $92576655004e1c2c$var$load("h0TDs")
]).then(()=>parcelRequire('1lkep'));

});

parcelRegister("bat28", function(module, exports) {

let $8217264db8cfcb2d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8217264db8cfcb2d$var$load("dsiAd"),
    $8217264db8cfcb2d$var$load("cM9em"),
    $8217264db8cfcb2d$var$load("fr9NE"),
    $8217264db8cfcb2d$var$load("h2MrD"),
    $8217264db8cfcb2d$var$load("bYT2S"),
    $8217264db8cfcb2d$var$load("hPzOn"),
    $8217264db8cfcb2d$var$load("hLGxH")
]).then(()=>parcelRequire('fz1ZD'));

});

parcelRegister("iyg8s", function(module, exports) {

let $d817eb1ae1141039$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d817eb1ae1141039$var$load("dsiAd"),
    $d817eb1ae1141039$var$load("cM9em"),
    $d817eb1ae1141039$var$load("fr9NE"),
    $d817eb1ae1141039$var$load("h2MrD"),
    $d817eb1ae1141039$var$load("bYT2S"),
    $d817eb1ae1141039$var$load("hPzOn"),
    $d817eb1ae1141039$var$load("13w3s")
]).then(()=>parcelRequire('lD0Zb'));

});

parcelRegister("gQJy5", function(module, exports) {

let $032a668b1beb7866$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $032a668b1beb7866$var$load("dsiAd"),
    $032a668b1beb7866$var$load("cM9em"),
    $032a668b1beb7866$var$load("fr9NE"),
    $032a668b1beb7866$var$load("h2MrD"),
    $032a668b1beb7866$var$load("bYT2S"),
    $032a668b1beb7866$var$load("hPzOn"),
    $032a668b1beb7866$var$load("YsZeU")
]).then(()=>parcelRequire('gQwn3'));

});

parcelRegister("7UIjK", function(module, exports) {

let $5c3023ed13e23afa$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5c3023ed13e23afa$var$load("cM9em"),
    $5c3023ed13e23afa$var$load("fr9NE"),
    $5c3023ed13e23afa$var$load("2Q2XH")
]).then(()=>parcelRequire('aPwmB'));

});

parcelRegister("lmZTQ", function(module, exports) {

let $f8ebab104a7491ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f8ebab104a7491ec$var$load("h2MrD"),
    $f8ebab104a7491ec$var$load("bYT2S"),
    $f8ebab104a7491ec$var$load("4B3Pp")
]).then(()=>parcelRequire('ebIkR'));

});

parcelRegister("4kfHt", function(module, exports) {

let $32653568d7020556$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $32653568d7020556$var$load("cM9em"),
    $32653568d7020556$var$load("fr9NE"),
    $32653568d7020556$var$load("c5BYw")
]).then(()=>parcelRequire('74PfD'));

});

parcelRegister("hPQIC", function(module, exports) {

let $cfc017ee8c8604ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cfc017ee8c8604ba$var$load("8QV79").then(()=>parcelRequire('9jt2S'));

});

parcelRegister("3ceee", function(module, exports) {

let $253d87993a37a182$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $253d87993a37a182$var$load("h2MrD"),
    $253d87993a37a182$var$load("bYT2S"),
    $253d87993a37a182$var$load("cM9em"),
    $253d87993a37a182$var$load("fr9NE"),
    $253d87993a37a182$var$load("iJ6aZ")
]).then(()=>parcelRequire('V5Yjo'));

});

parcelRegister("bbv0R", function(module, exports) {

let $8248c74ba6db9df5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8248c74ba6db9df5$var$load("h2MrD"),
    $8248c74ba6db9df5$var$load("bYT2S"),
    $8248c74ba6db9df5$var$load("jcqJ9")
]).then(()=>parcelRequire('hA9EZ'));

});


parcelRegister("5BLIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1269296b575a9fc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4dDLS = parcelRequire("4dDLS");
const $e1269296b575a9fc$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dDLS.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks
    }, children);
};
var $e1269296b575a9fc$export$2e2bcd8739ae039 = $e1269296b575a9fc$var$TextWrapper;

});
parcelRegister("4dDLS", function(module, exports) {

$parcel$export(module.exports, "TextWithAnnotationDraft", () => $3c5c154ced085d7f$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dLpur = parcelRequire("dLpur");

var $iYAgE = parcelRequire("iYAgE");

var $i9Z2i = parcelRequire("i9Z2i");

var $b60W1 = parcelRequire("b60W1");

var $fVTp8 = parcelRequire("fVTp8");

var $5Lu5s = parcelRequire("5Lu5s");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $3c5c154ced085d7f$var$markStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $5Lu5s.AnnotationSharedCSSByState)().common, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $5Lu5s.AnnotationSharedCSSByState)().focus);
const $3c5c154ced085d7f$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $fVTp8.dataAttributes)(draftPosition),
        css: $3c5c154ced085d7f$var$markStyles
    }, children));
};
const $3c5c154ced085d7f$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $3c5c154ced085d7f$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $3c5c154ced085d7f$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $h5tvG.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $3c5c154ced085d7f$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const nextDraftPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $iYAgE.AnnotationsDraftContext));
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $b60W1.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $i9Z2i.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $dLpur.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $i9Z2i.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $i9Z2i.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $3c5c154ced085d7f$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, components);
};

});
parcelRegister("dLpur", function(module, exports) {

$parcel$export(module.exports, "InsertDraftPosition", () => $0808a380eaa6574c$export$c1bd4813440b4505);
var $0808a380eaa6574c$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("i9Z2i", function(module, exports) {

$parcel$export(module.exports, "findTextString", () => $b2e5f988c70f5313$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $b2e5f988c70f5313$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $b2e5f988c70f5313$export$1059bfc467f4f55d);

var $5uXOq = parcelRequire("5uXOq");
const $b2e5f988c70f5313$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($b2e5f988c70f5313$var$isReactElement(childNode) && childNode.props.children) result = $b2e5f988c70f5313$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $b2e5f988c70f5313$var$isReactElement(child) {
    return !!child.type;
}
const $b2e5f988c70f5313$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $b2e5f988c70f5313$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("b60W1", function(module, exports) {

$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $cc6d6765c9b34830$export$b1baddbd5f289877);

var $dLpur = parcelRequire("dLpur");
const $cc6d6765c9b34830$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $dLpur.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $dLpur.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $dLpur.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $dLpur.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("5Lu5s", function(module, exports) {

$parcel$export(module.exports, "AnnotationSharedClassNames", () => $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $973d0f0bfe5e36b9$export$ac15f3ad21fefeac);
$parcel$export(module.exports, "AnnotationSharedCSSByState", () => $973d0f0bfe5e36b9$export$261ebe180da42726);
$parcel$export(module.exports, "annotationSharedStyles", () => $973d0f0bfe5e36b9$export$5f72fe1d39f8129b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $973d0f0bfe5e36b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $973d0f0bfe5e36b9$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c = {
    focus: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-focus`,
    blur: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-blur`,
    draft: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-draft`,
    hover: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-hover`
};
const $973d0f0bfe5e36b9$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $973d0f0bfe5e36b9$export$ac15f3ad21fefeac = {
    focus: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-focus`,
    blur: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-blur`,
    draft: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-draft`
};
var $973d0f0bfe5e36b9$var$_ref = {
    name: "j33ko3",
    styles: "background:var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
};
var $973d0f0bfe5e36b9$var$_ref2 = {
    name: "kh65d",
    styles: "background:var(--ds-background-accent-yellow-subtlest, #FFF7D6);border-bottom-color:var(--ds-border-accent-yellow, #B38600)"
};
var $973d0f0bfe5e36b9$var$_ref3 = {
    name: "buc4yh",
    styles: "background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
};
const $973d0f0bfe5e36b9$export$261ebe180da42726 = ()=>{
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) // NOTE: These styles are shared between renderer and editor. Sometimes they
    // need different selectors and other times they apply the same attributes
    // in a different way. For example in renderer the focus styles are an
    // override, not a separate class. Be sure to check both usages of this
    // before modifying.
    return {
        common: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            '&:has(.card), &:has([data-inline-card])': (0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles') ? {
                padding: '5px 0 3px 0'
            } : {
                paddingTop: '4px',
                border: 'none',
                boxShadow: `0 2px 0 0 ${"var(--ds-border-accent-yellow, #B38600)"}`
            },
            '&:has(.date-lozenger-container)': {
                paddingTop: '2px'
            }
        },
        focus: $973d0f0bfe5e36b9$var$_ref3,
        blur: $973d0f0bfe5e36b9$var$_ref2,
        hover: $973d0f0bfe5e36b9$var$_ref
    };
    else return {
        focus: /*#__PURE__*/ (0, $f8Sb3.css)({
            // Background is not coming through in confluence, suspecting to be caused by some specific combination of
            // emotion and token look up
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: https://product-fabric.atlassian.net/browse/DSP-4147
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }),
        blur: /*#__PURE__*/ (0, $f8Sb3.css)({
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            cursor: 'pointer'
        })
    };
};
const $973d0f0bfe5e36b9$export$5f72fe1d39f8129b = ()=>(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $f8Sb3.css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.hover, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";", $973d0f0bfe5e36b9$export$261ebe180da42726().hover, ";}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $f8Sb3.css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}}");

});

parcelRegister("h5tvG", function(module, exports) {

$parcel$export(module.exports, "segmentText", () => $63dc04a72edc8a4d$export$93301b6f1ff0b0c3);
function $63dc04a72edc8a4d$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("3VpWO", function(module, exports) {

$parcel$export(module.exports, "renderTextSegments", () => $eefbbe172cfc7a10$export$8a20fd0614851c5f);

var $5uXOq = parcelRequire("5uXOq");
function $eefbbe172cfc7a10$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            match: segment.text,
            groups: segment.groups,
            marks: marks,
            key: `${segment.text}_${startPos}_${idx}`,
            startPos: startPos + idx
        }, segment.text));
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        key: `text-wrapper_${startPos}`
    }, segments.map(renderSegment));
}

});



parcelRegister("cKKwC", function(module, exports) {

$parcel$export(module.exports, "isAnnotationMark", () => $d006a5118aec07b0$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $d006a5118aec07b0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $5uoEK = parcelRequire("5uoEK");
const $d006a5118aec07b0$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $d006a5118aec07b0$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $88i6h.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        id: id
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uoEK.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel
    }, children);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        id: id,
        ...data
    }, children));
};
var $d006a5118aec07b0$export$2e2bcd8739ae039 = $d006a5118aec07b0$var$AnnotationComponent;

});
parcelRegister("5uoEK", function(module, exports) {

$parcel$export(module.exports, "MarkElement", () => $97291021c9f24158$export$f3069f755c1eba0b);

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $8u8ms = parcelRequire("8u8ms");

var $6Oe8V = parcelRequire("6Oe8V");

var $3N1TD = parcelRequire("3N1TD");

var $1oOiu = parcelRequire("1oOiu");

var $iYAgE = parcelRequire("iYAgE");

var $dEtqo = parcelRequire("dEtqo");
const $97291021c9f24158$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $3N1TD.useInlineCommentSubscriberContext)();
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $1oOiu.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $5uXOq.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const onClick = (0, $5uXOq.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        updateSubscriber.emit((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel
    ]);
    const activeParentIds = (0, $6Oe8V.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $88i6h.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8u8ms.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel
    }, children);
};

});
parcelRegister("8u8ms", function(module, exports) {

$parcel$export(module.exports, "MarkComponent", () => $c95b45af50ffb058$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5Lu5s = parcelRequire("5Lu5s");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState` is not object-safe
const $c95b45af50ffb058$var$markStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;&[data-mark-annotation-state='", (0, $88i6h.AnnotationMarkStates).ACTIVE, "']{", (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? (0, $5Lu5s.AnnotationSharedCSSByState)().common : '', " ", (0, $5Lu5s.AnnotationSharedCSSByState)().blur, " &:focus,&[data-has-focus='true']{", (0, $5Lu5s.AnnotationSharedCSSByState)().focus, ";}&[data-is-hovered='true']:not([data-has-focus='true']){", (0, $VSDnB.fg)('confluence-frontend-comments-panel') ? (0, $5Lu5s.AnnotationSharedCSSByState)().hover : '', ";}}");
const $c95b45af50ffb058$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $c95b45af50ffb058$var$accessibilityStyles = (startMarker, endMarker)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        '&::before, &::after': {
            clipPath: 'inset(100%)',
            clip: 'rect(1px, 1px, 1px, 1px)',
            height: '1px',
            overflow: 'hidden',
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: '1px'
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            content: `' [${startMarker}] '`
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            content: `' [${endMarker}] '`
        }
    });
const $c95b45af50ffb058$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const isInlineCommentsKbAccessible = (0, $VSDnB.fg)('inline_comments_keyboard_accessible_renderer');
    const intl = (0, $koVbs.default)();
    const annotationIds = (0, $5uXOq.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const onMarkClick = (0, $5uXOq.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $88i6h.AnnotationMarkStates).ACTIVE) return;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = isInlineCommentsKbAccessible ? $c95b45af50ffb058$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    } : {};
    const accessibility = state !== (0, $88i6h.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    const getAccessibilityStyles = ()=>{
        if ($c95b45af50ffb058$var$isMobile()) return {};
        if (isInlineCommentsKbAccessible && state !== (0, $88i6h.AnnotationMarkStates).RESOLVED) {
            const startMarker = intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerStart);
            const endMarker = intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerEnd);
            return $c95b45af50ffb058$var$accessibilityStyles(startMarker, endMarker);
        } else return {};
    };
    return (0, $f8Sb3.jsx)(useBlockLevel ? 'div' : 'mark', {
        id: id,
        [(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $c95b45af50ffb058$var$markStyles,
                getAccessibilityStyles()
            ]
        }
    }, children);
};

});

parcelRegister("6Oe8V", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentsFilter", () => $588f60613625d184$export$8e7d47f9e38ad4f1);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $588f60613625d184$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    return (0, $5uXOq.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("3N1TD", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $861d152b5ce122b2$export$b46737175cffd396);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $861d152b5ce122b2$export$b46737175cffd396 = ()=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("GDkvY", function(module, exports) {

$parcel$export(module.exports, "toReact", () => $d1627eb50b8d1823$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $bVGKe = parcelRequire("bVGKe");

var $lqKi3 = parcelRequire("lqKi3");

var $kgK5w = parcelRequire("kgK5w");

var $f14yv = parcelRequire("f14yv");

var $eVxaj = parcelRequire("eVxaj");

var $gUlHA = parcelRequire("gUlHA");

var $c15YI = parcelRequire("c15YI");

var $koUAb = parcelRequire("koUAb");

var $eESZY = parcelRequire("eESZY");

var $95Yll = parcelRequire("95Yll");

var $lbdLJ = parcelRequire("lbdLJ");

var $9xZ5X = parcelRequire("9xZ5X");

var $g5EjF = parcelRequire("g5EjF");

var $acz8Q = parcelRequire("acz8Q");

var $8DQfy = parcelRequire("8DQfy");

var $g9yqu = parcelRequire("g9yqu");

var $cKKwC = parcelRequire("cKKwC");

var $itF0z = parcelRequire("itF0z");

var $6EeUE = parcelRequire("6EeUE");
const $d1627eb50b8d1823$export$c00d967a0f56fdb7 = {
    code: (0, $bVGKe.default),
    em: (0, $lqKi3.default),
    link: (0, $kgK5w.default),
    strike: (0, $f14yv.default),
    strong: (0, $eVxaj.default),
    subsup: (0, $gUlHA.default),
    textColor: (0, $c15YI.default),
    backgroundColor: (0, $koUAb.default),
    underline: (0, $eESZY.default),
    annotation: (0, $cKKwC.default),
    border: (0, $itF0z.default),
    // Stage0
    confluenceInlineComment: (0, $6EeUE.default),
    breakout: (0, $95Yll.default),
    alignment: (0, $lbdLJ.default),
    indentation: (0, $9xZ5X.default),
    unsupportedMark: (0, $g5EjF.default),
    unsupportedNodeAttribute: (0, $acz8Q.default),
    dataConsumer: (0, $8DQfy.default),
    fragment: (0, $g9yqu.default)
};
const $d1627eb50b8d1823$export$d4334b129116aad7 = (mark)=>{
    return $d1627eb50b8d1823$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("bVGKe", function(module, exports) {

$parcel$export(module.exports, "isCodeMark", () => $caa083dc61fd842d$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $caa083dc61fd842d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $O2UjQ = parcelRequire("O2UjQ");

var $fJyLQ = parcelRequire("fJyLQ");
const $caa083dc61fd842d$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $caa083dc61fd842d$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $O2UjQ.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes
    }, props.children);
}
var $caa083dc61fd842d$export$2e2bcd8739ae039 = (0, $8RXs9.default)($caa083dc61fd842d$export$7cea6ffa7022e85f);

});
parcelRegister("O2UjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c9c981a54265bdd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");

var $lBXbx = parcelRequire("lBXbx");

var $1HkQx = parcelRequire("1HkQx");
const $4c9c981a54265bdd$var$styles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline',
    padding: '2px 0.5ch',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $lBXbx.VAR_CODE_BG_COLOR)}, ${"var(--ds-background-neutral, #091E420F)"})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderStyle: 'none',
    boxDecorationBreak: 'clone',
    color: "var(--ds-text, #172B4D)",
    font: "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'inherit',
    overflow: 'auto',
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap'
});
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $4c9c981a54265bdd$var$Code = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $f8Sb3.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    }, children) : children;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        css: $4c9c981a54265bdd$var$styles,
        ...otherProps
    }, decoratedChildren));
}));
function $4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $31cgS.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        if ($4c9c981a54265bdd$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $f8Sb3.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, replacedChildren);
}
function $4c9c981a54265bdd$var$isReactElement(child) {
    return !!child.type;
}
$4c9c981a54265bdd$var$Code.displayName = 'Code';
var $4c9c981a54265bdd$export$2e2bcd8739ae039 = $4c9c981a54265bdd$var$Code;

});


parcelRegister("lqKi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd21faba719ebab1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $fd21faba719ebab1$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("em", props.dataAttributes, props.children);
}

});

parcelRegister("kgK5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9900830cb94354be$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $K5Jsy = parcelRequire("K5Jsy");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $VSDnB = parcelRequire("VSDnB");

var $iHvAB = parcelRequire("iHvAB");

var $daJ0i = parcelRequire("daJ0i");
const $9900830cb94354be$var$anchorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    }
});
function $9900830cb94354be$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $K5Jsy.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $daJ0i.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iHvAB.default), {
        css: $9900830cb94354be$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VISITED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).LINK,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        ...(0, $VSDnB.fg)('platform_editor_hyperlink_underline') && {
            isLinkComponent: true
        }
    }, props.children));
}

});
parcelRegister("K5Jsy", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $75b48ee07210971a$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $75b48ee07210971a$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $75b48ee07210971a$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $75b48ee07210971a$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75b48ee07210971a$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $75b48ee07210971a$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $kOFhM.defaultSchema));
        this.encode = $75b48ee07210971a$var$createEncoder(transformer, new (0, $hYNZx.JSONTransformer)());
    }
}
const $75b48ee07210971a$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $75b48ee07210971a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $75b48ee07210971a$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $75b48ee07210971a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("iHvAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e7a399613e0863$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $994MI = parcelRequire("994MI");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $g2eZ6 = parcelRequire("g2eZ6");

var $66xOO = parcelRequire("66xOO");

var $hTTxJ = parcelRequire("hTTxJ");

var $cI2hq = parcelRequire("cI2hq");
const $65e7a399613e0863$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $65e7a399613e0863$var$Anchor = (0, $g2eZ6.withLinkClickedEvent)('a');
const $65e7a399613e0863$export$8c0773eab230d49e = (0, $g2eZ6.withLinkClickedEvent)((0, $e4yMr.default));
const $65e7a399613e0863$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, ...props })=>{
    (0, $gKZoD.di)($65e7a399613e0863$export$8c0773eab230d49e, (0, $cI2hq.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $cI2hq.useLinkWarningModal)();
    const Link = isLinkComponent && (0, $VSDnB.fg)('platform_editor_hyperlink_underline') ? $65e7a399613e0863$export$8c0773eab230d49e : $65e7a399613e0863$var$Anchor;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $66xOO.LinkAnalyticsContext), {
                url: href,
                display: "url",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
                    "data-testid": testId,
                    href: href || '',
                    onClick: (e)=>{
                        if (!checkSafety) {
                            onClick && onClick(e);
                            return;
                        }
                        // Only call the onClick if the link is safe
                        if (isLinkSafe(e, href)) onClick && onClick(e);
                        else showSafetyWarningModal(e, href);
                    },
                    ...props,
                    children: children
                })
            }),
            checkSafety && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTTxJ.default), {
                ...linkWarningModalProps
            })
        ]
    });
};
var $65e7a399613e0863$export$2e2bcd8739ae039 = (0, $994MI.default)($65e7a399613e0863$var$PACKAGE_DATA)($65e7a399613e0863$var$LinkUrl);

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});

parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});

parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});


parcelRegister("66xOO", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $a51765c35bf0b052$export$9458cdec663b9ff1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");
const $a51765c35bf0b052$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        },
        children: children
    });
};

});

parcelRegister("hTTxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ef61591d3052acd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $fVnbM = parcelRequire("fVnbM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");

var $a58QI = parcelRequire("a58QI");
const $6ef61591d3052acd$var$breakWordsCss = null;
const $6ef61591d3052acd$var$WarningModalNew = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
            onClose: onClose,
            testId: "link-with-safety-warning",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                        appearance: "warning",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).check_this_link
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_o5726vc6 _1nmz9jpi"
                        ]),
                        children: url && unsafeLinkText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).link_safety_warning_message,
                            values: {
                                unsafeLinkText: unsafeLinkText,
                                a: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).go_back
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "warning",
                            onClick: onContinue,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).continue
                            })
                        })
                    ]
                })
            ]
        })
    });
    return intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: content
    });
};
const $6ef61591d3052acd$var$Component = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($6ef61591d3052acd$var$WarningModalNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a58QI.default), {
        ...props
    });
};
var $6ef61591d3052acd$export$2e2bcd8739ae039 = (0, $8RXs9.default)($6ef61591d3052acd$var$Component, {
    enforceContext: false
});

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});

parcelRegister("a58QI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5e6a6bcd9645309$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");
var $i5FdW = parcelRequire("i5FdW");

var $fVnbM = parcelRequire("fVnbM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $7zaVw = parcelRequire("7zaVw");

var $5joKY = parcelRequire("5joKY");
const $e5e6a6bcd9645309$var$WarningModalOld = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1R1Ge.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jgVsb.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gofOI.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $7zaVw.messages).check_this_link))), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7QSqG.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $5joKY.breakWordsCss)
    }, url && unsafeLinkText && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("a", {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $juxqI.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $7zaVw.messages).go_back)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fVnbM.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $7zaVw.messages).continue)))));
    return intl ? content : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $i5FdW.default), {
        locale: "en"
    }, content);
};
var $e5e6a6bcd9645309$export$2e2bcd8739ae039 = $e5e6a6bcd9645309$var$WarningModalOld;

});
parcelRegister("5joKY", function(module, exports) {

$parcel$export(module.exports, "breakWordsCss", () => $b66aa972276b3574$export$e4dda5b86d39ace5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $b66aa972276b3574$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b66aa972276b3574$export$e4dda5b86d39ace5 = {
    name: "1ujvzzx",
    styles: "white-space:pre-line;word-break:break-all"
};

});



parcelRegister("cI2hq", function(module, exports) {

$parcel$export(module.exports, "useLinkWarningModal", () => $afd5dc953340b04b$export$32b76c003683c2ec);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $57Lhk = parcelRequire("57Lhk");

var $fzJZi = parcelRequire("fzJZi");
const $afd5dc953340b04b$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $afd5dc953340b04b$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $5uXOq.useState)(null);
    const [url, setUrl] = (0, $5uXOq.useState)(null);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $57Lhk.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $afd5dc953340b04b$var$toUrl(href, window.location.origin);
        const linkTextUrl = $afd5dc953340b04b$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("57Lhk", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $8f5c48f3a9939b0b$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $8f5c48f3a9939b0b$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $e2gHg = parcelRequire("e2gHg");
const $8f5c48f3a9939b0b$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($e2gHg)))();
$8f5c48f3a9939b0b$var$linkify.add('sourcetree:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('jamfselfservice:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('notes:', 'http:');
const $8f5c48f3a9939b0b$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8f5c48f3a9939b0b$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8f5c48f3a9939b0b$var$tlds.push($8f5c48f3a9939b0b$var$tlds2Char);
$8f5c48f3a9939b0b$var$linkify.tlds($8f5c48f3a9939b0b$var$tlds, false);
const $8f5c48f3a9939b0b$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8f5c48f3a9939b0b$var$normaliseLinkHref = (url)=>{
    const match = $8f5c48f3a9939b0b$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8f5c48f3a9939b0b$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8f5c48f3a9939b0b$var$linkifyMatch(str);
    if (!match.length) match = $8f5c48f3a9939b0b$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8f5c48f3a9939b0b$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8f5c48f3a9939b0b$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8f5c48f3a9939b0b$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8f5c48f3a9939b0b$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8f5c48f3a9939b0b$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8f5c48f3a9939b0b$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8f5c48f3a9939b0b$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8f5c48f3a9939b0b$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8f5c48f3a9939b0b$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8f5c48f3a9939b0b$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("e2gHg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $a37e3434b26d3f31$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $a37e3434b26d3f31$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $a37e3434b26d3f31$var$isString(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object String]';
}
function $a37e3434b26d3f31$var$isObject(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Object]';
}
function $a37e3434b26d3f31$var$isRegExp(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object RegExp]';
}
function $a37e3434b26d3f31$var$isFunction(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Function]';
}
function $a37e3434b26d3f31$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $a37e3434b26d3f31$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $a37e3434b26d3f31$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $a37e3434b26d3f31$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $a37e3434b26d3f31$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $a37e3434b26d3f31$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $a37e3434b26d3f31$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $a37e3434b26d3f31$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $a37e3434b26d3f31$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $a37e3434b26d3f31$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $a37e3434b26d3f31$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("d5qnw"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($a37e3434b26d3f31$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($a37e3434b26d3f31$var$isObject(val)) {
            if ($a37e3434b26d3f31$var$isRegExp(val.validate)) compiled.validate = $a37e3434b26d3f31$var$createValidator(val.validate);
            else if ($a37e3434b26d3f31$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($a37e3434b26d3f31$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $a37e3434b26d3f31$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($a37e3434b26d3f31$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $a37e3434b26d3f31$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($a37e3434b26d3f31$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $a37e3434b26d3f31$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $a37e3434b26d3f31$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $a37e3434b26d3f31$var$createMatch(self, shift) {
    var match = new $a37e3434b26d3f31$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $a37e3434b26d3f31$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $a37e3434b26d3f31$var$LinkifyIt)) return new $a37e3434b26d3f31$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($a37e3434b26d3f31$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $a37e3434b26d3f31$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $a37e3434b26d3f31$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $a37e3434b26d3f31$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $a37e3434b26d3f31$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $a37e3434b26d3f31$var$LinkifyIt;

});
parcelRegister("d5qnw", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});






parcelRegister("f14yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31acef3336a9ea7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $e31acef3336a9ea7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        }
    }, props.children);
}

});

parcelRegister("eVxaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3356ea5acdd73a43$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $3356ea5acdd73a43$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("strong", props.dataAttributes, props.children);
}

});

parcelRegister("gUlHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c264e87eca3a3d05$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $c264e87eca3a3d05$var$isSub = (type)=>{
    return type === 'sub';
};
function $c264e87eca3a3d05$export$2e2bcd8739ae039(props) {
    if ($c264e87eca3a3d05$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("sub", props.dataAttributes, props.children);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("sup", props.dataAttributes, props.children);
}

});

parcelRegister("c15YI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8904856eee164f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $lKA8N = parcelRequire("lKA8N");

var $hxoiH = parcelRequire("hxoiH");
function $c8904856eee164f6$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});
parcelRegister("lKA8N", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $965e3166a7c18c5e$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $965e3166a7c18c5e$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $965e3166a7c18c5e$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $965e3166a7c18c5e$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("koUAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d139f843714a421$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $7dikW = parcelRequire("7dikW");

var $hxoiH = parcelRequire("hxoiH");
function $7d139f843714a421$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $7dikW.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});
parcelRegister("7dikW", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0);
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $b5a4f7ad3e4ae03c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $b5a4f7ad3e4ae03c$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("eESZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8016b636a69d58$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $6f8016b636a69d58$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("u", props.dataAttributes, props.children);
}

});

parcelRegister("95Yll", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f1f5242a99941b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");
const $56f1f5242a99941b$var$wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
function $56f1f5242a99941b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $56f1f5242a99941b$var$wrapperStyles,
            "data-mode": props.mode,
            ...(0, $gmhCD.editorExperiment)('advanced_layouts', true) && {
                'data-has-width': !!props.width,
                'data-width': props.width
            },
            style: {
                width: (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWithCustomWidth)(props.mode, 'width' in props ? props.width : null, width) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWidth)(props.mode, width)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "fabric-editor-breakout-mark fabric-editor-block-mark"
        }, props.children));
}

});

parcelRegister("lbdLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b7090399d1e727$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aeGrH = parcelRequire("aeGrH");
const $d1b7090399d1e727$var$MarkWrapper = (props)=>{
    const styles = props['data-align'] ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)("text-align:", (0, $aeGrH.alignmentPositionMap)[props['data-align']], ";") : '';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: styles,
        ...props
    }, props.children);
};
function $d1b7090399d1e727$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($d1b7090399d1e727$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("9xZ5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef073b46e3c6008$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $3ef073b46e3c6008$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level
    }, props.children);
}

});

parcelRegister("g5EjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1398622ac205fad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b1398622ac205fad$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("acz8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $04eeed03d14d0e78$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $04eeed03d14d0e78$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("8DQfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $009dff5e97619965$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $009dff5e97619965$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("g9yqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ac6eff929f5b91e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ac6eff929f5b91e$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("itF0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f200b42408cc462$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $7f200b42408cc462$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("6EeUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $efbb661461ca3406$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $efbb661461ca3406$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference
        }, children);
    }
}

});


parcelRegister("eQNWQ", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $7bbfc2d34b0938dd$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $7bbfc2d34b0938dd$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $7bbfc2d34b0938dd$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $7bbfc2d34b0938dd$export$81b20b6c83a56bd);

var $9IGaJ = parcelRequire("9IGaJ");
var $kc0v7 = parcelRequire("kc0v7");
var $iZOJ9 = parcelRequire("iZOJ9");
var $bFtEE = parcelRequire("bFtEE");

var $kOFhM = parcelRequire("kOFhM");

var $VSDnB = parcelRequire("VSDnB");
const $7bbfc2d34b0938dd$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $7bbfc2d34b0938dd$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $7bbfc2d34b0938dd$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(a.type.name) - $7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $7bbfc2d34b0938dd$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $7bbfc2d34b0938dd$export$fb80336a7e408cb3 = (doc, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const node = $7bbfc2d34b0938dd$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $7bbfc2d34b0938dd$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $7bbfc2d34b0938dd$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $kc0v7.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $7bbfc2d34b0938dd$export$fafd4f799ee68da0 = (content, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$ANCHOR_LINK = /^#/;
const $7bbfc2d34b0938dd$var$flattenUnknownBlockTree = (node, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($7bbfc2d34b0938dd$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$7bbfc2d34b0938dd$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $7bbfc2d34b0938dd$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $iZOJ9.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $7bbfc2d34b0938dd$var$flattenUnknownBlockTree(node)
    };
};
const $7bbfc2d34b0938dd$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $7bbfc2d34b0938dd$export$81b20b6c83a56bd = (originalNode, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $7bbfc2d34b0938dd$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $bFtEE.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $9IGaJ.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
};
const $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$7bbfc2d34b0938dd$var$RELATIVE_LINK.test(linkHref) && !$7bbfc2d34b0938dd$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $iZOJ9.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("kc0v7", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $eb355120b38723aa$export$b1f729c6af6f2a6e);

var $ctVrM = parcelRequire("ctVrM");
const $eb355120b38723aa$var$typedNodes = $ctVrM;
const $eb355120b38723aa$export$b1f729c6af6f2a6e = new Set(Object.keys($eb355120b38723aa$var$typedNodes).filter((key)=>$eb355120b38723aa$var$typedNodes[key] && $eb355120b38723aa$var$typedNodes[key].group === 'inline'));

});
parcelRegister("ctVrM", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("7kC9H")).expand);
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("7kC9H")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("7kC9H")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("6bbHe")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("5y0tR")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("bd7A9")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("xjCuM")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("aXBFx")).blockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("aXBFx")).blockquoteWithList);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => (parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("kjhhp")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("kjhhp")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("8vlrc")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("8vlrc")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("jnMM2")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("lRTZM")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("M4hHz")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("dwptW")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("dwptW")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("dwptW")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("abme3")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("7DoMR")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("7lRBh")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("g7Cky")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("g7Cky")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("2FIVU")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("2FIVU")).listItemWithTask);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("2FIVU")).listItemWithDecisionStage0);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("bFtEE")).extendedPanel);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("bFtEE")).PanelType);
$parcel$export(module.exports, "panelWithBlockquoteStage0", () => (parcelRequire("bFtEE")).panelWithBlockquoteStage0);
$parcel$export(module.exports, "text", () => (parcelRequire("3DR6L")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("9X587")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("5JeV5")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("7agO8")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("7agO8")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("7agO8")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("92lix")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("7Xgp3")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("bIGZ7")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("bIGZ7")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("bIGZ7")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("bIGZ7")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("bIGZ7")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("bIGZ7")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("9UDEr")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("9UDEr")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("9UDEr")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("9UDEr")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("9UDEr")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("9UDEr")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("9UDEr")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("9UDEr")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("9UDEr")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("9UDEr")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("9UDEr")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("9UDEr")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("9UDEr")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("9UDEr")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("9UDEr")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("9UDEr")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("9UDEr")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("9UDEr")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("9UDEr")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("9UDEr")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("9UDEr")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("9UDEr")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("9UDEr")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("8gSD8")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("8gSD8")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("Khvpb")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("43mJF")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("43mJF")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("iThOL")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("b2VmY")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dgJoa")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("gZoER")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("gZoER")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("4EbxI")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("cCBEe")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("21PS7")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("d1d6m")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("6kr5W")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("18bvk")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dx5eC")).nestedExpand);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("kshOv")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("hhN5g")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5BOuQ")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5AxYU")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("47jug")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("47jug")).multiBodiedExtension);

var $7kC9H = parcelRequire("7kC9H");

var $6bbHe = parcelRequire("6bbHe");

var $5y0tR = parcelRequire("5y0tR");

var $bd7A9 = parcelRequire("bd7A9");

var $xjCuM = parcelRequire("xjCuM");

var $aXBFx = parcelRequire("aXBFx");

var $kjhhp = parcelRequire("kjhhp");

var $8vlrc = parcelRequire("8vlrc");

var $jnMM2 = parcelRequire("jnMM2");

var $lRTZM = parcelRequire("lRTZM");

var $M4hHz = parcelRequire("M4hHz");

var $dwptW = parcelRequire("dwptW");

var $abme3 = parcelRequire("abme3");

var $7DoMR = parcelRequire("7DoMR");

var $7lRBh = parcelRequire("7lRBh");

var $g7Cky = parcelRequire("g7Cky");

var $2FIVU = parcelRequire("2FIVU");

var $bFtEE = parcelRequire("bFtEE");

var $3DR6L = parcelRequire("3DR6L");

var $9X587 = parcelRequire("9X587");

var $5JeV5 = parcelRequire("5JeV5");

var $7agO8 = parcelRequire("7agO8");

var $92lix = parcelRequire("92lix");

var $7Xgp3 = parcelRequire("7Xgp3");

var $bIGZ7 = parcelRequire("bIGZ7");

var $9UDEr = parcelRequire("9UDEr");

var $8gSD8 = parcelRequire("8gSD8");

var $Khvpb = parcelRequire("Khvpb");

var $43mJF = parcelRequire("43mJF");

var $iThOL = parcelRequire("iThOL");

var $b2VmY = parcelRequire("b2VmY");

var $dgJoa = parcelRequire("dgJoa");

var $gZoER = parcelRequire("gZoER");

var $4EbxI = parcelRequire("4EbxI");

var $cCBEe = parcelRequire("cCBEe");

var $21PS7 = parcelRequire("21PS7");

var $d1d6m = parcelRequire("d1d6m");

var $6kr5W = parcelRequire("6kr5W");

var $18bvk = parcelRequire("18bvk");

var $dx5eC = parcelRequire("dx5eC");

var $kshOv = parcelRequire("kshOv");

var $hhN5g = parcelRequire("hhN5g");

var $5BOuQ = parcelRequire("5BOuQ");

var $5AxYU = parcelRequire("5AxYU");

var $47jug = parcelRequire("47jug");

});



parcelRegister("bzwTW", function(module, exports) {

$parcel$export(module.exports, "insideBreakoutLayout", () => $99a90b85f857f7e6$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $99a90b85f857f7e6$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $99a90b85f857f7e6$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $99a90b85f857f7e6$export$244bf4b32387ef62);
const $99a90b85f857f7e6$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $99a90b85f857f7e6$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $99a90b85f857f7e6$export$d7bc71cca336a3b = (path)=>path.some((item)=>$99a90b85f857f7e6$var$isLayoutNode(item) && $99a90b85f857f7e6$var$hasBreakOutMark(item));
const $99a90b85f857f7e6$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $99a90b85f857f7e6$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $99a90b85f857f7e6$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};

});


parcelRegister("12yAL", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $af6d4930d9141440$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $4FBRr = parcelRequire("4FBRr");
var $aSk3Q = parcelRequire("aSk3Q");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
var $4IuOY = parcelRequire("4IuOY");

var $eQNWQ = parcelRequire("eQNWQ");

var $VSDnB = parcelRequire("VSDnB");

var $8QpSo = parcelRequire("8QpSo");

var $knXBU = parcelRequire("knXBU");

var $1cjf7 = parcelRequire("1cjf7");

var $kgV4b = parcelRequire("kgV4b");
const $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $af6d4930d9141440$var$withStopwatch = (cb)=>{
    const startTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $af6d4930d9141440$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4FBRr.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $4IuOY.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent);
    } else result = (0, $eQNWQ.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $aSk3Q.transformNestedTablesIncomingDocument)(result, {
            environment: 'renderer'
        });
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $gkwXh.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $af6d4930d9141440$var$memoValidation = (0, $8QpSo.default)($af6d4930d9141440$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator, skipValidation] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, oldSkipValidation] = lastArgs;
    // we're ignoring changes to dispatchAnalyticsEvent in this check
    const result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && skipValidation === oldSkipValidation;
    return result;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $af6d4930d9141440$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $af6d4930d9141440$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $af6d4930d9141440$var$memoSerializeFragment = (0, $8QpSo.default)($af6d4930d9141440$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $af6d4930d9141440$var$memoCreateNodeAndCheck = (0, $8QpSo.default)($af6d4930d9141440$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $kOFhM.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation)=>{
    const stat = {
        sanitizeTime: 0
    };
    const { output: validDoc, time: sanitizeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $d54NZ.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $1cjf7.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $kgV4b.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("4FBRr", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $75bd921bb3a8c47e$export$6528700f3fa2fe2a);

var $l1C1k = parcelRequire("l1C1k");
const $75bd921bb3a8c47e$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("4IuOY", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $2c0bbb60cfee2804$export$884cfad20dece33e);

var $905ey = parcelRequire("905ey");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
const $2c0bbb60cfee2804$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $2c0bbb60cfee2804$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent)=>{
    return (entity, error, options)=>{
        return $2c0bbb60cfee2804$export$468b008419c9a974(entity, error, options, marks, validate, dispatchAnalyticsEvent);
    };
};
const $2c0bbb60cfee2804$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $2c0bbb60cfee2804$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $2c0bbb60cfee2804$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    if (options.allowUnsupportedBlock) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : validate(child, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $d54NZ.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $2c0bbb60cfee2804$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $905ey.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent));
    return entity;
};
function $2c0bbb60cfee2804$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("905ey", function(module, exports) {

$parcel$export(module.exports, "validator", () => $e861220f24467804$export$956325f45c5d174a);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $gsiq1 = parcelRequire("gsiq1");

var $iiazc = parcelRequire("iiazc");

var $1H4Aw = parcelRequire("1H4Aw");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e861220f24467804$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $e861220f24467804$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($gsiq1).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$gsiq1[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $iiazc.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $gsiq1[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $iiazc.isString)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($gsiq1[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $gsiq1[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($gsiq1[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $gsiq1[subItem] : (0, $iiazc.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $e861220f24467804$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $e861220f24467804$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $e861220f24467804$export$66c739158ef99a42(spec, value) {
    if (!(0, $iiazc.isDefined)(value)) return !!spec.optional;
    if ($e861220f24467804$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $e861220f24467804$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $e861220f24467804$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $iiazc.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $iiazc.isBoolean)(value);
        case 'number':
            return (0, $iiazc.isNumber)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $iiazc.isInteger)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $iiazc.isDefined)((0, $1H4Aw.validatorFnMap)[rule]) && (0, $1H4Aw.validatorFnMap)[rule](value);
            return (0, $iiazc.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $iiazc.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $iiazc.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $iiazc.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$e861220f24467804$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$e861220f24467804$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $iiazc.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $e861220f24467804$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $e861220f24467804$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $e861220f24467804$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $e861220f24467804$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message
    }, $e861220f24467804$var$getUnsupportedOptions(parentSpec));
};
const $e861220f24467804$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $e861220f24467804$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $e861220f24467804$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $e861220f24467804$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $e861220f24467804$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $e861220f24467804$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $e861220f24467804$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $e861220f24467804$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $e861220f24467804$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $iiazc.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $iiazc.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$e861220f24467804$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $iiazc.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $iiazc.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $iiazc.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $e861220f24467804$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $e861220f24467804$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $e861220f24467804$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $e861220f24467804$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $e861220f24467804$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $e861220f24467804$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iiazc.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $iiazc.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $e861220f24467804$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : v.optional;
            return isOptional || (0, $iiazc.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $e861220f24467804$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $iiazc.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $iiazc.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("gsiq1", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("5fjVx")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("5fjVx")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("5fjVx")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("5fjVx")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("5fjVx")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("5fjVx")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("5fjVx")).blockquote);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5fjVx")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("5fjVx")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("5fjVx")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("5fjVx")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("5fjVx")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("5fjVx")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("5fjVx")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("5fjVx")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("5fjVx")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("5fjVx")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("5fjVx")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("5fjVx")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("5fjVx")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("5fjVx")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("5fjVx")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("5fjVx")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("5fjVx")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("5fjVx")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5fjVx")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("5fjVx")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("5fjVx")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("5fjVx")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("5fjVx")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("5fjVx")).extension_with_marks);
$parcel$export(module.exports, "fragment", () => (parcelRequire("5fjVx")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("5fjVx")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("5fjVx")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("5fjVx")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("5fjVx")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("5fjVx")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("5fjVx")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("5fjVx")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5fjVx")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("5fjVx")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("5fjVx")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("5fjVx")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("5fjVx")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("5fjVx")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("5fjVx")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("5fjVx")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("5fjVx")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("5fjVx")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("5fjVx")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("5fjVx")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("5fjVx")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("5fjVx")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("5fjVx")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("5fjVx")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("5fjVx")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("5fjVx")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("5fjVx")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("5fjVx")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("5fjVx")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("5fjVx")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("5fjVx")).panel);
$parcel$export(module.exports, "panel_with_nested_blockquote", () => (parcelRequire("5fjVx")).panel_with_nested_blockquote);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5fjVx")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("5fjVx")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("5fjVx")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("5fjVx")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("5fjVx")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("5fjVx")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("5fjVx")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("5fjVx")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("5fjVx")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("5fjVx")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("5fjVx")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("5fjVx")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("5fjVx")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("5fjVx")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("5fjVx")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("5fjVx")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("5fjVx")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("5fjVx")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("5fjVx")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("5fjVx")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("5fjVx")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("5fjVx")).underline);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5fjVx = parcelRequire("5fjVx");

});
parcelRegister("5fjVx", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $3d1dcf8b9eccd1a7$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $3d1dcf8b9eccd1a7$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $3d1dcf8b9eccd1a7$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $3d1dcf8b9eccd1a7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23);
$parcel$export(module.exports, "bodiedExtension", () => $3d1dcf8b9eccd1a7$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83);
$parcel$export(module.exports, "border", () => $3d1dcf8b9eccd1a7$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $3d1dcf8b9eccd1a7$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $3d1dcf8b9eccd1a7$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $3d1dcf8b9eccd1a7$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $3d1dcf8b9eccd1a7$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $3d1dcf8b9eccd1a7$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $3d1dcf8b9eccd1a7$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $3d1dcf8b9eccd1a7$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $3d1dcf8b9eccd1a7$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $3d1dcf8b9eccd1a7$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $3d1dcf8b9eccd1a7$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $3d1dcf8b9eccd1a7$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $3d1dcf8b9eccd1a7$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $3d1dcf8b9eccd1a7$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $3d1dcf8b9eccd1a7$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $3d1dcf8b9eccd1a7$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $3d1dcf8b9eccd1a7$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $3d1dcf8b9eccd1a7$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $3d1dcf8b9eccd1a7$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $3d1dcf8b9eccd1a7$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $3d1dcf8b9eccd1a7$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $3d1dcf8b9eccd1a7$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $3d1dcf8b9eccd1a7$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $3d1dcf8b9eccd1a7$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $3d1dcf8b9eccd1a7$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panel_with_nested_blockquote", () => $3d1dcf8b9eccd1a7$export$5d60af6db74e5cd3);
$parcel$export(module.exports, "paragraph", () => $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $3d1dcf8b9eccd1a7$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $3d1dcf8b9eccd1a7$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $3d1dcf8b9eccd1a7$export$b3401ee80eb31041);
$parcel$export(module.exports, "table", () => $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $3d1dcf8b9eccd1a7$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $3d1dcf8b9eccd1a7$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $3d1dcf8b9eccd1a7$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $3d1dcf8b9eccd1a7$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $3d1dcf8b9eccd1a7$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $3d1dcf8b9eccd1a7$export$425327af25286e5e);
const $3d1dcf8b9eccd1a7$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'panel_with_nested_blockquote',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $3d1dcf8b9eccd1a7$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'panel_with_nested_blockquote',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$5d60af6db74e5cd3 = [
    'panel',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule',
                        'decisionList',
                        'blockquote'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("iiazc", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $2c8456da404b8e3f$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $2c8456da404b8e3f$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $2c8456da404b8e3f$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $2c8456da404b8e3f$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $2c8456da404b8e3f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $2c8456da404b8e3f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $2c8456da404b8e3f$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $2c8456da404b8e3f$export$7b85fd78dd236198);
const $2c8456da404b8e3f$export$4e62c701997796c1 = (x)=>x != null;
const $2c8456da404b8e3f$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $2c8456da404b8e3f$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $2c8456da404b8e3f$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $2c8456da404b8e3f$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $2c8456da404b8e3f$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $2c8456da404b8e3f$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $2c8456da404b8e3f$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("1H4Aw", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $608e35270d0ca1e8$export$d1b377ca77ac267d);

var $iZOJ9 = parcelRequire("iZOJ9");
const $608e35270d0ca1e8$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $iZOJ9.isSafeUrl)
};

});



parcelRegister("1cjf7", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $dad344c5873159ce$export$a43de96edd8d0a0);

var $4NUlu = parcelRequire("4NUlu");
var $2KwKW = parcelRequire("2KwKW");

var $gkwXh = parcelRequire("gkwXh");

var $knXBU = parcelRequire("knXBU");
const $dad344c5873159ce$var$rendersMap = {};
const $dad344c5873159ce$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $2KwKW.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $4NUlu.getAnalyticsAppearance)(item.appearance),
                platform: (0, $knXBU.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $dad344c5873159ce$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE = 100;
const $dad344c5873159ce$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$dad344c5873159ce$var$rendersMap[appearance]) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $dad344c5873159ce$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $dad344c5873159ce$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($dad344c5873159ce$var$rendersMap[appearance].size === 1) $dad344c5873159ce$var$schedule(()=>$dad344c5873159ce$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($dad344c5873159ce$var$rendersMap[appearance].size % sampleRate === 0) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("2KwKW", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $4210b4deee40727f$export$484b83e0462998d);

var $l1C1k = parcelRequire("l1C1k");
var $4210b4deee40727f$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $4210b4deee40727f$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $4210b4deee40727f$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $4210b4deee40727f$export$f9f8a29778652c3e.BLOCKING
    };
};
const $4210b4deee40727f$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $l1C1k.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $l1C1k.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $4210b4deee40727f$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $4210b4deee40727f$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("kgV4b", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $7ac8dee2b321f8fd$export$1daf15cbaf649dad);

var $3Y1bF = parcelRequire("3Y1bF");
function $7ac8dee2b321f8fd$export$1daf15cbaf649dad(adfDocument) {
    return (0, $3Y1bF.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("3Y1bF", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $de5bae64a9d3f36e$export$533b26079ad0b4b);

var $l1C1k = parcelRequire("l1C1k");
function $de5bae64a9d3f36e$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("1urn6", function(module, exports) {

$parcel$export(module.exports, "EditorMediaClientProvider", () => $d9518b7b87f036fd$export$77218b6ff680865f);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $9S8fM = parcelRequire("9S8fM");
const $d9518b7b87f036fd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $5uXOq.useState)();
    const mediaProvider = (0, $9S8fM.useProvider)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $5uXOq.useContext)((0, $cEHh7.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $5uXOq.useMemo)(()=>mediaClientConfig ? (0, $cEHh7.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $5uXOq.useEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient
    }, children);
};

});

parcelRegister("1pTqN", function(module, exports) {

$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $ae2d04c26b960a03$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $ae2d04c26b960a03$export$cddc3c6ebe2d2cec);

var $5uXOq = parcelRequire("5uXOq");
const { Provider: $ae2d04c26b960a03$export$20439b49fdd0d26c, Consumer: $ae2d04c26b960a03$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $ae2d04c26b960a03$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $5uXOq.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2d04c26b960a03$var$Consumer, null, (newActiveHeaderId)=>{
        if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
        else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
            setActiveHeaderId(newActiveHeaderId);
            onNestedHeaderIdMatch();
        }
        return null;
    });
};

});

parcelRegister("jUVor", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $5224f7c9e411dec4$export$cfc1361be0de4203);

var $5uXOq = parcelRequire("5uXOq");

var $eOOFp = parcelRequire("eOOFp");

var $VSDnB = parcelRequire("VSDnB");

var $OxITw = parcelRequire("OxITw");
function $5224f7c9e411dec4$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const context = $5224f7c9e411dec4$export$92859d13f30c883e(id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $5224f7c9e411dec4$export$92859d13f30c883e(id) {
    return `
	 (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
    ${$5224f7c9e411dec4$export$47813c4121c8b4b3};
    (${$5224f7c9e411dec4$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${Boolean((0, $VSDnB.fg)('platform-fix-table-ssr-resizing'))});
  })(window);
`;
}
const $5224f7c9e411dec4$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $eOOFp.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $eOOFp.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $eOOFp.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcBreakoutWithCustomWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWithCustomWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $eOOFp.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $eOOFp.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $OxITw.FullPagePadding).toString()};
`;
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5224f7c9e411dec4$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldFixTableResizing) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector('[data-breakout-script-id="' + id + '"]'), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const resizedBreakout = node.dataset.hasWidth === 'true';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (!shouldFixTableResizing) {
                    if (node.classList.contains('pm-table-container') && mode === 'custom') {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const rendererWidth = renderer.offsetWidth;
                        const effectiveWidth = rendererWidth - breakoutConsts.padding;
                        width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                    } else if (resizedBreakout) width = breakoutConsts.calcBreakoutWithCustomWidth(mode, node.dataset.width || null, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderer.offsetWidth);
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                    if (node.style.width === width) return;
                    node.style.width = width;
                    // Tables require some special logic, as they are not using common css transform approach,
                    // because it breaks with sticky headers. This logic is copied from a table node:
                    // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                    if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    !renderer.classList.contains('is-full-width')) {
                        const lineLength = breakoutConsts.calcLineLength();
                        const left = lineLength / 2 - parseInt(width) / 2;
                        if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                        else node.style.left = '';
                    }
                }
            });
            else if (/**
				 * The mutation observer is only called once per added node.
				 * The above condition only deals with direct children of <div class="ak-renderer-document" />
				 * When it is initially called on the direct children, not all the sub children have loaded.
				 * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
				 * Thus adding this conditional to deal with all media elements directly.
				 */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
	 * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
	 * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
	 * That's why window load is necessary.
	 *
	 * More info:
	 * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
	 */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $5224f7c9e411dec4$export$2a0b3eeee3f2ea40 = (0, $eOOFp.breakoutConsts).calcLineLength;

});

parcelRegister("TPpI8", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $2d523c4d7c031fc5$export$3dee5e4542c672d9);


function $2d523c4d7c031fc5$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $9e7f9e5fe795995b$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $025bde419ff72534$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $025bde419ff72534$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $025bde419ff72534$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $9e7f9e5fe795995b$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("3lRy2", function(module, exports) {

$parcel$export(module.exports, "TruncatedWrapper", () => $de95a93fc343bd51$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");
const $de95a93fc343bd51$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $de95a93fc343bd51$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $de95a93fc343bd51$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, children);
};
class $de95a93fc343bd51$export$79ad592494094f07 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
    }
    // TODO: Quality ticket as elevation.surface will be issue when sits top of modal. https://product-fabric.atlassian.net/browse/DSP-4123
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($de95a93fc343bd51$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});


parcelRegister("h17zy", function(module, exports) {

$parcel$export(module.exports, "useEmojiProvider", () => $502e0815e90e6f7b$export$d80cf6b7758b1c7e);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");

var $hXRXz = parcelRequire("hXRXz");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");
const $502e0815e90e6f7b$export$d80cf6b7758b1c7e = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const emojiProvider = (0, $5uXOq.useMemo)(()=>{
        const dataProviders = new (0, $dGzaM.default)();
        dataProviders.setProvider('emojiProvider', (0, $hXRXz.getEmojiProviderWithCustomEmoji)(cloudId, atlassianAccountId) || undefined);
        return dataProviders;
    }, [
        cloudId,
        atlassianAccountId
    ]);
    return emojiProvider;
};

});

parcelRegister("6a30R", function(module, exports) {

$parcel$export(module.exports, "isExternalLink", () => $97cd92cd81dfd9ff$export$b98882f166bb7ce2);
$parcel$export(module.exports, "onLinkClick", () => $97cd92cd81dfd9ff$export$dccc97e4cadc9724);
$parcel$export(module.exports, "smartLinksDefault", () => $97cd92cd81dfd9ff$export$4f1b881d7a962ce6);
$parcel$export(module.exports, "useSmartCardProductType", () => $97cd92cd81dfd9ff$export$3f864e37674c79e7);
$parcel$export(module.exports, "useSmartCardIsAIEnabled", () => $97cd92cd81dfd9ff$export$af081b1242bfa300);
$parcel$export(module.exports, "SmartCardProviderWithAIHooks", () => $97cd92cd81dfd9ff$export$ca9fa6647337e334);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $8dO33 = parcelRequire("8dO33");

var $dn5wJ = parcelRequire("dn5wJ");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $iixvy = parcelRequire("iixvy");

var $93Yeu = parcelRequire("93Yeu");
const $97cd92cd81dfd9ff$var$isLeftClick = (event)=>event.button === 0;
const $97cd92cd81dfd9ff$var$isMiddleClick = (event)=>event.button === 1;
const $97cd92cd81dfd9ff$var$isCmdOrCtrlClick = (event)=>$97cd92cd81dfd9ff$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
const $97cd92cd81dfd9ff$export$b98882f166bb7ce2 = (url)=>{
    (0, $gKZoD.di)(window);
    try {
        const { hostname: hostname, pathname: pathname } = new URL(url);
        return(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        hostname !== window.location.hostname || ![
            '/jira',
            '/browse'
        ].some((includedPath)=>pathname.startsWith(includedPath)));
    } catch (err) {
        // Defaults to external link for invalid URLs to avoid further processing
        return true;
    }
};
const $97cd92cd81dfd9ff$export$dccc97e4cadc9724 = (event, url)=>{
    (0, $gKZoD.di)(window);
    if (!url) return;
    if ($97cd92cd81dfd9ff$export$b98882f166bb7ce2(url)) {
        event.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    if (event.defaultPrevented) {
        // The default has already been prevented meaning that we need to open links in one
        // way or another to ensure we do eventually open the link
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const mouseEvent = event;
        $97cd92cd81dfd9ff$var$isCmdOrCtrlClick(mouseEvent) || $97cd92cd81dfd9ff$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
    }
};
const $97cd92cd81dfd9ff$export$4f1b881d7a962ce6 = {
    actionOptions: {
        hide: false,
        exclude: [
            (0, $dn5wJ.CardAction).ChangeStatusAction
        ]
    }
};
const $97cd92cd81dfd9ff$export$4761115a9e18aa47 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 'JPD';
        default:
            return undefined;
    }
};
const $97cd92cd81dfd9ff$export$3f864e37674c79e7 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const product = (0, $5uXOq.useMemo)(()=>// Arbitrarily default to Jira Software if not specified
        $97cd92cd81dfd9ff$export$4761115a9e18aa47(projectType) ?? 'JSW', [
        projectType
    ]);
    return product;
};
const $97cd92cd81dfd9ff$export$af081b1242bfa300 = ()=>{
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isPremium = (0, $iixvy.useIsPremium)();
    const isAIFeatureEnabled = (0, $5uXOq.useMemo)(()=>isAiOptInEnabled && isPremium, [
        isAiOptInEnabled,
        isPremium
    ]);
    return isAIFeatureEnabled;
};
const $97cd92cd81dfd9ff$export$ca9fa6647337e334 = (props)=>{
    const product = $97cd92cd81dfd9ff$export$3f864e37674c79e7();
    const isAIEnabled = $97cd92cd81dfd9ff$export$af081b1242bfa300();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: isAIEnabled,
        ...props
    }, props.children);
};

});
parcelRegister("8dO33", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $08b794feb02c83c1$export$497ecb0280204df4);

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $cCcdH = parcelRequire("cCcdH");

var $k9B19 = parcelRequire("k9B19");

var $8b7fu = parcelRequire("8b7fu");

var $051X7 = parcelRequire("051X7");

var $7cFR3 = parcelRequire("7cFR3");
function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $5uXOq.useContext)((0, $051X7.SmartCardContext));
    const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $5uXOq.useMemo)(()=>{
        return (0, $3f2cs.createStore)((0, $8b7fu.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>{
        const client = customClient || new (0, $7cFR3.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cCcdH.getUrl)(store, url);
            return cardState.details ? (0, $k9B19.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $051X7.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;

});
parcelRegister("cCcdH", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("k9B19", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $596309a7bcc79771$export$4b0d98b1b7f6d115);

var $TFljV = parcelRequire("TFljV");

var $7OmtM = parcelRequire("7OmtM");
const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $TFljV.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $7OmtM.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $7OmtM.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("TFljV", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $f8cdc1e628cbc347$export$3e8ad908070b68b2);
const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("7OmtM", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $0784379594099aa0$export$396ba4ef2e37dc65);
const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("8b7fu", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $92a815d7e26b35c0$export$3c7c3113a97b6492);

var $2yPrN = parcelRequire("2yPrN");
var $fiKQs = parcelRequire("fiKQs");
const $92a815d7e26b35c0$var$isCardAction = (action)=>{
    return [
        (0, $2yPrN.ACTION_PENDING),
        (0, $2yPrN.ACTION_RESOLVING),
        (0, $2yPrN.ACTION_RESOLVED),
        (0, $2yPrN.ACTION_RELOADING),
        (0, $2yPrN.ACTION_ERROR),
        (0, $2yPrN.ACTION_ERROR_FALLBACK),
        (0, $2yPrN.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $fiKQs.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $2yPrN.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $2yPrN.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $2yPrN.ACTION_RESOLVED:
            return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $2yPrN.ACTION_RELOADING:
            return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $2yPrN.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $2yPrN.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $2yPrN.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("2yPrN", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $23a1ee9f12bb755d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $23a1ee9f12bb755d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $23a1ee9f12bb755d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $23a1ee9f12bb755d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $23a1ee9f12bb755d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $23a1ee9f12bb755d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $23a1ee9f12bb755d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("fiKQs", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $5c2f531cb20db568$export$b70265791d2079d4);
const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("051X7", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $b8de051ddcb2808f$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $b8de051ddcb2808f$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $b8de051ddcb2808f$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $b8de051ddcb2808f$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $b8de051ddcb2808f$export$2a29ca11e08dc129);

var $5uXOq = parcelRequire("5uXOq");

const $b8de051ddcb2808f$export$156b523e63b4f63a = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $b8de051ddcb2808f$export$e1d190b530cf0ee9() {
    const context = (0, $5uXOq.useContext)($b8de051ddcb2808f$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $b8de051ddcb2808f$export$10e9cca30e50f657 = ()=>$b8de051ddcb2808f$var$useContextMemoized($b8de051ddcb2808f$export$156b523e63b4f63a);
const $b8de051ddcb2808f$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $b8de051ddcb2808f$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
function $b8de051ddcb2808f$var$useContextMemoized(reactContext) {
    const value = (0, $5uXOq.useContext)(reactContext);
    const context = (0, $5uXOq.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $b8de051ddcb2808f$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $b8de051ddcb2808f$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Provider, {
        value: cardContext.value
    }, children);
};
var $b8de051ddcb2808f$export$2e2bcd8739ae039 = $b8de051ddcb2808f$export$156b523e63b4f63a;

});

parcelRegister("7cFR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d96ed473518bd99$export$2e2bcd8739ae039);

var $hhZW9 = parcelRequire("hhZW9");

var $hj8yn = parcelRequire("hj8yn");

var $hLXaJ = parcelRequire("hLXaJ");

var $kDZ6Z = parcelRequire("kDZ6Z");
var $itO4f = parcelRequire("itO4f");
var $fiKQs = parcelRequire("fiKQs");
var $dV0Jy = parcelRequire("dV0Jy");

var $4Bkrp = parcelRequire("4Bkrp");

var $iwKVT = parcelRequire("iwKVT");
const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
class $8d96ed473518bd99$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $4Bkrp.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $itO4f.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hLXaJ)))({
            limit: 1,
            interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $4Bkrp.isSuccessfulResponse)(response) || (0, $fiKQs.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $4Bkrp.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $4Bkrp.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $4Bkrp.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $4Bkrp.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $4Bkrp.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $dV0Jy.NetworkError)) return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $kDZ6Z.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $kDZ6Z.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $kDZ6Z.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $kDZ6Z.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("hj8yn", function(module, exports) {
// Packages

var $fGJx3 = parcelRequire("fGJx3");
function $c99ad890679d3578$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $fGJx3.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $c99ad890679d3578$var$retry;

});
parcelRegister("fGJx3", function(module, exports) {

module.exports = (parcelRequire("6Q6YB"));

});
parcelRegister("6Q6YB", function(module, exports) {

var $8vOLa = parcelRequire("8vOLa");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8vOLa(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("8vOLa", function(module, exports) {
function $632897d2769f1314$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $632897d2769f1314$var$RetryOperation;
$632897d2769f1314$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$632897d2769f1314$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$632897d2769f1314$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$632897d2769f1314$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$632897d2769f1314$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$632897d2769f1314$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$632897d2769f1314$var$RetryOperation.prototype.start = $632897d2769f1314$var$RetryOperation.prototype.try;
$632897d2769f1314$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$632897d2769f1314$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$632897d2769f1314$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("hLXaJ", function(module, exports) {
'use strict';
class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;

});

parcelRegister("kDZ6Z", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $8c263ecf028a2c14$export$3e5b797e39668f84);
class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("itO4f", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $21a0efece812cd9a$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $21a0efece812cd9a$export$dc37652c1696f231);
const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $21a0efece812cd9a$export$e2b040f052407032 = {
    dev: $21a0efece812cd9a$var$devBaseUrl,
    development: $21a0efece812cd9a$var$devBaseUrl,
    stg: $21a0efece812cd9a$var$stgBaseUrl,
    staging: $21a0efece812cd9a$var$stgBaseUrl,
    prd: $21a0efece812cd9a$var$prodBaseUrl,
    prod: $21a0efece812cd9a$var$prodBaseUrl,
    production: $21a0efece812cd9a$var$prodBaseUrl
};
const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;

});

parcelRegister("dV0Jy", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $5576d4e9d0a3858d$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $5576d4e9d0a3858d$export$b5fe3f66a567bec0);
const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("4Bkrp", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});



parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("iixvy", function(module, exports) {

$parcel$export(module.exports, "useIsPremium", () => $545133d1825caa45$export$1bb5840a003dc643);
$parcel$export(module.exports, "useOptInStatus", () => $545133d1825caa45$export$5e56b08674e48311);
$parcel$export(module.exports, "useAIOptIn", () => $545133d1825caa45$export$49e57b9044cda91c);

var $5uXOq = parcelRequire("5uXOq");

var $kTK0a = parcelRequire("kTK0a");
var $aIZdc = parcelRequire("aIZdc");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $5NH95 = parcelRequire("5NH95");

var $93Yeu = parcelRequire("93Yeu");

var $14XJw = parcelRequire("14XJw");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $4R6GH = parcelRequire("4R6GH");

var $ljlOe = parcelRequire("ljlOe");

var $44KLa = parcelRequire("44KLa");
const $545133d1825caa45$var$DISABLED = 'disabled';
const $545133d1825caa45$var$DISABLED_OPT_IN = 'disabled-opt-in';
const $545133d1825caa45$var$ENABLED = 'enabled';
const $545133d1825caa45$export$1bb5840a003dc643 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    // currently admin hub AI BE endpoint for JWM already defaults to JSW value
    // so we reflect same logic for JWM here
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.PREMIUM_EDITION);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $ldyPw.PREMIUM_EDITION);
        default:
            return false;
    }
};
const $545133d1825caa45$export$10e0dafdd792475b = ()=>{
    // upsell us for standard but not free subscription admins
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return appEditions.core === (0, $ldyPw.STANDARD_EDITION);
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.STANDARD_EDITION);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $ldyPw.STANDARD_EDITION);
        default:
            return false;
    }
};
const $545133d1825caa45$export$bd66bcf1f00b19d2 = ()=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPremium = $545133d1825caa45$export$1bb5840a003dc643();
    const isSupportedENV = !(0, $aIZdc.isFedRamp)();
    return isOrgAdmin && isPremium && isSupportedENV;
};
const $545133d1825caa45$export$1276193c77ae88bf = ()=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isStandard = $545133d1825caa45$export$10e0dafdd792475b();
    const isSupportedENV = !(0, $aIZdc.isFedRamp)();
    return isOrgAdmin && isStandard && isSupportedENV;
};
const $545133d1825caa45$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
    const canOptIn = $545133d1825caa45$export$bd66bcf1f00b19d2();
    const canStartPremiumTrial = $545133d1825caa45$export$1276193c77ae88bf();
    if ((0, $aIZdc.isFedRamp)()) return $545133d1825caa45$var$DISABLED;
    // AI Upsell In Editor Experiment - implicitly checks product, fedramp, if edition is FREE and user is an admin
    const { experimentValue: aiUpsellInEditorCohort } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? (0, $5NH95.useAIUpsellInEditorRequirements)(product) : {
        experimentValue: 'not-enrolled'
    };
    if (aiUpsellInEditorCohort === 'variation') return $545133d1825caa45$var$DISABLED_OPT_IN;
    const isValidForGlobalOptIn = [
        product !== 'JPD',
        canOptIn
    ].every((condition)=>condition === true);
    const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
    const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $545133d1825caa45$var$DISABLED_OPT_IN : $545133d1825caa45$var$DISABLED;
    return isAIOptedIn ? $545133d1825caa45$var$ENABLED : globalOptInEnabled;
};
const $545133d1825caa45$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
    const optInStatus = $545133d1825caa45$export$5e56b08674e48311(isAiOptInEnabled, product);
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [showOptInModal, setShowOptInModal] = (0, $5uXOq.useState)(false);
    const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $5uXOq.useState)(false);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const canStartTrial = $545133d1825caa45$export$1276193c77ae88bf();
    // AI Upsell In Editor Experiment
    const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? (0, $5NH95.useAIUpsellInEditorFree)(optInStatus, product) : {
        isExperimentEnabled: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerUpsellFlow: ()=>{},
        UpsellModal: null
    };
    // Callback that will be called when AI buttons are clicked and opt in status is disabled-op-in
    const triggerOptInFlow = (0, $5uXOq.useCallback)(()=>{
        setShowOptInModal(true);
    }, [
        setShowOptInModal
    ]);
    // alt callback for standard admins to trigger a premium upsell in order to opt in
    const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
        setShowPremiumTrialModal(true);
    }, [
        setShowPremiumTrialModal
    ]);
    const aiOptInModal = (0, $5uXOq.useMemo)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        const adminLink = `${(0, $kTK0a.getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44KLa.OptInModal), {
            showOptInModal: showOptInModal,
            isOrgAdmin: isOrgAdmin,
            onCloseModal: onCloseModal,
            adminLink: adminLink
        });
    }, [
        orgId,
        isOrgAdmin,
        showOptInModal
    ]);
    const aiUpsellModal = (0, $5uXOq.useMemo)(()=>{
        const onCloseModal = ()=>setShowPremiumTrialModal(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ljlOe.AIUpsellPremiumTrialEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44KLa.OptInUpsellModal), {
            "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
            showPremiumTrialModal: showPremiumTrialModal,
            onCloseModal: onCloseModal
        }));
    }, [
        showPremiumTrialModal
    ]);
    if ((0, $aIZdc.isFedRamp)()) return {
        optInStatus: $545133d1825caa45$var$DISABLED,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerOptInFlow: ()=>{},
        AIOptInModal: null
    };
    if (isAIUpsellInEditorFreeEnabled) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
        AIOptInModal: AIUpsellInEditorFreeModal
    };
    if (optInStatus === $545133d1825caa45$var$DISABLED || optInStatus === $545133d1825caa45$var$ENABLED) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: null
    };
    if (canStartTrial && optInStatus === $545133d1825caa45$var$DISABLED_OPT_IN) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerUpsellFlow,
        AIOptInModal: aiUpsellModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: aiOptInModal
    };
};

});
parcelRegister("5NH95", function(module, exports) {

$parcel$export(module.exports, "useAIUpsellInEditorRequirements", () => $26b3b3762ac33b52$export$38bfb0ec25eaa6b2);
$parcel$export(module.exports, "useAIUpsellInEditorFree", () => $26b3b3762ac33b52$export$beacfd188d344f95);
$parcel$export(module.exports, "AIUpsellButtonWrapper", () => $26b3b3762ac33b52$export$c44b9b0347b51c37);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aIZdc = parcelRequire("aIZdc");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $fmQtB = parcelRequire("fmQtB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $4R6GH = parcelRequire("4R6GH");

var $4SswE = parcelRequire("4SswE");

var $7xCut = parcelRequire("7xCut");
const $26b3b3762ac33b52$var$useGetSupportedProjectType = (product)=>{
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    switch(product){
        case 'JSW':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'JSM':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'JWM':
            // If tenant is configured with only JWM and JSW, we can provide an upgrade link for JSW
            return siteHasOnlyJira ? (0, $2vSU6.SOFTWARE_PROJECT) : undefined;
        case 'JPD':
        default:
            return undefined;
    }
};
const $26b3b3762ac33b52$var$useGetSupportedEdition = (product)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
    if (!appEditions) return undefined;
    if (projectType) return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    return undefined;
};
const $26b3b3762ac33b52$export$38bfb0ec25eaa6b2 = (product)=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const supportedEdition = $26b3b3762ac33b52$var$useGetSupportedEdition(product);
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config, fireExperimentExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_free_ai_in_editor_v2_experiment');
    const statsigExperimentValue = config.get('cohort', 'not-enrolled');
    const siteMeetsRequirements = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') && supportedEdition === (0, $ldyPw.FREE_EDITION) && isOrgAdmin && !(0, $aIZdc.isFedRamp)();
    const experimentValue = siteMeetsRequirements ? statsigExperimentValue : 'not-enrolled';
    const fireExposure = (0, $5uXOq.useCallback)(()=>{
        fireExperimentExposure();
    }, [
        fireExperimentExposure
    ]);
    return {
        siteMeetsRequirements: siteMeetsRequirements,
        experimentValue: experimentValue,
        statsigExperimentValue: statsigExperimentValue,
        fireExperimentExposure: fireExposure
    };
};
const $26b3b3762ac33b52$export$beacfd188d344f95 = (optInStatus, product)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [showUpsellModal, setShowUpsellModal] = (0, $5uXOq.useState)(false);
    const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $26b3b3762ac33b52$export$38bfb0ec25eaa6b2(product);
    const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
    const siteMeetsOptInRequirements = siteMeetsRequirements && // optInStatus 'disabled' means they are on control, 'disabled-opt-in' on variation
    optInStatus !== 'enabled';
    const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : 'not-enrolled';
    // If the site is not FREE, or not on JSW/JSM, or the user is not billable, they are not enrolled
    const isEnrolledInExperiment = experimentValue !== 'not-enrolled';
    const isExperimentEnabled = isEnrolledInExperiment && experimentValue === 'variation';
    const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'triggerUpsellFlow',
            actionSubject: 'aiUpsellInEditorFree'
        }), 'aiUpsellInEditorFreeTrigger', {});
        setShowUpsellModal(true);
        (0, $7xCut.setUpsellButtonWrapperClicked)(true);
    }, [
        createAnalyticsEvent
    ]);
    const UpsellModal = (0, $5uXOq.useMemo)(()=>showUpsellModal && projectType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmQtB.AsyncAiUpsellInEditorFreeModal), {
            projectType: projectType,
            testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
            onModalClose: ()=>setShowUpsellModal(false)
        }) : null, [
        showUpsellModal,
        projectType
    ]);
    return {
        isEnrolledInExperiment: isEnrolledInExperiment,
        isExperimentEnabled: isExperimentEnabled,
        fireExperimentExposure: fireExperimentExposure,
        triggerUpsellFlow: triggerUpsellFlow,
        UpsellModal: UpsellModal
    };
};
const $26b3b3762ac33b52$export$c44b9b0347b51c37 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isClicked = (0, $7xCut.getUpsellButtonWrapperClicked)();
    const hasFired = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFired.current) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {});
            hasFired.current = true;
        }
    }, [
        createAnalyticsEvent
    ]);
    return !isClicked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonContainer, {
        "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonInner, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $26b3b3762ac33b52$var$AIUpsellButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
            __cmplp.className
        ])
    });
});
const $26b3b3762ac33b52$var$AIUpsellButtonInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fmQtB", function(module, exports) {

$parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", () => $2c23576aa5eb8dba$export$827041a383456a6a);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("d6LGc")), {
    ssr: false,
    moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
});
const $2c23576aa5eb8dba$export$827041a383456a6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "asyncAiUpsellInEditorFreeModal",
        packageName: "jira-growth-ai-upsell-in-editor-free-modal",
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal, props));

});
parcelRegister("d6LGc", function(module, exports) {

let $98b0d21b5b5937ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $98b0d21b5b5937ec$var$load("h2MrD"),
    $98b0d21b5b5937ec$var$load("bYT2S"),
    $98b0d21b5b5937ec$var$load("bQd01")
]).then(()=>parcelRequire('b738i'));

});


parcelRegister("4SswE", function(module, exports) {

$parcel$export(module.exports, "useSiteHasOnlyJira", () => $b6d886096eb5e5b4$export$8ce0db5ac54a6136);

var $cVzoY = parcelRequire("cVzoY");


var $9OXo1 = parcelRequire("9OXo1");
function $b6d886096eb5e5b4$export$8ce0db5ac54a6136() {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    try {
        const [firstExplicitlyLicensedProduct, ...rest] = (0, $cVzoY.default)(tenantContext);
        return rest.length === 0 && firstExplicitlyLicensedProduct === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    } catch  {
        return false;
    }
}

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';


parcelRegister("7xCut", function(module, exports) {

$parcel$export(module.exports, "getUpsellButtonWrapperClicked", () => $b8d3bd23ca283e73$export$f7d51ee95145148b);
$parcel$export(module.exports, "setUpsellButtonWrapperClicked", () => $b8d3bd23ca283e73$export$b595420beb43f9ce);

var $bSSG7 = parcelRequire("bSSG7");
const $b8d3bd23ca283e73$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('ai-upsell-in-editor-free');
function $b8d3bd23ca283e73$export$f7d51ee95145148b() {
    return Boolean($b8d3bd23ca283e73$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
}
function $b8d3bd23ca283e73$export$b595420beb43f9ce(value) {
    $b8d3bd23ca283e73$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
}

});


parcelRegister("ljlOe", function(module, exports) {

$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", () => $82777381236a0306$export$77aa5ca661b0742c);
$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", () => $82777381236a0306$export$dd0a751f23b19473);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $b3Gth = parcelRequire("b3Gth");
const $82777381236a0306$export$77aa5ca661b0742c = (0, $l37qh.createUseEntryPointContext)();
const $82777381236a0306$export$dd0a751f23b19473 = ({ children: children })=>{
    const entryPointParams = {};
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $b3Gth.entryPointPremiumUpgradeModal), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82777381236a0306$export$77aa5ca661b0742c.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("l37qh", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $6e7e19c2d291c94c$export$41bce2223126846b);

var $5uXOq = parcelRequire("5uXOq");
const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $5uXOq.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});


parcelRegister("44KLa", function(module, exports) {

$parcel$export(module.exports, "OptInModal", () => $bf7c19a18c627984$export$1697f043758ae8d2);
$parcel$export(module.exports, "OptInUpsellModal", () => $bf7c19a18c627984$export$bbf8d259a508a485);

var $5uXOq = parcelRequire("5uXOq");

var $1R1Ge = parcelRequire("1R1Ge");
var $i8Qvm = parcelRequire("i8Qvm");

var $4UN9Z = parcelRequire("4UN9Z");

var $7XluA = parcelRequire("7XluA");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ljlOe = parcelRequire("ljlOe");

var $ejjdc = parcelRequire("ejjdc");
const $bf7c19a18c627984$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, showOptInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4UN9Z.default), {
        source: "jira-editor",
        product: "jira",
        isOrgAdmin: isOrgAdmin,
        onAdminClose: onCloseModal,
        adminLink: adminLink
    })));
const $bf7c19a18c627984$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $ljlOe.AIUpsellPremiumTrialEntryPointContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClose: ()=>{
                entryPointActions.unload();
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
            }
        }), [
        entryPointActions,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, showPremiumTrialModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ejjdc.AIOptInPremiumUpsell), {
        onClose: onCloseModal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
        packageName: "platform-react-hooks-use-ai-opt-in",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("4UN9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $498daaeb8cd4c6ec$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");
var $1GGwS = parcelRequire("1GGwS");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $c0x54 = parcelRequire("c0x54");


var $ek69Y = parcelRequire("ek69Y");

var $lJhAv = parcelRequire("lJhAv");
const $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $498daaeb8cd4c6ec$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: (0, $3490940fa7f2fa1c$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)
    };
    const defaultHeader = formatMessage((0, $ek69Y.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $5uXOq.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($c0x54)))
        ]);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.OptInContainer), null, image ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.ImageWrapper), null, image) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.ImageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c0x54))),
        height: "96px",
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.ContentContainer), null, isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles
    }, formatMessage((0, $ek69Y.messages).aiOptInAdminOnlyVisible)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.HeaderWrapper), null, isOrgAdmin ? orgAdminHeader : header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.BodyWrapper), {
        "data-testid": "dialog-body-text"
    }, isOrgAdmin ? orgAdminBody : body), isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onCloseClicked,
        testId: "admin-close-button"
    }, adminCloseCTAText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminMaybeLaterButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        appearance: "primary",
        onClick: onCTAClicked,
        href: adminLink ?? (0, $3490940fa7f2fa1c$export$bae9a077d7ed5dfe),
        target: "_blank",
        testId: "admin-cta-button"
    }, adminCTAText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminGetStartedButtonText))))));
};
var $498daaeb8cd4c6ec$export$2e2bcd8739ae039 = $498daaeb8cd4c6ec$var$AiOptIn;

});
parcelRegister("c0x54", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

const $3490940fa7f2fa1c$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $3490940fa7f2fa1c$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

parcelRegister("ek69Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5fe19a2c65ae0a6d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5fe19a2c65ae0a6d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Messages for the AI Global Opt-in component
	 */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
        defaultMessage: 'Maybe later',
        description: 'Admin maybe later button text'
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: 'ai-opt-in.dialog.admin.get-started.button.text',
        defaultMessage: 'Get started',
        description: 'Admin get started button text'
    },
    aiOptInBannerBodyText: {
        id: 'ai-opt-in.banner.body.text',
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
        description: 'Body text for Banner version of AI Opt In Dialog'
    },
    aiOptInBannerLearnMoreText: {
        id: 'ai-opt-in.banner.learn.more.text',
        defaultMessage: 'Learn more',
        description: 'Learn more text for Banner cta of AI Opt In Dialog'
    },
    aiOptInAdminBannerBodyText: {
        id: 'ai-opt-in.banner.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of the Banner Ai Opt In'
    },
    aiOptInAdminOnlyVisible: {
        id: 'ai-opt-in.admin.only.visible.text',
        defaultMessage: 'This message is only visible to org admins.',
        description: 'Text message to let org admins know that the content is only visible to them.'
    }
});

});

parcelRegister("lJhAv", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $1bcec8f5b168d85d$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $1bcec8f5b168d85d$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $1bcec8f5b168d85d$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $1bcec8f5b168d85d$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $1bcec8f5b168d85d$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $1bcec8f5b168d85d$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $1bcec8f5b168d85d$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $1bcec8f5b168d85d$export$24c280970213bb11 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko14y2 _11q71lxv _16qs1o46 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1k7a _1e0c1txw _1biu1k7a _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81bk4",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$14966827497f4695 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81oud",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ejjdc", function(module, exports) {

$parcel$export(module.exports, "AIOptInPremiumUpsell", () => $678322372bbc5cca$export$54e4ba490d2c6bb5);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $2jwCH = parcelRequire("2jwCH");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");


var $gEusR = parcelRequire("gEusR");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2ogyS = parcelRequire("2ogyS");

var $iau6N = parcelRequire("iau6N");
const $678322372bbc5cca$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'screen',
            action: 'viewed'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $678322372bbc5cca$var$containerBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignBlock: "stretch",
        xcss: $678322372bbc5cca$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "end",
        grow: "fill",
        xcss: $678322372bbc5cca$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $2ogyS.messages).closeModal),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2jwCH)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        all: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEusR.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "stretch",
        space: "space.200",
        xcss: $678322372bbc5cca$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $2ogyS.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $2ogyS.messages).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iau6N.StartPremiumTrialButton), {
        onCloseParent: onClose
    })))));
};
const $678322372bbc5cca$var$containerBorderStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    width: '438px',
    position: 'relative',
    padding: 'space.025',
    background: `linear-gradient(
      112.4deg,
      ${`var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`} 0%,
      ${`var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$export$c71e4279dd54a18d)})`} 100%
    )`
});
const $678322372bbc5cca$var$containerStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay',
    overflow: 'hidden'
});
const $678322372bbc5cca$var$headerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    padding: 'space.075',
    right: 'space.025'
});
const $678322372bbc5cca$var$textContainerStyles = (0, $8CUq3.xcss)({
    padding: 'space.300'
});

});
parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e966e44e10d4af587c95b714fe3851cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});

parcelRegister("gEusR", function(module, exports) {

$parcel$export(module.exports, "default", () => $daf0e2023e742d66$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $8nOP6 = parcelRequire("8nOP6");

var $4aPxh = parcelRequire("4aPxh");
const $daf0e2023e742d66$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4aPxh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8nOP6))
});
var $daf0e2023e742d66$export$2e2bcd8739ae039 = $daf0e2023e742d66$var$Illustration;
// for advanced use only
const $daf0e2023e742d66$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    96
];

});
parcelRegister("8nOP6", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();

});

parcelRegister("4aPxh", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();

});


parcelRegister("2ogyS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $703e8ca8733c69fc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $703e8ca8733c69fc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
        "defaultMessage": "Write better, work faster with Atlassian Intelligence"
    },
    body: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
        "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
    },
    closeModal: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
        "defaultMessage": "Close Modal"
    },
    tryItFreeButton: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
        "defaultMessage": "Try it free"
    }
});

});

parcelRegister("iau6N", function(module, exports) {

$parcel$export(module.exports, "StartPremiumTrialButton", () => $d916fa2fae12e75a$export$a2651a739f515dd4);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $3ZC89 = parcelRequire("3ZC89");


var $47gW9 = parcelRequire("47gW9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ljlOe = parcelRequire("ljlOe");

var $2ogyS = parcelRequire("2ogyS");
const $d916fa2fae12e75a$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $ljlOe.AIUpsellPremiumTrialEntryPointContext));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClickAnalytics = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        // Nb. premium trial modal open is handled by entry point via ref
        onCloseParent && onCloseParent();
        onClickAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        onClick: onClick,
        ref: triggerRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZC89))), {
            LEGACY_size: "small",
            label: "",
            color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, formatMessage((0, $2ogyS.messages).tryItFreeButton));
};

});





parcelRegister("4IoOR", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdf", () => $7c8efe67867622a1$export$3dfdef94497f0395);

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");

var $dN5CS = parcelRequire("dN5CS");
const $7c8efe67867622a1$var$wikiTransformer = new (0, $dN5CS.WikiMarkupTransformer)((0, $kOFhM.defaultSchema));
const $7c8efe67867622a1$var$adfTransformer = new (0, $hYNZx.JSONTransformer)();
const $7c8efe67867622a1$export$3dfdef94497f0395 = (wiki)=>{
    if (wiki === null || wiki === undefined || wiki === '') return null;
    const pmNode = $7c8efe67867622a1$var$wikiTransformer.parse(wiki);
    return $7c8efe67867622a1$var$adfTransformer.encode(pmNode);
};

});
parcelRegister("dN5CS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "WikiMarkupTransformer", () => $4011ad83704160d6$export$caaa00407b56b900);
$parcel$export(module.exports, "default", () => $4011ad83704160d6$export$2e2bcd8739ae039);

var $kOFhM = parcelRequire("kOFhM");

var $lxtC7 = parcelRequire("lxtC7");

var $djcbG = parcelRequire("djcbG");

var $bOMPB = parcelRequire("bOMPB");
class $4011ad83704160d6$export$caaa00407b56b900 {
    constructor(schema = (0, $kOFhM.defaultSchema)){
        this.schema = schema;
    }
    // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
    // The following has to be a regex to remove all instances of null instead of the first
    sanitizeWikiMarkup(wikiMarkup) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return wikiMarkup.replace(/\0/g, '');
    }
    encode(node, context) {
        const wikiMarkup = (0, $lxtC7.encode)(node, $4011ad83704160d6$var$normalizeContextObject(context));
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        return sanitizedWikiMarkup;
    }
    parse(wikiMarkup, context) {
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        const tree = new (0, $djcbG.default)(this.schema, sanitizedWikiMarkup);
        return tree.getProseMirrorModel(this.buildContext($4011ad83704160d6$var$normalizeContextObject(context)));
    }
    buildContext(context) {
        return context ? {
            ...context,
            issueKeyRegex: context.conversion ? (0, $bOMPB.buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
        } : {};
    }
}
/**
 * Turns mentionConversion object keys to lowercase for case insensitivity matching
 * This is okay, because conversion context object contains mapping and that should be case insensitive
 */ const $4011ad83704160d6$var$normalizeContextObject = (context)=>{
    if (!context || !context.conversion || !context.conversion.mentionConversion) // nothing to normalize, return original object
    return context;
    const mentionConversion = {};
    // eslint-disable-next-line guard-for-in
    for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
    context.conversion.mentionConversion = mentionConversion;
    return context;
};
var $4011ad83704160d6$export$2e2bcd8739ae039 = $4011ad83704160d6$export$caaa00407b56b900;

});
parcelRegister("lxtC7", function(module, exports) {

$parcel$export(module.exports, "encode", () => $f10f1fd2bcfd2732$export$c564cdbbe6da493);

var $03QYI = parcelRequire("03QYI");

var $6ises = parcelRequire("6ises");

var $hgytR = parcelRequire("hgytR");

var $b6sEJ = parcelRequire("b6sEJ");

var $73kPn = parcelRequire("73kPn");

var $1B6CN = parcelRequire("1B6CN");

var $8UMD2 = parcelRequire("8UMD2");

var $fIzNZ = parcelRequire("fIzNZ");

var $eTlm6 = parcelRequire("eTlm6");

var $6obXI = parcelRequire("6obXI");

var $h9tzi = parcelRequire("h9tzi");

var $abXFq = parcelRequire("abXFq");

var $flJtr = parcelRequire("flJtr");

var $czgKo = parcelRequire("czgKo");

var $acqkf = parcelRequire("acqkf");

var $1Nefo = parcelRequire("1Nefo");

var $69N10 = parcelRequire("69N10");

var $12A17 = parcelRequire("12A17");

var $bsbI5 = parcelRequire("bsbI5");
const $f10f1fd2bcfd2732$var$nodeEncoderMapping = {
    blockquote: $03QYI.blockquote,
    bulletList: $6ises.bulletList,
    taskList: $hgytR.taskList,
    decisionList: $b6sEJ.decisionList,
    codeBlock: $73kPn.codeBlock,
    doc: $1B6CN.doc,
    heading: $fIzNZ.heading,
    caption: $bsbI5.caption,
    mediaGroup: $eTlm6.mediaGroup,
    mediaInline: $6obXI.mediaInline,
    mediaSingle: (0, $eTlm6.mediaGroup),
    orderedList: $h9tzi.orderedList,
    panel: $abXFq.panel,
    paragraph: $flJtr.paragraph,
    rule: $czgKo.rule,
    table: $acqkf.table,
    blockCard: $69N10.blockCard,
    embedCard: $12A17.embedCard,
    expand: $8UMD2.expand
};
function $f10f1fd2bcfd2732$export$c564cdbbe6da493(node, context) {
    const encoder = $f10f1fd2bcfd2732$var$nodeEncoderMapping[node.type.name];
    try {
        if (encoder) return encoder(node, {
            context: context
        });
        return (0, $1Nefo.unknown)(node);
    } catch (err) {
        return (0, $1Nefo.unknown)(node);
    }
}

});
parcelRegister("03QYI", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $f393e710d4117486$export$67dc04e652a298ca);

var $lxtC7 = parcelRequire("lxtC7");
const $f393e710d4117486$export$67dc04e652a298ca = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return `{quote}${result.join('\n\n')}{quote}`;
};

});

parcelRegister("6ises", function(module, exports) {

$parcel$export(module.exports, "bulletList", () => $92e38ddcaccbcaf0$export$a140c94e5ea26bee);

var $bxtEu = parcelRequire("bxtEu");
const $92e38ddcaccbcaf0$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $bxtEu.listItem)(item, '*', context));
    });
    return result.join('\n');
};

});
parcelRegister("bxtEu", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $b39a87ae4fdec39c$export$76c7e83ecc9cdf05);

var $lxtC7 = parcelRequire("lxtC7");

var $flJtr = parcelRequire("flJtr");

var $1Nefo = parcelRequire("1Nefo");

var $73kPn = parcelRequire("73kPn");

var $eTlm6 = parcelRequire("eTlm6");

var $6obXI = parcelRequire("6obXI");
const $b39a87ae4fdec39c$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
    const result = [];
    let contentBuffer = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'paragraph':
                contentBuffer.push((0, $flJtr.paragraph)(n, {
                    context: context
                }));
                break;
            case 'bulletList':
            case 'orderedList':
                {
                    if (contentBuffer.length) {
                        result.push(`${prefix} ${contentBuffer.join('\n')}`);
                        contentBuffer = [];
                    }
                    const nestedList = (0, $lxtC7.encode)(n, context).split('\n').map((line)=>{
                        if ([
                            '#',
                            '*'
                        ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                        return line;
                    }).join('\n');
                    result.push(nestedList);
                    break;
                }
            case 'codeBlock':
                contentBuffer.push((0, $73kPn.codeBlock)(n));
                break;
            case 'mediaInline':
                contentBuffer.push((0, $6obXI.mediaInline)(n, {
                    context: context
                }));
                break;
            case 'mediaSingle':
                // mediaSingle and mediaGroup are holding the same conversion logic
                contentBuffer.push((0, $eTlm6.mediaGroup)(n, {
                    context: context
                }));
                break;
            default:
                contentBuffer.push((0, $1Nefo.unknown)(n));
        }
    });
    if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
    return result.join('\n');
};

});
parcelRegister("flJtr", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3fb83d21e304518d$export$9c206ddddb32a9b);

var $bK2QZ = parcelRequire("bK2QZ");
const $3fb83d21e304518d$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            context: context
        });
    });
    return result;
};

});
parcelRegister("bK2QZ", function(module, exports) {

$parcel$export(module.exports, "inlines", () => $d36b73d9ad63ab63$export$96c94bfc00b85760);

var $91ILy = parcelRequire("91ILy");

var $e34Iq = parcelRequire("e34Iq");

var $6obXI = parcelRequire("6obXI");

var $7GCbZ = parcelRequire("7GCbZ");

var $6ayzl = parcelRequire("6ayzl");

var $5IuwX = parcelRequire("5IuwX");

var $1HDja = parcelRequire("1HDja");

var $1Nefo = parcelRequire("1Nefo");

var $c08Yp = parcelRequire("c08Yp");
const $d36b73d9ad63ab63$var$inlinesEncoderMapping = {
    emoji: $91ILy.emoji,
    hardBreak: $e34Iq.hardBreak,
    mediaInline: $6obXI.mediaInline,
    mention: $7GCbZ.mention,
    text: $6ayzl.text,
    inlineCard: $5IuwX.inlineCard,
    status: $1HDja.status,
    date: $c08Yp.date
};
const $d36b73d9ad63ab63$export$96c94bfc00b85760 = (node, opts)=>{
    const encoder = $d36b73d9ad63ab63$var$inlinesEncoderMapping[node.type.name];
    if (encoder) return encoder(node, opts);
    return (0, $1Nefo.unknown)(node);
};

});
parcelRegister("91ILy", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $15d1256cf1644afa$export$a19185d1233fc4b2);

var $g5UJK = parcelRequire("g5UJK");

var $1Nefo = parcelRequire("1Nefo");
const $15d1256cf1644afa$export$a19185d1233fc4b2 = (node)=>{
    const value = (0, $g5UJK.mapping)[node.attrs.id];
    if (value) return value;
    if (node.attrs.shortName) return node.attrs.shortName;
    return (0, $1Nefo.unknown)(node);
};

});
parcelRegister("g5UJK", function(module, exports) {

$parcel$export(module.exports, "mapping", () => $c03ab45b5b0f3a2b$export$83e1f26587c4acd2);
const $c03ab45b5b0f3a2b$export$83e1f26587c4acd2 = {
    '1f600': "\uD83D\uDE00",
    '1f603': "\uD83D\uDE03",
    '1f604': "\uD83D\uDE04",
    '1f601': "\uD83D\uDE01",
    '1f606': "\uD83D\uDE06",
    '1f605': "\uD83D\uDE05",
    '1f602': "\uD83D\uDE02",
    '1f923': "\uD83E\uDD23",
    '263a': "\u263A\uFE0F",
    '1f60a': "\uD83D\uDE0A",
    '1f607': "\uD83D\uDE07",
    '1f642': "\uD83D\uDE42",
    '1f643': "\uD83D\uDE43",
    '1f609': "\uD83D\uDE09",
    '1f60c': "\uD83D\uDE0C",
    '1f60d': "\uD83D\uDE0D",
    '1f618': "\uD83D\uDE18",
    '1f617': "\uD83D\uDE17",
    '1f619': "\uD83D\uDE19",
    '1f61a': "\uD83D\uDE1A",
    '1f60b': "\uD83D\uDE0B",
    '1f61c': "\uD83D\uDE1C",
    '1f61d': "\uD83D\uDE1D",
    '1f61b': "\uD83D\uDE1B",
    '1f911': "\uD83E\uDD11",
    '1f917': "\uD83E\uDD17",
    '1f913': "\uD83E\uDD13",
    '1f60e': "\uD83D\uDE0E",
    '1f921': "\uD83E\uDD21",
    '1f920': "\uD83E\uDD20",
    '1f60f': "\uD83D\uDE0F",
    '1f612': "\uD83D\uDE12",
    '1f61e': "\uD83D\uDE1E",
    '1f614': "\uD83D\uDE14",
    '1f61f': "\uD83D\uDE1F",
    '1f615': "\uD83D\uDE15",
    '1f641': "\uD83D\uDE41",
    '2639': "\u2639\uFE0F",
    '1f623': "\uD83D\uDE23",
    '1f616': "\uD83D\uDE16",
    '1f62b': "\uD83D\uDE2B",
    '1f629': "\uD83D\uDE29",
    '1f624': "\uD83D\uDE24",
    '1f620': "\uD83D\uDE20",
    '1f621': "\uD83D\uDE21",
    '1f636': "\uD83D\uDE36",
    '1f610': "\uD83D\uDE10",
    '1f611': "\uD83D\uDE11",
    '1f62f': "\uD83D\uDE2F",
    '1f626': "\uD83D\uDE26",
    '1f627': "\uD83D\uDE27",
    '1f62e': "\uD83D\uDE2E",
    '1f632': "\uD83D\uDE32",
    '1f635': "\uD83D\uDE35",
    '1f633': "\uD83D\uDE33",
    '1f631': "\uD83D\uDE31",
    '1f628': "\uD83D\uDE28",
    '1f630': "\uD83D\uDE30",
    '1f622': "\uD83D\uDE22",
    '1f625': "\uD83D\uDE25",
    '1f924': "\uD83E\uDD24",
    '1f62d': "\uD83D\uDE2D",
    '1f613': "\uD83D\uDE13",
    '1f62a': "\uD83D\uDE2A",
    '1f634': "\uD83D\uDE34",
    '1f644': "\uD83D\uDE44",
    '1f914': "\uD83E\uDD14",
    '1f925': "\uD83E\uDD25",
    '1f62c': "\uD83D\uDE2C",
    '1f910': "\uD83E\uDD10",
    '1f922': "\uD83E\uDD22",
    '1f927': "\uD83E\uDD27",
    '1f637': "\uD83D\uDE37",
    '1f912': "\uD83E\uDD12",
    '1f915': "\uD83E\uDD15",
    '1f608': "\uD83D\uDE08",
    '1f47f': "\uD83D\uDC7F",
    '1f479': "\uD83D\uDC79",
    '1f47a': "\uD83D\uDC7A",
    '1f4a9': "\uD83D\uDCA9",
    '1f47b': "\uD83D\uDC7B",
    '1f480': "\uD83D\uDC80",
    '2620': "\u2620\uFE0F",
    '1f47d': "\uD83D\uDC7D",
    '1f47e': "\uD83D\uDC7E",
    '1f916': "\uD83E\uDD16",
    '1f383': "\uD83C\uDF83",
    '1f63a': "\uD83D\uDE3A",
    '1f638': "\uD83D\uDE38",
    '1f639': "\uD83D\uDE39",
    '1f63b': "\uD83D\uDE3B",
    '1f63c': "\uD83D\uDE3C",
    '1f63d': "\uD83D\uDE3D",
    '1f640': "\uD83D\uDE40",
    '1f63f': "\uD83D\uDE3F",
    '1f63e': "\uD83D\uDE3E",
    '1f450': "\uD83D\uDC50",
    '1f64c': "\uD83D\uDE4C",
    '1f44f': "\uD83D\uDC4F",
    '1f64f': "\uD83D\uDE4F",
    '1f91d': "\uD83E\uDD1D",
    '1f44d': "\uD83D\uDC4D",
    '1f44e': "\uD83D\uDC4E",
    '1f44a': "\uD83D\uDC4A",
    '270a': "\u270A",
    '1f91b': "\uD83E\uDD1B",
    '1f91c': "\uD83E\uDD1C",
    '1f91e': "\uD83E\uDD1E",
    '270c': "\u270C\uFE0F",
    '1f918': "\uD83E\uDD18",
    '1f44c': "\uD83D\uDC4C",
    '1f448': "\uD83D\uDC48",
    '1f449': "\uD83D\uDC49",
    '1f446': "\uD83D\uDC46",
    '1f447': "\uD83D\uDC47",
    '261d': "\u261D\uFE0F",
    '270b': "\u270B",
    '1f91a': "\uD83E\uDD1A",
    '1f590': "\uD83D\uDD90\uFE0F",
    '1f596': "\uD83D\uDD96",
    '1f44b': "\uD83D\uDC4B",
    '1f919': "\uD83E\uDD19",
    '1f4aa': "\uD83D\uDCAA",
    '1f595': "\uD83D\uDD95",
    '270d': "\u270D\uFE0F",
    '1f933': "\uD83E\uDD33",
    '1f485': "\uD83D\uDC85",
    '1f48d': "\uD83D\uDC8D",
    '1f484': "\uD83D\uDC84",
    '1f48b': "\uD83D\uDC8B",
    '1f444': "\uD83D\uDC44",
    '1f445': "\uD83D\uDC45",
    '1f442': "\uD83D\uDC42",
    '1f443': "\uD83D\uDC43",
    '1f463': "\uD83D\uDC63",
    '1f441': "\uD83D\uDC41\uFE0F",
    '1f440': "\uD83D\uDC40",
    '1f5e3': "\uD83D\uDDE3\uFE0F",
    '1f464': "\uD83D\uDC64",
    '1f465': "\uD83D\uDC65",
    '1f476': "\uD83D\uDC76",
    '1f466': "\uD83D\uDC66",
    '1f467': "\uD83D\uDC67",
    '1f468': "\uD83D\uDC68",
    '1f469': "\uD83D\uDC69",
    '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
    '1f471': "\uD83D\uDC71",
    '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
    '1f474': "\uD83D\uDC74",
    '1f475': "\uD83D\uDC75",
    '1f472': "\uD83D\uDC72",
    '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
    '1f473': "\uD83D\uDC73",
    '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
    '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
    '1f46e': "\uD83D\uDC6E",
    '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
    '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
    '1f477': "\uD83D\uDC77",
    '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
    '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
    '1f482': "\uD83D\uDC82",
    '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
    '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
    '1f575': "\uD83D\uDD75\uFE0F",
    '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
    '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
    '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
    '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
    '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
    '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
    '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
    '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
    '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
    '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
    '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
    '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
    '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
    '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
    '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
    '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
    '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
    '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
    '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
    '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
    '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
    '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
    '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
    '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
    '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
    '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
    '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
    '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
    '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
    '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
    '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
    '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
    '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
    '1f936': "\uD83E\uDD36",
    '1f385': "\uD83C\uDF85",
    '1f478': "\uD83D\uDC78",
    '1f934': "\uD83E\uDD34",
    '1f470': "\uD83D\uDC70",
    '1f935': "\uD83E\uDD35",
    '1f47c': "\uD83D\uDC7C",
    '1f930': "\uD83E\uDD30",
    '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
    '1f647': "\uD83D\uDE47",
    '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
    '1f481': "\uD83D\uDC81",
    '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
    '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
    '1f645': "\uD83D\uDE45",
    '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
    '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
    '1f646': "\uD83D\uDE46",
    '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
    '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
    '1f64b': "\uD83D\uDE4B",
    '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
    '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
    '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
    '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
    '1f926': "\uD83E\uDD26",
    '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
    '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
    '1f937': "\uD83E\uDD37",
    '1f64e': "\uD83D\uDE4E",
    '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
    '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
    '1f64d': "\uD83D\uDE4D",
    '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
    '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
    '1f487': "\uD83D\uDC87",
    '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
    '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
    '1f486': "\uD83D\uDC86",
    '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
    '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
    '1f574': "\uD83D\uDD74\uFE0F",
    '1f483': "\uD83D\uDC83",
    '1f57a': "\uD83D\uDD7A",
    '1f46f': "\uD83D\uDC6F",
    '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
    '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
    '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
    '1f6b6': "\uD83D\uDEB6",
    '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
    '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
    '1f3c3': "\uD83C\uDFC3",
    '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
    '1f46b': "\uD83D\uDC6B",
    '1f46d': "\uD83D\uDC6D",
    '1f46c': "\uD83D\uDC6C",
    '1f491': "\uD83D\uDC91",
    '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f48f': "\uD83D\uDC8F",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f46a': "\uD83D\uDC6A",
    '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f45a': "\uD83D\uDC5A",
    '1f455': "\uD83D\uDC55",
    '1f456': "\uD83D\uDC56",
    '1f454': "\uD83D\uDC54",
    '1f457': "\uD83D\uDC57",
    '1f459': "\uD83D\uDC59",
    '1f458': "\uD83D\uDC58",
    '1f460': "\uD83D\uDC60",
    '1f461': "\uD83D\uDC61",
    '1f462': "\uD83D\uDC62",
    '1f45e': "\uD83D\uDC5E",
    '1f45f': "\uD83D\uDC5F",
    '1f452': "\uD83D\uDC52",
    '1f3a9': "\uD83C\uDFA9",
    '1f393': "\uD83C\uDF93",
    '1f451': "\uD83D\uDC51",
    '26d1': "\u26D1\uFE0F",
    '1f392': "\uD83C\uDF92",
    '1f45d': "\uD83D\uDC5D",
    '1f45b': "\uD83D\uDC5B",
    '1f45c': "\uD83D\uDC5C",
    '1f4bc': "\uD83D\uDCBC",
    '1f453': "\uD83D\uDC53",
    '1f576': "\uD83D\uDD76\uFE0F",
    '1f302': "\uD83C\uDF02",
    '2602': "\u2602\uFE0F",
    '1f436': "\uD83D\uDC36",
    '1f431': "\uD83D\uDC31",
    '1f42d': "\uD83D\uDC2D",
    '1f439': "\uD83D\uDC39",
    '1f430': "\uD83D\uDC30",
    '1f98a': "\uD83E\uDD8A",
    '1f43b': "\uD83D\uDC3B",
    '1f43c': "\uD83D\uDC3C",
    '1f428': "\uD83D\uDC28",
    '1f42f': "\uD83D\uDC2F",
    '1f981': "\uD83E\uDD81",
    '1f42e': "\uD83D\uDC2E",
    '1f437': "\uD83D\uDC37",
    '1f43d': "\uD83D\uDC3D",
    '1f438': "\uD83D\uDC38",
    '1f435': "\uD83D\uDC35",
    '1f648': "\uD83D\uDE48",
    '1f649': "\uD83D\uDE49",
    '1f64a': "\uD83D\uDE4A",
    '1f412': "\uD83D\uDC12",
    '1f414': "\uD83D\uDC14",
    '1f427': "\uD83D\uDC27",
    '1f426': "\uD83D\uDC26",
    '1f424': "\uD83D\uDC24",
    '1f423': "\uD83D\uDC23",
    '1f425': "\uD83D\uDC25",
    '1f986': "\uD83E\uDD86",
    '1f985': "\uD83E\uDD85",
    '1f989': "\uD83E\uDD89",
    '1f987': "\uD83E\uDD87",
    '1f43a': "\uD83D\uDC3A",
    '1f417': "\uD83D\uDC17",
    '1f434': "\uD83D\uDC34",
    '1f984': "\uD83E\uDD84",
    '1f41d': "\uD83D\uDC1D",
    '1f41b': "\uD83D\uDC1B",
    '1f98b': "\uD83E\uDD8B",
    '1f40c': "\uD83D\uDC0C",
    '1f41a': "\uD83D\uDC1A",
    '1f41e': "\uD83D\uDC1E",
    '1f41c': "\uD83D\uDC1C",
    '1f577': "\uD83D\uDD77\uFE0F",
    '1f578': "\uD83D\uDD78\uFE0F",
    '1f422': "\uD83D\uDC22",
    '1f40d': "\uD83D\uDC0D",
    '1f98e': "\uD83E\uDD8E",
    '1f982': "\uD83E\uDD82",
    '1f980': "\uD83E\uDD80",
    '1f991': "\uD83E\uDD91",
    '1f419': "\uD83D\uDC19",
    '1f990': "\uD83E\uDD90",
    '1f420': "\uD83D\uDC20",
    '1f41f': "\uD83D\uDC1F",
    '1f421': "\uD83D\uDC21",
    '1f42c': "\uD83D\uDC2C",
    '1f988': "\uD83E\uDD88",
    '1f433': "\uD83D\uDC33",
    '1f40b': "\uD83D\uDC0B",
    '1f40a': "\uD83D\uDC0A",
    '1f406': "\uD83D\uDC06",
    '1f405': "\uD83D\uDC05",
    '1f403': "\uD83D\uDC03",
    '1f402': "\uD83D\uDC02",
    '1f404': "\uD83D\uDC04",
    '1f98c': "\uD83E\uDD8C",
    '1f42a': "\uD83D\uDC2A",
    '1f42b': "\uD83D\uDC2B",
    '1f418': "\uD83D\uDC18",
    '1f98f': "\uD83E\uDD8F",
    '1f98d': "\uD83E\uDD8D",
    '1f40e': "\uD83D\uDC0E",
    '1f416': "\uD83D\uDC16",
    '1f410': "\uD83D\uDC10",
    '1f40f': "\uD83D\uDC0F",
    '1f411': "\uD83D\uDC11",
    '1f415': "\uD83D\uDC15",
    '1f429': "\uD83D\uDC29",
    '1f408': "\uD83D\uDC08",
    '1f413': "\uD83D\uDC13",
    '1f983': "\uD83E\uDD83",
    '1f54a': "\uD83D\uDD4A\uFE0F",
    '1f407': "\uD83D\uDC07",
    '1f401': "\uD83D\uDC01",
    '1f400': "\uD83D\uDC00",
    '1f43f': "\uD83D\uDC3F\uFE0F",
    '1f43e': "\uD83D\uDC3E",
    '1f409': "\uD83D\uDC09",
    '1f432': "\uD83D\uDC32",
    '1f335': "\uD83C\uDF35",
    '1f384': "\uD83C\uDF84",
    '1f332': "\uD83C\uDF32",
    '1f333': "\uD83C\uDF33",
    '1f334': "\uD83C\uDF34",
    '1f331': "\uD83C\uDF31",
    '1f33f': "\uD83C\uDF3F",
    '2618': "\u2618\uFE0F",
    '1f340': "\uD83C\uDF40",
    '1f38d': "\uD83C\uDF8D",
    '1f38b': "\uD83C\uDF8B",
    '1f343': "\uD83C\uDF43",
    '1f342': "\uD83C\uDF42",
    '1f341': "\uD83C\uDF41",
    '1f344': "\uD83C\uDF44",
    '1f33e': "\uD83C\uDF3E",
    '1f490': "\uD83D\uDC90",
    '1f337': "\uD83C\uDF37",
    '1f339': "\uD83C\uDF39",
    '1f940': "\uD83E\uDD40",
    '1f33b': "\uD83C\uDF3B",
    '1f33c': "\uD83C\uDF3C",
    '1f338': "\uD83C\uDF38",
    '1f33a': "\uD83C\uDF3A",
    '1f30e': "\uD83C\uDF0E",
    '1f30d': "\uD83C\uDF0D",
    '1f30f': "\uD83C\uDF0F",
    '1f315': "\uD83C\uDF15",
    '1f316': "\uD83C\uDF16",
    '1f317': "\uD83C\uDF17",
    '1f318': "\uD83C\uDF18",
    '1f311': "\uD83C\uDF11",
    '1f312': "\uD83C\uDF12",
    '1f313': "\uD83C\uDF13",
    '1f314': "\uD83C\uDF14",
    '1f31a': "\uD83C\uDF1A",
    '1f31d': "\uD83C\uDF1D",
    '1f31e': "\uD83C\uDF1E",
    '1f31b': "\uD83C\uDF1B",
    '1f31c': "\uD83C\uDF1C",
    '1f319': "\uD83C\uDF19",
    '1f4ab': "\uD83D\uDCAB",
    '2b50': "\u2B50",
    '1f31f': "\uD83C\uDF1F",
    '2728': "\u2728",
    '26a1': "\u26A1",
    '1f525': "\uD83D\uDD25",
    '1f4a5': "\uD83D\uDCA5",
    '2604': "\u2604\uFE0F",
    '2600': "\u2600\uFE0F",
    '1f324': "\uD83C\uDF24\uFE0F",
    '26c5': "\u26C5",
    '1f325': "\uD83C\uDF25\uFE0F",
    '1f326': "\uD83C\uDF26\uFE0F",
    '1f308': "\uD83C\uDF08",
    '2601': "\u2601\uFE0F",
    '1f327': "\uD83C\uDF27\uFE0F",
    '26c8': "\u26C8\uFE0F",
    '1f329': "\uD83C\uDF29\uFE0F",
    '1f328': "\uD83C\uDF28\uFE0F",
    '2603': "\u2603\uFE0F",
    '26c4': "\u26C4",
    '2744': "\u2744\uFE0F",
    '1f32c': "\uD83C\uDF2C\uFE0F",
    '1f4a8': "\uD83D\uDCA8",
    '1f32a': "\uD83C\uDF2A\uFE0F",
    '1f32b': "\uD83C\uDF2B\uFE0F",
    '1f30a': "\uD83C\uDF0A",
    '1f4a7': "\uD83D\uDCA7",
    '1f4a6': "\uD83D\uDCA6",
    '2614': "\u2614",
    '1f992': "\uD83E\uDD92",
    '1f993': "\uD83E\uDD93",
    '1f994': "\uD83E\uDD94",
    '1f995': "\uD83E\uDD95",
    '1f996': "\uD83E\uDD96",
    '1f997': "\uD83E\uDD97",
    '1f34f': "\uD83C\uDF4F",
    '1f34e': "\uD83C\uDF4E",
    '1f350': "\uD83C\uDF50",
    '1f34a': "\uD83C\uDF4A",
    '1f34b': "\uD83C\uDF4B",
    '1f34c': "\uD83C\uDF4C",
    '1f349': "\uD83C\uDF49",
    '1f347': "\uD83C\uDF47",
    '1f353': "\uD83C\uDF53",
    '1f348': "\uD83C\uDF48",
    '1f352': "\uD83C\uDF52",
    '1f351': "\uD83C\uDF51",
    '1f34d': "\uD83C\uDF4D",
    '1f95d': "\uD83E\uDD5D",
    '1f951': "\uD83E\uDD51",
    '1f345': "\uD83C\uDF45",
    '1f346': "\uD83C\uDF46",
    '1f952': "\uD83E\uDD52",
    '1f955': "\uD83E\uDD55",
    '1f33d': "\uD83C\uDF3D",
    '1f336': "\uD83C\uDF36\uFE0F",
    '1f954': "\uD83E\uDD54",
    '1f360': "\uD83C\uDF60",
    '1f330': "\uD83C\uDF30",
    '1f95c': "\uD83E\uDD5C",
    '1f36f': "\uD83C\uDF6F",
    '1f950': "\uD83E\uDD50",
    '1f35e': "\uD83C\uDF5E",
    '1f956': "\uD83E\uDD56",
    '1f9c0': "\uD83E\uDDC0",
    '1f95a': "\uD83E\uDD5A",
    '1f373': "\uD83C\uDF73",
    '1f953': "\uD83E\uDD53",
    '1f95e': "\uD83E\uDD5E",
    '1f364': "\uD83C\uDF64",
    '1f357': "\uD83C\uDF57",
    '1f356': "\uD83C\uDF56",
    '1f355': "\uD83C\uDF55",
    '1f32d': "\uD83C\uDF2D",
    '1f354': "\uD83C\uDF54",
    '1f35f': "\uD83C\uDF5F",
    '1f959': "\uD83E\uDD59",
    '1f32e': "\uD83C\uDF2E",
    '1f32f': "\uD83C\uDF2F",
    '1f957': "\uD83E\uDD57",
    '1f958': "\uD83E\uDD58",
    '1f35d': "\uD83C\uDF5D",
    '1f35c': "\uD83C\uDF5C",
    '1f372': "\uD83C\uDF72",
    '1f365': "\uD83C\uDF65",
    '1f363': "\uD83C\uDF63",
    '1f371': "\uD83C\uDF71",
    '1f35b': "\uD83C\uDF5B",
    '1f359': "\uD83C\uDF59",
    '1f35a': "\uD83C\uDF5A",
    '1f358': "\uD83C\uDF58",
    '1f362': "\uD83C\uDF62",
    '1f361': "\uD83C\uDF61",
    '1f367': "\uD83C\uDF67",
    '1f368': "\uD83C\uDF68",
    '1f366': "\uD83C\uDF66",
    '1f370': "\uD83C\uDF70",
    '1f382': "\uD83C\uDF82",
    '1f36e': "\uD83C\uDF6E",
    '1f36d': "\uD83C\uDF6D",
    '1f36c': "\uD83C\uDF6C",
    '1f36b': "\uD83C\uDF6B",
    '1f37f': "\uD83C\uDF7F",
    '1f369': "\uD83C\uDF69",
    '1f36a': "\uD83C\uDF6A",
    '1f95b': "\uD83E\uDD5B",
    '1f37c': "\uD83C\uDF7C",
    '2615': "\u2615",
    '1f375': "\uD83C\uDF75",
    '1f376': "\uD83C\uDF76",
    '1f37a': "\uD83C\uDF7A",
    '1f37b': "\uD83C\uDF7B",
    '1f942': "\uD83E\uDD42",
    '1f377': "\uD83C\uDF77",
    '1f943': "\uD83E\uDD43",
    '1f378': "\uD83C\uDF78",
    '1f379': "\uD83C\uDF79",
    '1f37e': "\uD83C\uDF7E",
    '1f944': "\uD83E\uDD44",
    '1f374': "\uD83C\uDF74",
    '1f37d': "\uD83C\uDF7D\uFE0F",
    '1f95f': "\uD83E\uDD5F",
    '1f960': "\uD83E\uDD60",
    '1f961': "\uD83E\uDD61",
    '1f962': "\uD83E\uDD62",
    '1f963': "\uD83E\uDD63",
    '1f964': "\uD83E\uDD64",
    '1f965': "\uD83E\uDD65",
    '1f966': "\uD83E\uDD66",
    '1f967': "\uD83E\uDD67",
    '1f968': "\uD83E\uDD68",
    '1f969': "\uD83E\uDD69",
    '1f96a': "\uD83E\uDD6A",
    '1f96b': "\uD83E\uDD6B",
    '26bd': "\u26BD",
    '1f3c0': "\uD83C\uDFC0",
    '1f3c8': "\uD83C\uDFC8",
    '26be': "\u26BE",
    '1f3be': "\uD83C\uDFBE",
    '1f3d0': "\uD83C\uDFD0",
    '1f3c9': "\uD83C\uDFC9",
    '1f3b1': "\uD83C\uDFB1",
    '1f3d3': "\uD83C\uDFD3",
    '1f3f8': "\uD83C\uDFF8",
    '1f945': "\uD83E\uDD45",
    '1f3d2': "\uD83C\uDFD2",
    '1f3d1': "\uD83C\uDFD1",
    '1f3cf': "\uD83C\uDFCF",
    '26f3': "\u26F3",
    '1f3f9': "\uD83C\uDFF9",
    '1f3a3': "\uD83C\uDFA3",
    '1f94a': "\uD83E\uDD4A",
    '1f94b': "\uD83E\uDD4B",
    '26f8': "\u26F8\uFE0F",
    '1f3bf': "\uD83C\uDFBF",
    '26f7': "\u26F7\uFE0F",
    '1f3c2': "\uD83C\uDFC2",
    '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
    '1f3cb': "\uD83C\uDFCB\uFE0F",
    '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
    '1f93a': "\uD83E\uDD3A",
    '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
    '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
    '1f93c': "\uD83E\uDD3C",
    '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
    '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
    '1f938': "\uD83E\uDD38",
    '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
    '26f9': "\u26F9\uFE0F",
    '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
    '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
    '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
    '1f93e': "\uD83E\uDD3E",
    '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
    '1f3cc': "\uD83C\uDFCC\uFE0F",
    '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
    '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
    '1f3c4': "\uD83C\uDFC4",
    '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
    '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
    '1f3ca': "\uD83C\uDFCA",
    '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
    '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
    '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
    '1f93d': "\uD83E\uDD3D",
    '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
    '1f6a3': "\uD83D\uDEA3",
    '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
    '1f3c7': "\uD83C\uDFC7",
    '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
    '1f6b4': "\uD83D\uDEB4",
    '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
    '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
    '1f6b5': "\uD83D\uDEB5",
    '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
    '1f3bd': "\uD83C\uDFBD",
    '1f3c5': "\uD83C\uDFC5",
    '1f396': "\uD83C\uDF96\uFE0F",
    '1f947': "\uD83E\uDD47",
    '1f948': "\uD83E\uDD48",
    '1f949': "\uD83E\uDD49",
    '1f3c6': "\uD83C\uDFC6",
    '1f3f5': "\uD83C\uDFF5\uFE0F",
    '1f397': "\uD83C\uDF97\uFE0F",
    '1f3ab': "\uD83C\uDFAB",
    '1f39f': "\uD83C\uDF9F\uFE0F",
    '1f3aa': "\uD83C\uDFAA",
    '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
    '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
    '1f939': "\uD83E\uDD39",
    '1f3ad': "\uD83C\uDFAD",
    '1f3a8': "\uD83C\uDFA8",
    '1f3ac': "\uD83C\uDFAC",
    '1f3a4': "\uD83C\uDFA4",
    '1f3a7': "\uD83C\uDFA7",
    '1f3bc': "\uD83C\uDFBC",
    '1f3b9': "\uD83C\uDFB9",
    '1f941': "\uD83E\uDD41",
    '1f3b7': "\uD83C\uDFB7",
    '1f3ba': "\uD83C\uDFBA",
    '1f3b8': "\uD83C\uDFB8",
    '1f3bb': "\uD83C\uDFBB",
    '1f3b2': "\uD83C\uDFB2",
    '1f3af': "\uD83C\uDFAF",
    '1f3b3': "\uD83C\uDFB3",
    '1f3ae': "\uD83C\uDFAE",
    '1f3b0': "\uD83C\uDFB0",
    '1f6f7': "\uD83D\uDEF7",
    '1f931': "\uD83E\uDD31",
    '1f94c': "\uD83E\uDD4C",
    '1f9d6': "\uD83E\uDDD6",
    '1f9d7': "\uD83E\uDDD7",
    '1f9d8': "\uD83E\uDDD8",
    '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
    '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
    '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
    '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
    '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
    '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
    '1f697': "\uD83D\uDE97",
    '1f695': "\uD83D\uDE95",
    '1f699': "\uD83D\uDE99",
    '1f68c': "\uD83D\uDE8C",
    '1f68e': "\uD83D\uDE8E",
    '1f3ce': "\uD83C\uDFCE\uFE0F",
    '1f693': "\uD83D\uDE93",
    '1f691': "\uD83D\uDE91",
    '1f692': "\uD83D\uDE92",
    '1f690': "\uD83D\uDE90",
    '1f69a': "\uD83D\uDE9A",
    '1f69b': "\uD83D\uDE9B",
    '1f69c': "\uD83D\uDE9C",
    '1f6f4': "\uD83D\uDEF4",
    '1f6b2': "\uD83D\uDEB2",
    '1f6f5': "\uD83D\uDEF5",
    '1f3cd': "\uD83C\uDFCD\uFE0F",
    '1f6a8': "\uD83D\uDEA8",
    '1f694': "\uD83D\uDE94",
    '1f68d': "\uD83D\uDE8D",
    '1f698': "\uD83D\uDE98",
    '1f696': "\uD83D\uDE96",
    '1f6a1': "\uD83D\uDEA1",
    '1f6a0': "\uD83D\uDEA0",
    '1f69f': "\uD83D\uDE9F",
    '1f683': "\uD83D\uDE83",
    '1f68b': "\uD83D\uDE8B",
    '1f69e': "\uD83D\uDE9E",
    '1f69d': "\uD83D\uDE9D",
    '1f684': "\uD83D\uDE84",
    '1f685': "\uD83D\uDE85",
    '1f688': "\uD83D\uDE88",
    '1f682': "\uD83D\uDE82",
    '1f686': "\uD83D\uDE86",
    '1f687': "\uD83D\uDE87",
    '1f68a': "\uD83D\uDE8A",
    '1f689': "\uD83D\uDE89",
    '1f681': "\uD83D\uDE81",
    '1f6e9': "\uD83D\uDEE9\uFE0F",
    '2708': "\u2708\uFE0F",
    '1f6eb': "\uD83D\uDEEB",
    '1f6ec': "\uD83D\uDEEC",
    '1f680': "\uD83D\uDE80",
    '1f6f0': "\uD83D\uDEF0\uFE0F",
    '1f4ba': "\uD83D\uDCBA",
    '1f6f6': "\uD83D\uDEF6",
    '26f5': "\u26F5",
    '1f6e5': "\uD83D\uDEE5\uFE0F",
    '1f6a4': "\uD83D\uDEA4",
    '1f6f3': "\uD83D\uDEF3\uFE0F",
    '26f4': "\u26F4\uFE0F",
    '1f6a2': "\uD83D\uDEA2",
    '2693': "\u2693",
    '1f6a7': "\uD83D\uDEA7",
    '26fd': "\u26FD",
    '1f68f': "\uD83D\uDE8F",
    '1f6a6': "\uD83D\uDEA6",
    '1f6a5': "\uD83D\uDEA5",
    '1f5fa': "\uD83D\uDDFA\uFE0F",
    '1f5ff': "\uD83D\uDDFF",
    '1f5fd': "\uD83D\uDDFD",
    '26f2': "\u26F2",
    '1f5fc': "\uD83D\uDDFC",
    '1f3f0': "\uD83C\uDFF0",
    '1f3ef': "\uD83C\uDFEF",
    '1f3df': "\uD83C\uDFDF\uFE0F",
    '1f3a1': "\uD83C\uDFA1",
    '1f3a2': "\uD83C\uDFA2",
    '1f3a0': "\uD83C\uDFA0",
    '26f1': "\u26F1\uFE0F",
    '1f3d6': "\uD83C\uDFD6\uFE0F",
    '1f3dd': "\uD83C\uDFDD\uFE0F",
    '26f0': "\u26F0\uFE0F",
    '1f3d4': "\uD83C\uDFD4\uFE0F",
    '1f5fb': "\uD83D\uDDFB",
    '1f30b': "\uD83C\uDF0B",
    '1f3dc': "\uD83C\uDFDC\uFE0F",
    '1f3d5': "\uD83C\uDFD5\uFE0F",
    '26fa': "\u26FA",
    '1f6e4': "\uD83D\uDEE4\uFE0F",
    '1f6e3': "\uD83D\uDEE3\uFE0F",
    '1f3d7': "\uD83C\uDFD7\uFE0F",
    '1f3ed': "\uD83C\uDFED",
    '1f3e0': "\uD83C\uDFE0",
    '1f3e1': "\uD83C\uDFE1",
    '1f3d8': "\uD83C\uDFD8\uFE0F",
    '1f3da': "\uD83C\uDFDA\uFE0F",
    '1f3e2': "\uD83C\uDFE2",
    '1f3ec': "\uD83C\uDFEC",
    '1f3e3': "\uD83C\uDFE3",
    '1f3e4': "\uD83C\uDFE4",
    '1f3e5': "\uD83C\uDFE5",
    '1f3e6': "\uD83C\uDFE6",
    '1f3e8': "\uD83C\uDFE8",
    '1f3ea': "\uD83C\uDFEA",
    '1f3eb': "\uD83C\uDFEB",
    '1f3e9': "\uD83C\uDFE9",
    '1f492': "\uD83D\uDC92",
    '1f3db': "\uD83C\uDFDB\uFE0F",
    '26ea': "\u26EA",
    '1f54c': "\uD83D\uDD4C",
    '1f54d': "\uD83D\uDD4D",
    '1f54b': "\uD83D\uDD4B",
    '26e9': "\u26E9\uFE0F",
    '1f5fe': "\uD83D\uDDFE",
    '1f391': "\uD83C\uDF91",
    '1f3de': "\uD83C\uDFDE\uFE0F",
    '1f305': "\uD83C\uDF05",
    '1f304': "\uD83C\uDF04",
    '1f320': "\uD83C\uDF20",
    '1f387': "\uD83C\uDF87",
    '1f386': "\uD83C\uDF86",
    '1f307': "\uD83C\uDF07",
    '1f306': "\uD83C\uDF06",
    '1f3d9': "\uD83C\uDFD9\uFE0F",
    '1f303': "\uD83C\uDF03",
    '1f30c': "\uD83C\uDF0C",
    '1f309': "\uD83C\uDF09",
    '1f301': "\uD83C\uDF01",
    '1f6f8': "\uD83D\uDEF8",
    '231a': "\u231A",
    '1f4f1': "\uD83D\uDCF1",
    '1f4f2': "\uD83D\uDCF2",
    '1f4bb': "\uD83D\uDCBB",
    '2328': "\u2328\uFE0F",
    '1f5a5': "\uD83D\uDDA5\uFE0F",
    '1f5a8': "\uD83D\uDDA8\uFE0F",
    '1f5b1': "\uD83D\uDDB1\uFE0F",
    '1f5b2': "\uD83D\uDDB2\uFE0F",
    '1f579': "\uD83D\uDD79\uFE0F",
    '1f5dc': "\uD83D\uDDDC\uFE0F",
    '1f4bd': "\uD83D\uDCBD",
    '1f4be': "\uD83D\uDCBE",
    '1f4bf': "\uD83D\uDCBF",
    '1f4c0': "\uD83D\uDCC0",
    '1f4fc': "\uD83D\uDCFC",
    '1f4f7': "\uD83D\uDCF7",
    '1f4f8': "\uD83D\uDCF8",
    '1f4f9': "\uD83D\uDCF9",
    '1f3a5': "\uD83C\uDFA5",
    '1f4fd': "\uD83D\uDCFD\uFE0F",
    '1f39e': "\uD83C\uDF9E\uFE0F",
    '1f4de': "\uD83D\uDCDE",
    '260e': "\u260E\uFE0F",
    '1f4df': "\uD83D\uDCDF",
    '1f4e0': "\uD83D\uDCE0",
    '1f4fa': "\uD83D\uDCFA",
    '1f4fb': "\uD83D\uDCFB",
    '1f399': "\uD83C\uDF99\uFE0F",
    '1f39a': "\uD83C\uDF9A\uFE0F",
    '1f39b': "\uD83C\uDF9B\uFE0F",
    '23f1': "\u23F1\uFE0F",
    '23f2': "\u23F2\uFE0F",
    '23f0': "\u23F0",
    '1f570': "\uD83D\uDD70\uFE0F",
    '231b': "\u231B",
    '23f3': "\u23F3",
    '1f4e1': "\uD83D\uDCE1",
    '1f50b': "\uD83D\uDD0B",
    '1f50c': "\uD83D\uDD0C",
    '1f4a1': "\uD83D\uDCA1",
    '1f526': "\uD83D\uDD26",
    '1f56f': "\uD83D\uDD6F\uFE0F",
    '1f5d1': "\uD83D\uDDD1\uFE0F",
    '1f6e2': "\uD83D\uDEE2\uFE0F",
    '1f4b8': "\uD83D\uDCB8",
    '1f4b5': "\uD83D\uDCB5",
    '1f4b4': "\uD83D\uDCB4",
    '1f4b6': "\uD83D\uDCB6",
    '1f4b7': "\uD83D\uDCB7",
    '1f4b0': "\uD83D\uDCB0",
    '1f4b3': "\uD83D\uDCB3",
    '1f48e': "\uD83D\uDC8E",
    '2696': "\u2696\uFE0F",
    '1f527': "\uD83D\uDD27",
    '1f528': "\uD83D\uDD28",
    '2692': "\u2692\uFE0F",
    '1f6e0': "\uD83D\uDEE0\uFE0F",
    '26cf': "\u26CF\uFE0F",
    '1f529': "\uD83D\uDD29",
    '2699': "\u2699\uFE0F",
    '26d3': "\u26D3\uFE0F",
    '1f52b': "\uD83D\uDD2B",
    '1f4a3': "\uD83D\uDCA3",
    '1f52a': "\uD83D\uDD2A",
    '1f5e1': "\uD83D\uDDE1\uFE0F",
    '2694': "\u2694\uFE0F",
    '1f6e1': "\uD83D\uDEE1\uFE0F",
    '1f6ac': "\uD83D\uDEAC",
    '26b0': "\u26B0\uFE0F",
    '26b1': "\u26B1\uFE0F",
    '1f3fa': "\uD83C\uDFFA",
    '1f52e': "\uD83D\uDD2E",
    '1f4ff': "\uD83D\uDCFF",
    '1f488': "\uD83D\uDC88",
    '2697': "\u2697\uFE0F",
    '1f52d': "\uD83D\uDD2D",
    '1f52c': "\uD83D\uDD2C",
    '1f573': "\uD83D\uDD73\uFE0F",
    '1f48a': "\uD83D\uDC8A",
    '1f489': "\uD83D\uDC89",
    '1f321': "\uD83C\uDF21\uFE0F",
    '1f6bd': "\uD83D\uDEBD",
    '1f6b0': "\uD83D\uDEB0",
    '1f6bf': "\uD83D\uDEBF",
    '1f6c1': "\uD83D\uDEC1",
    '1f6c0': "\uD83D\uDEC0",
    '1f6ce': "\uD83D\uDECE\uFE0F",
    '1f511': "\uD83D\uDD11",
    '1f5dd': "\uD83D\uDDDD\uFE0F",
    '1f6aa': "\uD83D\uDEAA",
    '1f6cb': "\uD83D\uDECB\uFE0F",
    '1f6cf': "\uD83D\uDECF\uFE0F",
    '1f6cc': "\uD83D\uDECC",
    '1f5bc': "\uD83D\uDDBC\uFE0F",
    '1f6cd': "\uD83D\uDECD\uFE0F",
    '1f6d2': "\uD83D\uDED2",
    '1f381': "\uD83C\uDF81",
    '1f388': "\uD83C\uDF88",
    '1f38f': "\uD83C\uDF8F",
    '1f380': "\uD83C\uDF80",
    '1f38a': "\uD83C\uDF8A",
    '1f389': "\uD83C\uDF89",
    '1f38e': "\uD83C\uDF8E",
    '1f3ee': "\uD83C\uDFEE",
    '1f390': "\uD83C\uDF90",
    '2709': "\u2709\uFE0F",
    '1f4e9': "\uD83D\uDCE9",
    '1f4e8': "\uD83D\uDCE8",
    '1f4e7': "\uD83D\uDCE7",
    '1f48c': "\uD83D\uDC8C",
    '1f4e5': "\uD83D\uDCE5",
    '1f4e4': "\uD83D\uDCE4",
    '1f4e6': "\uD83D\uDCE6",
    '1f3f7': "\uD83C\uDFF7\uFE0F",
    '1f4ea': "\uD83D\uDCEA",
    '1f4eb': "\uD83D\uDCEB",
    '1f4ec': "\uD83D\uDCEC",
    '1f4ed': "\uD83D\uDCED",
    '1f4ee': "\uD83D\uDCEE",
    '1f4ef': "\uD83D\uDCEF",
    '1f4dc': "\uD83D\uDCDC",
    '1f4c3': "\uD83D\uDCC3",
    '1f4c4': "\uD83D\uDCC4",
    '1f4d1': "\uD83D\uDCD1",
    '1f4ca': "\uD83D\uDCCA",
    '1f4c8': "\uD83D\uDCC8",
    '1f4c9': "\uD83D\uDCC9",
    '1f5d2': "\uD83D\uDDD2\uFE0F",
    '1f5d3': "\uD83D\uDDD3\uFE0F",
    '1f4c6': "\uD83D\uDCC6",
    '1f4c5': "\uD83D\uDCC5",
    '1f4c7': "\uD83D\uDCC7",
    '1f5c3': "\uD83D\uDDC3\uFE0F",
    '1f5f3': "\uD83D\uDDF3\uFE0F",
    '1f5c4': "\uD83D\uDDC4\uFE0F",
    '1f4cb': "\uD83D\uDCCB",
    '1f4c1': "\uD83D\uDCC1",
    '1f4c2': "\uD83D\uDCC2",
    '1f5c2': "\uD83D\uDDC2\uFE0F",
    '1f5de': "\uD83D\uDDDE\uFE0F",
    '1f4f0': "\uD83D\uDCF0",
    '1f4d3': "\uD83D\uDCD3",
    '1f4d4': "\uD83D\uDCD4",
    '1f4d2': "\uD83D\uDCD2",
    '1f4d5': "\uD83D\uDCD5",
    '1f4d7': "\uD83D\uDCD7",
    '1f4d8': "\uD83D\uDCD8",
    '1f4d9': "\uD83D\uDCD9",
    '1f4da': "\uD83D\uDCDA",
    '1f4d6': "\uD83D\uDCD6",
    '1f516': "\uD83D\uDD16",
    '1f517': "\uD83D\uDD17",
    '1f4ce': "\uD83D\uDCCE",
    '1f587': "\uD83D\uDD87\uFE0F",
    '1f4d0': "\uD83D\uDCD0",
    '1f4cf': "\uD83D\uDCCF",
    '1f4cc': "\uD83D\uDCCC",
    '1f4cd': "\uD83D\uDCCD",
    '2702': "\u2702\uFE0F",
    '1f58a': "\uD83D\uDD8A\uFE0F",
    '1f58b': "\uD83D\uDD8B\uFE0F",
    '2712': "\u2712\uFE0F",
    '1f58c': "\uD83D\uDD8C\uFE0F",
    '1f58d': "\uD83D\uDD8D\uFE0F",
    '1f4dd': "\uD83D\uDCDD",
    '270f': "\u270F\uFE0F",
    '1f50d': "\uD83D\uDD0D",
    '1f50e': "\uD83D\uDD0E",
    '1f50f': "\uD83D\uDD0F",
    '1f510': "\uD83D\uDD10",
    '1f512': "\uD83D\uDD12",
    '1f513': "\uD83D\uDD13",
    '1f9e1': "\uD83E\uDDE1",
    '2764': "\u2764\uFE0F",
    '1f49b': "\uD83D\uDC9B",
    '1f49a': "\uD83D\uDC9A",
    '1f499': "\uD83D\uDC99",
    '1f49c': "\uD83D\uDC9C",
    '1f5a4': "\uD83D\uDDA4",
    '1f494': "\uD83D\uDC94",
    '2763': "\u2763\uFE0F",
    '1f495': "\uD83D\uDC95",
    '1f49e': "\uD83D\uDC9E",
    '1f493': "\uD83D\uDC93",
    '1f497': "\uD83D\uDC97",
    '1f496': "\uD83D\uDC96",
    '1f498': "\uD83D\uDC98",
    '1f49d': "\uD83D\uDC9D",
    '1f49f': "\uD83D\uDC9F",
    '262e': "\u262E\uFE0F",
    '271d': "\u271D\uFE0F",
    '262a': "\u262A\uFE0F",
    '1f549': "\uD83D\uDD49\uFE0F",
    '2638': "\u2638\uFE0F",
    '2721': "\u2721\uFE0F",
    '1f52f': "\uD83D\uDD2F",
    '1f54e': "\uD83D\uDD4E",
    '262f': "\u262F\uFE0F",
    '2626': "\u2626\uFE0F",
    '1f6d0': "\uD83D\uDED0",
    '26ce': "\u26CE",
    '2648': "\u2648",
    '2649': "\u2649",
    '264a': "\u264A",
    '264b': "\u264B",
    '264c': "\u264C",
    '264d': "\u264D",
    '264e': "\u264E",
    '264f': "\u264F",
    '2650': "\u2650",
    '2651': "\u2651",
    '2652': "\u2652",
    '2653': "\u2653",
    '1f194': "\uD83C\uDD94",
    '269b': "\u269B\uFE0F",
    '1f251': "\uD83C\uDE51",
    '2622': "\u2622\uFE0F",
    '2623': "\u2623\uFE0F",
    '1f4f4': "\uD83D\uDCF4",
    '1f4f3': "\uD83D\uDCF3",
    '1f236': "\uD83C\uDE36",
    '1f21a': "\uD83C\uDE1A",
    '1f238': "\uD83C\uDE38",
    '1f23a': "\uD83C\uDE3A",
    '1f237': "\uD83C\uDE37\uFE0F",
    '2734': "\u2734\uFE0F",
    '1f19a': "\uD83C\uDD9A",
    '1f4ae': "\uD83D\uDCAE",
    '1f250': "\uD83C\uDE50",
    '3299': "\u3299\uFE0F",
    '3297': "\u3297\uFE0F",
    '1f234': "\uD83C\uDE34",
    '1f235': "\uD83C\uDE35",
    '1f239': "\uD83C\uDE39",
    '1f232': "\uD83C\uDE32",
    '1f170': "\uD83C\uDD70\uFE0F",
    '1f171': "\uD83C\uDD71\uFE0F",
    '1f18e': "\uD83C\uDD8E",
    '1f191': "\uD83C\uDD91",
    '1f17e': "\uD83C\uDD7E\uFE0F",
    '1f198': "\uD83C\uDD98",
    '274c': "\u274C",
    '2b55': "\u2B55",
    '1f6d1': "\uD83D\uDED1",
    '26d4': "\u26D4",
    '1f4db': "\uD83D\uDCDB",
    '1f6ab': "\uD83D\uDEAB",
    '1f4af': "\uD83D\uDCAF",
    '1f4a2': "\uD83D\uDCA2",
    '2668': "\u2668\uFE0F",
    '1f6b7': "\uD83D\uDEB7",
    '1f6af': "\uD83D\uDEAF",
    '1f6b3': "\uD83D\uDEB3",
    '1f6b1': "\uD83D\uDEB1",
    '1f51e': "\uD83D\uDD1E",
    '1f4f5': "\uD83D\uDCF5",
    '1f6ad': "\uD83D\uDEAD",
    '2757': "\u2757",
    '2755': "\u2755",
    '2753': "\u2753",
    '2754': "\u2754",
    '203c': "\u203C\uFE0F",
    '2049': "\u2049\uFE0F",
    '1f505': "\uD83D\uDD05",
    '1f506': "\uD83D\uDD06",
    '303d': "\u303D\uFE0F",
    '26a0': "\u26A0\uFE0F",
    '1f6b8': "\uD83D\uDEB8",
    '1f531': "\uD83D\uDD31",
    '269c': "\u269C\uFE0F",
    '1f530': "\uD83D\uDD30",
    '267b': "\u267B\uFE0F",
    '2705': "\u2705",
    '1f22f': "\uD83C\uDE2F",
    '1f4b9': "\uD83D\uDCB9",
    '2747': "\u2747\uFE0F",
    '2733': "\u2733\uFE0F",
    '274e': "\u274E",
    '1f310': "\uD83C\uDF10",
    '1f4a0': "\uD83D\uDCA0",
    '24c2': "\u24C2\uFE0F",
    '1f300': "\uD83C\uDF00",
    '1f4a4': "\uD83D\uDCA4",
    '1f3e7': "\uD83C\uDFE7",
    '1f6be': "\uD83D\uDEBE",
    '267f': "\u267F",
    '1f17f': "\uD83C\uDD7F\uFE0F",
    '1f233': "\uD83C\uDE33",
    '1f202': "\uD83C\uDE02\uFE0F",
    '1f6c2': "\uD83D\uDEC2",
    '1f6c3': "\uD83D\uDEC3",
    '1f6c4': "\uD83D\uDEC4",
    '1f6c5': "\uD83D\uDEC5",
    '1f6b9': "\uD83D\uDEB9",
    '1f6ba': "\uD83D\uDEBA",
    '1f6bc': "\uD83D\uDEBC",
    '1f6bb': "\uD83D\uDEBB",
    '1f6ae': "\uD83D\uDEAE",
    '1f3a6': "\uD83C\uDFA6",
    '1f4f6': "\uD83D\uDCF6",
    '1f201': "\uD83C\uDE01",
    '1f523': "\uD83D\uDD23",
    '2139': "\u2139\uFE0F",
    '1f524': "\uD83D\uDD24",
    '1f521': "\uD83D\uDD21",
    '1f520': "\uD83D\uDD20",
    '1f196': "\uD83C\uDD96",
    '1f197': "\uD83C\uDD97",
    '1f199': "\uD83C\uDD99",
    '1f192': "\uD83C\uDD92",
    '1f195': "\uD83C\uDD95",
    '1f193': "\uD83C\uDD93",
    '30-20e3': "0\uFE0F\u20E3",
    '31-20e3': "1\uFE0F\u20E3",
    '32-20e3': "2\uFE0F\u20E3",
    '33-20e3': "3\uFE0F\u20E3",
    '34-20e3': "4\uFE0F\u20E3",
    '35-20e3': "5\uFE0F\u20E3",
    '36-20e3': "6\uFE0F\u20E3",
    '37-20e3': "7\uFE0F\u20E3",
    '38-20e3': "8\uFE0F\u20E3",
    '39-20e3': "9\uFE0F\u20E3",
    '1f51f': "\uD83D\uDD1F",
    '1f522': "\uD83D\uDD22",
    '23-20e3': "#\uFE0F\u20E3",
    '2a-20e3': "*\uFE0F\u20E3",
    '25b6': "\u25B6\uFE0F",
    '23f8': "\u23F8\uFE0F",
    '23ef': "\u23EF\uFE0F",
    '23f9': "\u23F9\uFE0F",
    '23fa': "\u23FA\uFE0F",
    '23cf': "\u23CF\uFE0F",
    '23ed': "\u23ED\uFE0F",
    '23ee': "\u23EE\uFE0F",
    '23e9': "\u23E9",
    '23ea': "\u23EA",
    '23eb': "\u23EB",
    '23ec': "\u23EC",
    '25c0': "\u25C0\uFE0F",
    '1f53c': "\uD83D\uDD3C",
    '1f53d': "\uD83D\uDD3D",
    '27a1': "\u27A1\uFE0F",
    '2b05': "\u2B05\uFE0F",
    '2b06': "\u2B06\uFE0F",
    '2b07': "\u2B07\uFE0F",
    '2197': "\u2197\uFE0F",
    '2198': "\u2198\uFE0F",
    '2199': "\u2199\uFE0F",
    '2196': "\u2196\uFE0F",
    '2195': "\u2195\uFE0F",
    '2194': "\u2194\uFE0F",
    '21aa': "\u21AA\uFE0F",
    '21a9': "\u21A9\uFE0F",
    '2934': "\u2934\uFE0F",
    '2935': "\u2935\uFE0F",
    '1f500': "\uD83D\uDD00",
    '1f501': "\uD83D\uDD01",
    '1f502': "\uD83D\uDD02",
    '1f504': "\uD83D\uDD04",
    '1f503': "\uD83D\uDD03",
    '1f3b5': "\uD83C\uDFB5",
    '1f3b6': "\uD83C\uDFB6",
    '2795': "\u2795",
    '2796': "\u2796",
    '2797': "\u2797",
    '2716': "\u2716\uFE0F",
    '1f4b2': "\uD83D\uDCB2",
    '1f4b1': "\uD83D\uDCB1",
    '2122': "\u2122\uFE0F",
    a9: "\xa9\uFE0F",
    ae: "\xae\uFE0F",
    '3030': "\u3030\uFE0F",
    '27b0': "\u27B0",
    '27bf': "\u27BF",
    '1f51a': "\uD83D\uDD1A",
    '1f519': "\uD83D\uDD19",
    '1f51b': "\uD83D\uDD1B",
    '1f51d': "\uD83D\uDD1D",
    '1f51c': "\uD83D\uDD1C",
    '2714': "\u2714\uFE0F",
    '2611': "\u2611\uFE0F",
    '1f518': "\uD83D\uDD18",
    '26aa': "\u26AA",
    '26ab': "\u26AB",
    '1f534': "\uD83D\uDD34",
    '1f535': "\uD83D\uDD35",
    '1f53a': "\uD83D\uDD3A",
    '1f53b': "\uD83D\uDD3B",
    '1f538': "\uD83D\uDD38",
    '1f539': "\uD83D\uDD39",
    '1f536': "\uD83D\uDD36",
    '1f537': "\uD83D\uDD37",
    '1f533': "\uD83D\uDD33",
    '1f532': "\uD83D\uDD32",
    '25aa': "\u25AA\uFE0F",
    '25ab': "\u25AB\uFE0F",
    '25fe': "\u25FE",
    '25fd': "\u25FD",
    '25fc': "\u25FC\uFE0F",
    '25fb': "\u25FB\uFE0F",
    '2b1b': "\u2B1B",
    '2b1c': "\u2B1C",
    '1f508': "\uD83D\uDD08",
    '1f507': "\uD83D\uDD07",
    '1f509': "\uD83D\uDD09",
    '1f50a': "\uD83D\uDD0A",
    '1f514': "\uD83D\uDD14",
    '1f515': "\uD83D\uDD15",
    '1f4e3': "\uD83D\uDCE3",
    '1f4e2': "\uD83D\uDCE2",
    '1f5e8': "\uD83D\uDDE8\uFE0F",
    '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
    '1f4ac': "\uD83D\uDCAC",
    '1f4ad': "\uD83D\uDCAD",
    '1f5ef': "\uD83D\uDDEF\uFE0F",
    '2660': "\u2660\uFE0F",
    '2663': "\u2663\uFE0F",
    '2665': "\u2665\uFE0F",
    '2666': "\u2666\uFE0F",
    '1f0cf': "\uD83C\uDCCF",
    '1f3b4': "\uD83C\uDFB4",
    '1f004': "\uD83C\uDC04",
    '1f550': "\uD83D\uDD50",
    '1f551': "\uD83D\uDD51",
    '1f552': "\uD83D\uDD52",
    '1f553': "\uD83D\uDD53",
    '1f554': "\uD83D\uDD54",
    '1f555': "\uD83D\uDD55",
    '1f556': "\uD83D\uDD56",
    '1f557': "\uD83D\uDD57",
    '1f558': "\uD83D\uDD58",
    '1f559': "\uD83D\uDD59",
    '1f55a': "\uD83D\uDD5A",
    '1f55b': "\uD83D\uDD5B",
    '1f55c': "\uD83D\uDD5C",
    '1f55d': "\uD83D\uDD5D",
    '1f55e': "\uD83D\uDD5E",
    '1f55f': "\uD83D\uDD5F",
    '1f560': "\uD83D\uDD60",
    '1f561': "\uD83D\uDD61",
    '1f562': "\uD83D\uDD62",
    '1f563': "\uD83D\uDD63",
    '1f564': "\uD83D\uDD64",
    '1f565': "\uD83D\uDD65",
    '1f566': "\uD83D\uDD66",
    '1f567': "\uD83D\uDD67",
    '1f3f3': "\uD83C\uDFF3\uFE0F",
    '1f3f4': "\uD83C\uDFF4",
    '1f3c1': "\uD83C\uDFC1",
    '1f6a9': "\uD83D\uDEA9",
    '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
    '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
    '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
    '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
    '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
    '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
    '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
    '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
    '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
    '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
    '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
    '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
    '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
    '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
    '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
    '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
    '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
    '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
    '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
    '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
    '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
    '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
    '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
    '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
    '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
    '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
    '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
    '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
    '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
    '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
    '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
    '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
    '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
    '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
    '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
    '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
    '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
    '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
    '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
    '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
    '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
    '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
    '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
    '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
    '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
    '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
    '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
    '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
    '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
    '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
    '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
    '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
    '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
    '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
    '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
    '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
    '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
    '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
    '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
    '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
    '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
    '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
    '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
    '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
    '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
    '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
    '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
    '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
    '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
    '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
    '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
    '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
    '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
    '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
    '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
    '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
    '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
    '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
    '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
    '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
    '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
    '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
    '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
    '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
    '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
    '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
    '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
    '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
    '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
    '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
    '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
    '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
    '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
    '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
    '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
    '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
    '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
    '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
    '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
    '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
    '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
    '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
    '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
    '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
    '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
    '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
    '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
    '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
    '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
    '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
    '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
    '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
    '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
    '1f38c': "\uD83C\uDF8C",
    '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
    '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
    '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
    '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
    '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
    '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
    '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
    '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
    '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
    '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
    '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
    '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
    '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
    '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
    '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
    '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
    '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
    '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
    '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
    '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
    '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
    '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
    '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
    '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
    '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
    '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
    '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
    '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
    '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
    '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
    '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
    '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
    '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
    '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
    '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
    '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
    '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
    '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
    '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
    '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
    '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
    '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
    '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
    '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
    '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
    '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
    '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
    '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
    '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
    '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
    '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
    '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
    '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
    '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
    '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
    '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
    '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
    '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
    '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
    '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
    '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
    '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
    '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
    '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
    '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
    '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
    '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
    '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
    '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
    '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
    '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
    '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
    '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
    '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
    '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
    '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
    '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
    '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
    '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
    '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
    '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
    '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
    '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
    '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
    '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
    '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
    '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
    '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
    '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
    '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
    '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
    '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
    '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
    '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
    '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
    '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
    '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
    '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
    '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
    '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
    '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
    '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
    '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
    '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
    '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
    '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
    '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
    '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
    '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
    '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
    '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
    '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
    '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
    '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
    '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
    '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
    '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
    '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
    '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
    '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
    '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
    '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
    '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
    '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
    '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
    '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
    '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
    '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
    '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
    '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
    '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
    '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
    '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
    '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
    '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
    '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
    '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
    '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
    '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
    '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
    '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
    '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
    '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
    '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
    '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
    '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
    '1f1ff': "\uD83C\uDDFF",
    '1f1fe': "\uD83C\uDDFE",
    '1f1fd': "\uD83C\uDDFD",
    '1f3fb': "\uD83C\uDFFB",
    '1f3fc': "\uD83C\uDFFC",
    '1f3fd': "\uD83C\uDFFD",
    '1f3fe': "\uD83C\uDFFE",
    '1f3ff': "\uD83C\uDFFF",
    '1f1fc': "\uD83C\uDDFC",
    '1f1fb': "\uD83C\uDDFB",
    '1f1fa': "\uD83C\uDDFA",
    '1f1f9': "\uD83C\uDDF9",
    '1f1f8': "\uD83C\uDDF8",
    '1f1f7': "\uD83C\uDDF7",
    '1f1f6': "\uD83C\uDDF6",
    '1f1f5': "\uD83C\uDDF5",
    '1f1f4': "\uD83C\uDDF4",
    '1f1f3': "\uD83C\uDDF3",
    '1f1f2': "\uD83C\uDDF2",
    '1f1f1': "\uD83C\uDDF1",
    '1f1f0': "\uD83C\uDDF0",
    '1f1ef': "\uD83C\uDDEF",
    '1f1ee': "\uD83C\uDDEE",
    '1f1ed': "\uD83C\uDDED",
    '1f1ec': "\uD83C\uDDEC",
    '1f1eb': "\uD83C\uDDEB",
    '1f1ea': "\uD83C\uDDEA",
    '1f1e9': "\uD83C\uDDE9",
    '1f1e8': "\uD83C\uDDE8",
    '1f1e7': "\uD83C\uDDE7",
    '1f1e6': "\uD83C\uDDE6",
    '2640': "\u2640\uFE0F",
    '2642': "\u2642\uFE0F",
    '2695': "\u2695\uFE0F",
    '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f928': "\uD83E\uDD28",
    '1f929': "\uD83E\uDD29",
    '1f92a': "\uD83E\uDD2A",
    '1f92b': "\uD83E\uDD2B",
    '1f92c': "\uD83E\uDD2C",
    '1f92d': "\uD83E\uDD2D",
    '1f92e': "\uD83E\uDD2E",
    '1f92f': "\uD83E\uDD2F",
    '1f9d0': "\uD83E\uDDD0",
    '1f9d1': "\uD83E\uDDD1",
    '1f9d2': "\uD83E\uDDD2",
    '1f9d3': "\uD83E\uDDD3",
    '1f9d4': "\uD83E\uDDD4",
    '1f9d5': "\uD83E\uDDD5",
    '1f9e0': "\uD83E\uDDE0",
    '1f9e2': "\uD83E\uDDE2",
    '1f9d9': "\uD83E\uDDD9",
    '1f9da': "\uD83E\uDDDA",
    '1f9db': "\uD83E\uDDDB",
    '1f9dc': "\uD83E\uDDDC",
    '1f9dd': "\uD83E\uDDDD",
    '1f9de': "\uD83E\uDDDE",
    '1f9df': "\uD83E\uDDDF",
    '1f9e3': "\uD83E\uDDE3",
    '1f9e4': "\uD83E\uDDE4",
    '1f9e5': "\uD83E\uDDE5",
    '1f9e6': "\uD83E\uDDE6",
    '1f91f': "\uD83E\uDD1F",
    '1f932': "\uD83E\uDD32",
    '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
    '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
    '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
    '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
    '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
    '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
    '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
    '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
    '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
    '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
    '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
    '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
    '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
    '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)'
};

});

parcelRegister("1Nefo", function(module, exports) {

$parcel$export(module.exports, "unknown", () => $6e7c0aa132a04ffb$export$19282c40b967aec6);

var $hYNZx = parcelRequire("hYNZx");
const $6e7c0aa132a04ffb$var$jsonTransformer = new (0, $hYNZx.JSONTransformer)();
const $6e7c0aa132a04ffb$export$19282c40b967aec6 = (node)=>{
    const content = JSON.stringify($6e7c0aa132a04ffb$var$jsonTransformer.encodeNode(node));
    return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
};

});


parcelRegister("e34Iq", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $0b90673427e9e36d$export$371da9dd35aba193);
const $0b90673427e9e36d$export$371da9dd35aba193 = (_node)=>{
    return '\n';
};

});

parcelRegister("6obXI", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $b266c76290bae2fd$export$38bab695e3f720f1);
const $b266c76290bae2fd$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
    const fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    return `[^${fileName}]`;
};

});

parcelRegister("7GCbZ", function(module, exports) {

$parcel$export(module.exports, "mention", () => $276f00c4f54975e4$export$db83999c14438df4);
const $276f00c4f54975e4$var$PREFIX = 'accountid:';
const $276f00c4f54975e4$var$UNKNOWN_USER = 'UNKNOWN_USER';
const $276f00c4f54975e4$var$addPrefix = (content)=>content.toLowerCase().startsWith($276f00c4f54975e4$var$PREFIX) ? content : `${$276f00c4f54975e4$var$PREFIX}${content}`;
const $276f00c4f54975e4$export$db83999c14438df4 = (node, { context: context } = {})=>{
    if (node.attrs.id === $276f00c4f54975e4$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
    const mentionKey = node.attrs.id.toLowerCase();
    const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $276f00c4f54975e4$var$addPrefix(node.attrs.id);
    return `[~${content}]`;
};

});

parcelRegister("6ayzl", function(module, exports) {

$parcel$export(module.exports, "text", () => $774ee87c38efef1c$export$6f093cfa640b7166);

var $cG4PY = parcelRequire("cG4PY");

var $4yZSi = parcelRequire("4yZSi");

var $aDTWq = parcelRequire("aDTWq");

var $gdFeW = parcelRequire("gdFeW");

var $jo5YT = parcelRequire("jo5YT");

var $9fwgI = parcelRequire("9fwgI");

var $eKxrE = parcelRequire("eKxrE");

var $1x55I = parcelRequire("1x55I");

var $8tKGr = parcelRequire("8tKGr");
/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */ const $774ee87c38efef1c$var$markEncoderMapping = new Map([
    [
        'em',
        (0, $gdFeW.em)
    ],
    [
        'strike',
        (0, $9fwgI.strike)
    ],
    [
        'strong',
        (0, $eKxrE.strong)
    ],
    [
        'subsup',
        (0, $1x55I.subsup)
    ],
    [
        'underline',
        (0, $8tKGr.underline)
    ],
    [
        'textColor',
        (0, $aDTWq.textColor)
    ],
    [
        'link',
        (0, $jo5YT.link)
    ],
    [
        'code',
        (0, $4yZSi.code)
    ]
]);
/**
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 * Before this change, any instance of "[" and "!" was being escaped
 * "[" is used for mentions
 * "!" is used for media
 */ const $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN = '(\\[~)'; // Matches pattern like [~
const $774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)'; // Matches non space content between two consecutive "!" e.g. !filename.txt!
const $774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])'; // Matches non space content between two consecutive "[^" "]" e.g. [^filename.txt]
/**
 * Checks if the node's content needs to be escaped before continuing processing.
 * Currently, the `code` mark and `codeBlock` nodes handle their own escaping, and
 * therefore, should not be escaped here.
 *
 * @param node the current node to encode
 * @param parent the parent node, if exist
 * @returns true if the node should have its text escaped when encoding to wikimarkup.
 */ const $774ee87c38efef1c$var$isEscapeNeeded = (node, parent)=>{
    return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
};
/**
 * ESS-2569: Removing the backsalshes from the regex
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 */ function $774ee87c38efef1c$var$escapingWikiFormatter(text) {
    const pattern = [
        $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN,
        ...(0, $cG4PY.macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
    ].join('|');
    return text// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp(pattern, 'g'), '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2') // Extra step required for media as currently both ends need to be escaped e.q. !filename.txt!
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
}
const $774ee87c38efef1c$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let result = $774ee87c38efef1c$var$isEscapeNeeded(node, parent) ? $774ee87c38efef1c$var$escapingWikiFormatter(node.text) : node.text;
    $774ee87c38efef1c$var$markEncoderMapping.forEach((encoder, markName)=>{
        const mark = node.marks.find((m)=>m.type.name === markName);
        if (mark) result = encoder(result, mark.attrs);
    });
    return result;
};

});
parcelRegister("cG4PY", function(module, exports) {

$parcel$export(module.exports, "macroKeywordTokenMap", () => $87fdd6b952f97dba$export$afcd7edeca61ca93);
$parcel$export(module.exports, "parseMacroKeyword", () => $87fdd6b952f97dba$export$39c29c0b4f759e52);
$parcel$export(module.exports, "parseOtherKeyword", () => $87fdd6b952f97dba$export$ce89e528658ee2ac);
$parcel$export(module.exports, "parseLeadingKeyword", () => $87fdd6b952f97dba$export$68162fc57528b560);
$parcel$export(module.exports, "parseIssueKeyword", () => $87fdd6b952f97dba$export$bcec6d03770b152c);

var $kSL4h = parcelRequire("kSL4h");

var $ayQVO = parcelRequire("ayQVO");
const $87fdd6b952f97dba$export$afcd7edeca61ca93 = [
    {
        type: (0, $kSL4h.TokenType).ADF_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{adf/i
    },
    {
        type: (0, $kSL4h.TokenType).ANCHOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{anchor/i
    },
    {
        type: (0, $kSL4h.TokenType).CODE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{code/i
    },
    {
        type: (0, $kSL4h.TokenType).QUOTE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{quote/i
    },
    {
        type: (0, $kSL4h.TokenType).NOFORMAT_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{noformat/i
    },
    {
        type: (0, $kSL4h.TokenType).PANEL_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{panel/i
    },
    {
        type: (0, $kSL4h.TokenType).COLOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{color/
    },
    {
        type: (0, $kSL4h.TokenType).LOREM_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{loremipsum/i
    }
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */ const $87fdd6b952f97dba$var$keywordTokenMap = {
    '[': (0, $kSL4h.TokenType).LINK_FORMAT,
    http: (0, $kSL4h.TokenType).LINK_TEXT,
    ftp: (0, $kSL4h.TokenType).LINK_TEXT,
    jamfselfservice: (0, $kSL4h.TokenType).LINK_TEXT,
    irc: (0, $kSL4h.TokenType).LINK_TEXT,
    mailto: (0, $kSL4h.TokenType).LINK_TEXT,
    '\\\\': (0, $kSL4h.TokenType).FORCE_LINE_BREAK,
    '\r': (0, $kSL4h.TokenType).HARD_BREAK,
    '\n': (0, $kSL4h.TokenType).HARD_BREAK,
    '\r\n': (0, $kSL4h.TokenType).HARD_BREAK,
    '!': (0, $kSL4h.TokenType).MEDIA,
    '----': (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
    '---': (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
    '--': (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
    '{-}': (0, $kSL4h.TokenType).DELETED,
    '{+}': (0, $kSL4h.TokenType).INSERTED,
    '{*}': (0, $kSL4h.TokenType).STRONG,
    '{^}': (0, $kSL4h.TokenType).SUPERSCRIPT,
    '{~}': (0, $kSL4h.TokenType).SUBSCRIPT,
    '{_}': (0, $kSL4h.TokenType).EMPHASIS,
    '{{{}': (0, $kSL4h.TokenType).MONOSPACE,
    '{??}': (0, $kSL4h.TokenType).CITATION,
    '-': (0, $kSL4h.TokenType).DELETED,
    '+': (0, $kSL4h.TokenType).INSERTED,
    '*': (0, $kSL4h.TokenType).STRONG,
    '^': (0, $kSL4h.TokenType).SUPERSCRIPT,
    '~': (0, $kSL4h.TokenType).SUBSCRIPT,
    _: (0, $kSL4h.TokenType).EMPHASIS,
    '{{': (0, $kSL4h.TokenType).MONOSPACE,
    '??': (0, $kSL4h.TokenType).CITATION
};
const $87fdd6b952f97dba$var$keywordTokenMapKeys = Object.keys($87fdd6b952f97dba$var$keywordTokenMap);
function $87fdd6b952f97dba$export$39c29c0b4f759e52(input) {
    for(let i = 0; i < $87fdd6b952f97dba$export$afcd7edeca61ca93.length; i++){
        const keyword = $87fdd6b952f97dba$export$afcd7edeca61ca93[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $87fdd6b952f97dba$export$ce89e528658ee2ac(input) {
    for(let i = 0; i < $87fdd6b952f97dba$var$keywordTokenMapKeys.length; i++){
        if (input.startsWith($87fdd6b952f97dba$var$keywordTokenMapKeys[i])) return {
            type: $87fdd6b952f97dba$var$keywordTokenMap[$87fdd6b952f97dba$var$keywordTokenMapKeys[i]]
        };
    }
    // Look for a emoji
    const char = input.charAt(0);
    if ([
        ':',
        '(',
        ';'
    ].indexOf(char) !== -1) return {
        // This potentially can be a emoji. The emoji parser will fail out if it's not
        type: (0, $kSL4h.TokenType).EMOJI
    };
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */ const $87fdd6b952f97dba$var$leadingKeywordTokenMap = [
    {
        type: (0, $kSL4h.TokenType).QUOTE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^bq\./
    },
    {
        type: (0, $kSL4h.TokenType).HEADING,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^h[1-6]\./
    },
    {
        type: (0, $kSL4h.TokenType).RULER,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{4,5}(\s|$)/
    },
    {
        type: (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{3}\s/
    },
    {
        type: (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{2}\s/
    },
    {
        // Lists are limited to max 20 levels of depth
        type: (0, $kSL4h.TokenType).LIST,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: new RegExp(`^([*#]{1,${(0, $ayQVO.MAX_LIST_DEPTH)}}|-) `)
    },
    {
        type: (0, $kSL4h.TokenType).TABLE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^\|{1,2}/
    }
];
function $87fdd6b952f97dba$export$68162fc57528b560(input) {
    for(let i = 0; i < $87fdd6b952f97dba$var$leadingKeywordTokenMap.length; i++){
        const keyword = $87fdd6b952f97dba$var$leadingKeywordTokenMap[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $87fdd6b952f97dba$export$bcec6d03770b152c(input, issueKeyRegex) {
    if (issueKeyRegex && issueKeyRegex.test(input)) return {
        type: (0, $kSL4h.TokenType).ISSUE_KEY
    };
    return null;
}

});
parcelRegister("kSL4h", function(module, exports) {

$parcel$export(module.exports, "TokenType", () => $160d182608400c84$export$f435f793048e7a0f);
$parcel$export(module.exports, "parseToken", () => $160d182608400c84$export$af8f4e8328578827);

var $4Foyv = parcelRequire("4Foyv");

var $30Un5 = parcelRequire("30Un5");

var $coK8g = parcelRequire("coK8g");

var $5RdHN = parcelRequire("5RdHN");

var $55t1E = parcelRequire("55t1E");

var $jor5q = parcelRequire("jor5q");

var $hZ14o = parcelRequire("hZ14o");

var $6xaH8 = parcelRequire("6xaH8");

var $jMpI6 = parcelRequire("jMpI6");

var $iDsRr = parcelRequire("iDsRr");

var $7tIdE = parcelRequire("7tIdE");

var $1MGc3 = parcelRequire("1MGc3");

var $ayQVO = parcelRequire("ayQVO");

var $kPrK8 = parcelRequire("kPrK8");

var $4ZFIG = parcelRequire("4ZFIG");

var $91y57 = parcelRequire("91y57");

var $1Mtv8 = parcelRequire("1Mtv8");

var $77w3e = parcelRequire("77w3e");

var $lf0Nr = parcelRequire("lf0Nr");

var $4s89q = parcelRequire("4s89q");

var $ir9MO = parcelRequire("ir9MO");

var $7E14k = parcelRequire("7E14k");

var $9MeiU = parcelRequire("9MeiU");

var $f50H1 = parcelRequire("f50H1");

var $bSil4 = parcelRequire("bSil4");

var $4Dfwq = parcelRequire("4Dfwq");

var $cjZPi = parcelRequire("cjZPi");

var $8tGpW = parcelRequire("8tGpW");

var $lyI5i = parcelRequire("lyI5i");

var $bOMPB = parcelRequire("bOMPB");
var $160d182608400c84$export$f435f793048e7a0f = /*#__PURE__*/ function(TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["ISSUE_KEY"] = "ISSUE_KEY";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    TokenType["STRONG"] = "STRONG";
    TokenType["MONOSPACE"] = "MONOSPACE";
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    TokenType["EMPHASIS"] = "EMPHASIS";
    TokenType["CITATION"] = "CITATION";
    TokenType["DELETED"] = "DELETED";
    TokenType["INSERTED"] = "INSERTED";
    TokenType["EMOJI"] = "EMOJI";
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
    return TokenType;
}({});
const $160d182608400c84$var$tokenToTokenParserMapping = {
    ["DOUBLE_DASH_SYMBOL"]: (0, $55t1E.doubleDashSymbol),
    ["TRIPLE_DASH_SYMBOL"]: (0, $ir9MO.tripleDashSymbol),
    ["QUADRUPLE_DASH_SYMBOL"]: (0, $4ZFIG.quadrupleDashSymbol),
    ["RULER"]: (0, $91y57.ruler),
    ["STRONG"]: (0, $1Mtv8.strong),
    ["MONOSPACE"]: (0, $kPrK8.monospace),
    ["SUPERSCRIPT"]: (0, $lf0Nr.superscript),
    ["SUBSCRIPT"]: (0, $77w3e.subscript),
    ["EMPHASIS"]: (0, $hZ14o.emphasis),
    ["CITATION"]: (0, $coK8g.citation),
    ["DELETED"]: (0, $5RdHN.deleted),
    ["INSERTED"]: (0, $iDsRr.inserted),
    ["HARD_BREAK"]: (0, $6xaH8.hardbreak),
    ["LINK_FORMAT"]: (0, $7tIdE.linkFormat),
    ["LINK_TEXT"]: (0, $1MGc3.linkText),
    ["HEADING"]: (0, $jMpI6.heading),
    ["MEDIA"]: (0, $4Foyv.media),
    ["LIST"]: (0, $ayQVO.list),
    ["QUOTE"]: (0, $30Un5.blockquote),
    ["TABLE"]: (0, $4s89q.table),
    ["EMOJI"]: (0, $jor5q.emoji),
    ["ADF_MACRO"]: (0, $9MeiU.adfMacro),
    ["ANCHOR_MACRO"]: (0, $f50H1.anchorMacro),
    ["CODE_MACRO"]: (0, $bSil4.codeMacro),
    ["QUOTE_MACRO"]: (0, $4Dfwq.quoteMacro),
    ["NOFORMAT_MACRO"]: (0, $8tGpW.noformatMacro),
    ["PANEL_MACRO"]: (0, $7E14k.panelMacro),
    ["COLOR_MACRO"]: (0, $cjZPi.colorMacro),
    ["FORCE_LINE_BREAK"]: (0, $lyI5i.forceLineBreak),
    ["ISSUE_KEY"]: (0, $bOMPB.issueKey)
};
function $160d182608400c84$export$af8f4e8328578827(input, type, position, schema, context) {
    const tokenParser = $160d182608400c84$var$tokenToTokenParserMapping[type];
    if (tokenParser) try {
        return tokenParser({
            input: input,
            position: position,
            schema: schema,
            context: context
        });
    } catch (err) {
        if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
        return $160d182608400c84$var$fallback(input, position);
    }
    return $160d182608400c84$var$fallback(input, position);
}
function $160d182608400c84$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("4Foyv", function(module, exports) {

$parcel$export(module.exports, "media", () => $8b246e16d82e8dde$export$987d49ffe1b0900f);

var $4V377 = parcelRequire("4V377");

var $4ZUg7 = parcelRequire("4ZUg7");

var $eyO0H = parcelRequire("eyO0H");
const $8b246e16d82e8dde$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
    const rawContentProcessor = (raw, length)=>{
        /**
		 * !image.gif|align=right, vspace=4|ignore-this!
		 * If it splits into more than 2 items, we ignore the rest
		 */ const [rawContent, rawAttrs = ''] = raw.split('|');
        const node = (0, $4V377.default)(schema, rawContent, (0, $4ZUg7.parseAttrs)(rawAttrs, ','), context);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    };
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: '!',
        closing: '!',
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("4V377", function(module, exports) {

$parcel$export(module.exports, "default", () => $2106e5f40786af56$export$2e2bcd8739ae039);

var $1MGc3 = parcelRequire("1MGc3");
const $2106e5f40786af56$var$defaultWidth = 200;
const $2106e5f40786af56$var$defaultHeight = 183;
const $2106e5f40786af56$var$clamp = (input, lower, upper)=>{
    if (upper !== undefined) input = input <= upper ? input : upper;
    if (lower !== undefined) input = input >= lower ? input : lower;
    return input;
};
function $2106e5f40786af56$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const { link: link } = schema.marks;
    const mediaMarks = [];
    let mediaNodeAttrs = {};
    if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $2106e5f40786af56$var$defaultWidth;
    if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $2106e5f40786af56$var$defaultHeight;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mediaSingleAttrs = {
        layout: 'center'
    };
    if (attrs.width && attrs.width.endsWith('%')) {
        const parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) mediaSingleAttrs.width = $2106e5f40786af56$var$clamp(parsed, 0, 100);
        mediaNodeAttrs = {};
    } else {
        if (attrs.width) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
        }
        if (attrs.height) {
            const parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
        }
    }
    if (attrs.href) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const href = attrs.href.replace(/^"(.+)"$/, '$1');
        mediaMarks.push(link.create({
            href: href
        }));
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match((0, $1MGc3.LINK_TEXT_REGEXP))) {
        const externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    } else {
        // try to look up media ID from conversion context
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        // try to look up collection from media context
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || '',
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}

});
parcelRegister("1MGc3", function(module, exports) {

$parcel$export(module.exports, "LINK_TEXT_REGEXP", () => $49f89f13b4b7c481$export$f69d1dce349473aa);
$parcel$export(module.exports, "linkText", () => $49f89f13b4b7c481$export$cb7bcf09a05b7705);

var $iZOJ9 = parcelRequire("iZOJ9");

var $iqYHB = parcelRequire("iqYHB");
const $49f89f13b4b7c481$export$f69d1dce349473aa = // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
/^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
const $49f89f13b4b7c481$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
    const matches = input.substring(position).match($49f89f13b4b7c481$export$f69d1dce349473aa);
    if (!matches) return $49f89f13b4b7c481$var$fallback(input, position);
    const match = $49f89f13b4b7c481$var$trimBadEndChar(matches);
    // Remove mailto:
    const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    // parse and correctly encode any illegal characters, and
    // so no longer need to be encoded when used below
    const url = (0, $iqYHB.decode)($49f89f13b4b7c481$var$unescape(match[0]));
    if (!(0, $iZOJ9.isSafeUrl)(url)) return $49f89f13b4b7c481$var$fallback(input, position);
    const mark = schema.marks.link.create({
        href: url
    });
    const textNode = schema.text(textRepresentation, [
        mark
    ]);
    return {
        type: 'pmnode',
        nodes: [
            textNode
        ],
        length: match[0].length
    };
};
function $49f89f13b4b7c481$var$unescape(url) {
    let result = '';
    for(let i = 0; i < url.length; i++){
        const char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        const nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function $49f89f13b4b7c481$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}
// removes bad characters from the end of regex match
function $49f89f13b4b7c481$var$trimBadEndChar(input) {
    return [
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input[0].replace(/[.,>)\];}"\'!]*$/, ''),
        input[1],
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input[2].replace(/[.,>)\];}"\'!]*$/, '')
    ];
}

});
parcelRegister("iqYHB", function(module, exports) {

$parcel$export(module.exports, "decode", () => $c6b4ec3136742c55$export$2f872c0f2117be69);
/**
 * returns a correctly percent-encoded & sanitized url.
 * Will fallback to using a DOM based implementation if the `URL` class
 * doesn't exist.
 *
 * @param raw a 'raw' url (possibly mixed percent-encoded).
 */ function $c6b4ec3136742c55$export$2f872c0f2117be69(raw) {
    if (typeof URL === 'function') {
        const decoded = new URL(raw);
        // IE11 doesn't support the `href` property in the `URL` class.
        // Fallback to the DOM below if it doesn't exist.
        if (decoded.href) return decoded.href;
    }
    // no `URL` class - pollyfill using the dom to parse and
    // decode. This should only be needed for IE11 or lower...
    const anchor = document.createElement('a');
    anchor.href = raw; // The DOM will parses even mixed %-encoded segments of a url when set.
    return anchor.href;
}

});



parcelRegister("4ZUg7", function(module, exports) {

$parcel$export(module.exports, "parseAttrs", () => $972abf9f01734b21$export$e1a9355cfd8f6c64);
function $972abf9f01734b21$export$e1a9355cfd8f6c64(str, sep = '|') {
    const output = {};
    if (!str) return output;
    const attributesStr = str.split(sep);
    attributesStr.forEach((attributeStr)=>{
        const [key, ...value] = attributeStr.split('=');
        // take only first value of the same keys
        if (!output[key]) output[key] = value.join('=');
    });
    return output;
}

});

parcelRegister("eyO0H", function(module, exports) {

$parcel$export(module.exports, "commonFormatter", () => $dee2bdf3f1017b16$export$a71d57024d3da1c5);

var $kSL4h = parcelRequire("kSL4h");

var $7tIdE = parcelRequire("7tIdE");

var $eWAZI = parcelRequire("eWAZI");

var $cG4PY = parcelRequire("cG4PY");

var $2weJO = parcelRequire("2weJO");
const $dee2bdf3f1017b16$var$processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5
};
function $dee2bdf3f1017b16$export$a71d57024d3da1c5(input, position, schema, opt) {
    let index = position;
    let state = $dee2bdf3f1017b16$var$processState.START;
    const buffer = [];
    const openingSymbolLength = opt.opening.length;
    const closingSymbolLength = opt.closing.length;
    const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
    const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
    while(index < input.length){
        const char = input.charAt(index);
        const twoChar = input.substr(index, 2);
        const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch(state){
            case $dee2bdf3f1017b16$var$processState.START:
                {
                    if (position > 0) {
                        /**
					 * If the previous char is a alphanumeric, then it's not a valid
					 * formatter
					 */ const charBeforeOpening = input.charAt(position - 1);
                        if (!openingWrapped && // Ignored via go/ees005
                        // eslint-disable-next-line require-unicode-regexp
                        /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $dee2bdf3f1017b16$var$fallback(input, index, openingSymbolLength);
                    }
                    const charAfterOpening = input.charAt(index + openingSymbolLength);
                    if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') // this is not a valid formatter mark
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    state = $dee2bdf3f1017b16$var$processState.BUFFER;
                    index += openingSymbolLength;
                    continue;
                }
            case $dee2bdf3f1017b16$var$processState.BUFFER:
                {
                    // the linebreak would break the strong marks
                    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(index));
                    if (length) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    if (charsMatchClosingSymbol === opt.closing) {
                        state = $dee2bdf3f1017b16$var$processState.END;
                        continue;
                    } else if (twoChar === '{{') {
                        // this is a monospace
                        buffer.push(twoChar);
                        index += 2;
                        continue;
                    } else if (char === '{') {
                        state = $dee2bdf3f1017b16$var$processState.INLINE_MACRO;
                        continue;
                    } else if (char === '[') {
                        state = $dee2bdf3f1017b16$var$processState.LINK_FORMAT;
                        continue;
                    } else if (char === '\\') {
                        state = $dee2bdf3f1017b16$var$processState.ESCAPE;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $dee2bdf3f1017b16$var$processState.END:
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                /**
				 * If the closing symbol is followed by a alphanumeric, it's
				 * not a valid formatter, and we keep looking for
				 * next valid closing formatter.
				 * ESS-1402: checking for the non-breaking space after closing symbol.
				 */ if (index < input.length) {
                    const charAfterEnd = input.charAt(index);
                    if (!closingWrapped && // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                        buffer.push(charsMatchClosingSymbol);
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    }
                }
                /**
				 * If the closing symbol has an empty space before it,
				 * it's not a valid formatter
				 */ if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                return opt.rawContentProcessor(buffer.join(''), index - position);
            case $dee2bdf3f1017b16$var$processState.INLINE_MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        break;
                    }
                    /**
				 * Is not a problem send an empty context because we're only checking
				 * if it has a nested macro inside.
				 */ const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, {});
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else if (match.type === (0, $kSL4h.TokenType).COLOR_MACRO) {
                        /**
					 * {color} is valid in formatter, we simply jump over the length
					 */ buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else // No macro are accepted in formater
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                }
            case $dee2bdf3f1017b16$var$processState.LINK_FORMAT:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 *
				 * Also, is not a problem send an empty context because we're only
				 * checking if it has a nested macro inside.
				 */ const token = (0, $7tIdE.linkFormat)({
                        input: input,
                        schema: schema,
                        position: index,
                        context: {}
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    }
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                }
            case $dee2bdf3f1017b16$var$processState.ESCAPE:
                {
                    const token = (0, $2weJO.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $dee2bdf3f1017b16$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
}
function $dee2bdf3f1017b16$var$fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length
    };
}

});
parcelRegister("7tIdE", function(module, exports) {

$parcel$export(module.exports, "linkFormat", () => $0412731f8f85cc95$export$e1f888a4b6f2ee53);

var $kSL4h = parcelRequire("kSL4h");

var $29zBb = parcelRequire("29zBb");

var $9jjzg = parcelRequire("9jjzg");

var $gGleW = parcelRequire("gGleW");
// [http://www.example.com] and [Example|http://www.example.com]
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0412731f8f85cc95$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
const $0412731f8f85cc95$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($0412731f8f85cc95$var$LINK_FORMAT_REGEXP);
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER,
        // We want to avoid recursion
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).LINK_FORMAT
    ];
    if (!match) return $0412731f8f85cc95$var$fallback();
    const content = (0, $gGleW.parseContentLink)(match[1]);
    const resolvedLink = (0, $9jjzg.resolveLink)(content, schema, context);
    if (resolvedLink) return resolvedLink;
    const nodes = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: ignoreTokenTypes,
        input: match[0]
    });
    return {
        type: 'pmnode',
        nodes: nodes,
        length: match[0].length
    };
};
function $0412731f8f85cc95$var$fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1
    };
}

});
parcelRegister("29zBb", function(module, exports) {

$parcel$export(module.exports, "parseString", () => $e7a948cf285a18ed$export$960addfb9e5a0cde);

var $04cDS = parcelRequire("04cDS");

var $cG4PY = parcelRequire("cG4PY");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $2weJO = parcelRequire("2weJO");

var $20lXC = parcelRequire("20lXC");
const $e7a948cf285a18ed$var$processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3
};
function $e7a948cf285a18ed$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
    let index = 0;
    let state = $e7a948cf285a18ed$var$processState.NEWLINE;
    let buffer = [];
    let tokenType = (0, $kSL4h.TokenType).STRING;
    let newLines = [];
    const output = [];
    let inlineNodes = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $e7a948cf285a18ed$var$processState.NEWLINE:
                {
                    /**
				 * During this state, the parser will trim leading
				 * spaces and looking for any leading keywords.
				 */ const substring = input.substring(index);
                    const length = (0, $eWAZI.parseWhitespaceOnly)(substring);
                    if (length) {
                        index += length;
                        if (includeLeadingSpace) buffer.push(char);
                        continue;
                    }
                    const match = (0, $cG4PY.parseLeadingKeyword)(substring) || (0, $cG4PY.parseMacroKeyword)(substring) || (0, $cG4PY.parseOtherKeyword)(substring) || (0, $cG4PY.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $e7a948cf285a18ed$var$processState.TOKEN;
                        continue;
                    } else {
                        state = $e7a948cf285a18ed$var$processState.BUFFER;
                        continue;
                    }
                }
            case $e7a948cf285a18ed$var$processState.BUFFER:
                {
                    /**
				 * During this state, the parser will start
				 * saving plaintext into the buffer until it hits
				 * a keyword
				 */ const substring = input.substring(index);
                    /**
				 * If the previous char is not a alphanumeric, we will parse
				 * format keywords.
				 * If the previous char is '{', we need to skip parse macro
				 * keyword
				 */ let match = null;
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, $cG4PY.parseOtherKeyword)(substring);
                    else match = (0, $cG4PY.parseMacroKeyword)(substring) || (0, $cG4PY.parseOtherKeyword)(substring) || (0, $cG4PY.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $e7a948cf285a18ed$var$processState.TOKEN;
                        continue;
                    }
                    if (char === '\\') {
                        state = $e7a948cf285a18ed$var$processState.ESCAPE;
                        continue;
                    }
                    buffer.push(char);
                    break;
                }
            case $e7a948cf285a18ed$var$processState.TOKEN:
                {
                    const token = (0, $kSL4h.parseToken)(input, tokenType, index, schema, context);
                    if (token.type === 'text') buffer.push(token.text);
                    else if (token.type === 'pmnode') {
                        /*ESS-2539 We are keeping track of consecutive newLines in the newLines array
            Whenever more than two consecutive newLines are encountered, we start a new paragraph
          */ if (newLines.length >= 2 && (tokenType !== (0, $kSL4h.TokenType).HARD_BREAK || buffer.length > 0)) {
                            output.push(...(0, $20lXC.normalizePMNodes)(inlineNodes, schema));
                            // push newLines to the buffer as a separator between media nodes
                            inlineNodes = $e7a948cf285a18ed$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                ...newLines
                            ] : [];
                            newLines = [];
                        }
                        if (inlineNodes.length === 0) newLines = [];
                        if (newLines.length > 0 && $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                            inlineNodes.push(...newLines);
                            newLines = [];
                        }
                        inlineNodes.push(...(0, $04cDS.createTextNode)(buffer.join(''), schema));
                        if (tokenType === (0, $kSL4h.TokenType).HARD_BREAK) newLines.push(...token.nodes);
                        else {
                            inlineNodes.push(...token.nodes);
                            if (token.nodes.length > 0) newLines = [];
                        }
                        buffer = []; // clear the buffer
                    }
                    index += token.length;
                    if (tokenType === (0, $kSL4h.TokenType).HARD_BREAK) state = $e7a948cf285a18ed$var$processState.NEWLINE;
                    else state = $e7a948cf285a18ed$var$processState.BUFFER;
                    continue;
                }
            case $e7a948cf285a18ed$var$processState.ESCAPE:
                {
                    const token = (0, $2weJO.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $e7a948cf285a18ed$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    const bufferedStr = buffer.join('');
    if (bufferedStr.length > 0) {
        // Wrapping the rest of the buffer into a text node
        if (newLines.length >= 2) {
            // normalize the nodes already parsed if more than two consecutive newLines are encountered
            output.push(...(0, $20lXC.normalizePMNodes)(inlineNodes, schema));
            inlineNodes = [];
            newLines = [];
        }
        if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
        inlineNodes.push(...(0, $04cDS.createTextNode)(bufferedStr, schema));
    }
    return [
        ...output,
        ...inlineNodes
    ];
}
/* checks whether a newLine is required between two consecutive nodes
   Returns true for inline nodes, false for block nodes
*/ function $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
    if (currentNodes.length === 0) return false;
    if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
    if (buffer.length === 0) {
        if (nextNodes.length === 0) return false;
        if (nextNodes[0]?.type.name === 'hardBreak') return false;
        if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
    }
    return true;
}
function $e7a948cf285a18ed$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
    return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
}

});
parcelRegister("04cDS", function(module, exports) {

$parcel$export(module.exports, "createTextNode", () => $e67b0538295ca231$export$b2ce9ad90858ed7a);
function $e67b0538295ca231$export$b2ce9ad90858ed7a(input, schema, marks) {
    if (input === '') return [];
    const node = schema.text(input, marks || []);
    return [
        node
    ];
}

});

parcelRegister("eWAZI", function(module, exports) {

$parcel$export(module.exports, "parseNewlineOnly", () => $b3a19bb1e901f2d4$export$1b7a83d725c8acf);
$parcel$export(module.exports, "parseWhitespaceOnly", () => $b3a19bb1e901f2d4$export$9c597b035e16623b);
function $b3a19bb1e901f2d4$export$877995a80ec11782(input) {
    const newlineLength = $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input);
    if (newlineLength) return newlineLength;
    const whitespaceLength = $b3a19bb1e901f2d4$export$9c597b035e16623b(input);
    if (whitespaceLength) return whitespaceLength;
    // There is nether whitespace nor newline
    return 0;
}
function $b3a19bb1e901f2d4$export$9c597b035e16623b(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\t' || char === ' ') index++;
    return index;
}
function $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') // CRLF (Windows)
        index++;
    } else if (char === '\n') // LF (MacOS)
    index++;
    return index;
}

});

parcelRegister("2weJO", function(module, exports) {

$parcel$export(module.exports, "escapeHandler", () => $35d0c4c2d3000f41$export$d16e8e6cf9622f9a);
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */ const $35d0c4c2d3000f41$var$escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@'
];
function $35d0c4c2d3000f41$export$d16e8e6cf9622f9a(input, position) {
    const buffer = [];
    const char = input.charAt(position);
    const prevChar = input.charAt(position - 1);
    const nextChar = input.charAt(position + 1);
    /**
	 * Ported from Jira:
	 * If previous char is also a backslash, then this is not a valid escape
	 */ if ($35d0c4c2d3000f41$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') // Insert \ in buffer mode
    buffer.push(char);
    buffer.push(nextChar);
    return {
        type: 'text',
        text: buffer.join(''),
        length: 2
    };
}

});

parcelRegister("20lXC", function(module, exports) {

$parcel$export(module.exports, "normalizePMNodes", () => $50669f552f016dd9$export$e21f6b7efdaf8b5d);

var $4UJvN = parcelRequire("4UJvN");
function $50669f552f016dd9$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
    return [
        $50669f552f016dd9$var$normalizeMediaGroups,
        $50669f552f016dd9$export$2cef2a4c047f9887,
        $50669f552f016dd9$export$cd936b894f116ed8
    ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
}
function $50669f552f016dd9$export$2cef2a4c047f9887(nodes, schema, parentNode) {
    // When we round-trip through ADF - WikiMarkup - ADF, expands get replaced by strong text.
    // That would result in the nested expand being in an invalid situation as it's no longer
    // nested in either a table or expand
    // This solves the issue for nested expands that sit in the root, which should cover every
    // case for Jira software
    const output = [];
    for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($50669f552f016dd9$var$convertNodeToExpand(node, schema));
    else output.push(node);
    return output;
}
function $50669f552f016dd9$export$cd936b894f116ed8(nodes, schema, _parentNode) {
    const output = [];
    let inlineNodeBuffer = [];
    for (const node of nodes){
        if (!node.isBlock) {
            inlineNodeBuffer.push(node);
            continue;
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, $4UJvN.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        inlineNodeBuffer = []; // clear buffer
        output.push(node);
    }
    if (inlineNodeBuffer.length > 0) output.push(...(0, $4UJvN.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
    if (output.length === 0) return [
        (0, $4UJvN.createEmptyParagraphNode)(schema)
    ];
    return output;
}
/**
 * Normalize the list of the given nodes for media groups.
 * The rule is: if there are consecutive media group nodes (each with a single child media
 * node) separated by any space or a single newline, then merge them into one media group
 * with multiple child media nodes.
 * @param nodes list of nodes to normalize. Must not be null
 * @param schema
 */ function $50669f552f016dd9$var$normalizeMediaGroups(nodes, schema, _parentNode) {
    const output = [];
    let mediaGroupBuffer = [];
    let separatorBuffer = [];
    for (const n of nodes){
        if (n.type.name === 'mediaGroup' && n.childCount === 1) {
            mediaGroupBuffer.push(n);
            //separator buffer keeps track of the seperator(s) between each mediaGroup nodes,
            //so needs resetting every time we encounter a new mediaGroup node
            separatorBuffer = [];
            continue;
        }
        if (mediaGroupBuffer.length > 0) {
            if ($50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                output.push(...separatorBuffer);
                output.push(n);
                mediaGroupBuffer = [];
                separatorBuffer = [];
            } else separatorBuffer.push(n);
            continue;
        }
        output.push(n);
    }
    if (mediaGroupBuffer.length > 0) output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
    // Dump everything else from separator buffer if anything is left
    output.push(...separatorBuffer);
    return output;
}
/**
 * Creates a single mediaGroup whose children are the single media elements from the given mediaGroupNodes.
 * @param mediaGroupNodes list of mediaGroups that have a single child each
 * @param schema the schema
 */ function $50669f552f016dd9$var$createMergedMediaGroup(mediaGroupNodes, schema) {
    const { mediaGroup: mediaGroup } = schema.nodes;
    const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
    return mediaGroup.createChecked({}, mediaNodes);
}
function $50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer) {
    return $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) || !$50669f552f016dd9$var$isEmptyTextNode(n) || $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n);
}
/**
 * Existing media groups with more than one child is considered as a significant separator.
 */ function $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n) {
    return n.type.name === 'mediaGroup' && n.childCount > 1;
}
/**
 * If the current node is a hard break, AND there's already at least
 * one hard break in the separator buffer, then we want to return true.
 * @param n the current node to examine
 * @param separatorBuffer the existing separator buffer.
 */ function $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) {
    return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
}
function $50669f552f016dd9$var$isEmptyTextNode(n) {
    return n.textContent !== undefined && n.textContent.trim().length === 0;
}
function $50669f552f016dd9$export$19b6d0f3f1dd6ddf(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
function $50669f552f016dd9$var$convertNodeToExpand(node, schema) {
    const { expand: expand } = schema.nodes;
    return expand.createChecked(node.attrs, node.content);
}

});
parcelRegister("4UJvN", function(module, exports) {

$parcel$export(module.exports, "createEmptyParagraphNode", () => $4ae1f625ac901e34$export$e930a5cfe8596ea0);
$parcel$export(module.exports, "createParagraphNodeFromInlineNodes", () => $4ae1f625ac901e34$export$f0eaed48ea684567);
function $4ae1f625ac901e34$export$e930a5cfe8596ea0(schema) {
    const { paragraph: paragraph } = schema.nodes;
    return paragraph.createChecked({}, []);
}
function $4ae1f625ac901e34$export$f0eaed48ea684567(inlineNodes, schema) {
    const { paragraph: paragraph } = schema.nodes;
    const result = [];
    const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
    if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
    return result;
}

});



parcelRegister("9jjzg", function(module, exports) {

$parcel$export(module.exports, "resolveLink", () => $c08b1d888f635e2c$export$c2baa561eb017101);

var $30RSK = parcelRequire("30RSK");

var $lRYXZ = parcelRequire("lRYXZ");

var $b0Iw2 = parcelRequire("b0Iw2");

var $k1MiS = parcelRequire("k1MiS");
// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
const $c08b1d888f635e2c$var$linkResolverStrategies = [
    (0, $lRYXZ.attachmentLinkResolver),
    (0, $30RSK.mentionLinkResolver),
    (0, $k1MiS.issueLinkResolver),
    (0, $b0Iw2.urlLinkResolver)
];
function $c08b1d888f635e2c$export$c2baa561eb017101(link, schema, context) {
    const length = link.originalLinkText.length + 2;
    for (const resolver of $c08b1d888f635e2c$var$linkResolverStrategies){
        const resolvedLink = resolver(link, schema, context);
        if (resolvedLink) return {
            length: length,
            nodes: resolvedLink,
            type: 'pmnode'
        };
    }
    return undefined;
}

});
parcelRegister("30RSK", function(module, exports) {

$parcel$export(module.exports, "mentionLinkResolver", () => $bbe5fc702887fa8b$export$1da3b34e38fc6ca8);
function $bbe5fc702887fa8b$export$1da3b34e38fc6ca8(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
        schema.nodes.paragraph.createChecked({}, [
            schema.nodes.text.create({})
        ])
    ];
    if (link.notLinkBody.startsWith('~')) {
        const mentionText = link.notLinkBody.substring(1);
        const mentionKey = mentionText.toLowerCase();
        const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id
            })
        ];
    }
    return;
}

});

parcelRegister("lRYXZ", function(module, exports) {

$parcel$export(module.exports, "attachmentLinkResolver", () => $2514090e6b8dffff$export$ce918f41a76b8445);

var $4vpto = parcelRequire("4vpto");
function $2514090e6b8dffff$export$ce918f41a76b8445(link, schema, context) {
    if (link.attachmentName) return [
        (0, $4vpto.default)(schema, link.attachmentName, context)
    ];
    return;
}

});
parcelRegister("4vpto", function(module, exports) {

$parcel$export(module.exports, "default", () => $904a1bc635a5ad9a$export$2e2bcd8739ae039);
function $904a1bc635a5ad9a$export$2e2bcd8739ae039(schema, filename, context = {}) {
    const { media: media, mediaGroup: mediaGroup } = schema.nodes;
    // try to look up media ID from conversion context
    const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
    // try to look up collection from media context
    const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
    const mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || ''
    });
    return mediaGroup.createChecked({}, mediaNode);
}

});


parcelRegister("b0Iw2", function(module, exports) {

$parcel$export(module.exports, "urlLinkResolver", () => $e20b005b86e07eab$export$b737d556d2167f9);

var $kSL4h = parcelRequire("kSL4h");

var $iZOJ9 = parcelRequire("iZOJ9");

var $29zBb = parcelRequire("29zBb");

var $gxAE9 = parcelRequire("gxAE9");
function $e20b005b86e07eab$export$b737d556d2167f9(link, schema, context) {
    const output = [];
    const url = link.notLinkBody;
    const textRepresentation = link.linkBody || link.notLinkBody;
    if (!(0, $iZOJ9.isSafeUrl)(url)) return;
    const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).ISSUE_KEY
    ];
    const rawContent = (0, $29zBb.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input: textRepresentation.replace(/^mailto:/, '')
    });
    const decoratedContent = rawContent.map((n)=>{
        const mark = schema.marks.link.create({
            href: url
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'link',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    output.push(...decoratedContent);
    if (!$e20b005b86e07eab$var$hasTextNode(rawContent)) {
        const mark = schema.marks.link.create({
            href: url
        });
        const linkTextNode = schema.text(textRepresentation, [
            mark
        ]);
        output.push(linkTextNode);
    }
    return output;
}
function $e20b005b86e07eab$var$hasTextNode(nodes) {
    return nodes.find((n)=>{
        return n.type.name === 'text';
    });
}

});
parcelRegister("gxAE9", function(module, exports) {

$parcel$export(module.exports, "hasAnyOfMarks", () => $fd57502cc274f1df$export$30c14ec359b8cbf0);
$parcel$export(module.exports, "isDigit", () => $fd57502cc274f1df$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isBlank", () => $fd57502cc274f1df$export$7ee701e290d9865);
$parcel$export(module.exports, "isNotBlank", () => $fd57502cc274f1df$export$4d9e7a1c098df5e2);
$parcel$export(module.exports, "getSurroundingSymbols", () => $fd57502cc274f1df$export$ddec3d40bf5e3693);
$parcel$export(module.exports, "StringBuffer", () => $fd57502cc274f1df$export$83347051c3437dc9);
function $fd57502cc274f1df$export$30c14ec359b8cbf0(node, types) {
    return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
}
function $fd57502cc274f1df$export$727d9dbc4fbb948f(value) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!value.match(/^\d$/);
}
function $fd57502cc274f1df$export$7ee701e290d9865(value) {
    return value === null || value.trim() === '';
}
function $fd57502cc274f1df$export$4d9e7a1c098df5e2(value) {
    return !$fd57502cc274f1df$export$7ee701e290d9865(value);
}
const $fd57502cc274f1df$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
    const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
    const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
    const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
    return {
        openingSymbol: openingSymbol,
        closingSymbol: closingSymbol
    };
};
class $fd57502cc274f1df$export$83347051c3437dc9 {
    constructor(buffer = ''){
        this.buffer = buffer;
    }
    indexOf(value) {
        return this.buffer.indexOf(value);
    }
    lastIndexOf(value) {
        return this.buffer.lastIndexOf(value);
    }
    charAt(index) {
        return this.buffer.charAt(index);
    }
    length() {
        return this.buffer.length;
    }
    delete(start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    }
    append(value) {
        this.buffer += value;
    }
    substring(start, end) {
        return this.buffer.substring(start, end);
    }
    deleteCharAt(index) {
        this.delete(index, index + 1);
    }
    toString() {
        return this.buffer;
    }
}

});


parcelRegister("k1MiS", function(module, exports) {

$parcel$export(module.exports, "issueLinkResolver", () => $7a9a102a7215e3d4$export$f40ed0efa65d4e8);

var $bOMPB = parcelRequire("bOMPB");
function $7a9a102a7215e3d4$export$f40ed0efa65d4e8(link, schema, context) {
    const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
    if (linkTitle === 'smart-card' || linkTitle === 'block-link' // TODO: Depricated should be removed in the next major release
    ) return [
        schema.nodes.blockCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-link') return [
        schema.nodes.inlineCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-embed') return [
        schema.nodes.embedCard.createChecked({
            url: notLinkBody
        })
    ];
    const issue = (0, $bOMPB.getIssue)(context, originalLinkText);
    if (issue) return (0, $bOMPB.buildInlineCard)(schema, issue);
    return undefined;
}

});
parcelRegister("bOMPB", function(module, exports) {

$parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", () => $ce5ca7baa00e39d0$export$a1a15f4d91e860d9);
$parcel$export(module.exports, "issueKey", () => $ce5ca7baa00e39d0$export$a0d841e329cebd91);
$parcel$export(module.exports, "getIssue", () => $ce5ca7baa00e39d0$export$34403cb88b30d33b);
$parcel$export(module.exports, "buildInlineCard", () => $ce5ca7baa00e39d0$export$cdebb4bc59c595a);
$parcel$export(module.exports, "buildIssueKeyRegex", () => $ce5ca7baa00e39d0$export$cd8701ad7512efee);

var $gxAE9 = parcelRequire("gxAE9");
const $ce5ca7baa00e39d0$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
const $ce5ca7baa00e39d0$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
    // This scenario happens when context is empty
    if (!context.issueKeyRegex) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const match = input.substring(position).match(context.issueKeyRegex);
    if (!match) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const issue = $ce5ca7baa00e39d0$export$34403cb88b30d33b(context, match[0]);
    // This scenario happens when context doesn't has all the issues inside a markup
    if (!issue) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const charBefore = input.charAt(position - 1);
    const charAfter = input.charAt(position + issue.key.length);
    if ((0, $gxAE9.isNotBlank)(charBefore) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charBefore) || (0, $gxAE9.isNotBlank)(charAfter) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charAfter)) return $ce5ca7baa00e39d0$var$fallback(input, position);
    return {
        type: 'pmnode',
        nodes: $ce5ca7baa00e39d0$export$cdebb4bc59c595a(schema, issue),
        length: match[0].length
    };
};
const $ce5ca7baa00e39d0$var$fallback = (input, position)=>({
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    });
const $ce5ca7baa00e39d0$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
        key: key,
        url: context.conversion.inlineCardConversion[key]
    } : null;
const $ce5ca7baa00e39d0$export$cdebb4bc59c595a = (schema, issue)=>{
    return [
        schema.nodes.inlineCard.createChecked({
            url: $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp(issue)
        })
    ];
};
const $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp = (issue)=>$ce5ca7baa00e39d0$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ce5ca7baa00e39d0$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
const $ce5ca7baa00e39d0$export$cd8701ad7512efee = (inlineCardConversion)=>{
    if (!inlineCardConversion) return undefined;
    const pattern = Object.keys(inlineCardConversion).join('|');
    if (!pattern) return undefined;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return new RegExp(`^(${pattern})`);
};

});



parcelRegister("gGleW", function(module, exports) {

$parcel$export(module.exports, "parseContentLink", () => $57e1d7866034b37b$export$3a250a08d37b0eae);

var $gxAE9 = parcelRequire("gxAE9");
/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */ function $57e1d7866034b37b$var$trimIfPossible(s) {
    if (s === null) return null;
    return s.trim();
}
function $57e1d7866034b37b$var$extractLinkBody(buffer) {
    const indexOfBang = buffer.indexOf('!');
    const indexOfPipe = buffer.indexOf('|');
    const lastIndexOfBang = buffer.lastIndexOf('!');
    const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
    if (notEscaped) return $57e1d7866034b37b$var$divideOn(buffer, '|');
    const body = new (0, $gxAE9.StringBuffer)();
    let inEscape = false;
    for(let i = 0; i < buffer.length(); i++){
        const c = buffer.charAt(i);
        if (c === '!') inEscape = !inEscape;
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function $57e1d7866034b37b$var$divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) return null;
    return $57e1d7866034b37b$var$divideAfter(buffer, buffer.lastIndexOf(divider));
}
function $57e1d7866034b37b$var$divideAfter(buffer, index) {
    if (typeof index === 'string') index = buffer.indexOf(index);
    if (index < 0) return null;
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    } else {
        const body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */ function $57e1d7866034b37b$var$divideOn(buffer, divider) {
    if (buffer.length() === 0) return null;
    const i = buffer.indexOf(divider);
    if (i < 0) return null;
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    } else {
        const body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function $57e1d7866034b37b$var$extractNumber(buf) {
    const digits = new (0, $gxAE9.StringBuffer)();
    let i = 0;
    for(; i < buf.length() && (0, $gxAE9.isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
    if (i > 0) buf.delete(0, i);
    try {
        return parseInt(digits.toString(), 10);
    } catch (e) {
        return 0;
    }
}
function $57e1d7866034b37b$export$2d20cd44728d07a1(linkText) {
    const originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
    const buf = new (0, $gxAE9.StringBuffer)(linkText);
    const linkBody = $57e1d7866034b37b$var$extractLinkBody(buf);
    const linkTitle = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '|'));
    const notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody
    };
}
function $57e1d7866034b37b$export$3a250a08d37b0eae(link) {
    if (typeof link === 'string') link = $57e1d7866034b37b$export$2d20cd44728d07a1(link);
    const { notLinkBody: notLinkBody } = link;
    let shortcutName = null;
    let shortcutValue = null;
    let spaceKey = null;
    let attachmentName = null;
    let anchor = null;
    let destinationTitle = '';
    let contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        const shortcutBuf = new (0, $gxAE9.StringBuffer)(notLinkBody);
        shortcutName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfterLast(shortcutBuf, '@'));
        if ((0, $gxAE9.isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
    }
    const buf = new (0, $gxAE9.StringBuffer)(notLinkBody);
    if ((0, $gxAE9.isBlank)(shortcutName)) {
        spaceKey = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = $57e1d7866034b37b$var$extractNumber(buf);
            if (contentId === 0) return {
                ...link,
                shortcutName: shortcutName,
                shortcutValue: shortcutValue,
                spaceKey: spaceKey,
                contentId: contentId,
                attachmentName: attachmentName,
                anchor: anchor,
                destinationTitle: destinationTitle
            };
        }
        attachmentName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '^'));
        anchor = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '#'));
    }
    if (contentId === 0) destinationTitle = buf.toString().trim();
    return {
        ...link,
        shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle
    };
}

});




parcelRegister("30Un5", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $0c863b8155c1a336$export$67dc04e652a298ca);

var $4Dfwq = parcelRequire("4Dfwq");
// bq. foobarbaz
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0c863b8155c1a336$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
const $0c863b8155c1a336$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($0c863b8155c1a336$var$BLOCKQUOTE_REGEXP);
    if (!match) return $0c863b8155c1a336$var$fallback(input, position);
    const [, rawContent] = match;
    return (0, $4Dfwq.rawContentProcessor)('', rawContent, match[0].length, schema, context);
};
function $0c863b8155c1a336$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("4Dfwq", function(module, exports) {

$parcel$export(module.exports, "quoteMacro", () => $0723b4b23edf777c$export$8f9545cee64b3251);
$parcel$export(module.exports, "rawContentProcessor", () => $0723b4b23edf777c$export$c2a5e4612254bfa);

var $3JW2n = parcelRequire("3JW2n");

var $gxAE9 = parcelRequire("gxAE9");

var $20lXC = parcelRequire("20lXC");

var $29zBb = parcelRequire("29zBb");
const $0723b4b23edf777c$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: $0723b4b23edf777c$export$c2a5e4612254bfa,
        context: context
    });
};
const $0723b4b23edf777c$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
    if (!rawContent.length) {
        const emptyQuote = $0723b4b23edf777c$var$emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [
                emptyQuote
            ],
            length: length
        };
    }
    const parsedContent = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $20lXC.normalizePMNodes)(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: $0723b4b23edf777c$var$sanitize(normalizedContent, schema),
        length: length
    };
};
function $0723b4b23edf777c$var$emptyBlockquote(schema) {
    const p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function $0723b4b23edf777c$var$sanitize(nodes, schema) {
    const output = [];
    let contentBuffer = [];
    for (const n of nodes)switch(n.type.name){
        case 'paragraph':
        case 'bulletList':
        case 'orderedList':
        case 'codeBlock':
        case 'mediaSingle':
        case 'mediaGroup':
            /**
				 * blockquote supports nesting paragraphs, lists, codeblocks and media nodes
				 */ contentBuffer.push(n);
            break;
        case 'heading':
            /**
				 * If a heading is inside a list item
				 * - h1. Bold, Uppercase
				 * - h2. Bold, Italic
				 * - h3. Bold
				 * - h4. Bold, Gray
				 * - h5. Gray, Italic
				 * - h6. Gray
				 */ contentBuffer.push($0723b4b23edf777c$var$transformHeading(n, schema));
            break;
        default:
            /**
				 * Anything else should be lifted
				 */ if (contentBuffer.length) {
                const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                output.push(blockquote);
                contentBuffer = [];
            }
            output.push(n);
    }
    if (contentBuffer.length) {
        const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function $0723b4b23edf777c$var$transformHeading(heading, schema) {
    const contentBuffer = [];
    heading.content.forEach((n)=>{
        const strong = schema.marks.strong.create();
        const italic = schema.marks.em.create();
        const gray = schema.marks.textColor.create({
            color: '#97a0af'
        });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) // @ts-ignore assigning to readonly prop to transform text
            n.text = n.text.toUpperCase();
            if (heading.attrs.level <= 4 && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'strong',
                'code'
            ])) n = n.mark([
                ...n.marks,
                strong
            ]);
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) n = n.mark([
                ...n.marks,
                italic
            ]);
            if (heading.attrs.level > 3 && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) n = n.mark([
                ...n.marks,
                gray
            ]);
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}

});
parcelRegister("3JW2n", function(module, exports) {

$parcel$export(module.exports, "commonMacro", () => $108725731ca4984f$export$b6a12943ac1bb1ba);
function $108725731ca4984f$export$b6a12943ac1bb1ba(input, schema, opt) {
    /**
	 * Forging the opening regex, the result would look something like
	 * /^\{(quote)(?::([^\{\n\}]*))?\}/i
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
    const matchOpening = input.match(opening);
    if (!matchOpening) return $108725731ca4984f$var$fallback(input);
    const [, name, rawAttrs] = matchOpening;
    const openingLength = matchOpening[0].length;
    if (!opt.paired) /**
		 * Some macros do not have a closing symbol, for example
		 * {anchor:here} {loremipsum}
		 */ return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
    /**
	 * Forging the closing regex, the result would look something like
	 * /\{quote\}/
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const closing = new RegExp(`\{${name}\}`);
    const matchClosing = closing.exec(input.substring(openingLength));
    let rawContent = '';
    if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
}
function $108725731ca4984f$var$fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1
    };
}

});



parcelRegister("coK8g", function(module, exports) {

$parcel$export(module.exports, "citation", () => $624cf9f0f9a0e4f4$export$258632c953c109e9);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");

const $624cf9f0f9a0e4f4$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY
    ];
    // Add code mark to each text
    const contentDecorator = (n, index)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) {
            if (index === 0) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
            n.text = `${0, $0c0aa3654d545c29$export$3bca9fae3002bd9b} ${n.text}`;
            return n.mark([
                ...n.marks,
                mark
            ]);
        }
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '??', '??');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
const $0c0aa3654d545c29$export$3bca9fae3002bd9b = "\u2014";


parcelRegister("5RdHN", function(module, exports) {

$parcel$export(module.exports, "deleted", () => $b9ac580681c978af$export$bccbf0c716f226f4);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $b9ac580681c978af$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    /** Add strike mark to each text */ const contentDecorator = (n)=>{
        const mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'strike',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '-', '-');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("55t1E", function(module, exports) {

$parcel$export(module.exports, "doubleDashSymbol", () => $74a06c4540bbf40b$export$65e3ca7c95899a2d);

var $1rQjR = parcelRequire("1rQjR");
const $74a06c4540bbf40b$var$token = {
    type: 'text',
    text: '\u2013',
    length: 2
};
const $74a06c4540bbf40b$var$fallback = {
    ...$74a06c4540bbf40b$var$token,
    text: '--'
};
const $74a06c4540bbf40b$export$65e3ca7c95899a2d = (0, $1rQjR.createDashTokenParser)($74a06c4540bbf40b$var$token, $74a06c4540bbf40b$var$fallback);

});
parcelRegister("1rQjR", function(module, exports) {

$parcel$export(module.exports, "createDashTokenParser", () => $75f433a8b52a8173$export$d43b58865d429e3c);
const $75f433a8b52a8173$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
        /**
		 * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
		 *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
		 *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
		 */ if (position > 0) {
            const charBeforeToken = input.charAt(position - 1);
            if (!$75f433a8b52a8173$var$isSpace(charBeforeToken)) return fallback;
        }
        if (position + token.length < input.length) {
            const charAfterToken = input.charAt(position + token.length);
            if (!$75f433a8b52a8173$var$isSpace(charAfterToken)) return fallback;
        }
        return token;
    };
const $75f433a8b52a8173$var$isSpace = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /\s/.test(char);
};

});


parcelRegister("jor5q", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $487b5ddb28312972$export$a19185d1233fc4b2);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $487b5ddb28312972$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
const $487b5ddb28312972$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
    const substring = input.substring(position);
    /**
	 * The length of wikimakrup emoji test ranges from 2 to 9 characters at the time of writing.
	 */ for(let i = 2; i <= 9 && i <= substring.length; ++i){
        const candidateText = substring.substring(0, i);
        const emojiId = $487b5ddb28312972$export$fabd2c9504f5bf35[candidateText];
        // Is current candidate an emoji AND next character empty string any special character?
        if (emojiId && $487b5ddb28312972$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.emoji.createChecked($487b5ddb28312972$export$797c048dfde076a1[emojiId])
            ],
            length: i
        };
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1
    };
};
const $487b5ddb28312972$export$797c048dfde076a1 = {
    '1f642': {
        id: '1f642',
        shortName: ':slight_smile:',
        text: "\uD83D\uDE42"
    },
    '1f61e': {
        id: '1f61e',
        shortName: ':disappointed:',
        text: "\uD83D\uDE1E"
    },
    '1f61b': {
        id: '1f61b',
        shortName: ':stuck_out_tongue:',
        text: "\uD83D\uDE1B"
    },
    '1f603': {
        id: '1f603',
        shortName: ':smiley:',
        text: "\uD83D\uDE03"
    },
    '1f609': {
        id: '1f609',
        shortName: ':wink:',
        text: "\uD83D\uDE09"
    },
    '1f44d': {
        id: '1f44d',
        shortName: ':thumbsup:',
        text: "\uD83D\uDC4D"
    },
    '1f44e': {
        id: '1f44e',
        shortName: ':thumbsdown:',
        text: "\uD83D\uDC4E"
    },
    'atlassian-info': {
        id: 'atlassian-info',
        shortName: ':info:',
        text: ':info:'
    },
    'atlassian-check_mark': {
        id: 'atlassian-check_mark',
        shortName: ':check_mark:',
        text: ':check_mark:'
    },
    'atlassian-cross_mark': {
        id: 'atlassian-cross_mark',
        shortName: ':cross_mark:',
        text: ':cross_mark:'
    },
    'atlassian-warning': {
        id: 'atlassian-warning',
        shortName: ':warning:',
        text: ':warning:'
    },
    'atlassian-plus': {
        id: 'atlassian-plus',
        shortName: ':plus:',
        text: ':plus:'
    },
    'atlassian-minus': {
        id: 'atlassian-minus',
        shortName: ':minus:',
        text: ':minus:'
    },
    'atlassian-question_mark': {
        id: 'atlassian-question_mark',
        shortName: ':question:',
        text: ':question:'
    },
    'atlassian-light_bulb_on': {
        id: 'atlassian-light_bulb_on',
        shortName: ':light_bulb_on:',
        text: ':light_bulb_on:'
    },
    'atlassian-light_bulb_off': {
        id: 'atlassian-light_bulb_off',
        shortName: ':light_bulb_off:',
        text: ':light_bulb_off:'
    },
    'atlassian-yellow_star': {
        id: 'atlassian-yellow_star',
        shortName: ':yellow_star:',
        text: ':yellow_star:'
    },
    'atlassian-red_star': {
        id: 'atlassian-red_star',
        shortName: ':red_star:',
        text: ':red_star:'
    },
    'atlassian-green_star': {
        id: 'atlassian-green_star',
        shortName: ':green_star:',
        text: ':green_star:'
    },
    'atlassian-blue_star': {
        id: 'atlassian-blue_star',
        shortName: ':blue_star:',
        text: ':blue_star:'
    },
    'atlassian-flag_on': {
        id: 'atlassian-flag_on',
        shortName: ':flag_on:',
        text: ':flag_on:'
    },
    'atlassian-flag_off': {
        id: 'atlassian-flag_off',
        shortName: ':flag_off:',
        text: ':flag_off:'
    }
};
const $487b5ddb28312972$export$fabd2c9504f5bf35 = {
    ':)': '1f642',
    ':-)': '1f642',
    ':(': '1f61e',
    ':-(': '1f61e',
    ':P': '1f61b',
    ':-P': '1f61b',
    ':p': '1f61b',
    ':-p': '1f61b',
    ':D': '1f603',
    ':-D': '1f603',
    ';)': '1f609',
    ';-)': '1f609',
    '(y)': '1f44d',
    '(n)': '1f44e',
    '(i)': 'atlassian-info',
    '(/)': 'atlassian-check_mark',
    '(x)': 'atlassian-cross_mark',
    '(!)': 'atlassian-warning',
    '(+)': 'atlassian-plus',
    '(-)': 'atlassian-minus',
    '(?)': 'atlassian-question_mark',
    '(on)': 'atlassian-light_bulb_on',
    '(off)': 'atlassian-light_bulb_off',
    '(*)': 'atlassian-yellow_star',
    '(*y)': 'atlassian-yellow_star',
    '(*r)': 'atlassian-red_star',
    '(*g)': 'atlassian-green_star',
    '(*b)': 'atlassian-blue_star',
    '(flag)': 'atlassian-flag_on',
    '(flagoff)': 'atlassian-flag_off'
};

});

parcelRegister("hZ14o", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $5100d4ec4f1b4884$export$bef81ba411953b51);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $5100d4ec4f1b4884$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '_', '_');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("6xaH8", function(module, exports) {

$parcel$export(module.exports, "hardbreak", () => $bc70e1090faff3e6$export$ac55bb44695749c1);

var $eWAZI = parcelRequire("eWAZI");
const $bc70e1090faff3e6$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
    // Look for normal hardbreak \r, \n, \r\n
    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(position));
    if (length === 0) // not a valid hardbreak
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
    return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: length
    };
};

});

parcelRegister("jMpI6", function(module, exports) {

$parcel$export(module.exports, "heading", () => $ed15d3e22c065f91$export$46e4a324ac90507f);

var $29zBb = parcelRequire("29zBb");

var $kSL4h = parcelRequire("kSL4h");
// h1. HEADING
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ed15d3e22c065f91$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
const $ed15d3e22c065f91$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL
    ];
    const match = input.substring(position).match($ed15d3e22c065f91$var$HEADING_REGEXP);
    if (!match) return $ed15d3e22c065f91$var$fallback(input, position);
    const level = parseInt(match[1], 10);
    const content = (0, $29zBb.parseString)({
        schema: schema,
        ignoreTokenTypes: ignoreTokenTypes,
        context: context,
        input: match[2]
    });
    try {
        const headingNode = schema.nodes.heading.createChecked({
            level: level
        }, content);
        return {
            type: 'pmnode',
            nodes: [
                headingNode
            ],
            length: match[0].length
        };
    } catch (err) {
        /**
		 * If the heading fails to rendering, we want to skip the text
		 * "h1."
		 */ return {
            type: 'text',
            text: '',
            length: 4
        };
    }
};
function $ed15d3e22c065f91$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});

parcelRegister("iDsRr", function(module, exports) {

$parcel$export(module.exports, "inserted", () => $33f79eddf582429a$export$744ba74fb86b8ca7);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $33f79eddf582429a$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'underline',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '+', '+');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("ayQVO", function(module, exports) {

$parcel$export(module.exports, "MAX_LIST_DEPTH", () => $4813b87fbe6448cc$export$d2a2f0ec33d903e1);
$parcel$export(module.exports, "list", () => $4813b87fbe6448cc$export$8837f4fc672e936d);

var $hnQWb = parcelRequire("hnQWb");

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");

var $cG4PY = parcelRequire("cG4PY");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $gxAE9 = parcelRequire("gxAE9");
const $4813b87fbe6448cc$export$d2a2f0ec33d903e1 = 20;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$4813b87fbe6448cc$export$d2a2f0ec33d903e1}}) `);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
const $4813b87fbe6448cc$var$processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3
};
const $4813b87fbe6448cc$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a listItem
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).LIST,
        (0, $kSL4h.TokenType).TABLE
    ];
    let index = position;
    let state = $4813b87fbe6448cc$var$processState.NEW_LINE;
    let buffer = [];
    let lastListSymbols = null;
    let builder = null;
    let contentBuffer = [];
    const output = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $4813b87fbe6448cc$var$processState.NEW_LINE:
                {
                    const substring = input.substring(index);
                    const listMatch = substring.match($4813b87fbe6448cc$var$LIST_ITEM_REGEXP);
                    if (listMatch) {
                        const [, symbols] = listMatch;
                        // Handle ruler in list
                        const rulerMatch = symbols.match($4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP);
                        if (rulerMatch) {
                            const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                            const emptyLineMatch = remainingAfterSymbol.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                            // If this is an empty line skip to the buffering step rather than match as a list element
                            if (emptyLineMatch) {
                                state = $4813b87fbe6448cc$var$processState.BUFFER;
                                continue;
                            }
                        }
                        if (!builder) {
                            // It happens because this is the first item of the list
                            builder = new (0, $hnQWb.ListBuilder)(schema, symbols);
                            lastListSymbols = symbols;
                        } else {
                            /**
						 * There is a builder, so we are in the middle of building a list
						 * and now there is a new list item
						 */ if (buffer.length > 0) {
                                // Wrap up previous list item and clear buffer
                                const content = (0, $29zBb.parseString)({
                                    ignoreTokenTypes: ignoreTokenTypes,
                                    schema: schema,
                                    context: context,
                                    input: buffer.join(''),
                                    includeLeadingSpace: true
                                });
                                contentBuffer.push(...content);
                                builder.add([
                                    {
                                        style: lastListSymbols,
                                        content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
                                    }
                                ]);
                                buffer = [];
                                contentBuffer = [];
                            }
                            // We finished last list item here, going to the new one
                            lastListSymbols = symbols;
                            const type = (0, $hnQWb.getType)(symbols);
                            // If it's top level and doesn't match, create a new list
                            if (type !== builder.type && symbols.length === 1) {
                                output.push(...builder.buildPMNode());
                                builder = new (0, $hnQWb.ListBuilder)(schema, symbols);
                            }
                        }
                        index += listMatch[0].length;
                    }
                    // If we encounter an empty line, we should end the list
                    const emptyLineMatch = substring.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        state = $4813b87fbe6448cc$var$processState.END;
                        continue;
                    }
                    state = $4813b87fbe6448cc$var$processState.BUFFER;
                    continue;
                }
            case $4813b87fbe6448cc$var$processState.BUFFER:
                {
                    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(index));
                    if (length) {
                        buffer.push(input.substr(index, length));
                        state = $4813b87fbe6448cc$var$processState.NEW_LINE;
                        index += length;
                        continue;
                    }
                    if (char === '{') {
                        state = $4813b87fbe6448cc$var$processState.MACRO;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $4813b87fbe6448cc$var$processState.MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $4813b87fbe6448cc$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    state = $4813b87fbe6448cc$var$processState.BUFFER;
                    continue;
                }
            case $4813b87fbe6448cc$var$processState.END:
                if (!builder) // Something is really wrong here
                return $4813b87fbe6448cc$var$fallback(input, position);
                if (buffer.length > 0) {
                    // Wrap up previous list item and clear buffer
                    const content = (0, $29zBb.parseString)({
                        ignoreTokenTypes: ignoreTokenTypes,
                        schema: schema,
                        context: context,
                        input: buffer.join(''),
                        includeLeadingSpace: true
                    });
                    contentBuffer.push(...content);
                }
                builder.add([
                    {
                        style: lastListSymbols,
                        content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
                    }
                ]);
                output.push(...builder.buildPMNode());
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrap up what's left in the buffer
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: buffer.join(''),
            includeLeadingSpace: true
        });
        contentBuffer.push(...content);
    }
    if (builder) {
        builder.add([
            {
                style: lastListSymbols,
                content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
            }
        ]);
        output.push(...builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $4813b87fbe6448cc$var$sanitize(nodes, schema) {
    return nodes.reduce((result, curr)=>{
        switch(curr.type.name){
            case 'blockquote':
                /**
				 * If a blockquote is inside a list item
				 * - Convert it to paragraph
				 */ curr.content.forEach((n)=>{
                    result.push(n);
                });
                break;
            case 'heading':
                {
                    /**
				 * If a heading is inside a list item
				 * - Convert the heading to paragraph
				 * - Convert text to upper case
				 * - Mark text with strong.
				 */ const contentBuffer = [];
                    curr.content.forEach((n)=>{
                        const mark = schema.marks.strong.create();
                        if (n.type.name === 'text') {
                            if (n.text) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
                            n.text = n.text.toUpperCase();
                            if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
                                'strong',
                                'code'
                            ])) contentBuffer.push(n.mark([
                                ...n.marks,
                                mark
                            ]));
                            else contentBuffer.push(n);
                        } else contentBuffer.push(n);
                    });
                    const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                    result.push(p);
                    break;
                }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function $4813b87fbe6448cc$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("hnQWb", function(module, exports) {

$parcel$export(module.exports, "getType", () => $3303253e6091964c$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "ListBuilder", () => $3303253e6091964c$export$876cfa3161bef296);
const $3303253e6091964c$var$supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
    'codeBlock'
];
function $3303253e6091964c$export$e2b5c5db9e2009fd(bullets) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
}
class $3303253e6091964c$export$876cfa3161bef296 {
    constructor(schema, bullets){
        /**
	 * Build prosemirror bulletList or orderedList node
	 * @param {List} list
	 * @returns {PMNode}
	 */ this.parseList = (list)=>{
            const listNode = this.schema.nodes[list.type];
            const output = [];
            let listItemsBuffer = [];
            for(let i = 0; i < list.children.length; i++){
                const parsedContent = this.parseListItem(list.children[i]);
                for(let j = 0; j < parsedContent.length; j++){
                    const parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
				 * If the node is not a listItem, then we need to
				 * wrap exisintg list and break out
				 */ if (listItemsBuffer.length) {
                        const list = listNode.createChecked({}, listItemsBuffer);
                        output.push(list);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                const list = listNode.createChecked({}, listItemsBuffer);
                output.push(list);
            }
            return output;
        };
        /**
	 * Build prosemirror listItem node
	 * This function would possibly return non listItem nodes
	 * which we need to break out later
	 * @param {ListItem} item
	 */ this.parseListItem = (item)=>{
            const output = [];
            if (!item.content) item.content = [];
            // Parse nested list
            const parsedChildren = item.children.reduce((result, list)=>{
                const parsedList = this.parseList(list);
                result.push(...parsedList);
                return result;
            }, []);
            // Append children to the content
            item.content.push(...parsedChildren);
            let contentBuffer = [];
            for(let i = 0; i < item.content.length; i++){
                const pmNode = item.content[i];
                /**
			 * Skip empty paragraph
			 */ if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                /* Skip Empty spaces after rule */ if (this.isParagraphEmptyTextNode(pmNode)) continue;
                if ($3303253e6091964c$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                const listItem = this.createListItem(contentBuffer, this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = {
            children: [],
            type: $3303253e6091964c$export$e2b5c5db9e2009fd(bullets)
        };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    /**
	 * Return the type of the base list
	 * @returns {ListType}
	 */ get type() {
        return this.root.type;
    }
    /**
	 * Add a list item to the builder
	 * @param {AddArgs[]} items
	 */ add(items) {
        for (const item of items){
            const { style: style, content: content } = item;
            // If there's no style, add to previous list item as multiline
            if (style === null) {
                this.appendToLastItem(content);
                continue;
            }
            const depth = style.length;
            const type = $3303253e6091964c$export$e2b5c5db9e2009fd(style);
            if (depth > this.lastDepth) {
                // Add children starting from last node
                this.createNest(depth - this.lastDepth, type);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            } else if (depth === this.lastDepth) // Add list item to current node
            this.lastList = this.addListItem(type, content);
            else {
                // Find node at depth and add list item
                this.lastList = this.findAncestor(this.lastDepth - depth);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            }
        }
    }
    /**
	 * Compile a prosemirror node from the root list
	 * @returns {PMNode[]}
	 */ buildPMNode() {
        return this.parseList(this.root);
    }
    /* Check if all paragraph's children nodes are text and empty */ isParagraphEmptyTextNode(node) {
        if (node.type.name !== 'paragraph' || !node.childCount) return false;
        for(let i = 0; i < node.childCount; i++){
            const n = node.content.child(i);
            if (n.type.name !== 'text') // Paragraph contains non-text node, so not empty
            return false;
            else if (n.textContent.trim() !== '') return false;
        }
        return true;
    }
    createListItem(content, schema) {
        if (content.length === 0 || [
            'paragraph',
            'mediaSingle'
        ].indexOf(content[0].type.name) === -1) // If the content is empty or the first element is not paragraph or mediaSingle.
        // this likely to be a nested list where the toplevel list is empty
        // For example: *# item 1
        // In this case we create an empty paragraph for the top level listNode
        content.unshift(this.schema.nodes.paragraph.createChecked());
        return schema.nodes.listItem.createChecked({}, content);
    }
    /**
	 * Add an item at the same level as the current list item
	 * @param {ListType} type
	 * @param {PMNode} content
	 * @returns {PMNode}
	 */ addListItem(type, content) {
        let list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            const parent = list.parent;
            const newList = {
                children: [],
                type: type,
                parent: parent
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent.children.push(newList);
            this.lastList = list = newList;
        }
        const listItem = {
            content: content,
            parent: list,
            children: []
        };
        list.children = [
            ...list.children,
            listItem
        ];
        return list;
    }
    /**
	 * Append the past content to the last accessed list node (multiline entries)
	 * @param {PMNode[]} content
	 */ appendToLastItem(content) {
        const { children: children } = this.lastList;
        const lastItem = children[children.length - 1];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lastItem.content.push(...content);
    }
    /**
	 * Created a nested list structure of N depth under the current node
	 * @param {number} depth
	 * @param {ListType} type
	 */ createNest(depth, type) {
        while(depth-- > 0){
            if (this.lastList.children.length === 0) {
                const listItem = {
                    parent: this.lastList,
                    children: []
                };
                this.lastList.children = [
                    listItem
                ];
            }
            const nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type
                }
            ];
            this.lastList = nextItem.children[0];
        }
    }
    /**
	 * Find the Nth list ancestor of the current list
	 * @param {number} depth
	 */ findAncestor(depth) {
        let list = this.lastList;
        while(depth-- > 0 && list.parent){
            const listItem = list.parent;
            if (listItem && listItem.parent) list = listItem.parent;
        }
        return list;
    }
}

});


parcelRegister("kPrK8", function(module, exports) {

$parcel$export(module.exports, "monospace", () => $7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).ADF_MACRO,
        (0, $kSL4h.TokenType).ANCHOR_MACRO,
        (0, $kSL4h.TokenType).CODE_MACRO,
        (0, $kSL4h.TokenType).QUOTE_MACRO,
        (0, $kSL4h.TokenType).NOFORMAT_MACRO,
        (0, $kSL4h.TokenType).PANEL_MACRO,
        (0, $kSL4h.TokenType).COLOR_MACRO,
        (0, $kSL4h.TokenType).LOREM_MACRO,
        (0, $kSL4h.TokenType).QUOTE,
        (0, $kSL4h.TokenType).STRING,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).LINK_FORMAT,
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).MEDIA,
        (0, $kSL4h.TokenType).HEADING,
        (0, $kSL4h.TokenType).LIST,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER,
        (0, $kSL4h.TokenType).HARD_BREAK,
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).STRONG,
        (0, $kSL4h.TokenType).MONOSPACE,
        (0, $kSL4h.TokenType).SUPERSCRIPT,
        (0, $kSL4h.TokenType).SUBSCRIPT,
        (0, $kSL4h.TokenType).EMPHASIS,
        (0, $kSL4h.TokenType).CITATION,
        (0, $kSL4h.TokenType).DELETED,
        (0, $kSL4h.TokenType).INSERTED,
        (0, $kSL4h.TokenType).EMOJI,
        (0, $kSL4h.TokenType).FORCE_LINE_BREAK
    ];
    // Add code mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) return n;
        return n.mark([
            mark
        ]);
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '{{', '}}');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4ZFIG", function(module, exports) {

$parcel$export(module.exports, "quadrupleDashSymbol", () => $819171e80205fd1c$export$95a7907a71f31921);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $819171e80205fd1c$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
const $819171e80205fd1c$export$95a7907a71f31921 = ({ input: input, position: position })=>{
    // This won't be a ruler because ruler has been checked at leadingKeywordMapping
    const match = input.substring(position).match($819171e80205fd1c$var$MULTI_DASH_REGEX);
    if (!match) return {
        type: 'text',
        text: '----',
        length: 4
    };
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length
    };
};

});

parcelRegister("91y57", function(module, exports) {

$parcel$export(module.exports, "ruler", () => $cf2c039554fba6e4$export$f9adada2013e846e);

var $i8dZb = parcelRequire("i8dZb");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $cf2c039554fba6e4$var$RULER_REGEX = /^-{4,5}(\s|$)/;
const $cf2c039554fba6e4$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
    const match = input.substring(position).match($cf2c039554fba6e4$var$RULER_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: (0, $i8dZb.createRuleNode)(schema),
        length: match[0].length
    };
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1
    };
};

});
parcelRegister("i8dZb", function(module, exports) {

$parcel$export(module.exports, "createRuleNode", () => $d0cc271b2b6d9a56$export$4267f2e5716b018a);
const $d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
function $d0cc271b2b6d9a56$export$2e2bcd8739ae039(schema, containerNodeType) {
    const { paragraph: paragraph, rule: rule } = schema.nodes;
    if (containerNodeType) {
        const textNode = schema.text($d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    } else return rule.createChecked();
}
function $d0cc271b2b6d9a56$export$4267f2e5716b018a(schema) {
    const { rule: rule } = schema.nodes;
    const ruleNode = rule.createChecked();
    return [
        ruleNode
    ];
}

});


parcelRegister("1Mtv8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $da489456937eda28$export$59ae2c325a998f89);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $da489456937eda28$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding strong mark to all text
    const contentDecorator = (pmNode)=>{
        const mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(pmNode, [
            'strong',
            'code'
        ])) return pmNode.mark([
            ...pmNode.marks,
            mark
        ]);
        return pmNode;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '*', '*');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("77w3e", function(module, exports) {

$parcel$export(module.exports, "subscript", () => $af8d85604a001a66$export$bc5390e4688d2822);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $af8d85604a001a66$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sub'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '~', '~');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("lf0Nr", function(module, exports) {

$parcel$export(module.exports, "superscript", () => $6f4f331694cf9bb6$export$b4aab94a5fcfcead);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $6f4f331694cf9bb6$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sup'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '^', '^');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4s89q", function(module, exports) {

$parcel$export(module.exports, "table", () => $8c7a9474c5649f43$export$9852986a3ec5f6a0);

var $48GZN = parcelRequire("48GZN");

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");

var $7tIdE = parcelRequire("7tIdE");

var $4Foyv = parcelRequire("4Foyv");

var $jor5q = parcelRequire("jor5q");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $cG4PY = parcelRequire("cG4PY");

var $gxAE9 = parcelRequire("gxAE9");
/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8c7a9474c5649f43$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8c7a9474c5649f43$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $8c7a9474c5649f43$var$processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
    EMOJI: 11
};
const $8c7a9474c5649f43$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER
    ];
    const output = [];
    let index = position;
    let currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
    let buffer = [];
    let cellsBuffer = [];
    let cellStyle = '';
    let builder = null;
    while(index < input.length){
        const char = input.charAt(index);
        const substring = input.substring(index);
        switch(currentState){
            case $8c7a9474c5649f43$var$processState.NEW_ROW:
                {
                    const tableMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                    if (tableMatch) {
                        if (!builder) builder = new (0, $48GZN.TableBuilder)(schema);
                        // Capture empty spaces
                        index += tableMatch[1].length;
                        cellStyle = tableMatch[2];
                        index += tableMatch[2].length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                    currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.LINE_BREAK:
                {
                    const emptyLineMatch = substring.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        // If we encounter an empty line, we should end the table
                        $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                        currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                        continue;
                    }
                    // If we enconter a new row
                    const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                    if (cellMatch) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                    else currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.BUFFER:
                {
                    const length = (0, $eWAZI.parseNewlineOnly)(substring);
                    if (length) {
                        // Calculate the index of the end of the current cell,
                        // upto and including the new line
                        const endIndex = index;
                        // Calculate the index of the start of the current cell
                        const startIndex = input.lastIndexOf('|', endIndex) + 1;
                        const charsBefore = input.substring(startIndex, endIndex);
                        if (charsBefore === '' || charsBefore.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP)) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                        else {
                            currentState = $8c7a9474c5649f43$var$processState.LINE_BREAK;
                            buffer.push(input.substr(index, length));
                        }
                        index += length;
                        continue;
                    }
                    switch(char){
                        case '|':
                            {
                                // This is now end of a cell, we should wrap the buffer into a cell
                                $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                buffer = [];
                                // Update cells tyle
                                const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                                // The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop
                                if (cellMatch) {
                                    cellStyle = cellMatch[2];
                                    // Move into the cell content
                                    index += cellMatch[2].length;
                                    continue;
                                }
                                break;
                            }
                        case ':':
                        case ';':
                        case '(':
                            currentState = $8c7a9474c5649f43$var$processState.EMOJI;
                            continue;
                        case '[':
                            currentState = $8c7a9474c5649f43$var$processState.LINK;
                            continue;
                        case '!':
                            currentState = $8c7a9474c5649f43$var$processState.MEDIA;
                            continue;
                        case '{':
                            currentState = $8c7a9474c5649f43$var$processState.MACRO;
                            continue;
                        default:
                            buffer.push(char);
                            index++;
                            continue;
                    }
                    break;
                }
            case $8c7a9474c5649f43$var$processState.CLOSE_ROW:
                {
                    const bufferOutput = buffer.join('');
                    if (bufferOutput.trim().length > 0) {
                        $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                        buffer = [];
                    }
                    if (builder) {
                        builder.add(cellsBuffer);
                        cellsBuffer = [];
                    }
                    currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.END_TABLE:
                if (builder) {
                    if (cellsBuffer.length) builder.add(cellsBuffer);
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
            case $8c7a9474c5649f43$var$processState.MEDIA:
                {
                    const token = (0, $4Foyv.media)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.EMOJI:
                {
                    const token = (0, $jor5q.emoji)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.LINK:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 */ const token = (0, $7tIdE.linkFormat)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                    break;
                }
            case $8c7a9474c5649f43$var$processState.MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
        }
        index++;
    }
    /**
	 * If there are left over content which didn't have a closing |
	 * For example
	 * |cell1|cell2|cell3
	 * we still want to create a new cell for the last cell3 if it's
	 * not empty.
	 */ const bufferOutput = buffer.join('');
    if (bufferOutput.trim().length > 0) $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
    if (builder) {
        if (cellsBuffer.length) builder.add(cellsBuffer);
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $8c7a9474c5649f43$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
    if (buffer.length) {
        let contentNode = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: buffer
        });
        if (style === '||') contentNode = contentNode.map((e)=>{
            return $8c7a9474c5649f43$var$createTableHeader(e, schema);
        });
        cellsBuffer.push({
            style: style,
            content: (0, $20lXC.normalizePMNodes)(contentNode, schema)
        });
    }
}
function $8c7a9474c5649f43$var$createTableHeader(node, schema) {
    const mark = schema.marks.strong.create();
    return $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8c7a9474c5649f43$var$traverseContent(node, mark, schema) {
    if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
    for(let i = 0; i < node.content.childCount; i++){
        const child = node.content.child(i);
        const markedChild = $8c7a9474c5649f43$var$traverseNodeAndAddMarks(child, mark, schema);
        const updatedContent = node.content.replaceChild(i, markedChild);
        node = node.copy(updatedContent);
    }
    return node;
}
function $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema) {
    if (node.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(node, [
        'strong',
        'code'
    ])) {
        const newNode = node.mark([
            ...node.marks,
            mark
        ]);
        return newNode;
    }
    return $8c7a9474c5649f43$var$traverseContent(node, mark, schema);
}

});
parcelRegister("48GZN", function(module, exports) {

$parcel$export(module.exports, "TableBuilder", () => $75a71ab9390c3135$export$9e18c07f56f31a89);
/**
 * Return the cell type based on the delimeter
 */ function $75a71ab9390c3135$var$getType(style) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
}
class $75a71ab9390c3135$export$9e18c07f56f31a89 {
    constructor(schema){
        this.emptyTableCell = ()=>{
            const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = ()=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, this.emptyTableCell());
        };
        /**
	 * Build prosemirror table node
	 * @returns {PMNode}
	 */ this.buildTableNode = ()=>{
            const { root: root } = this;
            const { table: table } = this.schema.nodes;
            const content = root.rows.map(this.buildTableRowNode);
            if (content.length === 0) content.push(this.emptyTableRow());
            return table.createChecked({}, content);
        };
        /**
	 * Build prosemirror tr node
	 * @returns {PMNode}
	 */ this.buildTableRowNode = (row)=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
        };
        /**
	 * Build prosemirror td/th node
	 * @param {TableCell} cell
	 * @returns {PMNode}
	 */ this.buildTableCellNode = (cell)=>{
            const { type: type, content: content } = cell;
            if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
            const cellNode = this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: []
        };
    }
    /**
	 * Return the type of the base element
	 * @returns {string}
	 */ get type() {
        return 'table';
    }
    /**
	 * Add new cells to the table
	 * @param {AddCellArgs[]} cells
	 */ add(cells) {
        if (!cells.length) return;
        // Iterate the cells and create TH/TD based on the delimeter
        let index = 0;
        for (const cell of cells){
            const { content: content, style: style } = cell;
            const cellType = $75a71ab9390c3135$var$getType(style);
            // For the first item, determine if it's a new row or not
            if (index === 0) this.addRow();
            const newCell = {
                type: cellType,
                content: content
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.lastRow.cells.push(newCell);
            index += 1;
        }
    }
    /**
	 * Build a prosemirror table from the data
	 * @returns {PMNode}
	 */ buildPMNode() {
        return this.buildTableNode();
    }
    /**
	 * Add a new row to the table
	 */ addRow() {
        const { rows: rows } = this.root;
        const row = {
            cells: []
        };
        rows.push(row);
        this.lastRow = row;
    }
}

});


parcelRegister("ir9MO", function(module, exports) {

$parcel$export(module.exports, "tripleDashSymbol", () => $0a377f498827084a$export$edbcd749367de060);

var $1rQjR = parcelRequire("1rQjR");
const $0a377f498827084a$var$token = {
    type: 'text',
    text: '\u2014',
    length: 3
};
const $0a377f498827084a$var$fallback = {
    ...$0a377f498827084a$var$token,
    text: '---'
};
const $0a377f498827084a$export$edbcd749367de060 = (0, $1rQjR.createDashTokenParser)($0a377f498827084a$var$token, $0a377f498827084a$var$fallback);

});

parcelRegister("7E14k", function(module, exports) {

$parcel$export(module.exports, "panelMacro", () => $fa58ef1a18570456$export$5d7bf7e31a674541);

var $3JW2n = parcelRequire("3JW2n");

var $29zBb = parcelRequire("29zBb");

var $4ZUg7 = parcelRequire("4ZUg7");

var $20lXC = parcelRequire("20lXC");

var $fQoRM = parcelRequire("fQoRM");

var $1agyv = parcelRequire("1agyv");
const $fa58ef1a18570456$var$allowedNodeType = [
    'paragraph',
    'heading',
    'orderedList',
    'bulletList'
];
const $fa58ef1a18570456$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        context: context,
        rawContentProcessor: $fa58ef1a18570456$var$rawContentProcessor
    });
};
const $fa58ef1a18570456$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    const output = [];
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    const nodeAttrs = {
        ...parsedAttrs,
        panelType: (0, $fQoRM.getPanelType)(parsedAttrs)
    };
    const parsedContent = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $20lXC.normalizePMNodes)(parsedContent, schema);
    let contentBuffer = parsedAttrs.title ? [
        (0, $1agyv.title)(parsedAttrs.title, schema)
    ] : [];
    for (const n of normalizedContent)if ($fa58ef1a18570456$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
    else {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
        contentBuffer = [];
        output.push(panelNode);
        output.push(n);
    }
    if (contentBuffer.length > 0) {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [
            $fa58ef1a18570456$var$emptyPanel(schema)
        ],
        length: length
    };
};
function $fa58ef1a18570456$var$emptyPanel(schema) {
    const p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}

});
parcelRegister("fQoRM", function(module, exports) {

$parcel$export(module.exports, "getPanelType", () => $afb9d2bd4cb626dc$export$fa00fa3d6c22a747);

var $4PfBJ = parcelRequire("4PfBJ");
const $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX = {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
};
const $afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB = {
    info: {
        r: 222,
        g: 235,
        b: 255
    },
    note: {
        r: 234,
        g: 230,
        b: 255
    },
    success: {
        r: 227,
        g: 252,
        b: 239
    },
    warning: {
        r: 255,
        g: 250,
        b: 230
    },
    error: {
        r: 255,
        g: 235,
        b: 230
    }
};
function $afb9d2bd4cb626dc$export$fa00fa3d6c22a747(attrs) {
    const rgb = $afb9d2bd4cb626dc$var$generateRgb(attrs.bgColor);
    if (!rgb) return 'info';
    let mapTo = 'info';
    let smallestDistance = Infinity;
    Object.keys($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
        const distance = $afb9d2bd4cb626dc$var$distanceOfRgb($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function $afb9d2bd4cb626dc$var$distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
}
function $afb9d2bd4cb626dc$var$generateRgb(color) {
    switch(true){
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort.test(color) || $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.test(color):
            return $afb9d2bd4cb626dc$var$parseHex(color);
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb.test(color):
            return $afb9d2bd4cb626dc$var$parseRgb(color);
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb.test(color):
            return $afb9d2bd4cb626dc$var$parsePrgb(color);
        default:
            return $afb9d2bd4cb626dc$var$parseColorName(color);
    }
}
function $afb9d2bd4cb626dc$var$parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
        return r + r + g + g + b + b;
    });
    const result = $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $afb9d2bd4cb626dc$var$parseRgb(rgb) {
    const result = rgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb);
    return result ? {
        r: parseInt(result[1], 10),
        g: parseInt(result[2], 10),
        b: parseInt(result[3], 10)
    } : null;
}
function $afb9d2bd4cb626dc$var$parsePrgb(prgb) {
    const result = prgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb);
    return result ? {
        r: Math.floor(255 * parseInt(result[1], 10) / 100),
        g: Math.floor(255 * parseInt(result[2], 10) / 100),
        b: Math.floor(255 * parseInt(result[4], 10) / 100)
    } : null;
}
function $afb9d2bd4cb626dc$var$parseColorName(color) {
    return (0, $4PfBJ.default)[color];
}

});
parcelRegister("4PfBJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6de0fe9d8acfe8$export$2e2bcd8739ae039);
const $fe6de0fe9d8acfe8$var$mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193
    },
    pink: {
        r: 255,
        g: 192,
        b: 203
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216
    },
    plum: {
        r: 221,
        g: 160,
        b: 221
    },
    violet: {
        r: 238,
        g: 130,
        b: 238
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139
    },
    purple: {
        r: 128,
        g: 0,
        b: 128
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250
    },
    blue: {
        r: 0,
        g: 0,
        b: 255
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139
    },
    navy: {
        r: 0,
        g: 0,
        b: 128
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209
    },
    azure: {
        r: 240,
        g: 255,
        b: 255
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139
    },
    teal: {
        r: 0,
        g: 128,
        b: 128
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34
    },
    lime: {
        r: 0,
        g: 255,
        b: 0
    },
    green: {
        r: 0,
        g: 128,
        b: 0
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240
    },
    beige: {
        r: 245,
        g: 245,
        b: 220
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0
    },
    olive: {
        r: 128,
        g: 128,
        b: 0
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205
    },
    gold: {
        r: 255,
        g: 215,
        b: 0
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11
    },
    orange: {
        r: 255,
        g: 128,
        b: 0
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173
    },
    tan: {
        r: 210,
        g: 180,
        b: 140
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0
    },
    peru: {
        r: 205,
        g: 133,
        b: 63
    },
    linen: {
        r: 250,
        g: 240,
        b: 230
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122
    },
    coral: {
        r: 255,
        g: 127,
        b: 80
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225
    },
    snow: {
        r: 255,
        g: 250,
        b: 250
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92
    },
    brown: {
        r: 165,
        g: 42,
        b: 42
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34
    },
    red: {
        r: 255,
        g: 0,
        b: 0
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0
    },
    white: {
        r: 255,
        g: 255,
        b: 255
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211
    },
    silver: {
        r: 192,
        g: 192,
        b: 192
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169
    },
    gray: {
        r: 128,
        g: 128,
        b: 128
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105
    },
    black: {
        r: 0,
        g: 0,
        b: 0
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245
    }
};
var $fe6de0fe9d8acfe8$export$2e2bcd8739ae039 = $fe6de0fe9d8acfe8$var$mapping;

});


parcelRegister("1agyv", function(module, exports) {

$parcel$export(module.exports, "title", () => $9eccd901f1df184b$export$fb184b623420d9be);
function $9eccd901f1df184b$export$fb184b623420d9be(text, schema) {
    const mark = schema.marks.strong.create();
    const title = schema.text(text, [
        mark
    ]);
    return schema.nodes.paragraph.createChecked({}, [
        title
    ]);
}

});


parcelRegister("9MeiU", function(module, exports) {

$parcel$export(module.exports, "adfMacro", () => $39fb2727ee273b16$export$8fb4b58db8f664fb);

var $3JW2n = parcelRequire("3JW2n");
const $39fb2727ee273b16$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        context: context,
        rawContentProcessor: $39fb2727ee273b16$var$rawContentProcessor
    });
};
const $39fb2727ee273b16$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
    try {
        const json = JSON.parse(rawContent);
        const node = schema.nodeFromJSON(json);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    } catch (_e) {
        const textContent = `Invalid ADF Macro: ${rawContent}`;
        const textNode = rawContent.length ? schema.text(textContent) : undefined;
        const { codeBlock: codeBlock } = schema.nodes;
        const node = codeBlock.create({
            language: undefined
        }, textNode);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    }
};

});

parcelRegister("f50H1", function(module, exports) {

$parcel$export(module.exports, "anchorMacro", () => $4b331e3d410cf176$export$e660dadc21580fa2);

var $3JW2n = parcelRequire("3JW2n");
const $4b331e3d410cf176$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        context: context,
        rawContentProcessor: $4b331e3d410cf176$var$rawContentProcessor
    });
};
const $4b331e3d410cf176$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
    return {
        type: 'text',
        text: '',
        length: length
    };
};

});

parcelRegister("bSil4", function(module, exports) {

$parcel$export(module.exports, "codeMacro", () => $38ee74463de0ec95$export$db6c131ac26c7700);

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $1agyv = parcelRequire("1agyv");
const $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery'
];
const $38ee74463de0ec95$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        context: context,
        rawContentProcessor: $38ee74463de0ec95$var$rawContentProcessor
    });
};
const $38ee74463de0ec95$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $1agyv.title)(parsedAttrs.title, schema));
    const nodeAttrs = {
        ...parsedAttrs,
        language: $38ee74463de0ec95$var$getCodeLanguage(parsedAttrs)
    };
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};
function $38ee74463de0ec95$var$getCodeLanguage(attrs) {
    const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
    for (const language of $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES){
        if (keys.indexOf(language) !== -1) return language;
    }
    if (keys.indexOf('objc') !== -1) return 'objective-c';
    return 'java';
}

});

parcelRegister("cjZPi", function(module, exports) {

$parcel$export(module.exports, "colorMacro", () => $2374771f8fbda9ef$export$b557be495948d995);

var $kSL4h = parcelRequire("kSL4h");

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $29zBb = parcelRequire("29zBb");

var $7p5zM = parcelRequire("7p5zM");

var $gxAE9 = parcelRequire("gxAE9");
const $2374771f8fbda9ef$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        context: context,
        rawContentProcessor: $2374771f8fbda9ef$var$rawContentProcessor
    });
};
const $2374771f8fbda9ef$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    // Removed ISSUE_KEY for https://getsupport.atlassian.com/browse/MOVE-1738018
    // Issue keys were not being migrated correctly if they were inside the color macro.
    const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE
    ];
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    const content = (0, $29zBb.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: rawContent
    });
    const decoratedContent = content.map((n)=>{
        const mark = schema.marks.textColor.create({
            color: (0, $7p5zM.getEditorColor)(parsedAttrs) || '#000000'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'textColor',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length
    };
};

});
parcelRegister("7p5zM", function(module, exports) {

$parcel$export(module.exports, "getEditorColor", () => $dace0eb9654d7c1b$export$c0cfc6f23e0b7578);

var $51H8P = parcelRequire("51H8P");
function $dace0eb9654d7c1b$export$c0cfc6f23e0b7578(attrs) {
    const keys = Object.keys(attrs);
    return (0, $51H8P.normalizeHexColor)(keys[0]);
}

});


parcelRegister("8tGpW", function(module, exports) {

$parcel$export(module.exports, "noformatMacro", () => $7fe042bf55811a5b$export$9199752eb9b2d5b4);

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $1agyv = parcelRequire("1agyv");
const $7fe042bf55811a5b$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        context: context,
        rawContentProcessor: $7fe042bf55811a5b$var$rawContentProcessor
    });
};
const $7fe042bf55811a5b$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $1agyv.title)(parsedAttrs.title, schema));
    output.push(codeBlock.createChecked({}, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};

});

parcelRegister("lyI5i", function(module, exports) {

$parcel$export(module.exports, "forceLineBreak", () => $90e9f72be02de2ac$export$2de3d7fd25cbc36);
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
const $90e9f72be02de2ac$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
    if (position > 0) {
        const charBefore = input.charAt(position - 1);
        if (charBefore === '\\') return $90e9f72be02de2ac$var$fallback(input, position);
    }
    const match = input.substring(position).match($90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: 2
    };
    return $90e9f72be02de2ac$var$fallback(input, position);
};
function $90e9f72be02de2ac$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2
    };
}

});



parcelRegister("4yZSi", function(module, exports) {

$parcel$export(module.exports, "code", () => $e115b67b9a7c1782$export$6565f9f03506010b);
const $e115b67b9a7c1782$export$6565f9f03506010b = (text)=>{
    return `{{${text}}}`;
};

});

parcelRegister("aDTWq", function(module, exports) {

$parcel$export(module.exports, "textColor", () => $ef3e88b1064ccc35$export$32f78bffcd82ff28);
const $ef3e88b1064ccc35$export$32f78bffcd82ff28 = (text, attrs)=>{
    return `{color:${attrs.color}}${text}{color}`;
};

});

parcelRegister("gdFeW", function(module, exports) {

$parcel$export(module.exports, "em", () => $e431017de2633455$export$c63c6f932822f543);

var $3ovek = parcelRequire("3ovek");
const $e431017de2633455$export$c63c6f932822f543 = (text)=>{
    if (text.startsWith("\u2014 ")) // This is a citation
    return (0, $3ovek.baseMarkPattern)(text.substring(2), '??');
    return (0, $3ovek.baseMarkPattern)(text, '_');
};

});
parcelRegister("3ovek", function(module, exports) {

$parcel$export(module.exports, "baseMarkPattern", () => $7f6f940a63ef31a6$export$3d8aed7830783c75);
/**
 * For text that has leading and ending space. We don't want to
 * convert it to `* strong *. Instead, we need it to be ` *strong* `
 */ const $7f6f940a63ef31a6$export$3d8aed7830783c75 = (text, token)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^\s*$/.test(text)) /**
		 * If it's a string with only whitespaces, wiki renderer
		 * will behave incorrect if we apply format on it
		 */ return text;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
};

});


parcelRegister("jo5YT", function(module, exports) {

$parcel$export(module.exports, "link", () => $5614ddd827a3bd70$export$9c30223ca0a664fb);
const $5614ddd827a3bd70$export$9c30223ca0a664fb = (text, attrs)=>{
    return `[${text}|${attrs.href}]`;
};

});

parcelRegister("9fwgI", function(module, exports) {

$parcel$export(module.exports, "strike", () => $486b01102f007d8c$export$4899a95d70ec5056);

var $3ovek = parcelRequire("3ovek");
const $486b01102f007d8c$export$4899a95d70ec5056 = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '-');
};

});

parcelRegister("eKxrE", function(module, exports) {

$parcel$export(module.exports, "strong", () => $5f94e33f4e7efc4b$export$59ae2c325a998f89);

var $3ovek = parcelRequire("3ovek");
const $5f94e33f4e7efc4b$export$59ae2c325a998f89 = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '*');
};

});

parcelRegister("1x55I", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $de8ae0bb6a3c8a22$export$b3401ee80eb31041);

var $3ovek = parcelRequire("3ovek");
const $de8ae0bb6a3c8a22$export$b3401ee80eb31041 = (text, attrs)=>{
    if (attrs.type === 'sub') return (0, $3ovek.baseMarkPattern)(text, '~');
    else return (0, $3ovek.baseMarkPattern)(text, '^');
};

});

parcelRegister("8tKGr", function(module, exports) {

$parcel$export(module.exports, "underline", () => $bb8b641056119651$export$425327af25286e5e);

var $3ovek = parcelRequire("3ovek");
const $bb8b641056119651$export$425327af25286e5e = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '+');
};

});


parcelRegister("5IuwX", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $c6769d560338119d$export$cbf8224b64e0d942);

var $1Nefo = parcelRequire("1Nefo");

var $bOMPB = parcelRequire("bOMPB");
const $c6769d560338119d$export$cbf8224b64e0d942 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    const match = node.attrs.url.match((0, $bOMPB.INLINE_CARD_FROM_TEXT_STAMP));
    if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
    return `[${match[2]}]`;
};

});

parcelRegister("1HDja", function(module, exports) {

$parcel$export(module.exports, "status", () => $d0c82c4f36685012$export$471f7ae5c4103ae1);

var $aDTWq = parcelRequire("aDTWq");

const $d0c82c4f36685012$var$color = {
    grey: (0, $829f609a65d26a98$export$eaa8c8a70ac22806),
    purple: (0, $829f609a65d26a98$export$b48405b95304b5a1),
    blue: (0, $829f609a65d26a98$export$9dc1ef0f3f48059b),
    red: (0, $829f609a65d26a98$export$4a7404f376229999),
    yellow: (0, $829f609a65d26a98$export$59619663aa6500fb),
    green: (0, $829f609a65d26a98$export$940e1f69e873f202)
};
const $d0c82c4f36685012$export$471f7ae5c4103ae1 = (node)=>{
    const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
    const newAttrs = {
        ...node.attrs
    };
    if ($d0c82c4f36685012$var$color[node.attrs.color]) newAttrs.color = $d0c82c4f36685012$var$color[node.attrs.color];
    else newAttrs.color = $d0c82c4f36685012$var$color['grey'];
    return (0, $aDTWq.textColor)(text, newAttrs);
};

});

parcelRegister("c08Yp", function(module, exports) {

$parcel$export(module.exports, "date", () => $61a6161cda09885d$export$324d90190a8b822a);
const $61a6161cda09885d$export$324d90190a8b822a = (node)=>{
    const addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const result = new Date(Number(node.attrs.timestamp));
    return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};

});



parcelRegister("73kPn", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $ef6a5d3a665df695$export$7bb0d5c671655cc4);

var $bK2QZ = parcelRequire("bK2QZ");
const $ef6a5d3a665df695$var$supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml'
];
const $ef6a5d3a665df695$export$7bb0d5c671655cc4 = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            parent: node
        });
    });
    if ($ef6a5d3a665df695$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
    else return `{noformat}${result}{noformat}`;
};

});

parcelRegister("eTlm6", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $b3a3fb1c58065f07$export$2855e964765eac9);

var $bsbI5 = parcelRequire("bsbI5");

var $48ot6 = parcelRequire("48ot6");

var $1Nefo = parcelRequire("1Nefo");
const $b3a3fb1c58065f07$export$2855e964765eac9 = (node, opts = {})=>{
    const result = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'media':
                result.push((0, $48ot6.media)(n, {
                    ...opts,
                    parent: node
                }));
                break;
            case 'caption':
                result.push((0, $bsbI5.caption)(n, opts));
                break;
            default:
                result.push((0, $1Nefo.unknown)(n));
                break;
        }
    });
    return result.join('\n');
};

});
parcelRegister("bsbI5", function(module, exports) {

$parcel$export(module.exports, "caption", () => $58b84b7bf3a1608d$export$8e3c2dfdc4f0453d);

var $bK2QZ = parcelRequire("bK2QZ");
const $58b84b7bf3a1608d$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            context: context
        });
    });
    return result;
};

});

parcelRegister("48ot6", function(module, exports) {

$parcel$export(module.exports, "media", () => $df984bb2074676e8$export$987d49ffe1b0900f);
const $df984bb2074676e8$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
    const wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) // Parent width is defined in percents
    wikiAttrs.push(`width=${parent.attrs.width}%`);
    else {
        if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
        if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
    }
    if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
    if (node.marks.length) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
    }
    let fileName;
    if (node.attrs.type === 'external') fileName = node.attrs.url;
    else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
    if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
    // default to thumbnail if no width or height is set
    return `!${fileName}|thumbnail!`;
};

});




parcelRegister("hgytR", function(module, exports) {

$parcel$export(module.exports, "taskList", () => $1fb2a139f9f264bf$export$375b6afcc5f4d291);

var $4kMeo = parcelRequire("4kMeo");
const $1fb2a139f9f264bf$var$nestedNode = (node, depth = 1)=>{
    const result = [];
    node.forEach((item)=>{
        if (item.type.name === 'taskList') result.push($1fb2a139f9f264bf$var$nestedNode(item, depth + 1));
        else result.push((0, $4kMeo.taskItem)(item, depth));
    });
    return result.join('\n');
};
const $1fb2a139f9f264bf$export$375b6afcc5f4d291 = (node)=>{
    return $1fb2a139f9f264bf$var$nestedNode(node);
};

});
parcelRegister("4kMeo", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $b96ea7b246afcc42$export$6d8b0ef52e2e6390);

var $bK2QZ = parcelRequire("bK2QZ");
const $b96ea7b246afcc42$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        // Generate stars based on depth
        const prefix = Array(nestedLevel).fill('*').join('');
        if (node.attrs.state === 'DONE') result += `${prefix} -${(0, $bK2QZ.inlines)(n, {
            context: context
        })}-`;
        else result += `${prefix} ${(0, $bK2QZ.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("b6sEJ", function(module, exports) {

$parcel$export(module.exports, "decisionList", () => $9054c6d3a6a22504$export$62d45a65fb43d95e);

var $h0oA4 = parcelRequire("h0oA4");
const $9054c6d3a6a22504$export$62d45a65fb43d95e = (node)=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $h0oA4.decisionItem)(item));
    });
    return result.join('\n');
};

});
parcelRegister("h0oA4", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $6209b59f60b56dcd$export$6959e16eeff859b4);

var $bK2QZ = parcelRequire("bK2QZ");
const $6209b59f60b56dcd$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += `* <> ${(0, $bK2QZ.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("1B6CN", function(module, exports) {

$parcel$export(module.exports, "doc", () => $5ce407caf0707589$export$2a111da947c407d2);

var $lxtC7 = parcelRequire("lxtC7");
const $5ce407caf0707589$export$2a111da947c407d2 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return result.join('\n\n');
};

});

parcelRegister("8UMD2", function(module, exports) {

$parcel$export(module.exports, "expand", () => $dcda58106fc3b9ff$export$9f77e0932fb78f72);

var $lxtC7 = parcelRequire("lxtC7");
const $dcda58106fc3b9ff$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
    // Title of expand appears as a bold text, followed by empty line
    const result = [
        `*${node.attrs.title}*`,
        ''
    ];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("fIzNZ", function(module, exports) {

$parcel$export(module.exports, "heading", () => $2a94cb79881b69b7$export$46e4a324ac90507f);

var $bK2QZ = parcelRequire("bK2QZ");
const $2a94cb79881b69b7$export$46e4a324ac90507f = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n);
    });
    return `h${node.attrs.level}. ${result}`;
};

});

parcelRegister("h9tzi", function(module, exports) {

$parcel$export(module.exports, "orderedList", () => $c2a8fd1ebb40e986$export$a5dc81035676e7a);

var $bxtEu = parcelRequire("bxtEu");
const $c2a8fd1ebb40e986$export$a5dc81035676e7a = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $bxtEu.listItem)(item, '#', context));
    });
    return result.join('\n');
};

});

parcelRegister("abXFq", function(module, exports) {

$parcel$export(module.exports, "panel", () => $d8008c2d580ced87$export$21f42ab9b6679f44);

var $lxtC7 = parcelRequire("lxtC7");
const $d8008c2d580ced87$var$panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6'
};
const $d8008c2d580ced87$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return `{panel:bgColor=${$d8008c2d580ced87$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
};

});

parcelRegister("czgKo", function(module, exports) {

$parcel$export(module.exports, "rule", () => $bf5c50b1fb980df8$export$fbeb3a3956e8a3c7);
const $bf5c50b1fb980df8$export$fbeb3a3956e8a3c7 = (_node)=>{
    return '----';
};

});

parcelRegister("acqkf", function(module, exports) {

$parcel$export(module.exports, "table", () => $6deed74ceb5bf80f$export$9852986a3ec5f6a0);

var $lxtC7 = parcelRequire("lxtC7");

var $1Nefo = parcelRequire("1Nefo");
const $6deed74ceb5bf80f$export$9852986a3ec5f6a0 = (node, opts = {})=>{
    try {
        const result = [];
        node.forEach((n)=>{
            result.push($6deed74ceb5bf80f$var$tableRow(n, opts));
        });
        return result.join('\n');
    } catch (err) {
        return (0, $1Nefo.unknown)(node);
    }
};
const $6deed74ceb5bf80f$var$tableRow = (node, opts = {})=>{
    let result = '';
    let separator = '|';
    node.forEach((n)=>{
        if (n.type.name === 'tableHeader') separator = '||';
        else separator = '|';
        result = `${result}${separator}${$6deed74ceb5bf80f$var$tableCell(n, opts)}`;
    });
    return `${result}${separator}`;
};
const $6deed74ceb5bf80f$var$tableCell = (node, { context: context } = {})=>{
    if ($6deed74ceb5bf80f$var$hasMergedCell(node)) // This is an advanced table
    throw new Error('Advanced feature of table is not supported');
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    const output = result.join('\n').trim();
    // Return single whitespace if content of cell is empty
    // to preserve correct empty cell rendering in wiki
    return output === '' ? ' ' : output;
};
const $6deed74ceb5bf80f$var$hasMergedCell = (node)=>{
    if (!node.attrs) return false;
    if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
    if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
    return false;
};

});

parcelRegister("69N10", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $0c06383b3aca4143$export$c4c2f833baaebdb8);

var $1Nefo = parcelRequire("1Nefo");
const $0c06383b3aca4143$export$c4c2f833baaebdb8 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};

});

parcelRegister("12A17", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $c9c7f4b278041854$export$be4283d9a1cb1ff6);

var $1Nefo = parcelRequire("1Nefo");
const $c9c7f4b278041854$export$be4283d9a1cb1ff6 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
};

});


parcelRegister("djcbG", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f62fc9e2776603$export$2e2bcd8739ae039);

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");
class $74f62fc9e2776603$export$2e2bcd8739ae039 {
    constructor(schema, wikiMarkup){
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
	 * Convert reduced macros tree into prosemirror model tree
	 */ getProseMirrorModel(context) {
        const content = (0, $29zBb.parseString)({
            context: context,
            ignoreTokenTypes: [],
            input: this.wikiMarkup,
            schema: this.schema
        });
        return this.schema.nodes.doc.createChecked({}, (0, $20lXC.normalizePMNodes)(content, this.schema, 'doc'));
    }
}

});



parcelRegister("aQb3V", function(module, exports) {

$parcel$export(module.exports, "getLearnMoreMessage", () => $8cc68cbdef3ac4a4$export$2c1e5dc35269c547);
$parcel$export(module.exports, "getErrorMessage", () => $8cc68cbdef3ac4a4$export$82f46aa4e6535a45);

var $6s1PB = parcelRequire("6s1PB");

var $bGrWH = parcelRequire("bGrWH");


var $7vNya = parcelRequire("7vNya");

var $dOrZq = parcelRequire("dOrZq");
const $8cc68cbdef3ac4a4$export$2c1e5dc35269c547 = (fieldHelpTextUrl)=>{
    const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
    const learnMoreMessages = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7vNya.LEARN_MORE_MESSAGES_WITH_ISSUE_TERM) : (0, $7vNya.LEARN_MORE_MESSAGES);
    if (urlSuffix in learnMoreMessages) return learnMoreMessages[urlSuffix];
    return (0, $dOrZq.default).fieldHelpTextLabel;
};
const $8cc68cbdef3ac4a4$export$188aeee1ab8948d8 = (fieldHelpTextUrl, formatMessage)=>{
    const helperMessage = $8cc68cbdef3ac4a4$export$2c1e5dc35269c547(fieldHelpTextUrl);
    return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
};
const $8cc68cbdef3ac4a4$export$82f46aa4e6535a45 = (validationError, fieldName, formatMessage, formatNumber)=>{
    switch(validationError){
        case 0, $bGrWH.REQUIRED:
            return formatMessage((0, $dOrZq.default).requiredErrorMessage, {
                fieldName: fieldName
            });
        case 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca:
            return formatMessage((0, $dOrZq.default).labelsMaxErrorMessage, {
                MAX_ALLOWED_LABELS: formatNumber((0, $d46ffa3990e23a4d$export$1fdf850c93de8bae))
            });
        case 0, $d46ffa3990e23a4d$export$e77d629cc732976d:
            return formatMessage((0, $dOrZq.default).labelsInvalidErrorMessage, {
                MAX_LABEL_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$9151073f92820ff8))
            });
        case 0, $d46ffa3990e23a4d$export$618e922e89e8bcae:
            return formatMessage((0, $dOrZq.default).stringInvalidErrorMessage, {
                fieldName: fieldName,
                MAX_STRING_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$fe1a70381f6491b5))
            });
        case 0, $d46ffa3990e23a4d$export$8d30d41a8828e14f:
            return formatMessage((0, $dOrZq.default).forgeLabelsInvalidErrorMessage, {
                MAX_LABEL_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$9151073f92820ff8))
            });
        default:
            return validationError;
    }
};

});
const $d46ffa3990e23a4d$export$9151073f92820ff8 = 255;
const $d46ffa3990e23a4d$export$fe1a70381f6491b5 = 255;
const $d46ffa3990e23a4d$export$1fdf850c93de8bae = 55;
const $d46ffa3990e23a4d$export$fd7dfa1695d325ca = 'MAX ALLOWED LABELS';
const $d46ffa3990e23a4d$export$e77d629cc732976d = 'LABELS INVALID';
const $d46ffa3990e23a4d$export$8d30d41a8828e14f = 'FORGE LABELS INVALID';
const $d46ffa3990e23a4d$export$618e922e89e8bcae = 'STRING_INVALID';

parcelRegister("7vNya", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE_MESSAGES_WITH_ISSUE_TERM", () => $6a6781d11d912198$export$1b2b0fc2cd5817de);
$parcel$export(module.exports, "LEARN_MORE_MESSAGES", () => $6a6781d11d912198$export$eedb1bf75e1efb26);

var $dOrZq = parcelRequire("dOrZq");
const $6a6781d11d912198$var$LEARN_MORE_TYPES = {
    IssueTypes: '#IssueTypes',
    PriorityLevels: '#PriorityLevels',
    ResolutionTypes: '#ResolutionTypes',
    SecurityLevels: '#SecurityLevels'
};
const $6a6781d11d912198$export$1b2b0fc2cd5817de = {
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.IssueTypes]: (0, $dOrZq.default).fieldHelpIssueTypesIssueTermRefresh,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $dOrZq.default).fieldHelpPriorityLevels,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $dOrZq.default).fieldHelpResolutionDefinitions,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $dOrZq.default).fieldHelpSecurityLevels
};
const $6a6781d11d912198$export$eedb1bf75e1efb26 = {
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.IssueTypes]: (0, $dOrZq.default).fieldHelpIssueTypes,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $dOrZq.default).fieldHelpPriorityLevels,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $dOrZq.default).fieldHelpResolutionDefinitions,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $dOrZq.default).fieldHelpSecurityLevels
};

});
parcelRegister("dOrZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c5d9a42d37b19ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c5d9a42d37b19ea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-create-commons.common.field-message.required-error-message",
        "defaultMessage": "{fieldName} is required"
    },
    labelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-invalid-error-message",
        "defaultMessage": "Labels can't have spaces or be more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    stringInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.string-invalid-error-message",
        "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
    },
    forgeLabelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.forge-labels-invalid-error-message",
        "defaultMessage": "Labels can't have more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    labelsMaxErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-max-error-message",
        "defaultMessage": "Can't have more than {MAX_ALLOWED_LABELS, plural, one {# label} other {# labels}}"
    },
    fieldHelpTextLabel: {
        "id": "issue-create-commons.common.field-message.field-help-text-label",
        "defaultMessage": "Learn more"
    },
    fieldHelpIssueTypes: {
        "id": "issue-create-commons.common.field-message.field-help-issue-types",
        "defaultMessage": "Learn about issue types"
    },
    fieldHelpPriorityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-priority-levels",
        "defaultMessage": "Learn about priority levels"
    },
    fieldHelpResolutionDefinitions: {
        "id": "issue-create-commons.common.field-message.field-help-resolution-definitions",
        "defaultMessage": "Resolutions definitions"
    },
    fieldHelpSecurityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-security-levels",
        "defaultMessage": "More on security levels"
    },
    fieldHelpIssueTypesIssueTermRefresh: {
        "id": "issue-create-commons.common.field-message.field-help-issue-types-issue-term-refresh",
        "defaultMessage": "Learn about work types"
    }
});

});




parcelRegister("iblgc", function(module, exports) {

$parcel$export(module.exports, "FieldSkeleton", () => $20aa6a3390c971a5$export$f102dad4aafe4ad4);
$parcel$export(module.exports, "default", () => $20aa6a3390c971a5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1wbtX = parcelRequire("1wbtX");

var $YSJPS = parcelRequire("YSJPS");
const $20aa6a3390c971a5$export$f102dad4aafe4ad4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "issue-create-commons.common.ui.loader.skeleton",
        "data-testid": "issue-create-commons.common.ui.loader.skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$var$Label, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YSJPS.StyledFieldSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$var$Description, null));
const $20aa6a3390c971a5$var$IssueCreateLoader = ({ skeletonCount: skeletonCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, Array.from({
        length: skeletonCount
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$export$f102dad4aafe4ad4, {
            key: `field-skeleton-${index}`
        })));
var $20aa6a3390c971a5$export$2e2bcd8739ae039 = $20aa6a3390c971a5$var$IssueCreateLoader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20aa6a3390c971a5$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iv47k _1bsb68cl _19pkv47k _otyr12x7",
            __cmplp.className
        ])
    });
});
$20aa6a3390c971a5$var$Label.displayName = 'LabelSkeleton';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20aa6a3390c971a5$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ipxbi _1bsb1mjv",
            __cmplp.className
        ])
    });
});
$20aa6a3390c971a5$var$Description.displayName = 'DescriptionSkeleton';

});
parcelRegister("YSJPS", function(module, exports) {

$parcel$export(module.exports, "StyledFieldSkeleton", () => $f113eb09b8933f94$export$ed5de990fe261b7b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1wbtX = parcelRequire("1wbtX");
const $f113eb09b8933f94$export$ed5de990fe261b7b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp _1bsb1edt _otyr12x7",
            __cmplp.className
        ])
    });
});
$f113eb09b8933f94$export$ed5de990fe261b7b.displayName = 'FieldSkeleton';

});


parcelRegister("86fzT", function(module, exports) {

$parcel$export(module.exports, "generateKeyForRequiredFromUIM", () => $81f27e245685507d$export$920d96e4692b3d51);
const $81f27e245685507d$export$920d96e4692b3d51 = (parameters)=>{
    const { fieldId: fieldId, isRequiredFromUIM: isRequiredFromUIM } = parameters;
    return `${fieldId}-field_${isRequiredFromUIM ? '' : 'non-'}required_from_uim`;
};

});


parcelRegister("ii6hB", function(module, exports) {

$parcel$export(module.exports, "AffectedServicesField", () => $387f926e9d9168ff$export$dbde2fdac14e77d6);
$parcel$export(module.exports, "default", () => $387f926e9d9168ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $f0bro = parcelRequire("f0bro");

var $7C5S0 = parcelRequire("7C5S0");

var $YSJPS = parcelRequire("YSJPS");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $aZJYe = parcelRequire("aZJYe");

const $387f926e9d9168ff$export$dbde2fdac14e77d6 = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, defaultValue: defaultValue } = props;
    const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $5uXOq.useState)(true);
    const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)([]);
    const [{ isLoading: isLoading }, fetchAffectedServicesName] = (0, $aZJYe.useFetchAffectedServicesName)();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
            /*
            const ids = defaultValue.map((service) => service.serviceId);
            Simply extracting serviceId above causes Flow error as 'service'
            is of type (JiraAffectedService | AffectedServiceOption).
            See TURTLE-89 for more details.
             */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const ids = defaultValue.reduce((serviceIds, service)=>// @ts-expect-error - TS2339 - Property 'serviceId' does not exist on type 'AffectedServiceOption'. | TS2339 - Property 'serviceId' does not exist on type 'AffectedServiceOption'.
                service.serviceId != null ? serviceIds.concat(service.serviceId) : serviceIds, []);
            if (ids.length > 0) fetchAffectedServicesName(ids, setSelectedOptions);
            setShouldFetchServiceName(false);
        } else setSelectedOptions(value);
    }, [
        defaultValue,
        fetchAffectedServicesName,
        setSelectedOptions,
        shouldFetchServiceName,
        value
    ]);
    const getAffectedServicesEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0bro.default), {
            ...fieldProps,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: selectedOptions,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true
        });
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YSJPS.StyledFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getAffectedServicesEdit()) : getAffectedServicesEdit());
};
var $387f926e9d9168ff$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aZJYe.transformDefaultAffectedServices)
})($387f926e9d9168ff$export$dbde2fdac14e77d6);

});
parcelRegister("f0bro", function(module, exports) {

$parcel$export(module.exports, "default", () => $64bb95b3ef8c5394$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d7FF4 = parcelRequire("d7FF4");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $FtZX9 = parcelRequire("FtZX9");

var $kEqrP = parcelRequire("kEqrP");

var $2WZSx = parcelRequire("2WZSx");

var $2ngL6 = parcelRequire("2ngL6");
const $64bb95b3ef8c5394$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $64bb95b3ef8c5394$var$AffectedServicesPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [lastFetchFailed, setLastFetchFailed] = (0, $5uXOq.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
    const searchAffectedServices = async (query = '')=>{
        setLastFetchFailed(false);
        try {
            (0, $kEqrP.fetchAffectedServicesExperience).start();
            const affectedServices = await (0, $2ngL6.fetchAffectedServices)(query, autoCompleteUrl);
            (0, $kEqrP.fetchAffectedServicesExperience).success();
            return affectedServices;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLastFetchFailed(true);
            (0, $kEqrP.fetchAffectedServicesExperience).failure();
            return [];
        }
    };
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchAffectedServices();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const loadOptionsDebounced = (0, $FtZX9.default)(searchAffectedServices, $64bb95b3ef8c5394$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
    const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $2WZSx.default).failedFetch : (0, $2WZSx.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        ...fieldProps,
        classNamePrefix: "affected-services-picker",
        fieldId: fieldId,
        loadOptions: loadOptionsDebounced,
        // @ts-expect-error - TS2322 - Type '(value: AffectedServiceOption[]) => void' is not assignable to type '(value: OptionsType<AffectedServiceOption>, action: ActionMeta<AffectedServiceOption>) => void'.
        onChange: onChange,
        autoFocus: false,
        ...defaultOptionsProps(),
        isClearable: Boolean(value),
        isMulti: true,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        "data-testid": "issue-field-affected-services.ui.edit.async-select"
    });
};
var $64bb95b3ef8c5394$export$2e2bcd8739ae039 = $64bb95b3ef8c5394$var$AffectedServicesPickerEdit;

});
parcelRegister("FtZX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb46637e8f856b8$export$2e2bcd8739ae039);
const $ebb46637e8f856b8$var$defer = ()=>{
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ebb46637e8f856b8$var$debounce(fn, wait = 0) {
    let deferred;
    let timer;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let lastArgs;
    function flush() {
        const thisDeferred = deferred;
        clearTimeout(timer);
        if (thisDeferred) // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation. | TS7005 - Variable 'lastArgs' implicitly has an 'any' type.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
        lastArgs = [];
        deferred = null;
    }
    // @ts-expect-error - TS2322 - Type '(...args: readonly any[]) => any' is not assignable to type 'F'.
    return function debounced(...args) {
        if (deferred) clearTimeout(timer);
        else deferred = $ebb46637e8f856b8$var$defer();
        lastArgs = args;
        // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        timer = setTimeout(flush.bind(this), wait);
        return deferred.promise;
    };
}
var $ebb46637e8f856b8$export$2e2bcd8739ae039 = $ebb46637e8f856b8$var$debounce;

});

parcelRegister("kEqrP", function(module, exports) {

$parcel$export(module.exports, "graphModalExperience", () => $92ce1ce82a42bb8a$export$1b179afadba799dc);
$parcel$export(module.exports, "rapidSearchExperience", () => $92ce1ce82a42bb8a$export$1a90deecc86e78f8);
$parcel$export(module.exports, "autocompleteInsightFieldExperience", () => $92ce1ce82a42bb8a$export$94337fa170a193d2);
$parcel$export(module.exports, "fetchAffectedServicesExperience", () => $92ce1ce82a42bb8a$export$ce8d2a860f4e0316);
$parcel$export(module.exports, "objectDetailsViewExperience", () => $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", () => $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", () => $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4);
$parcel$export(module.exports, "createObjectTypeExperience", () => $92ce1ce82a42bb8a$export$15a29f6e079c9b3d);
$parcel$export(module.exports, "createObjectExperience", () => $92ce1ce82a42bb8a$export$aaf507c87c29ab22);
$parcel$export(module.exports, "loadSchemaObjectListExperience", () => $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f);
$parcel$export(module.exports, "loadAttributesConfigurationExperience", () => $92ce1ce82a42bb8a$export$8f63f06b0486e498);
$parcel$export(module.exports, "updateObjectFilterExperience", () => $92ce1ce82a42bb8a$export$967859e6be8e6f4b);
$parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", () => $92ce1ce82a42bb8a$export$e4deb66475dfa46b);
$parcel$export(module.exports, "loadObjectDetailExperience", () => $92ce1ce82a42bb8a$export$3f1da23c065671d2);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $92ce1ce82a42bb8a$export$1b179afadba799dc = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$1a90deecc86e78f8 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$94337fa170a193d2 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience,
    featureFlags: [
        'jsm-insight-field-performance-improvements_fplgq'
    ]
});
const $92ce1ce82a42bb8a$export$ce8d2a860f4e0316 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3 = new (0, $duUGa.UFOExperience)('jsm-cmdb-object-details-view', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$15a29f6e079c9b3d = new (0, $duUGa.UFOExperience)('jsm-cmdb-create-object-type', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'created-on-server',
            endMark: 'object-type-created-on-server'
        }
    ]
});
const $92ce1ce82a42bb8a$export$aaf507c87c29ab22 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.create-object', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f = new (0, $duUGa.UFOExperience)('jsm-cmdb-load-object-list', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$8f63f06b0486e498 = new (0, $duUGa.UFOExperience)('jsm-cmdb-load-attributes-tab', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$967859e6be8e6f4b = new (0, $duUGa.UFOExperience)('jsm-cmdb-object-filter', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'response-received',
            endMark: 'server-response-received'
        },
        {
            key: 'object-table-rendered',
            endMark: 'object-table-rendered'
        },
        {
            key: 'object-list-rendered',
            endMark: 'object-list-rendered'
        },
        {
            key: 'no-filter-results-rendered',
            endMark: 'no-filter-results-rendered'
        }
    ]
});
const $92ce1ce82a42bb8a$export$e4deb66475dfa46b = ()=>new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
        type: (0, $atdLB.ExperienceTypes).Experience
    });
const $92ce1ce82a42bb8a$export$3f1da23c065671d2 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("2WZSx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a56352311f156b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $9a56352311f156b3$var$messages = (0, $7VHMR.defineMessages)({
    noMatches: {
        "id": "issue-field-affected-services.edit.no-matches",
        "defaultMessage": "No Matches"
    },
    failedFetch: {
        "id": "issue-field-affected-services.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    }
});
var $9a56352311f156b3$export$2e2bcd8739ae039 = $9a56352311f156b3$var$messages;

});

parcelRegister("2ngL6", function(module, exports) {

$parcel$export(module.exports, "mapServiceEntitiesToOptions", () => $ee273b75b82219a4$export$23b96a30f377b741);
$parcel$export(module.exports, "mapOptionsToServiceEntities", () => $ee273b75b82219a4$export$7dcfc49587479fac);
$parcel$export(module.exports, "fetchAffectedServices", () => $ee273b75b82219a4$export$66d34216c85d32cb);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $ee273b75b82219a4$export$23b96a30f377b741 = (services)=>services.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $ee273b75b82219a4$export$7dcfc49587479fac = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));
const $ee273b75b82219a4$export$66d34216c85d32cb = async (inputValue, autoCompleteUrl)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        query: inputValue
    });
    return (0, $eusud.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>$ee273b75b82219a4$export$23b96a30f377b741(response.services)).catch((error)=>{
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'fetchAffectedServices',
            packageName: 'jiraIssueFieldAffectedServices',
            logToSentry: !(0, $jJZqs.isValidationError)(error),
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                errorMessage: error.message
            }
        });
        throw error;
    });
};

});


parcelRegister("7C5S0", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $17c5ea94a7a7a600$export$b5c4b0e7cd7f148b);
$parcel$export(module.exports, "Description", () => $17c5ea94a7a7a600$export$393edc798c47379d);
$parcel$export(module.exports, "SelectContainer", () => $17c5ea94a7a7a600$export$446eebadefe1123b);
$parcel$export(module.exports, "Divider", () => $17c5ea94a7a7a600$export$2e0a83ec2e27ecbb);
/* styled.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $c0dQj = parcelRequire("c0dQj");
const $17c5ea94a7a7a600$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ebfkjq": (0, $lD23V.default)((()=>{
                return typeof (__cmplp.width ?? ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350)) === 'number' ? `${__cmplp.width ?? ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350)}px` : __cmplp.width ?? ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350);
            })()),
            "--_1glwpqj": (0, $lD23V.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $lD23V.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbhi17 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$393edc798c47379d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$446eebadefe1123b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it94y _1bsb1osq _bfhkb5v6 _19pk1ejb _2hwxidpf _otyr1ejb _18u0idpf",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gLdtQ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATE_MODAL_BODY_SELECTOR", () => $60f472fd3d28277e$export$7c7171667037b275);
$parcel$export(module.exports, "closeMenuOnScroll", () => $60f472fd3d28277e$export$fe334d83c6aac80f);
// keeping it here instead of jira-issue-create to avoid cyclic dependencies.
const $60f472fd3d28277e$export$7c7171667037b275 = 'issue-create.ui.modal.modal-body';
const $60f472fd3d28277e$var$MENU_CLOSE_SELECTORS = [
    $60f472fd3d28277e$export$7c7171667037b275
];
const $60f472fd3d28277e$export$fe334d83c6aac80f = (e)=>{
    // @ts-expect-error - TS18047 -  'e.target' is possibly 'null'.
    if ($60f472fd3d28277e$var$MENU_CLOSE_SELECTORS.includes(e.target.id)) return true;
    return false;
};

});

parcelRegister("aZJYe", function(module, exports) {

$parcel$export(module.exports, "mutateAffectedServicesField", () => $3cf4650743fd53da$export$c5ca3c9d905a51f0);
$parcel$export(module.exports, "transformDefaultAffectedServices", () => $3cf4650743fd53da$export$6f4e94c57a16128c);
$parcel$export(module.exports, "useFetchAffectedServicesName", () => $3cf4650743fd53da$export$9abe2f602f72a411);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $2ngL6 = parcelRequire("2ngL6");
const $3cf4650743fd53da$export$c5ca3c9d905a51f0 = (selectedAffectedServices, fieldId)=>({
        affectedServicesField: {
            fieldId: fieldId,
            affectedServices: selectedAffectedServices.map(({ value: value })=>({
                    serviceId: value
                }))
        }
    });
const $3cf4650743fd53da$export$6f4e94c57a16128c = (defaultAffectedServices)=>defaultAffectedServices.map((service)=>({
            value: service.serviceId
        }));
const $3cf4650743fd53da$export$9abe2f602f72a411 = ()=>{
    const [isLoading, setLoading] = (0, $5uXOq.useState)(false);
    const baseUrl = '';
    const handleFetch = (0, $5uXOq.useRef)((ids, setSelectedOptions)=>{
        setLoading(true);
        (0, $7f4tk.default)(`${baseUrl}/rest/service-registry-api/service`, {
            method: 'POST',
            body: JSON.stringify({
                ids: ids
            })
        }).then((response)=>{
            setLoading(false);
            setSelectedOptions((0, $2ngL6.mapServiceEntitiesToOptions)(response.services));
        }).catch((error)=>{
            setLoading(false);
            setSelectedOptions([]);
            (0, $jcw0u.default)({
                meta: {
                    id: 'useFetchAffectedServicesName',
                    packageName: 'jiraIssueCreateCommons',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    });
    return [
        {
            isLoading: isLoading
        },
        handleFetch.current
    ];
};

});


parcelRegister("6iZh4", function(module, exports) {

$parcel$export(module.exports, "validateRequired", () => $2a21f21632a09b2e$export$2e85a6f149681784);

var $bGrWH = parcelRequire("bGrWH");
const $2a21f21632a09b2e$export$2e85a6f149681784 = (value, isRequired, _)=>{
    if (isRequired) {
        if (!value || Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};

});


parcelRegister("kShoa", function(module, exports) {

$parcel$export(module.exports, "toLabelsField", () => $e44b536616936050$export$7a0cc61c6cdac523);
$parcel$export(module.exports, "textFieldWriter", () => $e44b536616936050$export$3f2b7c786f4381f3);
$parcel$export(module.exports, "selectFieldWriter", () => $e44b536616936050$export$9ed21ff1d3f239ed);
$parcel$export(module.exports, "checkboxSelectFieldWriter", () => $e44b536616936050$export$6372f460d19ccf04);
$parcel$export(module.exports, "textAreaFieldWriter", () => $e44b536616936050$export$daf547ed9d724058);
$parcel$export(module.exports, "dateFieldWriter", () => $e44b536616936050$export$ab1ac718ca53b3a2);
$parcel$export(module.exports, "labelsFieldWriter", () => $e44b536616936050$export$ad0f5c4a81b9b717);
$parcel$export(module.exports, "priorityFieldWriter", () => $e44b536616936050$export$255f6ed818b27fe9);
$parcel$export(module.exports, "numberFieldWriter", () => $e44b536616936050$export$f187c825de05664b);
$parcel$export(module.exports, "dateTimeFieldWriter", () => $e44b536616936050$export$aa8970635118882c);
$parcel$export(module.exports, "urlFieldWriter", () => $e44b536616936050$export$823b946bef17fbde);
$parcel$export(module.exports, "multiUserPickerFieldWriter", () => $e44b536616936050$export$f56da03febf03bbe);
$parcel$export(module.exports, "cascadingSelectFieldWriter", () => $e44b536616936050$export$dd0315e6bb70be50);
$parcel$export(module.exports, "singleUserPickerFieldWriter", () => $e44b536616936050$export$44ca38ec8bc1b849);
$parcel$export(module.exports, "radioSelectFieldWriter", () => $e44b536616936050$export$3930624833f8c678);
$parcel$export(module.exports, "multiSelectFieldWriter", () => $e44b536616936050$export$550c89601caa8cb);
$parcel$export(module.exports, "attachmentFieldWriter", () => $e44b536616936050$export$a751298e00103db5);
$parcel$export(module.exports, "descriptionFieldWriter", () => $e44b536616936050$export$8545d310869fe805);
$parcel$export(module.exports, "singleGroupPickerFieldWriter", () => $e44b536616936050$export$8b286e49fa801799);
$parcel$export(module.exports, "multipleGroupPickerFieldWriter", () => $e44b536616936050$export$ada212938d86109a);
$parcel$export(module.exports, "teamFieldWriter", () => $e44b536616936050$export$77028ba2835a8f1c);
$parcel$export(module.exports, "assigneeFieldWriter", () => $e44b536616936050$export$1c1d0a4431d22b72);

var $5kDIl = parcelRequire("5kDIl");

var $bWtQ8 = parcelRequire("bWtQ8");

var $em1U0 = parcelRequire("em1U0");

var $hx8g7 = parcelRequire("hx8g7");

var $2QTbq = parcelRequire("2QTbq");

var $4IxfP = parcelRequire("4IxfP");

var $aSk8p = parcelRequire("aSk8p");

var $5pHXe = parcelRequire("5pHXe");

var $1K3Xb = parcelRequire("1K3Xb");

var $4R6GH = parcelRequire("4R6GH");
const $e44b536616936050$var$toMultipleSelectField = (id, ids)=>{
    const toOptionInput = (optionId)=>({
            id: optionId
        });
    return {
        fieldId: id,
        options: ids.map(toOptionInput)
    };
};
const $e44b536616936050$var$toStringField = (id, value)=>({
        fieldId: id,
        value: value
    });
const $e44b536616936050$export$7a0cc61c6cdac523 = (id, labels)=>({
        fieldId: id,
        values: {
            values: labels
        }
    });
const $e44b536616936050$var$toPriorityField = (priorityId)=>({
        priorityId: priorityId
    });
const $e44b536616936050$export$f27a949cf2ef9fc6 = (id, accountId)=>({
        fieldId: id,
        user: {
            accountId: accountId
        }
    });
const $e44b536616936050$var$toADFField = (id, adf)=>{
    const { version: version } = adf;
    return {
        fieldId: id,
        adf: {
            version: version,
            jsonValue: adf
        }
    };
};
const $e44b536616936050$var$toGroupInput = (pickerOption)=>({
        groupName: pickerOption.name
    });
const $e44b536616936050$export$3f2b7c786f4381f3 = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
};
const $e44b536616936050$export$9ed21ff1d3f239ed = (id, value, fields)=>{
    if (value) fields.stringFields.push($e44b536616936050$var$toStringField(id, String((0, $5pHXe.mapSelectOptionsToData)(value).id)));
};
const $e44b536616936050$export$6372f460d19ccf04 = (id, value, fields)=>{
    fields.multipleSelectFields.push($e44b536616936050$var$toMultipleSelectField(id, (0, $hx8g7.mapOptionsToData)(value).map((o)=>o.id)));
};
const $e44b536616936050$export$daf547ed9d724058 = (id, value, fields)=>{
    if (value instanceof Object && (0, $4R6GH.fg)('forms_multiline_text_wiki_renderer')) return;
    // @ts-expect-error Remove this typecheck suppression on forms_multiline_text_wiki_renderer cleanup ts(2345)
    fields.adfFields.push($e44b536616936050$var$toADFField(id, (0, $1K3Xb.convertTextToAdf)(value)));
};
const $e44b536616936050$export$ab1ac718ca53b3a2 = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
};
const $e44b536616936050$export$ad0f5c4a81b9b717 = (id, value, fields)=>{
    fields.labels.push($e44b536616936050$export$7a0cc61c6cdac523(id, (0, $2QTbq.mapLabelOptionsToData)(value)));
};
const $e44b536616936050$export$255f6ed818b27fe9 = (_id, value, fields)=>{
    // eslint-disable-next-line no-param-reassign
    fields.priority = $e44b536616936050$var$toPriorityField((0, $4IxfP.mapOptionToData)(value).id);
};
const $e44b536616936050$export$f187c825de05664b = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
};
const $e44b536616936050$export$aa8970635118882c = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
};
const $e44b536616936050$export$823b946bef17fbde = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
};
const $e44b536616936050$export$f56da03febf03bbe = (id, value, fields)=>{
    const accountIds = (0, $5kDIl.mapUserOptionsToAccountIds)(value);
    fields.multipleSelectUserPickerFields.push({
        fieldId: id,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        users: accountIds
    });
};
const $e44b536616936050$export$dd0315e6bb70be50 = (id, value, fields)=>{
    const option = (0, $em1U0.transformToServerValue)(value);
    if (option !== null) {
        fields.stringFields.push($e44b536616936050$var$toStringField(id, option.id));
        if (option.child) fields.stringFields.push($e44b536616936050$var$toStringField(`${id}:1`, option.child.id));
    }
};
const $e44b536616936050$export$44ca38ec8bc1b849 = (id, value, fields)=>{
    if (!value) return;
    const result = (0, $5kDIl.mapUserOptionsToIds)(value);
    if (!Array.isArray(result)) fields.users.push($e44b536616936050$export$f27a949cf2ef9fc6(id, result.id));
};
const $e44b536616936050$export$3930624833f8c678 = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, (0, $aSk8p.mapOptionToData)(value).id));
};
const $e44b536616936050$export$550c89601caa8cb = (id, value, fields)=>{
    fields.multipleSelectFields.push($e44b536616936050$var$toMultipleSelectField(id, value.map((o)=>o.value).filter((selectedValue)=>typeof selectedValue === 'string' || typeof selectedValue === 'number').map((o)=>String(o))));
};
const $e44b536616936050$export$a751298e00103db5 = (_id, value, fields)=>{
    if (Array.isArray(value) && value.length >= 1) {
        const ids = (0, $bWtQ8.getFileIdsFromFiles)(value);
        fields.stringFields.push($e44b536616936050$var$toStringField('attachment', ids.join(',')));
    }
};
const $e44b536616936050$export$8545d310869fe805 = (id, value, fields)=>{
    if (!value) return;
    if (typeof value === 'string' && (0, $4R6GH.fg)('forms_multiline_text_wiki_renderer')) // On forms_multiline_text_wiki_renderer cleanup, merge this early exit with one above:
    // I.e. if (!value || typeof value === 'string')
    return;
    // @ts-expect-error Remove this typecheck suppression on forms_multiline_text_wiki_renderer cleanup ts(2345)
    fields.adfFields.push($e44b536616936050$var$toADFField(id, value));
};
const $e44b536616936050$export$8b286e49fa801799 = (id, value, fields)=>{
    const group = $e44b536616936050$var$toGroupInput(value);
    fields.singleGroupPickerFields.push({
        fieldId: id,
        group: group
    });
};
const $e44b536616936050$export$ada212938d86109a = (id, value, fields)=>{
    const groups = value.map($e44b536616936050$var$toGroupInput);
    fields.multipleGroupPickerFields.push({
        fieldId: id,
        groups: groups
    });
};
const $e44b536616936050$export$77028ba2835a8f1c = (id, value, fields)=>{
    if (value) fields.stringFields.push($e44b536616936050$var$toStringField(id, value.value));
};
const $e44b536616936050$export$1c1d0a4431d22b72 = (id, value, fields)=>{
    if (value?.accountId) fields.users.push($e44b536616936050$export$f27a949cf2ef9fc6(id, value.accountId));
};

});
parcelRegister("5kDIl", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToUserOption", () => $5870d9a04b0eab40$export$3e406786572c35b0);
$parcel$export(module.exports, "transformDefaultUserValues", () => $5870d9a04b0eab40$export$26760e7b66ccf1e1);
$parcel$export(module.exports, "mapUserOptionsToIds", () => $5870d9a04b0eab40$export$2482a6858a4714ad);
$parcel$export(module.exports, "mapUserOptionsToAccountIds", () => $5870d9a04b0eab40$export$e4490ea0dfe4173f);
$parcel$export(module.exports, "mutateSingleUserPicker", () => $5870d9a04b0eab40$export$7937ee6404102aff);
$parcel$export(module.exports, "mutateMultiUserPicker", () => $5870d9a04b0eab40$export$53e350638c0acebc);

const $5870d9a04b0eab40$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $5870d9a04b0eab40$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($5870d9a04b0eab40$export$3e406786572c35b0);
    return $5870d9a04b0eab40$export$3e406786572c35b0(defaultValue);
};
const $5870d9a04b0eab40$export$2482a6858a4714ad = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            id: option.id
        }));
    return {
        id: userOption.id
    };
};
const $5870d9a04b0eab40$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $5870d9a04b0eab40$export$7937ee6404102aff = (selectedUser, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $2b6d45687558f2b0$export$6684456d545bf498),
        user: {
            accountId: selectedUser.id
        }
    });
const $5870d9a04b0eab40$export$53e350638c0acebc = (selectedUsers, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $2b6d45687558f2b0$export$52003ca9b6035e0c),
        users: selectedUsers.map((user)=>({
                accountId: user.id
            }))
    });

});
const $2b6d45687558f2b0$export$6684456d545bf498 = 'singleSelectUserPickerFields';
const $2b6d45687558f2b0$export$52003ca9b6035e0c = 'multipleSelectUserPickerFields';


parcelRegister("bWtQ8", function(module, exports) {

$parcel$export(module.exports, "getFileIdsFromFiles", () => $7bad3ba374b5e258$export$90bf402b5b4274c7);
$parcel$export(module.exports, "validateAttachment", () => $7bad3ba374b5e258$export$8af997fabc69757a);
$parcel$export(module.exports, "getFieldDropZoneContainerID", () => $7bad3ba374b5e258$export$2fab292eea84487a);

var $bGrWH = parcelRequire("bGrWH");
const $7bad3ba374b5e258$export$90bf402b5b4274c7 = (files)=>files.map((file)=>file.id.toString());
const $7bad3ba374b5e258$export$8af997fabc69757a = (value, isRequired)=>{
    if (isRequired) {
        if (!value || value.length === 0) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $7bad3ba374b5e258$export$2fab292eea84487a = (fieldId)=>`${fieldId ? `${fieldId}-` : ''}dropzone-container`;

});

parcelRegister("em1U0", function(module, exports) {

$parcel$export(module.exports, "transformToServerValue", () => $657085c715b654ca$export$6f0c6eec5b71d787);

var $gJBT6 = parcelRequire("gJBT6");
const $657085c715b654ca$export$d1480328df7a42bf = (serverValue)=>{
    if (!serverValue) return null;
    const { id: id, value: value, child: child } = serverValue;
    return {
        value: id,
        label: value,
        child: child && {
            value: child.id,
            label: child.value
        }
    };
};
const $657085c715b654ca$export$899758961952c638 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((values)=>values.map(({ id: id, value: value })=>({
            value: id,
            label: value
        })));
const $657085c715b654ca$export$575da772c90849b8 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((values)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    values.reduce((acc, { id: id, children: children })=>{
        acc[id] = children ? $657085c715b654ca$export$899758961952c638(children) : [];
        return acc;
    }, {}));
const $657085c715b654ca$export$6f0c6eec5b71d787 = (option)=>{
    if (!option) return null;
    const { label: label, value: value } = option;
    // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
    const child = option.child || undefined;
    return {
        id: value,
        value: label,
        child: child && {
            id: child.value,
            value: child.label
        }
    };
};

});

parcelRegister("hx8g7", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $551084a6b97f85f9$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $551084a6b97f85f9$export$ffef3a401aef987b);
const $551084a6b97f85f9$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $551084a6b97f85f9$export$ffef3a401aef987b = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            value: label
        }));

});

parcelRegister("4IxfP", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $ae732ed1951f68ed$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $ae732ed1951f68ed$export$fc800909123977f3);
const $ae732ed1951f68ed$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name, iconUrl: iconUrl })=>({
            label: name,
            value: id,
            iconUrl: iconUrl
        }));
const $ae732ed1951f68ed$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
        id: value,
        name: label,
        iconUrl: iconUrl
    });

});

parcelRegister("aSk8p", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $08634f5a5ba1d218$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $08634f5a5ba1d218$export$fc800909123977f3);
const $08634f5a5ba1d218$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $08634f5a5ba1d218$export$fc800909123977f3 = ({ label: label, value: value })=>({
        id: value,
        value: label
    });

});

parcelRegister("5pHXe", function(module, exports) {

$parcel$export(module.exports, "mapSelectOptionsToData", () => $aeaea2f472af8476$export$7cdfccbc726f6f22);
$parcel$export(module.exports, "mapMultiSelectOptionsToData", () => $aeaea2f472af8476$export$b91253d30be01e62);
$parcel$export(module.exports, "mapDataToSelectOption", () => $aeaea2f472af8476$export$8f475f1fdc96a964);
$parcel$export(module.exports, "mapDataToSelectOptions", () => $aeaea2f472af8476$export$dc22cde66e28d4af);
const $aeaea2f472af8476$export$7cdfccbc726f6f22 = (option)=>({
        id: option.value,
        value: option.label
    });
const $aeaea2f472af8476$export$b91253d30be01e62 = (options)=>options.map((option)=>({
            id: option.value,
            value: option.label
        }));
const $aeaea2f472af8476$export$8f475f1fdc96a964 = (optionExternal)=>({
        label: optionExternal.value,
        value: optionExternal.id
    });
const $aeaea2f472af8476$export$dc22cde66e28d4af = (data)=>data.map((optionExternal)=>$aeaea2f472af8476$export$8f475f1fdc96a964(optionExternal));

});

parcelRegister("1K3Xb", function(module, exports) {

$parcel$export(module.exports, "convertTextToAdf", () => $903ba9c436cc186a$export$c10cf32c4acc1d57);

var $bPWvi = parcelRequire("bPWvi");
var $50sdg = parcelRequire("50sdg");

var $kz2lw = parcelRequire("kz2lw");
const $903ba9c436cc186a$export$c10cf32c4acc1d57 = (text)=>{
    if (text === '') return (0, $kz2lw.getEmptyADF)();
    return (0, $bPWvi.doc)((0, $50sdg.paragraph)(text));
};

});
parcelRegister("bPWvi", function(module, exports) {

$parcel$export(module.exports, "doc", () => $c17b5e301ceeeae8$export$2a111da947c407d2);
const $c17b5e301ceeeae8$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("50sdg", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $b5360ede7330200d$export$9c206ddddb32a9b);

var $3lRhe = parcelRequire("3lRhe");
const $b5360ede7330200d$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $3lRhe.createTextNodes)(content)
    });

});
parcelRegister("3lRhe", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $4fbd120aea0a69b1$export$3a269a5941b62f04);

var $gBTcG = parcelRequire("gBTcG");
function $4fbd120aea0a69b1$export$3a269a5941b62f04(nodes) {
    return nodes.map($4fbd120aea0a69b1$export$72b9432ea0656b50);
}
function $4fbd120aea0a69b1$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $gBTcG.text)(str) : str;
}

});
parcelRegister("gBTcG", function(module, exports) {

$parcel$export(module.exports, "text", () => $9654feec8f8dd4ec$export$6f093cfa640b7166);
const $9654feec8f8dd4ec$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});






parcelRegister("22Wo8", function(module, exports) {

$parcel$export(module.exports, "AssigneeFieldTypeConfig", () => $818cad83f092a8b9$export$760aa32e02dd931e);

var $5uXOq = parcelRequire("5uXOq");

var $bdVbi = parcelRequire("bdVbi");

var $5FwUN = parcelRequire("5FwUN");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $818cad83f092a8b9$var$AssigneeFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FwUN.default), props);
const $818cad83f092a8b9$export$760aa32e02dd931e = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bdVbi))),
    type: (0, $5fc53.ASSIGNEE_TYPE),
    Component: $818cad83f092a8b9$var$AssigneeFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.AssigneeFieldPlaceholder), null),
    writer: (0, $kShoa.assigneeFieldWriter)
};

});
parcelRegister("5FwUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $489f100aee3a6307$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $89S0t = parcelRequire("89S0t");

var $leRCk = parcelRequire("leRCk");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

var $bfnma = parcelRequire("bfnma");

var $5rYSU = parcelRequire("5rYSU");
const $489f100aee3a6307$export$7c52097ee36bd91 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { autoCompleteUrl: autoCompleteUrl = '', width: width = (0, $dCm1o.isVisualRefreshEnabled)() ? '100%' : props.width, fieldProps: { value: value, onChange: onChange, id: id, ...fieldProps }, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const onAssignToMeClick = ()=>{
        onChange(loggedInUser);
    };
    const onAddAssigneeKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (id && (event.key === 'Enter' || event.key === ' ')) {
            onChange(loggedInUser);
            // this focus was implemented with getElementById as there is problem here using ref in UserPicker
            // doesn't pass ref to input inside the component
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            setTimeout(()=>document.getElementById(id)?.focus());
        }
    }, [
        id,
        loggedInUser,
        onChange
    ]);
    const showAssignToMe = loggedInUser && !isReadOnly;
    const assignToMeButton = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        onClick: onAssignToMeClick,
        onKeyDown: onAddAssigneeKeyDown,
        testId: "issue-create-commons.ui.assignee-field.assing-to-me-button",
        xcss: $489f100aee3a6307$var$assignToMeStyles
    }, formatMessage((0, $bfnma.default).assignToMe)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        onClick: onAssignToMeClick,
        onKeyDown: onAddAssigneeKeyDown,
        testId: "issue-create-commons.ui.assignee-field.assing-to-me-button"
    }, formatMessage((0, $bfnma.default).assignToMe));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($489f100aee3a6307$var$FieldContainer, {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89S0t.default), {
        ...fieldProps,
        value: value,
        onChange: onChange,
        shouldPreloadAssignToMe: true,
        autoCompleteUrl: autoCompleteUrl,
        enableAutomaticOption: true,
        autoFocus: autoFocus,
        isDisabled: isReadOnly,
        width: width,
        inputId: id,
        openMenuOnClick: true
    }), showAssignToMe && assignToMeButton);
};
var $489f100aee3a6307$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateAssigneeField),
    transformDefaultValue: (0, $5rYSU.transformDefaultAssigneeValue // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<UserPickerFieldConfig, UserValue>, any>'.
    )
})($489f100aee3a6307$export$7c52097ee36bd91);
const $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOff = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $7C5S0.FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1v091b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $7C5S0.FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1v091b66 _1wqpstnw _acx6idpf _1h0p1n1a",
            __cmplp.className
        ])
    });
});
const $489f100aee3a6307$var$assignToMeStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    color: 'color.link',
    cursor: 'pointer',
    marginTop: 'space.050',
    padding: 'space.0',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.link.pressed'
    }
});
const $489f100aee3a6307$var$FieldContainer = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOn, $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOff);

});
parcelRegister("89S0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a7ac4b7108cf6a7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $cr0SA = parcelRequire("cr0SA");

var $aWse0 = parcelRequire("aWse0");

var $ecbCU = parcelRequire("ecbCU");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $4R6GH = parcelRequire("4R6GH");


var $fhSLy = parcelRequire("fhSLy");

var $7lGt2 = parcelRequire("7lGt2");

var $h36wX = parcelRequire("h36wX");

var $kt8K4 = parcelRequire("kt8K4");
const $3a7ac4b7108cf6a7$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience = new (0, $duUGa.UFOExperience)('inline-assignee-picker.field-options-load', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'inline-assignee-picker.field-options-load'
});
const $3a7ac4b7108cf6a7$var$InlineAssigneePickerEdit = ({ shouldPreloadAssignToMe: shouldPreloadAssignToMe = false, autoCompleteUrl: autoCompleteUrl, value: value = null, width: width, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange, searchDebounceTimeout: searchDebounceTimeout = $3a7ac4b7108cf6a7$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, enablePeopleInvite: enablePeopleInvite = true, enableAutomaticOption: enableAutomaticOption = false, isSubtle: isSubtle = false, appearance: appearance = 'normal', autoFocus: autoFocus = false, inputId: inputId, openMenuOnClick: openMenuOnClick = false, ariaLabel: ariaLabel, isRequired: isRequired, ...fieldProps })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const self = (0, $5uXOq.useRef)({
        previousQuery: undefined
    }).current;
    const [{ data: users, loading: loading, error: error }, fetchUsers] = (0, $kt8K4.default)(autoCompleteUrl || '');
    const [assigneeValue, assigneeOptions] = (0, $4R6GH.fg)('fix_a11y_issue_in_transition_form') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $h36wX.useAssigneeOptions)(value, users, intl, shouldPreloadAssignToMe, self.previousQuery, enablePeopleInvite, enableAutomaticOption, undefined, undefined, isRequired) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $h36wX.useAssigneeOptions)(value, users, intl, shouldPreloadAssignToMe, self.previousQuery, enablePeopleInvite, enableAutomaticOption);
    const [, { openDrawer: openDrawer }] = (0, $ecbCU.useInvitePeopleDrawer)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (loading) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loading'
            }), 'inlineAssigneeOptions loading');
            $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.start();
        }
        if (error) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'failed'
            }), 'inlineAssigneeOptions failed');
            $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.failure();
        }
        if (users.length) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loaded'
            }), 'inlineAssigneeOptions loaded');
            $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.success();
        }
    }, [
        loading,
        error,
        users,
        createAnalyticsEvent
    ]);
    const handleSearch = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            /*
     * Added extra condition to skip search. it's getting called during onBlur because previousQuery is undefined and query is empty string
     * then query !== self.previousQuery will be true and fetchUsers getting called unnecessarily
     */ if (query === '' && self.previousQuery === undefined) return;
            query !== self.previousQuery && fetchUsers(query);
            self.previousQuery = query;
        }, searchDebounceTimeout), // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fetchUsers,
        searchDebounceTimeout,
        self.previousQuery
    ]);
    const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
        onFocus?.(sessionId);
        if (!users || !users.length) fetchUsers();
    }, [
        onFocus,
        users,
        fetchUsers
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
        onBlur?.(sessionId);
        self.previousQuery = undefined;
    }, [
        onBlur,
        self
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)((updatedValue, action)=>{
        if (!updatedValue || Array.isArray(updatedValue)) return;
        if (enablePeopleInvite && updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) {
            openDrawer(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            onChange?.(value, action);
            return;
        }
        let newValue;
        if (updatedValue.id === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) || updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) newValue = null;
        else newValue = (0, $fhSLy.getUserFromUserOption)(updatedValue);
        onChange?.(newValue, action);
    }, [
        enablePeopleInvite,
        onChange,
        openDrawer,
        value,
        createAnalyticsEvent
    ]);
    /*
   * user picker default opens on focus, fetchUsers has to be called onFocus
   * when openMenuOnClick is enabled then fetchUsers should be called during onOpen rather than onFocus
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: handleOnFocus
    } : {
        onFocus: handleOnFocus
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        inputId: inputId,
        fieldId: (0, $5fc53.ASSIGNEE_TYPE),
        autoFocus: autoFocus,
        placeholder: intl.formatMessage((0, $7lGt2.default).searchForAssignee),
        isLoading: loading,
        options: assigneeOptions,
        value: assigneeValue,
        isMulti: false,
        isClearable: false,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        onInputChange: handleSearch,
        subtle: isSubtle,
        appearance: appearance,
        width: width,
        isDisabled: isDisabled,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        UNSAFE_hasDraggableParentComponent: true,
        ariaLabel: ariaLabel,
        ...controlProps
    });
};
var $3a7ac4b7108cf6a7$export$2e2bcd8739ae039 = $3a7ac4b7108cf6a7$var$InlineAssigneePickerEdit;

});
parcelRegister("ecbCU", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleDrawer", () => $6f07668563b12d68$export$48fb2d80745c5e67);
$parcel$export(module.exports, "triggerOpenDrawer", () => $6f07668563b12d68$export$b7dab610045052db);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
var $bKpgX = parcelRequire("bKpgX");

var $2fX5x = parcelRequire("2fX5x");
const $6f07668563b12d68$var$CONTROLLER_NAME = 'invite-people-drawer';
const $6f07668563b12d68$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined
};
const $6f07668563b12d68$var$Store = (0, $iXqE5.createStore)({
    name: $6f07668563b12d68$var$CONTROLLER_NAME,
    initialState: $6f07668563b12d68$var$initialState,
    actions: {
        openDrawer: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl })=>({ setState: setState })=>{
                (0, $2fX5x.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, analyticsSource);
                (0, $2fX5x.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl
                });
            },
        closeDrawer: ()=>({ setState: setState })=>setState($6f07668563b12d68$var$initialState)
    }
});
const $6f07668563b12d68$export$48fb2d80745c5e67 = (0, $3sQ5x.createHook)($6f07668563b12d68$var$Store);
const $6f07668563b12d68$export$ac7fed664b4735b5 = (0, $gg7kZ.createContainer)($6f07668563b12d68$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $6f07668563b12d68$export$4358742cbaf4a6d4 = (0, $51nlc.createSubscriber)($6f07668563b12d68$var$Store, {
    displayName: 'InvitePeopleDrawerSubscriber',
    selector: (state)=>state.isOpen
});
const $6f07668563b12d68$export$b7dab610045052db = (createAnalyticsEvent, contextConfig)=>{
    (0, $bKpgX.defaultRegistry).getStore($6f07668563b12d68$var$Store)?.actions.openDrawer(createAnalyticsEvent, contextConfig);
};

});
parcelRegister("2fX5x", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $b69ddc7a728288ef$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $b69ddc7a728288ef$export$6815765da918b983);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $b69ddc7a728288ef$export$21b810258e82d438);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $8zOmE = parcelRequire("8zOmE");
var $lhVtI = parcelRequire("lhVtI");

var $fjcgS = parcelRequire("fjcgS");

var $d3xqi = parcelRequire("d3xqi");
const $b69ddc7a728288ef$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $5uXOq.useRef)((0, $fjcgS.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $lhVtI.getEvent)(analyticsEvent)));
        }
    };
};
const $b69ddc7a728288ef$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $b69ddc7a728288ef$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $fjcgS.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $b69ddc7a728288ef$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: (0, $d3xqi.getSourceByInviteFlow)(inviteFlow)
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $b69ddc7a728288ef$export$21b810258e82d438 = async (createAnalyticsEvent, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        source: source != null && source !== '' ? source : 'unknown'
    };
    $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("d3xqi", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $1b54655f5f68975f$export$c35cd18e9d0123e3);
const $1b54655f5f68975f$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};

});



const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';

parcelRegister("fhSLy", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $bdabf260f25df73f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $bdabf260f25df73f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $bdabf260f25df73f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $bdabf260f25df73f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $bdabf260f25df73f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $bdabf260f25df73f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $bdabf260f25df73f$export$322b6ab8c29a006e);

var $5i5DK = parcelRequire("5i5DK");

var $6s1PB = parcelRequire("6s1PB");

var $7lGt2 = parcelRequire("7lGt2");

var $12ZsE = parcelRequire("12ZsE");

const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>{
    const avatarUrls = (0, $6s1PB.expVal)('thor_unassigned_icon_update_milestone1_experiment', 'isUnassignedIconUpdated', false) ? {
        '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($5i5DK)))
    } : {};
    return {
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: avatarUrls
    };
};
const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $7lGt2.default).automaticOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $7lGt2.default).invitePeopleOptionAdmin : (0, $7lGt2.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($12ZsE)))
        }
    });
const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("5i5DK", function(module, exports) {
module.exports = new URL("unassignedAvatar.299fb7bf.svg", import.meta.url).toString();

});

parcelRegister("7lGt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2aaed3328149e1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("12ZsE", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});


parcelRegister("h36wX", function(module, exports) {

$parcel$export(module.exports, "useAssigneeOptions", () => $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8);

var $3OKtJ = parcelRequire("3OKtJ");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $itmJb = parcelRequire("itmJb");

var $leRCk = parcelRequire("leRCk");

var $4R6GH = parcelRequire("4R6GH");


var $fhSLy = parcelRequire("fhSLy");

var $7lGt2 = parcelRequire("7lGt2");
const $92b31ca8d85d4433$var$fireInviteItemRendererEvent = (createAnalyticsEvent, suggestionsCount, isAdmin, isInviteAndAssignFromBoard = false)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField',
        ...isInviteAndAssignFromBoard && {
            isInviteAndAssignFromBoard: true
        }
    };
    (0, $8zOmE.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8 = (value, users, intl, shouldPreloadAssignToMe, search, enablePeopleInvite, enableAutomaticOption, suggestedEmailDomain, isEligibleForInviteAndAssign, shouldHideUnassigned)=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const unassigned = (0, $fhSLy.getUnassignedUser)(intl);
    const automaticOption = (0, $fhSLy.getAutomaticUserOption)(intl);
    const valueOption = (0, $fhSLy.getUserOptionFromUser)(value || unassigned);
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const loggedInUserOption = loggedInUser ? {
        ...(0, $fhSLy.getUserOptionFromUser)(loggedInUser),
        publicName: intl.formatMessage((0, $7lGt2.default).assignToMe)
    } : null;
    const isInvalidSearch = search === undefined || search === '';
    const hideUnassigned = (0, $4R6GH.fg)('fix_a11y_issue_in_transition_form') && shouldHideUnassigned;
    // show unassigned option if value is defined and no search or unassigned display name match the search
    const showUnassigned = !hideUnassigned && (isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase()));
    let showAutomaticOption = false;
    if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
    const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
    const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
    const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
    const userOptions = users.filter((user)=>// remove selected user (value) from users list when search is not defined
        (!isInvalidSearch || user.accountId !== valueOption.id) && // remove logged in user (is already added in 2nd position above)
        !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, $fhSLy.getUserOptionFromUser));
    const invitePeopleOptions = [];
    if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
        if (isEligibleForInviteAndAssign) {
            invitePeopleOptions.push((0, $3OKtJ.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
            $92b31ca8d85d4433$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin, true);
        } else {
            $92b31ca8d85d4433$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin);
            invitePeopleOptions.push((0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getInvitePeopleOption)(intl, isAdmin)));
        }
    }
    const options = [
        ...showUnassigned ? [
            (0, $fhSLy.getUserOptionFromUser)(unassigned)
        ] : [],
        ...showAutomaticOption ? [
            (0, $fhSLy.getUserOptionFromUser)(automaticOption)
        ] : [],
        ...showAssignToMe && loggedInUserOption !== null ? [
            loggedInUserOption
        ] : [],
        ...userOptions,
        ...invitePeopleOptions
    ];
    return [
        valueOption,
        options
    ];
};

});
parcelRegister("3OKtJ", function(module, exports) {

$parcel$export(module.exports, "isValidEmailAddress", () => $d369cb9a3149539e$export$866f45a7554d0870);
$parcel$export(module.exports, "getInviteAndAssignPeopleOption", () => $d369cb9a3149539e$export$34e0d98131b0b98a);

var $M0UM1 = parcelRequire("M0UM1");

var $ivhIb = parcelRequire("ivhIb");


var $eXneb = parcelRequire("eXneb");
const $d369cb9a3149539e$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
    const isEmail = inputValue && [
        (0, $a56e5eac5897104f$export$18d36911c7f94286),
        (0, $a56e5eac5897104f$export$da1c529049028734)
    ].includes((0, $M0UM1.isValidEmail)(inputValue));
    const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
    return value;
};
const $d369cb9a3149539e$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, $M0UM1.isValidEmail)(inputValue) === (0, $a56e5eac5897104f$export$18d36911c7f94286);
const $d369cb9a3149539e$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
    const possibleEmail = $d369cb9a3149539e$var$getInviteAndAssignOption(input, suggestedEmailDomain);
    return {
        id: (0, $a56e5eac5897104f$export$898547b9297d1a3a),
        name: possibleEmail,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ivhIb))),
        byline: formatMessage((0, $eXneb.default).inviteAndAssign),
        isDisabled: (0, $M0UM1.isValidEmail)(possibleEmail) !== 'VALID'
    };
};

});
parcelRegister("ivhIb", function(module, exports) {
module.exports = new URL("email.very-specific-illu.3b6402e8.png", import.meta.url).toString();

});

const $a56e5eac5897104f$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $a56e5eac5897104f$export$18d36911c7f94286 = 'VALID';
const $a56e5eac5897104f$export$da1c529049028734 = 'POTENTIAL';

parcelRegister("eXneb", function(module, exports) {

$parcel$export(module.exports, "default", () => $31de51ead46cb5cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31de51ead46cb5cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    inviteAndAssign: {
        "id": "invite-and-assign.common.invite-and-assign",
        "defaultMessage": "Invite and assign"
    }
});

});



parcelRegister("kt8K4", function(module, exports) {

$parcel$export(module.exports, "default", () => $564a5b059c2a0fff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $dJl1T = parcelRequire("dJl1T");

var $7f4tk = parcelRequire("7f4tk");
const $564a5b059c2a0fff$var$useUsersQuery = (autoCompleteUrl, customFetchUsers)=>{
    const [users, setUsers] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const currentQuery = (0, $5uXOq.useRef)('');
    const fetchUsers = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2345 - Argument of type '(query?: string | undefined) => Promise<void> | Promise<never[]>' is not assignable to parameter of type 'FetchUsers'.
    (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
        const fetchUsersMethod = customFetchUsers && (0, $4R6GH.fg)('issue_cards_in_program_board') ? customFetchUsers(query) : (0, $7f4tk.default)(usersFetchUrl);
        return fetchUsersMethod.then((response)=>{
            if (query === currentQuery.current) setUsers(response);
        }).catch((err)=>{
            if (query === currentQuery.current) setError(err);
            const errorMessage = customFetchUsers && (0, $4R6GH.fg)('issue_cards_in_program_board') ? 'Failed to fetch using custom user fetcher' : 'Failed to fetch users';
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.fields.assigne', errorMessage, err);
        }).finally(()=>setLoading(false));
    }, [
        autoCompleteUrl,
        error,
        customFetchUsers
    ]);
    return [
        {
            data: users,
            error: error,
            loading: loading
        },
        fetchUsers
    ];
};
var $564a5b059c2a0fff$export$2e2bcd8739ae039 = $564a5b059c2a0fff$var$useUsersQuery;

});


parcelRegister("jGVMX", function(module, exports) {

$parcel$export(module.exports, "validateString", () => $e5b3b607ab8affce$export$d7b0a588f685ba7e);
$parcel$export(module.exports, "validateSelectField", () => $e5b3b607ab8affce$export$53ded7ceec493f10);
$parcel$export(module.exports, "validateCascadingSelectField", () => $e5b3b607ab8affce$export$837294b8fc732f20);
$parcel$export(module.exports, "validateAssigneeField", () => $e5b3b607ab8affce$export$dd17aabe3f77b2ba);
$parcel$export(module.exports, "validateUserPickerField", () => $e5b3b607ab8affce$export$356346770aab95cb);
$parcel$export(module.exports, "validateCheckboxField", () => $e5b3b607ab8affce$export$7aa5e0976d0c384b);
$parcel$export(module.exports, "validateComponentField", () => $e5b3b607ab8affce$export$89943b0814df306d);
$parcel$export(module.exports, "validateCustomTeamsField", () => $e5b3b607ab8affce$export$364ea91bee38a994);
$parcel$export(module.exports, "validateGroupPickerField", () => $e5b3b607ab8affce$export$c6d4785f3f46f73a);
$parcel$export(module.exports, "validateMultiVersionsField", () => $e5b3b607ab8affce$export$727e23f536334715);
$parcel$export(module.exports, "validateOrganizationsField", () => $e5b3b607ab8affce$export$b97bb8e170430af8);
$parcel$export(module.exports, "validatePriorityField", () => $e5b3b607ab8affce$export$17fd881b060187f7);
$parcel$export(module.exports, "validateRadioSelectField", () => $e5b3b607ab8affce$export$f69029476f9179b);
$parcel$export(module.exports, "validateRadioGroupField", () => $e5b3b607ab8affce$export$d60dcaa093bca71d);
$parcel$export(module.exports, "validateResolutionField", () => $e5b3b607ab8affce$export$316feff8e636f81f);
$parcel$export(module.exports, "validateSingleVersionField", () => $e5b3b607ab8affce$export$45f7908dc93110fb);
$parcel$export(module.exports, "validateLabelField", () => $e5b3b607ab8affce$export$1a8caa895b9fda26);
$parcel$export(module.exports, "validateForgeLabelField", () => $e5b3b607ab8affce$export$bf4287ae453e2aab);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $bGrWH = parcelRequire("bGrWH");

// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$d7b0a588f685ba7e = (value, isRequired, type)=>{
    if (isRequired && !value?.trim?.()) return 0, $bGrWH.REQUIRED;
    if (typeof value === 'string' && type === 'text' && value?.length > (0, $d46ffa3990e23a4d$export$fe1a70381f6491b5)) return 0, $d46ffa3990e23a4d$export$618e922e89e8bcae;
    return undefined;
};
const $e5b3b607ab8affce$export$53ded7ceec493f10 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$837294b8fc732f20 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$dd17aabe3f77b2ba = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$356346770aab95cb = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$7aa5e0976d0c384b = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$89943b0814df306d = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$364ea91bee38a994 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$c6d4785f3f46f73a = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$727e23f536334715 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (!value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$b97bb8e170430af8 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(data) && !data.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$17fd881b060187f7 = (data, isRequired)=>{
    if (isRequired && !data) return 0, $bGrWH.REQUIRED;
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$f69029476f9179b = (data, isRequired)=>{
    if (isRequired && !data) return 0, $bGrWH.REQUIRED;
    return undefined;
};
const $e5b3b607ab8affce$export$d60dcaa093bca71d = (data, isRequired)=>{
    if (isRequired && !data) return 0, $bGrWH.REQUIRED;
    return undefined;
};
const $e5b3b607ab8affce$export$316feff8e636f81f = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$45f7908dc93110fb = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$1a8caa895b9fda26 = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $bGrWH.REQUIRED;
    }
    if (labels && labels?.length > (0, $d46ffa3990e23a4d$export$1fdf850c93de8bae)) return 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.includes(' ') || value.length > (0, $d46ffa3990e23a4d$export$9151073f92820ff8))) return 0, $d46ffa3990e23a4d$export$e77d629cc732976d;
    return undefined;
};
const $e5b3b607ab8affce$export$bf4287ae453e2aab = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $bGrWH.REQUIRED;
    }
    if (labels && labels?.length > (0, $d46ffa3990e23a4d$export$1fdf850c93de8bae)) return 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.length > (0, $d46ffa3990e23a4d$export$9151073f92820ff8))) return 0, $d46ffa3990e23a4d$export$8d30d41a8828e14f;
    return undefined;
};

});

parcelRegister("bfnma", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd95939e2e05e754$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dd95939e2e05e754$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assignToMe: {
        "id": "issue-create-commons.assignee-field.assign-to-me",
        "defaultMessage": "Assign to me"
    }
});

});

parcelRegister("5rYSU", function(module, exports) {

$parcel$export(module.exports, "transformDefaultAssigneeValue", () => $b31c169a5b4e6cfd$export$f5415de9103f1c69);
$parcel$export(module.exports, "mapUserToAssigneeValue", () => $b31c169a5b4e6cfd$export$c4dfa893fba82437);
$parcel$export(module.exports, "mutateAssigneeUserPicker", () => $b31c169a5b4e6cfd$export$a6706b2f4762043b);


const $b31c169a5b4e6cfd$export$f5415de9103f1c69 = (value)=>({
        accountId: (value.accountId === '-1' ? (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027) : value.accountId) || '',
        displayName: value.name || '',
        avatarUrls: value.picture !== undefined ? {
            '16x16': value.picture,
            '24x24': value.picture,
            '32x32': value.picture,
            '48x48': value.picture
        } : {}
    });
const $b31c169a5b4e6cfd$export$c4dfa893fba82437 = (value)=>{
    if (value === null) return null;
    if (value.accountId === (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) return undefined;
    return {
        id: value.accountId
    };
};
const $b31c169a5b4e6cfd$export$a6706b2f4762043b = (selectedUser, fieldId)=>{
    if (selectedUser === null || selectedUser.accountId === null) return null;
    return {
        fieldId: fieldId,
        mutationGroup: (0, $2b6d45687558f2b0$export$6684456d545bf498),
        user: {
            accountId: selectedUser.accountId
        }
    };
};

});



parcelRegister("1Zt9x", function(module, exports) {

$parcel$export(module.exports, "AttachmentFieldTypeConfig", () => $4f864de41952e13f$export$ada1e5fc2d37745a);

var $5uXOq = parcelRequire("5uXOq");

var $dP8up = parcelRequire("dP8up");

var $azL7v = parcelRequire("azL7v");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $4f864de41952e13f$var$AttachmentFieldTypeComponent = (props)=>props.mediaUploadContexts.attachmentUploadContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azL7v.default), {
        ...props,
        mediaUploadContext: props.mediaUploadContexts.attachmentUploadContext
    }) : null;
const $4f864de41952e13f$export$ada1e5fc2d37745a = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dP8up))),
    type: (0, $5fc53.ATTACHMENT_TYPE),
    Component: $4f864de41952e13f$var$AttachmentFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.AttachmentFieldPlaceholder), null),
    writer: (0, $kShoa.attachmentFieldWriter)
};

});
parcelRegister("dP8up", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6e10ac4814be7d0fba44895ccfe1f68>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1069f9774dbd57c$var$_react = $a1069f9774dbd57c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a1069f9774dbd57c$var$_baseNew = $a1069f9774dbd57c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a1069f9774dbd57c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for attaching files to issues or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1069f9774dbd57c$var$AttachmentIcon = (props)=>/*#__PURE__*/ $a1069f9774dbd57c$var$_react.default.createElement($a1069f9774dbd57c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.25 4.5 5.75 9a1.414 1.414 0 1 0 2 2l4.5-4.5a2.828 2.828 0 1 0-4-4L3.75 7a4.243 4.243 0 0 0 6 6l2.5-2.5"/>`
    }, props));
$a1069f9774dbd57c$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $a1069f9774dbd57c$var$_default = module.exports.default = $a1069f9774dbd57c$var$AttachmentIcon;

});

parcelRegister("azL7v", function(module, exports) {

$parcel$export(module.exports, "AttachmentsField", () => $e446c7b6c6df08e3$export$f7c49e57ef98664f);
$parcel$export(module.exports, "default", () => $e446c7b6c6df08e3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k9tnV = parcelRequire("k9tnV");

var $eCeGD = parcelRequire("eCeGD");

var $hPcwl = parcelRequire("hPcwl");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $koVbs = parcelRequire("koVbs");

var $bGrWH = parcelRequire("bGrWH");

var $3F8e9 = parcelRequire("3F8e9");

var $lySs6 = parcelRequire("lySs6");

var $6UFK0 = parcelRequire("6UFK0");

var $lfTZh = parcelRequire("lfTZh");

var $hpV4g = parcelRequire("hpV4g");

var $c431P = parcelRequire("c431P");

var $bWtQ8 = parcelRequire("bWtQ8");
const $e446c7b6c6df08e3$export$f7c49e57ef98664f = (props)=>{
    const { mediaUploadContext: mediaUploadContext, onInProgressChange: onInProgressChange, projectId: projectId, fieldId: fieldId = '', fieldProps: { onChange: onChange, value: value, ...fieldProps }, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, dropzoneContainerId: dropzoneContainerId = '', shouldScrollIntoViewOnUploadStart: shouldScrollIntoViewOnUploadStart = false, defaultValue: defaultValue = [], attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { files: files, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onRemoveFile: onRemoveFile, onUploadEnd: onUploadEnd, isUploading: isUploading, setAttachments: setAttachments, ...resUseAttachments } = (0, $lySs6.default)({
        mediaUploadContext: mediaUploadContext,
        projectId: projectId,
        maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
        onAttachmentSizeValidation: onAttachmentSizeValidation,
        attachmentCustomUploadURL: attachmentCustomUploadURL
    });
    const { isDefaultValueInitialized: isDefaultValueInitialized, setDefaultValueInitialized: setDefaultValueInitialized } = resUseAttachments;
    (0, $5uXOq.useEffect)(()=>{
        // setting DefaultValueInitialized only when receiving default Value to guarantee we will set DefaultValue even if it's loaded with some delay.
        if (defaultValue && Array.isArray(defaultValue) && isDefaultValueInitialized === false) {
            const currentAttachments = [];
            setAttachments(currentAttachments.concat(defaultValue.map((mediaFile)=>({
                    mediaFile: mediaFile,
                    isUploading: false
                }))));
            setDefaultValueInitialized(true);
        }
    }, [
        setAttachments,
        defaultValue,
        isDefaultValueInitialized,
        setDefaultValueInitialized
    ]);
    (0, $5uXOq.useEffect)(()=>{
        let shouldCallOnChange = false;
        const isValueAnArray = Array.isArray(value);
        if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
        if (!isValueAnArray && files.length) shouldCallOnChange = true;
        if (shouldCallOnChange) onChange(files);
    }, [
        files,
        onChange,
        value
    ]);
    // TBD: create a controlled reusable attachment component
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'shouldClear' does not exist on type 'FieldValue'.
        if (value && value.shouldClear === true) setAttachments([]);
    }, [
        setAttachments,
        value
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onInProgressChange && onInProgressChange(isUploading);
    }, [
        isUploading,
        onInProgressChange
    ]);
    if (!mediaUploadContext) return null;
    const onAttachmentUploadStart = (uploadStartPayload)=>{
        onUploadStart(uploadStartPayload);
        if (shouldScrollIntoViewOnUploadStart) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const fieldElement = document.getElementById((0, $bWtQ8.getFieldDropZoneContainerID)(fieldId));
            if (fieldElement) (0, $k9tnV.default)(fieldElement, (0, $bGrWH.DEFAULT_SCROLL_OPTIONS));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$FieldDropzoneContainer, {
        id: (0, $bWtQ8.getFieldDropZoneContainerID)(fieldId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$BrowseDropzoneArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hPcwl))), {
        spacing: "spacious",
        label: "",
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N100})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$BrowseDropzoneAreaText, null, `${formatMessage((0, $c431P.default).dropzone)}`, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UFK0.default), {
        ...fieldProps,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onUploadError: onUploadError,
        onUploadStart: onAttachmentUploadStart,
        onUploadEnd: onUploadEnd,
        dropzoneContainer: document.getElementById(dropzoneContainerId || (0, $bWtQ8.getFieldDropZoneContainerID)(fieldId))
    }, ({ setIsBrowserOpen: setIsBrowserOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $e446c7b6c6df08e3$var$browseButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            onClick: ()=>setIsBrowserOpen(true),
            "aria-label": formatMessage((0, $c431P.default).browseAriaLabel)
        }, formatMessage((0, $c431P.default).browse)))))), files.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e446c7b6c6df08e3$var$mediaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "attachments-filmstrip-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3F8e9.AsyncAttachmentsFilmstripView), {
        mediaClientConfig: mediaClientConfig,
        files: files,
        onRemoveFile: onRemoveFile,
        collectionName: mediaUploadContext.collection
    }))));
};
var $e446c7b6c6df08e3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $hpV4g.withFormField)({
    validator: (0, $bWtQ8.validateAttachment // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element | null' is not assignable to parameter of type 'AbstractComponent<ComponentProps<AttachmentFieldConfig, FieldValue>, any>'.
    )
})($e446c7b6c6df08e3$export$f7c49e57ef98664f);
const $e446c7b6c6df08e3$var$FieldDropzoneContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189et94y _1dqogq9o _1h6dq6nq _1e0c1txw _1bah1h6o _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _syaz1e9r",
            __cmplp.className
        ])
    });
});
const $e446c7b6c6df08e3$var$mediaContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050'
});
const $e446c7b6c6df08e3$var$browseButtonStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e446c7b6c6df08e3$var$BrowseDropzoneArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e446c7b6c6df08e3$var$BrowseDropzoneAreaText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3F8e9", function(module, exports) {

$parcel$export(module.exports, "AsyncAttachmentsFilmstripView", () => $eb0c63a29297e8e6$export$85605b8f3b532b83);

var $kxZPA = parcelRequire("kxZPA");

const $eb0c63a29297e8e6$export$85605b8f3b532b83 = (0, $kxZPA.lazy)(()=>(parcelRequire("8bbCy")).then((module)=>module.AttachmentsFilmstripView), {
    moduleId: "./src/packages/issue/fields/attachments/src/index.tsx"
});

});
parcelRegister("8bbCy", function(module, exports) {

let $5f485d7d41831fc8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f485d7d41831fc8$var$load("kiYwA").then(()=>parcelRequire('4MZE8'));

});


parcelRegister("lySs6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25872ff6af438731$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $f4KvR = parcelRequire("f4KvR");
const $25872ff6af438731$var$useAttachments = (attachmentArgs)=>{
    const { mediaUploadContext: mediaUploadContext, projectId: projectId, issueId: issueId, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, attachmentCustomUploadURL: attachmentCustomUploadURL } = attachmentArgs;
    if (!mediaUploadContext) throw new Error('mediaUploadContext is null!');
    const [attachments, setAttachments] = (0, $5uXOq.useState)([]);
    const [files, setFiles] = (0, $5uXOq.useState)([]);
    const [isUploading, setUploading] = (0, $5uXOq.useState)(false);
    const [isDefaultValueInitialized, setDefaultValueInitialized] = (0, $5uXOq.useState)(false);
    const stateRef = (0, $5uXOq.useRef)();
    stateRef.current = files;
    (0, $5uXOq.useEffect)(()=>{
        setFiles(attachments.map((attachment)=>attachment.mediaFile));
        setUploading(attachments.some((attachment)=>attachment.isUploading));
    }, [
        attachments
    ]);
    const mediaClientConfig = (0, $5uXOq.useMemo)(()=>({
            authProvider: ()=>Promise.resolve({
                    baseUrl: mediaUploadContext.serviceHost,
                    clientId: mediaUploadContext.clientId,
                    token: mediaUploadContext.token
                }),
            useSha256ForUploads: true
        }), [
        mediaUploadContext
    ]);
    const uploadConfig = (0, $5uXOq.useMemo)(()=>({
            uploadParams: {
                collection: mediaUploadContext.collection
            }
        }), [
        mediaUploadContext.collection
    ]);
    const onUploadStart = (0, $5uXOq.useCallback)((uploadStartPayload)=>{
        const currentFiles = stateRef.current ? stateRef.current : [];
        const totalAttachments = [
            ...uploadStartPayload.files,
            ...currentFiles
        ];
        if (maxAllowedTotalAttachmentsSize === undefined || (0, $f4KvR.getAttachmentsSize)(totalAttachments) <= maxAllowedTotalAttachmentsSize) {
            if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
            setAttachments((currentAttachments)=>currentAttachments.concat(uploadStartPayload.files.map((mediaFile)=>({
                        mediaFile: mediaFile,
                        isUploading: true
                    }))));
        } else if (onAttachmentSizeValidation) onAttachmentSizeValidation(true);
    }, [
        onAttachmentSizeValidation,
        maxAllowedTotalAttachmentsSize
    ]);
    const onUploadError = (0, $5uXOq.useCallback)((uploadError)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== uploadError.fileId));
    }, []);
    const onUploadEnd = (0, $5uXOq.useCallback)((uploadEndPayload)=>{
        (async ()=>{
            const mediaFile = uploadEndPayload.file;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId)) await (0, $f4KvR.copyToAttachment)({
                id: projectId,
                isProjectId: true,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueId)) await (0, $f4KvR.copyToAttachment)({
                id: issueId,
                isProjectId: false,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            setAttachments((currentAttachments)=>{
                const isAttachmentPresentInCurrentAttachments = currentAttachments.find((attachment)=>attachment.mediaFile.id === mediaFile.id);
                if (isAttachmentPresentInCurrentAttachments) return currentAttachments.filter((attachment)=>attachment.mediaFile.id !== mediaFile.id).concat([
                    {
                        mediaFile: mediaFile,
                        isUploading: false
                    }
                ]);
                return currentAttachments;
            });
        })();
    }, [
        issueId,
        projectId,
        attachmentCustomUploadURL
    ]);
    const onRemoveFile = (fileToBeRemoved)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== fileToBeRemoved.details.id));
        if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
    };
    return {
        files: files,
        setAttachments: setAttachments,
        onUploadStart: onUploadStart,
        onUploadError: onUploadError,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onRemoveFile: onRemoveFile,
        onUploadEnd: onUploadEnd,
        isUploading: isUploading,
        isDefaultValueInitialized: isDefaultValueInitialized,
        setDefaultValueInitialized: setDefaultValueInitialized
    };
};
var $25872ff6af438731$export$2e2bcd8739ae039 = $25872ff6af438731$var$useAttachments;

});
parcelRegister("f4KvR", function(module, exports) {

$parcel$export(module.exports, "copyToAttachment", () => $ac4c15282d67ab83$export$b9a44fdbc3de4b85);
$parcel$export(module.exports, "getAttachmentsSize", () => $ac4c15282d67ab83$export$ed1597b81cfdb5f6);

var $eusud = parcelRequire("eusud");
const $ac4c15282d67ab83$export$a7455b0d8bb5c44e = (projectId)=>`/rest/api/2/attachment/upload/project/${projectId}`;
const $ac4c15282d67ab83$export$cf1f2654bf86294f = (issueId)=>`/rest/api/2/attachment/upload/issue/${issueId}`;
const $ac4c15282d67ab83$export$b9a44fdbc3de4b85 = async (props)=>{
    const { id: id, mediaFile: mediaFile, isProjectId: isProjectId, attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { attachmentId: attachmentId } = await (0, $eusud.performPostRequest)(attachmentCustomUploadURL || (isProjectId ? $ac4c15282d67ab83$export$a7455b0d8bb5c44e(id) : $ac4c15282d67ab83$export$cf1f2654bf86294f(id)), {
        body: JSON.stringify({
            fileId: mediaFile.id
        })
    });
    return attachmentId;
};
const $ac4c15282d67ab83$export$ed1597b81cfdb5f6 = (files)=>files.reduce((attachmentsSize, attachment)=>attachmentsSize + attachment.size, 0);

});


parcelRegister("6UFK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c958c4e419db9df$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ayrxQ = parcelRequire("ayrxQ");
var $lU1w9 = parcelRequire("lU1w9");

var $495Tz = parcelRequire("495Tz");
const $2c958c4e419db9df$var$AttachmentsUpload = (props)=>{
    const [isBrowserOpen, setIsBrowserOpen] = (0, $5uXOq.useState)(false);
    const { dropzoneContainer: dropzoneContainer, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onUploadEnd: onUploadEnd, children: renderPropFn } = props;
    const dropzoneConfig = {
        ...uploadConfig
    };
    const browserConfig = {
        ...uploadConfig,
        multiple: true
    };
    const clipboardConfig = {
        ...uploadConfig
    };
    if (dropzoneContainer) dropzoneConfig.container = dropzoneContainer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ayrxQ.BrowserLoader), {
        isOpen: isBrowserOpen,
        config: browserConfig,
        mediaClientConfig: mediaClientConfig,
        onUploadsStart: onUploadStart,
        onError: onUploadError,
        onEnd: onUploadEnd,
        onClose: ()=>setIsBrowserOpen(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lU1w9.DropzoneLoader), {
        mediaClientConfig: mediaClientConfig,
        config: dropzoneConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $495Tz.Clipboard), {
        mediaClientConfig: mediaClientConfig,
        config: clipboardConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd,
        isolated: false
    }), renderPropFn({
        setIsBrowserOpen: setIsBrowserOpen
    }));
};
var $2c958c4e419db9df$export$2e2bcd8739ae039 = $2c958c4e419db9df$var$AttachmentsUpload;

});
parcelRegister("ayrxQ", function(module, exports) {

$parcel$export(module.exports, "BrowserLoader", () => $91b264e5a1a03fda$export$3ce634ac4a869e2c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


class $91b264e5a1a03fda$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'AsyncBrowser';
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("9lemj")),
                (parcelRequire("1gZ2y"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(this.state.Browser, {
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            Browser: $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("9lemj", function(module, exports) {

let $6cd1369e824d2440$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6cd1369e824d2440$var$load("5GwtU").then(()=>parcelRequire('7b5A1'));

});

parcelRegister("1gZ2y", function(module, exports) {

let $0ed6a26774047cb5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0ed6a26774047cb5$var$load("h2MrD"),
    $0ed6a26774047cb5$var$load("bYT2S"),
    $0ed6a26774047cb5$var$load("JoTl6")
]).then(()=>parcelRequire('fr527'));

});


parcelRegister("lU1w9", function(module, exports) {

$parcel$export(module.exports, "DropzoneLoader", () => $5f5f884766c60e4b$export$66201d263cd6342);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");



class $5f5f884766c60e4b$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'AsyncDropzone';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
            const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("9lemj")),
                (parcelRequire("bgKUp")),
                (parcelRequire("9WYQI"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $5f5f884766c60e4b$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $5f5f884766c60e4b$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2272]: Add operational error to catch async import error
        }
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(MediaPickerErrorBoundary, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Dropzone, {
                ...this.props
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            Dropzone: $5f5f884766c60e4b$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("bgKUp", function(module, exports) {

let $8345936e1ef22239$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8345936e1ef22239$var$load("h2MrD"),
    $8345936e1ef22239$var$load("bYT2S"),
    $8345936e1ef22239$var$load("aBP1r")
]).then(()=>parcelRequire('cw5oc'));

});

parcelRegister("9WYQI", function(module, exports) {

let $73e8bb36b273a50d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $73e8bb36b273a50d$var$load("hPzOn"),
    $73e8bb36b273a50d$var$load("3j9rr")
]).then(()=>parcelRequire('quJ0B'));

});


parcelRegister("495Tz", function(module, exports) {

$parcel$export(module.exports, "Clipboard", () => $a204c5b4c1d898fb$export$8b44c43c7d8f0830);

var $5uXOq = parcelRequire("5uXOq");

var $2AN6s = parcelRequire("2AN6s");

var $46dC9 = parcelRequire("46dC9");
const $a204c5b4c1d898fb$export$7b1ba4955557a858 = ()=>null;
const $a204c5b4c1d898fb$export$8b44c43c7d8f0830 = ({ config: config, isolated: isolated, ...props })=>{
    const container = (0, $46dC9.useClipboardContextBoundary)();
    const onPaste = (0, $5uXOq.useCallback)((event)=>{
        // do not propagate event above container boundary
        event.stopPropagation();
        // preventing default will disable any copy-paste
        // event.preventDefault();
        // false means "allow"
        return false;
    }, []);
    const derivedConfig = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        container ? {
            ...config,
            container: container,
            onPaste: onPaste
        } : config, [
        config,
        container,
        onPaste
    ]);
    if (!container && isolated !== false) // hard block clipboard if boundary is not set
    // render "marker" to ease testing
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a204c5b4c1d898fb$export$7b1ba4955557a858, null);
    // Here there is a good opportunity to report own existence to the boundary to prevent two Clipboards from being active at the same node
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2AN6s.ClipboardLoader), {
        ...props,
        config: derivedConfig
    });
};

});
parcelRegister("2AN6s", function(module, exports) {

$parcel$export(module.exports, "ClipboardLoader", () => $943d05c2815ce49d$export$d7936799bf32b554);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


class $943d05c2815ce49d$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'AsyncClipboard';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Clipboard) {
            const [mediaClient, clipboardModule] = await Promise.all([
                (parcelRequire("9lemj")),
                (parcelRequire("cabCi"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $943d05c2815ce49d$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $943d05c2815ce49d$export$d7936799bf32b554.Clipboard
            });
        }
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(this.state.Clipboard, {
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.state = {
            Clipboard: $943d05c2815ce49d$export$d7936799bf32b554.Clipboard
        };
    }
}

});
parcelRegister("cabCi", function(module, exports) {

let $8daf6e0487d24df6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8daf6e0487d24df6$var$load("axhr4").then(()=>parcelRequire('h0DlA'));

});


parcelRegister("46dC9", function(module, exports) {

$parcel$export(module.exports, "ClipboardStoreContainer", () => $315b0e877a12fb17$export$c4bc9440a978eec1);
$parcel$export(module.exports, "useClipboardContextActions", () => $315b0e877a12fb17$export$a3e41c5b3d4c30b7);
$parcel$export(module.exports, "useClipboardContextBoundary", () => $315b0e877a12fb17$export$37046969a30ae0a0);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $315b0e877a12fb17$var$ClipboardStore = (0, $iXqE5.createStore)({
    name: 'clipboard-store',
    // using containedBy will break all "unscoped" locations. We dont want it for now
    // containedBy: ClipboardStoreContainer,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initialState: {
        boundary: null
    },
    actions: {
        setClipBoardContext: (boundary)=>({ setState: setState })=>{
                setState({
                    boundary: boundary
                });
            }
    }
});
const $315b0e877a12fb17$export$c4bc9440a978eec1 = (0, $gg7kZ.createContainer)($315b0e877a12fb17$var$ClipboardStore);
const $315b0e877a12fb17$export$a3e41c5b3d4c30b7 = (0, $3sQ5x.createActionsHook)($315b0e877a12fb17$var$ClipboardStore);
const $315b0e877a12fb17$var$useClipboardContextBoundarySelector = (0, $3sQ5x.createHook)($315b0e877a12fb17$var$ClipboardStore, {
    selector: (state)=>state.boundary
});
const $315b0e877a12fb17$export$37046969a30ae0a0 = ()=>$315b0e877a12fb17$var$useClipboardContextBoundarySelector()[0];

});



parcelRegister("c431P", function(module, exports) {

$parcel$export(module.exports, "default", () => $23a51dc4ce208a9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $23a51dc4ce208a9a$var$messages = (0, $7VHMR.defineMessages)({
    dropzone: {
        "id": "issue-create-commons.attachments-field.dropzone",
        "defaultMessage": "Drop files to attach or"
    },
    browse: {
        "id": "issue-create-commons.attachments-field.browse",
        "defaultMessage": "Browse"
    },
    browseAriaLabel: {
        "id": "issue-create-commons.attachments-field.browse-aria-label",
        "defaultMessage": "Browse attachment"
    },
    missingToken: {
        "id": "issue-create-commons.attachments-field.missing-token",
        "defaultMessage": "Something went wrong"
    }
});
var $23a51dc4ce208a9a$export$2e2bcd8739ae039 = $23a51dc4ce208a9a$var$messages;

});



parcelRegister("1C9NJ", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectFieldTypeConfig", () => $19ee995e12970e69$export$b1cccbe22677a87b);

var $5uXOq = parcelRequire("5uXOq");

var $4xPlE = parcelRequire("4xPlE");

var $gbo8w = parcelRequire("gbo8w");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $19ee995e12970e69$var$CascadingSelectFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gbo8w.default), props);
const $19ee995e12970e69$export$b1cccbe22677a87b = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))),
    type: (0, $5fc53.CASCADING_SELECT_CF_TYPE),
    Component: $19ee995e12970e69$var$CascadingSelectFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.cascadingSelectFieldWriter)
};

});
parcelRegister("4xPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04ee2256c9951abd5553cb541d8d6854>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34f2132ab88342e6$var$_react = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $34f2132ab88342e6$var$_baseNew = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $34f2132ab88342e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34f2132ab88342e6$var$TaskIcon = (props)=>/*#__PURE__*/ $34f2132ab88342e6$var$_react.default.createElement($34f2132ab88342e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M3 14.25h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$34f2132ab88342e6$var$TaskIcon.displayName = 'TaskIcon';
var $34f2132ab88342e6$var$_default = module.exports.default = $34f2132ab88342e6$var$TaskIcon;

});

parcelRegister("gbo8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $094c2ce3abc8686f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4zFcG = parcelRequire("4zFcG");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $j0pqC = parcelRequire("j0pqC");

const $094c2ce3abc8686f$var$CascadingSelectField = (props)=>{
    const { fieldProps: { value: value, onChange: onChange, ...fieldProps }, allowedValues: cascadingSelectOptions, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isEditable: isEditable = true } = props;
    const { allowedValues: allowedValues, allowedChildValues: allowedChildValues } = (0, $5uXOq.useMemo)(()=>(0, $j0pqC.transformToCascadingSelectOptions)(cascadingSelectOptions), [
        cascadingSelectOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zFcG.AsyncCascadingSelectEdit), {
        ...fieldProps,
        value: value,
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues,
        // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLElement>) => boolean' is not assignable to type '(e: SyntheticEvent<HTMLElement, Event>) => boolean'.
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        // @ts-expect-error - TS2322 - Type '(value: SelectedOption) => void' is not assignable to type '(value: SelectedOption, meta: null, analyticsEvent: UIAnalyticsEventInterface) => Promise<void>'.
        onChange: onChange,
        isInvalid: false,
        autoFocus: autoFocus,
        areOptionsOnSameRow: false,
        isEditable: !isReadOnly && isEditable
    }));
};
var $094c2ce3abc8686f$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateCascadingSelectField),
    transformDefaultValue: $j0pqC.transformDefaultValue
})($094c2ce3abc8686f$var$CascadingSelectField);

});
parcelRegister("4zFcG", function(module, exports) {

$parcel$export(module.exports, "AsyncCascadingSelectEdit", () => $0a411cf33e78ceb6$export$7db21897d0716698);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kmnNN = parcelRequire("kmnNN");
const $0a411cf33e78ceb6$var$EMPTY_OBJECT = {};
const $0a411cf33e78ceb6$export$7db21897d0716698 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kmnNN.asyncCascadingSelectEditEntryPoint), // use stable object reference to avoid re-renders
    $0a411cf33e78ceb6$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "async-jira-issue-field-cascading-select-edit",
        packageName: "jira-issue-field-cascading-select",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("kmnNN", function(module, exports) {

$parcel$export(module.exports, "asyncCascadingSelectEditEntryPoint", () => $8f41019f840ae33a$export$336a3a4bd9539e41);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $8f41019f840ae33a$export$336a3a4bd9539e41 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eW4FG")).then((module)=>module.CascadingSelectViewEntryPointContent), {
        moduleId: "dba9fb26"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eW4FG", function(module, exports) {

let $adfa1b197796c7d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $adfa1b197796c7d7$var$load("bhpAB").then(()=>parcelRequire('aKsI4'));

});



parcelRegister("j0pqC", function(module, exports) {

$parcel$export(module.exports, "transformToCascadingSelectOptions", () => $c7fead76ffb795b3$export$b06e6053830d7554);
$parcel$export(module.exports, "transformDefaultValue", () => $c7fead76ffb795b3$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutateCascadingSelectField", () => $c7fead76ffb795b3$export$f402e35d933d11b5);

const $c7fead76ffb795b3$export$facac75482a8e0c5 = (option)=>{
    const { value: value, id: id } = option || {};
    if (value && id) return {
        label: value,
        value: id
    };
    return null;
};
const $c7fead76ffb795b3$export$b06e6053830d7554 = (cascadingSelectData)=>{
    const allowedValues = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allowedChildValues = {};
    cascadingSelectData.forEach(({ parentOptionValue: parentOptionValue, childOptionValues: childOptionValues })=>{
        const transformedParentOption = $c7fead76ffb795b3$export$facac75482a8e0c5(parentOptionValue);
        if (parentOptionValue !== null && transformedParentOption !== null) {
            allowedValues.push(transformedParentOption);
            allowedChildValues[parentOptionValue.id] = childOptionValues.map($c7fead76ffb795b3$export$facac75482a8e0c5);
        }
    });
    return {
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues
    };
};
const $c7fead76ffb795b3$export$e2f4e5d31db527cc = (defaultValue)=>{
    const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = defaultValue;
    const transformedParentOption = $c7fead76ffb795b3$export$facac75482a8e0c5(parentOptionValue);
    let transformedDefaultValue = null;
    if (transformedParentOption !== null) transformedDefaultValue = {
        ...transformedParentOption,
        child: childOptionValue ? $c7fead76ffb795b3$export$facac75482a8e0c5(childOptionValue) : undefined
    };
    return transformedDefaultValue;
};
const $c7fead76ffb795b3$export$f402e35d933d11b5 = (selectedOption, fieldId)=>({
        fieldId: fieldId,
        parentOptionValue: {
            optionId: selectedOption.value
        },
        // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
        childOptionValue: selectedOption.child ? {
            // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
            optionId: selectedOption.child.value
        } : null,
        mutationGroup: (0, $4a7dfdb992f68644$export$31fd86f8f183952c)
    });

});
const $4a7dfdb992f68644$export$31fd86f8f183952c = 'cascadingSelectFields';




parcelRegister("97VNg", function(module, exports) {

$parcel$export(module.exports, "CategoryFieldTypeConfig", () => $8500d0c5b0bf9983$export$3e2ea7bfd7261cb5);

var $5uXOq = parcelRequire("5uXOq");

var $3fDjf = parcelRequire("3fDjf");

var $k4tyx = parcelRequire("k4tyx");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $8500d0c5b0bf9983$var$CategoryFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4tyx.default), {
        ...props,
        defaultValue: undefined
    });
const $8500d0c5b0bf9983$export$3e2ea7bfd7261cb5 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3fDjf))),
    type: (0, $5fc53.CATEGORY_TYPE),
    Component: $8500d0c5b0bf9983$var$CategoryFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.selectFieldWriter)
};

});
parcelRegister("k4tyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $108361897c01a8f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d3RWa = parcelRequire("d3RWa");

const $108361897c01a8f5$var$SingleSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d3RWa.default), {
        ...props,
        isMulti: false,
        closeMenuOnSelect: true
    });
var $108361897c01a8f5$export$2e2bcd8739ae039 = $108361897c01a8f5$var$SingleSelectField;

});
parcelRegister("d3RWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $da96ee86c52df1e6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cOyAh = parcelRequire("cOyAh");

var $5pHXe = parcelRequire("5pHXe");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $hpV4g = parcelRequire("hpV4g");

var $7C5S0 = parcelRequire("7C5S0");

var $90YqS = parcelRequire("90YqS");
const $da96ee86c52df1e6$var$SelectField = (props)=>{
    const { fieldId: fieldId, autoFocus: autoFocus = false, allowedValues: allowedValues, width: width, error: error, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isMulti: isMulti = false, isReadOnly: isReadOnly = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, closeMenuOnSelect: closeMenuOnSelect = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOyAh.default), {
        onChange: onChange,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        options: (0, $5pHXe.mapDataToSelectOptions)(allowedValues),
        value: value,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        classNamePrefix: `select-${fieldId}`,
        isMulti: isMulti,
        hideSelectedOptions: true,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isClearable: true,
        onFilterOption: (0, $90YqS.onFilterOption),
        isDisabled: isReadOnly,
        isRequired: isRequired,
        inputId: id,
        closeMenuOnSelect: closeMenuOnSelect
    }));
};
var $da96ee86c52df1e6$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $90YqS.transformDefaultSelectValues),
    validator: (0, $jGVMX.validateSelectField)
})($da96ee86c52df1e6$var$SelectField);

});
parcelRegister("cOyAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ff8480905da065$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $lElIo = parcelRequire("lElIo");

var $4R6GH = parcelRequire("4R6GH");
const $45ff8480905da065$var$SelectEdit = (props)=>{
    const { classNamePrefix: classNamePrefix, closeMenuOnSelect: closeMenuOnSelect = false, placeholder: placeholder = '', options: options, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus = false, isInvalid: isInvalid, isMulti: isMulti = false, isDisabled: isDisabled = false, value: value, isClearable: isClearable, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onFilterOption: onFilterOption, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, defaultMenuIsOpen: defaultMenuIsOpen } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        placeholder: placeholder,
        options: options,
        value: value,
        classNamePrefix: classNamePrefix,
        // @ts-expect-error - TS2322 - Type '(option: SelectOption) => void' is not assignable to type '(value: SelectOption | OptionsType<SelectOption> | null, action: ActionMeta<SelectOption>) => void'.
        onChange: onChange,
        onBlur: onBlur,
        isMulti: isMulti,
        onFocus: onFocus,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        isClearable: isClearable,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        filterOption: onFilterOption,
        inputId: inputId,
        required: isRequired,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        closeMenuOnSelect: closeMenuOnSelect,
        ...(0, $4R6GH.fg)('bulk_ops_ktlo_fixes') && {
            defaultMenuIsOpen: defaultMenuIsOpen
        }
    });
};
var $45ff8480905da065$export$2e2bcd8739ae039 = $45ff8480905da065$var$SelectEdit;

});

parcelRegister("90YqS", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSelectValues", () => $3a49366a4ffd7ccc$export$cfb7677fb5241257);
$parcel$export(module.exports, "onFilterOption", () => $3a49366a4ffd7ccc$export$5fde4483c43b93b);

var $5pHXe = parcelRequire("5pHXe");
const $3a49366a4ffd7ccc$export$cfb7677fb5241257 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return (0, $5pHXe.mapDataToSelectOptions)(defaultValue);
    return (0, $5pHXe.mapDataToSelectOption)(defaultValue);
};
const $3a49366a4ffd7ccc$export$5fde4483c43b93b = (option, inputValue)=>option.label.toLowerCase().includes(inputValue.toLowerCase());

});




parcelRegister("aR835", function(module, exports) {

$parcel$export(module.exports, "ComponentsFieldTypeConfig", () => $004c360808306af4$export$75a450cecebc09fa);

var $5uXOq = parcelRequire("5uXOq");

var $ehis8 = parcelRequire("ehis8");

var $776me = parcelRequire("776me");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $004c360808306af4$var$ComponentsFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $776me.default), props);
// Effectively the same as `multiSelectFieldWriter`. For some reason, the type of the field value of
// `ComponentsField` (`Options`) has a nullable value type. This function just pre-processes the value
// to strip away any `null` value options before passing it to `multiSelectFieldWriter`.
const $004c360808306af4$var$componentsFieldWriter = (id, value, fields)=>{
    const filteredValues = value.filter((option)=>option.value !== null);
    (0, $kShoa.multiSelectFieldWriter)(id, filteredValues, fields);
};
const $004c360808306af4$export$75a450cecebc09fa = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ehis8))),
    type: (0, $5fc53.COMPONENTS_TYPE),
    Component: $004c360808306af4$var$ComponentsFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: $004c360808306af4$var$componentsFieldWriter
};

});
parcelRegister("776me", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6c3a95c2efe6aba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $hFon0 = parcelRequire("hFon0");

var $koVbs = parcelRequire("koVbs");

var $as9La = parcelRequire("as9La");

var $6Fkzt = parcelRequire("6Fkzt");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $YSJPS = parcelRequire("YSJPS");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $b399U = parcelRequire("b399U");

const $f6c3a95c2efe6aba$var$ComponentsField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired, ...fieldProps }, error: error, allowedValues: allowedValues, selectedProject: selectedProject, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isDisabled = allowedValues.length === 0;
    const options = (0, $6Fkzt.mapDataToOptions)(allowedValues);
    const { projectKey: projectKey } = selectedProject || {};
    const projectKeyStr = projectKey || '';
    const { enabled: areGlobalComponentsEnabled, loading: loading } = (0, $hFon0.useGlobalComponentsProperty)(projectKeyStr);
    const getComponentSelectEdit = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YSJPS.StyledFieldSkeleton), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $as9La.default), {
            ...fieldProps,
            options: options,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            showFooter: false,
            projectKey: projectKeyStr,
            placeholder: isDisabled ? formatMessage((0, $b399U.default).none) : '',
            isDisabled: isDisabled || isReadOnly,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            canCreateNewItem: !areGlobalComponentsEnabled,
            inputId: id,
            isRequired: isRequired
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $b399U.default).tooltipWhenDisabled)
    }, getComponentSelectEdit()) : getComponentSelectEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $f6c3a95c2efe6aba$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $6Fkzt.mapDataToOptions),
    validator: (0, $jGVMX.validateComponentField),
    shouldRenderFieldMessage: false
})($f6c3a95c2efe6aba$var$ComponentsField);

});
parcelRegister("hFon0", function(module, exports) {

$parcel$export(module.exports, "useGlobalComponentsProperty", () => $e88d764a116eddca$export$a070f388fcd93df0);

var $5uXOq = parcelRequire("5uXOq");

var $do78Z = parcelRequire("do78Z");

var $feQhf = parcelRequire("feQhf");
function $e88d764a116eddca$export$a070f388fcd93df0(projectKey) {
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [enabled, setEnabled] = (0, $5uXOq.useState)(undefined);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const loadGlobalComponentsProperty = (0, $5uXOq.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $5uXOq.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        loadGlobalComponentsProperty();
        (0, $feQhf.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    const setProperty = (0, $5uXOq.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $feQhf.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $do78Z.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}

});
parcelRegister("do78Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b15e5e3de311da0$export$2e2bcd8739ae039);

var $c3jsi = parcelRequire("c3jsi");

var $1AJVB = parcelRequire("1AJVB");
var $2b15e5e3de311da0$export$2e2bcd8739ae039 = (0, $c3jsi.default)((0, $1AJVB.props));

});
parcelRegister("c3jsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdca2a0bd8756d7$export$2e2bcd8739ae039);

var $8Op28 = parcelRequire("8Op28");
const $ccdca2a0bd8756d7$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ccdca2a0bd8756d7$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $8Op28.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $ccdca2a0bd8756d7$var$pNothing,
        update: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $ccdca2a0bd8756d7$var$pNothing
    };
};

});
parcelRegister("8Op28", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3e46065a4b1d2500$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $3e46065a4b1d2500$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");

var $dJl1T = parcelRequire("dJl1T");


var $1NZBJ = parcelRequire("1NZBJ");
const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $1NZBJ.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, $bSSG7.createLocalStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        else storage = (0, $eNf8a.createSessionStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $dJl1T.default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $1NZBJ.default).scopes.current !== (0, $1NZBJ.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3e46065a4b1d2500$var$cacheMap = {};
const $3e46065a4b1d2500$var$getCache = async (props)=>{
    await (0, $1NZBJ.scopeGuard)().catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
    return $3e46065a4b1d2500$var$cacheMap[cacheKey];
};
const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
    Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
};
var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;

});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';



parcelRegister("1AJVB", function(module, exports) {

$parcel$export(module.exports, "props", () => $68c0e7b1e3ad3adb$export$8128bb6492cf3de7);

const $68c0e7b1e3ad3adb$var$MAX_RESULTS = 10;
const $68c0e7b1e3ad3adb$var$CACHE_SIZE = $68c0e7b1e3ad3adb$var$MAX_RESULTS * 2;
const $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY = 'components';
const $68c0e7b1e3ad3adb$export$8128bb6492cf3de7 = {
    size: $68c0e7b1e3ad3adb$var$CACHE_SIZE,
    cacheKey: $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)
};

});


parcelRegister("feQhf", function(module, exports) {

$parcel$export(module.exports, "getGlobalComponentsProperty", () => $f3ade48088ec15c3$export$1db3503600a1638e);
$parcel$export(module.exports, "setGlobalComponentsProperty", () => $f3ade48088ec15c3$export$71702a5b14caff65);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $f3ade48088ec15c3$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $f3ade48088ec15c3$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $f3ade48088ec15c3$var$getProjectId = async (projectKey)=>{
    const project = await (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $f3ade48088ec15c3$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $eusud.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};
async function $f3ade48088ec15c3$export$71702a5b14caff65(projectKey, value) {
    try {
        let endpoint;
        if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
            if (!projectId) return;
            endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        await (0, $eusud.performPutRequest)(endpoint, {
            body: JSON.stringify(value)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'setGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
}

});


parcelRegister("as9La", function(module, exports) {

$parcel$export(module.exports, "default", () => $974a261702eec2af$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iOwNT = parcelRequire("iOwNT");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $2Icx9 = parcelRequire("2Icx9");

var $lMeVa = parcelRequire("lMeVa");
const $974a261702eec2af$var$ComponentsSelectEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus = false, isInvalid: isInvalid = false, isDisabled: isDisabled = false, showFooter: showFooter = false, onCloseMenuOnScroll: onCloseMenuOnScroll, projectKey: projectKey, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, canCreateNewItem: canCreateNewItem = false, formatNewInlineComponentCreateLabel: formatNewInlineComponentCreateLabel, inputId: inputId, isRequired: isRequired, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getNewInlineComponentCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatNewInlineComponentCreateLabel !== undefined ? formatNewInlineComponentCreateLabel : formatMessage((0, $lMeVa.default).createNewItem)})`, [
        formatNewInlineComponentCreateLabel,
        formatMessage
    ]);
    const isValidNewOption = (0, $5uXOq.useCallback)((query)=>{
        const fieldInputLabels = options.map((option)=>option.label.toLowerCase());
        return canCreateNewItem && query.trim() !== '' && !fieldInputLabels.includes(query.trim().toLowerCase());
    }, [
        canCreateNewItem,
        options
    ]);
    const handleInlineComponentCreate = (inputValue)=>{
        onChange([
            ...value || [],
            {
                label: inputValue,
                value: null
            }
        ]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iOwNT.default), {
        inputId: inputId,
        required: isRequired,
        ...fieldProps,
        value: value,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - TS2322 - Type 'Options' is not assignable to type 'readonly (Options | GroupBase<Options>)[]
        options: options,
        placeholder: placeholder || formatMessage((0, $lMeVa.default).placeholder),
        // @ts-expect-error - TS2322 - Type '(arg1: Options) => void' is not assignable to type '(value: OptionsType<{ label: string; value: string; }>, action: ActionMeta<{ label: string; value: string; }>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: (menuListProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Icx9.default), {
                    ...menuListProps,
                    showFooter: showFooter,
                    projectKey: projectKey
                })
        },
        isMulti: true,
        isDisabled: isDisabled,
        isValidNewOption: isValidNewOption,
        formatCreateLabel: getNewInlineComponentCreateLabel,
        onCreateOption: handleInlineComponentCreate,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "components-field-select" // added this for testing purpose, it doesn't apply any style
        ,
        classNamePrefix: "components-field-select"
    });
};
var $974a261702eec2af$export$2e2bcd8739ae039 = $974a261702eec2af$var$ComponentsSelectEdit;

});
parcelRegister("2Icx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5b255b0441ea615$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $99M5v = parcelRequire("99M5v");

var $bChGW = parcelRequire("bChGW");

var $koVbs = parcelRequire("koVbs");

var $dyW5a = parcelRequire("dyW5a");
const $b5b255b0441ea615$var$MenuWithFooter = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, showFooter: showFooter, projectKey: projectKey, footerLabel: footerLabel, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, restProps, children), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$fd9000017733fabf, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$500fb058ad7aeb1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$e0513c91be1318ca, {
        href: `/plugins/servlet/project-config/${projectKey}/administer-components`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
        label: "componentFooterAddIcon",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$var$LinkText, null, footerLabel ?? formatMessage((0, $dyW5a.default).componentLabel))))));
};
var $b5b255b0441ea615$export$2e2bcd8739ae039 = $b5b255b0441ea615$var$MenuWithFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5b255b0441ea615$var$LinkText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $b5b255b0441ea615$export$fd9000017733fabf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dope8f _1e0c1txw _2lx2vrvc _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});
const $b5b255b0441ea615$export$500fb058ad7aeb1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3utpp _n3td1b66 _19bvutpp _1bsb1osq _irr314ae",
            __cmplp.className
        ])
    });
});
const $b5b255b0441ea615$export$e0513c91be1318ca = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dyW5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ca6088d964e72a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $86ca6088d964e72a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    componentLabel: {
        "id": "issue-field-components-field.edit.menu.component-label",
        "defaultMessage": "Create new component"
    }
});

});


parcelRegister("lMeVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb020ac6d54b422f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb020ac6d54b422f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-field-components-field.edit.placeholder",
        "defaultMessage": "Select Component"
    },
    createNewItem: {
        "id": "issue-field-components-field.edit.create-new-item",
        "defaultMessage": "New Component"
    }
});

});


parcelRegister("6Fkzt", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $4d2c67350b914b81$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $4d2c67350b914b81$export$ffef3a401aef987b);
const $4d2c67350b914b81$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $4d2c67350b914b81$export$ffef3a401aef987b = (data)=>data.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));

});

parcelRegister("b399U", function(module, exports) {

$parcel$export(module.exports, "default", () => $f31bbe63abb7b51a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $f31bbe63abb7b51a$var$messages = (0, $7VHMR.defineMessages)({
    none: {
        "id": "issue-create-commons.components-field.none",
        "defaultMessage": "None"
    },
    tooltipWhenDisabled: {
        "id": "issue-create-commons.components-field.tooltip-when-disabled",
        "defaultMessage": "We couldn't find any components for this project"
    }
});
var $f31bbe63abb7b51a$export$2e2bcd8739ae039 = $f31bbe63abb7b51a$var$messages;

});



parcelRegister("9Hxrl", function(module, exports) {

$parcel$export(module.exports, "DateCustomFieldTypeConfig", () => $bdb941f53f9415a4$export$a7f793e7c226ca61);

var $5uXOq = parcelRequire("5uXOq");

var $hyKRO = parcelRequire("hyKRO");

var $iY8FG = parcelRequire("iY8FG");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $bdb941f53f9415a4$var$DateCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iY8FG.default), props);
const $bdb941f53f9415a4$export$a7f793e7c226ca61 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))),
    type: (0, $5fc53.DATE_CF_TYPE),
    Component: $bdb941f53f9415a4$var$DateCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DateFieldPlaceholder), null),
    writer: (0, $kShoa.dateFieldWriter)
};

});
parcelRegister("iY8FG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f022abefd67c0e3c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cHapz = parcelRequire("cHapz");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $DVljb = parcelRequire("DVljb");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $9FL4D = parcelRequire("9FL4D");

var $jGVMX = parcelRequire("jGVMX");

var $eVzdP = parcelRequire("eVzdP");

const $f022abefd67c0e3c$var$DateField = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value = '', onChange: onChange, id: id }, error: error, isReadOnly: isReadOnly = false } = props;
    const locale = (0, $DVljb.useNativeLocale)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const weekStartDay = (0, $1p96B.getLocale)(locale)?.options?.weekStartsOn;
    const safeValue = value === null ? undefined : value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHapz.default), {
        value: safeValue,
        isDisabled: isReadOnly,
        onChange: onChange,
        autoFocus: autoFocus,
        locale: locale,
        isInvalid: Boolean(error),
        selectProps: {
            /**
      	Temporary fix to prevent form submit on enter press on an open calendar.
      	Ideally this should either be handled by atlaskit or keypress enter event should only be supressed when calendar is open.
      	There is no way to know if the calendar is open in the current implementation
      		Side Effect: Form will not submit on enter keyPress even when calendar is not open.
      */ onKeyDown: (0, $9FL4D.preventFormSubmitOnEnterKeyPress)
        },
        weekStartDay: weekStartDay,
        label: formatMessage((0, $eVzdP.default).ariaLabel),
        "aria-describedby": `${id}-helper`,
        id: id,
        placeholder: formatMessage((0, $eVzdP.default).placeholder),
        shouldShowCalendarButton: true,
        inputLabel: formatMessage((0, $eVzdP.default).ariaLabel)
    }));
};
var // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateFieldConfig, FieldValue>, any>'.
$f022abefd67c0e3c$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})($f022abefd67c0e3c$var$DateField);

});
parcelRegister("cHapz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a844b50b385d50f7$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");
const $a844b50b385d50f7$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;

});
parcelRegister("cKsfY", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $8f027f90da2b6bac$export$6e8ea24b15199873);

var $5uXOq = parcelRequire("5uXOq");
function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("2TI0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19201d0a1f7d7d54$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
function $19201d0a1f7d7d54$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
const $19201d0a1f7d7d54$var$dropdownIndicatorStyles = (0, $8CUq3.xcss)({
    minWidth: "var(--ds-space-300, 24px)",
    minHeight: "var(--ds-space-300, 24px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
const $19201d0a1f7d7d54$var$pickerContainerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $19201d0a1f7d7d54$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    flexBasis: 'inherit',
    color: 'color.text.subtlest',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    transition: `color 150ms`,
    ':hover': {
        color: 'color.text.subtle'
    }
});
const $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.400'
});
const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.050'
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $5RLF6.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso);
            // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $5RLF6.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                });
                // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $6AqCE.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
            // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        }, // This event handler is triggered from both keydown and click. It's weird.
        this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                });
                // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        }, // `unknown` is used because `value` is unused so it does not matter.
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date()),
            l10n: (0, $7qZ1x.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $7qZ1x.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $19201d0a1f7d7d54$var$dropdownIndicatorStyles
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $dBs4v.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iaQLg.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gtijU.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $jHBnA.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
        };
        // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $5RLF6.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null;
        // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        // Until innerProps is removed, it must remain a div rather than a primitive component.
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ...innerProps,
            css: $19201d0a1f7d7d54$var$pickerContainerStyles,
            // Since the onclick, onfocus are passed down, adding role="presentation" prevents typecheck errors.
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7K5PP.default), {
            appearance: this.props.appearance,
            "aria-describedby": ariaDescribedBy,
            label: label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            // FOr some reason, this and the below `styles` type error _only_ show
            // up when you alter some of the properties in the `selectComponents`
            // object. These errors are still present, and I suspect have always
            // been present, without changing the unrelated code. Ignoring as the
            // component still works as expected despite this error. And also
            // because the select refresh team may solve it later.
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: this.onSelectBlur,
            onChange: this.onSelectChange,
            onFocus: this.onSelectFocus,
            onInputChange: this.handleSelectInputChange,
            placeholder: (0, $5RLF6.getPlaceholder)({
                placeholder: this.props.placeholder,
                l10n: this.state.l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            // These are below the spread because I don't know what is in
            // selectProps or not and what wil be overwritten
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            // These aren't part of `Select`'s API, but we're using them here.
            // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9KnKW.IdProvider), {
            prefix: "open-calendar-label--"
        }, ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: [
                    $19201d0a1f7d7d54$var$iconContainerStyles,
                    value && !hideIcon ? $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles : $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles
                ]
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
                appearance: "subtle",
                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                id: openCalendarLabelId,
                icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                        ...iconProps,
                        color: "var(--ds-icon, #44546F)"
                    }),
                onClick: this.onCalendarButtonClick,
                onKeyDown: this.onCalendarButtonKeyDown,
                ref: this.calendarButtonRef,
                testId: testId && `${testId}--open-calendar-button`
            }))) : null));
    }
}
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $19201d0a1f7d7d54$var$DatePicker = (0, $994MI.default)({
    componentName: 'datePicker',
    packageName: $19201d0a1f7d7d54$var$packageName,
    packageVersion: $19201d0a1f7d7d54$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $19201d0a1f7d7d54$var$packageName,
            packageVersion: $19201d0a1f7d7d54$var$packageVersion
        }
    })
})($19201d0a1f7d7d54$export$df43d21f5faca9f7));
var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;

});
parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $is0Fy.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $3wYKB = parcelRequire("3wYKB");

var $lCAti = parcelRequire("lCAti");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("5RLF6", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $e0db4b6edb7dbfac$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $e0db4b6edb7dbfac$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $e0db4b6edb7dbfac$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $e0db4b6edb7dbfac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $2ucUe = parcelRequire("2ucUe");

var $jHBnA = parcelRequire("jHBnA");
const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(parsedDate)}`;
    return newIso;
};
const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $jHBnA.defaultDateFormat));
    return l10n.parseDate(date);
};
const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $jHBnA.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $jHBnA.placeholderDatetime));
};

});
parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("iaQLg", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $d73476b891de3e0c$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bChGW = parcelRequire("bChGW");
function $d73476b891de3e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d73476b891de3e0c$var$calendarButtonInclusionStyles = {
    name: "i3e4rp",
    styles: "margin-inline-start:var(--ds-space-400, 32px)"
};
const $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles = {
    name: "19a3ait",
    styles: "margin-inline-start:var(--ds-space-300, 24px)"
};
const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: showClearIndicator ? $d73476b891de3e0c$var$calendarButtonInclusionStyles : $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).IndicatorsContainer, rest));

});

parcelRegister("gtijU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e800a879ee1613fc$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $1f0Hs = parcelRequire("1f0Hs");

var $9MHPe = parcelRequire("9MHPe");


var $k5uoT = parcelRequire("k5uoT");

var $avHVh = parcelRequire("avHVh");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $e800a879ee1613fc$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $e800a879ee1613fc$var$menuStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: (0, $k5uoT.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    overflow: 'hidden'
});
const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
    const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9MHPe.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: // The mousedown event is required for a date selection to work when
        // the menu is opened via the calendar button. The reason why is
        // because there is a mousedown event on the menu inside of
        // `react-select` that will stop the calendar select event from
        // firing. This is passed in via the `innerProps`. Therefore, we must
        // pass it in *after* the `innerProps` spread.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $e800a879ee1613fc$var$menuStyles,
            ...innerProps,
            onMouseDown: onMenuMouseDown
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1f0Hs.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            ref: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));
};

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ $5uXOq.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $16abbcd9b9109722$var$styles.box,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ $5uXOq.createElement((0, $414Wj.default), {
        space: "space.150"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ePz3p.default // The month number needs to be translated to index in the month
    ), {
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextMonthHeading: getNextMonthHeading(),
        nextYearHeading: getNextYearHeading(),
        previousMonthHeading: getPreviousMonthHeading(),
        previousYearHeading: getPreviousYearHeading(),
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ $5uXOq.createElement((0, $avO9B.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ $5uXOq.createElement((0, $lJWdi.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    }))))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ $5uXOq.createElement($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("414Wj", function(module, exports) {

$parcel$export(module.exports, "default", () => $452354e10b30c8d8$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $452354e10b30c8d8$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $452354e10b30c8d8$var$Stack = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $452354e10b30c8d8$var$styles.hug, grow === 'fill' && $452354e10b30c8d8$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$452354e10b30c8d8$var$Stack.displayName = 'Stack';
var $452354e10b30c8d8$export$2e2bcd8739ae039 = $452354e10b30c8d8$var$Stack;

});
parcelRegister("bUmQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ccb72b8ddc20b7$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0ccb72b8ddc20b7$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $d0ccb72b8ddc20b7$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $d0ccb72b8ddc20b7$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $d0ccb72b8ddc20b7$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $d0ccb72b8ddc20b7$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $d0ccb72b8ddc20b7$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $d0ccb72b8ddc20b7$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $d0ccb72b8ddc20b7$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $d0ccb72b8ddc20b7$var$styles.root,
            gap && $d0ccb72b8ddc20b7$var$columnGapMap[gap],
            columnGap && $d0ccb72b8ddc20b7$var$columnGapMap[columnGap],
            gap && $d0ccb72b8ddc20b7$var$rowGapMap[gap],
            rowGap && $d0ccb72b8ddc20b7$var$rowGapMap[rowGap],
            alignItems && $d0ccb72b8ddc20b7$var$alignItemsMap[alignItems],
            direction && $d0ccb72b8ddc20b7$var$flexDirectionMap[direction],
            justifyContent && $d0ccb72b8ddc20b7$var$justifyContentMap[justifyContent],
            wrap && $d0ccb72b8ddc20b7$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$d0ccb72b8ddc20b7$var$Flex.displayName = 'Flex';
var $d0ccb72b8ddc20b7$export$2e2bcd8739ae039 = $d0ccb72b8ddc20b7$var$Flex;

});


parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $l1N8i = parcelRequire("l1N8i");

var $iPF0X = parcelRequire("iPF0X");

var $dq6Kz = parcelRequire("dq6Kz");

var $lRheX = parcelRequire("lRheX");

var $3dGN0 = parcelRequire("3dGN0");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, (0, $VSDnB.fg)('dst-a11y-add-year-buttons-to-calendar') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevYearInteraction,
        testId: testId && `${testId}--previous-year`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iPF0X))),
        label: `${previousYearLabel}, ${previousYearHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lRheX))),
        label: `${previousMonthLabel}, ${previousMonthHeading}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))),
        label: `${previousMonthLabel}, ${previousMonthHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), (0, $VSDnB.fg)('dst-a11y-add-year-buttons-to-calendar') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100",
        alignBlock: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))),
        label: `${nextMonthLabel}, ${nextMonthHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextYearInteraction,
        testId: testId && `${testId}--next-year`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dq6Kz))),
        label: `${nextYearLabel}, ${nextYearHeading}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6s76W))),
        label: `${nextMonthLabel}, ${nextMonthHeading}`
    })));
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("iPF0X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e9bde9ffb1901db299d24420ed3d13>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db5cce05fac9743f$var$_react = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $db5cce05fac9743f$var$_baseNew = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $db5cce05fac9743f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDoubleLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db5cce05fac9743f$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $db5cce05fac9743f$var$_react.default.createElement($db5cce05fac9743f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 10.5 6 6l4.5-4.5m-4.75 9L1.25 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$db5cce05fac9743f$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $db5cce05fac9743f$var$_default = module.exports.default = $db5cce05fac9743f$var$ChevronDoubleLeftIcon;

});

parcelRegister("dq6Kz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71b79966080ec94bc04e328878ca72a7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c52f081c61754ba$var$_react = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c52f081c61754ba$var$_baseNew = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c52f081c61754ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDoubleRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c52f081c61754ba$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $9c52f081c61754ba$var$_react.default.createElement($9c52f081c61754ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.5 10.5 6 6 1.5 1.5m4.75 9 4.5-4.5-4.5-4.5"/>`,
        type: 'utility'
    }, props));
$9c52f081c61754ba$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $9c52f081c61754ba$var$_default = module.exports.default = $9c52f081c61754ba$var$ChevronDoubleRightIcon;

});

parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6122da5228d1f3e4cce8be42702737a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("c0aEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed572e62fc5b1cd0$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $ed572e62fc5b1cd0$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $ed572e62fc5b1cd0$var$Separator = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            $ed572e62fc5b1cd0$var$styles.separator
        ])
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $ed572e62fc5b1cd0$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5uXOq.createElement($ed572e62fc5b1cd0$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $ed572e62fc5b1cd0$var$styles.hug, grow === 'fill' && $ed572e62fc5b1cd0$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$ed572e62fc5b1cd0$var$Inline.displayName = 'Inline';
var $ed572e62fc5b1cd0$export$2e2bcd8739ae039 = $ed572e62fc5b1cd0$var$Inline;

});


parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h581D.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1q4y8.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $joKkQ = parcelRequire("joKkQ");
const $d70b02566a310b79$var$dateCellSiblingStyle = null;
const $d70b02566a310b79$var$dateCellTodayStyle = null;
const $d70b02566a310b79$var$dateCellPrevSelectedStyle = null;
const $d70b02566a310b79$var$dateCellSelectedStyle = null;
const $d70b02566a310b79$var$dateCellDisabledStyle = null;
const $d70b02566a310b79$var$dateCellStyles = null;
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $joKkQ.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ $5uXOq.createElement("button", {
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
        className: (0, $bwpsq.default)([
            "_kkk2n7od _2rko1l7b _11c81oud _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
            isSibling && "_syaz1wmz _30l31wmz",
            isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
            isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
            isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
            isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
        ])
    }, day));
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- TODO: Allow pass-through from `props.xcss`
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $joKkQ = parcelRequire("joKkQ");
const $5c8aba25f4ae00ff$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joKkQ.default), {
        testId: testId,
        xcss: $5c8aba25f4ae00ff$var$styles.templateColumns,
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
            padding: "space.100",
            xcss: $f29b1b1295ce3a84$var$styles.columnHeader,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");

var $k5uoT = parcelRequire("k5uoT");
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - (0, $k5uoT.gridSize)()
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkD4s.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1V7PR.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oNEb.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $k5uoT.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args), this.update = (0, $eGmKJ.default);
    }
}

});


parcelRegister("6AqCE", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $caee16c105163c22$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $caee16c105163c22$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $2ucUe = parcelRequire("2ucUe");
function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)('YYYY-MM-DD'));
}
function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue
        }, children);
    };

});


parcelRegister("jcbUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5b21daaca02ab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
function $48f5b21daaca02ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $48f5b21daaca02ab$var$packageName = "platform-pkg";
const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
const $48f5b21daaca02ab$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $48f5b21daaca02ab$var$packageName,
    packageVersion: $48f5b21daaca02ab$var$packageVersion
};
const $48f5b21daaca02ab$var$pickerContainerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $48f5b21daaca02ab$var$dropdownIndicatorStyles = (0, $8CUq3.xcss)({
    minWidth: "var(--ds-space-300, 24px)",
    minHeight: "var(--ds-space-300, 24px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $48f5b21daaca02ab$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    flexBasis: 'inherit',
    color: 'color.text.subtlest',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    transition: `color 150ms`,
    ':hover': {
        color: 'color.text.subtle'
    }
});
const $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.400'
});
const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.050'
});
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $48f5b21daaca02ab$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$48f5b21daaca02ab$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $7qZ1x.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false);
            // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $5RLF6.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso);
        // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $5RLF6.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            });
            // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6AqCE.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase();
        // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
        // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    };
    // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen(!isOpen);
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    };
    // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref;
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            xcss: $48f5b21daaca02ab$var$dropdownIndicatorStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, props));
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iaQLg.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gtijU.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
    };
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $5RLF6.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null;
    // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $9KnKW.useId)()}`;
    return(// These event handlers must be on this element because the events come
    // from different child elements.
    // Until innerProps is removed, it must remain a div rather than a primitive component.
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...innerProps,
        css: $48f5b21daaca02ab$var$pickerContainerStyles,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        // Since the onclick, onfocus are passed down, adding role="presentation" prevents typecheck errors.
        role: "presentation"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        name: name,
        type: "hidden",
        value: getterValue,
        "data-testid": testId && `${testId}--input`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7K5PP.default), {
        appearance: appearance,
        "aria-describedby": ariaDescribedBy,
        label: label || undefined,
        autoFocus: autoFocus,
        clearControlLabel: clearControlLabel,
        closeMenuOnSelect: true,
        // For some reason, this and the below `styles` type error _only_ show
        // up when you alter some of the properties in the `selectComponents`
        // object. These errors are still present, and I suspect have always
        // been present, without changing the unrelated code. Ignoring as the
        // component still works as expected despite this error. And also
        // because the select refresh team may solve it later.
        components: selectComponents,
        enableAnimation: false,
        inputId: id,
        inputValue: actualSelectInputValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: menuIsOpen,
        onBlur: onSelectBlur,
        onChange: onSelectChange,
        onFocus: onSelectFocus,
        onInputChange: handleSelectInputChange,
        placeholder: (0, $5RLF6.getPlaceholder)({
            placeholder: placeholder,
            l10n: l10n
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        styles: mergedStyles,
        value: initialValue,
        ...selectProps,
        // These are below the spread because I don't know what is in
        // selectProps or not and what wil be overwritten
        isClearable: true,
        isInvalid: isInvalid,
        spacing: spacing,
        testId: testId,
        // These aren't part of `Select`'s API, but we're using them here.
        // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
        calendarContainerRef: calendarProps.calendarContainerRef,
        calendarDisabled: calendarProps.calendarDisabled,
        calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
        calendarLocale: calendarProps.calendarLocale,
        calendarMaxDate: calendarProps.calendarMaxDate,
        calendarMinDate: calendarProps.calendarMinDate,
        calendarRef: calendarProps.calendarRef,
        calendarValue: calendarProps.calendarValue,
        calendarView: calendarProps.calendarView,
        calendarWeekStartDay: calendarProps.calendarWeekStartDay,
        nextMonthLabel: nextMonthLabel,
        onCalendarChange: calendarProps.onCalendarChange,
        onCalendarSelect: calendarProps.onCalendarSelect,
        previousMonthLabel: previousMonthLabel,
        shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
    }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: [
            $48f5b21daaca02ab$var$iconContainerStyles,
            value && !hideIcon ? $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles : $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
        appearance: "subtle",
        label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
        "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
        id: openCalendarLabelId,
        icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                ...iconProps,
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                color: "var(--ds-icon, #44546F)"
            }),
        onClick: onCalendarButtonClick,
        onKeyDown: onCalendarButtonKeyDown,
        ref: calendarButtonRef,
        testId: testId && `${testId}--open-calendar-button`
    })) : null));
});
var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;

});


parcelRegister("9FL4D", function(module, exports) {

$parcel$export(module.exports, "preventFormSubmitOnEnterKeyPress", () => $ee02e7651d6a8221$export$9d2267fe165de4b6);
const $ee02e7651d6a8221$export$9d2267fe165de4b6 = (event)=>{
    event.key === 'Enter' && event.preventDefault();
};

});

parcelRegister("eVzdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $049ff715c3e8bf03$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $049ff715c3e8bf03$var$messages = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-create-commons.date-field.placeholder",
        "defaultMessage": "Select date"
    },
    ariaLabel: {
        "id": "issue-create-commons.date-field.aria-label",
        "defaultMessage": "Enter a Date"
    }
});
var $049ff715c3e8bf03$export$2e2bcd8739ae039 = $049ff715c3e8bf03$var$messages;

});



parcelRegister("bunMY", function(module, exports) {

$parcel$export(module.exports, "DateTimeCustomFieldTypeConfig", () => $f1af920deed83f57$export$f2143df7edd6483d);

var $5uXOq = parcelRequire("5uXOq");

var $hyKRO = parcelRequire("hyKRO");

var $fpis9 = parcelRequire("fpis9");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $f1af920deed83f57$var$DateTimeCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpis9.default), props);
const $f1af920deed83f57$export$f2143df7edd6483d = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))),
    type: (0, $5fc53.DATETIME_CF_TYPE),
    Component: $f1af920deed83f57$var$DateTimeCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DateTimeFieldPlaceholder), null),
    writer: (0, $kShoa.dateTimeFieldWriter)
};

});
parcelRegister("fpis9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d01bc814484554$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cHu6v = parcelRequire("cHu6v");

var $lfTZh = parcelRequire("lfTZh");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $9FL4D = parcelRequire("9FL4D");

var $jGVMX = parcelRequire("jGVMX");

var $lkRXf = parcelRequire("lkRXf");

const $a9d01bc814484554$export$ae1ced156568f0b0 = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled, ...fieldProps }, error: error, isReadOnly: isReadOnly = false, fieldName: fieldName } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleChange = (dateTimeValue)=>{
        onChange(dateTimeValue || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "date-time-field-edit-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHu6v.AsyncDateTimeFieldEditView), {
        label: fieldName,
        ...fieldProps,
        isDisabled: isDisabled || isReadOnly,
        autoFocus: autoFocus,
        value: value,
        onChange: handleChange,
        isInvalid: Boolean(error),
        datePickerProps: {
            selectProps: {
                onKeyDown: (0, $9FL4D.preventFormSubmitOnEnterKeyPress)
            },
            placeholder: formatMessage((0, $lkRXf.default).datePickerPlaceholder)
        },
        timePickerProps: {
            placeholder: formatMessage((0, $lkRXf.default).timePickerPlaceholder)
        }
    })));
};
var $a9d01bc814484554$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateTimeFieldConfig, FieldValue>, any>'.
$a9d01bc814484554$export$ae1ced156568f0b0);

});
parcelRegister("cHu6v", function(module, exports) {

$parcel$export(module.exports, "AsyncDateTimeFieldEditView", () => $f165d6e156b4ac02$export$657a1b8545a979b8);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $fwbTL = parcelRequire("fwbTL");
const $f165d6e156b4ac02$var$EMPTY_OBJECT = {};
const $f165d6e156b4ac02$export$657a1b8545a979b8 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $fwbTL.asyncDateTimeFieldEditViewEntrypoint), // use stable reference to avoid re-renders
    $f165d6e156b4ac02$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "async-jira-issue-field-date-time-edit-view",
        packageName: "jira-issue-field-date-time",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("fwbTL", function(module, exports) {

$parcel$export(module.exports, "asyncDateTimeFieldEditViewEntrypoint", () => $d8c60609c3da1617$export$971e82244ad6d423);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $d8c60609c3da1617$export$971e82244ad6d423 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aVfp9")).then((module)=>module.DateTimeFieldEditViewEntryPointContent), {
        moduleId: "267b9282"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aVfp9", function(module, exports) {

let $7f3b2d517bbc585a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f3b2d517bbc585a$var$load("hoRHv").then(()=>parcelRequire('7p4p7'));

});



parcelRegister("bGEod", function(module, exports) {

$parcel$export(module.exports, "FieldLoader", () => $6a1003bb52c05df4$export$dbd27b551621740c);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");
const $6a1003bb52c05df4$export$dbd27b551621740c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
        width: "350px",
        height: "40px"
    });

});

parcelRegister("lkRXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb6bff0fa93541ec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $bb6bff0fa93541ec$var$messages = (0, $7VHMR.defineMessages)({
    datePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.date-picker-placeholder",
        "defaultMessage": "Select date"
    },
    timePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.time-picker-placeholder",
        "defaultMessage": "Select time"
    }
});
var $bb6bff0fa93541ec$export$2e2bcd8739ae039 = $bb6bff0fa93541ec$var$messages;

});



parcelRegister("bxMnv", function(module, exports) {

$parcel$export(module.exports, "DescriptionFieldTypeConfig", () => $72a9f72b3b249b64$export$efd98ef2e1e5f7e9);

var $5uXOq = parcelRequire("5uXOq");

var $5Hpaz = parcelRequire("5Hpaz");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $hDpqy = parcelRequire("hDpqy");

var $kShoa = parcelRequire("kShoa");
const $72a9f72b3b249b64$var$DescriptionFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDpqy.default), {
        ...props,
        defaultValue: undefined,
        fieldWrapperElement: null,
        mediaUploadContext: props.mediaUploadContexts.uploadContext
    });
const $72a9f72b3b249b64$export$efd98ef2e1e5f7e9 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))),
    type: (0, $5fc53.DESCRIPTION_TYPE),
    Component: $72a9f72b3b249b64$var$DescriptionFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DescriptionFieldPlaceholder), null),
    writer: (0, $kShoa.descriptionFieldWriter)
};

});
parcelRegister("5Hpaz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b015b78d8f1d45000c2b6c1df1f2dde>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42647e07473269d7$var$_react = $42647e07473269d7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42647e07473269d7$var$_baseNew = $42647e07473269d7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $42647e07473269d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42647e07473269d7$var$TextIcon = (props)=>/*#__PURE__*/ $42647e07473269d7$var$_react.default.createElement($42647e07473269d7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.063 1.75H2.75V5m5.313-3.25h5.187V5M8.063 1.75v12.5m0 0H10.5m-2.437 0H5.5"/>`
    }, props));
$42647e07473269d7$var$TextIcon.displayName = 'TextIcon';
var $42647e07473269d7$var$_default = module.exports.default = $42647e07473269d7$var$TextIcon;

});

parcelRegister("hDpqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef1b91f5985cb5ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $h0fZ7 = parcelRequire("h0fZ7");

var $9GobK = parcelRequire("9GobK");
const $ef1b91f5985cb5ff$export$336230c809f2ec53 = (props)=>{
    const editorKey = (0, $5uXOq.useRef)(Date.now());
    const { fieldProps: { value: value, onChange: onChange }, mediaUploadContext: mediaUploadContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9GobK.DescriptionEdit), {
        key: editorKey.current,
        onChange: onChange,
        defaultValue: value,
        mediaContext: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - TS2740 - Type '{}' is missing the following properties from type 'ViewContext': clientId, serviceHost, token, tokenLifespanInMs, and 3 more
            viewContext: mediaUploadContext || {},
            uploadContext: mediaUploadContext,
            userAuth: null
        }
    }));
};
const $ef1b91f5985cb5ff$var$DescriptionFormField = (0, $hpV4g.withFormField)({
    validator: (0, $h0fZ7.validateDescriptionField)
})($ef1b91f5985cb5ff$export$336230c809f2ec53);
var $ef1b91f5985cb5ff$export$2e2bcd8739ae039 = $ef1b91f5985cb5ff$var$DescriptionFormField;

});
parcelRegister("h0fZ7", function(module, exports) {

$parcel$export(module.exports, "sanitizeADFField", () => $e0781922eb7ae616$export$28941b736a01da7b);
$parcel$export(module.exports, "mutateADFField", () => $e0781922eb7ae616$export$82a40b3982cf31c4);
$parcel$export(module.exports, "validateDescriptionField", () => $e0781922eb7ae616$export$78b1417f15a51a4f);

var $fr1K2 = parcelRequire("fr1K2");

var $kz2lw = parcelRequire("kz2lw");

var $jcw0u = parcelRequire("jcw0u");

var $bGrWH = parcelRequire("bGrWH");

const $e0781922eb7ae616$var$emptyADFString = JSON.stringify((0, $kz2lw.getEmptyADF)());
const $e0781922eb7ae616$export$28941b736a01da7b = (adfValue)=>{
    // @ts-expect-error extra properties are not a part of ADF
    if (adfValue?.overrideRequired || adfValue?.resetRequired) (0, $jcw0u.default)({
        meta: {
            id: 'adfObjectTypeErrorIssueCreate',
            packageName: 'jiraIssueCreateModal',
            teamName: 'gryffindor'
        },
        sendToPrivacyUnsafeSplunk: true
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const sanitizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(adfValue, [
        'overrideRequired',
        'resetRequired'
    ]);
    return sanitizedValue;
};
const $e0781922eb7ae616$export$82a40b3982cf31c4 = (adfValue, fieldId)=>{
    // stringify to compare with emptyADF
    const adfValueString = JSON.stringify(adfValue);
    // emptyADF is special case where input retention should not happen
    return $e0781922eb7ae616$var$emptyADFString === adfValueString ? null : {
        fieldId: fieldId,
        mutationGroup: (0, $6aa4505c49fca768$export$31fd86f8f183952c),
        richText: {
            adfValue: adfValue
        }
    };
};
const $e0781922eb7ae616$export$78b1417f15a51a4f = (adfValue, isRequired)=>{
    if (!isRequired) return undefined;
    const isAdfEmptyOrUndefined = !adfValue || JSON.stringify(adfValue) === JSON.stringify((0, $kz2lw.getEmptyADF)());
    if (isAdfEmptyOrUndefined) return 0, $bGrWH.REQUIRED;
    const hardBreakNodeType = 'hardBreak';
    // Users can bypass the required field validation for the description field by pressing shift + enter. shift + enter creates a 'hardBreak' block inside the value. If only hardBreaks exist then treat the description field as empty
    let isAnythingThereApartFromHardBreaks = false;
    if (adfValue?.content?.length > 0) for(let i = 0; i < adfValue.content.length; i += 1){
        const block = adfValue.content[i];
        // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'BlockContent | LayoutSectionDefinition | CodeBlockWithMarksDefinition | ExpandWithBreakoutDefinition | ParagraphWithIndentationDefinition'.
        const blockContent = block.content;
        isAnythingThereApartFromHardBreaks = blockContent?.some(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (blockItem)=>blockItem.type !== hardBreakNodeType);
        if (isAnythingThereApartFromHardBreaks) break;
    }
    if (isAnythingThereApartFromHardBreaks) return undefined;
    return 0, $bGrWH.REQUIRED;
};

});
const $6aa4505c49fca768$export$31fd86f8f183952c = 'richTextFields';


parcelRegister("9GobK", function(module, exports) {

$parcel$export(module.exports, "DescriptionEdit", () => $91ea1cf50c5539fa$export$cd5df8eea6a360e2);

var $5uXOq = parcelRequire("5uXOq");

var $8dO33 = parcelRequire("8dO33");

var $1wbtX = parcelRequire("1wbtX");

var $9ah8z = parcelRequire("9ah8z");

var $lfTZh = parcelRequire("lfTZh");
const $91ea1cf50c5539fa$export$cd5df8eea6a360e2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "smart-card-provider",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
            height: "150px",
            width: "auto"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ah8z.AsyncRichTextEditView), props)));

});
parcelRegister("9ah8z", function(module, exports) {

$parcel$export(module.exports, "AsyncRichTextEditView", () => $5d9d583311ca074a$export$ba962c8a1ae57ac);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $30zeq = parcelRequire("30zeq");
const $5d9d583311ca074a$var$EMPTY_OBJECT = {};
const $5d9d583311ca074a$export$ba962c8a1ae57ac = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $30zeq.asyncRichTextEditEntryPoint), // use stable object reference to avoid re-renders
    $5d9d583311ca074a$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira-issue-field-rich-text-edit-async",
        packageName: "jira-issue-field-rich-text",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            height: "150px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("30zeq", function(module, exports) {

$parcel$export(module.exports, "asyncRichTextEditEntryPoint", () => $33d1c4c4e757e553$export$153c0381975152a7);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $33d1c4c4e757e553$export$153c0381975152a7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("sjam9")).then((module)=>module.EntryPointContent), {
        moduleId: "7ade4e9b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("sjam9", function(module, exports) {

let $05517b9d6c9b7f79$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $05517b9d6c9b7f79$var$load("hPzOn"),
    $05517b9d6c9b7f79$var$load("dsiAd"),
    $05517b9d6c9b7f79$var$load("h2MrD"),
    $05517b9d6c9b7f79$var$load("bYT2S"),
    $05517b9d6c9b7f79$var$load("cM9em"),
    $05517b9d6c9b7f79$var$load("fr9NE"),
    $05517b9d6c9b7f79$var$load("gNIa8")
]).then(()=>parcelRequire('dhLv0'));

});






parcelRegister("iNY3w", function(module, exports) {

$parcel$export(module.exports, "DueDateFieldTypeConfig", () => $c9f18c52a31bf116$export$1f36cc37f9d9ead0);

var $5uXOq = parcelRequire("5uXOq");

var $hyKRO = parcelRequire("hyKRO");

var $iY8FG = parcelRequire("iY8FG");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $c9f18c52a31bf116$var$DueDateFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iY8FG.default), props);
const $c9f18c52a31bf116$export$1f36cc37f9d9ead0 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))),
    type: (0, $5fc53.DUE_DATE_TYPE),
    Component: $c9f18c52a31bf116$var$DueDateFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DateFieldPlaceholder), null),
    writer: (0, $kShoa.dateFieldWriter)
};

});

parcelRegister("jbGY4", function(module, exports) {

$parcel$export(module.exports, "GroupCustomFieldTypeConfig", () => $6b8eaafecaddddf0$export$fcafcf9905a0ab43);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $3Z98Z = parcelRequire("3Z98Z");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $6b8eaafecaddddf0$var$GroupCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z98Z.default), props);
const $6b8eaafecaddddf0$export$fcafcf9905a0ab43 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
    type: (0, $5fc53.GROUP_CF_TYPE),
    Component: $6b8eaafecaddddf0$var$GroupCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.singleGroupPickerFieldWriter)
};

});
parcelRegister("3Z98Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ebb6e060acd861c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9EuZf = parcelRequire("9EuZf");

var $5fnvk = parcelRequire("5fnvk");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $d8h6M = parcelRequire("d8h6M");

const $4ebb6e060acd861c$var$SingleGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getExtraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $9EuZf.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
        return {
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fnvk.default), {
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        autoFocus: autoFocus,
        isMulti: false,
        "aria-labelledby": ariaLabelledBy,
        width: width,
        isInvalid: Boolean(error),
        placeholder: " ",
        ...getExtraProps()
    });
};
var $4ebb6e060acd861c$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateGroupPickerField),
    transformDefaultValue: (0, $d8h6M.transformGroupDefaultValueToUserOption)
})($4ebb6e060acd861c$var$SingleGroupPickerField);

});
parcelRegister("9EuZf", function(module, exports) {

$parcel$export(module.exports, "defaultUserPickerStyles", () => $378ea0219a6c1ff7$export$ddd4b90ea2d7a329);

var $gwIPs = parcelRequire("gwIPs");
const $378ea0219a6c1ff7$export$ddd4b90ea2d7a329 = {
    menuPortal: (base)=>({
            ...base,
            zIndex: String((0, $gwIPs.layers).modal)
        })
};

});

parcelRegister("5fnvk", function(module, exports) {

$parcel$export(module.exports, "default", () => $81263082e0845513$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $cr0SA = parcelRequire("cr0SA");

var $koVbs = parcelRequire("koVbs");

var $arYvt = parcelRequire("arYvt");

var $hSBXu = parcelRequire("hSBXu");

var $lGKF5 = parcelRequire("lGKF5");

var $3PgDR = parcelRequire("3PgDR");
const $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $81263082e0845513$var$GroupPicker = ({ autoCompleteUrl: autoCompleteUrl, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, isMulti: isMulti, isDisabled: isDisabled, fieldId: fieldId, width: width, searchDebounceTimeout: // @ts-expect-error - TS2339 - Property 'searchDebounceTimeout' does not exist on type 'Props'.
searchDebounceTimeout = $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, isInvalid: isInvalid, autoFocus: autoFocus = false, placeholder: placeholder, onCloseMenuOnScroll: onCloseMenuOnScroll, menuPosition: menuPosition, groupPickerStyles: groupPickerStyles = {}, isClearable: isClearable = true, ...fieldProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const previousQuery = (0, $5uXOq.useRef)('');
    const { groups: groups, loading: loading, fetchGroups: fetchGroups } = (0, $hSBXu.default)(autoCompleteUrl || '');
    const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(false);
    const getUserPickerControlStyle = (0, $5uXOq.useCallback)((styles)=>{
        if (isInvalid === true) return {
            ...styles,
            ...(0, $3PgDR.invalidStateStyle)
        };
        return styles;
    }, [
        isInvalid
    ]);
    const handleSearch = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            setIsDropdownVisible(!!query);
            // if query has changed, get groups
            if (query !== previousQuery.current && query !== undefined) fetchGroups(query);
            previousQuery.current = query || '';
        }, searchDebounceTimeout), [
        fetchGroups,
        previousQuery,
        searchDebounceTimeout
    ]);
    const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
        setIsDropdownVisible(true);
        onFocus?.(sessionId);
        if (!groups || !groups.length) fetchGroups();
    }, [
        fetchGroups,
        groups,
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
        setIsDropdownVisible(false);
        onBlur?.(sessionId);
        previousQuery.current = '';
    }, [
        onBlur,
        previousQuery
    ]);
    const handleOnChange = (updatedValue)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(updatedValue);
    };
    const getOptions = ()=>groups.filter((group)=>group.name.includes(previousQuery.current)).map((group)=>(0, $arYvt.transformGroupToUserOption)(group));
    const onClear = ()=>{
        onChange(null);
    };
    const closeMenuOnScroll = (e)=>{
        if (isDropdownVisible && onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const getIsClearable = ()=>isClearable ? Boolean(value) : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        ariaLabelledBy: fieldProps['aria-labelledby'],
        fieldId: fieldId,
        width: width,
        autoFocus: autoFocus,
        isLoading: loading,
        options: getOptions(),
        value: value,
        onFocus: handleOnFocus,
        onClear: onClear,
        isMulti: isMulti,
        isDisabled: isDisabled,
        isClearable: getIsClearable(),
        onBlur: handleOnBlur,
        onInputChange: handleSearch,
        onChange: handleOnChange,
        placeholder: placeholder,
        addMoreMessage: formatMessage((0, $lGKF5.default).addMoreGroupsPrompt),
        UNSAFE_hasDraggableParentComponent: true,
        closeMenuOnScroll: closeMenuOnScroll,
        open: isDropdownVisible,
        menuPosition: menuPosition,
        styles: {
            control: getUserPickerControlStyle,
            ...groupPickerStyles
        }
    });
};
var $81263082e0845513$export$2e2bcd8739ae039 = $81263082e0845513$var$GroupPicker;

});
parcelRegister("arYvt", function(module, exports) {

$parcel$export(module.exports, "transformGroupToUserOption", () => $70d728bf86d0ecee$export$f9f97cb0418e400f);
$parcel$export(module.exports, "transformUserPickerOptionToGroup", () => $70d728bf86d0ecee$export$7727449e04185a4c);
$parcel$export(module.exports, "transformGroupToName", () => $70d728bf86d0ecee$export$c76efe48b8ca8203);
$parcel$export(module.exports, "transformGroupsToNames", () => $70d728bf86d0ecee$export$285022bf9288513e);
$parcel$export(module.exports, "appendTypePropertyToGroupOptions", () => $70d728bf86d0ecee$export$705009f1a414da46);
const $70d728bf86d0ecee$export$f9f97cb0418e400f = (group)=>({
        id: group.name,
        name: group.name,
        type: 'group'
    });
const $70d728bf86d0ecee$export$7727449e04185a4c = (userOption)=>({
        groupId: userOption.id,
        name: userOption.name,
        type: 'group'
    });
const $70d728bf86d0ecee$export$c76efe48b8ca8203 = (group)=>({
        name: group.name
    });
const $70d728bf86d0ecee$export$285022bf9288513e = (groups)=>groups.map((group)=>$70d728bf86d0ecee$export$c76efe48b8ca8203(group));
const $70d728bf86d0ecee$export$705009f1a414da46 = (groups)=>groups.map((group)=>({
            ...group,
            type: 'group'
        }));

});

parcelRegister("hSBXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9613200b5cbe8cb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");

var $arYvt = parcelRequire("arYvt");
const $b9613200b5cbe8cb$var$useGroupsQuery = (autoCompleteUrl)=>{
    const [groups, setGroups] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const currentQuery = (0, $5uXOq.useRef)('');
    const fetchGroups = (0, $5uXOq.useCallback)(async (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        const groupsFetchUrl = `${autoCompleteUrl || ''}${query}`;
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        try {
            const response = await (0, $eusud.performGetRequest)(groupsFetchUrl);
            let groupsWithType = [];
            if (query === currentQuery.current) {
                if (response && response.groups) {
                    groupsWithType = (0, $arYvt.appendTypePropertyToGroupOptions)(response.groups);
                    setGroups(groupsWithType);
                } else setGroups([]);
            }
            return groupsWithType;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (query === currentQuery.current) setError(err);
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.fields.grouppicker', 'Failed to fetch groups', err);
            return err;
        } finally{
            setLoading(false);
        }
    }, [
        autoCompleteUrl,
        error
    ]);
    return {
        groups: groups,
        error: error,
        loading: loading,
        fetchGroups: fetchGroups
    };
};
var $b9613200b5cbe8cb$export$2e2bcd8739ae039 = $b9613200b5cbe8cb$var$useGroupsQuery;

});

parcelRegister("lGKF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d585cea41a3a80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82d585cea41a3a80$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addMoreGroupsPrompt: {
        "id": "issue-field-group-picker.edit.add-more-groups-prompt",
        "defaultMessage": "add more groups..."
    }
});

});

parcelRegister("3PgDR", function(module, exports) {

$parcel$export(module.exports, "invalidStateStyle", () => $2e61feb10eb63767$export$f204658c943efb85);

const $2e61feb10eb63767$export$f204658c943efb85 = {
    borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$exports).R400})`
};

});


parcelRegister("d8h6M", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $dab4f2debb035d9d$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateSingleGroupPickerField", () => $dab4f2debb035d9d$export$daeca2ffaa5d8b62);

var $arYvt = parcelRequire("arYvt");

const $dab4f2debb035d9d$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    return (0, $arYvt.transformGroupToUserOption)(group);
};
const $dab4f2debb035d9d$export$daeca2ffaa5d8b62 = (selectedGroup, fieldId)=>({
        fieldId: fieldId,
        group: {
            groupName: selectedGroup.name
        },
        mutationGroup: (0, $b977eeb5f24a5299$export$31fd86f8f183952c)
    });

});
const $b977eeb5f24a5299$export$31fd86f8f183952c = 'singleGroupPickerFields';




parcelRegister("awO6U", function(module, exports) {

$parcel$export(module.exports, "LabelsCustomFieldTypeConfig", () => $337cc26aaa6435a9$export$c08ea7a9c6fbd5e0);

var $5uXOq = parcelRequire("5uXOq");

var $eKl4L = parcelRequire("eKl4L");

var $8GQyc = parcelRequire("8GQyc");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $337cc26aaa6435a9$var$LabelsCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GQyc.default), props);
const $337cc26aaa6435a9$export$c08ea7a9c6fbd5e0 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eKl4L))),
    type: (0, $5fc53.LABELS_CF_TYPE),
    Component: $337cc26aaa6435a9$var$LabelsCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.labelsFieldWriter)
};

});
parcelRegister("8GQyc", function(module, exports) {

$parcel$export(module.exports, "ForgeLabelsField", () => $34600c8cb7aa4373$export$f77bab10d748bb71);
$parcel$export(module.exports, "default", () => $34600c8cb7aa4373$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $800rQ = parcelRequire("800rQ");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $evGBv = parcelRequire("evGBv");

const $34600c8cb7aa4373$var$LabelsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, error: error, width: width, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $800rQ.LabelsEdit), {
        isInvalid: Boolean(error),
        fetchSuggestionsOnMount: false,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired
    }));
};
const $34600c8cb7aa4373$export$f77bab10d748bb71 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateForgeLabelField),
    transformDefaultValue: (0, $evGBv.mapDataToLabelOptions)
})($34600c8cb7aa4373$var$LabelsField);
var $34600c8cb7aa4373$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateLabelField),
    transformDefaultValue: (0, $evGBv.mapDataToLabelOptions)
})($34600c8cb7aa4373$var$LabelsField);

});
parcelRegister("800rQ", function(module, exports) {

$parcel$export(module.exports, "LabelsEdit", () => $392f4ecadcf70f0f$export$23584166c0ffb901);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $7Jxgt = parcelRequire("7Jxgt");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6Vzc4 = parcelRequire("6Vzc4");

var $3BhEA = parcelRequire("3BhEA");

var $lElIo = parcelRequire("lElIo");

var $5fc53 = parcelRequire("5fc53");

var $7ldcY = parcelRequire("7ldcY");

var $lpRLe = parcelRequire("lpRLe");

var $ek97b = parcelRequire("ek97b");

var $6s1PB = parcelRequire("6s1PB");

var $2QTbq = parcelRequire("2QTbq");

var $l2SvC = parcelRequire("l2SvC");

var $e3wnO = parcelRequire("e3wnO");

var $l5gEe = parcelRequire("l5gEe");
const $392f4ecadcf70f0f$export$251bdbdbce9550ea = 300;
const $392f4ecadcf70f0f$var$labelsValueStyles = {
    multiValue: (base, { data: data })=>{
        // @ts-expect-error - ts2345 - Argument of type 'ReactNode' is not assignable to parameter of type 'string | null | undefined'.
        const { backgroundColor: backgroundColor } = (0, $ek97b.getColorMetadata)((0, $7ldcY.getAutoGeneratedColorForLabels)(data.label));
        return {
            ...base,
            border: `1px solid ${backgroundColor}`,
            '& > div > div > div': {
                paddingLeft: 0,
                paddingRight: 0
            }
        };
    },
    multiValueLabel: (base)=>({
            ...base,
            '& > div > div': {
                borderColor: 'transparent'
            }
        })
};
const $392f4ecadcf70f0f$var$selectStyle = {
    ...(0, $lElIo.defaultSelectStyles),
    ...$392f4ecadcf70f0f$var$labelsValueStyles
};
const $392f4ecadcf70f0f$export$23584166c0ffb901 = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, cachedOptions: cachedOptions = [], formatCreateLabel: formatCreateLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $5fc53.LABELS_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, ariaLabel: ariaLabel = '', inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus } = props;
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
    const lastQuery = (0, $5uXOq.useRef)('');
    const sessionId = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getLabelsSuggestions: getLabelsSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $l2SvC.useLabelsSuggestions)({
        fieldId: fieldId,
        getSuggestions: getSuggestions
    });
    const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.FailedFetchOptionWrapper), null, formatMessage((0, $l5gEe.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
        try {
            const response = await getLabelsSuggestions(autoCompleteUrl, query, sessionId.current);
            setIsLoadingSuggestions(false);
            if (lastQuery.current === query) {
                const results = (0, $2QTbq.mapLabelsResponseToLabelOptions)(response);
                setSuggestions(results);
                if (query === '') setDefaultSuggestions(results);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsLoadingSuggestions(false);
            setHasLastFetchFailed(true);
            setSuggestions([
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ]);
        }
    }, [
        autoCompleteUrl,
        getFailedFetchMessage,
        getLabelsSuggestions,
        lastQuery,
        sessionId,
        setHasLastFetchFailed,
        setIsLoadingSuggestions
    ]);
    if ((0, $4R6GH.fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const groupedSuggestions = (0, $5uXOq.useMemo)(()=>[
            {
                label: formatMessage((0, $l5gEe.default).recent),
                options: cachedOptions
            },
            {
                label: formatMessage((0, $l5gEe.default).all),
                options: suggestions || []
            }
        ], [
        cachedOptions,
        formatMessage,
        suggestions
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(fetchSuggestions, $392f4ecadcf70f0f$export$251bdbdbce9550ea), []);
    const getCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, $l5gEe.default).createNewItem)})`, [
        formatCreateLabel,
        formatMessage
    ]);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $l5gEe.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $l5gEe.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $5uXOq.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $3BhEA.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
        if (!suggestions) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        onFocus && onFocus(e);
    }, [
        suggestions,
        onFocus,
        setIsLoadingSuggestions,
        fetchSuggestions
    ]);
    const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    const isLoading = isLoadingSuggestions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e3wnO.default), {
        isMulti: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: groupedSuggestions,
        value: value,
        isDisabled: isDisabled,
        onBlur: onSelectBlur,
        menuPosition: menuPosition,
        styles: (0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? $392f4ecadcf70f0f$var$selectStyle : (0, $lElIo.defaultSelectStyles),
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $l5gEe.default).placeholder),
        onInputChange: onQueryChange,
        onChange: onChange,
        spacing: spacing,
        isLoading: isLoading,
        filterOption: filterOption,
        formatCreateLabel: getCreateLabel,
        ...(0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
            formatOptionLabel: (option)=>$392f4ecadcf70f0f$export$f64ca8d680ed0ac0(option)
        } : {},
        validationState: isInvalid === true ? 'error' : null,
        sessionId: sessionId.current,
        "aria-label": ariaLabel,
        inputId: inputId,
        isRequired: isRequired,
        openMenuOnFocus: openMenuOnFocus
    });
};
const $392f4ecadcf70f0f$export$f64ca8d680ed0ac0 = (option)=>{
    // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
        name: option.label,
        color: (0, $7ldcY.getAutoGeneratedColorForLabels)(option.label)
    });
};
var $392f4ecadcf70f0f$export$2e2bcd8739ae039 = $392f4ecadcf70f0f$export$23584166c0ffb901;

});
parcelRegister("6Vzc4", function(module, exports) {

$parcel$export(module.exports, "FailedFetchOptionWrapper", () => $9302f6c83ce60c04$export$38a1a0a811e06255);
$parcel$export(module.exports, "getFailedFetchSelectOptionsWithDefaultLabel", () => $9302f6c83ce60c04$export$aa3357fb0ebcdb2b);
$parcel$export(module.exports, "OptionWrapper", () => $9302f6c83ce60c04$export$d6f6a072cce04542);
$parcel$export(module.exports, "ImgSpan", () => $9302f6c83ce60c04$export$df67068a00dece12);
$parcel$export(module.exports, "FlexSpan", () => $9302f6c83ce60c04$export$d90eccb59fb62cab);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $9302f6c83ce60c04$export$9e874bb1adc98a55);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $goAgE = parcelRequire("goAgE");
const $9302f6c83ce60c04$export$6ed0d629c0656ce1 = (query, label)=>[
        {
            options: [
                {
                    label: label,
                    value: '',
                    isDisabled: true,
                    filterValues: [
                        query
                    ] // filterOptionByLabelAndFilterValues will check `filterValues` and since it contains the user's query, this option will always show
                }
            ]
        }
    ];
const $9302f6c83ce60c04$var$DefaultFailedFetchMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const failedFetchMessage = (0, $goAgE.default).failedFetch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9302f6c83ce60c04$export$38a1a0a811e06255, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, formatMessage(failedFetchMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        role: "button",
        href: window.location.href,
        onClick: ()=>window.location.reload()
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $goAgE.default).reloadIssueIssueTermRefresh : (0, $goAgE.default).reloadIssue))));
};
const $9302f6c83ce60c04$export$aa3357fb0ebcdb2b = (query)=>$9302f6c83ce60c04$export$6ed0d629c0656ce1(query, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9302f6c83ce60c04$var$DefaultFailedFetchMessage, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9302f6c83ce60c04$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9302f6c83ce60c04$export$38a1a0a811e06255 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $9302f6c83ce60c04$export$d6f6a072cce04542, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9302f6c83ce60c04$export$df67068a00dece12 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $9302f6c83ce60c04$export$d90eccb59fb62cab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $9302f6c83ce60c04$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { errorMessagePopsition: errorMessagePopsition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.errorMessagePopsition === 'top' && "_otyri2wt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("goAgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7a2287a5c23e167$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b7a2287a5c23e167$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    failedFetch: {
        "id": "issue-field-select-base.failed-fetch-options.failed-fetch",
        "defaultMessage": "Search failed."
    },
    reloadIssue: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue",
        "defaultMessage": "Try reloading the issue."
    },
    reloadIssueIssueTermRefresh: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue-issue-term-refresh",
        "defaultMessage": "Try reloading"
    }
});

});


parcelRegister("3BhEA", function(module, exports) {

$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $0eb6c4d40c779509$export$58bb91b619b113f6);

var $8QpSo = parcelRequire("8QpSo");

var $5JAlL = parcelRequire("5JAlL");
const $0eb6c4d40c779509$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text including the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal = (0, $8QpSo.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $5JAlL.createFilter)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues
    }));
const $0eb6c4d40c779509$export$58bb91b619b113f6 = (option, inputValue)=>$0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("7ldcY", function(module, exports) {

$parcel$export(module.exports, "getAutoGeneratedColorForLabels", () => $7fa3a87d53177c9e$export$97056d4b28203ee9);
$parcel$export(module.exports, "getAutoGeneratedColorForLabelsTag", () => $7fa3a87d53177c9e$export$a3f5334e7a13e57a);

var $1L3S5 = parcelRequire("1L3S5");

var $fzY6y = parcelRequire("fzY6y");

var $96pcJ = parcelRequire("96pcJ");
const $7fa3a87d53177c9e$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $1L3S5.GREY_META).name;
};
const $7fa3a87d53177c9e$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $1L3S5.GREY_META).tagColor;
};

});
parcelRegister("1L3S5", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $0d4a83e59182b411$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $0d4a83e59182b411$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $0d4a83e59182b411$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $0d4a83e59182b411$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $0d4a83e59182b411$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $0d4a83e59182b411$export$7c14120abebd4749);


var $9GtPC = parcelRequire("9GtPC");
// Grey
const $0d4a83e59182b411$var$N100 = '#F0F1F4';
const $0d4a83e59182b411$var$N300 = (0, $829f609a65d26a98$exports).N60A;
const $0d4a83e59182b411$var$N500 = (0, $829f609a65d26a98$exports).N800;
// Teal
const $0d4a83e59182b411$var$T100 = '#E3FAFC';
const $0d4a83e59182b411$var$T200 = '#C1F0F5';
const $0d4a83e59182b411$var$T300 = '#60C6D2';
const $0d4a83e59182b411$var$T400 = '#206B74';
const $0d4a83e59182b411$var$T500 = '#1D474C';
// Green
const $0d4a83e59182b411$var$G100 = '#DFFCF0';
const $0d4a83e59182b411$var$G400 = '#216E4E';
// Lime
const $0d4a83e59182b411$var$L100 = '#EEFBDA';
const $0d4a83e59182b411$var$Y200 = (0, $829f609a65d26a98$exports).Y75;
const $0d4a83e59182b411$var$Y300 = '#E2B203';
// Orange
const $0d4a83e59182b411$var$O100 = '#FFF4E5';
const $0d4a83e59182b411$var$O200 = '#FFE2BD';
const $0d4a83e59182b411$var$O300 = '#FAA53D';
const $0d4a83e59182b411$var$O400 = '#974F0C';
const $0d4a83e59182b411$var$O500 = '#5F3811';
// Red
const $0d4a83e59182b411$var$R100 = '#FFEDEB';
const $0d4a83e59182b411$var$R200 = '#FFD2CC';
const $0d4a83e59182b411$var$R300 = '#F87462';
const $0d4a83e59182b411$var$R400 = '#AE2A19';
const $0d4a83e59182b411$var$R500 = '#601E16';
const $0d4a83e59182b411$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: `var(--ds-background-neutral, ${$0d4a83e59182b411$var$N100})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N900})`,
    messageLabel: (0, $9GtPC.default).greyLightest
};
const $0d4a83e59182b411$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N900})`,
    messageLabel: (0, $9GtPC.default).greyLighter
};
const $0d4a83e59182b411$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: `var(--ds-background-neutral-pressed, ${$0d4a83e59182b411$var$N300})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N900})`,
    messageLabel: (0, $9GtPC.default).grey
};
const $0d4a83e59182b411$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).greyDarker
};
const $0d4a83e59182b411$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: `var(--ds-background-neutral-bold-pressed, ${$0d4a83e59182b411$var$N500})`,
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).greyDarkest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLightest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLighter
};
const $0d4a83e59182b411$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purple
};
const $0d4a83e59182b411$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).purpleDarker
};
const $0d4a83e59182b411$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).purpleDarkest
};
const $0d4a83e59182b411$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLightest
};
const $0d4a83e59182b411$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLighter
};
const $0d4a83e59182b411$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blue
};
const $0d4a83e59182b411$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).blueDarker
};
const $0d4a83e59182b411$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).blueDarkest
};
const $0d4a83e59182b411$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-teal-subtlest, ${$0d4a83e59182b411$var$T100})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$0d4a83e59182b411$var$T500})`,
    messageLabel: (0, $9GtPC.default).tealLightest
};
const $0d4a83e59182b411$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: `var(--ds-background-accent-teal-subtler, ${$0d4a83e59182b411$var$T200})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$0d4a83e59182b411$var$T500})`,
    messageLabel: (0, $9GtPC.default).tealLighter
};
const $0d4a83e59182b411$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: `var(--ds-background-accent-teal-subtle, ${$0d4a83e59182b411$var$T300})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$0d4a83e59182b411$var$T500})`,
    messageLabel: (0, $9GtPC.default).teal
};
const $0d4a83e59182b411$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: `var(--ds-text-accent-teal, ${$0d4a83e59182b411$var$T400})`,
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).tealDarker
};
const $0d4a83e59182b411$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: `var(--ds-text-accent-teal-bolder, ${$0d4a83e59182b411$var$T500})`,
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).tealDarkest
};
const $0d4a83e59182b411$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-green-subtlest, ${$0d4a83e59182b411$var$G100})`,
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLightest
};
const $0d4a83e59182b411$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLighter
};
const $0d4a83e59182b411$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).green
};
const $0d4a83e59182b411$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: `var(--ds-background-accent-green-bolder, ${$0d4a83e59182b411$var$G400})`,
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).greenDarker
};
const $0d4a83e59182b411$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).greenDarkest
};
const $0d4a83e59182b411$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-lime-subtlest, ${$0d4a83e59182b411$var$L100})`,
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLightest
};
const $0d4a83e59182b411$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLighter
};
const $0d4a83e59182b411$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).lime
};
const $0d4a83e59182b411$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).limeDarker
};
const $0d4a83e59182b411$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).limeDarkest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLightest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: `var(--ds-background-accent-yellow-subtler, ${$0d4a83e59182b411$var$Y200})`,
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLighter
};
const $0d4a83e59182b411$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: `var(--ds-background-accent-yellow-subtle, ${$0d4a83e59182b411$var$Y300})`,
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellow
};
const $0d4a83e59182b411$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).yellowDarker
};
const $0d4a83e59182b411$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).yellowDarkest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-orange-subtlest, ${$0d4a83e59182b411$var$O100})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$0d4a83e59182b411$var$O500})`,
    messageLabel: (0, $9GtPC.default).orangeLightest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-orange-subtler, ${$0d4a83e59182b411$var$O200})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$0d4a83e59182b411$var$O500})`,
    messageLabel: (0, $9GtPC.default).orangeLighter
};
const $0d4a83e59182b411$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: `var(--ds-background-accent-orange-subtle, ${$0d4a83e59182b411$var$O300})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$0d4a83e59182b411$var$O500})`,
    messageLabel: (0, $9GtPC.default).orange
};
const $0d4a83e59182b411$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: `var(--ds-background-accent-orange-bolder, ${$0d4a83e59182b411$var$O400})`,
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).orangeDarker
};
const $0d4a83e59182b411$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: `var(--ds-text-accent-orange-bolder, ${$0d4a83e59182b411$var$O500})`,
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).orangeDarkest
};
const $0d4a83e59182b411$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-red-subtlest, ${$0d4a83e59182b411$var$R100})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$0d4a83e59182b411$var$R500})`,
    messageLabel: (0, $9GtPC.default).redLightest
};
const $0d4a83e59182b411$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: `var(--ds-background-accent-red-subtler, ${$0d4a83e59182b411$var$R200})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$0d4a83e59182b411$var$R500})`,
    messageLabel: (0, $9GtPC.default).redLighter
};
const $0d4a83e59182b411$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: `var(--ds-background-accent-red-subtle, ${$0d4a83e59182b411$var$R300})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$0d4a83e59182b411$var$R500})`,
    messageLabel: (0, $9GtPC.default).red
};
const $0d4a83e59182b411$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: `var(--ds-background-accent-red-bolder, ${$0d4a83e59182b411$var$R400})`,
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).redDarker
};
const $0d4a83e59182b411$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: `var(--ds-text-accent-red-bolder, ${$0d4a83e59182b411$var$R500})`,
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).redDarkest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: `var(--ds-text-accent-magenta-bolder, ${$0d4a83e59182b411$var$R500})`,
    messageLabel: (0, $9GtPC.default).magentaLightest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: `var(--ds-text-accent-magenta-bolder, ${$0d4a83e59182b411$var$R500})`,
    messageLabel: (0, $9GtPC.default).magentaLighter
};
const $0d4a83e59182b411$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: `var(--ds-text-accent-magenta-bolder, ${$0d4a83e59182b411$var$R500})`,
    messageLabel: (0, $9GtPC.default).magenta
};
const $0d4a83e59182b411$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).magentaDarker
};
const $0d4a83e59182b411$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).magentaDarkest
};
const $0d4a83e59182b411$export$270aee965367aeb3 = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
const $0d4a83e59182b411$export$941ef40ef5fdd2b1 = `var(--ds-text, ${(0, $829f609a65d26a98$exports).N500})`;
const $0d4a83e59182b411$export$7f42563469df7e01 = [
    $0d4a83e59182b411$var$GREY_LIGHTEST_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTEST_META,
    $0d4a83e59182b411$var$BLUE_LIGHTEST_META,
    $0d4a83e59182b411$var$TEAL_LIGHTEST_META,
    $0d4a83e59182b411$var$GREEN_LIGHTEST_META,
    $0d4a83e59182b411$var$LIME_LIGHTEST_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTEST_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTEST_META,
    $0d4a83e59182b411$var$RED_LIGHTEST_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META,
    $0d4a83e59182b411$var$GREY_LIGHTER_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTER_META,
    $0d4a83e59182b411$var$BLUE_LIGHTER_META,
    $0d4a83e59182b411$var$TEAL_LIGHTER_META,
    $0d4a83e59182b411$var$GREEN_LIGHTER_META,
    $0d4a83e59182b411$var$LIME_LIGHTER_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTER_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTER_META,
    $0d4a83e59182b411$var$RED_LIGHTER_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTER_META,
    $0d4a83e59182b411$export$11b75436f568ab00,
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$BLUE_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$LIME_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$7c314e2461a7241b,
    $0d4a83e59182b411$var$BLUE_DARKER_META,
    $0d4a83e59182b411$export$6daaa1cc3f46f41,
    $0d4a83e59182b411$var$GREEN_DARKER_META,
    $0d4a83e59182b411$var$LIME_DARKER_META,
    $0d4a83e59182b411$var$YELLOW_DARKER_META,
    $0d4a83e59182b411$var$ORANGE_DARKER_META,
    $0d4a83e59182b411$var$RED_DARKER_META,
    $0d4a83e59182b411$var$MAGENTA_DARKER_META,
    $0d4a83e59182b411$var$GREY_DARKEST_META,
    $0d4a83e59182b411$var$PURPLE_DARKEST_META,
    $0d4a83e59182b411$export$69c4eac71b813fba,
    $0d4a83e59182b411$var$TEAL_DARKEST_META,
    $0d4a83e59182b411$var$GREEN_DARKEST_META,
    $0d4a83e59182b411$var$LIME_DARKEST_META,
    $0d4a83e59182b411$var$YELLOW_DARKEST_META,
    $0d4a83e59182b411$var$ORANGE_DARKEST_META,
    $0d4a83e59182b411$var$RED_DARKEST_META,
    $0d4a83e59182b411$var$MAGENTA_DARKEST_META
];
const $0d4a83e59182b411$export$2c649adf8351b065 = [
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$11b75436f568ab00
];
const $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$0d4a83e59182b411$export$2c649adf8351b065.forEach((option)=>{
    $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $0d4a83e59182b411$export$7c14120abebd4749 = {};
$0d4a83e59182b411$export$7f42563469df7e01.forEach((option)=>{
    $0d4a83e59182b411$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("9GtPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8610941b4777e2f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8610941b4777e2f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});


parcelRegister("fzY6y", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $899e3507d4080274$export$e352defce701b36e);

const $899e3507d4080274$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $37d3405989cb4520$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $37d3405989cb4520$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $37d3405989cb4520$export$d15e38bcd75fda7c = 256;
const $37d3405989cb4520$export$e143f4b09221a374 = 1000000007;


parcelRegister("96pcJ", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $9ffc042ff38af51a$export$cb0dffe2d2ae675a);

var $1L3S5 = parcelRequire("1L3S5");
const $9ffc042ff38af51a$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("lpRLe", function(module, exports) {

$parcel$export(module.exports, "OptionTag", () => $7e21718d85b37a90$export$5991b62d89f5cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ek97b = parcelRequire("ek97b");
const $7e21718d85b37a90$export$5991b62d89f5cc = /*#__PURE__*/ (0, $5uXOq.memo)(({ name: name, color: color, isInteractive: isInteractive = true })=>{
    const { backgroundColor: tagColor } = (0, $ek97b.getColorMetadata)(color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $7e21718d85b37a90$var$tagWrapperStyles,
            isInteractive && $7e21718d85b37a90$var$interactiveStyles
        ],
        "aria-label": name,
        testId: "option-color-picker.option-tag.field-tag-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e21718d85b37a90$var$StyledTag, {
        "data-testid": `option-color-picker.option-tag.${color || 'default'}`,
        color: tagColor
    }, name));
});
const $7e21718d85b37a90$var$tagWrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    justifyContent: 'left',
    alignItems: 'center',
    transition: '0.3s',
    maxWidth: '100%',
    minWidth: '0',
    minHeight: '0',
    color: 'color.text'
});
const $7e21718d85b37a90$var$interactiveStyles = (0, $8CUq3.xcss)({
    ':hover': {
        cursor: 'pointer'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e21718d85b37a90$var$StyledTagBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81oud _1reo15vq _18m915vq _vwz4f6fq _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $7e21718d85b37a90$var$StyledTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $7e21718d85b37a90$var$StyledTagBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $lD23V.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko5n0m _19it11we _bfhk18uv _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ek97b", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $c5f14892c9125c93$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $c5f14892c9125c93$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $c5f14892c9125c93$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $c5f14892c9125c93$export$49fce7fdcf55f26d);

var $1L3S5 = parcelRequire("1L3S5");
const $c5f14892c9125c93$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length);
    return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
};
const $c5f14892c9125c93$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $1L3S5.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $c5f14892c9125c93$export$9eff62e8ee2aaa2c = (colorName)=>(0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
const $c5f14892c9125c93$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $1L3S5.GREY_META;
    return (0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $1L3S5.GREY_META);
};
const $c5f14892c9125c93$export$4ef6b7574883e63d = ()=>(0, $1L3S5.OPTION_COLOR_THEMES).map((item)=>item.name);

});


parcelRegister("l2SvC", function(module, exports) {

$parcel$export(module.exports, "useLabelsSuggestions", () => $aed9af8029ae7a32$export$c5b80cd78ff71c5f);

var $5uXOq = parcelRequire("5uXOq");

var $6RCeq = parcelRequire("6RCeq");

var $eusud = parcelRequire("eusud");

var $8SCDp = parcelRequire("8SCDp");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");
const $aed9af8029ae7a32$export$343652b9755c68e7 = async (autoCompleteUrl, query, sessionId)=>{
    let url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (sessionId !== undefined && sessionId !== null) url = `${url}&sessionId=${sessionId}`;
    return (0, $eusud.performGetRequest)(url);
};
const $aed9af8029ae7a32$export$c5b80cd78ff71c5f = (props)=>{
    const { fieldId: fieldId, getSuggestions: getSuggestions = $aed9af8029ae7a32$export$343652b9755c68e7 } = props;
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getLabelsSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, sessionId)=>{
        const startTime = (0, $6RCeq.default).now();
        const queryLength = query.length;
        try {
            const response = await getSuggestions(autoCompleteUrl, query, sessionId);
            if (fieldId === (0, $5fc53.LABELS_TYPE)) (0, $8SCDp.fireSuggestionsRequestSuccessEvent)((0, $5fc53.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId,
                queryLength: queryLength
            });
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (fieldId === (0, $5fc53.LABELS_TYPE)) (0, $8SCDp.fireSuggestionsRequestFailedEvent)((0, $5fc53.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId
            });
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        createAnalyticsEvent,
        fieldId,
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>({
            getLabelsSuggestions: getLabelsSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getLabelsSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
parcelRegister("8SCDp", function(module, exports) {

$parcel$export(module.exports, "fireSuggestionsRequestSuccessEvent", () => $305439819cb2bcec$export$7eeca21c46efa338);
$parcel$export(module.exports, "fireSuggestionsRequestFailedEvent", () => $305439819cb2bcec$export$a31ac580130dee62);

var $6RCeq = parcelRequire("6RCeq");

var $8zOmE = parcelRequire("8zOmE");
const $305439819cb2bcec$var$fireRequestEvent = (action, actionSubject, startTime, createAnalyticsEvent, additionalAttributes)=>{
    const attributes = {
        ...additionalAttributes,
        elapsedTimeMs: (0, $6RCeq.default).now() - startTime
    };
    createAnalyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    }), `${actionSubject} ${action}`, attributes);
};
const $305439819cb2bcec$export$7eeca21c46efa338 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $305439819cb2bcec$var$fireRequestEvent('succeeded', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};
const $305439819cb2bcec$export$a31ac580130dee62 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $305439819cb2bcec$var$fireRequestEvent('failed', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};

});


parcelRegister("e3wnO", function(module, exports) {

$parcel$export(module.exports, "default", () => $35584119a49c4bd8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $7Jxgt = parcelRequire("7Jxgt");

var $iOwNT = parcelRequire("iOwNT");

var $6RCeq = parcelRequire("6RCeq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $db8jg = parcelRequire("db8jg");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $biBfP = parcelRequire("biBfP");
const $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $35584119a49c4bd8$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $35584119a49c4bd8$export$29e0f2c0983c7379 = (0, $2OMDV.AnalyticsEventToProps)('select', $35584119a49c4bd8$var$analyticsProps)((0, $iOwNT.default));
const $35584119a49c4bd8$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options, value: value, isDisabled: isDisabled, sessionId: customSessionId, isMulti: isMulti, inputId: inputId, isRequired: isRequired } = props;
    const sessionId = (0, $5uXOq.useRef)(customSessionId);
    const editSessionId = (0, $5uXOq.useRef)();
    const sessionStartedAt = (0, $5uXOq.useRef)(0);
    const editSessionStartedAt = (0, $5uXOq.useRef)(0);
    const [flatOptions, setFlatOptions] = (0, $5uXOq.useState)((0, $biBfP.flattenOptions)(options));
    const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
    const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) ? value : [];
        let filteredOptions = (0, $biBfP.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $biBfP.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            isDisabled: isDisabled,
            optionsLength: optionsLength,
            componentName: 'select',
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $biBfP.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $db8jg.memoizedHashString)(query),
            selectedOptions: (0, $biBfP.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $biBfP.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading,
        isDisabled
    ]);
    const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startEditSession = (0, $5uXOq.useCallback)(()=>{
        if (editSessionId.current === undefined) editSessionId.current = (0, $7Jxgt.v4)();
        editSessionStartedAt.current = (0, $6RCeq.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'fieldEditSession', {
            editSessionId: editSessionId.current
        });
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent
    ]);
    const endEditSession = (0, $5uXOq.useCallback)(()=>{
        if (editSessionId.current !== undefined) {
            const config = (0, $4R6GH.fg)('labels_restricted_to_project_experiment') && (0, $6s1PB.UNSAFE_noExposureExp)('labels_restricted_to_project')[0];
            const elapsedTime = (0, $6RCeq.default).now() - editSessionStartedAt.current;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'fieldEditSession', {
                elapsedTime: elapsedTime,
                editSessionId: editSessionId.current,
                ...config ? {
                    hasProjectScopedLabels: config.get('showProjectFilter', false)
                } : {}
            });
        }
        editSessionId.current = undefined;
        editSessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent
    ]);
    const startSession = (0, $5uXOq.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, $7Jxgt.v4)();
        sessionStartedAt.current = (0, $6RCeq.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $5uXOq.useCallback)((interactionType)=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt !== 0 ? (0, $6RCeq.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime,
                interactionType: interactionType
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $5uXOq.useCallback)((interactionType)=>{
        endSession(interactionType);
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession('option created');
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $biBfP.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $biBfP.getSafeValue)(option.value) : undefined
        });
    }, [
        fireUIAnalyticsEvent,
        savedQuery
    ]);
    const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession('option selected');
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $biBfP.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        const selectedValue = isMulti ? selectedOptionOrOptions || [] : selectedOptionOrOptions;
        if (onChange) onChange(selectedValue, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange,
        isMulti
    ]);
    const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        startSession();
        startEditSession();
        fireInputChangedEvent('', {
            action: 'fake-action'
        }, createAnalyticsEvent({}));
        return ()=>{
            endSession();
            endEditSession();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // since due to multiple setState calls component is rerendered
        // added this change to reduce the number of setState call will be fixed,
        // wasn't able to replicate this issue in local so adding this change in feature flag.
        // sentry link: https://sentry.prod.atl-paas.net/atlassian/jira-frontend/issues/4943577/?query=is%3Aunresolved%20logger%3AjiraIssueCreateModal.withFormField
        const flattenedOption = (0, $biBfP.flattenOptions)(options);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(flatOptions, flattenedOption)) setFlatOptions(flattenedOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35584119a49c4bd8$export$29e0f2c0983c7379, {
        ...props,
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics
    });
};
var $35584119a49c4bd8$export$2e2bcd8739ae039 = $35584119a49c4bd8$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("db8jg", function(module, exports) {

$parcel$export(module.exports, "memoizedHashString", () => $6aa2f917648b2dec$export$c9e165da390f6283);

var $eb3tB = parcelRequire("eb3tB");

var $8QpSo = parcelRequire("8QpSo");

var $4Pf62 = parcelRequire("4Pf62");
const $6aa2f917648b2dec$export$fdd2c0ba94025c3c = (0, $8QpSo.default)(()=>{
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    return cloudId;
});
const $6aa2f917648b2dec$export$c9e165da390f6283 = (attribute)=>{
    const cloudId = $6aa2f917648b2dec$export$fdd2c0ba94025c3c();
    const hash = (0, $eb3tB.sha256)(`${cloudId}_${attribute.trim()}`);
    return hash;
};

});
parcelRegister("eb3tB", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");


/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.11.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2024
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $6cAn5 === 'object' && $6cAn5.versions && $6cAn5.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = (parcelRequire("3gWwf"));
        var Buffer = (parcelRequire("3gWwf")).Buffer;
        var algorithm = is224 ? 'sha224' : 'sha256';
        var bufferFrom;
        if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                this.block = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >>> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >>> 2] |= (0xc0 | code >>> 6) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >>> 2] |= (0xe0 | code >>> 12) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >>> 2] |= (0xf0 | code >>> 18) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >>> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
            this.chromeBugWorkAround = true;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >>> 28 & 0x0F] + HEX_CHARS[h0 >>> 24 & 0x0F] + HEX_CHARS[h0 >>> 20 & 0x0F] + HEX_CHARS[h0 >>> 16 & 0x0F] + HEX_CHARS[h0 >>> 12 & 0x0F] + HEX_CHARS[h0 >>> 8 & 0x0F] + HEX_CHARS[h0 >>> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >>> 28 & 0x0F] + HEX_CHARS[h1 >>> 24 & 0x0F] + HEX_CHARS[h1 >>> 20 & 0x0F] + HEX_CHARS[h1 >>> 16 & 0x0F] + HEX_CHARS[h1 >>> 12 & 0x0F] + HEX_CHARS[h1 >>> 8 & 0x0F] + HEX_CHARS[h1 >>> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >>> 28 & 0x0F] + HEX_CHARS[h2 >>> 24 & 0x0F] + HEX_CHARS[h2 >>> 20 & 0x0F] + HEX_CHARS[h2 >>> 16 & 0x0F] + HEX_CHARS[h2 >>> 12 & 0x0F] + HEX_CHARS[h2 >>> 8 & 0x0F] + HEX_CHARS[h2 >>> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >>> 28 & 0x0F] + HEX_CHARS[h3 >>> 24 & 0x0F] + HEX_CHARS[h3 >>> 20 & 0x0F] + HEX_CHARS[h3 >>> 16 & 0x0F] + HEX_CHARS[h3 >>> 12 & 0x0F] + HEX_CHARS[h3 >>> 8 & 0x0F] + HEX_CHARS[h3 >>> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >>> 28 & 0x0F] + HEX_CHARS[h4 >>> 24 & 0x0F] + HEX_CHARS[h4 >>> 20 & 0x0F] + HEX_CHARS[h4 >>> 16 & 0x0F] + HEX_CHARS[h4 >>> 12 & 0x0F] + HEX_CHARS[h4 >>> 8 & 0x0F] + HEX_CHARS[h4 >>> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >>> 28 & 0x0F] + HEX_CHARS[h5 >>> 24 & 0x0F] + HEX_CHARS[h5 >>> 20 & 0x0F] + HEX_CHARS[h5 >>> 16 & 0x0F] + HEX_CHARS[h5 >>> 12 & 0x0F] + HEX_CHARS[h5 >>> 8 & 0x0F] + HEX_CHARS[h5 >>> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >>> 28 & 0x0F] + HEX_CHARS[h6 >>> 24 & 0x0F] + HEX_CHARS[h6 >>> 20 & 0x0F] + HEX_CHARS[h6 >>> 16 & 0x0F] + HEX_CHARS[h6 >>> 12 & 0x0F] + HEX_CHARS[h6 >>> 8 & 0x0F] + HEX_CHARS[h6 >>> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >>> 28 & 0x0F] + HEX_CHARS[h7 >>> 24 & 0x0F] + HEX_CHARS[h7 >>> 20 & 0x0F] + HEX_CHARS[h7 >>> 16 & 0x0F] + HEX_CHARS[h7 >>> 12 & 0x0F] + HEX_CHARS[h7 >>> 8 & 0x0F] + HEX_CHARS[h7 >>> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >>> 24 & 0xFF,
            h0 >>> 16 & 0xFF,
            h0 >>> 8 & 0xFF,
            h0 & 0xFF,
            h1 >>> 24 & 0xFF,
            h1 >>> 16 & 0xFF,
            h1 >>> 8 & 0xFF,
            h1 & 0xFF,
            h2 >>> 24 & 0xFF,
            h2 >>> 16 & 0xFF,
            h2 >>> 8 & 0xFF,
            h2 & 0xFF,
            h3 >>> 24 & 0xFF,
            h3 >>> 16 & 0xFF,
            h3 >>> 8 & 0xFF,
            h3 & 0xFF,
            h4 >>> 24 & 0xFF,
            h4 >>> 16 & 0xFF,
            h4 >>> 8 & 0xFF,
            h4 & 0xFF,
            h5 >>> 24 & 0xFF,
            h5 >>> 16 & 0xFF,
            h5 >>> 8 & 0xFF,
            h5 & 0xFF,
            h6 >>> 24 & 0xFF,
            h6 >>> 16 & 0xFF,
            h6 >>> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >>> 24 & 0xFF, h7 >>> 16 & 0xFF, h7 >>> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >>> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >>> 12;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >>> 18;
                    bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});


parcelRegister("biBfP", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $e31cfbdea683954a$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $e31cfbdea683954a$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $e31cfbdea683954a$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $e31cfbdea683954a$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $e31cfbdea683954a$export$60d56ed3961c839c);

var $chc6P = parcelRequire("chc6P");

var $db8jg = parcelRequire("db8jg");
const $e31cfbdea683954a$export$d05672fd1312a6d = (val)=>(0, $db8jg.memoizedHashString)(val.toString()).toString();
const $e31cfbdea683954a$export$fde3d804891b8254 = (items)=>items.filter((item)=>item.value).map(({ value: value })=>$e31cfbdea683954a$export$d05672fd1312a6d(value));
const $e31cfbdea683954a$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(optionGroups.map((group)=>group.options));
const $e31cfbdea683954a$export$e2e167245697ed4e = (items)=>items.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
const $e31cfbdea683954a$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});


parcelRegister("l5gEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8773284d2f300e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ef8773284d2f300e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    empty: {
        "id": "issue-field-labels.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-labels.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-labels.edit.placeholder",
        "defaultMessage": "Select label"
    },
    createNewItem: {
        "id": "issue-field-labels.edit.create-new-item",
        "defaultMessage": "New label"
    },
    loading: {
        "id": "issue-field-labels.edit.loading",
        "defaultMessage": "Searching..."
    },
    recent: {
        "id": "issue-field-labels.edit.recent",
        "defaultMessage": "Recent labels"
    },
    all: {
        "id": "issue-field-labels.edit.all",
        "defaultMessage": "All labels"
    }
});

});


parcelRegister("evGBv", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $df66270ab3f9af77$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mutateLabelsFields", () => $df66270ab3f9af77$export$f691a7c5b86be653);

const $df66270ab3f9af77$export$cd8e373d5b1325b1 = (data)=>data.map(({ name: name })=>({
            value: name,
            label: name
        }));
const $df66270ab3f9af77$export$f691a7c5b86be653 = (selectedLabels, fieldId)=>({
        fieldId: fieldId,
        labels: selectedLabels.map(({ value: value })=>({
                name: value
            })),
        mutationGroup: (0, $fbaea1aecc52fe2c$export$31fd86f8f183952c)
    });

});
const $fbaea1aecc52fe2c$export$31fd86f8f183952c = 'labelsFields';




parcelRegister("3ZQGw", function(module, exports) {

$parcel$export(module.exports, "LabelsFieldTypeConfig", () => $0e9a07e22e44fb24$export$e4c3d82c6a697032);

var $5uXOq = parcelRequire("5uXOq");

var $eKl4L = parcelRequire("eKl4L");

var $8GQyc = parcelRequire("8GQyc");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $0e9a07e22e44fb24$var$LabelsFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GQyc.default), props);
const $0e9a07e22e44fb24$export$e4c3d82c6a697032 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eKl4L))),
    type: (0, $5fc53.LABELS_TYPE),
    Component: $0e9a07e22e44fb24$var$LabelsFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.labelsFieldWriter)
};

});

parcelRegister("kTnsH", function(module, exports) {

$parcel$export(module.exports, "MultiCheckboxesCustomFieldTypeConfig", () => $a666f3e6ce2ead81$export$29399cace92d6d05);

var $5uXOq = parcelRequire("5uXOq");

var $4xPlE = parcelRequire("4xPlE");

var $aqCUo = parcelRequire("aqCUo");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $a666f3e6ce2ead81$var$MultiCheckboxesCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aqCUo.default), props);
const $a666f3e6ce2ead81$export$29399cace92d6d05 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))),
    type: (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    Component: $a666f3e6ce2ead81$var$MultiCheckboxesCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.checkboxSelectFieldWriter)
};

});
parcelRegister("aqCUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e0b893bc2fc3f63$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $edQZ6 = parcelRequire("edQZ6");

var $hx8g7 = parcelRequire("hx8g7");

var $lfTZh = parcelRequire("lfTZh");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

const $0e0b893bc2fc3f63$var$CheckboxSelectField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false } = props;
    const options = (0, $hx8g7.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-checkbox-select-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $edQZ6.AsyncCheckboxSelectEdit), {
        ...fieldProps,
        options: options,
        value: value,
        onChange: onChange,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly
    })));
};
var $0e0b893bc2fc3f63$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateCheckboxField),
    transformDefaultValue: (0, $hx8g7.mapDataToOptions)
})($0e0b893bc2fc3f63$var$CheckboxSelectField);

});
parcelRegister("edQZ6", function(module, exports) {

$parcel$export(module.exports, "AsyncCheckboxSelectEdit", () => $53d0db7977df62c9$export$48ad7b39ee5392c2);

var $kxZPA = parcelRequire("kxZPA");

const $53d0db7977df62c9$export$48ad7b39ee5392c2 = (0, $kxZPA.lazy)(()=>(parcelRequire("kp0As")).then((module)=>module.CheckboxSelectEdit), {
    moduleId: "./src/packages/issue/fields/checkbox-select/src/index.tsx"
});

});
parcelRegister("kp0As", function(module, exports) {

let $eda699023d615286$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eda699023d615286$var$load("gTShp").then(()=>parcelRequire('7p86r'));

});




parcelRegister("g8kqC", function(module, exports) {

$parcel$export(module.exports, "MultiGroupCustomFieldTypeConfig", () => $f461df346d8eee00$export$62823f7adb904a12);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $5sz86 = parcelRequire("5sz86");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $f461df346d8eee00$var$MultiGroupCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sz86.default), props);
const $f461df346d8eee00$export$62823f7adb904a12 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
    type: (0, $5fc53.MULTI_GROUP_CF_TYPE),
    Component: $f461df346d8eee00$var$MultiGroupCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.multipleGroupPickerFieldWriter)
};

});
parcelRegister("5sz86", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0e92fcc13435d46$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9EuZf = parcelRequire("9EuZf");

var $5fnvk = parcelRequire("5fnvk");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $1IlAr = parcelRequire("1IlAr");

const $b0e92fcc13435d46$var$MultiGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
    const getExtraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $9EuZf.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
        return {
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fnvk.default), {
        ...fieldProps,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isMulti: true,
        placeholder: " ",
        ...getExtraProps()
    }));
};
var $b0e92fcc13435d46$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateGroupPickerField),
    transformDefaultValue: (0, $1IlAr.transformGroupDefaultValueToUserOption)
})($b0e92fcc13435d46$var$MultiGroupPickerField);

});
parcelRegister("1IlAr", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $d2f2135dd78f2505$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateMultipleGroupPickerField", () => $d2f2135dd78f2505$export$8cb86783be488510);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $arYvt = parcelRequire("arYvt");

const $d2f2135dd78f2505$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    if (Array.isArray(group)) return group.map((groupItem)=>(0, $arYvt.transformGroupToUserOption)(groupItem));
    return (0, $arYvt.transformGroupToUserOption)(group);
};
const $d2f2135dd78f2505$export$8cb86783be488510 = (selectedGroups, fieldId)=>({
        fieldId: fieldId,
        groups: selectedGroups.map(({ name: name })=>({
                groupName: name
            })),
        mutationGroup: (0, $795be18a4b521940$export$31fd86f8f183952c)
    });

});
const $795be18a4b521940$export$31fd86f8f183952c = 'multipleGroupPickerFields';




parcelRegister("iHSUu", function(module, exports) {

$parcel$export(module.exports, "MultiSelectCustomFieldTypeConfig", () => $19289b6ae773b2f1$export$1203387d0e5999ed);

var $5uXOq = parcelRequire("5uXOq");

var $kqDoy = parcelRequire("kqDoy");

var $g2djo = parcelRequire("g2djo");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $19289b6ae773b2f1$var$MultiSelectCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2djo.default), {
        ...props,
        defaultValue: undefined
    });
const $19289b6ae773b2f1$export$1203387d0e5999ed = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kqDoy))),
    type: (0, $5fc53.MULTI_SELECT_CF_TYPE),
    Component: $19289b6ae773b2f1$var$MultiSelectCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.multiSelectFieldWriter)
};

});
parcelRegister("kqDoy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::048e951b670250d3baacb0e9e5e7fd04>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edf4cb651ed8a915$var$_react = $edf4cb651ed8a915$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $edf4cb651ed8a915$var$_baseNew = $edf4cb651ed8a915$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $edf4cb651ed8a915$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxUnchecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edf4cb651ed8a915$var$CheckboxUncheckedIcon = (props)=>/*#__PURE__*/ $edf4cb651ed8a915$var$_react.default.createElement($edf4cb651ed8a915$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<rect width="12.5" height="12.5" x="1.75" y="1.75" stroke="currentcolor" stroke-width="1.5" rx="1.25"/>`
    }, props));
$edf4cb651ed8a915$var$CheckboxUncheckedIcon.displayName = 'CheckboxUncheckedIcon';
var $edf4cb651ed8a915$var$_default = module.exports.default = $edf4cb651ed8a915$var$CheckboxUncheckedIcon;

});

parcelRegister("g2djo", function(module, exports) {

$parcel$export(module.exports, "default", () => $970d61a7c1588270$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d3RWa = parcelRequire("d3RWa");

const $970d61a7c1588270$var$MultiSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d3RWa.default), {
        ...props,
        isMulti: true
    });
var $970d61a7c1588270$export$2e2bcd8739ae039 = $970d61a7c1588270$var$MultiSelectField;

});


parcelRegister("3owst", function(module, exports) {

$parcel$export(module.exports, "MultiUserCustomFieldTypeConfig", () => $114133be8a191ff4$export$e61985ad3f4b288f);

var $5uXOq = parcelRequire("5uXOq");

var $fptva = parcelRequire("fptva");

var $gARR3 = parcelRequire("gARR3");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $114133be8a191ff4$export$e61985ad3f4b288f = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($fptva))),
    type: (0, $5fc53.MULTI_USER_CF_TYPE),
    Component: (0, $gARR3.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.AssigneeFieldPlaceholder), null),
    writer: (0, $kShoa.multiUserPickerFieldWriter)
};

});
parcelRegister("gARR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $06543e5a7cef326e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lzCWA = parcelRequire("lzCWA");
const $06543e5a7cef326e$var$MultiUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lzCWA.default), {
        ...props,
        isMulti: true,
        context: "CustomMultiUserField"
    });
var $06543e5a7cef326e$export$2e2bcd8739ae039 = $06543e5a7cef326e$var$MultiUserPickerField;

});
parcelRegister("lzCWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a02b9e46792852c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $dQLtU = parcelRequire("dQLtU");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $hpV4g = parcelRequire("hpV4g");

var $7C5S0 = parcelRequire("7C5S0");

var $5kDIl = parcelRequire("5kDIl");

const $a02b9e46792852c4$var$getAutoCompleteUrl = (context, fieldId, projectKey)=>`/rest/api/3/user/recommend?${new URLSearchParams({
        context: context,
        ...projectKey && {
            project: projectKey
        },
        ...fieldId && {
            fieldId: fieldId
        },
        query: ''
    })}`;
const $a02b9e46792852c4$var$UserPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id }, isMulti: isMulti, autoFocus: autoFocus = false, fieldId: fieldId, placeholder: placeholder = ' ', isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, onFetchSuggestions: onFetchSuggestions, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, context: context, selectedProject: selectedProject, projectKey: projectKey } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dQLtU.default), {
        autoCompleteUrl: $a02b9e46792852c4$var$getAutoCompleteUrl(context, fieldId, // this is for fixing an issue that the custom user picker doesn't show the right user group in form when the project key is missing
        (0, $4R6GH.fg)('jira_forms_fix_user_picker_missing_project_key') ? projectKey || selectedProject?.projectKey : selectedProject?.projectKey),
        placeholder: placeholder,
        isDisabled: isReadOnly || isDisabled,
        onChange: onChange,
        value: value,
        appearance: "normal",
        isMulti: isMulti,
        autoFocus: autoFocus,
        fieldId: fieldId,
        fetchSuggestions: onFetchSuggestions,
        isClearable: true,
        width: width,
        inputId: id,
        onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
    }));
};
var $a02b9e46792852c4$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateUserPickerField),
    transformDefaultValue: (0, $5kDIl.transformDefaultUserValues)
})($a02b9e46792852c4$var$UserPickerField);

});
parcelRegister("dQLtU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d56a824ba419e6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jOrdN = parcelRequire("jOrdN");

var $9EuZf = parcelRequire("9EuZf");
const $e4d56a824ba419e6$var$UserPickerEdit = (props)=>{
    const { fieldId: fieldId, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, isMulti: isMulti, fetchSuggestions: fetchSuggestions, emptyOption: emptyOption, onDataLoaded: onDataLoaded, onDataRequest: onDataRequest, onCancel: onCancel, isDropdownVisibleByDefault: isDropdownVisibleByDefault, isClearable: isClearable, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll, inputId: inputId, isBulkEdit: isBulkEdit = false, ...fieldProps } = props;
    const extraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            styles: (0, $9EuZf.defaultUserPickerStyles),
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
        return {
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jOrdN.default), {
        ...fieldProps,
        fieldId: fieldId,
        inputId: inputId,
        appearance: appearance,
        width: width,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        placeholder: placeholder,
        isDisabled: isDisabled,
        isMulti: isMulti,
        autoCompleteUrl: autoCompleteUrl,
        fetchSuggestions: fetchSuggestions,
        emptyOption: emptyOption,
        onSelection: onSelection,
        onDataLoaded: onDataLoaded,
        onDataRequest: onDataRequest,
        onCancel: onCancel,
        isDropdownVisibleByDefault: isDropdownVisibleByDefault,
        isClearable: isClearable,
        isBulkEdit: isBulkEdit,
        ...extraProps()
    });
};
var $e4d56a824ba419e6$export$2e2bcd8739ae039 = $e4d56a824ba419e6$var$UserPickerEdit;

});
parcelRegister("jOrdN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f3563054ff092b8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $cr0SA = parcelRequire("cr0SA");

var $eusud = parcelRequire("eusud");

var $koVbs = parcelRequire("koVbs");


var $duvPR = parcelRequire("duvPR");

var $khYiH = parcelRequire("khYiH");
const $9f3563054ff092b8$var$stringContains = (str, substr)=>{
    if (str == null) return false;
    if (substr == null || substr === '') return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $9f3563054ff092b8$export$251bdbdbce9550ea = 400;
const $9f3563054ff092b8$var$UserPickerWrapper = (props)=>{
    const { allowEmail: allowEmail = false, isDisabled: isDisabled, isMulti: isMulti = false, value: value = null, emptyOption: emptyOption = null, appearance: appearance = 'compact', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSelection: onSelection = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDataRequest: onDataRequest = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDataLoaded: onDataLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isClearable: isClearable = false, portalElement: portalElement, isDropdownVisibleByDefault: isDropdownVisibleByDefault, menuPosition: menuPosition, onCloseMenuOnScroll: onCloseMenuOnScroll, autoFocus: autoFocus, fieldId: fieldId, placeholder: placeholder, width: width, autoCompleteUrl: autoCompleteUrl, noBorder: noBorder, styles: styles, shouldShowEmailInOptions: shouldShowEmailInOptions = false, withoutDebounce: withoutDebounce = false, inputId: inputId, isBulkEdit: isBulkEdit = false, openMenuOnClick: openMenuOnClick = false, isRequired: isRequired = false, menuMinWidth: menuMinWidth, fetchSuggestions: fetchSuggestionsProps, ...fieldProps } = props;
    const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(Boolean(isDropdownVisibleByDefault));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // null instead of '' because:
    // 1. fetchSuggestions is called as part of useEffect with query as one of the dependencies
    // 2. we dont want to call fetchSuggestions on mount, so added a check query !== null
    // 3. we want to call fetchSuggestions when query is '' and when picker gets focused (we set query as '') when it gets focused
    const [query, setQueryString] = (0, $5uXOq.useState)(null);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [wasFocused, setWasFocused] = (0, $5uXOq.useState)(false);
    const [wasCleared, setWasCleared] = (0, $5uXOq.useState)(false);
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)([]);
    const [sessionId, setSessionId] = (0, $5uXOq.useState)('');
    const getEmptyValue = ()=>emptyOption ? {
            ...emptyOption,
            id: (0, $768a4f0fe483a263$export$61a0b64dfe00294c)
        } : null;
    const debounceTime = withoutDebounce ? 0 : $9f3563054ff092b8$export$251bdbdbce9550ea;
    const requestSuggestionsDebounced = (0, $5uXOq.useMemo)(()=>{
        const isCurrentValue = (userOptionValue)=>{
            if (!userOptionValue) return value === null;
            if (Array.isArray(value)) return value.length > 0 ? !!value.find((suggestion)=>suggestion.id === userOptionValue.id) : userOptionValue.id === (0, $768a4f0fe483a263$export$61a0b64dfe00294c);
            return value ? userOptionValue.id === value.id : userOptionValue.id === (0, $768a4f0fe483a263$export$61a0b64dfe00294c);
        };
        const fetchSuggestions = async ()=>{
            let users = [];
            if (autoCompleteUrl !== undefined) {
                const autoCompleteResponse = await (0, $eusud.performGetRequest)(`${autoCompleteUrl}${query || ''}`);
                users = (0, $khYiH.mapAutoCompleteResponseToUsers)(autoCompleteResponse, isBulkEdit);
            }
            return users.map((userData)=>(0, $khYiH.mapUserObjectToUserOption)(userData, shouldShowEmailInOptions));
        };
        const handleSuggestions = (newSuggestions)=>{
            if (!isDropdownVisible || !newSuggestions) return;
            // Prevent the selected value from appearing in the list of suggestions at initial load.
            const filteredSuggestions = wasFocused ? newSuggestions.filter((suggestion)=>!isCurrentValue(suggestion)) : newSuggestions;
            setIsLoading(false);
            setSuggestions(filteredSuggestions);
            onDataLoaded(!query, filteredSuggestions.length);
        };
        const handleError = ()=>{
            setIsLoading(false);
            setSuggestions([]);
        };
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        const requestSuggestions = ()=>{
            onDataRequest(!query);
            if (fetchSuggestionsProps) return fetchSuggestionsProps(query, sessionId).then((results)=>{
                handleSuggestions(results);
            }).catch(handleError);
            return fetchSuggestions().then((results)=>handleSuggestions(results)).catch(handleError);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            requestSuggestions();
        }, debounceTime);
    }, [
        debounceTime,
        value,
        autoCompleteUrl,
        query,
        isBulkEdit,
        shouldShowEmailInOptions,
        isDropdownVisible,
        wasFocused,
        onDataLoaded,
        onDataRequest,
        fetchSuggestionsProps,
        sessionId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Added extra !isDropdownVisible condition - avoid query when dropdown is closed
        if (query === null || !isDropdownVisible) return;
        requestSuggestionsDebounced();
        return ()=>{
            requestSuggestionsDebounced.cancel();
        };
    }, [
        requestSuggestionsDebounced,
        query,
        isDropdownVisible
    ]);
    const onSelectedValueChangeMulti = (userOptionValue)=>{
        if (userOptionValue && userOptionValue.length === 0) onChange(null);
        else onChange(userOptionValue);
    };
    const onSelectedValueChangeSingle = (userOptionValue)=>{
        const valueId = userOptionValue && !Array.isArray(userOptionValue) && userOptionValue.id;
        if (valueId === (0, $768a4f0fe483a263$export$61a0b64dfe00294c)) onChange(null);
        else onChange(userOptionValue);
    };
    const onSuggestionSelect = (userOptionValue, sId)=>{
        setSessionId(sId || '');
        setWasFocused(false);
        setWasCleared(false);
        setIsLoading(false);
        setSuggestions([]);
        onSelection(sessionId);
        if (Array.isArray(userOptionValue)) onSelectedValueChangeMulti(userOptionValue);
        else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onSelectedValueChangeSingle(userOptionValue);
    };
    const onBlur = ()=>{
        setIsDropdownVisible(false);
        setIsLoading(false);
        setWasFocused(false);
        setSuggestions([]);
        if (wasCleared) {
            onSuggestionSelect(getEmptyValue());
            return;
        }
        onCancel();
    };
    const onDropdownOpen = (sId)=>{
        setSessionId(sId || '');
        setQueryString('');
        setIsDropdownVisible(true);
        setIsLoading(true);
        setWasFocused(true);
        setWasCleared(false);
    };
    const onQueryChange = (queryStr, sId)=>{
        setSessionId(sId || '');
        setQueryString(queryStr || '');
        setIsLoading(!!queryStr);
        setWasFocused(false);
        setIsDropdownVisible(!!queryStr);
    };
    const onClear = ()=>{
        setWasCleared(true);
        onSuggestionSelect(null);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const closeMenuOnScroll = (e)=>{
        if (onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const isMatchingQuery = (suggestion)=>{
        // when feature flag is false the predict should allow all
        const { displayName: displayName, name: name } = suggestion;
        return !isLoading || $9f3563054ff092b8$var$stringContains(displayName, query) || $9f3563054ff092b8$var$stringContains(name, query);
    };
    const getSuggestions = ()=>suggestions.filter((suggestion)=>isMatchingQuery(suggestion));
    const filteredSuggestions = getSuggestions();
    const pickerValue = value || getEmptyValue();
    const getNoOptionsMessage = ()=>query === null || query === '' ? formatMessage((0, $duvPR.default).emptyQueryMessage) : undefined;
    /*
   * user picker default opens on focus, so most of the operations like loading, querying, dropdown open/close are modified during onFocus
   * when openMenuOnClick is true then dropdown state managed internally as like select then have to use onOpen to modify any state like loading, querying
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: onDropdownOpen
    } : {
        open: isDropdownVisible,
        onFocus: onDropdownOpen
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        value: pickerValue,
        options: filteredSuggestions,
        isMulti: isMulti,
        fieldId: fieldId,
        menuMinWidth: menuMinWidth,
        menuPortalTarget: portalElement,
        width: width,
        appearance: appearance,
        isClearable: isClearable,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        placeholder: placeholder,
        onBlur: onBlur,
        isLoading: isLoading && isDropdownVisible,
        onClear: onClear,
        onInputChange: onQueryChange,
        onChange: onSuggestionSelect,
        noBorder: noBorder,
        styles: styles,
        noOptionsMessage: getNoOptionsMessage,
        allowEmail: allowEmail,
        inputId: inputId,
        required: isRequired,
        ariaLabel: fieldProps['aria-label'],
        ariaLabelledBy: fieldProps['aria-labelledby'],
        closeMenuOnScroll: closeMenuOnScroll,
        menuPosition: menuPosition,
        ...controlProps
    });
};
var $9f3563054ff092b8$export$2e2bcd8739ae039 = $9f3563054ff092b8$var$UserPickerWrapper;

});
const $768a4f0fe483a263$export$61a0b64dfe00294c = 'USER_PICKER_EMPTY';

parcelRegister("duvPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7ea6ee4d1ce51e6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7ea6ee4d1ce51e6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyQueryMessage: {
        "id": "base-user-picker.empty-query-message",
        "defaultMessage": "Start typing to get a list of possible matches."
    }
});

});

parcelRegister("khYiH", function(module, exports) {

$parcel$export(module.exports, "mapUserObjectToUserOption", () => $5eec43efc9e4eafe$export$e11fc32dba4fe919);
$parcel$export(module.exports, "mapAutoCompleteResponseToUsers", () => $5eec43efc9e4eafe$export$ec325826d2bf6655);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");
const $5eec43efc9e4eafe$export$e11fc32dba4fe919 = (userData, shouldShowEmailInOptions = false)=>{
    let userOption = {
        id: userData.accountId || '',
        name: userData.displayName || '',
        avatarUrl: userData?.avatarUrl || userData.avatarUrls?.['32x32'] || ''
    };
    if (shouldShowEmailInOptions === true && userData.emailAddress !== null && userData.emailAddress !== undefined) // @ts-expect-error - TS2322 - Type '{ byline: string; id: string; name: string; avatarUrl: string; }' is not assignable to type '{ id: string; name: string; avatarUrl: string; }'.
    userOption = {
        ...userOption,
        byline: userData.emailAddress
    };
    return userOption;
};
const $5eec43efc9e4eafe$export$ec325826d2bf6655 = (autoCompleteResponse, isBulkEdit)=>{
    try {
        if (isBulkEdit) {
            if (autoCompleteResponse && typeof autoCompleteResponse === 'object' && 'users' in autoCompleteResponse && autoCompleteResponse.users) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return autoCompleteResponse.users;
        } else if (Array.isArray(autoCompleteResponse)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return autoCompleteResponse;
        throw Error('autoCompleteResponse is either null or not expected value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'mapAutoCompleteResponse',
                packageName: 'jiraBaseUserPicker',
                teamName: 'gryffindor'
            },
            error: error,
            ...(0, $4R6GH.fg)('skip-autocomplete-error-from-sentry') ? {
                skipSentry: true,
                attributes: {
                    autoCompleteResponseIsNull: autoCompleteResponse === null
                },
                sendToPrivacyUnsafeSplunk: true
            } : {}
        });
    }
    return [];
};

});






parcelRegister("dzSVK", function(module, exports) {

$parcel$export(module.exports, "NumberCustomFieldTypeConfig", () => $ba1f787e6f666f7e$export$9263307b5dc5bafe);

var $5uXOq = parcelRequire("5uXOq");

var $7WX1N = parcelRequire("7WX1N");

var $bo14T = parcelRequire("bo14T");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $ba1f787e6f666f7e$var$NumberCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bo14T.default), props);
const $ba1f787e6f666f7e$export$9263307b5dc5bafe = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7WX1N))),
    type: (0, $5fc53.NUMBER_CF_TYPE),
    Component: $ba1f787e6f666f7e$var$NumberCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.TextFieldPlaceholder), null),
    writer: (0, $kShoa.numberFieldWriter)
};

});
parcelRegister("7WX1N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2424f7589ad3de6440a9b3fffe6660f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c9bbce6cd34e80a$var$_react = $5c9bbce6cd34e80a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5c9bbce6cd34e80a$var$_baseNew = $5c9bbce6cd34e80a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5c9bbce6cd34e80a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Hashtag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: topics in Atlas, tags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c9bbce6cd34e80a$var$HashtagIcon = (props)=>/*#__PURE__*/ $5c9bbce6cd34e80a$var$_react.default.createElement($5c9bbce6cd34e80a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m6.75 1-2.5 14m7.5-14-2.5 14M14 10.25H1m14-4.5H2"/>`
    }, props));
$5c9bbce6cd34e80a$var$HashtagIcon.displayName = 'HashtagIcon';
var $5c9bbce6cd34e80a$var$_default = module.exports.default = $5c9bbce6cd34e80a$var$HashtagIcon;

});

parcelRegister("bo14T", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dfdc9c56d4f0e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hMKLn = parcelRequire("hMKLn");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

var $kU4qk = parcelRequire("kU4qk");

const $69dfdc9c56d4f0e9$export$63c5fa0b2fdccd2e = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMKLn.InputField), {
        type: "number",
        width: width,
        ...rest
    });
};
var $69dfdc9c56d4f0e9$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString),
    transformDefaultValue: (0, $kU4qk.transformAsString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$69dfdc9c56d4f0e9$export$63c5fa0b2fdccd2e);

});
parcelRegister("hMKLn", function(module, exports) {

$parcel$export(module.exports, "InputField", () => $c59ad84f24b74144$export$dd2171e2b7d3bc5b);
$parcel$export(module.exports, "default", () => $c59ad84f24b74144$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kY99m = parcelRequire("kY99m");

var $jGVMX = parcelRequire("jGVMX");

var $hpV4g = parcelRequire("hpV4g");

var $lrbT7 = parcelRequire("lrbT7");
const $c59ad84f24b74144$export$dd2171e2b7d3bc5b = (props)=>{
    const { type: type = 'text', width: width = 'auto', error: error, fieldProps: { value: value = '', onChange: onChange, ...rest }, autoFocus: autoFocus, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ...rest,
        // @ts-expect-error - TS2322 - Type '(value: string) => void' is not assignable to type 'FormEventHandler<HTMLInputElement>'.
        onChange: onChange,
        value: value,
        type: type,
        width: width,
        step: "any",
        testId: "issue-create-commons.common.ui.fields.base-fields.input-field.textfield",
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        onWheel: (0, $lrbT7.preventMouseScrollForNumericFieldHandler),
        isDisabled: isReadOnly || rest.isDisabled
    });
};
var $c59ad84f24b74144$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$c59ad84f24b74144$export$dd2171e2b7d3bc5b);

});
parcelRegister("lrbT7", function(module, exports) {

$parcel$export(module.exports, "preventMouseScrollForNumericFieldHandler", () => $0fe71c1efa633a57$export$3fedcbfe1c53d8f);
const $0fe71c1efa633a57$export$3fedcbfe1c53d8f = (event)=>{
    if (event?.currentTarget?.type === 'number') event.currentTarget.blur?.();
};

});


parcelRegister("kU4qk", function(module, exports) {

$parcel$export(module.exports, "transformAsNumber", () => $2648f8f88d1e9261$export$52c4e7404b9db862);
$parcel$export(module.exports, "mutateNumberField", () => $2648f8f88d1e9261$export$6701d4d68ea6db95);
$parcel$export(module.exports, "transformAsString", () => $2648f8f88d1e9261$export$afe59f8094df7220);

const $2648f8f88d1e9261$export$52c4e7404b9db862 = (value)=>{
    if (value) return Number(value);
    return undefined;
};
const $2648f8f88d1e9261$export$6701d4d68ea6db95 = (value, fieldId)=>({
        fieldId: fieldId,
        value: Number(value),
        mutationGroup: (0, $358fca2fc5354374$export$31fd86f8f183952c)
    });
const $2648f8f88d1e9261$export$afe59f8094df7220 = (value)=>{
    if (value !== undefined) return String(value);
    return undefined;
};

});
const $358fca2fc5354374$export$31fd86f8f183952c = 'numberFields';




parcelRegister("2prZd", function(module, exports) {

$parcel$export(module.exports, "ParentFieldTypeConfig", () => $2c89c4ecde62323b$export$dfc79382467975d5);

var $5uXOq = parcelRequire("5uXOq");

var $c0edv = parcelRequire("c0edv");

var $8mBES = parcelRequire("8mBES");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $2c89c4ecde62323b$var$ParentFieldTypeComponent = (props)=>{
    if (!props.issueTypeId || !props.canUserViewProject) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8mBES.default), {
        ...props,
        selectedProject: {
            value: props.projectId
        },
        selectedIssueType: {
            value: props.issueTypeId
        },
        isFieldResponsive: true
    });
};
const $2c89c4ecde62323b$export$dfc79382467975d5 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0edv))),
    type: (0, $5fc53.PARENT_TYPE),
    Component: $2c89c4ecde62323b$var$ParentFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.selectFieldWriter)
};

});
parcelRegister("c0edv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::930c8bc34af369ff70dfc1fe8c87ccc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bd0834c72dd821c$var$_react = $8bd0834c72dd821c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bd0834c72dd821c$var$_baseNew = $8bd0834c72dd821c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8bd0834c72dd821c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Field".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Field suggestions provided by Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bd0834c72dd821c$var$FieldIcon = (props)=>/*#__PURE__*/ $8bd0834c72dd821c$var$_react.default.createElement($8bd0834c72dd821c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M0 2.75h6m-4 8.5h12c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H2C1.31 5.75.75 6.31.75 7v3c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$8bd0834c72dd821c$var$FieldIcon.displayName = 'FieldIcon';
var $8bd0834c72dd821c$var$_default = module.exports.default = $8bd0834c72dd821c$var$FieldIcon;

});

parcelRegister("8mBES", function(module, exports) {

$parcel$export(module.exports, "default", () => $28698af5fbb25d8a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $aIZdc = parcelRequire("aIZdc");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $1iKBB = parcelRequire("1iKBB");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $bA6nL = parcelRequire("bA6nL");

var $eulr6 = parcelRequire("eulr6");

const $28698af5fbb25d8a$export$96c87c0afbe06b37 = (props)=>{
    const { fieldId: fieldId, fieldProps: { value: value, onChange: onChange }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isExistingIssue: isExistingIssue, selectedProject: selectedProject, selectedIssueType: selectedIssueType, issueKey: issueKey, isReadOnly: isReadOnly = false } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let issueTypeId;
    if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
    /**
   * When creating a sub-task from the GIC modal, we:
   * - pre-populate the parent field in "src/packages/issue-navigator/issue-operations/meatball-menu/src/ui/dropdown-menu-group/button-item/index"
   * - disable the parent field to prevent the user to change it
   *
   * This prevents the user to make a mistake or bump into potential edge cases.
   */ const isDisabled = props.isSubTaskCreationOpen || isReadOnly;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1iKBB.ParentFieldEdit), {
        fieldId: fieldId,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isExistingIssue: isExistingIssue,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        selectedProjectId: selectedProject ? selectedProject.value : undefined,
        selectedIssueTypeId: issueTypeId,
        fetchSuggestionsOnFocus: true,
        passedInIssueKey: (0, $4R6GH.fg)('render-modern-issue-transition') || (0, $aIZdc.isFedRamp)() ? issueKey : undefined,
        spacing: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $28698af5fbb25d8a$var$fieldDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bA6nL.default).descriptionIssueTermRefresh : (0, $bA6nL.default).description))));
};
const $28698af5fbb25d8a$var$fieldDescriptionStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});
var $28698af5fbb25d8a$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $eulr6.transformDefaultParentValue),
    validator: (0, $eulr6.validateParentField)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ParentFieldConfig, LegacyValue<Option>>, any>'.
$28698af5fbb25d8a$export$96c87c0afbe06b37);

});
// error types
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';

parcelRegister("1iKBB", function(module, exports) {

$parcel$export(module.exports, "ParentFieldEdit", () => $b89ca9fa2a80ab1b$export$55c2cccecfd24751);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck react-select unsupported props

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $3BhEA = parcelRequire("3BhEA");

var $lElIo = parcelRequire("lElIo");

var $koeKL = parcelRequire("koeKL");

var $iVcsU = parcelRequire("iVcsU");

var $inRSh = parcelRequire("inRSh");

var $3orGF = parcelRequire("3orGF");

var $1sPJ0 = parcelRequire("1sPJ0");

var $6v0ju = parcelRequire("6v0ju");
const $b89ca9fa2a80ab1b$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $b89ca9fa2a80ab1b$export$55c2cccecfd24751 = (props)=>{
    const { onFocus: onFocus, onBlur: onBlur, value: value = null, onChange: onChange, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, isInvalid: isInvalid = false, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled = false, isExistingIssue: isExistingIssue = false, defaultMenuIsOpen: defaultMenuIsOpen = false, isEditing: isEditing, classNamePrefix: classNamePrefix, isClearable: isClearable = true, passedInIssueKey: passedInIssueKey, fieldId: // used for experiences that don't have issueKey in context, eg. bulk edit
    fieldId, spacing: spacingProps = 'compact', 'aria-labelledby': ariaLabelledBy, onSearchParents: onSearchParents, showDoneIssuesCheckboxVisible: showDoneIssuesCheckboxVisible } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
    const [noOptionsMessage, setNoOptionsMessage] = (0, $5uXOq.useState)('');
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
    const [excludeDone, setExcludeDone] = (0, $5uXOq.useState)(true);
    const isInitialMount = (0, $5uXOq.useRef)(true);
    const lastQuery = (0, $5uXOq.useRef)('');
    const cloudId = (0, $koeKL.useCloudId)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const componentProps = (0, $5uXOq.useMemo)(()=>({
            onChange: (event)=>{
                setExcludeDone(!event.target.checked);
            },
            showDoneIssuesCheckboxVisible: showDoneIssuesCheckboxVisible
        }), [
        showDoneIssuesCheckboxVisible
    ]);
    const formatOptionLabel = (0, $5uXOq.useCallback)((option, { context: context })=>{
        if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: option.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sPJ0.default), {
            option: option
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, option.label || `${option.key} ${option.fields.summary}`);
    }, []);
    const searchParents = (0, $5uXOq.useCallback)(async (query = '')=>{
        setHasLastFetchFailed(false);
        try {
            lastQuery.current = query;
            if (isExistingIssue) {
                const fetchedOptions = await (0, $6v0ju.fetchParentsForExisting)({
                    searchTerm: query,
                    issueKey: passedInIssueKey || issueKey,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            if (selectedProjectId && selectedIssueTypeId) {
                const fetchedOptions = await (0, $6v0ju.fetchParentsForNew)({
                    searchTerm: query,
                    selectedProjectId: selectedProjectId,
                    selectedIssueTypeId: selectedIssueTypeId,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        } catch  {
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        }
    }, [
        isExistingIssue,
        issueKey,
        cloudId,
        excludeDone,
        selectedProjectId,
        selectedIssueTypeId,
        passedInIssueKey
    ]);
    const requestSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
        let response;
        if (onSearchParents && (0, $4R6GH.fg)('issue_view_in_program_board')) response = await onSearchParents(query);
        else response = await searchParents(query);
        if (lastQuery.current === query) {
            if (response.options !== undefined) {
                setSuggestions(response.options);
                if (response.options.length === 0 && response.message) setNoOptionsMessage(response.message);
                if (query === '') setDefaultSuggestions(response.options);
            } else {
                setSuggestions([]);
                if (query === '') setDefaultSuggestions([]);
            }
            setIsLoading(false);
        }
    }, [
        searchParents,
        onSearchParents
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(requestSuggestions, $b89ca9fa2a80ab1b$var$LOAD_OPTIONS_DEBOUNCE_TIMER), [
        excludeDone
    ]);
    const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoading(true);
            debouncedRequestSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions
    ]);
    const handleFocus = (0, $5uXOq.useCallback)((e)=>{
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const filterOption = (0, $5uXOq.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $3BhEA.filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
    }, [
        hasLastFetchFailed
    ]);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>{
        const noOptions = noOptionsMessage !== '' ? noOptionsMessage : formatMessage((0, $3orGF.default).noMatches);
        // we now get the translated message from the backend, but will fall back to the old message if it's not there
        return hasLastFetchFailed ? formatMessage((0, $3orGF.default).failedFetch) : noOptions;
    }, [
        formatMessage,
        hasLastFetchFailed,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, $3orGF.default).loading), [
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoading(true);
            requestSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        excludeDone,
        requestSuggestions
    ]);
    const spacing = (0, $5uXOq.useMemo)(()=>spacingProps, [
        spacingProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        // need to stop esc keydown propagation to avoid modal close if select is open
        onKeyDown: (0, $iVcsU.preventEscKeyPropagationKeyPressHandler),
        inputId: `${fieldId}-field`,
        options: suggestions,
        value: value,
        formatOptionLabel: formatOptionLabel,
        onBlur: onBlur,
        onFocus: handleFocus,
        onChange: onChange,
        menuPosition: isDropdownMenuFixedAndLayered ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        isMulti: false,
        isLoading: isLoading,
        onInputChange: onQueryChange,
        loadingMessage: getLoadingMessage,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $3orGF.default).placeholder),
        components: {
            Menu: $inRSh.default
        },
        componentsProps: componentProps,
        autoFocus: autoFocus,
        filterOption: filterOption,
        validationState: isInvalid === true ? 'error' : undefined,
        hideSelectedOptions: true,
        isClearable: isClearable,
        ...isEditing !== undefined && {
            menuIsOpen: isEditing
        },
        isDisabled: isDisabled,
        defaultMenuIsOpen: defaultMenuIsOpen,
        classNamePrefix: classNamePrefix,
        spacing: spacing,
        "aria-label": formatMessage((0, $3orGF.default).placeholder),
        "aria-labelledby": ariaLabelledBy,
        ...(0, $4R6GH.fg)('issue_view_in_program_board') && {
            menuPlacement: 'auto'
        }
    });
};

});
parcelRegister("iVcsU", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElem", () => $608100d8bb869e55$export$b00899e73680c477);
$parcel$export(module.exports, "mapDataToOptions", () => $608100d8bb869e55$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $608100d8bb869e55$export$fc800909123977f3);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $608100d8bb869e55$export$feb08457bf70a411);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $608100d8bb869e55$export$949dc67535a8ff2);
/* utils.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $heWHN = parcelRequire("heWHN");

var $iHPnC = parcelRequire("iHPnC");
const $608100d8bb869e55$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, $heWHN.MAP_COLORS_TO_VALUE)[color];
const $608100d8bb869e55$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($608100d8bb869e55$var$ColorPatch, {
        color: color,
        "data-testid": `issue-field-parent.common.color-patch-${color}`
    });
const $608100d8bb869e55$export$99a866ffa3af7d8b = (issueParents)=>{
    return issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`,
            isDone: isDone
        }));
};
const $608100d8bb869e55$export$fc800909123977f3 = (option)=>({
        id: option.value
    });
const $608100d8bb869e55$export$9b822862d986dfdf = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $608100d8bb869e55$export$feb08457bf70a411 = (event)=>{
    if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
};
const $608100d8bb869e55$export$949dc67535a8ff2 = (color)=>$608100d8bb869e55$export$9b822862d986dfdf[color];
// We adjust the size of the color patch away from normal grid sizes because
// the issue type icon actually has a 1px border on each side, which is 2x1px on width/height
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $608100d8bb869e55$var$ColorPatch = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1nzbko4": (0, $lD23V.default)($608100d8bb869e55$export$bc913b9c9057634d(__cmplp.color))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1bsbdlk8 _1ul9dlk8 _4t3idlk8 _bfhk1vzt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("heWHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3a4ee6f2b0ce40ab$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);

var $ggSx2 = parcelRequire("ggSx2");


var $kFsv3 = parcelRequire("kFsv3");
const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
    [(0, $kFsv3.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
    [(0, $kFsv3.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
    [(0, $kFsv3.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
    [(0, $kFsv3.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
    [(0, $kFsv3.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
    [(0, $kFsv3.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
    [(0, $kFsv3.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
    [(0, $kFsv3.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
    [(0, $kFsv3.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
    [(0, $kFsv3.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
    [(0, $kFsv3.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
    [(0, $kFsv3.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
    [(0, $kFsv3.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
    [(0, $kFsv3.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
};
const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
    [(0, $829f609a65d26a98$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
    [(0, $829f609a65d26a98$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
    [(0, $829f609a65d26a98$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
    [(0, $829f609a65d26a98$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
    [(0, $829f609a65d26a98$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
    [(0, $829f609a65d26a98$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
    [(0, $829f609a65d26a98$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
    [(0, $829f609a65d26a98$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
    [(0, $829f609a65d26a98$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
    [(0, $829f609a65d26a98$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
    [(0, $829f609a65d26a98$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
    [(0, $829f609a65d26a98$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
    [(0, $829f609a65d26a98$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
    [(0, $829f609a65d26a98$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
};
const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
    [(0, $kFsv3.SERVER_PURPLE)]: (0, $kFsv3.PURPLE),
    [(0, $kFsv3.SERVER_DARK_PURPLE)]: (0, $kFsv3.DARK_PURPLE),
    [(0, $kFsv3.SERVER_BLUE)]: (0, $kFsv3.BLUE),
    [(0, $kFsv3.SERVER_DARK_BLUE)]: (0, $kFsv3.DARK_BLUE),
    [(0, $kFsv3.SERVER_GREEN)]: (0, $kFsv3.GREEN),
    [(0, $kFsv3.SERVER_DARK_GREEN)]: (0, $kFsv3.DARK_GREEN),
    [(0, $kFsv3.SERVER_TEAL)]: (0, $kFsv3.TEAL),
    [(0, $kFsv3.SERVER_DARK_TEAL)]: (0, $kFsv3.DARK_TEAL),
    [(0, $kFsv3.SERVER_YELLOW)]: (0, $kFsv3.YELLOW),
    [(0, $kFsv3.SERVER_DARK_YELLOW)]: (0, $kFsv3.DARK_YELLOW),
    [(0, $kFsv3.SERVER_ORANGE)]: (0, $kFsv3.ORANGE),
    [(0, $kFsv3.SERVER_DARK_ORANGE)]: (0, $kFsv3.DARK_ORANGE),
    [(0, $kFsv3.SERVER_GREY)]: (0, $kFsv3.GREY),
    [(0, $kFsv3.SERVER_DARK_GREY)]: (0, $kFsv3.DARK_GREY)
};
const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
    [(0, $kFsv3.GHX_LABEL_1)]: (0, $kFsv3.DARK_GREY),
    [(0, $kFsv3.GHX_LABEL_2)]: (0, $kFsv3.DARK_YELLOW),
    [(0, $kFsv3.GHX_LABEL_3)]: (0, $kFsv3.YELLOW),
    [(0, $kFsv3.GHX_LABEL_4)]: (0, $kFsv3.DARK_BLUE),
    [(0, $kFsv3.GHX_LABEL_5)]: (0, $kFsv3.DARK_TEAL),
    [(0, $kFsv3.GHX_LABEL_6)]: (0, $kFsv3.GREEN),
    [(0, $kFsv3.GHX_LABEL_7)]: (0, $kFsv3.PURPLE),
    [(0, $kFsv3.GHX_LABEL_8)]: (0, $kFsv3.DARK_PURPLE),
    [(0, $kFsv3.GHX_LABEL_9)]: (0, $kFsv3.ORANGE),
    [(0, $kFsv3.GHX_LABEL_10)]: (0, $kFsv3.BLUE),
    [(0, $kFsv3.GHX_LABEL_11)]: (0, $kFsv3.TEAL),
    [(0, $kFsv3.GHX_LABEL_12)]: (0, $kFsv3.GREY),
    [(0, $kFsv3.GHX_LABEL_13)]: (0, $kFsv3.DARK_GREEN),
    [(0, $kFsv3.GHX_LABEL_14)]: (0, $kFsv3.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
    [(0, $kFsv3.AGILE_COLOR_1)]: (0, $kFsv3.DARK_GREY),
    [(0, $kFsv3.AGILE_COLOR_2)]: (0, $kFsv3.DARK_YELLOW),
    [(0, $kFsv3.AGILE_COLOR_3)]: (0, $kFsv3.YELLOW),
    [(0, $kFsv3.AGILE_COLOR_4)]: (0, $kFsv3.DARK_BLUE),
    [(0, $kFsv3.AGILE_COLOR_5)]: (0, $kFsv3.DARK_TEAL),
    [(0, $kFsv3.AGILE_COLOR_6)]: (0, $kFsv3.GREEN),
    [(0, $kFsv3.AGILE_COLOR_7)]: (0, $kFsv3.PURPLE),
    [(0, $kFsv3.AGILE_COLOR_8)]: (0, $kFsv3.DARK_PURPLE),
    [(0, $kFsv3.AGILE_COLOR_9)]: (0, $kFsv3.ORANGE),
    [(0, $kFsv3.AGILE_COLOR_10)]: (0, $kFsv3.BLUE),
    [(0, $kFsv3.AGILE_COLOR_11)]: (0, $kFsv3.TEAL),
    [(0, $kFsv3.AGILE_COLOR_12)]: (0, $kFsv3.GREY),
    [(0, $kFsv3.AGILE_COLOR_13)]: (0, $kFsv3.DARK_GREEN),
    [(0, $kFsv3.AGILE_COLOR_14)]: (0, $kFsv3.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
    [(0, $kFsv3.GHX_LABEL_1)]: (0, $kFsv3.AGILE_COLOR_1),
    [(0, $kFsv3.GHX_LABEL_2)]: (0, $kFsv3.AGILE_COLOR_2),
    [(0, $kFsv3.GHX_LABEL_3)]: (0, $kFsv3.AGILE_COLOR_3),
    [(0, $kFsv3.GHX_LABEL_4)]: (0, $kFsv3.AGILE_COLOR_4),
    [(0, $kFsv3.GHX_LABEL_5)]: (0, $kFsv3.AGILE_COLOR_5),
    [(0, $kFsv3.GHX_LABEL_6)]: (0, $kFsv3.AGILE_COLOR_6),
    [(0, $kFsv3.GHX_LABEL_7)]: (0, $kFsv3.AGILE_COLOR_7),
    [(0, $kFsv3.GHX_LABEL_8)]: (0, $kFsv3.AGILE_COLOR_8),
    [(0, $kFsv3.GHX_LABEL_9)]: (0, $kFsv3.AGILE_COLOR_9),
    [(0, $kFsv3.GHX_LABEL_10)]: (0, $kFsv3.AGILE_COLOR_10),
    [(0, $kFsv3.GHX_LABEL_11)]: (0, $kFsv3.AGILE_COLOR_11),
    [(0, $kFsv3.GHX_LABEL_12)]: (0, $kFsv3.AGILE_COLOR_12),
    [(0, $kFsv3.GHX_LABEL_13)]: (0, $kFsv3.AGILE_COLOR_13),
    [(0, $kFsv3.GHX_LABEL_14)]: (0, $kFsv3.AGILE_COLOR_14)
};
const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
    [(0, $kFsv3.DARK_GREY)]: 'grey',
    [(0, $kFsv3.DARK_YELLOW)]: 'yellow',
    [(0, $kFsv3.YELLOW)]: 'yellowLight',
    [(0, $kFsv3.DARK_BLUE)]: 'blue',
    [(0, $kFsv3.DARK_TEAL)]: 'teal',
    [(0, $kFsv3.GREEN)]: 'greenLight',
    [(0, $kFsv3.PURPLE)]: 'purpleLight',
    [(0, $kFsv3.DARK_PURPLE)]: 'purple',
    [(0, $kFsv3.ORANGE)]: 'redLight',
    [(0, $kFsv3.BLUE)]: 'blueLight',
    [(0, $kFsv3.TEAL)]: 'tealLight',
    [(0, $kFsv3.GREY)]: 'greyLight',
    [(0, $kFsv3.DARK_GREEN)]: 'green',
    [(0, $kFsv3.DARK_ORANGE)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
    [(0, $kFsv3.AGILE_COLOR_1)]: 'grey',
    [(0, $kFsv3.AGILE_COLOR_2)]: 'yellow',
    [(0, $kFsv3.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $kFsv3.AGILE_COLOR_4)]: 'blue',
    [(0, $kFsv3.AGILE_COLOR_5)]: 'teal',
    [(0, $kFsv3.AGILE_COLOR_6)]: 'greenLight',
    [(0, $kFsv3.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $kFsv3.AGILE_COLOR_8)]: 'purple',
    [(0, $kFsv3.AGILE_COLOR_9)]: 'redLight',
    [(0, $kFsv3.AGILE_COLOR_10)]: 'blueLight',
    [(0, $kFsv3.AGILE_COLOR_11)]: 'tealLight',
    [(0, $kFsv3.AGILE_COLOR_12)]: 'greyLight',
    [(0, $kFsv3.AGILE_COLOR_13)]: 'green',
    [(0, $kFsv3.AGILE_COLOR_14)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
    [(0, $kFsv3.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P500})`,
        text: "var(--ds-text-accent-purple, #803FA5)",
        textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $829f609a65d26a98$exports).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B500})`,
        text: "var(--ds-text-accent-blue, #1558BC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$exports).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G500})`,
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $829f609a65d26a98$exports).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T500})`,
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $829f609a65d26a98$exports).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $829f609a65d26a98$exports).Y500})`,
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        border: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$exports).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R500})`,
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N500})`,
        text: "var(--ds-text-accent-gray, #505258)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        border: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
        border: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $829f609a65d26a98$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N300})`,
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
        border: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("kFsv3", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $da8a77f13d52b186$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $da8a77f13d52b186$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $da8a77f13d52b186$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $da8a77f13d52b186$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $da8a77f13d52b186$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $da8a77f13d52b186$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $da8a77f13d52b186$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $da8a77f13d52b186$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $da8a77f13d52b186$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $da8a77f13d52b186$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $da8a77f13d52b186$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $da8a77f13d52b186$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $da8a77f13d52b186$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $da8a77f13d52b186$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $da8a77f13d52b186$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $da8a77f13d52b186$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $da8a77f13d52b186$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $da8a77f13d52b186$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $da8a77f13d52b186$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $da8a77f13d52b186$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $da8a77f13d52b186$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $da8a77f13d52b186$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $da8a77f13d52b186$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $da8a77f13d52b186$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $da8a77f13d52b186$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $da8a77f13d52b186$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $da8a77f13d52b186$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $da8a77f13d52b186$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $da8a77f13d52b186$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $da8a77f13d52b186$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $da8a77f13d52b186$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $da8a77f13d52b186$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $da8a77f13d52b186$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $da8a77f13d52b186$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $da8a77f13d52b186$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $da8a77f13d52b186$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $da8a77f13d52b186$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $da8a77f13d52b186$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $da8a77f13d52b186$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $da8a77f13d52b186$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $da8a77f13d52b186$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $da8a77f13d52b186$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $da8a77f13d52b186$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $da8a77f13d52b186$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $da8a77f13d52b186$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $da8a77f13d52b186$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $da8a77f13d52b186$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $da8a77f13d52b186$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $da8a77f13d52b186$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $da8a77f13d52b186$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $da8a77f13d52b186$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $da8a77f13d52b186$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $da8a77f13d52b186$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $da8a77f13d52b186$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $da8a77f13d52b186$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $da8a77f13d52b186$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $da8a77f13d52b186$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $da8a77f13d52b186$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $da8a77f13d52b186$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $da8a77f13d52b186$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $da8a77f13d52b186$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $da8a77f13d52b186$export$7ffdeca4b2f927a2 = 'PURPLE';
const $da8a77f13d52b186$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $da8a77f13d52b186$export$738c3b9a44c87ecc = 'BLUE';
const $da8a77f13d52b186$export$1225f83626261b80 = 'DARK_BLUE';
const $da8a77f13d52b186$export$48d4b2cd5bc0e88b = 'GREEN';
const $da8a77f13d52b186$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $da8a77f13d52b186$export$d0446fe88325854e = 'TEAL';
const $da8a77f13d52b186$export$bb848c92687e69dc = 'DARK_TEAL';
const $da8a77f13d52b186$export$aab610c505c06a8f = 'YELLOW';
const $da8a77f13d52b186$export$466af87757d343a2 = 'DARK_YELLOW';
const $da8a77f13d52b186$export$3de5e29ed1757f9b = 'ORANGE';
const $da8a77f13d52b186$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $da8a77f13d52b186$export$7d278ca694634874 = 'GREY';
const $da8a77f13d52b186$export$26453300bfc61cb8 = 'DARK_GREY';
const $da8a77f13d52b186$export$56d196d2844d1ca1 = [
    $da8a77f13d52b186$export$7ffdeca4b2f927a2,
    $da8a77f13d52b186$export$c815fe495e8174a0,
    $da8a77f13d52b186$export$738c3b9a44c87ecc,
    $da8a77f13d52b186$export$1225f83626261b80,
    $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
    $da8a77f13d52b186$export$c6f4cf2e5768eb78,
    $da8a77f13d52b186$export$d0446fe88325854e,
    $da8a77f13d52b186$export$bb848c92687e69dc,
    $da8a77f13d52b186$export$aab610c505c06a8f,
    $da8a77f13d52b186$export$466af87757d343a2,
    $da8a77f13d52b186$export$3de5e29ed1757f9b,
    $da8a77f13d52b186$export$da02e4820b6ab753,
    $da8a77f13d52b186$export$7d278ca694634874,
    $da8a77f13d52b186$export$26453300bfc61cb8
];
const $da8a77f13d52b186$export$792af22a0198af8d = 'purple';
const $da8a77f13d52b186$export$588af712afdcb006 = 'dark_purple';
const $da8a77f13d52b186$export$84c4918645391802 = 'blue';
const $da8a77f13d52b186$export$b8f1f5838352a33a = 'dark_blue';
const $da8a77f13d52b186$export$9384b7e350ee6542 = 'green';
const $da8a77f13d52b186$export$87d3fb8d8656d38b = 'dark_green';
const $da8a77f13d52b186$export$b0b4ce3e99e66aae = 'teal';
const $da8a77f13d52b186$export$a89b77a449bd223e = 'dark_teal';
const $da8a77f13d52b186$export$9a33b5e3cde94885 = 'yellow';
const $da8a77f13d52b186$export$33253d7862bceb8a = 'dark_yellow';
const $da8a77f13d52b186$export$6609c2b23fc42f39 = 'orange';
const $da8a77f13d52b186$export$cd994662b5911917 = 'dark_orange';
const $da8a77f13d52b186$export$1793d43e13e078c5 = 'grey';
const $da8a77f13d52b186$export$487a6e9145526564 = 'dark_grey';
const $da8a77f13d52b186$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $da8a77f13d52b186$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $da8a77f13d52b186$export$94ac87c81ed074a7 = 'ghx-label-3';
const $da8a77f13d52b186$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $da8a77f13d52b186$export$610a2c132b6fcf96 = 'ghx-label-5';
const $da8a77f13d52b186$export$8e4997dba71f1c40 = 'ghx-label-6';
const $da8a77f13d52b186$export$18a545b4e69b27b4 = 'ghx-label-7';
const $da8a77f13d52b186$export$27fff1a0d295292a = 'ghx-label-8';
const $da8a77f13d52b186$export$e57aa662a56724e1 = 'ghx-label-9';
const $da8a77f13d52b186$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $da8a77f13d52b186$export$457ecb9560f2bf83 = 'ghx-label-11';
const $da8a77f13d52b186$export$a866db37165a696c = 'ghx-label-12';
const $da8a77f13d52b186$export$9b18447c1168a1b6 = 'ghx-label-13';
const $da8a77f13d52b186$export$93b9ad4020e271b7 = 'ghx-label-14';
const $da8a77f13d52b186$export$5cd2af17b34de3e3 = 'color_1';
const $da8a77f13d52b186$export$987671fa69482a7b = 'color_2';
const $da8a77f13d52b186$export$70ba8a5b1f4c7446 = 'color_3';
const $da8a77f13d52b186$export$fcd1c42d8d3ebd36 = 'color_4';
const $da8a77f13d52b186$export$f80a5bd2fa0ba256 = 'color_5';
const $da8a77f13d52b186$export$37ad5ce8d2aeaf78 = 'color_6';
const $da8a77f13d52b186$export$9dc62d5d151cb355 = 'color_7';
const $da8a77f13d52b186$export$1ed15b30f5663f92 = 'color_8';
const $da8a77f13d52b186$export$5d23a84d55ac1644 = 'color_9';
const $da8a77f13d52b186$export$bf08c9a6ed42e349 = 'color_10';
const $da8a77f13d52b186$export$66c5d8f0b5ff279c = 'color_11';
const $da8a77f13d52b186$export$da30755a37c3a597 = 'color_12';
const $da8a77f13d52b186$export$721cf84faff6bf19 = 'color_13';
const $da8a77f13d52b186$export$4b8f8666bd7b61dd = 'color_14';
const $da8a77f13d52b186$export$c537fa0d021d010b = {
    PURPLE: $da8a77f13d52b186$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $da8a77f13d52b186$export$c815fe495e8174a0,
    BLUE: $da8a77f13d52b186$export$738c3b9a44c87ecc,
    DARK_BLUE: $da8a77f13d52b186$export$1225f83626261b80,
    GREEN: $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $da8a77f13d52b186$export$c6f4cf2e5768eb78,
    TEAL: $da8a77f13d52b186$export$d0446fe88325854e,
    DARK_TEAL: $da8a77f13d52b186$export$bb848c92687e69dc,
    YELLOW: $da8a77f13d52b186$export$aab610c505c06a8f,
    DARK_YELLOW: $da8a77f13d52b186$export$466af87757d343a2,
    ORANGE: $da8a77f13d52b186$export$3de5e29ed1757f9b,
    DARK_ORANGE: $da8a77f13d52b186$export$da02e4820b6ab753,
    GREY: $da8a77f13d52b186$export$7d278ca694634874,
    DARK_GREY: $da8a77f13d52b186$export$26453300bfc61cb8
};
const $da8a77f13d52b186$export$d33d39828a18210a = {
    SERVER_PURPLE: $da8a77f13d52b186$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $da8a77f13d52b186$export$588af712afdcb006,
    SERVER_BLUE: $da8a77f13d52b186$export$84c4918645391802,
    SERVER_DARK_BLUE: $da8a77f13d52b186$export$b8f1f5838352a33a,
    SERVER_GREEN: $da8a77f13d52b186$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $da8a77f13d52b186$export$87d3fb8d8656d38b,
    SERVER_TEAL: $da8a77f13d52b186$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $da8a77f13d52b186$export$a89b77a449bd223e,
    SERVER_YELLOW: $da8a77f13d52b186$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $da8a77f13d52b186$export$33253d7862bceb8a,
    SERVER_ORANGE: $da8a77f13d52b186$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $da8a77f13d52b186$export$cd994662b5911917,
    SERVER_GREY: $da8a77f13d52b186$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $da8a77f13d52b186$export$487a6e9145526564
};
const $da8a77f13d52b186$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $da8a77f13d52b186$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $da8a77f13d52b186$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $da8a77f13d52b186$export$94ac87c81ed074a7,
    GHX_LABEL_4: $da8a77f13d52b186$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $da8a77f13d52b186$export$610a2c132b6fcf96,
    GHX_LABEL_6: $da8a77f13d52b186$export$8e4997dba71f1c40,
    GHX_LABEL_7: $da8a77f13d52b186$export$18a545b4e69b27b4,
    GHX_LABEL_8: $da8a77f13d52b186$export$27fff1a0d295292a,
    GHX_LABEL_9: $da8a77f13d52b186$export$e57aa662a56724e1,
    GHX_LABEL_10: $da8a77f13d52b186$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $da8a77f13d52b186$export$457ecb9560f2bf83,
    GHX_LABEL_12: $da8a77f13d52b186$export$a866db37165a696c,
    GHX_LABEL_13: $da8a77f13d52b186$export$9b18447c1168a1b6,
    GHX_LABEL_14: $da8a77f13d52b186$export$93b9ad4020e271b7
};
const $da8a77f13d52b186$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $da8a77f13d52b186$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $da8a77f13d52b186$export$987671fa69482a7b,
    AGILE_COLOR_3: $da8a77f13d52b186$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $da8a77f13d52b186$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $da8a77f13d52b186$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $da8a77f13d52b186$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $da8a77f13d52b186$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $da8a77f13d52b186$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $da8a77f13d52b186$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $da8a77f13d52b186$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $da8a77f13d52b186$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $da8a77f13d52b186$export$da30755a37c3a597,
    AGILE_COLOR_13: $da8a77f13d52b186$export$721cf84faff6bf19,
    AGILE_COLOR_14: $da8a77f13d52b186$export$4b8f8666bd7b61dd
};

});


parcelRegister("iHPnC", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $e626bf77f0e696c5$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $e626bf77f0e696c5$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $e626bf77f0e696c5$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $e626bf77f0e696c5$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $e626bf77f0e696c5$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $e626bf77f0e696c5$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $e626bf77f0e696c5$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $e626bf77f0e696c5$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $e626bf77f0e696c5$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $e626bf77f0e696c5$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $e626bf77f0e696c5$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $e626bf77f0e696c5$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $e626bf77f0e696c5$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $ggSx2 = parcelRequire("ggSx2");

var $heWHN = parcelRequire("heWHN");

var $ehxiD = parcelRequire("ehxiD");

var $kFsv3 = parcelRequire("kFsv3");
const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $kFsv3.Colors).PURPLE;
    if (color in (0, $kFsv3.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $kFsv3.Colors).PURPLE;
};
const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $kFsv3.ServerColors).SERVER_PURPLE;
    if (color in (0, $kFsv3.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $kFsv3.ServerColors).SERVER_PURPLE;
};
const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $kFsv3.Colors).PURPLE];
    if (color in (0, $kFsv3.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $kFsv3.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $kFsv3.Colors).PURPLE];
    if (color in (0, $kFsv3.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $kFsv3.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $heWHN.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $kFsv3.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, $heWHN.MAP_COLORS_TO_VALUE)[color] || (0, $heWHN.MAP_COLORS_TO_VALUE)[0, $kFsv3.PURPLE];
const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $heWHN.MAP_COLORS_TO_VALUE))[value] || (0, $kFsv3.PURPLE);
const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $kFsv3.PURPLE);
const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $kFsv3.PURPLE);
const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $ehxiD.default).purpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).blueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).tealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).yellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).orangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).GREY]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkPurpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkBlueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkTealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkYellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkOrangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_GREY]
        }
    ];
const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, $heWHN.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, $heWHN.DEFAULT_EPIC_COLOR];
const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $kFsv3.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("ehxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b7e3d933c7b9f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});



parcelRegister("inRSh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8f1b6faa7238bb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kkJfY = parcelRequire("kkJfY");

var $bChGW = parcelRequire("bChGW");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $drCen = parcelRequire("drCen");
const $bc8f1b6faa7238bb$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, ...restProps } = props;
    // note: "isDefaultChecked" is used for VR tests only, therefore it is defaulted to false in production
    const isDefaultChecked = props.selectProps?.componentsProps?.isDefaultChecked || false;
    // default to true if showDoneIssuesCheckboxVisible is undefined
    const showDoneIssuesCheckboxVisible = props.selectProps?.componentsProps?.showDoneIssuesCheckboxVisible !== undefined && (0, $4R6GH.fg)('issue_view_in_program_board') ? props.selectProps.componentsProps.showDoneIssuesCheckboxVisible : true;
    const label = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $drCen.default).checkboxLabelIssueTermRefresh : (0, $drCen.default).checkboxLabel);
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Menu, restProps, showDoneIssuesCheckboxVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc8f1b6faa7238bb$var$CheckboxWrapper, {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        defaultChecked: isDefaultChecked,
        onKeyDown: onKeyDown,
        label: label
    })), children);
};
var $bc8f1b6faa7238bb$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bc8f1b6faa7238bb$var$Menu;
const $bc8f1b6faa7238bb$var$CheckboxWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _n7zlpe8f _1e0c1txw _2lx2vrvc _1bah1y6m _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvmg5w _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");


var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $3106eb14f9b0a593$var$checkboxStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $3106eb14f9b0a593$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kag1C.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hsLv2.default), null, label, isRequired && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e62YQ.default), null)));
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5"
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $7b368d644c230660$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $7b368d644c230660$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $7b368d644c230660$var$disabledStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $7b368d644c230660$var$labelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $7b368d644c230660$var$baseStyles,
            label && $7b368d644c230660$var$textLabelLayoutStyles,
            isDisabled && $7b368d644c230660$var$disabledStyles,
            $7b368d644c230660$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce636d67b4ff1120$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $ce636d67b4ff1120$var$labelTextStyles
    }, children);
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $d2156c28a3894cac$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $d2156c28a3894cac$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*"));
}

});


parcelRegister("drCen", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c6a6ed4bb83a84$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $90c6a6ed4bb83a84$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-parent.edit.menu.checkbox-label",
        "defaultMessage": "Show done issues"
    },
    checkboxLabelIssueTermRefresh: {
        "id": "issue-field-parent.edit.menu.checkbox-label-issue-term-refresh",
        "defaultMessage": "Show everything marked as done"
    }
});

});


parcelRegister("3orGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57b6631f3fbd470$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f57b6631f3fbd470$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noMatches: {
        "id": "issue-field-parent.edit.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-parent.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-parent.edit.placeholder",
        "defaultMessage": "Select parent"
    },
    loading: {
        "id": "issue-field-parent.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("1sPJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aae186893156b3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eJbwP = parcelRequire("eJbwP");


var $koVbs = parcelRequire("koVbs");

var $iVcsU = parcelRequire("iVcsU");

var $hVITp = parcelRequire("hVITp");
const $3aae186893156b3c$var$renderOptionDescription = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionDescriptionWrapper, null, option.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$Description, null, option.description) : null);
const $3aae186893156b3c$var$renderIconsKeyAndDoneLabel = (option, doneParentLabel, iconAltMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionColorTypeKeyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IconColorKeyWrapper, null, option?.color ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $iVcsU.getOptionColorElem)(option?.color), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IconWithColor, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$Icon, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IssueKey, null, option.key)), option.isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$DoneWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
        spacing: "spacious",
        color: `var(--ds-text-success, ${(0, $829f609a65d26a98$exports).G500})`,
        label: "done-parent-issue"
    }), doneParentLabel) : null);
const $3aae186893156b3c$var$CustomOption = ({ option: option })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // narrowing type to ParentFieldOption
    if ('fields' in option) {
        const fields = option?.fields;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionLabel, null, $3aae186893156b3c$var$renderIconsKeyAndDoneLabel(option, formatMessage((0, $hVITp.default).doneParentLabel), formatMessage((0, $hVITp.default).icon, {
            issueType: fields?.issuetype.name || ''
        })), option.fields.summary)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionWrapper, null, option.elemBefore != null ? option.elemBefore : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionLabel, null, option.label), $3aae186893156b3c$var$renderOptionDescription(option)));
};
var $3aae186893156b3c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3aae186893156b3c$var$CustomOption;
const $3aae186893156b3c$var$IconWithColor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$IconColorKeyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$DoneWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz1rc1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$IssueKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionColorTypeKeyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _syaz1rc1 _otyr1b66",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionDescriptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _1e0c1txw _2lx2vrvc _4cvr1h6o _19pk1b66",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionTextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _19pkidpf _2hwxu2gc _otyridpf _18u0u2gc _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eJbwP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f201723548e4f57fdc94cbc14d31fc2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
    }, props));
$ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6349e25a79f10f7ca6cae195737423f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});


parcelRegister("hVITp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c6ab058a23c088$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c3c6ab058a23c088$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    icon: {
        "id": "issue-field-parent.edit.option.icon",
        "defaultMessage": "{issueType} icon"
    },
    doneParentLabel: {
        "id": "issue-field-parent.edit.option.done-parent-label",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("6v0ju", function(module, exports) {

$parcel$export(module.exports, "fetchParentsForNew", () => $2703467b5174b086$export$73bed6a0175e413);
$parcel$export(module.exports, "fetchParentsForExisting", () => $2703467b5174b086$export$f995718992ca6c2f);

var $jcw0u = parcelRequire("jcw0u");

var $cWEsa = parcelRequire("cWEsa");

var $cAZGv = parcelRequire("cAZGv");

var $iVcsU = parcelRequire("iVcsU");
const $2703467b5174b086$export$cfeee2ee86ead336 = 'bento';
const $2703467b5174b086$export$73bed6a0175e413 = async (props)=>{
    const { searchTerm: searchTerm, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $cAZGv.fetchParentCandidatesForNewIssue)(cloudId, selectedProjectId, selectedIssueTypeId, searchTerm, excludeDone);
        return {
            options: (0, $iVcsU.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchParentsForNew',
                packageName: 'jiraIssueFieldParent',
                teamName: $2703467b5174b086$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error(error);
    }
};
const $2703467b5174b086$export$f995718992ca6c2f = async (props)=>{
    const { searchTerm: searchTerm, issueKey: issueKey, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $cWEsa.fetchParentCandidatesForExistingIssue)(cloudId, issueKey, searchTerm, excludeDone);
        return {
            options: (0, $iVcsU.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchParentsForExisting',
                packageName: 'jiraIssueFieldParent',
                teamName: $2703467b5174b086$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("cWEsa", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForExistingIssue", () => $96b7190bd204920f$export$59a0f41a1d5dcee0);


var $jJZqs = parcelRequire("jJZqs");

var $d8JF2 = parcelRequire("d8JF2");

var $2t8So = parcelRequire("2t8So");

var $k90nh = parcelRequire("k90nh");

var $1aPWY = parcelRequire("1aPWY");
const $96b7190bd204920f$export$59a0f41a1d5dcee0 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const response = (0, $2t8So.default)(cloudId, issueKey, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $k90nh.default)(new Error(message), (0, $d8JF2.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    if (data.jira.parentCandidatesWithInfoForExistingIssue !== undefined && !data.jira?.parentCandidatesWithInfoForExistingIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $d8JF2.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $d8JF2.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? (0, $1aPWY.transformData)(data.jira.parentCandidatesWithInfoForExistingIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? data.jira.parentCandidatesWithInfoForExistingIssue.message : undefined
    };
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("d8JF2", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO", () => $9b9ac42d3f1a3741$export$c7c7f21787854c5b);
$parcel$export(module.exports, "buildParentCandidatesForExistingIssueQuery", () => $9b9ac42d3f1a3741$export$b64c34b6ba3d6bf5);

var $bItI4 = parcelRequire("bItI4");
const $9b9ac42d3f1a3741$export$c7c7f21787854c5b = 'issueParentCandidatesForExistingIssuesQueryWithInfo';
const $9b9ac42d3f1a3741$export$b64c34b6ba3d6bf5 = ()=>`
    query jira_parenting_${$9b9ac42d3f1a3741$export$c7c7f21787854c5b}($issueKey: String!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $bItI4.parentCandidatesForExistingIssueQuery)()}
    }
`;

});
parcelRegister("bItI4", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForExistingIssueQuery", () => $a63b2f209c365c28$export$f63a6e3151b9dd82);
const $a63b2f209c365c28$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $a63b2f209c365c28$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $a63b2f209c365c28$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $a63b2f209c365c28$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $a63b2f209c365c28$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$a63b2f209c365c28$var$issueType()}
      ${$a63b2f209c365c28$var$summary()}
      ${$a63b2f209c365c28$var$status()}
    }
  }
}`;
const $a63b2f209c365c28$export$f63a6e3151b9dd82 = ()=>`
    jira {
      parentCandidatesWithInfoForExistingIssue(key: $issueKey, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
        parentCandidates {
          edges {
            node {
              issueId
              key
              ${$a63b2f209c365c28$var$color()}
              ${$a63b2f209c365c28$var$fieldsById()}
            }
          }
        }
        message
      }
    }
`;

});


parcelRegister("2t8So", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07071af5f9e15eb$export$2e2bcd8739ae039);

var $d8JF2 = parcelRequire("d8JF2");

var $iBOrg = parcelRequire("iBOrg");
const $b07071af5f9e15eb$export$83bff8b82e36a9e9 = 20;
var /**
 * Returns parent candidates for an existing issue
 *
 * @param cloudId - The cloud ID of the instance
 * @param issueKey - The key of the issue to find parents for e.g SCRUM-1000
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified issue
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$b07071af5f9e15eb$export$2e2bcd8739ae039 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        issueKey: issueKey,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $b07071af5f9e15eb$export$83bff8b82e36a9e9
    };
    const response = await (0, $iBOrg.getClient)('').query({
        query: (0, $d8JF2.buildParentCandidatesForExistingIssueQuery)(),
        variables: variables
    });
    return response;
};

});

parcelRegister("k90nh", function(module, exports) {

$parcel$export(module.exports, "default", () => $602ab0b685964cde$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");
class $602ab0b685964cde$export$2e2bcd8739ae039 extends Error {
    constructor(error, endpoint){
        if (error instanceof $602ab0b685964cde$export$2e2bcd8739ae039) return error;
        super(error.message);
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $jJZqs.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        this.endpoint = endpoint;
    }
}

});

parcelRegister("1aPWY", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9711633f84674efa$export$3ceb62baab058c6b);


var $gULOk = parcelRequire("gULOk");

var $jJZqs = parcelRequire("jJZqs");

var $heWHN = parcelRequire("heWHN");
const $9711633f84674efa$export$3ceb62baab058c6b = (edges)=>edges.map((edge)=>{
        const edgeNode = edge.node;
        const fieldsEdges = edgeNode.fieldsById.edges;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const summaryField = fieldsEdges.find((field)=>field.node.fieldId === 'summary');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issueTypeField = fieldsEdges.find((field)=>field.node.fieldId === 'issuetype');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const statusField = fieldsEdges.find((field)=>field.node.fieldId === 'status');
        const colorField = edgeNode.issueColorField;
        if (summaryField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'summary',
                error: 'Call to gira for parent candidates returned without summary data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        if (issueTypeField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'issueType',
                error: 'Call to gira for parent candidates returned without issue type data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        if (statusField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'status',
                error: 'Call to gira for parent candidates returned without status data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        if (// only issues at level 1 are expected to have a hierarchy level (i.e Epics)
        issueTypeField.node.issueType?.hierarchy?.level === 1 && colorField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'Issue Color',
                error: 'Call to gira for parent candidates returned without color data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        const summaryFieldNode = summaryField.node;
        const issueTypeFieldNode = issueTypeField.node;
        const checkParentIssueIsDone = (statusCategoryId)=>{
            const doneStatusCategoryId = (0, $gULOk).StatusCategoryIds[(0, $gULOk).StatusCategoryTypes.DONE];
            return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
        };
        const isDone = checkParentIssueIsDone(statusField.node.status.statusCategory.statusCategoryId);
        const statusCategoryId = statusField?.node.status.statusCategory.statusCategoryId;
        const parent = {
            id: edgeNode.issueId,
            key: edgeNode.key,
            summary: summaryFieldNode.text,
            issueType: {
                id: String(issueTypeFieldNode.issueType.issueTypeId),
                name: issueTypeFieldNode.issueType.name,
                iconUrl: issueTypeFieldNode.issueType.avatar.xsmall
            },
            isDone: isDone,
            statusCategoryId: statusCategoryId
        };
        // todo: write a test for issueColor undefined
        return {
            ...parent,
            color: colorField?.color?.colorKey ? (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorField.color.colorKey] : undefined
        };
    });

});


parcelRegister("cAZGv", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForNewIssue", () => $e563dea4a8edeb6a$export$48a29a1313179c04);


var $jJZqs = parcelRequire("jJZqs");

var $78P89 = parcelRequire("78P89");

var $iveGN = parcelRequire("iveGN");

var $k90nh = parcelRequire("k90nh");

var $1aPWY = parcelRequire("1aPWY");
const $e563dea4a8edeb6a$export$48a29a1313179c04 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const response = (0, $iveGN.default)(cloudId, projectId, issueTypeId, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $k90nh.default)(new Error(message), (0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    if (!data.jira?.parentCandidatesWithInfoForNewIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? (0, $1aPWY.transformData)(data.jira.parentCandidatesWithInfoForNewIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? data.jira.parentCandidatesWithInfoForNewIssue.message : undefined
    };
};

});
parcelRegister("78P89", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO", () => $cf42cbd052db3ab7$export$26f006aaa0389bc0);
$parcel$export(module.exports, "buildParentCandidatesForNewIssueQuery", () => $cf42cbd052db3ab7$export$453f3d2e0fac3592);

var $eVi6b = parcelRequire("eVi6b");
const $cf42cbd052db3ab7$export$26f006aaa0389bc0 = 'issueParentCandidatesForNewIssuesQueryWithInfo';
const $cf42cbd052db3ab7$export$453f3d2e0fac3592 = ()=>`
    query jira_parenting_${$cf42cbd052db3ab7$export$26f006aaa0389bc0}($projectId: ID!, $issueTypeId: ID!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $eVi6b.parentCandidatesForNewIssueQuery)()}
    }
`;

});
parcelRegister("eVi6b", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForNewIssueQuery", () => $5f9b4891c9749af5$export$1dfd5c8a625d5960);
const $5f9b4891c9749af5$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $5f9b4891c9749af5$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $5f9b4891c9749af5$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $5f9b4891c9749af5$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $5f9b4891c9749af5$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$5f9b4891c9749af5$var$issueType()}
      ${$5f9b4891c9749af5$var$summary()}
      ${$5f9b4891c9749af5$var$status()}
    }
  }
}`;
const $5f9b4891c9749af5$export$1dfd5c8a625d5960 = ()=>`
    jira {
        parentCandidatesWithInfoForNewIssue(projectId: $projectId, issueTypeId: $issueTypeId, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          parentCandidates {
            edges {
              node {
                issueId
                key
                ${$5f9b4891c9749af5$var$color()}
                ${$5f9b4891c9749af5$var$fieldsById()}
              }
            }
          }
          message
        }
      }
`;

});


parcelRegister("iveGN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9969b12a843159$export$2e2bcd8739ae039);

var $78P89 = parcelRequire("78P89");

var $iBOrg = parcelRequire("iBOrg");
const $4b9969b12a843159$export$1fd3b40492f4ef9f = 20;
var /**
 * Returns parent candidates for a new issue (e.g one that is about to be created)
 *
 * @param cloudId - The cloud ID of the instance
 * @param projectId - The ID of the project in which the issue will be created
 * @param issueTypeId - The issue type of the project to be created
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified project and issue type
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b9969b12a843159$export$2e2bcd8739ae039 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        projectId: projectId,
        issueTypeId: issueTypeId,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $4b9969b12a843159$export$1fd3b40492f4ef9f
    };
    const response = await (0, $iBOrg.getClient)('').query({
        query: (0, $78P89.buildParentCandidatesForNewIssueQuery)(),
        variables: variables,
        operationName: `jira_parenting_${(0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO)}`
    });
    return response;
};

});




parcelRegister("bA6nL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b53543067399a8c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b53543067399a8c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        "id": "issue-create-commons.parent-field.description",
        "defaultMessage": "Your issue type hierarchy determines the issues you can select here."
    },
    descriptionIssueTermRefresh: {
        "id": "issue-create-commons.parent-field.description-issue-term-refresh",
        "defaultMessage": "Your work type hierarchy determines the work items you can select here."
    }
});

});

parcelRegister("eulr6", function(module, exports) {

$parcel$export(module.exports, "transformDefaultParentValue", () => $ca97e2610eb77570$export$f38bec4d01c88544);
$parcel$export(module.exports, "validateParentField", () => $ca97e2610eb77570$export$656803053e0b9113);
$parcel$export(module.exports, "mutateParentField", () => $ca97e2610eb77570$export$15ec054c85ac7db1);

var $bGrWH = parcelRequire("bGrWH");

var $heWHN = parcelRequire("heWHN");
const $ca97e2610eb77570$export$f38bec4d01c88544 = (defaultValue)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const summaryField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraSingleLineTextField');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraIssueType');
    const { key: key, issueId: issueId, issueColorField: issueColorField } = defaultValue;
    const summary = summaryField?.node.text;
    const label = `${key} ${summary}`;
    return {
        label: label,
        value: issueId,
        key: key,
        color: issueColorField && issueColorField.color !== null ? (0, $heWHN.MAP_FROM_SERVER_COLOR)[issueColorField.color] : undefined,
        fields: {
            summary: summary,
            issuetype: {
                name: issueTypeField?.node.issueType.name,
                iconUrl: issueTypeField?.node.issueType.avatar.xsmall
            }
        }
    };
};
const $ca97e2610eb77570$export$656803053e0b9113 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $ca97e2610eb77570$export$15ec054c85ac7db1 = ({ value: value })=>({
        parentField: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueId: value
        }
    });

});



parcelRegister("eRVlU", function(module, exports) {

$parcel$export(module.exports, "PeopleCustomFieldType", () => $f83100d884a853ed$export$531787d3fa23885);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $gARR3 = parcelRequire("gARR3");

var $lfWSN = parcelRequire("lfWSN");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $f83100d884a853ed$var$PeopleCustomFieldTypeComponent = (props)=>{
    if (props.schemaConfiguration.isMulti) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gARR3.default), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfWSN.default), props);
};
const $f83100d884a853ed$export$531787d3fa23885 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
    type: (0, $5fc53.PEOPLE_CF_TYPE),
    Component: $f83100d884a853ed$var$PeopleCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.AssigneeFieldPlaceholder), null),
    writer: (id, value, fields)=>Array.isArray(value) ? (0, $kShoa.multiUserPickerFieldWriter)(id, value, fields) : (0, $kShoa.singleUserPickerFieldWriter)(id, value, fields)
};

});
parcelRegister("lfWSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dbbb313a8b6153d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lzCWA = parcelRequire("lzCWA");
const $8dbbb313a8b6153d$var$SingleUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lzCWA.default), {
        ...props,
        isMulti: false,
        context: "CustomUserField"
    });
var $8dbbb313a8b6153d$export$2e2bcd8739ae039 = $8dbbb313a8b6153d$var$SingleUserPickerField;

});


parcelRegister("cK31e", function(module, exports) {

$parcel$export(module.exports, "PriorityFieldTypeConfig", () => $73ea0385fc1a41bb$export$63f81e33b9847d28);

var $5uXOq = parcelRequire("5uXOq");

var $p8UKh = parcelRequire("p8UKh");

var $2QZDj = parcelRequire("2QZDj");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $73ea0385fc1a41bb$var$PriorityFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2QZDj.default), props);
const $73ea0385fc1a41bb$export$63f81e33b9847d28 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($p8UKh))),
    type: (0, $5fc53.PRIORITY_TYPE),
    Component: $73ea0385fc1a41bb$var$PriorityFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.priorityFieldWriter)
};

});
parcelRegister("p8UKh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a090d0ee8aafb332949c574dcd34241>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04b94019459ee8f9$var$_react = $04b94019459ee8f9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $04b94019459ee8f9$var$_baseNew = $04b94019459ee8f9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $04b94019459ee8f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PriorityHighest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for highest issue priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04b94019459ee8f9$var$PriorityHighestIcon = (props)=>/*#__PURE__*/ $04b94019459ee8f9$var$_react.default.createElement($04b94019459ee8f9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 11.875 8 8.25l5.5 3.625m-11-4.5L8 3.75l5.5 3.625"/>`
    }, props));
$04b94019459ee8f9$var$PriorityHighestIcon.displayName = 'PriorityHighestIcon';
var $04b94019459ee8f9$var$_default = module.exports.default = $04b94019459ee8f9$var$PriorityHighestIcon;

});

parcelRegister("2QZDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29a3848e499878f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4qOqP = parcelRequire("4qOqP");

var $4IxfP = parcelRequire("4IxfP");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $hnBts = parcelRequire("hnBts");

const $b29a3848e499878f$var$PriorityField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, ariaLabelledBy: ariaLabelledBy } = props;
    const options = (0, $4IxfP.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4qOqP.default), {
        options: options,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired,
        ariaLabelledBy: ariaLabelledBy
    }));
};
var $b29a3848e499878f$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validatePriorityField),
    transformDefaultValue: $hnBts.transformDefaultValue
})($b29a3848e499878f$var$PriorityField);

});
parcelRegister("4qOqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $00acd3f7bdd60a4f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $9UhzQ = parcelRequire("9UhzQ");

var $lElIo = parcelRequire("lElIo");
const $00acd3f7bdd60a4f$var$PriorityEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        inputId: inputId,
        required: isRequired,
        value: value,
        options: options,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '(arg1: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        formatOptionLabel: (0, $9UhzQ.formatOptionLabel),
        isClearable: false,
        hideSelectedOptions: true,
        closeMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isDisabled,
        classNamePrefix: classNamePrefix,
        openMenuOnFocus: openMenuOnFocus,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $00acd3f7bdd60a4f$export$2e2bcd8739ae039 = $00acd3f7bdd60a4f$var$PriorityEdit;

});
parcelRegister("9UhzQ", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", () => $7c6c645af44efe7b$export$322216d90ffb8d0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");
const $7c6c645af44efe7b$export$b4053b30a2d3983b = (props)=>{
    const { option: { label: label, iconUrl: iconUrl, description: description }, optionContext: optionContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$FlexRow, null, Boolean(iconUrl) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        src: iconUrl,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$FlexColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "issue-field-select-base.ui.format-option-label.c-label"
    }, label), optionContext === 'menu' && Boolean(description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$Description, null, description)));
};
const $7c6c645af44efe7b$export$322216d90ffb8d0e = (option, { context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$export$b4053b30a2d3983b, {
        option: option,
        optionContext: context
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c6c645af44efe7b$var$FlexRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $7c6c645af44efe7b$var$FlexColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $7c6c645af44efe7b$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $7c6c645af44efe7b$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81vlj _syaz1rc1",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hnBts", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $f6b5541ab69f5e0c$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutatePriorityField", () => $f6b5541ab69f5e0c$export$2c46dd13be598543);
const $f6b5541ab69f5e0c$export$e2f4e5d31db527cc = ({ id: id, name: name, iconUrl: iconUrl })=>({
        label: name,
        value: id,
        iconUrl: iconUrl
    });
const $f6b5541ab69f5e0c$export$2c46dd13be598543 = ({ value: value })=>({
        priority: {
            priorityId: value
        }
    });

});



parcelRegister("9HQd3", function(module, exports) {

$parcel$export(module.exports, "RadioButtonsCustomFieldTypeConfig", () => $238501c66641cf61$export$2483417b1f9a587c);

var $5uXOq = parcelRequire("5uXOq");

var $4iV1e = parcelRequire("4iV1e");

var $evAhI = parcelRequire("evAhI");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $238501c66641cf61$var$RadioButtonsCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evAhI.default), props);
const $238501c66641cf61$export$2483417b1f9a587c = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))),
    type: (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
    Component: $238501c66641cf61$var$RadioButtonsCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.radioSelectFieldWriter)
};

});
parcelRegister("evAhI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa82702cc29d68e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $g2wOz = parcelRequire("g2wOz");

var $aSk8p = parcelRequire("aSk8p");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $glFZG = parcelRequire("glFZG");
const $dfa82702cc29d68e$var$RadioSelectField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled = false }, isReadOnly: isReadOnly = false, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const options = (0, $aSk8p.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2wOz.default), {
        options: options,
        isDisabled: isReadOnly || isDisabled,
        value: value,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onChange: onChange,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        ariaLabelledBy: ariaLabelledBy
    }));
};
var $dfa82702cc29d68e$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateRadioSelectField),
    transformDefaultValue: $glFZG.transformDefaultValue
})($dfa82702cc29d68e$var$RadioSelectField);

});
parcelRegister("g2wOz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1767240ecaf9413$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jE4Xj = parcelRequire("jE4Xj");

var $lElIo = parcelRequire("lElIo");
const $c1767240ecaf9413$var$RadioSelectEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', isDisabled: isDisabled = false, autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, isClearable: isClearable = true, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jE4Xj.default), {
        classNamePrefix: classNamePrefix,
        value: value,
        options: options,
        isDisabled: isDisabled,
        placeholder: placeholder,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '(arg1: Option) => void' is not assignable to type '(value: OptionType | null, action: ActionMeta<OptionType>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        closeMenuOnScroll: onCloseMenuOnScroll,
        onBlur: onBlur,
        autoFocus: autoFocus,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        isClearable: isClearable,
        openMenuOnFocus: openMenuOnFocus,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $c1767240ecaf9413$export$2e2bcd8739ae039 = $c1767240ecaf9413$var$RadioSelectEdit;

});
parcelRegister("jE4Xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c1de6c1d3b6d34f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $itpgN = parcelRequire("itpgN");
const $1c1de6c1d3b6d34f$var$RadioSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ components: components, ...props })=>{
    const mergedComponents = (0, $5uXOq.useMemo)(()=>({
            ...components,
            Option: (0, $itpgN.RadioOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...props,
        isMulti: false,
        components: mergedComponents
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c1de6c1d3b6d34f$export$2e2bcd8739ae039 = $1c1de6c1d3b6d34f$var$RadioSelect;

});


parcelRegister("glFZG", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $bab8deb286f07f08$export$e2f4e5d31db527cc);
const $bab8deb286f07f08$export$e2f4e5d31db527cc = ({ id: id, value: value })=>({
        label: value,
        value: id
    });

});



parcelRegister("7lpSO", function(module, exports) {

$parcel$export(module.exports, "SelectCustomFieldTypeConfig", () => $a425e0c10378516d$export$8ed2c57b191fc5f5);

var $5uXOq = parcelRequire("5uXOq");

var $kqDoy = parcelRequire("kqDoy");

var $k4tyx = parcelRequire("k4tyx");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $a425e0c10378516d$var$SelectCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4tyx.default), {
        ...props,
        defaultValue: undefined
    });
const $a425e0c10378516d$export$8ed2c57b191fc5f5 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kqDoy))),
    type: (0, $5fc53.SELECT_CF_TYPE),
    Component: $a425e0c10378516d$var$SelectCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.selectFieldWriter)
};

});

parcelRegister("chk7J", function(module, exports) {

$parcel$export(module.exports, "SprintFieldTypeConfig", () => $7cbcc31fd938100a$export$da0c478aebabb75b);

var $5uXOq = parcelRequire("5uXOq");

var $8mG85 = parcelRequire("8mG85");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $3Xb7y = parcelRequire("3Xb7y");

var $kShoa = parcelRequire("kShoa");
const $7cbcc31fd938100a$var$SprintFieldTypeComponent = (props)=>{
    const { projectKey: projectKey, canUserViewProject: canUserViewProject } = props;
    if (!projectKey || !canUserViewProject) return null;
    // This is the same URL as the default for `SprintField` - the only difference here is we
    // want to hardcode the options list to only show sprints from parent project instead of showing
    // sprints across all projects visible to the user
    const autoCompleteUrl = `/rest/greenhopper/1.0/sprint/picker?projectKey=${projectKey}&query=`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Xb7y.default), {
        ...props,
        autoCompleteUrl: autoCompleteUrl
    });
};
const $7cbcc31fd938100a$export$da0c478aebabb75b = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8mG85))),
    type: (0, $5fc53.SELECT_CF_TYPE),
    Component: $7cbcc31fd938100a$var$SprintFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.selectFieldWriter)
};

});
parcelRegister("3Xb7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $50063478b6346348$export$2e2bcd8739ae039);

var $hpV4g = parcelRequire("hpV4g");

var $3pqs3 = parcelRequire("3pqs3");

var $aqMtW = parcelRequire("aqMtW");

var $6iZh4 = parcelRequire("6iZh4");
var $50063478b6346348$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aqMtW.transformDefaultSprintValue),
    validator: (0, $6iZh4.validateRequired),
    shouldRenderFieldMessage: false
})((0, $3pqs3.SprintField));

});
parcelRegister("3pqs3", function(module, exports) {

$parcel$export(module.exports, "SprintField", () => $83fe5b61920278eb$export$617303ef516d5a01);
$parcel$export(module.exports, "default", () => $83fe5b61920278eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $io7kF = parcelRequire("io7kF");

var $3spCR = parcelRequire("3spCR");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $ahEu3 = parcelRequire("ahEu3");

var $aqMtW = parcelRequire("aqMtW");

const $83fe5b61920278eb$export$617303ef516d5a01 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { width: width, autoCompleteUrl: autoCompleteUrl = '/rest/greenhopper/1.0/sprint/picker?query=', fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, selectedProject: selectedProject, error: error, fieldId: fieldId, autoFocus: autoFocus = false, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isMini: isMini } = props;
    const renderSprintEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $io7kF.default), {
            fieldId: fieldId,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            fetchSuggestionsOnMount: false,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isEditable === false,
            getSuggestions: (0, $aqMtW.getSprintSuggestions),
            ...selectedProject?.projectKey ? {
                projectKey: selectedProject?.projectKey
            } : {},
            inputId: id,
            isRequired: isRequired
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, renderSprintEdit()) : renderSprintEdit(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }), value && value.state === (0, $3spCR.ACTIVE_SPRINT_STATE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $83fe5b61920278eb$var$messageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning",
        testId: "issue-create-commons.ui.sprint-field.required-fields-message"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ahEu3.default).activeSprintSelectionWarningMessageIssueTermRefresh : (0, $ahEu3.default).activeSprintSelectionWarningMessage))) : null);
};
var $83fe5b61920278eb$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aqMtW.transformDefaultSprintValue),
    shouldRenderFieldMessage: false
})($83fe5b61920278eb$export$617303ef516d5a01);
const $83fe5b61920278eb$var$messageContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("io7kF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42898dffd6db898$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6Vzc4 = parcelRequire("6Vzc4");

var $3BhEA = parcelRequire("3BhEA");

var $9UhzQ = parcelRequire("9UhzQ");

var $lElIo = parcelRequire("lElIo");

var $gcvId = parcelRequire("gcvId");

var $5fc53 = parcelRequire("5fc53");

var $249dD = parcelRequire("249dD");

var $bW9R0 = parcelRequire("bW9R0");

var $egtXp = parcelRequire("egtXp");

var $gxJKL = parcelRequire("gxJKL");

var $ckVH2 = parcelRequire("ckVH2");
const $e42898dffd6db898$export$251bdbdbce9550ea = 300;
const $e42898dffd6db898$var$SprintEdit = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, projectKey: projectKey, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, useTransformSuggestions: useTransformSuggestions, onPostTransformSuggestions: onPostTransformSuggestions, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $5fc53.SPRINT_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus, 'aria-labelledby': ariaLabelledBy } = props;
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
    const lastQuery = (0, $5uXOq.useRef)('');
    const [restrictSprints, setRestrictSprint] = (0, $5uXOq.useState)((0, $egtXp.getCheckboxValueFromLocalStorage)((0, $egtXp.EDIT_SPRINT_CHECKBOX_CACHE_KEY)));
    const isInitialMount = (0, $5uXOq.useRef)(true);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getSprintSuggestions: getSprintSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $bW9R0.useSprintSuggestions)({
        getSuggestions: getSuggestions
    });
    const onCheckboxClick = (0, $5uXOq.useCallback)(()=>{
        setRestrictSprint(!restrictSprints);
        (0, $egtXp.setCheckBoxValueInLocalStorage)((0, $egtXp.EDIT_SPRINT_CHECKBOX_CACHE_KEY), !restrictSprints);
    }, [
        restrictSprints
    ]);
    const componentProps = (0, $5uXOq.useMemo)(()=>({
            isChecked: restrictSprints,
            onChange: onCheckboxClick,
            projectKey: projectKey
        }), [
        restrictSprints,
        projectKey,
        onCheckboxClick
    ]);
    const handleSuggestions = (0, $5uXOq.useCallback)((results, query)=>{
        if (lastQuery.current === query) {
            const transformSuggestions = useTransformSuggestions || (0, $249dD.transformSuggestions);
            const response = transformSuggestions(results, formatMessage);
            if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
            setSuggestions(response);
            if (query === '') setDefaultSuggestions(response);
        }
    }, [
        formatMessage,
        useTransformSuggestions,
        onPostTransformSuggestions
    ]);
    const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.FailedFetchOptionWrapper), null, formatMessage((0, $ckVH2.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
        try {
            let response;
            if (restrictSprints && projectKey) response = await getSprintSuggestions(autoCompleteUrl, query, projectKey);
            else response = await getSprintSuggestions(autoCompleteUrl, query);
            handleSuggestions(response, query);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setHasLastFetchFailed(true);
            const failedOption = [
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ];
            setSuggestions(failedOption);
        }
    }, [
        autoCompleteUrl,
        restrictSprints,
        projectKey,
        getFailedFetchMessage,
        getSprintSuggestions,
        handleSuggestions
    ]);
    if ((0, $4R6GH.fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(fetchSuggestions, $e42898dffd6db898$export$251bdbdbce9550ea), [
        restrictSprints
    ]);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $ckVH2.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $ckVH2.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $5uXOq.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $3BhEA.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
        if (!suggestions) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        onFocus && onFocus(e);
    }, [
        fetchSuggestions,
        onFocus,
        setIsLoadingSuggestions,
        suggestions
    ]);
    const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const onValueChange = (0, $5uXOq.useCallback)((newValues)=>{
        // We're passing in suggestions for validation
        // e.g., if selected sprint is active and will affect the issue
        onChange && onChange(newValues, suggestions);
    }, [
        onChange,
        suggestions
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    // Fetch the suggestions again if user toggles the checkbox
    (0, $5uXOq.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        restrictSprints,
        debouncedFetchSuggestions,
        setIsLoadingSuggestions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcvId.default), {
        inputId: inputId,
        isRequired: isRequired,
        isClearable: true,
        hideSelectedOptions: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: suggestions,
        value: value,
        onBlur: onSelectBlur,
        menuPosition: menuPosition,
        componentsProps: projectKey ? componentProps : undefined,
        components: projectKey ? {
            Menu: $gxJKL.default
        } : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $ckVH2.default).placeholder),
        onInputChange: onQueryChange,
        onChange: onValueChange,
        spacing: spacing,
        isLoading: isLoadingSuggestions,
        filterOption: filterOption,
        formatOptionLabel: (0, $9UhzQ.formatOptionLabel),
        validationState: isInvalid === true ? 'error' : null,
        isDisabled: isDisabled,
        openMenuOnFocus: openMenuOnFocus,
        "aria-labelledby": ariaLabelledBy
    });
};
var $e42898dffd6db898$export$2e2bcd8739ae039 = $e42898dffd6db898$var$SprintEdit;

});
parcelRegister("gcvId", function(module, exports) {

$parcel$export(module.exports, "default", () => $2132d0cd1f409256$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $7Jxgt = parcelRequire("7Jxgt");

var $iOwNT = parcelRequire("iOwNT");

var $6RCeq = parcelRequire("6RCeq");

var $koVbs = parcelRequire("koVbs");

var $db8jg = parcelRequire("db8jg");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8z9w3 = parcelRequire("8z9w3");

var $dKKqb = parcelRequire("dKKqb");
const $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $2132d0cd1f409256$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $2132d0cd1f409256$export$53574ab050410077 = (0, $2OMDV.AnalyticsEventToProps)('select', $2132d0cd1f409256$var$analyticsProps)((0, $iOwNT.default));
const $2132d0cd1f409256$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options = [], value: value, sessionId: customSessionId, canCreateNewItem: canCreateNewItem = false, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel = '' } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasSessionStarted = (0, $5uXOq.useRef)(false);
    const sessionId = (0, $5uXOq.useRef)(customSessionId);
    const sessionStartedAt = (0, $5uXOq.useRef)(0);
    const endSessionRef = (0, $5uXOq.useRef)(undefined);
    const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
    const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const flatOptions = (0, $5uXOq.useMemo)(()=>(0, $dKKqb.flattenOptions)(options), [
        options
    ]);
    const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) ? value : [];
        let filteredOptions = (0, $dKKqb.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $dKKqb.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            optionsLength: optionsLength,
            componentName: 'select',
            // TODO: update the lib's version after the bump
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $dKKqb.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $db8jg.memoizedHashString)(query),
            selectedOptions: (0, $dKKqb.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $dKKqb.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading
    ]);
    const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startSession = (0, $5uXOq.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, $7Jxgt.v4)();
        sessionStartedAt.current = (0, $6RCeq.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $5uXOq.useCallback)(()=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt === 0 ? (0, $6RCeq.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $5uXOq.useCallback)(()=>{
        endSession();
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $dKKqb.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $dKKqb.getSafeValue)(option.value) : undefined
        });
    }, [
        fireUIAnalyticsEvent,
        savedQuery
    ]);
    const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $dKKqb.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        onChange && onChange(selectedOptionOrOptions, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange
    ]);
    const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange && onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    const isValidNewOption = (0, $5uXOq.useCallback)(()=>!!canCreateNewItem, [
        canCreateNewItem
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasSessionStarted.current) {
            startSession();
            fireInputChangedEvent('', {
                action: 'fake-action'
            }, createAnalyticsEvent({}));
            hasSessionStarted.current = true;
        }
    }, [
        createAnalyticsEvent,
        fireInputChangedEvent,
        startSession
    ]);
    (0, $5uXOq.useEffect)(()=>{
        endSessionRef.current = endSession;
    }, [
        endSession
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            endSessionRef.current && endSessionRef.current();
        }, // In order to avoid triggering this cleanup when the endSession callback is updated by adding a dependency to endSession here,
    // we call it via a ref instead
    []);
    const { isRequired: required, ...propsWithoutRequired } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2132d0cd1f409256$export$53574ab050410077, {
        ...propsWithoutRequired,
        required: isRequired,
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics,
        isValidNewOption: isValidNewOption,
        label: ariaLabel || formatMessage((0, $8z9w3.default).ariaLabelForSelect)
    });
};
var $2132d0cd1f409256$export$2e2bcd8739ae039 = $2132d0cd1f409256$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("8z9w3", function(module, exports) {

$parcel$export(module.exports, "default", () => $283d0de21cddfa94$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $283d0de21cddfa94$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabelForSelect: {
        "id": "issue-field-select-with-analytics.ariaLabel",
        "defaultMessage": "Select Field"
    }
});

});

parcelRegister("dKKqb", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $52dde5a2f186bbcb$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $52dde5a2f186bbcb$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $52dde5a2f186bbcb$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $52dde5a2f186bbcb$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $52dde5a2f186bbcb$export$60d56ed3961c839c);

var $chc6P = parcelRequire("chc6P");

var $db8jg = parcelRequire("db8jg");
const $52dde5a2f186bbcb$export$d05672fd1312a6d = (val)=>(0, $db8jg.memoizedHashString)(val.toString()).toString();
const $52dde5a2f186bbcb$export$fde3d804891b8254 = (items)=>{
    const itemsToFilter = Array.isArray(items) ? items : [
        items
    ];
    return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>$52dde5a2f186bbcb$export$d05672fd1312a6d(value));
};
const $52dde5a2f186bbcb$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(optionGroups.map((optionOrGroup)=>optionOrGroup.options ? optionOrGroup.options : [
            optionOrGroup
        ]));
const $52dde5a2f186bbcb$export$e2e167245697ed4e = (items)=>{
    const itemsToFilter = Array.isArray(items) ? items : [
        items
    ];
    return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
};
const $52dde5a2f186bbcb$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});


parcelRegister("249dD", function(module, exports) {

$parcel$export(module.exports, "hasState", () => $cfadc135289d0d3a$export$d2fec4e2fc5f065a);
$parcel$export(module.exports, "findSprintWithState", () => $cfadc135289d0d3a$export$fb6b70a9c996212b);
$parcel$export(module.exports, "mapSprintOptionToData", () => $cfadc135289d0d3a$export$fb7a6b38a05bd2b7);
$parcel$export(module.exports, "transformSuggestions", () => $cfadc135289d0d3a$export$1d0ee4320c26fb60);

var $3spCR = parcelRequire("3spCR");

var $e7pk8 = parcelRequire("e7pk8");
const $cfadc135289d0d3a$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $cfadc135289d0d3a$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
const $cfadc135289d0d3a$export$fb6b70a9c996212b = (sprints, state)=>{
    if (!sprints) return undefined;
    return sprints.find($cfadc135289d0d3a$export$d2fec4e2fc5f065a(state));
};
const $cfadc135289d0d3a$export$d63c3784bf3852ca = (state)=>{
    if (state !== undefined) {
        const stateKey = state.toUpperCase();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly ACTIVE: "ACTIVE"; readonly CLOSED: "CLOSED"; readonly FUTURE: "FUTURE"; }'.
        return (0, $3spCR.SPRINT_STATES)[stateKey];
    }
    return undefined;
};
const $cfadc135289d0d3a$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
const $cfadc135289d0d3a$export$fbb2e1641ffac377 = (option)=>({
        id: Number(option.value),
        name: String(option.label),
        state: option.state,
        // mapSprintValueToOption ensures there will always be a boardId
        boardId: Number(option.data?.boardId) || 0
    });
const $cfadc135289d0d3a$export$b9928e57702db7d9 = (items)=>items.map($cfadc135289d0d3a$export$fbb2e1641ffac377);
const $cfadc135289d0d3a$export$cbdf60de7f2200e7 = (option)=>({
        id: Number(option.value),
        boardName: option.description,
        name: String(option.label),
        // mapSprintSuggestionToOption ensures there will always be a state
        // @ts-expect-error - TS2322 - Type 'SprintState | undefined' is not assignable to type 'SprintState'.
        stateKey: $cfadc135289d0d3a$export$d63c3784bf3852ca(option.state),
        // mapSprintSuggestionToOption ensures there will always be a date
        date: String(option.data?.date)
    });
const $cfadc135289d0d3a$export$db10bf437c75c497 = (items)=>items.map($cfadc135289d0d3a$export$cbdf60de7f2200e7);
const $cfadc135289d0d3a$export$15c97379ebef6b30 = (sprint)=>({
        id: sprint.id,
        description: sprint.boardName,
        label: sprint.name,
        state: sprint.stateKey,
        value: sprint.id,
        data: {
            date: sprint.date,
            fromCache: sprint.fromCache
        }
    });
const $cfadc135289d0d3a$export$c1cb9e6f1beaee0d = (items)=>items.map($cfadc135289d0d3a$export$15c97379ebef6b30);
const $cfadc135289d0d3a$export$ce3013ece3dbf252 = (sprint)=>({
        id: sprint.id,
        name: sprint.name,
        href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
        endDate: sprint.endDate || ''
    });
const $cfadc135289d0d3a$export$755a6a3c6172f7e = (sprint)=>({
        label: sprint.name,
        value: sprint.id,
        href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
        state: $cfadc135289d0d3a$export$d63c3784bf3852ca(sprint.state),
        data: {
            boardId: sprint.boardId,
            date: sprint.startDate
        }
    });
const $cfadc135289d0d3a$export$cbcaba92baa2e404 = (items)=>items.map($cfadc135289d0d3a$export$755a6a3c6172f7e);
const $cfadc135289d0d3a$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
    const serverSuggestions = suggestionsFromServer.suggestions || [];
    const allMatches = suggestionsFromServer.allMatches || [];
    const allItems = serverSuggestions.concat(allMatches);
    const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, $3spCR.ACTIVE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, $3spCR.FUTURE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const sprints = [
        {
            label: formatMessage((0, $e7pk8.default).activeSprints),
            options: activeItems
        },
        {
            label: formatMessage((0, $e7pk8.default).futureSprints),
            options: futureItems
        }
    ];
    return sprints;
};

});
parcelRegister("3spCR", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $113c1ed08a0bda4f$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $113c1ed08a0bda4f$export$73a0206a4dc59760);
const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
    ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
    CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
    FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
};

});

parcelRegister("e7pk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f3d56beb10e0cde$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f3d56beb10e0cde$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activeSprints: {
        "id": "issue-field-sprint.common.active-sprints",
        "defaultMessage": "Active"
    },
    futureSprints: {
        "id": "issue-field-sprint.common.future-sprints",
        "defaultMessage": "Future"
    },
    recentSprints: {
        "id": "issue-field-sprint.common.recent-sprints",
        "defaultMessage": "Recent sprints"
    }
});

});


parcelRegister("bW9R0", function(module, exports) {

$parcel$export(module.exports, "useSprintSuggestions", () => $76a69867a9473261$export$16d0ab78a0b529dc);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $eusud = parcelRequire("eusud");

const $76a69867a9473261$var$defaultParams = (0, $ebyGx.stringify)({
    maxActiveSprints: (0, $546eebefed97ea78$export$7112c73100e3ee45),
    maxResults: (0, $546eebefed97ea78$export$f6b2881bc1090cea)
});
const $76a69867a9473261$export$6945d45e210d19eb = async (autoCompleteUrl, query, projectKey)=>{
    let queryString;
    if (projectKey !== null && projectKey !== undefined) queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&projectKey=${encodeURIComponent(projectKey)}&${$76a69867a9473261$var$defaultParams}`;
    else queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&${$76a69867a9473261$var$defaultParams}`;
    return (0, $eusud.performGetRequest)(queryString);
};
const $76a69867a9473261$export$16d0ab78a0b529dc = (props)=>{
    const { getSuggestions: getSuggestions = $76a69867a9473261$export$6945d45e210d19eb } = props || {};
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
    const getSprintSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, projectKey)=>{
        try {
            const response = await getSuggestions(autoCompleteUrl, query, projectKey);
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>({
            getSprintSuggestions: getSprintSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getSprintSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
const $546eebefed97ea78$export$f27038d72181627e = '/rest/greenhopper/1.0/sprint/picker?query=';
const $546eebefed97ea78$export$7112c73100e3ee45 = 5;
const $546eebefed97ea78$export$f6b2881bc1090cea = 10;


parcelRegister("egtXp", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_CHECKBOX_CACHE_KEY", () => $da54a1ad644b3ed6$export$90fd8fcc9388370d);
$parcel$export(module.exports, "getCheckboxValueFromLocalStorage", () => $da54a1ad644b3ed6$export$b6ec857d138d143b);
$parcel$export(module.exports, "setCheckBoxValueInLocalStorage", () => $da54a1ad644b3ed6$export$1750bf12ee05e0ac);

var $ebyGx = parcelRequire("ebyGx");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $da54a1ad644b3ed6$var$getViewMode = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(window.location.search).view || '';
const $da54a1ad644b3ed6$export$d5e150c1e3186bd1 = ()=>$da54a1ad644b3ed6$var$getViewMode().includes('planning');
const $da54a1ad644b3ed6$export$90fd8fcc9388370d = 'edit_sprint_cache_value';
const $da54a1ad644b3ed6$export$b6ec857d138d143b = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const value = window.localStorage?.getItem(key);
    return value ? JSON.parse(value) : true;
};
const $da54a1ad644b3ed6$export$1750bf12ee05e0ac = (key, value)=>{
    try {
        // @ts-expect-error - TS2345 - Argument of type 'boolean' is not assignable to parameter of type 'string'.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.localStorage.setItem(key, value);
    } catch  {
    // do nothing
    }
};

});

parcelRegister("gxJKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb901ddd959c90f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $bChGW = parcelRequire("bChGW");

var $koVbs = parcelRequire("koVbs");

var $ghRU5 = parcelRequire("ghRU5");

var $kacDU = parcelRequire("kacDU");
const $fb901ddd959c90f6$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, ...restProps } = props;
    const isChecked = props.selectProps?.componentsProps?.isChecked || false;
    const projectKey = props.selectProps?.componentsProps?.projectKey || null;
    const label = formatMessage((0, $ghRU5.default).checkboxLabel, {
        projectKey: projectKey
    });
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'ReactElement<any, string | JSXElementConstructor<any>>', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Menu, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kacDU.CheckboxWrapper), {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        onKeyDown: onKeyDown,
        isChecked: isChecked,
        label: label,
        testId: "issue-field-sprint.ui.edit.menu.checkbox"
    })), children)));
};
var // @ts-expect-error - TS2352 - Conversion of type '(props: Props) => JSX.Element' to type 'ReactNode' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$fb901ddd959c90f6$export$2e2bcd8739ae039 = $fb901ddd959c90f6$var$Menu;

});
parcelRegister("ghRU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7044cf08eb2bc7be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7044cf08eb2bc7be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-sprint.edit.menu.checkbox-label",
        "defaultMessage": "Only show sprints in this project ({projectKey})"
    }
});

});

parcelRegister("kacDU", function(module, exports) {

$parcel$export(module.exports, "CheckboxWrapper", () => $38a94e57c20f776f$export$eef12940a6696c78);
/* styled.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $38a94e57c20f776f$export$eef12940a6696c78 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zlpe8f _1e0c1txw _2lx2vrvc _1bah1y6m _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ckVH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe9503663e56e29$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6fe9503663e56e29$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-field-sprint.edit.placeholder",
        "defaultMessage": "Select sprint"
    },
    empty: {
        "id": "issue-field-sprint.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-sprint.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    loading: {
        "id": "issue-field-sprint.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});


parcelRegister("ahEu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77c8f330a49e37f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e77c8f330a49e37f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activeSprintSelectionWarningMessage: {
        "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message",
        "defaultMessage": "Creating this issue will affect the active sprint's scope"
    },
    activeSprintSelectionWarningMessageIssueTermRefresh: {
        "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message-issue-term-refresh",
        "defaultMessage": "Creating this work item will affect the active sprint's scope"
    }
});

});

parcelRegister("aqMtW", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSprintValue", () => $02b747729b1ec287$export$94efa001ab93bfd1);
$parcel$export(module.exports, "mutateJiraSprintField", () => $02b747729b1ec287$export$38f8d6ec9f8dd490);
$parcel$export(module.exports, "getSprintSuggestions", () => $02b747729b1ec287$export$a5ccca5b51d5d670);

var $eusud = parcelRequire("eusud");
const $02b747729b1ec287$export$94efa001ab93bfd1 = (selectedSprints)=>{
    const sprint = selectedSprints[0];
    return sprint && {
        label: sprint.name,
        value: sprint.sprintId,
        state: sprint.state
    };
};
const $02b747729b1ec287$export$38f8d6ec9f8dd490 = ({ value: value }, fieldId)=>({
        sprintsField: {
            fieldId: fieldId,
            sprints: [
                {
                    sprintId: value.toString()
                }
            ]
        }
    });
const $02b747729b1ec287$export$c1102c96d31ebe29 = (autoCompleteUrl, query, projectKey)=>{
    const queryString = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (projectKey !== null && projectKey !== undefined) return `${queryString}&projectKey=${encodeURIComponent(projectKey)}`;
    return queryString;
};
const $02b747729b1ec287$export$a5ccca5b51d5d670 = async (autoCompleteUrl, query, projectKey)=>(0, $eusud.performGetRequest)($02b747729b1ec287$export$c1102c96d31ebe29(autoCompleteUrl, query, projectKey));

});




parcelRegister("j85Ze", function(module, exports) {

$parcel$export(module.exports, "StoryPointEstimateCustomFieldTypeConfig", () => $bc3fb5d2c33a6a48$export$8deb8e2b0423b5b3);

var $5uXOq = parcelRequire("5uXOq");

var $7WX1N = parcelRequire("7WX1N");

var $bo14T = parcelRequire("bo14T");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $bc3fb5d2c33a6a48$var$StoryPointEstimateCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bo14T.default), props);
const $bc3fb5d2c33a6a48$export$8deb8e2b0423b5b3 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7WX1N))),
    type: (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
    Component: $bc3fb5d2c33a6a48$var$StoryPointEstimateCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.TextFieldPlaceholder), null),
    writer: (0, $kShoa.numberFieldWriter)
};

});

parcelRegister("9TyvL", function(module, exports) {

$parcel$export(module.exports, "SummaryFieldTypeConfig", () => $3f14060b386f603e$export$ac5c271c33c3c6d7);

var $5uXOq = parcelRequire("5uXOq");

var $7nQJF = parcelRequire("7nQJF");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $3f14060b386f603e$export$ac5c271c33c3c6d7 = {
    type: (0, $5fc53.SUMMARY_TYPE),
    Component: (0, $7nQJF.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.TextFieldPlaceholder), null),
    writer: (0, $kShoa.textFieldWriter)
};

});
parcelRegister("7nQJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e43d0c98a72456c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hMKLn = parcelRequire("hMKLn");

const $7e43d0c98a72456c$var$TextField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMKLn.default), {
        type: "text",
        ...props
    });
var $7e43d0c98a72456c$export$2e2bcd8739ae039 = $7e43d0c98a72456c$var$TextField;

});


parcelRegister("j2R7K", function(module, exports) {

$parcel$export(module.exports, "TeamCustomFieldTypeConfig", () => $1b14f3049c72d53c$export$68615ecd9a5b878d);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $iPfC3 = parcelRequire("iPfC3");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $1b14f3049c72d53c$var$TeamCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iPfC3.default), props);
const $1b14f3049c72d53c$export$68615ecd9a5b878d = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
    type: (0, $5fc53.TEAM_CF_TYPE),
    Component: $1b14f3049c72d53c$var$TeamCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.teamFieldWriter)
};

});
parcelRegister("iPfC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cafe98c17438b5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $eb5hX = parcelRequire("eb5hX");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $9K1c2 = parcelRequire("9K1c2");

const $35cafe98c17438b5$export$c3b8fa1b9560fb7e = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '/rest/teams/1.0/teams/find', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eb5hX.default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true,
            ariaLabelledBy: ariaLabelledBy
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit());
};
var $35cafe98c17438b5$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateCustomTeamsField),
    transformDefaultValue: (0, $9K1c2.transformDefaultTeam)
})($35cafe98c17438b5$export$c3b8fa1b9560fb7e);

});
parcelRegister("eb5hX", function(module, exports) {

$parcel$export(module.exports, "default", () => $762657ba3faad803$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d7FF4 = parcelRequire("d7FF4");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $FtZX9 = parcelRequire("FtZX9");

var $blh8O = parcelRequire("blh8O");

var $b6swk = parcelRequire("b6swk");

var $ibWtm = parcelRequire("ibWtm");

var $jv74C = parcelRequire("jv74C");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $762657ba3faad803$var$MenuList = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6swk.default), props);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $762657ba3faad803$var$Option = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibWtm.default), props);
const $762657ba3faad803$var$CustomTeamPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, autoFocus: autoFocus = false, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
    const handleSearch = (0, $FtZX9.default)(async (query)=>(0, $jv74C.fetchTeams)(query || '', autoCompleteUrl), 300);
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await handleSearch();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, $blh8O.default).noMatches), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        fieldId: fieldId,
        ...defaultOptionsProps(),
        loadOptions: handleSearch,
        onChange: onChange,
        autoFocus: autoFocus,
        isClearable: Boolean(value),
        isMulti: false,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: $762657ba3faad803$var$MenuList,
            Option: $762657ba3faad803$var$Option
        },
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        classNamePrefix: classNamePrefix,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $762657ba3faad803$export$2e2bcd8739ae039 = $762657ba3faad803$var$CustomTeamPickerEdit;

});
parcelRegister("blh8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $47204223650b9e34$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $47204223650b9e34$var$messages = (0, $7VHMR.defineMessages)({
    menuHeader: {
        "id": "issue-field-custom-team.menu-header",
        "defaultMessage": "Pick a shared team that you\u2019ve created through a Portfolio plan"
    },
    noMatches: {
        "id": "issue-field-custom-team.no-matches",
        "defaultMessage": "No Matches"
    },
    menuFooter: {
        "id": "issue-field-custom-team.menu-footer",
        "defaultMessage": "Showing 100 results. To display more results, please refine your search."
    }
});
var $47204223650b9e34$export$2e2bcd8739ae039 = $47204223650b9e34$var$messages;

});

parcelRegister("b6swk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7d58b272b039ad0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");

var $koVbs = parcelRequire("koVbs");

var $blh8O = parcelRequire("blh8O");
const $b7d58b272b039ad0$var$MenuListComponent = (props)=>{
    const { options: options } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const footer = options.length > 0 && options[0].moreResultsAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b7d58b272b039ad0$var$MenuFooterText, null, formatMessage((0, $blh8O.default).menuFooter)) : null;
    return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; options: GroupOption[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 7 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b7d58b272b039ad0$var$Container, null, formatMessage((0, $blh8O.default).menuHeader)), props.children, footer));
};
var $b7d58b272b039ad0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b7d58b272b039ad0$var$MenuListComponent;
const $b7d58b272b039ad0$var$MenuFooterText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81oud _syaz1ifp _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $b7d58b272b039ad0$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ibWtm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82bc7e69d2cb0c6a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $7KPXo = parcelRequire("7KPXo");
const $82bc7e69d2cb0c6a$var$OptionComponent = (props)=>{
    const value = props.data;
    if (value) {
        const { avatarUrl: avatarUrl, label: label } = value;
        return(// @ts-expect-error - TS2740 - Type '{ children: Element; data: TeamFieldType; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$OptionWrapper, null, avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$Icon, {
            src: avatarUrl,
            alt: label
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $82bc7e69d2cb0c6a$var$boxStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7KPXo.default), {
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$OptionText, null, props.children))));
    }
    return null;
};
var $82bc7e69d2cb0c6a$export$2e2bcd8739ae039 = $82bc7e69d2cb0c6a$var$OptionComponent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82bc7e69d2cb0c6a$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $82bc7e69d2cb0c6a$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvr1h6o _1bahv2br _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66",
            __cmplp.className
        ])
    });
});
const $82bc7e69d2cb0c6a$var$OptionText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $82bc7e69d2cb0c6a$var$boxStyle = (0, $8CUq3.xcss)({
    height: '16px',
    width: '16px',
    marginRight: 'space.100'
});

});
parcelRegister("7KPXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6eecaecb2670c4$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $dCLgq = parcelRequire("dCLgq");

var $6oKGV = parcelRequire("6oKGV");
const $6f6eecaecb2670c4$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6oKGV)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6oKGV))
});
var $6f6eecaecb2670c4$export$2e2bcd8739ae039 = $6f6eecaecb2670c4$var$Illustration;
// for advanced use only
const $6f6eecaecb2670c4$export$a179c88182cb9d56 = [
    0,
    0,
    596,
    596
];

});
parcelRegister("6oKGV", function(module, exports) {
module.exports = new URL("team.aa9af04e.svg", import.meta.url).toString();

});



parcelRegister("jv74C", function(module, exports) {

$parcel$export(module.exports, "transformTeamFieldTypeString", () => $dbbd6d0fcad033b6$export$f7d628c77d5447d0);
$parcel$export(module.exports, "fetchTeams", () => $dbbd6d0fcad033b6$export$a789e725ac68b08d);

var $eusud = parcelRequire("eusud");
const $dbbd6d0fcad033b6$export$4accbe1c2fbc55dd = (team)=>({
        label: team.title,
        value: team.id.toString(),
        isShared: team.shareable,
        avatarUrl: team.avatarUrl
    });
const $dbbd6d0fcad033b6$export$f7d628c77d5447d0 = (team)=>{
    if (team) return team.value.toString();
    return null;
};
const $dbbd6d0fcad033b6$export$a789e725ac68b08d = async (query, autoCompleteUrl)=>{
    const response = await (0, $eusud.performPostRequest)(autoCompleteUrl, {
        body: JSON.stringify({
            excludedIds: [],
            maxResults: 100,
            query: query
        })
    });
    if (response) {
        const teams = response.teams.map($dbbd6d0fcad033b6$export$4accbe1c2fbc55dd);
        return [
            {
                moreResultsAvailable: response.moreResultsAvailable,
                options: teams
            }
        ];
    }
    return [];
};

});


parcelRegister("9K1c2", function(module, exports) {

$parcel$export(module.exports, "mutateTeamField", () => $e945ecd21dcd5234$export$8db32a33b76e5823);
$parcel$export(module.exports, "transformDefaultTeam", () => $e945ecd21dcd5234$export$d2d64eb763c850a1);

const $e945ecd21dcd5234$export$8db32a33b76e5823 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $0a8c3ec56489edc2$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.value
        }
    } : null;
const $e945ecd21dcd5234$export$d2d64eb763c850a1 = (team)=>({
        label: team.name,
        value: team.teamId,
        isShared: true
    });

});
const $0a8c3ec56489edc2$export$31fd86f8f183952c = 'teamFields';




parcelRegister("kfv7e", function(module, exports) {

$parcel$export(module.exports, "TeamsPlatformCustomFieldTypeConfig", () => $5b2998e95da8bc40$export$bd8e1979d863fc93);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $d9PPV = parcelRequire("d9PPV");

var $kShoa = parcelRequire("kShoa");
const $5b2998e95da8bc40$var$TeamsPlatformCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9PPV.TeamField), {
        ...props,
        defaultValue: undefined
    });
const $5b2998e95da8bc40$export$bd8e1979d863fc93 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
    type: (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
    Component: $5b2998e95da8bc40$var$TeamsPlatformCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.singleUserPickerFieldWriter)
};

});
parcelRegister("d9PPV", function(module, exports) {

$parcel$export(module.exports, "TeamField", () => $4d064a61ca9e1968$export$6f6cb44144d37e0d);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $4kXb0 = parcelRequire("4kXb0");
const $4d064a61ca9e1968$var$CLICKED_KEY = 'clicked';
const $4d064a61ca9e1968$var$ONBOARDING_BANNER_KEY = 'TEAM_FIELD_ONBOARDING_BANNER_DISMISSED';
const $4d064a61ca9e1968$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('team-field-onboarding');
const $4d064a61ca9e1968$export$6f6cb44144d37e0d = (props)=>{
    // We need to override the localstorage so we don't get any of the onboarding for the form
    $4d064a61ca9e1968$var$localStorage.set($4d064a61ca9e1968$var$CLICKED_KEY, true);
    $4d064a61ca9e1968$var$localStorage.set($4d064a61ca9e1968$var$ONBOARDING_BANNER_KEY, true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4kXb0.default), props);
};

});
parcelRegister("4kXb0", function(module, exports) {

$parcel$export(module.exports, "AtlassianTeamsField", () => $2d376b3496c34d29$export$96c8ee98de63ec5b);
$parcel$export(module.exports, "default", () => $2d376b3496c34d29$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $b71gk = parcelRequire("b71gk");

var $8vFwj = parcelRequire("8vFwj");

var $4ajjx = parcelRequire("4ajjx");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $icXkU = parcelRequire("icXkU");

const $2d376b3496c34d29$var$overrideSelectStyles = {
    // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
    control: (base)=>({
            ...base,
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} 0`
        })
};
const $2d376b3496c34d29$var$stopFormPropagation = (e)=>{
    e.stopPropagation();
    e.preventDefault();
};
const $2d376b3496c34d29$export$96c8ee98de63ec5b = (props)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const siteId = tenantContext.cloudId;
    /**
   * The following is a hack to force the TeamPickerEdit to close after creating a team.
   * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
   * doesn't expose the select Ref.
   *  */ const [hackIsEditable, setHackIsEditable] = (0, $5uXOq.useState)(true);
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, autoFocus: autoFocus } = props;
    const onCreate = (0, $5uXOq.useCallback)((team)=>{
        if (team && team?.id !== value?.id) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'createTeamInline succeeded', 'issueCreate', {
                memberCount: team.memberCount
            });
            /**
       * The following is a hack to force the TeamPickerEdit to close after creating a team.
       * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
       * doesn't expose the select Ref.
       *  */ setHackIsEditable(false);
            // required wait for new created team to be available
            setTimeout(()=>{
                onChange(team);
                setHackIsEditable(true);
            }, 1000);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        value?.id
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $8vFwj.useCreateTeamDialog)({
        onCreate: onCreate
    });
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "team-picker-edit",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ajjx.AsyncTeamPickerEdit), {
            ...fieldProps,
            width: width,
            siteId: siteId,
            autoFocus: autoFocus,
            defaultValue: value,
            // @ts-expect-error - TS2322 - Type '(value: TeamValue) => void' is not assignable to type 'OnChange'.
            onChange: onChange,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isDisabled: isEditable === false || !hackIsEditable,
            styles: $2d376b3496c34d29$var$overrideSelectStyles,
            createTeamDialogTrigger: createTeamDialogTrigger
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "create-issue-field-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        name: "gic-create-team-dialog-form",
        onSubmit: $2d376b3496c34d29$var$stopFormPropagation
    }, createTeamDialog)));
};
var $2d376b3496c34d29$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $icXkU.validateAtlassianTeamsField),
    transformDefaultValue: (0, $icXkU.transformDefaultAtlassianTeam)
})($2d376b3496c34d29$export$96c8ee98de63ec5b);

});
parcelRegister("4ajjx", function(module, exports) {

$parcel$export(module.exports, "AsyncTeamPickerEdit", () => $81014c0bebd525f2$export$7db2ade8dff2be91);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kxZPA = parcelRequire("kxZPA");

var $9n6Ty = parcelRequire("9n6Ty");
const $81014c0bebd525f2$var$EMPTY_OBJECT = {};

const $81014c0bebd525f2$export$eaed616868423e8a = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("hgQ4J"))), {
    moduleId: "./src/packages/issue/fields/team/src/ui/edit-mode/index.tsx"
});
const $81014c0bebd525f2$export$7db2ade8dff2be91 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $9n6Ty.asyncTeamPickerEditEntryPoint), // use stable object reference to avoid re-renders
    $81014c0bebd525f2$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "async-jira-issue-atlassian-team-picker-edit",
        packageName: "jira-issue-field-team",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("9n6Ty", function(module, exports) {

$parcel$export(module.exports, "asyncTeamPickerEditEntryPoint", () => $306b3712a4b90308$export$80ec8c2b96e9988);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $306b3712a4b90308$export$80ec8c2b96e9988 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("hgQ4J"))).then((module)=>module.TeamPickerEditEntryPointContent), {
        moduleId: "ce0fa7b5"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("icXkU", function(module, exports) {

$parcel$export(module.exports, "mutateAtlassianTeamField", () => $9b9cb321960b72df$export$c8b8a48d1ff67754);
$parcel$export(module.exports, "transformDefaultAtlassianTeam", () => $9b9cb321960b72df$export$3fee94ad0b9e180c);
$parcel$export(module.exports, "transformAtlassianTeamFieldTypeString", () => $9b9cb321960b72df$export$450002773f9da0a4);
$parcel$export(module.exports, "validateAtlassianTeamsField", () => $9b9cb321960b72df$export$8222f94513c7d2e6);

var $bGrWH = parcelRequire("bGrWH");

const $9b9cb321960b72df$export$c8b8a48d1ff67754 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $9f942793bea6ba7a$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.id
        }
    } : null;
const $9b9cb321960b72df$export$3fee94ad0b9e180c = (team)=>({
        name: team.name,
        id: team.teamId,
        avatarUrl: team?.avatar?.small
    });
const $9b9cb321960b72df$export$450002773f9da0a4 = (team)=>{
    if (team && team.id) return team.id;
    return null;
};
const $9b9cb321960b72df$export$8222f94513c7d2e6 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};

});
const $9f942793bea6ba7a$export$31fd86f8f183952c = 'atlassianTeamFields';





parcelRegister("9uVge", function(module, exports) {

$parcel$export(module.exports, "TextAreaCustomFieldTypeConfig", () => $62cfff7fda2456e7$export$a843cc77cac50059);

var $5uXOq = parcelRequire("5uXOq");

var $5Hpaz = parcelRequire("5Hpaz");

var $9cNbb = parcelRequire("9cNbb");

var $5fc53 = parcelRequire("5fc53");


var $4R6GH = parcelRequire("4R6GH");

var $hDpqy = parcelRequire("hDpqy");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $62cfff7fda2456e7$var$TextAreaCustomFieldTypeComponent = (props)=>{
    if (props.renderer && props.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) && (0, $4R6GH.fg)('forms_multiline_text_wiki_renderer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDpqy.default), {
        ...props,
        defaultValue: undefined,
        fieldWrapperElement: null,
        mediaUploadContext: props.mediaUploadContexts.uploadContext
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9cNbb.default), props);
};
const $62cfff7fda2456e7$export$a843cc77cac50059 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))),
    type: (0, $5fc53.TEXT_AREA_CF_TYPE),
    Component: $62cfff7fda2456e7$var$TextAreaCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DescriptionFieldPlaceholder), null),
    writer: (id, value, fields, renderer)=>{
        if (!(0, $4R6GH.fg)('forms_multiline_text_wiki_renderer')) return (0, $kShoa.textAreaFieldWriter)(id, value, fields);
        return renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) ? (0, $kShoa.descriptionFieldWriter)(id, value, fields) : (0, $kShoa.textAreaFieldWriter)(id, value, fields);
    }
};

});
parcelRegister("9cNbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bfbc76c8b6a999d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e7njR = parcelRequire("e7njR");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

const $9bfbc76c8b6a999d$var$TextAreaField = (props)=>{
    const { width: width = '100%', fieldProps: { value: value = '', onChange: onChange, onBlur: onBlur, ...fieldProps }, error: error, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const onTextAreaChange = (e)=>{
        onChange(e.target.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e7njR.default), {
        ...fieldProps,
        value: value,
        onChange: onTextAreaChange,
        onBlur: onBlur,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isDisabled: isReadOnly
    }));
};
var $9bfbc76c8b6a999d$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<TextAreaFieldConfig, string>, any>'.
$9bfbc76c8b6a999d$var$TextAreaField);

});
parcelRegister("e7njR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac310125020056c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6LCpJ = parcelRequire("6LCpJ");
const $ac310125020056c3$var$TextAreaEdit = (props)=>{
    const { isRequired: isRequired = false, isInvalid: isInvalid, value: value, placeholder: placeholder = '', onBlur: onBlur, onFocus: onFocus, onChange: onChange, minimumRows: minimumRows = 3, autoFocus: autoFocus = false, isDisabled: isDisabled = false, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LCpJ.default), {
        ...fieldProps,
        isRequired: isRequired,
        placeholder: placeholder,
        value: value,
        autoFocus: autoFocus,
        onBlur: onBlur,
        onFocus: onFocus,
        onChange: onChange,
        isInvalid: isInvalid,
        minimumRows: minimumRows,
        isDisabled: isDisabled
    });
};
var $ac310125020056c3$export$2e2bcd8739ae039 = $ac310125020056c3$var$TextAreaEdit;

});
parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $1qQmi = parcelRequire("1qQmi");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $1qQmi.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $5uXOq.useMemo)(()=>(0, $1qQmi.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)([
        baseStyles,
        (0, $1qQmi.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});
parcelRegister("1qQmi", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $0f8aaecc0e682a20$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $0f8aaecc0e682a20$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $0f8aaecc0e682a20$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $iaE2J = parcelRequire("iaE2J");
function $0f8aaecc0e682a20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0f8aaecc0e682a20$var$disabledRules = {
    backgroundColor: $iaE2J.disabledBackground,
    backgroundColorFocus: $iaE2J.disabledBackground,
    backgroundColorHover: $iaE2J.disabledBackground,
    borderColor: $iaE2J.disabledBorder,
    borderColorFocus: $iaE2J.defaultBorderColorFocus,
    textColor: $iaE2J.disabledTextColor
};
const $0f8aaecc0e682a20$var$invalidRules = {
    borderColor: $iaE2J.invalidBorderColor,
    borderColorFocus: $iaE2J.defaultBorderColorFocus,
    backgroundColor: $iaE2J.defaultBackgroundColor,
    backgroundColorFocus: $iaE2J.defaultBackgroundColorFocus,
    backgroundColorHover: $iaE2J.defaultBackgroundColorHover
};
const $0f8aaecc0e682a20$var$backgroundColor = {
    standard: $iaE2J.defaultBackgroundColor,
    subtle: $iaE2J.transparent,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$backgroundColorFocus = {
    standard: $iaE2J.defaultBackgroundColorFocus,
    subtle: $iaE2J.defaultBackgroundColorFocus,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$backgroundColorHover = {
    standard: $iaE2J.defaultBackgroundColorHover,
    subtle: $iaE2J.defaultBackgroundColorHover,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$borderColor = {
    standard: $iaE2J.defaultBorderColor,
    subtle: $iaE2J.transparent,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$borderColorFocus = {
    standard: $iaE2J.defaultBorderColorFocus,
    subtle: $iaE2J.defaultBorderColorFocus,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$borderColorHover = {
    standard: $iaE2J.defaultBorderColor,
    subtle: $iaE2J.subtleBorderColorHover,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$lineHeightBase = 20;
const $0f8aaecc0e682a20$var$lineHeightCompact = 16;
const $0f8aaecc0e682a20$var$compactVerticalPadding = 2;
const $0f8aaecc0e682a20$var$verticalPadding = 6;
const $0f8aaecc0e682a20$var$horizontalPadding = 8;
const $0f8aaecc0e682a20$var$transitionDuration = '0.2s';
const $0f8aaecc0e682a20$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $0f8aaecc0e682a20$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $0f8aaecc0e682a20$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $0f8aaecc0e682a20$var$lineHeightBase * minimumRows;
    return contentHeight + $0f8aaecc0e682a20$var$verticalPadding * 2 + borderHeight * 2;
};
const $0f8aaecc0e682a20$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $0f8aaecc0e682a20$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $0f8aaecc0e682a20$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $0f8aaecc0e682a20$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $f8Sb3.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorFocus,
                borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColor,
                borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColor
            }
        } : {}
    });
const $0f8aaecc0e682a20$var$placeholderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $iaE2J.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $0f8aaecc0e682a20$var$disabledRules.textColor
    }
});
const $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
            }
        }
    });
var $0f8aaecc0e682a20$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $0f8aaecc0e682a20$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $0f8aaecc0e682a20$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        resize: resize
    });
    if (resize === 'auto') return $0f8aaecc0e682a20$var$_ref2;
    return $0f8aaecc0e682a20$var$_ref;
};
const $0f8aaecc0e682a20$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $0f8aaecc0e682a20$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)" : "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
const $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $0f8aaecc0e682a20$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$0f8aaecc0e682a20$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $0f8aaecc0e682a20$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$0f8aaecc0e682a20$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $0f8aaecc0e682a20$var$lineHeightBase / 14
        }
    });
};
const $0f8aaecc0e682a20$var$staticStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out,
               border-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$0f8aaecc0e682a20$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
// suggestion: these two could be merged into cssMap during @compiled rewrite
const $0f8aaecc0e682a20$var$newFontStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    [(0, $h9kUS.media).above.xs]: {
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }
});
const $0f8aaecc0e682a20$var$monospacedFontFamilyStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    [(0, $h9kUS.media).above.xs]: {
        // Reapply the monospaced font family as the font declaration used in the breakpoint in newFontStyles overrides it otherwise
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
    }
});
const $0f8aaecc0e682a20$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$borderStyle(appearance), // @todo: remove in `platform_design_system_team_safari_input_fix` cleanup
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? $0f8aaecc0e682a20$var$newFontStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    isMonospaced && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? $0f8aaecc0e682a20$var$monospacedFontFamilyStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $0f8aaecc0e682a20$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $iaE2J.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $0f8aaecc0e682a20$var$disabledRules.textColor
        }
    });

});
parcelRegister("iaE2J", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f788b902061573a8$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f788b902061573a8$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f788b902061573a8$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f788b902061573a8$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f788b902061573a8$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f788b902061573a8$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f788b902061573a8$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f788b902061573a8$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f788b902061573a8$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f788b902061573a8$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f788b902061573a8$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f788b902061573a8$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f788b902061573a8$export$f4d082c200a4b4b8);

const $f788b902061573a8$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $f788b902061573a8$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
const $f788b902061573a8$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
const $f788b902061573a8$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`;
const $f788b902061573a8$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
const $f788b902061573a8$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`;
const $f788b902061573a8$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
const $f788b902061573a8$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $f788b902061573a8$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f788b902061573a8$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
const $f788b902061573a8$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
const $f788b902061573a8$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`;
const $f788b902061573a8$export$f4d082c200a4b4b8 = 'transparent';

});





const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';


parcelRegister("4I0dG", function(module, exports) {

$parcel$export(module.exports, "TextCustomFieldTypeConfig", () => $479801bf04725697$export$c0fb3f2e63d9c457);

var $5uXOq = parcelRequire("5uXOq");

var $5Hpaz = parcelRequire("5Hpaz");

var $7nQJF = parcelRequire("7nQJF");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $479801bf04725697$export$c0fb3f2e63d9c457 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))),
    type: (0, $5fc53.TEXT_CF_TYPE),
    Component: (0, $7nQJF.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.TextFieldPlaceholder), null),
    writer: (0, $kShoa.textFieldWriter)
};

});

parcelRegister("eFzGt", function(module, exports) {

$parcel$export(module.exports, "UrlCustomFieldTypeConfig", () => $1f67de6720141602$export$ffd29c07a77eba88);

var $5uXOq = parcelRequire("5uXOq");

var $1f9bV = parcelRequire("1f9bV");

var $b3x8f = parcelRequire("b3x8f");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $1f67de6720141602$export$ffd29c07a77eba88 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))),
    type: (0, $5fc53.URL_CF_TYPE),
    Component: (0, $b3x8f.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.TextFieldPlaceholder), null),
    writer: (0, $kShoa.urlFieldWriter)
};

});
parcelRegister("b3x8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $097d081b3402af20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hMKLn = parcelRequire("hMKLn");

const $097d081b3402af20$var$UrlField = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMKLn.default), {
        type: "url",
        width: width,
        ...rest
    });
};
var $097d081b3402af20$export$2e2bcd8739ae039 = $097d081b3402af20$var$UrlField;

});


parcelRegister("5VWF9", function(module, exports) {

$parcel$export(module.exports, "UserCustomFieldTypeConfig", () => $236772e6b1d3a040$export$e4e5f327b24b40ce);

var $5uXOq = parcelRequire("5uXOq");

var $bdVbi = parcelRequire("bdVbi");

var $lfWSN = parcelRequire("lfWSN");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $236772e6b1d3a040$export$e4e5f327b24b40ce = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bdVbi))),
    type: (0, $5fc53.USER_CF_TYPE),
    Component: (0, $lfWSN.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.AssigneeFieldPlaceholder), null),
    writer: (0, $kShoa.singleUserPickerFieldWriter)
};

});

parcelRegister("1avQ5", function(module, exports) {

$parcel$export(module.exports, "VersionFieldTypeConfig", () => $8ec751d67ae1a8ea$export$db147413137ce6f2);
$parcel$export(module.exports, "MultiVersionsFieldTypeConfig", () => $8ec751d67ae1a8ea$export$2b457390d9f3d552);

var $5uXOq = parcelRequire("5uXOq");

var $2Ljwn = parcelRequire("2Ljwn");

var $k5vQX = parcelRequire("k5vQX");

var $aQNfA = parcelRequire("aQNfA");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
// The version field components expect `allowedValues` options to have a `status` enum field value
function $8ec751d67ae1a8ea$var$mapPropToExternalOptionAllowedValues(allowedValuesProp) {
    return allowedValuesProp.map(({ id: id, name: name, released: released, archived: archived })=>{
        let status = 'UNRELEASED';
        if (archived) status = 'ARCHIVED';
        else if (released) status = 'RELEASED';
        return {
            id: id,
            name: name,
            status: status
        };
    });
}
const $8ec751d67ae1a8ea$var$VersionFieldTypeComponent = (props)=>{
    const allowedValues = $8ec751d67ae1a8ea$var$mapPropToExternalOptionAllowedValues(props.allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQNfA.default), {
        ...props,
        allowedValues: allowedValues
    });
};
const $8ec751d67ae1a8ea$export$db147413137ce6f2 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Ljwn))),
    type: (0, $5fc53.VERSION_CF_TYPE),
    Component: $8ec751d67ae1a8ea$var$VersionFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.selectFieldWriter)
};
const $8ec751d67ae1a8ea$var$MultiVersionsFieldTypeComponent = (props)=>{
    const allowedValues = $8ec751d67ae1a8ea$var$mapPropToExternalOptionAllowedValues(props.allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5vQX.default), {
        ...props,
        allowedValues: allowedValues
    });
};
const $8ec751d67ae1a8ea$export$2b457390d9f3d552 = (type)=>({
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Ljwn))),
        type: type,
        Component: $8ec751d67ae1a8ea$var$MultiVersionsFieldTypeComponent,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
        writer: (0, $kShoa.multiSelectFieldWriter)
    });

});
parcelRegister("k5vQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $76983af27be6a3ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hTBEr = parcelRequire("hTBEr");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $cBHNh = parcelRequire("cBHNh");

var $34EcD = parcelRequire("34EcD");

const $76983af27be6a3ff$var$MultiVersionsField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, fieldId: fieldId, fieldName: fieldName, description: description, isReadOnly: isReadOnly = false, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const options = (0, $34EcD.transformVersionExternalOptionstoVersionOptions)(allowedValues);
    const isDisabled = allowedValues.length === 0;
    const onChangeVersionsEdit = (versionEditValue)=>{
        if (Array.isArray(versionEditValue) || versionEditValue === null) onChange(versionEditValue);
    };
    const getVersionsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTBEr.default), {
            options: options,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isMulti: true,
            onChange: onChangeVersionsEdit,
            isInvalid: Boolean(error),
            fieldId: fieldId,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isReadOnly || isDisabled,
            autoFocus: autoFocus,
            placeholder: isDisabled ? formatMessage((0, $cBHNh.default).none) : '',
            inputId: id,
            isRequired: isRequired
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $cBHNh.default).tooltip)
    }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $76983af27be6a3ff$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateMultiVersionsField),
    transformDefaultValue: (0, $34EcD.transformVersionExternalOptionstoVersionOptions),
    shouldRenderFieldMessage: false
})($76983af27be6a3ff$var$MultiVersionsField);

});
parcelRegister("hTBEr", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c89427d751fd8d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $dTQPF = parcelRequire("dTQPF");
const $87c89427d751fd8d$var$Versions = (props)=>{
    const { value: value, options: options, onChange: onChange, placeholder: placeholder = '', isInvalid: isInvalid, fieldId: fieldId, isMulti: isMulti, autoFocus: autoFocus = false, isDisabled: isDisabled, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, isClearable: isClearable = true, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, openMenuOnFocus: openMenuOnFocus = false } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getIsClearable = ()=>{
        if (!isClearable) return false;
        return Array.isArray(value) ? value.length > 0 : Boolean(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        placeholder: placeholder,
        options: (0, $dTQPF.getGroupedOptions)((0, $dTQPF.removeArchivedOptions)(options), formatMessage),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        value: value,
        fieldId: fieldId,
        isMulti: isMulti,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '(option: VersionOption | VersionOption[] | null) => void' is not assignable to type '(value: VersionOption | OptionsType<VersionOption> | null, action: ActionMeta<VersionOption>) => void'.
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        isClearable: getIsClearable(),
        inputId: inputId,
        required: isRequired,
        classNamePrefix: classNamePrefix,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        openMenuOnFocus: openMenuOnFocus
    });
};
var $87c89427d751fd8d$export$2e2bcd8739ae039 = $87c89427d751fd8d$var$Versions;

});
parcelRegister("dTQPF", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalToVersion", () => $418fd006fc4a31c5$export$c1c38f7974aa8bed);
$parcel$export(module.exports, "removeArchivedOptions", () => $418fd006fc4a31c5$export$6f0b68b6e372a0e6);
$parcel$export(module.exports, "getGroupedOptions", () => $418fd006fc4a31c5$export$721c3d9226425f9c);
$parcel$export(module.exports, "getVersionsIds", () => $418fd006fc4a31c5$export$c96a1607e976ccc6);
$parcel$export(module.exports, "getVersionId", () => $418fd006fc4a31c5$export$d0a84488c5034e2b);

var $lCBBY = parcelRequire("lCBBY");
const $418fd006fc4a31c5$var$getStatusFromRestOption = (option)=>{
    if (option.released) return 'RELEASED';
    if (option.archived) return 'ARCHIVED';
    return 'UNRELEASED';
};
const $418fd006fc4a31c5$export$eb178ff2323a1ab3 = (option)=>({
        label: option.name,
        value: option.id,
        status: $418fd006fc4a31c5$var$getStatusFromRestOption(option)
    });
const $418fd006fc4a31c5$export$c1c38f7974aa8bed = (option)=>({
        label: option.name,
        value: option.id,
        status: option.status
    });
const $418fd006fc4a31c5$export$6f0b68b6e372a0e6 = (options)=>options.filter((option)=>option.status !== 'ARCHIVED');
const $418fd006fc4a31c5$export$721c3d9226425f9c = (options, formatMessage)=>{
    const groupedOptions = [];
    // archived options are assumed to be filtered out already since we don't want to display them. Here, we are grouping according to 'status' being RELEASED or UNRELEASED
    if (options.length) {
        // the order of versions is decided from the first option since the API response follows the order
        const versionOrder = options.length && options[0].status === 'RELEASED' ? [
            'RELEASED',
            'UNRELEASED'
        ] : [
            'UNRELEASED',
            'RELEASED'
        ];
        // @ts-expect-error - TS2345 - Argument of type '(status: Status) => void' is not assignable to parameter of type '(value: string, index: number, array: string[]) => void'.
        versionOrder.forEach((status)=>{
            const statusOptions = options.filter((option)=>option.status === status);
            if (statusOptions.length) groupedOptions.push({
                options: statusOptions,
                label: status === 'RELEASED' ? formatMessage((0, $lCBBY.default).released) : formatMessage((0, $lCBBY.default).unreleased)
            });
        });
    }
    return groupedOptions;
};
const $418fd006fc4a31c5$export$c96a1607e976ccc6 = (selectedVersions)=>selectedVersions.map((v)=>({
            id: v.value
        }));
const $418fd006fc4a31c5$export$d0a84488c5034e2b = (selectedVersion)=>({
        id: selectedVersion.value
    });

});
parcelRegister("lCBBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a958e5bb1549bd80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a958e5bb1549bd80$var$messages = (0, $7VHMR.defineMessages)({
    released: {
        "id": "issue-field-versions.released",
        "defaultMessage": "Released"
    },
    unreleased: {
        "id": "issue-field-versions.unreleased",
        "defaultMessage": "Unreleased"
    }
});
var $a958e5bb1549bd80$export$2e2bcd8739ae039 = $a958e5bb1549bd80$var$messages;

});



parcelRegister("cBHNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b40c0e93e07915fd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b40c0e93e07915fd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "issue-create-commons.multi-versions-field.none",
        "defaultMessage": "None"
    },
    tooltip: {
        "id": "issue-create-commons.multi-versions-field.tooltip",
        "defaultMessage": "We couldn't find any versions for this project"
    }
});

});

parcelRegister("34EcD", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", () => $f99feaf445ed0ec0$export$11cad9e2f2e9ae55);
$parcel$export(module.exports, "mutateMultiVersionsField", () => $f99feaf445ed0ec0$export$6999207a9642bd09);

var $dTQPF = parcelRequire("dTQPF");

const $f99feaf445ed0ec0$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, $dTQPF.transformVersionExternalToVersion)(option));
const $f99feaf445ed0ec0$export$6999207a9642bd09 = (selectedVersions, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $a7d2b97eb2e0b950$export$31fd86f8f183952c),
        versions: selectedVersions.map(({ value: value })=>({
                versionId: value
            }))
    });

});
const $a7d2b97eb2e0b950$export$31fd86f8f183952c = 'multipleVersionPickerFields';



parcelRegister("aQNfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d04647b01be2b83f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hTBEr = parcelRequire("hTBEr");

var $dTQPF = parcelRequire("dTQPF");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $jrGSc = parcelRequire("jrGSc");

var $1AaWN = parcelRequire("1AaWN");

const $d04647b01be2b83f$var$SingleVersionField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, fieldName: fieldName, description: description, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeVersionsEdit = (versionEditValue)=>{
        if (!Array.isArray(versionEditValue)) onChange(versionEditValue);
    };
    const options = (0, $1AaWN.transformVersionExternalOptionstoVersionOptions)(allowedValues);
    const isDisabled = allowedValues.length === 0;
    const getVersionsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTBEr.default), {
            options: options,
            value: value,
            onChange: onChangeVersionsEdit,
            isInvalid: Boolean(error),
            fieldId: fieldId,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isMulti: false,
            isDisabled: isDisabled,
            placeholder: isDisabled ? formatMessage((0, $jrGSc.default).none) : '',
            autoFocus: autoFocus,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            ariaLabelledBy: ariaLabelledBy
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jrGSc.default).tooltip)
    }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $d04647b01be2b83f$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateSingleVersionField),
    transformDefaultValue: (0, $dTQPF.transformVersionExternalToVersion),
    shouldRenderFieldMessage: false
})($d04647b01be2b83f$var$SingleVersionField);

});
parcelRegister("jrGSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5396ea8e93f1b004$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5396ea8e93f1b004$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "issue-create-commons.single-version-field.none",
        "defaultMessage": "None"
    },
    tooltip: {
        "id": "issue-create-commons.single-version-field.tooltip",
        "defaultMessage": "We couldn't find any versions for this project"
    }
});

});

parcelRegister("1AaWN", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", () => $79dd8b3734a0e456$export$11cad9e2f2e9ae55);
$parcel$export(module.exports, "mutateSingleVersionField", () => $79dd8b3734a0e456$export$57ed62196c76c8b6);

var $dTQPF = parcelRequire("dTQPF");

const $79dd8b3734a0e456$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, $dTQPF.transformVersionExternalToVersion)(option));
const $79dd8b3734a0e456$export$57ed62196c76c8b6 = ({ value: value }, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $703505cc37235a2c$export$31fd86f8f183952c),
        version: {
            versionId: value
        }
    });

});
const $703505cc37235a2c$export$31fd86f8f183952c = 'singleVersionPickerFields';








parcelRegister("hmRfM", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionRoot", () => $5045058046d328b0$export$4ae1a0970466e244);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");

var $eiOkd = parcelRequire("eiOkd");

var $e21nk = parcelRequire("e21nk");

var $cm8b5 = parcelRequire("cm8b5");

var $8HvEs = parcelRequire("8HvEs");

var $7Wnap = parcelRequire("7Wnap");

var $7yduy = parcelRequire("7yduy");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l2N2a = parcelRequire("l2N2a");

var $l8ruj = parcelRequire("l8ruj");

var $doZTA = parcelRequire("doZTA");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $iEEXl = parcelRequire("iEEXl");

var $7wwVP = parcelRequire("7wwVP");

var $j3cMm = parcelRequire("j3cMm");

var $6czoq = parcelRequire("6czoq");

var $aCsR5 = parcelRequire("aCsR5");

var $lAzTA = parcelRequire("lAzTA");

var $fOgCm = parcelRequire("fOgCm");

var $b668c = parcelRequire("b668c");

var $g2iZ7 = parcelRequire("g2iZ7");

var $djHla = parcelRequire("djHla");


var $7YlSK = parcelRequire("7YlSK");

var $f9uY0 = parcelRequire("f9uY0");

var $b8mPJ = parcelRequire("b8mPJ");
const $5045058046d328b0$var$FormContent = /*#__PURE__*/ (0, $5uXOq.memo)(// TODO remove eslint disable as part of FF FD-41661 cleanup
// eslint-disable-next-line complexity
({ formSubmissionLoading: formSubmissionLoading, formSubmissionData: formSubmissionData, formSubmissionError: formSubmissionError })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: project } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const accessLevel = formSubmissionData?.formWithFieldData?.accessLevel;
    const canCreateIssues = Boolean(project?.permissions.createIssues) || accessLevel === (0, $7wwVP.FormAccessLevelTypes).OPEN || accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC && (0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', false);
    const hasError = formSubmissionError !== undefined; // if form's issue type has been deleted
    if (!formSubmissionLoading && formSubmissionData?.formWithFieldData && !formSubmissionData?.formWithFieldData?.issueType && !hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.IssueTypeDeletedView), null);
     // if form's issue type has been disassociated from the project
    if (!formSubmissionLoading && formSubmissionData?.formWithFieldData && !formSubmissionData.fieldMetaData && canCreateIssues && formSubmissionData?.formWithFieldData?.issueType && !hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.IssueTypeNotAssociatedView), {
        issueTypeName: formSubmissionData?.formWithFieldData?.issueType?.name ?? ''
    });
     // if user has no permission to create issues
    if (!canCreateIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.NoPermissionView), null);
     // if issue cannot be created because there are missing supported required fields
    if (formSubmissionData?.formSubmissionValidationData?.hasMissingSupportedRequiredFields) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.FormMissingSupportedRequiredFieldsView), null);
     // if issue cannot be created because there are missing unsupported required fields
    if (formSubmissionData?.formSubmissionValidationData?.hasUnsupportedRequiredFields) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.FormContainsUnsupportedRequiredFieldsView), null);
    if (accessLevel !== (0, $7wwVP.FormAccessLevelTypes).PUBLIC || !(0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', false)) {
        const canViewIssues = Boolean(project?.permissions.viewIssues); // if issue cannot be created because there are project-scoped required fields and the user does not have permission to view them
        const noPermissionToViewProjectScopedRequiredFields = formSubmissionData?.formSubmissionValidationData?.hasProjectScopedRequiredFields && !canViewIssues;
        if (noPermissionToViewProjectScopedRequiredFields) {
            const projectScopedRequiredFields = formSubmissionData?.formWithFieldData?.fields.filter((f)=>f.isRequiredByForm && (0, $fOgCm.isProjectScopedFieldType)(f.type)).map((f)=>f.type) ?? [];
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'formUnavailable viewed', {
                error: 'noPermissionToViewProjectScopedRequiredFields',
                projectScopedRequiredFields: projectScopedRequiredFields
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.NoProjectAccessView), null);
        }
    } // generic screen for any other kind of error
    if (hasError || formSubmissionData == null || formSubmissionData.formWithFieldData == null || formSubmissionData.fieldMetaData == null || formSubmissionData?.formWithFieldData?.enabled === false || formSubmissionData?.formSubmissionValidationData?.isFormSubmissionValid === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.FormUnavailableView), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $djHla.MediaPermissionsPreloader), {
        projectId: String(formSubmissionData.formWithFieldData.projectId),
        formId: formSubmissionData.formWithFieldData.formId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f9uY0.FillInView), null));
});
const $5045058046d328b0$export$2f8578dc462e47a9 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { featureView: featureView } = (0, $b668c.useJWMFormsFeatures)();
    const { data: formSubmissionData, loading: formSubmissionLoading, error: formSubmissionError } = (0, $g2iZ7.useFormSubmission)();
    const pageHeading = formatMessage((0, $b8mPJ.default).pageHeading);
    const hasError = formSubmissionError !== undefined;
    const loading = formSubmissionLoading;
    const experienceTrackerAttributes = (0, $lAzTA.useConditionalFieldLogicAnalyticsAttrs)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "form-submission"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "form-submission",
        hold: loading
    }), !loading && (0, $4R6GH.fg)('jira_move_fire_screen_analytics_to_form_submission') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            usedFieldsCount: formSubmissionData?.formWithFieldData?.fields?.length ?? undefined
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Wnap.RenderStartMark), {
        view: featureView,
        loading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e21nk.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCsR5.FormBackground), {
        bannerColor: formSubmissionData?.formWithFieldData?.bannerColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j3cMm.Card), {
        minHeight: (0, $410f34228866ee1a$export$aa78f5e84beba3ce)
    }, !hasError && loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$var$Placeholder, {
        id: "form-content",
        "data-testid": "business-form.ui.form-submission.place-holder"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$var$FormContent, {
        formSubmissionLoading: formSubmissionLoading,
        formSubmissionData: formSubmissionData,
        formSubmissionError: formSubmissionError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceSuccess), {
        experience: (0, $iEEXl.VIEW_FORM_SUBMISSION_EXPERIENCE),
        attributes: experienceTrackerAttributes
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HvEs.PerformanceAnalytics), {
        view: featureView,
        loading: loading
    }), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7yduy.JWMSpaStatePageReady), null));
});
const $5045058046d328b0$export$4ae1a0970466e244 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { data: project } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const [{ query: query }] = (0, $doZTA.useRouter)();
    const { data: formSubmissionData } = (0, $g2iZ7.useFormSubmission)();
    let shouldShowContactAdminBanner = false;
    if (formSubmissionData?.formWithFieldData?.accessLevel !== (0, $7wwVP.FormAccessLevelTypes).PUBLIC || !(0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', false)) {
        const canCreateOrModifyForm = Boolean(project?.permissions.administerProject);
        shouldShowContactAdminBanner = !canCreateOrModifyForm && query[(0, $iEEXl.URL_PARAMS).FROM] === (0, $iEEXl.URL_PARAMS).DIRECTORY;
    }
    const analyticsAttributes = (0, $lAzTA.useConditionalFieldLogicAnalyticsAttrs)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "form-submission-root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormSubmission",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: analyticsAttributes
    }, shouldShowContactAdminBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YlSK.ContactAdminBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eiOkd.default), {
        shouldAddPadding: false,
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$export$2f8578dc462e47a9, null)), !(0, $4R6GH.fg)('jira_move_fire_screen_analytics_to_form_submission') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))));
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5045058046d328b0$var$Placeholder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ip3fh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eiOkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98d0f47ed36cd9a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6cG4N = parcelRequire("6cG4N");


var $bUSNl = parcelRequire("bUSNl");

var $lLfAu = parcelRequire("lLfAu");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $b98d0f47ed36cd9a$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent }] = (0, $bUSNl.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLfAu.SidebarLayout), {
        theme: sidebarTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b98d0f47ed36cd9a$var$contentWrapperStyles,
            isSidebarOpen && $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles
        ]
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b98d0f47ed36cd9a$var$ThemedContainer, {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, content);
};
const $b98d0f47ed36cd9a$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $6cG4N.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $b98d0f47ed36cd9a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b98d0f47ed36cd9a$var$BusinessAppWrapper);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b98d0f47ed36cd9a$var$ThemedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1n261q9c _vchhusvi _1e0c1txw _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syazfrbu",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});

});
const $c15b7ab4e654e0c4$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("bUSNl", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $39fc2da09b28cabf$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $39fc2da09b28cabf$export$54c70f22f548bff8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hE5wF = parcelRequire("hE5wF");

var $3hGWp = parcelRequire("3hGWp");

var $dCm1o = parcelRequire("dCm1o");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $jnA4H = parcelRequire("jnA4H");
const $39fc2da09b28cabf$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD = 360;
const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH = 435;
const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
        (0, $hE5wF.SELECTED_ISSUE_PARAM),
        (0, $hE5wF.SELECTED_COMMENT_PARAM)
    ];
const $39fc2da09b28cabf$export$f4c7df452942956a = ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH : $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD;
const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newWidth = Math.max(width, $39fc2da09b28cabf$export$f4c7df452942956a());
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $jnA4H.localStorage).set($39fc2da09b28cabf$export$86880b4b2e1a2384, newWidth);
    };
const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        });
    };
const $39fc2da09b28cabf$var$actions = {
    setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
    setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
    setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
    closeSidebar: $39fc2da09b28cabf$var$closeSidebar
};
const $39fc2da09b28cabf$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        content: null,
        sidebarWidth: (0, $jnA4H.localStorage).get($39fc2da09b28cabf$export$86880b4b2e1a2384) || $39fc2da09b28cabf$export$f4c7df452942956a(),
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    actions: $39fc2da09b28cabf$var$actions,
    name: 'JWMSidebarStore'
});
const $39fc2da09b28cabf$var$useHook = (0, $3sQ5x.createHook)($39fc2da09b28cabf$var$Store);
const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
    const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $3hGWp.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("hE5wF", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $bfd6cbe4770149b5$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $bfd6cbe4770149b5$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $bfd6cbe4770149b5$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $bfd6cbe4770149b5$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $bfd6cbe4770149b5$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $bfd6cbe4770149b5$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $bfd6cbe4770149b5$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $bfd6cbe4770149b5$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $bfd6cbe4770149b5$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $bfd6cbe4770149b5$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $bfd6cbe4770149b5$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $bfd6cbe4770149b5$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$c72ea455b368cdd9);
$parcel$export(module.exports, "UNASSIGNED_USER_ID", () => $bfd6cbe4770149b5$export$12e572fd459c10dc);

const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
const $bfd6cbe4770149b5$export$12e572fd459c10dc = 'unassigned';

});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("jnA4H", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $301038d04a64b539$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");
const $301038d04a64b539$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_business_common');

});


parcelRegister("lLfAu", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $1dbab6fa0f2d1b51$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $getxR = parcelRequire("getxR");

var $He4jn = parcelRequire("He4jn");

var $bUSNl = parcelRequire("bUSNl");

var $eHSp3 = parcelRequire("eHSp3");
const $1dbab6fa0f2d1b51$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $1dbab6fa0f2d1b51$var$sidebarStyles,
            theme === 'business' && $1dbab6fa0f2d1b51$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children);
const $1dbab6fa0f2d1b51$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $getxR.useSidebarQueryParams)();
    const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $He4jn.useResizer)();
    // reset sidebar content on view unmount
    (0, $5uXOq.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dbab6fa0f2d1b51$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.SidebarContent), null, content)));
};
const $1dbab6fa0f2d1b51$var$sidebarStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $1dbab6fa0f2d1b51$var$businessSidebarStyles = (0, $8CUq3.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("getxR", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $7ddee5a34b903b90$export$34adbeffbeceba68);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $4R6GH = parcelRequire("4R6GH");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3hGWp = parcelRequire("3hGWp");

var $bUSNl = parcelRequire("bUSNl");
const $7ddee5a34b903b90$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $7ddee5a34b903b90$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $bUSNl.useSidebar)();
    const sidebarQueryParams = (0, $bUSNl.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $3hGWp.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $1XJ20.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $5uXOq.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        resetSidebarQueryParams();
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $5uXOq.useEffect)(()=>{
        sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $5uXOq.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $hE5wF.SELECTED_ISSUE_PARAM] && (0, $4R6GH.fg)('jira_list_keyboard_nav')) // sidebar is not open, exit
            return;
            if (queryParams[0, $hE5wF.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($7ddee5a34b903b90$var$isEscapeEvent(event)) {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        typeof document !== 'undefined' && document.addEventListener('keydown', handleKeydown);
        return ()=>{
            typeof document !== 'undefined' && document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("He4jn", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $80d7a99fb39f1e91$export$faede3f1542958fc);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $bUSNl = parcelRequire("bUSNl");
const $80d7a99fb39f1e91$var$THROTTLE_TIME = 16;
const $80d7a99fb39f1e91$export$faede3f1542958fc = ()=>{
    const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, $bUSNl.useSidebar)();
    const startRef = (0, $5uXOq.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $5uXOq.useRef)(0);
    const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $80d7a99fb39f1e91$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mousemove', onMouseMove);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("eHSp3", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $71d20039839e60ab$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarContent", () => $71d20039839e60ab$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $71d20039839e60ab$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $71d20039839e60ab$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $71d20039839e60ab$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _ogwtu2gc _6tinidpf _1cezu2gc _m3zkidpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $71d20039839e60ab$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _16r2glyw _qc5othzt _aetrb3bt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _gcm1194a _4tpu194a",
            __cmplp.className
        ])
    });
});

});



parcelRegister("e21nk", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $aa5670652f17dfc4$export$416064ba09d98e69);

var $5uXOq = parcelRequire("5uXOq");

var $id7K0 = parcelRequire("id7K0");

var $54qG5 = parcelRequire("54qG5");
const $aa5670652f17dfc4$export$416064ba09d98e69 = /*#__PURE__*/ (0, $5uXOq.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("54qG5", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $a71d927d8f07dfcc$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $a71d927d8f07dfcc$export$ff2574b00bc1c100);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $a71d927d8f07dfcc$var$BusinessEntityContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a71d927d8f07dfcc$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a71d927d8f07dfcc$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $a71d927d8f07dfcc$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $5uXOq.useContext)($a71d927d8f07dfcc$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});


parcelRegister("8HvEs", function(module, exports) {

$parcel$export(module.exports, "PerformanceAnalytics", () => $0eced7986dcab954$export$ec3c3b39c046a620);

var $5uXOq = parcelRequire("5uXOq");

var $fNobW = parcelRequire("fNobW");


var $2nbdU = parcelRequire("2nbdU");

var $3vR0I = parcelRequire("3vR0I");

var $7Wnap = parcelRequire("7Wnap");
const $0eced7986dcab954$export$ec3c3b39c046a620 = /*#__PURE__*/ (0, $5uXOq.memo)(({ view: view, loading: loading, itemsCount: itemsCount, attributes: attributes })=>{
    const loadingRef = (0, $5uXOq.useRef)(loading);
    loadingRef.current = loading;
    if (loading === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "performance-analytics-loading"
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const scrollElement = false ? null : document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597));
    const product = view.startsWith('software') ? 'jsw' : 'jwm';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Wnap.PageLoadMetrics), {
        view: view,
        attributes: attributes,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vR0I.FirstInteractionMetric), {
        view: view,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2nbdU.default), {
        viewId: `${product}.${view}`,
        scrollElement: scrollElement,
        itemsCount: itemsCount,
        attributes: attributes
    }));
});

});
parcelRegister("2nbdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $551da07557368f71$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

const $551da07557368f71$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $ed1164448c2018a0$export$9d3e6d8a99023567));
const $551da07557368f71$export$46962be62755f053 = /*#__PURE__*/ (0, $5uXOq.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $ed1164448c2018a0$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const samplingCount = (0, $5uXOq.useRef)(0);
    const frames = (0, $5uXOq.useRef)(0);
    const rafId = (0, $5uXOq.useRef)(null);
    const start = (0, $5uXOq.useRef)(0);
    (0, $5uXOq.useEffect)(()=>{
        const container = scrollElement ?? document;
        const hasScrollCapture = true;
        const tick = ()=>{
            if (frames.current < (0, $ed1164448c2018a0$export$299249b1dad3b14a)) {
                frames.current += 1;
                rafId.current = requestAnimationFrame(tick);
            } else {
                const stopTime = performance.now();
                const elapsedMs = stopTime - start.current;
                const fps = $551da07557368f71$export$df7175b69b5630dd(frames.current, elapsedMs);
                const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                frames.current = 0;
                const attr = {
                    ...attributes || {},
                    itemsCount: itemsCount,
                    avgFrameDuration: avgFrameDuration,
                    fps: fps
                };
                (0, $8zOmE.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
            }
        };
        const handleOnScroll = ()=>{
            samplingCount.current += 1;
            if (samplingCount.current !== samplingRate) return;
            samplingCount.current = 0;
            // start counting frames
            start.current = performance.now();
            tick();
        };
        container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [
        scrollElement,
        createAnalyticsEvent,
        itemsCount,
        samplingRate,
        viewId,
        attributes
    ]);
    return null;
});
var $551da07557368f71$export$2e2bcd8739ae039 = $551da07557368f71$export$46962be62755f053;

});
// how often do we measure, e.g. every 100th scroll
const $ed1164448c2018a0$export$71d024136796e395 = 100;
const $ed1164448c2018a0$export$299249b1dad3b14a = 20;
const $ed1164448c2018a0$export$9d3e6d8a99023567 = 60;


parcelRegister("3vR0I", function(module, exports) {

$parcel$export(module.exports, "FirstInteractionMetric", () => $43e497a79074b7d0$export$70b569bf2edd0b7f);

var $5uXOq = parcelRequire("5uXOq");


var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $43e497a79074b7d0$export$70b569bf2edd0b7f = ({ view: view, product: product = 'jwm' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const container = document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597)) ?? document;
        const hasScrollCapture = true;
        const startTime = performance.now();
        const handleFirstClick = ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction clicked`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('click', handleFirstClick);
        };
        const handleFirstScroll = ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction scrolled`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
        container.addEventListener('click', handleFirstClick);
        container.addEventListener('scroll', handleFirstScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('click', handleFirstClick);
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
    }, [
        createAnalyticsEvent,
        view,
        product
    ]);
    return null;
};

});

parcelRegister("7Wnap", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $4c177752bab6a832$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $4c177752bab6a832$export$66b33c055cbb625e);

var $5uXOq = parcelRequire("5uXOq");

var $5rqex = parcelRequire("5rqex");


var $gN11a = parcelRequire("gN11a");
const $4c177752bab6a832$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $gN11a.markViewMetric)(view, (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4));
    return null;
};
const $4c177752bab6a832$export$66b33c055cbb625e = /*#__PURE__*/ (0, $5uXOq.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $gN11a.markViewMetric)(view, (0, $a286480ec63fa4c8$export$88ea1e280513690f));
    const metric = (0, $gN11a.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});




parcelRegister("7yduy", function(module, exports) {

$parcel$export(module.exports, "JWMSpaStatePageReady", () => $150b436063f0aaae$export$d54524c142a057f);

var $5uXOq = parcelRequire("5uXOq");

var $dZw8H = parcelRequire("dZw8H");
const $150b436063f0aaae$export$d54524c142a057f = ()=>{
    const [isReady, setIsReady] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Waiting for 2 animation frames is equivalent to waiting for react to paint the DOM.
		 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        let id = window.requestAnimationFrame(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            id = window.requestAnimationFrame(()=>{
                setIsReady(true);
            });
        });
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.cancelAnimationFrame(id);
        };
    }, []);
    if (!isReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null);
};

});

parcelRegister("j3cMm", function(module, exports) {

$parcel$export(module.exports, "Card", () => $da92e917e9b85f56$export$60332b2344f7fe41);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $da92e917e9b85f56$export$c75a6d3667a4a2e7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _bfhkhp5a _otyru2gc _ca0qutpp _u5f3xy5q _n3tdutpp _19bvxy5q _16qs1bpa",
            __cmplp.className
        ])
    });
});
const $da92e917e9b85f56$var$StyledCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $da92e917e9b85f56$export$c75a6d3667a4a2e7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_brev0o": (0, $lD23V.default)(__cmplp.minHeight, "px"),
            "--_1upm8ip": (0, $lD23V.default)(__cmplp.maxHeight, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.minHeight !== null ? "_1tke1rgx" : "_1tke1wug",
            __cmplp.maxHeight !== null ? "_c71l1w9o" : "_c71l1wug",
            __cmplp.className
        ])
    });
});
const $da92e917e9b85f56$export$60332b2344f7fe41 = $da92e917e9b85f56$var$StyledCard;

});

parcelRegister("aCsR5", function(module, exports) {

$parcel$export(module.exports, "FormBackground", () => $4c9d8229fbc4b0b5$export$e13fb218ba50bebd);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3NYLB = parcelRequire("3NYLB");
const $4c9d8229fbc4b0b5$export$e13fb218ba50bebd = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, bannerColor: bannerColor, header: header })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c9d8229fbc4b0b5$var$Background, {
        bannerColor: (0, $3NYLB.getDesignTokenBannerColor)(bannerColor)
    }, header, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c9d8229fbc4b0b5$var$ContentWrapper, null, children)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9d8229fbc4b0b5$var$Background = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { bannerColor: bannerColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1yndzv5": (0, $lD23V.default)(`linear-gradient(to bottom, ${__cmplp.bannerColor || "var(--ds-background-neutral-hovered, #091E4224)"} 30%, transparent 30%)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7nlav _qmxj1n9t _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $4c9d8229fbc4b0b5$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbufrr _19pk1ejb _2hwx1wug _otyr1ejb _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3NYLB", function(module, exports) {

$parcel$export(module.exports, "getRandomBannerColor", () => $8d0eb4c1d86abc14$export$aefdd89adb2344b3);
$parcel$export(module.exports, "getDesignTokenBannerColor", () => $8d0eb4c1d86abc14$export$c3fba1eee1434e93);

const $8d0eb4c1d86abc14$var$FORM_COLORS = [
    (0, $829f609a65d26a98$export$60847d42f9da92a6),
    (0, $829f609a65d26a98$export$5aae31392d72caaa),
    (0, $829f609a65d26a98$export$747d86715d4175de),
    (0, $829f609a65d26a98$export$215b7063051591f1),
    (0, $829f609a65d26a98$export$69cb3ca10c1e330e),
    (0, $829f609a65d26a98$export$a7175d4e9206bc80)
];
const $8d0eb4c1d86abc14$export$993a5daeae2a3b3d = (index)=>$8d0eb4c1d86abc14$var$FORM_COLORS[index];
const $8d0eb4c1d86abc14$export$aefdd89adb2344b3 = ()=>$8d0eb4c1d86abc14$var$FORM_COLORS[Math.floor(Math.random() * $8d0eb4c1d86abc14$var$FORM_COLORS.length)];
const $8d0eb4c1d86abc14$export$c3fba1eee1434e93 = (colorCode)=>{
    switch(colorCode){
        case 0, $829f609a65d26a98$export$60847d42f9da92a6:
            return `var(--ds-background-accent-red-subtle, ${0, $829f609a65d26a98$export$60847d42f9da92a6})`;
        case 0, $829f609a65d26a98$export$5aae31392d72caaa:
            return `var(--ds-background-accent-yellow-subtle, ${0, $829f609a65d26a98$export$5aae31392d72caaa})`;
        case 0, $829f609a65d26a98$export$747d86715d4175de:
            return `var(--ds-background-accent-green-subtle, ${0, $829f609a65d26a98$export$747d86715d4175de})`;
        case 0, $829f609a65d26a98$export$69cb3ca10c1e330e:
            return `var(--ds-background-accent-teal-subtle, ${0, $829f609a65d26a98$export$69cb3ca10c1e330e})`;
        case 0, $829f609a65d26a98$export$a7175d4e9206bc80:
            return `var(--ds-background-accent-purple-subtle, ${0, $829f609a65d26a98$export$a7175d4e9206bc80})`;
        case 0, $829f609a65d26a98$export$215b7063051591f1:
        default:
            return `var(--ds-background-accent-blue-subtle, ${0, $829f609a65d26a98$export$215b7063051591f1})`;
    }
};

});


parcelRegister("b668c", function(module, exports) {

$parcel$export(module.exports, "useJWMFormsFeatures", () => $16b8c1742dea6da5$export$761e4daa424a5fb7);
$parcel$export(module.exports, "default", () => $16b8c1742dea6da5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $16b8c1742dea6da5$var$defaultFeaturesContext = {
    featureView: 'form-submit',
    shouldHidePoweredBy: false
};
const $16b8c1742dea6da5$var$JWMFormsFeaturesContext = /*#__PURE__*/ (0, $5uXOq.createContext)($16b8c1742dea6da5$var$defaultFeaturesContext);
const $16b8c1742dea6da5$export$761e4daa424a5fb7 = ()=>(0, $5uXOq.useContext)($16b8c1742dea6da5$var$JWMFormsFeaturesContext);
var $16b8c1742dea6da5$export$2e2bcd8739ae039 = $16b8c1742dea6da5$var$JWMFormsFeaturesContext;

});

parcelRegister("djHla", function(module, exports) {

$parcel$export(module.exports, "MediaPermissionsPreloader", () => $d53363cdf9dab000$export$1ea28abf1046610e);
$parcel$export(module.exports, "useMediaPermissions", () => $d53363cdf9dab000$export$270452b93e9d2c99);

var $5uXOq = parcelRequire("5uXOq");

var $6dxIs = parcelRequire("6dxIs");

var $dJTwj = parcelRequire("dJTwj");
const $d53363cdf9dab000$export$1ea28abf1046610e = ({ projectId: projectId, formId: formId })=>{
    const { uploadPermissions: uploadPermissions, fetchUploadPermissions: fetchUploadPermissions, uploadPermissionStatus: uploadPermissionStatus } = (0, $6dxIs.useUploadPermissions)();
    const [, { updateStore: updateStore }] = (0, $dJTwj.useMediaPermissionsStore)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectId) fetchUploadPermissions(projectId, formId);
    }, [
        projectId,
        fetchUploadPermissions,
        formId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStore({
            mediaUploadPermissions: uploadPermissions,
            mediaUploadPermissionStatus: uploadPermissionStatus
        });
    }, [
        updateStore,
        uploadPermissionStatus,
        uploadPermissions
    ]);
    return null;
};
const $d53363cdf9dab000$export$270452b93e9d2c99 = ()=>{
    const [{ mediaUploadPermissions: mediaUploadPermissions, mediaUploadPermissionStatus: mediaUploadPermissionStatus }] = (0, $dJTwj.useMediaPermissionsStore)();
    const isUploadPermissionReady = mediaUploadPermissionStatus === 'COMPLETED' && mediaUploadPermissions !== null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        mediaUploadPermissions: mediaUploadPermissions,
        mediaUploadPermissionStatus: mediaUploadPermissionStatus,
        mediaContext: {
            viewContext: isUploadPermissionReady ? mediaUploadPermissions : {},
            uploadContext: isUploadPermissionReady ? mediaUploadPermissions : {},
            userAuth: null
        }
    };
};

});
parcelRegister("6dxIs", function(module, exports) {

$parcel$export(module.exports, "useUploadPermissions", () => $d55c0017318f0800$export$9fc4bf889c7dbfba);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jpsyn = parcelRequire("jpsyn");
const $d55c0017318f0800$var$QUERY_ID = 'formSubmissionMediaPermissions';
const $d55c0017318f0800$export$9fc4bf889c7dbfba = (isDescriptionField)=>{
    const [uploadPermissionStatus, setUploadPermissionStatus] = (0, $5uXOq.useState)('NOT_STARTED');
    const [uploadPermissions, setUploadPermissions] = (0, $5uXOq.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fetchUploadPermissions = (0, $5uXOq.useCallback)(async (projectId, formId)=>{
        setUploadPermissionStatus('LOADING');
        try {
            const url = (0, $jpsyn.getMediaUploadPermissionUrl)(formId, Boolean(isDescriptionField));
            const uploadResponse = await (0, $eusud.performGetRequest)(url);
            setUploadPermissions({
                clientId: uploadResponse.clientId,
                serviceHost: uploadResponse.endpointUrl,
                token: uploadResponse.token,
                tokenLifespanInMs: uploadResponse.tokenDurationInMins * 60000,
                collection: uploadResponse.targetCollection,
                tokenIssueTimestamp: Date.now() - 10000
            });
            setUploadPermissionStatus('COMPLETED');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setUploadPermissionStatus('COMPLETED');
            if (err.statusCode === 403) // user does not have media permission
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${$d55c0017318f0800$var$QUERY_ID} forbidden`);
            else (0, $jcw0u.default)({
                meta: {
                    id: $d55c0017318f0800$var$QUERY_ID,
                    packageName: 'jiraBusinessForm',
                    teamName: 'jira-werewolves'
                },
                attributes: {
                    statusCode: err.statusCode
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        isDescriptionField
    ]);
    return {
        uploadPermissions: uploadPermissions,
        fetchUploadPermissions: fetchUploadPermissions,
        uploadPermissionStatus: uploadPermissionStatus
    };
};

});
parcelRegister("jpsyn", function(module, exports) {

$parcel$export(module.exports, "getMediaUploadPermissionUrl", () => $d10e4390e86d9aea$export$9f4e6a02a32c7984);
$parcel$export(module.exports, "getFormAttachmentUploadUrl", () => $d10e4390e86d9aea$export$b80950102aaa651d);
const $d10e4390e86d9aea$export$9f4e6a02a32c7984 = (formId, returnCreateIssueAdf)=>`/rest/api/2/attachment/upload/form/${formId}/credentials?returnCreateIssueAdf=${returnCreateIssueAdf}`;
const $d10e4390e86d9aea$export$b80950102aaa651d = (formId)=>`/rest/api/2/attachment/upload/form/${formId}`;

});


parcelRegister("dJTwj", function(module, exports) {

$parcel$export(module.exports, "useMediaPermissionsStore", () => $91f5295abbefbb95$export$9c03e2ed7cceacd6);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $91f5295abbefbb95$var$actions = {
    updateStore: (newData)=>({ setState: setState })=>{
            setState(newData);
        }
};
const $91f5295abbefbb95$var$MediaPermissionsStore = (0, $iXqE5.createStore)({
    initialState: {
        mediaUploadPermissions: null,
        mediaUploadPermissionStatus: 'NOT_STARTED'
    },
    actions: $91f5295abbefbb95$var$actions,
    name: 'JWMMediaPermissions'
});
const $91f5295abbefbb95$export$9c03e2ed7cceacd6 = (0, $3sQ5x.createHook)($91f5295abbefbb95$var$MediaPermissionsStore);

});


const $410f34228866ee1a$export$aa78f5e84beba3ce = 240;

parcelRegister("7YlSK", function(module, exports) {

$parcel$export(module.exports, "ContactAdminBanner", () => $de37af4b546c3e70$export$a50845fcec7cb9ff);

var $5uXOq = parcelRequire("5uXOq");

var $lkmWu = parcelRequire("lkmWu");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $aLvPW = parcelRequire("aLvPW");
const $de37af4b546c3e70$var$ContactYourAdminLink = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: "/jira/contact-administrator"
    }, children);
const $de37af4b546c3e70$export$a50845fcec7cb9ff = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(true);
    const handleDismissClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $de37af4b546c3e70$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkmWu.default), {
        testId: "business-form.ui.form-submission.contact-admin-banner.banner",
        appearance: "announcement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        componentsMapping: {
            link: $de37af4b546c3e70$var$ContactYourAdminLink
        },
        message: formatMessage((0, $aLvPW.default).needToEdit, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $de37af4b546c3e70$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        label: "dismiss",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $aLvPW.default).dismiss),
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        onClick: handleDismissClick
    })));
};
const $de37af4b546c3e70$var$bannerContainerStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $de37af4b546c3e70$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.100'
});

});
parcelRegister("aLvPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe90aa245dc4244$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8fe90aa245dc4244$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    needToEdit: {
        "id": "business-form.form-submission.contact-admin-banner.need-to-edit",
        "defaultMessage": "{linkStart}Contact your admin{linkEnd} to edit this form."
    },
    dismiss: {
        "id": "business-form.form-submission.contact-admin-banner.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("f9uY0", function(module, exports) {

$parcel$export(module.exports, "FillInView", () => $35a47656ff93b9c5$export$32d78bb31929ae49);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $2rqOp = parcelRequire("2rqOp");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");
var $8jRgk = parcelRequire("8jRgk");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $467lJ = parcelRequire("467lJ");
var $LJaTB = parcelRequire("LJaTB");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $l2N2a = parcelRequire("l2N2a");

var $cSD7y = parcelRequire("cSD7y");

var $iEEXl = parcelRequire("iEEXl");

var $co4Oy = parcelRequire("co4Oy");

var $6czoq = parcelRequire("6czoq");

var $icLsg = parcelRequire("icLsg");

var $fOgCm = parcelRequire("fOgCm");

var $b668c = parcelRequire("b668c");

var $g2iZ7 = parcelRequire("g2iZ7");

var $djHla = parcelRequire("djHla");

var $kMDCx = parcelRequire("kMDCx");

var $6dxIs = parcelRequire("6dxIs");

var $jpsyn = parcelRequire("jpsyn");

var $7wwVP = parcelRequire("7wwVP");

var $c4qDm = parcelRequire("c4qDm");

var $icFsv = parcelRequire("icFsv");

var $6Ti3X = parcelRequire("6Ti3X");

var $jfugj = parcelRequire("jfugj");

var $luvaQ = parcelRequire("luvaQ");
const $35a47656ff93b9c5$var$submissionErrorFlag = (errorMessage)=>{
    if (errorMessage === (0, $iEEXl.FORM_VALIDATION_ERROR).ATTACHMENT_ERROR) return {
        type: 'error',
        title: (0, $icFsv.default).submissionErrorFlag,
        description: (0, $icFsv.default).submissionAttachmentErrorContent,
        testId: 'business-form.ui.form-submission.fill-in-view.form-attachment-error-flag'
    };
    return {
        type: 'error',
        title: (0, $icFsv.default).submissionErrorFlag,
        description: errorMessage,
        testId: 'business-form.ui.form-submission.fill-in-view.error-flag'
    };
};
const $35a47656ff93b9c5$var$interactions = [
    'scroll',
    'click',
    'focus',
    'keydown'
];
const $35a47656ff93b9c5$var$hasInitialInteractionCapture = true;
const $35a47656ff93b9c5$var$FormFooterOld = (prop)=>{
    const { createIssueLoading: createIssueLoading, uploading: uploading } = prop;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8jRgk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        testId: "business-form.ui.form-submission.fill-in-view.loading-button",
        type: "submit",
        appearance: "primary",
        isLoading: createIssueLoading || uploading,
        interactionName: "business-form-submission-submit"
    }, formatMessage((0, $icFsv.default).submitButton)));
};
const $35a47656ff93b9c5$var$FormFooterNew = (prop)=>{
    const { isPublicForm: isPublicForm, createIssueLoading: createIssueLoading, uploading: uploading } = prop;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, isPublicForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luvaQ.PublicFormPrivacyPolicyFooter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $35a47656ff93b9c5$var$submitButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        testId: "business-form.ui.form-submission.fill-in-view.loading-button",
        type: "submit",
        appearance: "primary",
        isLoading: createIssueLoading || uploading,
        interactionName: "business-form-submission-submit"
    }, formatMessage((0, $icFsv.default).submitButton))));
};
const $35a47656ff93b9c5$var$Footer = (0, $cSD7y.componentWithFG)('jira-forms-public-access', $35a47656ff93b9c5$var$FormFooterNew, $35a47656ff93b9c5$var$FormFooterOld);
const $35a47656ff93b9c5$export$32d78bb31929ae49 = ()=>{
    const [uploading, setUploading] = (0, $5uXOq.useState)(false);
    const [shouldRenderExtraFields, setShouldRenderExtraFields] = (0, $5uXOq.useState)(false);
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: formSubmissionData, formId: formId } = (0, $g2iZ7.useFormSubmission)();
    const { data: projectData } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const { shouldHidePoweredBy: shouldHidePoweredBy } = (0, $b668c.useJWMFormsFeatures)();
    const { formWithFieldData: formWithFieldData, fieldMetaData: fieldMetaData } = formSubmissionData ?? {};
    const { description: description, projectId: projectId, accessLevel: accessLevel, issueType: issueType } = formWithFieldData ?? {}; // This is for description field
    const { uploadPermissions: uploadPermissions, fetchUploadPermissions: fetchUploadPermissions, uploadPermissionStatus: uploadPermissionStatus } = (0, $6dxIs.useUploadPermissions)(true);
    const { mediaUploadPermissions: mediaUploadPermissions, mediaUploadPermissionStatus: mediaUploadPermissionStatus, mediaContext: mediaContext } = (0, $djHla.useMediaPermissions)();
    const isUploadPermissionNotReady = uploadPermissionStatus !== 'COMPLETED' || mediaUploadPermissionStatus !== 'COMPLETED';
    const parsedDescription = (0, $5uXOq.useMemo)(()=>{
        if (description === undefined || description === '') return undefined;
        try {
            return JSON.parse(description);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData((0, $iEEXl.PACKAGE_NAME), 'failed to parse form description in form submission');
            // ignore description from backend if it's not a valid JSON format
            return undefined;
        }
    }, [
        description
    ]);
    const analyticAttributes = (0, $5uXOq.useMemo)(()=>({
            accessLevel: accessLevel?.toString(),
            isOutsideUser: !projectData || !projectData?.permissions.createIssues,
            formId: formId
        }), [
        accessLevel,
        projectData,
        formId
    ]);
    const handleCreateIssueOnComplete = (0, $5uXOq.useCallback)(()=>{
        setIsVisible(false);
    }, [
        setIsVisible
    ]);
    const handleResetClick = (0, $5uXOq.useCallback)(()=>{
        setIsVisible(true);
    }, [
        setIsVisible
    ]);
    const renderExtraFields = (0, $5uXOq.useCallback)(()=>{
        setShouldRenderExtraFields(true);
        if (typeof document !== 'undefined') $35a47656ff93b9c5$var$interactions.forEach((evt)=>document.removeEventListener(evt, renderExtraFields, $35a47656ff93b9c5$var$hasInitialInteractionCapture));
    }, []);
    const setRef = (0, $jfugj.useIntersectionObserver)(renderExtraFields);
    const setIntersectionRef = (0, $5uXOq.useCallback)((element)=>setRef(element), [
        setRef
    ]);
    const { create: create, data: createIssueData, error: createIssueError, errorMessage: errorMessage, loading: createIssueLoading } = (0, $kMDCx.useCreateIssue)(formSubmissionData?.formWithFieldData, handleCreateIssueOnComplete, projectData?.type);
    const handleSubmitClick = (0, $5uXOq.useCallback)(async (formData)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form submitted', 'formSubmission', analyticAttributes);
        await create(formData);
    }, [
        create,
        createAnalyticsEvent,
        analyticAttributes
    ]);
    const renderFields = (0, $5uXOq.useCallback)((fields)=>fields.map((f)=>{
            // If the field no longer exists, do not render it.
            if (!fieldMetaData || !fieldMetaData[f.fieldId]) return null;
            const fieldConfig = (0, $fOgCm.getFieldTypeConfig)(f.type, projectData?.type);
            if (!fieldConfig) {
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'field missing', {
                    type: f.type
                });
                return null;
            }
            const { autoCompleteUrl: autoCompleteUrl, allowedValues: allowedValues = [], defaultFieldValue: defaultFieldValue, schema: schema } = fieldMetaData[f.fieldId]; /**
                                   * autoCompleteUrls contains origin/host.
                                   * In storybook, we want these to point to our proxy.
                                   */ 
            let completeUrl = autoCompleteUrl;
            if (Boolean(undefined) && typeof autoCompleteUrl === 'string') {
                const url = new URL(autoCompleteUrl);
                completeUrl = `${url.pathname}${url.search}`;
            }
            const isFieldRequired = f.isRequired || !!f.isRequiredByForm;
            const fieldDescription = f.description;
            const field = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(fieldConfig.Component, {
                key: f.fieldId,
                fieldName: typeof f.alias === 'string' && f.alias.length > 0 ? f.alias : f.name,
                fieldId: f.fieldId,
                isRequired: isFieldRequired,
                description: fieldDescription,
                autoCompleteUrl: completeUrl,
                allowedValues: allowedValues,
                mediaUploadContexts: {
                    uploadContext: uploadPermissions,
                    attachmentUploadContext: mediaUploadPermissions
                },
                projectId: String(projectId),
                issueTypeId: issueType?.id,
                projectKey: projectData?.key,
                onInProgressChange: setUploading,
                defaultValue: defaultFieldValue,
                attachmentCustomUploadURL: (0, $jpsyn.getFormAttachmentUploadUrl)(formId),
                canUserViewProject: Boolean(projectData?.permissions?.viewIssues),
                schemaConfiguration: schema?.configuration,
                renderer: (0, $4R6GH.fg)('forms_multiline_text_wiki_renderer') ? f.renderer : undefined
            });
            return f.parentCondition && (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4qDm.default), {
                key: `${f.parentCondition.id}:${f.fieldId}`,
                condition: f.parentCondition
            }, field) : field;
        }), [
        fieldMetaData,
        uploadPermissions,
        mediaUploadPermissions,
        projectId,
        issueType?.id,
        formId,
        projectData?.permissions?.viewIssues,
        projectData?.key,
        projectData?.type,
        createAnalyticsEvent
    ]);
    const getErrorFlag = (0, $5uXOq.useCallback)(()=>errorMessage !== null && typeof errorMessage === 'string' ? $35a47656ff93b9c5$var$submissionErrorFlag(errorMessage) : (0, $467lJ.default).genericError(), [
        errorMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (typeof document !== 'undefined') $35a47656ff93b9c5$var$interactions.forEach((evt)=>document.addEventListener(evt, renderExtraFields, $35a47656ff93b9c5$var$hasInitialInteractionCapture));
        return ()=>{
            if (typeof document !== 'undefined') $35a47656ff93b9c5$var$interactions.forEach((evt)=>document.removeEventListener(evt, renderExtraFields, $35a47656ff93b9c5$var$hasInitialInteractionCapture));
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (typeof projectId === 'number') fetchUploadPermissions(String(projectId), formId);
    }, [
        fetchUploadPermissions,
        formId,
        projectId
    ]);
    if (createIssueData?.success && !isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "business-form.ui.form-submission.fill-in-view.success-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.SuccessView), {
        shouldHidePoweredBy: shouldHidePoweredBy,
        onResetClick: handleResetClick,
        analyticAttributes: analyticAttributes
    }));
    if (!formSubmissionData || !formWithFieldData || !fieldMetaData || isUploadPermissionNotReady) return null;
     // only render the first 15 fields for performance reasons
    // remaining fields will be rendered once the user interacts with the page
    const cloneInitialFields = [
        ...formWithFieldData.fields
    ];
    const initialFields = cloneInitialFields.splice(0, 15);
    const shouldRenderAdditionalFields = cloneInitialFields.length > 0 && shouldRenderExtraFields;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        objectType: "form",
        objectId: formId,
        containerType: "project",
        containerId: String(projectId),
        attributes: {
            ...(0, $jfugj.generateFieldAnalytics)(formWithFieldData.fields),
            ...analyticAttributes
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "formSubmission viewed"
    }), projectData?.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a47656ff93b9c5$var$ProjectNameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "small",
        src: projectData?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtle",
        weight: "semibold"
    }, projectData?.name))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $35a47656ff93b9c5$var$projectNamePlaceholderStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formWithFieldData.title,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $icLsg.TitleWrapperTruncated), null, formWithFieldData.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a47656ff93b9c5$var$DescriptionWrapper, {
        "data-testid": "business-form.ui.form-submission.fill-in-view.description"
    }, parsedDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "description-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $co4Oy.default), {
        document: parsedDescription,
        mediaContext: mediaContext,
        featureFlags: {
            codeBidiWarnings: true,
            'code-bidi-warnings': true
        },
        baseUrl: ""
    })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        isDisabled: createIssueLoading || createIssueData?.success && !isVisible,
        onSubmit: handleSubmitClick
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            ...formProps,
            name: "submit form",
            noValidate: true,
            "data-test-id": "business-form.ui.form-submission.fill-in-view.form"
        }, renderFields(initialFields), shouldRenderAdditionalFields && renderFields(cloneInitialFields), !shouldRenderAdditionalFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            ref: setIntersectionRef
        }), (shouldRenderAdditionalFields || formWithFieldData.fields.length <= 15) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a47656ff93b9c5$var$Footer, {
            isPublicForm: accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC,
            createIssueLoading: createIssueLoading,
            uploading: uploading
        }), (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Ti3X.default), null))), createIssueError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "business-form.ui.form-submission.fill-in-view.flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
        flag: getErrorFlag()
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $35a47656ff93b9c5$var$ProjectNameWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf",
            __cmplp.className
        ])
    });
});
const $35a47656ff93b9c5$var$projectNamePlaceholderStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $35a47656ff93b9c5$var$DescriptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $35a47656ff93b9c5$var$submitButtonStyle = (0, $8CUq3.xcss)({
    alignSelf: 'flex-end'
});

});
parcelRegister("467lJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc639d9ac2372482$export$2e2bcd8739ae039);

var $8BkAH = parcelRequire("8BkAH");

var $8hiuq = parcelRequire("8hiuq");

var $l7mS2 = parcelRequire("l7mS2");

var $5jDRa = parcelRequire("5jDRa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc639d9ac2372482$export$2e2bcd8739ae039 = {
    forbidden: $8BkAH.default,
    genericError: $8hiuq.default,
    serverError: $l7mS2.default,
    unauthorized: $5jDRa.default
};

});
parcelRegister("8BkAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $47acdb71562a5159$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $47acdb71562a5159$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47acdb71562a5159$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $47acdb71562a5159$var$messages.title,
        description: $47acdb71562a5159$var$messages.description,
        messageId: 'flags.ui.configurations.errors.forbidden.error',
        messageType: 'transactional'
    });

});

parcelRegister("8hiuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd4533bf12eb3f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ffd4533bf12eb3f1$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffd4533bf12eb3f1$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $ffd4533bf12eb3f1$var$messages.title,
        description: $ffd4533bf12eb3f1$var$messages.description,
        messageId: 'flags.ui.configurations.errors.genericError.error',
        messageType: 'transactional'
    });

});

parcelRegister("l7mS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a915dd4c1d2142$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $31a915dd4c1d2142$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31a915dd4c1d2142$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $31a915dd4c1d2142$var$messages.title,
        description: $31a915dd4c1d2142$var$messages.description,
        messageId: 'flags.ui.configurations.errors.serverError.error',
        messageType: 'transactional'
    });

});

parcelRegister("5jDRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8754751d720d57d4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8754751d720d57d4$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8754751d720d57d4$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $8754751d720d57d4$var$messages.title,
        description: $8754751d720d57d4$var$messages.description,
        messageId: 'flags.ui.configurations.errors.unauthorized.error',
        messageType: 'transactional'
    });

});


parcelRegister("LJaTB", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $2de6889b93863972$export$7c38ebd1f7ca6a5a);

var $hkhmi = parcelRequire("hkhmi");

var $34Vv8 = parcelRequire("34Vv8");
const $2de6889b93863972$export$7c38ebd1f7ca6a5a = (0, $34Vv8.default)((0, $hkhmi.default));

});
parcelRegister("hkhmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2971dd786c0add8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
class $e2971dd786c0add8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $fHfPB.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});


parcelRegister("co4Oy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2436649549ab9cdd$export$2e2bcd8739ae039);

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2436649549ab9cdd$var$AsyncDescriptionReadView = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("70E57")), {
    ssr: false,
    moduleId: "./src/packages/business/form/src/common/ui/description-read/main.tsx"
});
var $2436649549ab9cdd$export$2e2bcd8739ae039 = $2436649549ab9cdd$var$AsyncDescriptionReadView;

});
parcelRegister("70E57", function(module, exports) {

let $51a79fda2c4fe27a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $51a79fda2c4fe27a$var$load("7VuUY").then(()=>parcelRequire('bFrp8'));

});


parcelRegister("icLsg", function(module, exports) {

$parcel$export(module.exports, "TitleWrapper", () => $e2b5765917c57fb2$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleWrapperTruncated", () => $e2b5765917c57fb2$export$179667894b01611b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.0 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $e2b5765917c57fb2$export$585a3b23e887288b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81p5s _19pkidpf _6id51kw7 _fh0l1f4h _o8b6idpf _1ols1kw7",
            __cmplp.className
        ])
    });
});
const $e2b5765917c57fb2$export$179667894b01611b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $e2b5765917c57fb2$export$585a3b23e887288b, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kMDCx", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $b6e087ee0849b727$export$8af2d18142c8506c);

var $5tTFS = parcelRequire("5tTFS");

var $cm8b5 = parcelRequire("cm8b5");

var $2vSU6 = parcelRequire("2vSU6");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eCBf9 = parcelRequire("eCBf9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iEEXl = parcelRequire("iEEXl");

var $gak61 = parcelRequire("gak61");

var $lAzTA = parcelRequire("lAzTA");


var $kgZWx = parcelRequire("kgZWx");

var $qPGip = parcelRequire("qPGip");
const $b6e087ee0849b727$var$QUERY_NAME = 'CreateJiraBusinessIssueForm';
const $b6e087ee0849b727$var$logMissing = (name)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData((0, $iEEXl.PACKAGE_NAME), `"${name}" was unexpectedly null or undefined for form submission`);
};
const $b6e087ee0849b727$export$8af2d18142c8506c = (formWithFieldData, onComplete, // TODO: Remove on cleanup of fix_forms_issue_create_labelling_issue
projectTypeOld = (0, $2vSU6.CORE_PROJECT))=>{
    const startExperience = (0, $cm8b5.useExperienceStart)((0, $iEEXl.SUBMIT_FORM_EXPERIENCE));
    const markExperienceSuccess = (0, $cm8b5.useExperienceSuccess)((0, $iEEXl.SUBMIT_FORM_EXPERIENCE));
    const markExperienceFailed = (0, $cm8b5.useExperienceFail)((0, $iEEXl.SUBMIT_FORM_EXPERIENCE));
    const projectType = (0, $4R6GH.fg)('fix_forms_issue_create_labelling_issue') ? (0, $gak61.useProjectType)() : projectTypeOld;
    const experienceAnalyticsAttributes = (0, $lAzTA.useConditionalFieldLogicAnalyticsAttrs)();
    const doFireErrorAnalytics = (error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: $b6e087ee0849b727$var$QUERY_NAME,
                packageName: 'jiraBusinessForm',
                teamName: 'jira-werewolves'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: Array.isArray(error) && error.length > 0 ? error[0] : error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [createIssue, { data: data, loading: loading, error: error }] = (0, $5tTFS.useMutation)((0, $kgZWx.FORM_CREATE_ISSUE_MUTATION), {
        onError: (apolloError)=>{
            doFireErrorAnalytics(apolloError);
            markExperienceFailed('create issue service - mutation onError', apolloError, experienceAnalyticsAttributes);
            (0, $dJl1T.default).safeErrorWithoutCustomerData((0, $iEEXl.PACKAGE_NAME), 'ApolloError: Failed to create issue using form');
        },
        onCompleted: (responseData)=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$b6e087ee0849b727$var$QUERY_NAME} succeeded`, {});
            if (responseData.createJiraBusinessIssueByForm?.errors) {
                const errors = responseData.createJiraBusinessIssueByForm.errors.map((e)=>new (0, $eCBf9.MutationError)(e)).filter((e)=>e.message !== (0, $iEEXl.FORM_VALIDATION_ERROR).ATTACHMENT_ERROR && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$b46f0126077d6b7c) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$d65db43b48ab539f) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$e8b6f1ad2ff52ae6));
                if (errors.length > 0) {
                    doFireErrorAnalytics(errors);
                    const mutationError = errors.find((e)=>e.message);
                    if (mutationError) markExperienceFailed('Create issue service mutation failed', new (0, $eCBf9.MutationError)(mutationError), {
                        errorType: mutationError.extensions?.errorType || '',
                        statusCode: mutationError.extensions?.statusCode || '',
                        ...experienceAnalyticsAttributes
                    });
                }
                return;
            }
            if (responseData.createJiraBusinessIssueByForm?.item?.issueId) {
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(responseData.createJiraBusinessIssueByForm.item.issueId));
                onComplete?.();
            }
            markExperienceSuccess(experienceAnalyticsAttributes);
        }
    });
    /**
	 * This function will create an issue with specified fields
	 * It will always resolve the promise even if there are any errors (apollo error, bad request)
	 * To know whether it's successful or not, use the `data` and `error` prop returned by the hook
	 */ const create = async (formInputData)=>{
        const projectId = formWithFieldData?.projectId;
        const issueTypeId = formWithFieldData?.issueType?.id;
        const formId = formWithFieldData?.formId;
        startExperience();
        if (typeof formInputData !== 'object') {
            $b6e087ee0849b727$var$logMissing('formInputData');
            return;
        }
        if (typeof formWithFieldData !== 'object') {
            $b6e087ee0849b727$var$logMissing('formWithFieldData');
            return;
        }
        if (typeof projectId !== 'number') {
            $b6e087ee0849b727$var$logMissing('projectId');
            return;
        }
        if (typeof issueTypeId !== 'string') {
            $b6e087ee0849b727$var$logMissing('issueTypeId');
            return;
        }
        if (typeof formId !== 'string') {
            $b6e087ee0849b727$var$logMissing('formId');
            return;
        }
        const fields = (0, $4R6GH.fg)('jsw_forms_rollout') ? (0, $qPGip.transformFormData)({
            formInputData: formInputData,
            formWithFieldData: formWithFieldData,
            projectType: projectType
        }) : (0, $qPGip.transformFormData)({
            formInputData: formInputData,
            formWithFieldData: formWithFieldData
        });
        await createIssue({
            variables: {
                input: {
                    formId: formId,
                    fields: fields
                }
            },
            // @ts-expect-error - TS2345 - Argument of type '{ variables: { input: { projectId: string; issueType: string; fields: JiraIssueFieldsInput; }; }; onError: () => void; }' is not assignable to parameter of type 'MutationFunctionOptions<CreateJiraBusinessIssueForm, CreateJiraBusinessIssueFormVariables>'.
            // onError is needed to make sure the Promise always resolve instead of throwing Promise rejected error
            onError: ()=>{
                (0, $dJl1T.default).safeErrorWithoutCustomerData((0, $iEEXl.PACKAGE_NAME), 'ApolloError: Failed to create issue using form');
            }
        });
    };
    // find error that has message
    const mutationBadRequestError = data?.createJiraBusinessIssueByForm?.errors?.map((e)=>new (0, $eCBf9.MutationError)(e))?.find((e)=>e.message);
    return {
        error: // if there are any errors from Apollo, surface that first
        // otherwise if there are errors from bad request, use that
        error || mutationBadRequestError,
        errorMessage: mutationBadRequestError ? (0, $qPGip.transformErrorMessage)(mutationBadRequestError, formWithFieldData) : null,
        data: (0, $qPGip.transformResult)(data),
        loading: loading,
        create: create
    };
};

});
parcelRegister("eCBf9", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $5fe48c9a5d56428c$export$10c788363424e94e);
class $5fe48c9a5d56428c$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}

});

const $b2058fd633cf6c26$export$b46f0126077d6b7c = 'REQUIRED_FIELD_MISSING';
const $b2058fd633cf6c26$export$d65db43b48ab539f = 'FIELD_VALIDATION_FAILED';
const $b2058fd633cf6c26$export$e8b6f1ad2ff52ae6 = 'FORM_NOT_FOUND';

parcelRegister("kgZWx", function(module, exports) {

$parcel$export(module.exports, "FORM_CREATE_ISSUE_MUTATION", () => $aa968c869903eefe$export$8421abc4fb1c6a51);

var $5cllN = parcelRequire("5cllN");
const $aa968c869903eefe$export$8421abc4fb1c6a51 = (0, $5cllN.default)`
mutation CreateJiraBusinessIssueByForm($input: JwmFormCreateIssueInput!) {
  createJiraBusinessIssueByForm(input: $input) {
    item {
      id
      issueId
    }
    success
    errors {
      message
      extensions {
        ... on FieldValidationMutationErrorExtension {
          statusCode
          errorType
          fieldId
        }
        ... on GenericMutationErrorExtension {
          statusCode
          errorType
        }
      }
    }
  }
}
`;

});

parcelRegister("qPGip", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $aa4cd5c41c12e7b8$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "transformFormData", () => $aa4cd5c41c12e7b8$export$d1360584b6d92fb7);
$parcel$export(module.exports, "transformErrorMessage", () => $aa4cd5c41c12e7b8$export$d7c77df21c828876);

var $4Xk2W = parcelRequire("4Xk2W");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $fOgCm = parcelRequire("fOgCm");

var $kShoa = parcelRequire("kShoa");
const $aa4cd5c41c12e7b8$export$f13b29f9ed0c5a03 = (data)=>{
    if (!data) return data;
    const issueId = data.createJiraBusinessIssueByForm?.item?.issueId;
    const isIssueIdValid = typeof issueId === 'number';
    const isCreateJiraBusinessIssueSuccessValid = typeof data.createJiraBusinessIssueByForm?.success === 'boolean';
    if (!isIssueIdValid || !isCreateJiraBusinessIssueSuccessValid) (0, $jcw0u.default)({
        meta: {
            id: 'transformFormSubmissionResult',
            packageName: 'jiraBusinessForm',
            teamName: 'jira-werewolves'
        },
        attributes: {
            message: 'Some fields from form submission were not returned properly',
            isIssueIdValid: isIssueIdValid,
            isCreateJiraBusinessIssueSuccessValid: isCreateJiraBusinessIssueSuccessValid
        },
        sendToPrivacyUnsafeSplunk: true
    });
    if (typeof data.createJiraBusinessIssueByForm?.success !== 'boolean') return undefined;
    return {
        success: data.createJiraBusinessIssueByForm.success,
        issueId: issueId
    };
};
const $aa4cd5c41c12e7b8$export$d1360584b6d92fb7 = ({ formInputData: formInputData, formWithFieldData: formWithFieldData, projectType: projectType })=>{
    const formFieldsById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(formWithFieldData.fields, (f)=>f.fieldId);
    const fields = {
        users: [],
        labels: [],
        versions: [],
        stringFields: [],
        adfFields: [],
        multipleSelectFields: [],
        singleGroupPickerFields: [],
        multipleGroupPickerFields: [],
        multipleSelectUserPickerFields: []
    };
    Object.entries(formInputData).forEach(([key, value])=>{
        if (value === undefined || value === null) return;
        const fieldData = formFieldsById[key];
        if (!fieldData) return;
        const { type: type, renderer: renderer } = fieldData;
        const fieldConfig = (0, $fOgCm.getFieldTypeConfig)(type, projectType);
        if (!fieldConfig) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'transformFormSubmissionResult',
                    packageName: 'jiraBusinessForm',
                    teamName: 'jira-werewolves'
                },
                attributes: {
                    message: `"${type}" was unexpectedly missing in form config in form submission`
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        fieldConfig.writer(key, value, fields, renderer);
    });
    // If a label doesn't exist, add it.
    const labelsField = fields.labels.find((f)=>f.fieldId === 'labels');
    const formLabelPrefix = (0, $4R6GH.fg)('jsw_forms_rollout') ? (0, $fOgCm.getFormLabelPrefix)(projectType) : (0, $fOgCm.FORM_LABEL);
    const uniqueFormLabel = (0, $fOgCm.getUniqueFormLabel)(formLabelPrefix, formWithFieldData.formId);
    // NOTE: We don't want this check to fire exposure - that should happen in the form directory view
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jwm_business_forms_issue_view');
    if (labelsField) {
        if (!labelsField.values.values.includes(formLabelPrefix)) labelsField.values.values.push(formLabelPrefix);
        if (expConfig.get('isFormsIssueViewEnabled', false)) {
            if (!labelsField.values.values.includes(uniqueFormLabel)) labelsField.values.values.push(uniqueFormLabel);
        }
    } else {
        const labelsToAdd = [
            formLabelPrefix
        ];
        if (expConfig.get('isFormsIssueViewEnabled', false)) labelsToAdd.push(uniqueFormLabel);
        fields.labels.push((0, $kShoa.toLabelsField)('labels', labelsToAdd));
    }
    return fields;
};
const $aa4cd5c41c12e7b8$export$d7c77df21c828876 = (err, formWithFieldData)=>{
    const fieldWithError = formWithFieldData?.fields?.find((field)=>field.fieldId === err?.extensions?.fieldId);
    const errorMessage = fieldWithError?.alias ? err?.message.replace(fieldWithError.name, fieldWithError.alias) : err?.message;
    return errorMessage;
};

});


parcelRegister("c4qDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $70398421e931218a$export$2e2bcd8739ae039);

var $9fDOt = parcelRequire("9fDOt");
const $70398421e931218a$var$Condition = ({ condition: condition, children: children })=>{
    const isValid = (0, $9fDOt.useConditionValidator)(condition);
    return isValid ? children : null;
};
var $70398421e931218a$export$2e2bcd8739ae039 = $70398421e931218a$var$Condition;

});
parcelRegister("9fDOt", function(module, exports) {

$parcel$export(module.exports, "useConditionValidator", () => $8cb5eb768c39cd03$export$17591b2856d3d1a3);

var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $homE5 = parcelRequire("homE5");

var $3SFJ0 = parcelRequire("3SFJ0");
const $8cb5eb768c39cd03$export$be08e95e749ed486 = (condition)=>{
    if (condition.__typename === 'JiraFormSelectCondition') return (0, $3SFJ0.makeSelectConditionValidator)(condition);
    return null;
};
const $8cb5eb768c39cd03$export$17591b2856d3d1a3 = (condition)=>{
    const formState = (0, $bUa6y.useFormState)({
        values: true
    });
    const validator = (0, $5uXOq.useMemo)(()=>$8cb5eb768c39cd03$export$be08e95e749ed486(condition), [
        condition
    ]);
    if (!validator || !formState?.values || (0, $homE5.isConditionEmpty)(condition)) return true;
    const fieldValue = formState.values[condition.parentField.fieldId];
    // User has not input anything yet
    if (fieldValue === undefined) return false;
    return validator(fieldValue);
};

});
parcelRegister("homE5", function(module, exports) {

$parcel$export(module.exports, "isConditionEmpty", () => $34bc0c87da3a6fce$export$a864e35e15f2d639);
/* eslint-disable camelcase */ const $34bc0c87da3a6fce$export$a864e35e15f2d639 = (condition)=>{
    if (condition.__typename === 'JiraFormSelectCondition') return !condition.fieldOptionIds?.length;
    return true;
};

});

parcelRegister("3SFJ0", function(module, exports) {

$parcel$export(module.exports, "makeSelectConditionValidator", () => $e775093f07257699$export$8c83f6839a9dfd3);
const $e775093f07257699$export$26db3529e2ea773b = (possibleSelectOption)=>{
    return 'value' in possibleSelectOption && (typeof possibleSelectOption.value === 'undefined' || typeof possibleSelectOption.value === 'string');
};
const $e775093f07257699$export$4be42473522c84f6 = (possibleSelectOptionArray)=>{
    if (!Array.isArray(possibleSelectOptionArray)) return false;
    // Confirm that each of the selected values conforms to the expected shape
    if (possibleSelectOptionArray.length) return possibleSelectOptionArray.every($e775093f07257699$export$26db3529e2ea773b);
    // When empty we assume the array is valid until proven otherwise
    return true;
};
const $e775093f07257699$export$8c83f6839a9dfd3 = (condition)=>{
    const { fieldOptionIds: fieldOptionIds, operator: operator } = condition;
    return (fieldValue)=>{
        if (!fieldOptionIds?.length) return true;
        // Value will be null when user clears
        // the input of a single-select field
        if (fieldValue === null) return false;
        if ($e775093f07257699$export$26db3529e2ea773b(fieldValue)) return fieldOptionIds.includes(fieldValue.value);
        if ($e775093f07257699$export$4be42473522c84f6(fieldValue)) return operator === 'ALL' ? fieldOptionIds.every((id)=>fieldValue.find(({ value: value })=>value === id)) : fieldOptionIds.some((id)=>fieldValue.find(({ value: value })=>value === id));
        // Default to true if the shape of the given
        // field value is non-conforming
        return true;
    };
};

});



parcelRegister("icFsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f40c930e967a388f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f40c930e967a388f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    submissionErrorFlag: {
        "id": "business-form.form-submission.fill-in-view.submission-error-flag",
        "defaultMessage": "Something's gone wrong"
    },
    submissionAttachmentErrorContent: {
        "id": "business-form.form-submission.fill-in-view.submission-attachment-error-content",
        "defaultMessage": "Attachment upload failed. Make sure the file format and size are correct, and check your internet connection before trying again."
    },
    submitButton: {
        "id": "business-form.form-submission.fill-in-view.submit-button",
        "defaultMessage": "Submit"
    }
});

});

parcelRegister("6Ti3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $59de8f2d041a296c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $bUa6y = parcelRequire("bUa6y");

var $fraBZ = parcelRequire("fraBZ");

var $koVbs = parcelRequire("koVbs");

var $ea1JH = parcelRequire("ea1JH");
const $59de8f2d041a296c$var$useMessageCreator = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $5uXOq.useCallback)((prevValues, newValues)=>{
        if (!prevValues || !newValues) return '';
        // Then number of keys in form values is a proxy for number of
        // fields on the form
        const fieldCountDiff = Object.keys(prevValues).length - Object.keys(newValues).length;
        if (fieldCountDiff === 0) return '';
        return fieldCountDiff < 0 ? formatMessage((0, $ea1JH.default).fieldsAdded, {
            fieldCount: Math.abs(fieldCountDiff)
        }) : formatMessage((0, $ea1JH.default).fieldsRemoved, {
            fieldCount: Math.abs(fieldCountDiff)
        });
    }, [
        formatMessage
    ]);
};
/**
 * Creates screenreader announcements to notify users
 * when fields are added or removed from a form. This
 * occurs as field values change and conditions are met
 * or unmet.
 */ const $59de8f2d041a296c$var$ScreenreaderAnnouncer = ()=>{
    const formState = (0, $bUa6y.useFormState)({
        values: true
    });
    const prevValues = (0, $5uXOq.useRef)();
    const [message, setMessage] = (0, $5uXOq.useState)('');
    const getMessage = $59de8f2d041a296c$var$useMessageCreator();
    /**
   * When multiple fields are added or removed from a form after
   * a single form update, multiple state updates might be triggered
   * via useFormState. In order to capture all of these updates as
   * unified message, we need to debounce the update of the message.
   *
   * Without this, for example, instead of:
   * 	Updated message: "4 fields have been removed below"
   * We might end up with:
   * 	Updated message 1: "2 fields have been removed below"
   *  Updated message 2: "2 fields have been removed below"
   */ const debouncedUpdateMessage = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((newValues)=>{
            const newMessage = getMessage(prevValues.current, newValues);
            prevValues.current = newValues;
            setMessage(newMessage);
        }, 200), [
        getMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        debouncedUpdateMessage(formState?.values);
    }, [
        debouncedUpdateMessage,
        formState?.values
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: message
    });
};
var $59de8f2d041a296c$export$2e2bcd8739ae039 = $59de8f2d041a296c$var$ScreenreaderAnnouncer;

});
parcelRegister("ea1JH", function(module, exports) {

$parcel$export(module.exports, "default", () => $38c1ce986f69f095$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $38c1ce986f69f095$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fieldsRemoved: {
        "id": "business-form.form-submission.fill-in-view.screenreader-announcer.fields-removed",
        "defaultMessage": "{fieldCount, plural,\n\t\t\tone {# form field has been removed below}\n\t\t\tother {# form fields have been removed below}\n\t\t}"
    },
    fieldsAdded: {
        "id": "business-form.form-submission.fill-in-view.screenreader-announcer.fields-added",
        "defaultMessage": "{fieldCount, plural,\n\t\t\tone {# form field has been added below}\n\t\t\tother {# form fields have been added below}\n\t\t}"
    }
});

});


parcelRegister("jfugj", function(module, exports) {

$parcel$export(module.exports, "generateFieldAnalytics", () => $f80bb0d21b4f5357$export$9c1a0599c1937c10);
$parcel$export(module.exports, "useIntersectionObserver", () => $f80bb0d21b4f5357$export$a7395f9832c00176);

var $5uXOq = parcelRequire("5uXOq");

var $kGsr8 = parcelRequire("kGsr8");
const $f80bb0d21b4f5357$export$9c1a0599c1937c10 = (fields)=>{
    const fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(fields.map((field)=>field.type.replace('com.atlassian.jira.plugin.system.customfieldtypes:', '')));
    const customFieldCount = fields.filter((field)=>field.fieldId.startsWith('customfield_')).length;
    const fieldCount = fields.length;
    return {
        fieldIds: fieldIds,
        customFieldCount: customFieldCount,
        fieldCount: fieldCount
    };
};
const $f80bb0d21b4f5357$export$a7395f9832c00176 = (onIntersection)=>{
    const [ref, setRef] = (0, $5uXOq.useState)(null);
    const handleObserver = (0, $5uXOq.useCallback)((entries)=>{
        entries.forEach(({ isIntersecting: isIntersecting })=>{
            if (isIntersecting) onIntersection();
        });
    }, [
        onIntersection
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!ref || typeof window === 'undefined' || typeof window !== 'undefined' && !window.IntersectionObserver) return undefined;
        const observer = new IntersectionObserver(handleObserver, {
            root: null,
            rootMargin: '20px',
            threshold: 0
        });
        if (ref) observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        onIntersection,
        handleObserver
    ]);
    return setRef;
};

});

parcelRegister("luvaQ", function(module, exports) {

$parcel$export(module.exports, "PublicFormPrivacyPolicyFooter", () => $1ac8c170d5dd5661$export$a53ab96977f40285);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $41j30 = parcelRequire("41j30");

var $koVbs = parcelRequire("koVbs");

var $7UxRb = parcelRequire("7UxRb");
const $1ac8c170d5dd5661$var$LinkToSubmitFormPrivacyPolicy = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: "https://www.atlassian.com/legal/privacy-policy" // TODO TBD
        ,
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": props.description
    }, props.children);
const $1ac8c170d5dd5661$export$a53ab96977f40285 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const footerContent = formatMessage((0, $7UxRb.default).publicFormPrivacyFooter, {
        a: (privacyPolicy)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ac8c170d5dd5661$var$LinkToSubmitFormPrivacyPolicy, {
                description: formatMessage((0, $7UxRb.default).anchorArialLabel)
            }, privacyPolicy)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1ac8c170d5dd5661$var$privacyPolicyFooterStyle,
        "data-testId": "business-form.ui.form-submission.fill-in-view.public-form-privacy-policy-footer"
    }, footerContent);
};
const $1ac8c170d5dd5661$var$privacyPolicyFooterStyle = (0, $8CUq3.xcss)({
    width: '100%',
    textAlign: 'center',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // TODO confirm the color from designer to fix a11y the link contrast issue
    // src/packages/business/form/integration-tests/accessibility.cy-integration.tsx@['FormSubmissionView', 1, 0],
    color: 'color.text.subtlest',
    marginBottom: 'space.300',
    marginTop: 'space.250',
    flex: 1
});

});
parcelRegister("7UxRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a0dd21f5055864$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $97a0dd21f5055864$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    publicFormPrivacyFooter: {
        "id": "business-form.form-submission.fill-in-view.public-form-privacy-footer",
        "defaultMessage": "By submitting, you agree to our <a>Terms & Privacy Policy</a>"
    },
    anchorArialLabel: {
        "id": "business-form.form-submission.fill-in-view.public-form-privacy-footer.anchor-arial-label",
        "defaultMessage": "Atlassian Submit Form Privacy Policy"
    }
});

});



parcelRegister("b8mPJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d009e2d1a73fd0a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d009e2d1a73fd0a0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageHeading: {
        "id": "business-form.form-submission.page-heading",
        "defaultMessage": "Form submission"
    }
});

});


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});




//# sourceMappingURL=async-software-form-submit-entrypoint.58bb86ab.js.map
